
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("2Zool", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $arQY7 = parcelRequire("arQY7");


var $ad7Ou = parcelRequire("ad7Ou");

var $1sCHt = parcelRequire("1sCHt");


var $7BfeF = parcelRequire("7BfeF");


var $hpa99 = parcelRequire("hpa99");


var $I7hWB = parcelRequire("I7hWB");


var $aRvnq = parcelRequire("aRvnq");


var $l3wuH = parcelRequire("l3wuH");


var $hMaHH = parcelRequire("hMaHH");


var $d2UzA = parcelRequire("d2UzA");


var $93fnf = parcelRequire("93fnf");


var $c8bBH = parcelRequire("c8bBH");


var $5wHqn = parcelRequire("5wHqn");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $l8wPz = parcelRequire("l8wPz");


var $4yYAm = parcelRequire("4yYAm");


var $3qg1D = parcelRequire("3qg1D");


var $jdA6O = parcelRequire("jdA6O");


var $e3Wrf = parcelRequire("e3Wrf");




/**
 * Parses an expert `identifier` field from the authority_ui_metadata backend response
 * into a raw Atlassian accountId.
 *
 * Supported formats:
 *   - ARI:       `ari:cloud:identity::user/{accountId}`
 *   - Bare:      `{accountId}` (contains a colon, e.g. `712020:abc-123`)
 *   - accountId prefix: `accountId:{accountId}`
 *
 * Returns `null` for unrecognised/malformed identifiers (e.g. bare slugs like `MCB`).
 */ function $31f9d2449afd7b36$export$c731743d1971e078(identifier) {
    if (!identifier) return null;
    // ARI format: ari:cloud:identity::user/{accountId}
    const ariMatch = identifier.match(/^ari:cloud:identity::user\/(.+)$/);
    if (ariMatch) {
        const accountId = ariMatch[1];
        return accountId ? accountId : null;
    }
    // accountId: prefix format: accountId:{accountId}
    if (identifier.startsWith('accountId:')) {
        const accountId = identifier.slice(10);
        return accountId ? accountId : null;
    }
    // Bare accountId format — must contain a colon but NOT start with `ari:` (e.g. `712020:abc-123`)
    // Slugs like `MCB` have no colon and are unresolvable.
    // ARIs that didn't match the user pattern above are rejected.
    if (identifier.includes(':') && !identifier.startsWith('ari:')) return identifier;
    return null;
}


const $e36ca689003a1522$var$AGG_ENDPOINT = '/gateway/api/graphql';
const $e36ca689003a1522$var$OPERATION_NAME = 'AuthoritativeAnswerExpertProfilesQuery';
const $e36ca689003a1522$var$EXPERT_PROFILES_QUERY = `
query ${$e36ca689003a1522$var$OPERATION_NAME}($accountIds: [ID!]!) {
  users(accountIds: $accountIds) {
    accountId
    name
    picture
    ... on AtlassianAccountUser {
      extendedProfile {
        jobTitle
      }
    }
  }
}
`;
async function $e36ca689003a1522$var$fetchUserProfiles(accountIds, signal) {
    const response = await fetch(`${$e36ca689003a1522$var$AGG_ENDPOINT}?q=${$e36ca689003a1522$var$OPERATION_NAME}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            operationName: $e36ca689003a1522$var$OPERATION_NAME,
            query: $e36ca689003a1522$var$EXPERT_PROFILES_QUERY,
            variables: {
                accountIds: accountIds
            }
        }),
        signal: signal
    });
    if (!response.ok) throw new Error(`AGG request failed: ${response.status}`);
    const json = await response.json();
    return json?.data?.users ?? [];
}
const $e36ca689003a1522$export$67363325cdb0c92e = (domainExperts)=>{
    const [profileMap, setProfileMap] = (0, $cozmU.useState)({});
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    // Parse all identifiers upfront — experts with null accountId are invalid
    const parsedExperts = (0, $cozmU.useMemo)(()=>domainExperts.map((expert)=>({
                ...expert,
                accountId: (0, $31f9d2449afd7b36$export$c731743d1971e078)(expert.identifier)
            })), [
        domainExperts
    ]);
    const validAccountIds = (0, $cozmU.useMemo)(()=>parsedExperts.map((e)=>e.accountId).filter((id)=>id !== null), [
        parsedExperts
    ]);
    // Stable string key to avoid re-fetching when array identity changes but content is the same
    const accountIdKey = validAccountIds.join('|');
    (0, $cozmU.useEffect)(()=>{
        if (!validAccountIds.length) return;
        const controller = new AbortController();
        setIsLoading(true);
        $e36ca689003a1522$var$fetchUserProfiles(validAccountIds, controller.signal).then((profiles)=>{
            if (controller.signal.aborted) return;
            const map = {};
            profiles.forEach((profile)=>{
                map[profile.accountId] = profile;
            });
            setProfileMap(map);
        }).catch(()=>{
        // Graceful degradation — retain BE-provided names, no avatars
        }).finally(()=>{
            if (!controller.signal.aborted) setIsLoading(false);
        });
        return ()=>{
            controller.abort();
        };
    // accountIdKey is a stable derived value from validAccountIds — safe to use as dep
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        accountIdKey
    ]);
    const experts = (0, $cozmU.useMemo)(()=>parsedExperts.map((expert)=>{
            const profile = expert.accountId ? profileMap[expert.accountId] : undefined;
            return {
                ...expert,
                resolvedName: profile?.name || expert.name,
                avatarUrl: profile?.picture,
                jobTitle: profile?.extendedProfile?.jobTitle
            };
        }), [
        parsedExperts,
        profileMap
    ]);
    return {
        experts: experts,
        isLoading: isLoading
    };
};





const $15f010d612b2bfa9$var$messages = (0, $kSwu1.defineMessages)({
    attributionGenerated: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.attributionGenerated",
        defaultMessage: "Verified across <trigger>high confidence knowledge</trigger>"
    },
    attributionAnswer: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.attributionAnswer",
        defaultMessage: "<bold>Answer</bold> verified across <trigger>high confidence knowledge</trigger>"
    },
    panelHeading: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.panelHeading",
        defaultMessage: "High confidence knowledge"
    },
    closePanel: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.closePanel",
        defaultMessage: "Close"
    },
    viewExpert: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.viewExpert",
        defaultMessage: "View {name}"
    },
    feedbackPrompt: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.feedbackPrompt",
        defaultMessage: "Was this high confidence knowledge helpful?"
    },
    feedbackHelpfulLabel: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.feedbackHelpfulLabel",
        defaultMessage: "Helpful"
    },
    feedbackNotHelpfulLabel: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.feedbackNotHelpfulLabel",
        defaultMessage: "Not helpful"
    },
    feedbackHeadingPositive: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.feedbackHeadingPositive",
        defaultMessage: "What worked about this response?"
    },
    feedbackHeadingNegative: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.feedbackHeadingNegative",
        defaultMessage: "What didn't work about these sources?"
    },
    feedbackItWasLabel: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.feedbackItWasLabel",
        defaultMessage: "It was..."
    },
    feedbackSubmitLabel: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.feedbackSubmitLabel",
        defaultMessage: "Submit feedback"
    },
    feedbackCloseLabel: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.feedbackCloseLabel",
        defaultMessage: "Close feedback form"
    },
    feedbackConfirmation: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.feedbackConfirmation",
        defaultMessage: "Thanks for your feedback"
    },
    feedbackAdditionalLabel: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.feedbackAdditionalLabel",
        defaultMessage: "Additional feedback"
    },
    feedbackAdditionalPlaceholder: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.feedbackAdditionalPlaceholder",
        defaultMessage: "Tell us more"
    },
    feedbackAdditionalRequired: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.feedbackAdditionalRequired",
        defaultMessage: "Please provide additional details when selecting \"Other\""
    },
    categoryUpToDate: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.categoryUpToDate",
        defaultMessage: "Up to date"
    },
    categoryAccurate: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.categoryAccurate",
        defaultMessage: "Accurate"
    },
    categoryHelpful: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.categoryHelpful",
        defaultMessage: "Helpful"
    },
    categoryWellSourced: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.categoryWellSourced",
        defaultMessage: "Well-sourced"
    },
    categoryOutOfDate: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.categoryOutOfDate",
        defaultMessage: "Out of date"
    },
    categoryInaccurate: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.categoryInaccurate",
        defaultMessage: "Inaccurate"
    },
    categoryNotHelpful: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.categoryNotHelpful",
        defaultMessage: "Not helpful"
    },
    categoryPoorlySourced: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.categoryPoorlySourced",
        defaultMessage: "Poorly-sourced"
    },
    categoryOther: {
        id: "rovo-platform-ui-components.authoritative-answer-attribution.categoryOther",
        defaultMessage: "Other"
    }
});
var $15f010d612b2bfa9$export$2e2bcd8739ae039 = $15f010d612b2bfa9$var$messages;


const $d7887939350a32bd$var$useHoverPopup = (0, $gtMdU.isReactCompilerActivePlatform)() ? (isOpen, open, close)=>{
    const $ = (0, $bDgLe.c)(21);
    const lockedByClick = (0, $cozmU.useRef)(false);
    const closeTimer = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>()=>{
                if (closeTimer.current) clearTimeout(closeTimer.current);
            };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[2] !== close) {
        t2 = ()=>{
            lockedByClick.current = false;
            close();
        };
        $[2] = close;
        $[3] = t2;
    } else t2 = $[3];
    const closeAndUnlock = t2;
    let t3;
    if ($[4] !== open) {
        t3 = ()=>{
            if (closeTimer.current) clearTimeout(closeTimer.current);
            open();
        };
        $[4] = open;
        $[5] = t3;
    } else t3 = $[5];
    const onTriggerMouseEnter = t3;
    let t4;
    if ($[6] !== closeAndUnlock) {
        t4 = ()=>{
            closeTimer.current = setTimeout(()=>{
                if (!lockedByClick.current) closeAndUnlock();
            }, 150);
        };
        $[6] = closeAndUnlock;
        $[7] = t4;
    } else t4 = $[7];
    const onTriggerMouseLeave = t4;
    let t5;
    if ($[8] !== closeAndUnlock || $[9] !== isOpen || $[10] !== open) {
        t5 = ()=>{
            if (isOpen && lockedByClick.current) {
                closeAndUnlock();
                return;
            }
            lockedByClick.current = !lockedByClick.current;
            open();
        };
        $[8] = closeAndUnlock;
        $[9] = isOpen;
        $[10] = open;
        $[11] = t5;
    } else t5 = $[11];
    const onTriggerClick = t5;
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            if (closeTimer.current) clearTimeout(closeTimer.current);
        };
        $[12] = t6;
    } else t6 = $[12];
    const onContentMouseEnter = t6;
    let t7;
    if ($[13] !== closeAndUnlock) {
        t7 = ()=>{
            if (!lockedByClick.current) closeAndUnlock();
        };
        $[13] = closeAndUnlock;
        $[14] = t7;
    } else t7 = $[14];
    const onContentMouseLeave = t7;
    const onCloseButton = closeAndUnlock;
    let t8;
    if ($[15] !== onCloseButton || $[16] !== onContentMouseLeave || $[17] !== onTriggerClick || $[18] !== onTriggerMouseEnter || $[19] !== onTriggerMouseLeave) {
        t8 = {
            onTriggerMouseEnter: onTriggerMouseEnter,
            onTriggerMouseLeave: onTriggerMouseLeave,
            onTriggerClick: onTriggerClick,
            onContentMouseEnter: onContentMouseEnter,
            onContentMouseLeave: onContentMouseLeave,
            onCloseButton: onCloseButton
        };
        $[15] = onCloseButton;
        $[16] = onContentMouseLeave;
        $[17] = onTriggerClick;
        $[18] = onTriggerMouseEnter;
        $[19] = onTriggerMouseLeave;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
} : (isOpen, open, close)=>{
    const lockedByClick = (0, $cozmU.useRef)(false);
    const closeTimer = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>()=>{
            if (closeTimer.current) clearTimeout(closeTimer.current);
        }, []);
    const closeAndUnlock = (0, $cozmU.useCallback)(()=>{
        lockedByClick.current = false;
        close();
    }, [
        close
    ]);
    const onTriggerMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (closeTimer.current) clearTimeout(closeTimer.current);
        open();
    }, [
        open
    ]);
    const onTriggerMouseLeave = (0, $cozmU.useCallback)(()=>{
        closeTimer.current = setTimeout(()=>{
            if (!lockedByClick.current) closeAndUnlock();
        }, 150);
    }, [
        closeAndUnlock
    ]);
    const onTriggerClick = (0, $cozmU.useCallback)(()=>{
        if (isOpen && lockedByClick.current) {
            closeAndUnlock();
            return;
        }
        lockedByClick.current = !lockedByClick.current;
        open();
    }, [
        isOpen,
        open,
        closeAndUnlock
    ]);
    const onContentMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (closeTimer.current) clearTimeout(closeTimer.current);
    }, []);
    const onContentMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (!lockedByClick.current) closeAndUnlock();
    }, [
        closeAndUnlock
    ]);
    const onCloseButton = closeAndUnlock;
    return {
        onTriggerMouseEnter: onTriggerMouseEnter,
        onTriggerMouseLeave: onTriggerMouseLeave,
        onTriggerClick: onTriggerClick,
        onContentMouseEnter: onContentMouseEnter,
        onContentMouseLeave: onContentMouseLeave,
        onCloseButton: onCloseButton
    };
};
const $d7887939350a32bd$var$styles = {
    root: "_43nrzT2ADO",
    icon: "_3iDTPbccYA _1RrJLit2nV _1UtDYzGL5O",
    panelHeadingIcon: "_1UtDYzGL5O _3YEZNOdnbC",
    link: "_2sNsIgmnOE _4c065UPgdg _2Y7lL4Pgdg _3iDTPbS8kF _0KLXrujOvk _1UtDYzM7Tp _1kk5Tkf7mX _0wOv4Q7zJH _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMAwSC",
    panel: "_4bt5LAIZbP _2WAcuGIZbP _39xV02BmSS _1EqgXljeu6 _0NUa3rHakr",
    panelTall: "_4bt5LAIZbP _2WAcuGIZbP _39xV02wBC3 _1EqgXljeu6 _0NUa3rSfBv",
    panelHeader: "_2Y7lL45zaO _46hvQm5zaO _0xmtko2ADO",
    panelDivider: "_0vfIXINvrM _4hyvPa6wH8 _1KhSQW9r67",
    itemRow: "_4c065U8HPE _2Y7lL45zaO _3iDTPbvLZJ _39xV02N91d _0KLXru66of _2fwxA57p2s _1eOmH6KcZT",
    itemRowArrow: "_23rrnHO2Fc _3YEZNOdnbC _1YKVNsdnbC",
    itemRowArrowVisible: "_23rrnHO2Fc _3YEZNOdnbC _1YKVNs7dHp",
    feedbackRow: "_4c065UgVvo _2Y7lL45zaO",
    feedbackForm: "_0bjKvDyzSk _3SamIH8HPE _2YLqiK5zaO _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _30KhUP8HPE _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _1zr6Dc98eZ _0htemXYbGa _067LceT6kp _1ubuxo98eZ _1NDpvbYbGa _2wtOC9T6kp",
    textAreaWrap: "_0bjKvDKTcp _4bt5LAnQyn _2WAcuGnQyn _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _2Y7lL41Y8M _4c065U1Y8M _0KLXru7Cj1 _1jJ2xknXvL _4j5xbavc3e"
};
const $d7887939350a32bd$var$titleBlockCss = null;
const $d7887939350a32bd$var$ExpertRow = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(34);
    const { expert: expert, index: index, onExpertClick: onExpertClick, cloudId: cloudId, testId: testId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const profileUrl = expert.accountId ? cloudId ? `https://home.atlassian.com/people/${expert.accountId}?cloudId=${cloudId}` : `/people/${expert.accountId}` : undefined;
    let t1;
    if ($[0] !== expert.avatarUrl || $[1] !== expert.resolvedName) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
            size: "medium",
            name: expert.resolvedName,
            src: expert.avatarUrl
        });
        $[0] = expert.avatarUrl;
        $[1] = expert.resolvedName;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== expert.resolvedName) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            as: "h3",
            size: "xxsmall"
        }, expert.resolvedName);
        $[3] = expert.resolvedName;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== expert.jobTitle || $[6] !== expert.role) {
        t3 = expert.jobTitle || expert.role ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            size: "small"
        }, expert.jobTitle || expert.role) : null;
        $[5] = expert.jobTitle;
        $[6] = expert.role;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t2 || $[9] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.0"
        }, t2, t3);
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== expert.resolvedName || $[12] !== formatMessage || $[13] !== isHovered || $[14] !== profileUrl) {
        t5 = profileUrl ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: isHovered ? $d7887939350a32bd$var$styles.itemRowArrowVisible : $d7887939350a32bd$var$styles.itemRowArrow
        }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
            label: formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).viewExpert, {
                name: expert.resolvedName
            }),
            appearance: "default",
            tabIndex: isHovered ? 0 : -1
        })) : null;
        $[11] = expert.resolvedName;
        $[12] = formatMessage;
        $[13] = isHovered;
        $[14] = profileUrl;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== t4 || $[17] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.0",
            grow: "fill"
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between"
        }, t4, t5));
        $[16] = t4;
        $[17] = t5;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== t1 || $[20] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, t1, t6);
        $[19] = t1;
        $[20] = t6;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== expert.reasoning) {
        t8 = expert.reasoning ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 2
        }, expert.reasoning) : null;
        $[22] = expert.reasoning;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== t7 || $[25] !== t8) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t7, t8);
        $[24] = t7;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    const expertContent = t9;
    let t10;
    if ($[27] !== expert || $[28] !== expertContent || $[29] !== index || $[30] !== onExpertClick || $[31] !== profileUrl || $[32] !== testId) {
        t10 = profileUrl ? /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            xcss: $d7887939350a32bd$var$styles.itemRow,
            onClick: ()=>{
                onExpertClick?.(expert);
                window.open(profileUrl, "_blank", "noopener,noreferrer");
            },
            onMouseEnter: ()=>setIsHovered(true),
            onMouseLeave: ()=>setIsHovered(false),
            testId: testId ? `${testId}--expert-${index}` : undefined
        }, expertContent) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $d7887939350a32bd$var$styles.itemRow,
            testId: testId ? `${testId}--expert-${index}` : undefined
        }, expertContent);
        $[27] = expert;
        $[28] = expertContent;
        $[29] = index;
        $[30] = onExpertClick;
        $[31] = profileUrl;
        $[32] = testId;
        $[33] = t10;
    } else t10 = $[33];
    return t10;
} : ({ expert: expert, index: index, onExpertClick: onExpertClick, cloudId: cloudId, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const profileUrl = expert.accountId ? cloudId ? `https://home.atlassian.com/people/${expert.accountId}?cloudId=${cloudId}` : `/people/${expert.accountId}` : undefined;
    const expertContent = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
        size: "medium",
        name: expert.resolvedName,
        src: expert.avatarUrl
    }), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.0",
        grow: "fill"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.0"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        as: "h3",
        size: "xxsmall"
    }, expert.resolvedName), expert.jobTitle || expert.role ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small"
    }, expert.jobTitle || expert.role) : null), profileUrl ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: isHovered ? $d7887939350a32bd$var$styles.itemRowArrowVisible : $d7887939350a32bd$var$styles.itemRowArrow
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
        label: formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).viewExpert, {
            name: expert.resolvedName
        }),
        appearance: "default",
        tabIndex: isHovered ? 0 : -1
    })) : null))), expert.reasoning ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small",
        maxLines: 2
    }, expert.reasoning) : null);
    return profileUrl ? /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: $d7887939350a32bd$var$styles.itemRow,
        onClick: ()=>{
            onExpertClick?.(expert);
            window.open(profileUrl, '_blank', 'noopener,noreferrer');
        },
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        testId: testId ? `${testId}--expert-${index}` : undefined
    }, expertContent) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d7887939350a32bd$var$styles.itemRow,
        testId: testId ? `${testId}--expert-${index}` : undefined
    }, expertContent);
};
const $d7887939350a32bd$var$SourceRow = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { source: source, index: index, onSourceClick: onSourceClick, onError: onError, testId: testId } = t0;
    let t1;
    if ($[0] !== index || $[1] !== onError || $[2] !== onSourceClick || $[3] !== source || $[4] !== testId) {
        t1 = source.url ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $d7887939350a32bd$var$styles.itemRow,
            testId: testId ? `${testId}--source-${index}` : undefined
        }, /*#__PURE__*/ $cozmU.createElement((0, $l8wPz.Card), {
            appearance: "block",
            ui: {
                theme: (0, $4yYAm.SmartLinkTheme).Black,
                clickableContainer: true,
                hideBackground: true,
                hideElevation: true,
                hidePadding: true,
                size: (0, $4yYAm.SmartLinkSize).Medium,
                removeBlockRestriction: true
            },
            url: source.url,
            onClick: ()=>onSourceClick?.(source),
            onError: ()=>source.url && onError?.(source.url)
        }, /*#__PURE__*/ $cozmU.createElement((0, $jdA6O.default), {
            maxLines: 1,
            size: (0, $4yYAm.SmartLinkSize).Medium,
            position: (0, $4yYAm.SmartLinkPosition).Center,
            subtitle: [
                {
                    name: (0, $4yYAm.ElementName).Provider,
                    hideIcon: true
                },
                {
                    name: (0, $4yYAm.ElementName).ModifiedOn
                }
            ],
            className: (0, $hekY6.default)([
                "_4hM5yg8fU6 _0yksiO2ADO _32GWj52ADO _2ztbEw2ADO _46UOc62ADO _3l7hjhDMqu _2XqGtx5UaJ _4bInUCPgdg _0IyFICKGUX _04hdQqKGUX _0PILyQFQfX"
            ])
        }), source.reasoning ? /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 2
        }, source.reasoning)) : null)) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $d7887939350a32bd$var$styles.itemRow,
            testId: testId ? `${testId}--source-${index}` : undefined
        }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
            label: "",
            size: "medium"
        }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "medium",
            maxLines: 1
        }, source.title)), source.reasoning ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 2
        }, source.reasoning) : null));
        $[0] = index;
        $[1] = onError;
        $[2] = onSourceClick;
        $[3] = source;
        $[4] = testId;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ source: source, index: index, onSourceClick: onSourceClick, onError: onError, testId: testId })=>{
    return source.url ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d7887939350a32bd$var$styles.itemRow,
        testId: testId ? `${testId}--source-${index}` : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $l8wPz.Card), {
        appearance: "block",
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            size: (0, $4yYAm.SmartLinkSize).Medium,
            removeBlockRestriction: true
        },
        url: source.url,
        onClick: ()=>onSourceClick?.(source),
        onError: ()=>source.url && onError?.(source.url)
    }, /*#__PURE__*/ $cozmU.createElement((0, $jdA6O.default), {
        maxLines: 1,
        size: (0, $4yYAm.SmartLinkSize).Medium,
        position: (0, $4yYAm.SmartLinkPosition).Center,
        subtitle: [
            {
                name: (0, $4yYAm.ElementName).Provider,
                hideIcon: true
            },
            {
                name: (0, $4yYAm.ElementName).ModifiedOn
            }
        ],
        className: (0, $hekY6.default)([
            "_4hM5yg8fU6 _0yksiO2ADO _32GWj52ADO _2ztbEw2ADO _46UOc62ADO _3l7hjhDMqu _2XqGtx5UaJ _4bInUCPgdg _0IyFICKGUX _04hdQqKGUX _0PILyQFQfX"
        ])
    }), source.reasoning ? /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small",
        maxLines: 2
    }, source.reasoning)) : null)) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d7887939350a32bd$var$styles.itemRow,
        testId: testId ? `${testId}--source-${index}` : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
        label: "",
        size: "medium"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "medium",
        maxLines: 1
    }, source.title)), source.reasoning ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small",
        maxLines: 2
    }, source.reasoning) : null));
};
const $d7887939350a32bd$var$MAX_PANEL_ITEMS = 3;
const $d7887939350a32bd$var$MAX_SOURCES = 2;
const $d7887939350a32bd$var$sliceItems = (sources, experts)=>{
    const sourcesCount = Math.min(sources.length, experts.length > 0 ? $d7887939350a32bd$var$MAX_SOURCES : $d7887939350a32bd$var$MAX_PANEL_ITEMS);
    const expertsCount = Math.min(experts.length, $d7887939350a32bd$var$MAX_PANEL_ITEMS - sourcesCount);
    return {
        sources: sources.slice(0, sourcesCount),
        experts: experts.slice(0, expertsCount)
    };
};
const $d7887939350a32bd$var$CombinedPanel = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(79);
    const { sources: sources, domainExperts: domainExperts, overallReasoning: overallReasoning, onSourceClick: onSourceClick, onExpertClick: onExpertClick, onClose: onClose, onFeedbackSubmit: onFeedbackSubmit, cloudId: cloudId, panelId: panelId, panelSize: panelSize, testId: testId } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = new Set();
        $[0] = t1;
    } else t1 = $[0];
    const [erroredUrls, setErroredUrls] = (0, $cozmU.useState)(t1);
    const [feedbackSentiment, setFeedbackSentiment] = (0, $cozmU.useState)(null);
    const [feedbackSubmitted, setFeedbackSubmitted] = (0, $cozmU.useState)(false);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[1] = t2;
    } else t2 = $[1];
    const [selectedReasons, setSelectedReasons] = (0, $cozmU.useState)(t2);
    const [feedbackComment, setFeedbackComment] = (0, $cozmU.useState)("");
    const [showValidationError, setShowValidationError] = (0, $cozmU.useState)(false);
    const feedbackFormRef = (0, $cozmU.useRef)(null);
    let t3;
    let t4;
    if ($[2] !== feedbackSentiment) {
        t3 = ()=>{
            const node = feedbackFormRef.current;
            if (feedbackSentiment && node) {
                node.tabIndex = -1;
                node.focus();
            }
        };
        t4 = [
            feedbackSentiment
        ];
        $[2] = feedbackSentiment;
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (reason)=>{
            setSelectedReasons((prev)=>prev.includes(reason) ? prev.filter((r)=>r !== reason) : [
                    ...prev,
                    reason
                ]);
        };
        $[5] = t5;
    } else t5 = $[5];
    const toggleReason = t5;
    let t6;
    if ($[6] !== cloudId || $[7] !== domainExperts || $[8] !== erroredUrls || $[9] !== feedbackComment || $[10] !== feedbackSentiment || $[11] !== feedbackSubmitted || $[12] !== formatMessage || $[13] !== onClose || $[14] !== onExpertClick || $[15] !== onFeedbackSubmit || $[16] !== onSourceClick || $[17] !== overallReasoning || $[18] !== panelId || $[19] !== panelSize || $[20] !== selectedReasons || $[21] !== showValidationError || $[22] !== sources || $[23] !== testId) {
        const positiveReasons = [
            formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryUpToDate),
            formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryAccurate),
            formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryHelpful),
            formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryWellSourced),
            formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryOther)
        ];
        const negativeReasons = [
            formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryOutOfDate),
            formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryInaccurate),
            formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryNotHelpful),
            formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryPoorlySourced),
            formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryOther)
        ];
        const otherLabel = formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryOther);
        const feedbackReasons = feedbackSentiment === "like" ? positiveReasons : negativeReasons;
        const isOtherSelected = selectedReasons.includes(otherLabel);
        let t7;
        if ($[25] !== feedbackComment || $[26] !== isOtherSelected || $[27] !== showValidationError) {
            t7 = showValidationError && isOtherSelected && !feedbackComment.trim();
            $[25] = feedbackComment;
            $[26] = isOtherSelected;
            $[27] = showValidationError;
            $[28] = t7;
        } else t7 = $[28];
        const showCommentError = t7;
        let t8;
        if ($[29] !== feedbackComment || $[30] !== feedbackSentiment || $[31] !== isOtherSelected || $[32] !== onFeedbackSubmit || $[33] !== selectedReasons) {
            t8 = ()=>{
                if (!feedbackSentiment) return;
                if (isOtherSelected && !feedbackComment.trim()) {
                    setShowValidationError(true);
                    return;
                }
                onFeedbackSubmit?.({
                    sentiment: feedbackSentiment,
                    reasons: selectedReasons,
                    comment: feedbackComment || undefined
                });
                setFeedbackSubmitted(true);
            };
            $[29] = feedbackComment;
            $[30] = feedbackSentiment;
            $[31] = isOtherSelected;
            $[32] = onFeedbackSubmit;
            $[33] = selectedReasons;
            $[34] = t8;
        } else t8 = $[34];
        const handleFeedbackSubmit = t8;
        let t9;
        if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
            t9 = (url)=>setErroredUrls((prev_0)=>new Set([
                        ...prev_0,
                        url
                    ]));
            $[35] = t9;
        } else t9 = $[35];
        const handleSourceError = t9;
        let T0;
        let t10;
        let t11;
        let t12;
        let t13;
        let t14;
        let t15;
        let t16;
        if ($[36] !== cloudId || $[37] !== domainExperts || $[38] !== erroredUrls || $[39] !== formatMessage || $[40] !== onClose || $[41] !== onExpertClick || $[42] !== onSourceClick || $[43] !== overallReasoning || $[44] !== panelId || $[45] !== panelSize || $[46] !== sources || $[47] !== testId) {
            let t17;
            if ($[56] !== erroredUrls) {
                t17 = (s)=>!s.url || !erroredUrls.has(s.url);
                $[56] = erroredUrls;
                $[57] = t17;
            } else t17 = $[57];
            const validSources = sources.filter(t17);
            const { sources: slicedSources, experts: slicedExperts } = $d7887939350a32bd$var$sliceItems(validSources, domainExperts);
            T0 = (0, $iMnC5.Box);
            t10 = panelId;
            t11 = panelSize === "tall" ? $d7887939350a32bd$var$styles.panelTall : $d7887939350a32bd$var$styles.panel;
            t12 = testId;
            let t18;
            if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
                t18 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $d7887939350a32bd$var$styles.panelHeadingIcon
                }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
                    label: "",
                    size: "small"
                }));
                $[58] = t18;
            } else t18 = $[58];
            let t19;
            if ($[59] !== formatMessage) {
                t19 = formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).panelHeading);
                $[59] = formatMessage;
                $[60] = t19;
            } else t19 = $[60];
            let t20;
            if ($[61] !== t19) {
                t20 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    space: "space.075"
                }, t18, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
                    as: "h2",
                    size: "xsmall"
                }, t19));
                $[61] = t19;
                $[62] = t20;
            } else t20 = $[62];
            let t21;
            if ($[63] !== formatMessage) {
                t21 = formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).closePanel);
                $[63] = formatMessage;
                $[64] = t21;
            } else t21 = $[64];
            const t22 = testId ? `${testId}--close` : undefined;
            let t23;
            if ($[65] !== onClose || $[66] !== t21 || $[67] !== t22) {
                t23 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
                    label: t21,
                    appearance: "subtle",
                    onClick: onClose,
                    testId: t22
                });
                $[65] = onClose;
                $[66] = t21;
                $[67] = t22;
                $[68] = t23;
            } else t23 = $[68];
            let t24;
            if ($[69] !== t20 || $[70] !== t23) {
                t24 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                    spread: "space-between",
                    alignBlock: "center"
                }, t20, t23);
                $[69] = t20;
                $[70] = t23;
                $[71] = t24;
            } else t24 = $[71];
            let t25;
            if ($[72] !== overallReasoning) {
                t25 = overallReasoning ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                    color: "color.text.subtlest",
                    size: "small"
                }, overallReasoning) : null;
                $[72] = overallReasoning;
                $[73] = t25;
            } else t25 = $[73];
            if ($[74] !== t24 || $[75] !== t25) {
                t13 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
                    xcss: $d7887939350a32bd$var$styles.panelHeader,
                    space: "space.0"
                }, t24, t25);
                $[74] = t24;
                $[75] = t25;
                $[76] = t13;
            } else t13 = $[76];
            if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
                t14 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: $d7887939350a32bd$var$styles.panelDivider
                });
                $[77] = t14;
            } else t14 = $[77];
            t15 = slicedSources.length > 0 ? /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
                space: "space.0"
            }, slicedSources.map((source, index)=>/*#__PURE__*/ $cozmU.createElement($d7887939350a32bd$var$SourceRow, {
                    key: `${source.title}-${index}`,
                    source: source,
                    index: index,
                    onSourceClick: onSourceClick,
                    onError: handleSourceError,
                    testId: testId
                }))) : null;
            t16 = slicedExperts.length > 0 ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, slicedSources.length > 0 ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $d7887939350a32bd$var$styles.panelDivider
            }) : null, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
                space: "space.0"
            }, slicedExperts.map((expert, index_0)=>/*#__PURE__*/ $cozmU.createElement($d7887939350a32bd$var$ExpertRow, {
                    key: `${expert.identifier}-${index_0}`,
                    expert: expert,
                    index: index_0,
                    onExpertClick: onExpertClick,
                    cloudId: cloudId,
                    testId: testId
                })))) : null;
            $[36] = cloudId;
            $[37] = domainExperts;
            $[38] = erroredUrls;
            $[39] = formatMessage;
            $[40] = onClose;
            $[41] = onExpertClick;
            $[42] = onSourceClick;
            $[43] = overallReasoning;
            $[44] = panelId;
            $[45] = panelSize;
            $[46] = sources;
            $[47] = testId;
            $[48] = T0;
            $[49] = t10;
            $[50] = t11;
            $[51] = t12;
            $[52] = t13;
            $[53] = t14;
            $[54] = t15;
            $[55] = t16;
        } else {
            T0 = $[48];
            t10 = $[49];
            t11 = $[50];
            t12 = $[51];
            t13 = $[52];
            t14 = $[53];
            t15 = $[54];
            t16 = $[55];
        }
        let t17;
        if ($[78] === Symbol.for("react.memo_cache_sentinel")) {
            t17 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $d7887939350a32bd$var$styles.panelDivider
            });
            $[78] = t17;
        } else t17 = $[78];
        t6 = /*#__PURE__*/ $cozmU.createElement(T0, {
            id: t10,
            xcss: t11,
            testId: t12
        }, t13, t14, t15, t16, t17, feedbackSubmitted ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $d7887939350a32bd$var$styles.feedbackRow,
            testId: testId ? `${testId}--feedback-confirmation` : undefined
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            size: "small"
        }, formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackConfirmation))) : /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            xcss: $d7887939350a32bd$var$styles.feedbackRow,
            spread: "space-between",
            alignBlock: "center",
            space: "space.100"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            size: "small"
        }, formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackPrompt)), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))),
            label: formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackHelpfulLabel),
            appearance: "subtle",
            spacing: "compact",
            isSelected: feedbackSentiment === "like",
            onClick: ()=>setFeedbackSentiment("like"),
            testId: testId ? `${testId}--feedback-helpful` : undefined
        }), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($93fnf))),
            label: formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackNotHelpfulLabel),
            appearance: "subtle",
            spacing: "compact",
            isSelected: feedbackSentiment === "dislike",
            onClick: ()=>setFeedbackSentiment("dislike"),
            testId: testId ? `${testId}--feedback-not-helpful` : undefined
        }))), feedbackSentiment ? /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            ref: feedbackFormRef,
            xcss: $d7887939350a32bd$var$styles.feedbackForm,
            space: "space.100",
            testId: testId ? `${testId}--feedback-form` : undefined
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            spread: "space-between",
            alignBlock: "center"
        }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            as: "h3",
            size: "xxsmall"
        }, feedbackSentiment === "like" ? formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackHeadingPositive) : formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackHeadingNegative)), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackCloseLabel),
            appearance: "subtle",
            spacing: "compact",
            onClick: ()=>setFeedbackSentiment(null),
            testId: testId ? `${testId}--feedback-form-close` : undefined
        })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest",
            weight: "bold"
        }, formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackItWasLabel)), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.100",
            shouldWrap: true,
            role: "group",
            "aria-label": formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackItWasLabel)
        }, feedbackReasons.map((reason_0)=>/*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                key: reason_0,
                isSelected: selectedReasons.includes(reason_0),
                onClick: ()=>toggleReason(reason_0),
                testId: testId ? `${testId}--feedback-reason` : undefined
            }, reason_0))), isOtherSelected ? /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            size: "small",
            color: "color.text.subtlest",
            weight: "bold"
        }, formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackAdditionalLabel), " ", /*#__PURE__*/ $cozmU.createElement((0, $hpa99.RequiredAsterisk), null)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $d7887939350a32bd$var$styles.textAreaWrap
        }, /*#__PURE__*/ $cozmU.createElement((0, $e3Wrf.default), {
            appearance: "none",
            value: feedbackComment,
            onChange: (e)=>setFeedbackComment(e.currentTarget.value),
            placeholder: formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackAdditionalPlaceholder),
            minimumRows: 3,
            resize: "vertical",
            "aria-required": true,
            "aria-invalid": showCommentError,
            testId: testId ? `${testId}--feedback-comment` : undefined
        })), showCommentError ? /*#__PURE__*/ $cozmU.createElement((0, $7BfeF.ErrorMessage), null, formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackAdditionalRequired)) : null) : null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            appearance: "primary",
            onClick: handleFeedbackSubmit,
            testId: testId ? `${testId}--feedback-submit` : undefined
        }, formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackSubmitLabel))) : null));
        $[6] = cloudId;
        $[7] = domainExperts;
        $[8] = erroredUrls;
        $[9] = feedbackComment;
        $[10] = feedbackSentiment;
        $[11] = feedbackSubmitted;
        $[12] = formatMessage;
        $[13] = onClose;
        $[14] = onExpertClick;
        $[15] = onFeedbackSubmit;
        $[16] = onSourceClick;
        $[17] = overallReasoning;
        $[18] = panelId;
        $[19] = panelSize;
        $[20] = selectedReasons;
        $[21] = showValidationError;
        $[22] = sources;
        $[23] = testId;
        $[24] = t6;
    } else t6 = $[24];
    return t6;
} : ({ sources: sources, domainExperts: domainExperts, overallReasoning: overallReasoning, onSourceClick: onSourceClick, onExpertClick: onExpertClick, onClose: onClose, onFeedbackSubmit: onFeedbackSubmit, cloudId: cloudId, panelId: panelId, panelSize: panelSize, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [erroredUrls, setErroredUrls] = (0, $cozmU.useState)(new Set());
    const [feedbackSentiment, setFeedbackSentiment] = (0, $cozmU.useState)(null);
    const [feedbackSubmitted, setFeedbackSubmitted] = (0, $cozmU.useState)(false);
    const [selectedReasons, setSelectedReasons] = (0, $cozmU.useState)([]);
    const [feedbackComment, setFeedbackComment] = (0, $cozmU.useState)('');
    const [showValidationError, setShowValidationError] = (0, $cozmU.useState)(false); // Move focus to the revealed form so it scrolls into view and is announced.
    // `tabIndex` is set imperatively because the compiled `Stack` does not accept
    // a `tabIndex` prop; -1 keeps it out of the tab order but allows `.focus()`.
    const feedbackFormRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const node = feedbackFormRef.current;
        if (feedbackSentiment && node) {
            node.tabIndex = -1;
            node.focus();
        }
    }, [
        feedbackSentiment
    ]);
    const toggleReason = (0, $cozmU.useCallback)((reason)=>{
        setSelectedReasons((prev)=>prev.includes(reason) ? prev.filter((r)=>r !== reason) : [
                ...prev,
                reason
            ]);
    }, []);
    const positiveReasons = [
        formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryUpToDate),
        formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryAccurate),
        formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryHelpful),
        formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryWellSourced),
        formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryOther)
    ];
    const negativeReasons = [
        formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryOutOfDate),
        formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryInaccurate),
        formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryNotHelpful),
        formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryPoorlySourced),
        formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryOther)
    ];
    const otherLabel = formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).categoryOther);
    const feedbackReasons = feedbackSentiment === 'like' ? positiveReasons : negativeReasons;
    const isOtherSelected = selectedReasons.includes(otherLabel);
    const showCommentError = showValidationError && isOtherSelected && !feedbackComment.trim();
    const handleFeedbackSubmit = ()=>{
        if (!feedbackSentiment) return;
         // Free-text is required when the "Other" reason is selected.
        if (isOtherSelected && !feedbackComment.trim()) {
            setShowValidationError(true);
            return;
        }
        onFeedbackSubmit?.({
            sentiment: feedbackSentiment,
            reasons: selectedReasons,
            comment: feedbackComment || undefined
        });
        setFeedbackSubmitted(true);
    };
    const handleSourceError = (0, $cozmU.useCallback)((url)=>setErroredUrls((prev_0)=>new Set([
                ...prev_0,
                url
            ])), []); // Filter errored sources before slicing so we always show up to the cap from
    // valid sources (Smart Card resolution errors arrive async via onError).
    const validSources = sources.filter((s)=>!s.url || !erroredUrls.has(s.url));
    const { sources: slicedSources, experts: slicedExperts } = $d7887939350a32bd$var$sliceItems(validSources, domainExperts);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        id: panelId,
        xcss: panelSize === 'tall' ? $d7887939350a32bd$var$styles.panelTall : $d7887939350a32bd$var$styles.panel,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $d7887939350a32bd$var$styles.panelHeader,
        space: "space.0"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d7887939350a32bd$var$styles.panelHeadingIcon
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
        label: "",
        size: "small"
    })), /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).panelHeading))), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).closePanel),
        appearance: "subtle",
        onClick: onClose,
        testId: testId ? `${testId}--close` : undefined
    })), overallReasoning ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small"
    }, overallReasoning) : null), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d7887939350a32bd$var$styles.panelDivider
    }), slicedSources.length > 0 ? /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.0"
    }, slicedSources.map((source, index)=>/*#__PURE__*/ $cozmU.createElement($d7887939350a32bd$var$SourceRow, {
            key: `${source.title}-${index}`,
            source: source,
            index: index,
            onSourceClick: onSourceClick,
            onError: handleSourceError,
            testId: testId
        }))) : null, slicedExperts.length > 0 ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, slicedSources.length > 0 ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d7887939350a32bd$var$styles.panelDivider
    }) : null, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.0"
    }, slicedExperts.map((expert, index_0)=>/*#__PURE__*/ $cozmU.createElement($d7887939350a32bd$var$ExpertRow, {
            key: `${expert.identifier}-${index_0}`,
            expert: expert,
            index: index_0,
            onExpertClick: onExpertClick,
            cloudId: cloudId,
            testId: testId
        })))) : null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d7887939350a32bd$var$styles.panelDivider
    }), feedbackSubmitted ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d7887939350a32bd$var$styles.feedbackRow,
        testId: testId ? `${testId}--feedback-confirmation` : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small"
    }, formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackConfirmation))) : /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $d7887939350a32bd$var$styles.feedbackRow,
        spread: "space-between",
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small"
    }, formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackPrompt)), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))),
        label: formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackHelpfulLabel),
        appearance: "subtle",
        spacing: "compact",
        isSelected: feedbackSentiment === 'like',
        onClick: ()=>setFeedbackSentiment('like'),
        testId: testId ? `${testId}--feedback-helpful` : undefined
    }), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($93fnf))),
        label: formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackNotHelpfulLabel),
        appearance: "subtle",
        spacing: "compact",
        isSelected: feedbackSentiment === 'dislike',
        onClick: ()=>setFeedbackSentiment('dislike'),
        testId: testId ? `${testId}--feedback-not-helpful` : undefined
    }))), feedbackSentiment ? /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        ref: feedbackFormRef,
        xcss: $d7887939350a32bd$var$styles.feedbackForm,
        space: "space.100",
        testId: testId ? `${testId}--feedback-form` : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        as: "h3",
        size: "xxsmall"
    }, feedbackSentiment === 'like' ? formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackHeadingPositive) : formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackHeadingNegative)), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackCloseLabel),
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setFeedbackSentiment(null),
        testId: testId ? `${testId}--feedback-form-close` : undefined
    })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        weight: "bold"
    }, formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackItWasLabel)), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        shouldWrap: true,
        role: "group",
        "aria-label": formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackItWasLabel)
    }, feedbackReasons.map((reason_0)=>/*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            key: reason_0,
            isSelected: selectedReasons.includes(reason_0),
            onClick: ()=>toggleReason(reason_0),
            testId: testId ? `${testId}--feedback-reason` : undefined
        }, reason_0))), isOtherSelected ? /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        weight: "bold"
    }, formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackAdditionalLabel), " ", /*#__PURE__*/ $cozmU.createElement((0, $hpa99.RequiredAsterisk), null)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d7887939350a32bd$var$styles.textAreaWrap
    }, /*#__PURE__*/ $cozmU.createElement((0, $e3Wrf.default), {
        appearance: "none",
        value: feedbackComment,
        onChange: (e)=>setFeedbackComment(e.currentTarget.value),
        placeholder: formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackAdditionalPlaceholder),
        minimumRows: 3,
        resize: "vertical",
        "aria-required": true,
        "aria-invalid": showCommentError,
        testId: testId ? `${testId}--feedback-comment` : undefined
    })), showCommentError ? /*#__PURE__*/ $cozmU.createElement((0, $7BfeF.ErrorMessage), null, formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackAdditionalRequired)) : null) : null, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleFeedbackSubmit,
        testId: testId ? `${testId}--feedback-submit` : undefined
    }, formatMessage((0, $15f010d612b2bfa9$export$2e2bcd8739ae039).feedbackSubmitLabel))) : null));
}; /**
    * Attribution line shown above an authoritative AI answer.
    *
    * Renders "Answer verified across high confidence knowledge" (SAIN) or
    * "Verified across high confidence knowledge" (Chat) where the bolded text
    * opens a combined panel showing sources and expert contributors.
    *
    * Designed for reuse across Rovo surfaces (Rovo Chat, SAIN).
    */ 
const $d7887939350a32bd$export$c495c3bf41770fa5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { sources: sources, domainExperts: domainExperts, overallReasoning: overallReasoning, labelVariant: t1, onSourceClick: onSourceClick, onExpertClick: onExpertClick, onPanelOpen: onPanelOpen, cloudId: cloudId, onFeedbackSubmit: onFeedbackSubmit, surface: t2, panelSize: t3, testId: testId } = t0;
    const labelVariant = t1 === undefined ? "generated" : t1;
    const surface = t2 === undefined ? "chat" : t2;
    const panelSize = t3 === undefined ? "compact" : t3;
    const placement = surface === "sain" ? "bottom-start" : "top-start";
    const shouldRenderToParent = surface === "chat";
    const instanceId = (0, $cozmU.useId)();
    const panelId = `${instanceId}-panel`;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { experts: allHydratedExperts } = (0, $e36ca689003a1522$export$67363325cdb0c92e)(domainExperts);
    let t4;
    if ($[0] !== allHydratedExperts) {
        t4 = allHydratedExperts.filter($d7887939350a32bd$var$_temp);
        $[0] = allHydratedExperts;
        $[1] = t4;
    } else t4 = $[1];
    const hydratedExperts = t4;
    const hasSources = sources.length > 0;
    const hasExperts = hydratedExperts.length > 0;
    let t5;
    if ($[2] !== onPanelOpen) {
        t5 = ()=>{
            setIsOpen((wasOpen)=>{
                if (!wasOpen) onPanelOpen?.();
                return true;
            });
        };
        $[2] = onPanelOpen;
        $[3] = t5;
    } else t5 = $[3];
    const openPanel = t5;
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>setIsOpen(false);
        $[4] = t6;
    } else t6 = $[4];
    const closePanel = t6;
    const isSAINVariant = labelVariant === "answer";
    const hoverPopup = $d7887939350a32bd$var$useHoverPopup(isOpen, openPanel, closePanel);
    if (!hasSources && !hasExperts) return null;
    let t7;
    if ($[5] !== cloudId || $[6] !== hoverPopup || $[7] !== hydratedExperts || $[8] !== isOpen || $[9] !== isSAINVariant || $[10] !== onExpertClick || $[11] !== onFeedbackSubmit || $[12] !== onSourceClick || $[13] !== overallReasoning || $[14] !== panelId || $[15] !== panelSize || $[16] !== placement || $[17] !== shouldRenderToParent || $[18] !== sources || $[19] !== testId) {
        t7 = (chunks)=>/*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
                isOpen: isOpen,
                onClose: hoverPopup.onCloseButton,
                placement: placement,
                shouldRenderToParent: shouldRenderToParent,
                content: ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                        onMouseEnter: hoverPopup.onContentMouseEnter,
                        onMouseLeave: hoverPopup.onContentMouseLeave
                    }, /*#__PURE__*/ $cozmU.createElement($d7887939350a32bd$var$CombinedPanel, {
                        sources: sources,
                        domainExperts: hydratedExperts,
                        overallReasoning: overallReasoning,
                        onSourceClick: onSourceClick,
                        onExpertClick: onExpertClick,
                        onClose: hoverPopup.onCloseButton,
                        onFeedbackSubmit: onFeedbackSubmit,
                        cloudId: cloudId,
                        panelId: panelId,
                        panelSize: panelSize,
                        testId: testId ? `${testId}--panel` : undefined
                    })),
                trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                        as: "span",
                        role: "button",
                        tabIndex: 0,
                        ...triggerProps,
                        "aria-expanded": isOpen,
                        "aria-controls": panelId,
                        xcss: $d7887939350a32bd$var$styles.link,
                        onClick: hoverPopup.onTriggerClick,
                        onKeyDown: (e_0)=>{
                            if (e_0.key === "Enter" || e_0.key === " ") hoverPopup.onTriggerClick();
                        },
                        onMouseEnter: isSAINVariant ? hoverPopup.onTriggerMouseEnter : undefined,
                        onMouseLeave: isSAINVariant ? hoverPopup.onTriggerMouseLeave : undefined,
                        testId: testId ? `${testId}--trigger` : undefined
                    }, chunks)
            });
        $[5] = cloudId;
        $[6] = hoverPopup;
        $[7] = hydratedExperts;
        $[8] = isOpen;
        $[9] = isSAINVariant;
        $[10] = onExpertClick;
        $[11] = onFeedbackSubmit;
        $[12] = onSourceClick;
        $[13] = overallReasoning;
        $[14] = panelId;
        $[15] = panelSize;
        $[16] = placement;
        $[17] = shouldRenderToParent;
        $[18] = sources;
        $[19] = testId;
        $[20] = t7;
    } else t7 = $[20];
    const trigger = t7;
    if (isSAINVariant) {
        let t8;
        if ($[21] !== trigger) {
            t8 = /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $15f010d612b2bfa9$export$2e2bcd8739ae039).attributionAnswer,
                values: {
                    trigger: trigger,
                    bold: $d7887939350a32bd$var$_temp2
                }
            });
            $[21] = trigger;
            $[22] = t8;
        } else t8 = $[22];
        let t9;
        if ($[23] !== t8 || $[24] !== testId) {
            t9 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                color: "color.text.subtlest",
                testId: testId
            }, t8);
            $[23] = t8;
            $[24] = testId;
            $[25] = t9;
        } else t9 = $[25];
        return t9;
    }
    let t8;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $d7887939350a32bd$var$styles.icon
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
            label: "",
            size: "small"
        }));
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== trigger) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, t8, " ", /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $15f010d612b2bfa9$export$2e2bcd8739ae039).attributionGenerated,
            values: {
                trigger: trigger
            }
        }));
        $[27] = trigger;
        $[28] = t9;
    } else t9 = $[28];
    let t10;
    if ($[29] !== t9 || $[30] !== testId) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $d7887939350a32bd$var$styles.root,
            testId: testId
        }, t9);
        $[29] = t9;
        $[30] = testId;
        $[31] = t10;
    } else t10 = $[31];
    return t10;
} : ({ sources: sources, domainExperts: domainExperts, overallReasoning: overallReasoning, labelVariant: labelVariant = 'generated', onSourceClick: onSourceClick, onExpertClick: onExpertClick, onPanelOpen: onPanelOpen, cloudId: cloudId, onFeedbackSubmit: onFeedbackSubmit, surface: surface = 'chat', panelSize: panelSize = 'compact', testId: testId })=>{
    // Anchoring is derived from the surface: Chat opens upward as a sibling of the
    // trigger (matching its "N Sources" popup so the answer stays visible in the
    // narrow right panel); SAIN opens below the inline text and portals to body.
    const placement = surface === 'sain' ? 'bottom-start' : 'top-start';
    const shouldRenderToParent = surface === 'chat';
    const instanceId = (0, $cozmU.useId)();
    const panelId = `${instanceId}-panel`;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { experts: allHydratedExperts } = (0, $e36ca689003a1522$export$67363325cdb0c92e)(domainExperts); // Filter out experts with unresolvable identifiers (accountId: null)
    const hydratedExperts = allHydratedExperts.filter((e)=>e.accountId !== null);
    const hasSources = sources.length > 0;
    const hasExperts = hydratedExperts.length > 0;
    const openPanel = (0, $cozmU.useCallback)(()=>{
        // Fire onPanelOpen only on the closed -> open transition so hover + click
        // re-entrancy does not double-count the panel-shown analytics event.
        setIsOpen((wasOpen)=>{
            if (!wasOpen) onPanelOpen?.();
            return true;
        });
    }, [
        onPanelOpen
    ]);
    const closePanel = (0, $cozmU.useCallback)(()=>setIsOpen(false), []);
    const isSAINVariant = labelVariant === 'answer';
    const hoverPopup = $d7887939350a32bd$var$useHoverPopup(isOpen, openPanel, closePanel);
    if (!hasSources && !hasExperts) return null;
     // Rendered as an ICU tag so the full attribution sentence — including the
    // linked phrase — lives in a single translatable message. `chunks` is the
    // translated link text supplied by the surrounding message.
    const trigger = (chunks)=>/*#__PURE__*/ $cozmU.createElement((0, $5wHqn.default), {
            isOpen: isOpen,
            onClose: hoverPopup.onCloseButton,
            placement: placement,
            shouldRenderToParent: shouldRenderToParent,
            content: ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    onMouseEnter: hoverPopup.onContentMouseEnter,
                    onMouseLeave: hoverPopup.onContentMouseLeave
                }, /*#__PURE__*/ $cozmU.createElement($d7887939350a32bd$var$CombinedPanel, {
                    sources: sources,
                    domainExperts: hydratedExperts,
                    overallReasoning: overallReasoning,
                    onSourceClick: onSourceClick,
                    onExpertClick: onExpertClick,
                    onClose: hoverPopup.onCloseButton,
                    onFeedbackSubmit: onFeedbackSubmit,
                    cloudId: cloudId,
                    panelId: panelId,
                    panelSize: panelSize,
                    testId: testId ? `${testId}--panel` : undefined
                })),
            trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    as: "span",
                    role: "button",
                    tabIndex: 0,
                    ...triggerProps,
                    "aria-expanded": isOpen,
                    "aria-controls": panelId,
                    xcss: $d7887939350a32bd$var$styles.link,
                    onClick: hoverPopup.onTriggerClick,
                    onKeyDown: (e_0)=>{
                        if (e_0.key === 'Enter' || e_0.key === ' ') hoverPopup.onTriggerClick();
                    },
                    onMouseEnter: isSAINVariant ? hoverPopup.onTriggerMouseEnter : undefined,
                    onMouseLeave: isSAINVariant ? hoverPopup.onTriggerMouseLeave : undefined,
                    testId: testId ? `${testId}--trigger` : undefined
                }, chunks)
        }); // SAIN: render only the attribution text inline
    if (isSAINVariant) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $15f010d612b2bfa9$export$2e2bcd8739ae039).attributionAnswer,
        values: {
            trigger: trigger,
            bold: (chunks_0)=>/*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
                    as: "strong",
                    color: "color.text",
                    weight: "bold"
                }, chunks_0)
        }
    }));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d7887939350a32bd$var$styles.root,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $d7887939350a32bd$var$styles.icon
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
        label: "",
        size: "small"
    })), ' ', /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $15f010d612b2bfa9$export$2e2bcd8739ae039).attributionGenerated,
        values: {
            trigger: trigger
        }
    })));
};
function $d7887939350a32bd$var$_temp(e) {
    return e.accountId !== null;
}
function $d7887939350a32bd$var$_temp2(chunks_0) {
    return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "strong",
        color: "color.text",
        weight: "bold"
    }, chunks_0);
}
module.exports["AuthoritativeAnswerAttribution"] = $d7887939350a32bd$export$c495c3bf41770fa5;

});

parcelRegister("fhQlP", function(module, exports) {
const $050790baf9a4bce9$export$49889f8b8926df87 = (authorityUiMetadata)=>{
    if (!authorityUiMetadata) return {
        hasAuthoritativeSources: false
    };
    return {
        hasAuthoritativeSources: true,
        authorityLevel: authorityUiMetadata.authorityLevel,
        isHighlyAuthoritative: authorityUiMetadata.isHighlyAuthoritative ?? authorityUiMetadata.highlyAuthoritative ?? false,
        overallConfidence: authorityUiMetadata.overallConfidence,
        authoritativeSourceCount: authorityUiMetadata.sources?.length ?? 0,
        authoritativeExpertCount: authorityUiMetadata.domainExperts?.length ?? 0
    };
};
const $050790baf9a4bce9$export$7682e19f2147a1c6 = ({ product: product, source: source, correlationAttributes: correlationAttributes, authorityUiMetadata: authorityUiMetadata })=>({
        action: 'shown',
        actionSubject: 'authoritativeAnswerPanel',
        ...source ? {
            source: source
        } : {},
        eventType: 'track',
        attributes: {
            product: product,
            ...correlationAttributes,
            ...$050790baf9a4bce9$export$49889f8b8926df87(authorityUiMetadata)
        }
    });
module.exports["getAuthorityAttributes"] = $050790baf9a4bce9$export$49889f8b8926df87;
module.exports["buildAuthoritativeAnswerPanelShownEvent"] = $050790baf9a4bce9$export$7682e19f2147a1c6;

});

parcelRegister("1V59x", function(module, exports) {
/**
 * Shared, headless submission of Authoritative Answers panel feedback to the
 * Feedback Collector API (`POST /gateway/api/feedback-collector-api/v2/feedback`).
 *
 * Both surfaces that render the Authoritative Answers panel (SAIN and Chat)
 * submit through this function, each passing its own `entrypointId` and `origin`
 * so the feedback lands in that surface's established feedback pipeline while
 * remaining attributable to the Authoritative Answers panel.
 *
 * This mirrors the request the `@atlaskit/feedback-collector` component makes but
 * without rendering its modal, because the panel already collects the sentiment,
 * reasons and optional comment inline.
 */ 
var $hlvTd = parcelRequire("hlvTd");

const $957289ccc1aee3cc$export$c4fda24479ad6357 = '82633dea-7fbf-4faa-9a51-a83a3fd181d9';
const $957289ccc1aee3cc$export$71bd15dd9ac53df = '45c9c029-3180-4960-ab0d-db7cdeaf5f54';
const $957289ccc1aee3cc$export$e3a491d55fee66c5 = 'sain-authoritative-answer-panel';
const $957289ccc1aee3cc$export$2b69acc757be9633 = 'chat-authoritative-answer-panel';
const $957289ccc1aee3cc$var$FEEDBACK_COLLECTOR_PATH = '/gateway/api/feedback-collector-api/v2/feedback';
const $957289ccc1aee3cc$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $957289ccc1aee3cc$var$ENTRYPOINT_UI_VERSION = '1.0.0';
const $957289ccc1aee3cc$var$MAX_SUMMARY_LENGTH_CHARS = 100;
/**
 * Default field ids / values expected by the Feedback Collector API. These match
 * the defaults used by `@atlaskit/feedback-collector`
 * (platform/packages/web-platform/feedback-collector).
 */ const $957289ccc1aee3cc$var$FIELD_IDS = {
    summary: 'summary',
    description: 'description',
    customerName: 'customfield_10045',
    canBeContacted: 'customfield_10043',
    enrollInResearch: 'customfield_10044',
    feedbackContext: $957289ccc1aee3cc$var$FEEDBACK_CONTEXT_CF
};
const $957289ccc1aee3cc$var$FIELD_VALUES = {
    canBeContactedDecline: [
        {
            id: '10111'
        }
    ],
    enrollInResearchDecline: [
        {
            id: '10112'
        }
    ]
};
const $957289ccc1aee3cc$var$base64Encode = (str)=>{
    try {
        // Encode to UTF-8 bytes first so `btoa` handles non-Latin1 input.
        const bytes = new TextEncoder().encode(str);
        let binary = '';
        for (const byte of bytes)binary += String.fromCharCode(byte);
        return btoa(binary);
    } catch  {
        return str;
    }
};
const $957289ccc1aee3cc$var$truncate = (text, length = $957289ccc1aee3cc$var$MAX_SUMMARY_LENGTH_CHARS)=>text.length > length ? `${text.slice(0, length - 1)}\u{2026}` : text;
const $957289ccc1aee3cc$export$39ce1305cbacab2b = async ({ submission: { sentiment: sentiment, reasons: reasons, comment: comment }, entrypointId: entrypointId, origin: origin, cloudId: cloudId, debugAttributes: debugAttributes })=>{
    const { traceId: traceId, searchSessionId: searchSessionId, queryHash: queryHash } = debugAttributes ?? {};
    const sentimentLabel = sentiment === 'like' ? 'positive' : 'negative';
    const summary = $957289ccc1aee3cc$var$truncate(`Authoritative answer feedback: ${sentimentLabel}`);
    const context = {
        origin: origin,
        sentiment: sentimentLabel,
        reasons: reasons,
        ...cloudId ? {
            cloudId: cloudId
        } : {},
        ...traceId ? {
            traceId: traceId
        } : {},
        ...searchSessionId ? {
            searchSessionId: searchSessionId
        } : {},
        ...queryHash ? {
            queryHash: queryHash
        } : {}
    };
    const description = `${comment ?? ''}

\`\`\`
${JSON.stringify(context, null, 2)}
\`\`\`
`;
    const feedbackContextValue = [
        `origin: ${origin}`,
        `sentiment: ${sentimentLabel}`,
        reasons.length ? `reasons: ${reasons.join(', ')}` : undefined,
        traceId ? `traceId: ${traceId}` : undefined,
        searchSessionId ? `searchSessionId: ${searchSessionId}` : undefined,
        queryHash ? `queryHash: ${queryHash}` : undefined
    ].filter(Boolean).join('\n');
    const fields = [
        {
            id: $957289ccc1aee3cc$var$FIELD_IDS.summary,
            value: summary
        },
        {
            id: $957289ccc1aee3cc$var$FIELD_IDS.description,
            value: description
        },
        {
            id: $957289ccc1aee3cc$var$FIELD_IDS.customerName,
            value: 'unknown'
        },
        {
            id: $957289ccc1aee3cc$var$FIELD_IDS.canBeContacted,
            value: $957289ccc1aee3cc$var$FIELD_VALUES.canBeContactedDecline
        },
        {
            id: $957289ccc1aee3cc$var$FIELD_IDS.enrollInResearch,
            value: $957289ccc1aee3cc$var$FIELD_VALUES.enrollInResearchDecline
        },
        {
            id: $957289ccc1aee3cc$var$FIELD_IDS.feedbackContext,
            value: feedbackContextValue
        }
    ];
    const body = {
        feedback: {
            entrypointId: entrypointId,
            entrypointUiVersion: $957289ccc1aee3cc$var$ENTRYPOINT_UI_VERSION,
            fields: fields
        }
    };
    const postData = $957289ccc1aee3cc$var$base64Encode(JSON.stringify(body));
    try {
        const response = await fetch($957289ccc1aee3cc$var$FEEDBACK_COLLECTOR_PATH, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                data: postData
            }),
            credentials: 'include'
        });
        if (!response.ok) throw new Error(`Authority feedback submission failed with status ${response.status}`);
        return {
            success: true
        };
    } catch (error) {
        (0, $hlvTd.logException)({
            exception: error,
            name: 'submitAuthorityFeedback'
        });
        return {
            success: false
        };
    }
};
module.exports["FEEDBACK_ENTRYPOINT_ID_SAIN"] = $957289ccc1aee3cc$export$c4fda24479ad6357;
module.exports["FEEDBACK_ENTRYPOINT_ID_CHAT"] = $957289ccc1aee3cc$export$71bd15dd9ac53df;
module.exports["AUTHORITY_FEEDBACK_ORIGIN_SAIN"] = $957289ccc1aee3cc$export$e3a491d55fee66c5;
module.exports["AUTHORITY_FEEDBACK_ORIGIN_CHAT"] = $957289ccc1aee3cc$export$2b69acc757be9633;
module.exports["submitAuthorityFeedback"] = $957289ccc1aee3cc$export$39ce1305cbacab2b;

});

parcelRegister("5AzUy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $8BQV6 = parcelRequire("8BQV6");


var $4QMIF = parcelRequire("4QMIF");


var $a33Aa = parcelRequire("a33Aa");

const $7ce401f883a6d6c9$var$UFOCustomCohortData = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UFOCustomCohortData(t0) {
    const { dataKey: dataKey, value: value } = t0;
    const interactionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    let t1;
    bb0: {
        if (!interactionContext) {
            t1 = undefined;
            break bb0;
        }
        const interactionId = (0, $4QMIF.getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) {
            t1 = undefined;
            break bb0;
        }
        (0, $a33Aa.addCohortingCustomData)(currentInteractionId, dataKey, value);
        t1 = undefined;
    }
    return null;
} : function UFOCustomCohortData({ dataKey: dataKey, value: value }) {
    const interactionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    (0, $cozmU.useMemo)(()=>{
        if (!interactionContext) return;
        const interactionId = (0, $4QMIF.getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        (0, $a33Aa.addCohortingCustomData)(currentInteractionId, dataKey, value);
    }, [
        dataKey,
        value,
        interactionContext
    ]);
    return null;
}; // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $7ce401f883a6d6c9$export$2e2bcd8739ae039 = $7ce401f883a6d6c9$var$UFOCustomCohortData;
function $7ce401f883a6d6c9$export$f9c6890b323d326b(key, value) {
    const interactionId = (0, $4QMIF.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $a33Aa.addCohortingCustomData)(currentInteractionId, key, value);
}
module.exports["default"] = $7ce401f883a6d6c9$export$2e2bcd8739ae039;
module.exports["addUFOCustomCohortData"] = $7ce401f883a6d6c9$export$f9c6890b323d326b;

});

parcelRegister("4cW8x", function(module, exports) {
/* ai-answer-dialog.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $3u5lg = parcelRequire("3u5lg");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $5AzUy = parcelRequire("5AzUy");


var $3PNw6 = parcelRequire("3PNw6");


var $a1L5E = parcelRequire("a1L5E");


var $29vMs = parcelRequire("29vMs");

var $cXLoX = parcelRequire("cXLoX");


var $f3OgL = parcelRequire("f3OgL");


var $k8VpS = parcelRequire("k8VpS");


var $aMSTz = parcelRequire("aMSTz");


var $6JEx2 = parcelRequire("6JEx2");


var $bZMnB = parcelRequire("bZMnB");


var $eySxZ = parcelRequire("eySxZ");





var $eVK28 = parcelRequire("eVK28");

const $f557ddd0ea926672$export$baca5c7d93c77000 = ({ userId: userId, cloudId: cloudId, source: source })=>{
    return (0, $cozmU.useMemo)(()=>(0, $eVK28.sha256)(`${userId}-${cloudId}-${Date.now().toString()}-${source}`), [
        userId,
        cloudId,
        source
    ]);
};








const $06f67127312b8dc5$export$6dde22325042712e = (config)=>{
    const { isEnabled: isEnabled, isInViewport: isInViewport, tabHasFocus: tabHasFocus, thresholdMs: thresholdMs, onDwellStart: onDwellStart, onDwellThreshold: onDwellThreshold, onDwellEnd: onDwellEnd } = config;
    const [isThresholdReached, setIsThresholdReached] = (0, $cozmU.useState)(false);
    const [dwellTimer, setDwellTimer] = (0, $cozmU.useState)(null);
    const dwellStartTimeRef = (0, $cozmU.useRef)();
    const isDwellActiveRef = (0, $cozmU.useRef)(false);
    const isInterruptedRef = (0, $cozmU.useRef)(false);
    const isThresholdReachedRef = (0, $cozmU.useRef)(false);
    const isInViewportRef = (0, $cozmU.useRef)(isInViewport);
    const tabHasFocusRef = (0, $cozmU.useRef)(tabHasFocus);
    const onDwellEndRef = (0, $cozmU.useRef)(onDwellEnd);
    // Keep refs in sync with current values
    isInViewportRef.current = isInViewport;
    tabHasFocusRef.current = tabHasFocus;
    onDwellEndRef.current = onDwellEnd;
    // Reset state when disabled
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled) {
            setIsThresholdReached(false);
            isThresholdReachedRef.current = false;
            isDwellActiveRef.current = false;
            isInterruptedRef.current = false;
            dwellStartTimeRef.current = undefined;
            if (dwellTimer) {
                clearTimeout(dwellTimer);
                setDwellTimer(null);
            }
        }
    }, [
        isEnabled,
        dwellTimer
    ]);
    // Handle dwell start
    (0, $cozmU.useEffect)(()=>{
        if (isEnabled && isInViewport && tabHasFocus) // Start dwell if not already active or if interrupted
        {
            if (!isDwellActiveRef.current || isInterruptedRef.current) {
                // Clear any existing timer
                if (dwellTimer) {
                    clearTimeout(dwellTimer);
                    setDwellTimer(null);
                }
                isDwellActiveRef.current = true;
                isInterruptedRef.current = false;
                dwellStartTimeRef.current = Date.now();
                // Fire dwell start event (always fire for QSR tracking)
                onDwellStart?.();
                // Set fresh threshold timer if threshold hasn't been reached yet
                if (!isThresholdReachedRef.current) {
                    const timer = setTimeout(()=>{
                        setDwellTimer(null);
                        // Only fire threshold event if still in viewport, has focus, and not already reached
                        if (isInViewportRef.current && tabHasFocusRef.current && !isThresholdReachedRef.current) {
                            const dwellTime = dwellStartTimeRef.current ? Date.now() - dwellStartTimeRef.current : 0;
                            isThresholdReachedRef.current = true;
                            setIsThresholdReached(true);
                            onDwellThreshold?.(dwellTime);
                        }
                    }, thresholdMs);
                    setDwellTimer(timer);
                }
            }
        }
    }, [
        isEnabled,
        isInViewport,
        tabHasFocus,
        thresholdMs,
        onDwellStart,
        onDwellThreshold,
        dwellTimer
    ]);
    // Handle dwell end (leaving viewport or losing tab focus)
    (0, $cozmU.useEffect)(()=>{
        if (isEnabled && (!isInViewport || !tabHasFocus) && isDwellActiveRef.current) {
            isDwellActiveRef.current = false;
            isInterruptedRef.current = true;
            const dwellTime = dwellStartTimeRef.current ? Date.now() - dwellStartTimeRef.current : 0;
            // Clear timer when leaving viewport or losing focus
            if (dwellTimer) {
                clearTimeout(dwellTimer);
                setDwellTimer(null);
            }
            // Reset threshold state if dwell hasn't been reached yet to allow consecutive sessions
            if (!isThresholdReached) // Reset start time to prepare for next dwell session
            dwellStartTimeRef.current = undefined;
            // Fire dwell end event
            onDwellEnd?.(dwellTime);
        }
    }, [
        isEnabled,
        isInViewport,
        tabHasFocus,
        onDwellEnd,
        dwellTimer,
        isThresholdReached
    ]);
    // Handle page navigation and unmount
    (0, $cozmU.useEffect)(()=>{
        const handleNavigation = ()=>{
            if (isDwellActiveRef.current && dwellStartTimeRef.current) {
                const dwellTime = Date.now() - dwellStartTimeRef.current;
                onDwellEndRef.current?.(dwellTime);
                isDwellActiveRef.current = false; // Prevent duplicate firing
            }
        };
        const removeNavigationListener = (0, $cbY7C.bind)(window, {
            type: 'beforeunload',
            listener: handleNavigation
        });
        return ()=>{
            removeNavigationListener();
            if (isDwellActiveRef.current && dwellStartTimeRef.current) {
                const dwellTime = Date.now() - dwellStartTimeRef.current;
                onDwellEndRef.current?.(dwellTime);
            }
        };
    }, []);
    // Cleanup on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (dwellTimer) clearTimeout(dwellTimer);
        };
    }, [
        dwellTimer
    ]);
};



var $1XsRq = parcelRequire("1XsRq");


var $zzZbq = parcelRequire("zzZbq");

const $b8dde4ad487d9f98$export$38439c13a4683ecf = (smartAnswersRoute)=>{
    switch(smartAnswersRoute){
        case (0, $zzZbq.QueryIntent).PERSON:
            return 'Person Card';
        case (0, $zzZbq.QueryIntent).TEAM:
            return 'Team Card';
        case (0, $zzZbq.QueryIntent).LOCATION:
            return 'Location Card';
        case (0, $zzZbq.QueryIntent).DATE:
            return 'Date Card';
        case (0, $zzZbq.QueryIntent).TOPIC:
            return 'Topic Card';
        case (0, $zzZbq.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY:
            return 'Jira Card';
        case (0, $zzZbq.QueryIntent).JIRA_NLQ_KEYWORD:
            return 'Jira NLQ Keyword Card';
        case (0, $zzZbq.QueryIntent).AGENT:
            return 'Agent Card';
        case (0, $zzZbq.QueryIntent).JIRA_ISSUE:
            return 'Jira Issue Card';
        case (0, $zzZbq.QueryIntent).ORG_CHART:
            return 'Org Chart Card';
        case (0, $zzZbq.QueryIntent).NAVIGATIONAL:
            return 'Navigational';
        case (0, $zzZbq.QueryIntent).NAV_CONTENT:
            return 'Nav Card';
        case (0, $zzZbq.QueryIntent).BOOKMARK:
            return 'Bookmark Knowledge Card';
        case (0, $zzZbq.QueryIntent).VISUAL:
            return 'Visual Card';
        case (0, $zzZbq.QueryIntent).NONE:
            return 'None';
        case (0, $zzZbq.QueryIntent).DEFAULT:
            return 'Default';
        case (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY:
        case (0, $zzZbq.QueryIntent).KEYWORD_OR_ACRONYM:
        default:
            return 'Plain Text';
    }
};



var $7DMz5 = parcelRequire("7DMz5");




/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $w6R6I = parcelRequire("w6R6I");








var $eDWBm = parcelRequire("eDWBm");





var $htnqN = parcelRequire("htnqN");

/* reading-aids-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $hekY6 = parcelRequire("hekY6");

const $43c2452d73591196$export$a9f6f8fd5598a12e = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDOLYo _1mT5xdRAKS _0NUa3rWHam _39xV024DOi _0KLXruoI2d _4bt5LAnQyn _2WAcuGLTLW _3oUqlsYbGa _0jfunhYbGa _3cvhttYbGa _0WcmCNGrMT",
            __cmplp.className
        ])
    });
});


/* reading-aids-popup-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 





var $9aYkv = parcelRequire("9aYkv");

const $74af3b3d0be03000$export$f79f209cc21596d = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, continueAnimation: continueAnimation, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1rywqsk": (0, $9aYkv.default)(__cmplp.isLoading || __cmplp.continueAnimation ? 'rotationAnimation linear 3s infinite' : ''),
            "--_8bhvpm": (0, $9aYkv.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            __cmplp.isLoading || __cmplp.continueAnimation ? 'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)' : "var(--ds-surface-overlay, #FFFFFF)")
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDKTcp _4FKVYEFQfX _2fBhtecplg _2uo31fIuZq _1mT5xdRAKS _2OUyjtGk8v",
            __cmplp.className
        ])
    });
});



var $cuvLu = parcelRequire("cuvLu");





var $aTjYs = parcelRequire("aTjYs");




const $4e7a34c8df556253$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    error_boundary_fallback_text: {
        id: "search_ai.error_boundary_fallback_text",
        defaultMessage: "Something went wrong. Try refreshing the page or trying again later."
    }
});


const $14367db50208fb8a$var$styles = {
    root: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC",
    readingAids: "_2sNsIg20Hp _0Of8r28HPE _1ZnuxbNHnM _1wydGW8HPE _2Zuz6QNHnM _1UtDYzyXux _1EqgXl8WQH _0NUa3rgZxp _2WAcuGIZbP",
    nonReadingAids: "_2sNsIgmnOE _0Of8r2kG2W _1ZnuxbNHnM _1wydGWkG2W _2Zuz6QNHnM _1UtDYzUktF _0NUa3rpL1x _2WAcuGIZbP _39xV02N91d"
};
const $14367db50208fb8a$export$e926676385687eaf = ({ isReadingAids: isReadingAids, wrapper: wrapper, source: source, cloudId: cloudId, children: children })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const DefaultWrapper = isReadingAids ? (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $74af3b3d0be03000$export$f79f209cc21596d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $43c2452d73591196$export$a9f6f8fd5598a12e), null, props.children)) : (0, $aMSTz.SearchDialog);
    const Wrapper = wrapper ? wrapper : DefaultWrapper;
    const logError = (0, $cozmU.useCallback)((error)=>{
        // Currently we are in between deprecating UFOv1 and adopting react-UFO  for platform packages, so this is a temporary way for us to collect error logs
        // https://atlassian.slack.com/archives/C01AY8132S3/p1716509785878689
        const errorAttributes = {
            errorName: error.name,
            errorMessage: error.message,
            errorStack: error.stack?.split('\n').at(1),
            isHello: (0, $aTjYs.isHello)(cloudId)
        };
        createAnalyticsEvent({
            action: 'failed',
            actionSubject: 'aiAnswerDialog',
            source: source || 'unknown',
            eventType: 'track',
            attributes: errorAttributes
        }).fire((0, $zzZbq.DEFAULT_GAS_CHANNEL));
        if ((0, $iDrrr.fg)('kd_sain_error_boundary_shown_event')) createAnalyticsEvent({
            action: 'shown',
            actionSubject: 'aiAnswerError',
            source: source || 'unknown',
            eventType: 'track',
            attributes: {
                ...errorAttributes,
                errorState: (0, $htnqN.NLPSearchErrorState).RenderError
            }
        }).fire((0, $zzZbq.DEFAULT_GAS_CHANNEL));
        (0, $cuvLu.logger).error({
            error: errorAttributes,
            functionName: 'ErrorBoundary: Depricated'
        });
    }, [
        source,
        createAnalyticsEvent,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eDWBm.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($14367db50208fb8a$var$styles.root, isReadingAids ? $14367db50208fb8a$var$styles.root : $14367db50208fb8a$var$styles.readingAids)
        }, formatMessage((0, $4e7a34c8df556253$export$defe85febe8b728c).error_boundary_fallback_text))),
        onException: logError
    }, children);
};





const $e8f4d0b6d7c43b83$export$694ee0cc469a8709 = (isReadingAids, smartAnswersRoute)=>{
    if (isReadingAids) return (0, $zzZbq.AnswerCardType).DEFINITION;
    switch(smartAnswersRoute){
        case (0, $zzZbq.QueryIntent).PERSON:
            return (0, $zzZbq.AnswerCardType).PERSON;
        case (0, $zzZbq.QueryIntent).TEAM:
            return (0, $zzZbq.AnswerCardType).TEAM;
        case (0, $zzZbq.QueryIntent).AGENT:
            return (0, $zzZbq.AnswerCardType).AGENT;
        case (0, $zzZbq.QueryIntent).DATE:
            return (0, $zzZbq.AnswerCardType).DATE;
        case (0, $zzZbq.QueryIntent).LOCATION:
            return (0, $zzZbq.AnswerCardType).LOCATION;
        case (0, $zzZbq.QueryIntent).TOPIC:
            return (0, $zzZbq.AnswerCardType).TOPIC;
        case (0, $zzZbq.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY:
        case (0, $zzZbq.QueryIntent).JIRA_NLQ_KEYWORD:
            return (0, $zzZbq.AnswerCardType).JIRA_NATURAL_LANGUAGE_QUERY;
        case (0, $zzZbq.QueryIntent).JIRA_ISSUE:
            return (0, $zzZbq.AnswerCardType).JIRA_ISSUE;
        case (0, $zzZbq.QueryIntent).NAV_CONTENT:
            return (0, $zzZbq.AnswerCardType).NAV_CONTENT;
        case (0, $zzZbq.QueryIntent).BOOKMARK:
            return (0, $zzZbq.AnswerCardType).BOOKMARK_KNOWLEDGE_CARD;
        case (0, $zzZbq.QueryIntent).VISUAL:
            return (0, $zzZbq.AnswerCardType).VISUAL;
        case (0, $zzZbq.QueryIntent).ORG_CHART:
            return (0, $zzZbq.AnswerCardType).ORG_CHART;
        case (0, $zzZbq.QueryIntent).NAVIGATIONAL:
            return (0, $zzZbq.AnswerCardType).NAVIGATIONAL;
        case (0, $zzZbq.QueryIntent).NONE:
            return (0, $zzZbq.AnswerCardType).NONE;
        case (0, $zzZbq.QueryIntent).DEFAULT:
            return (0, $zzZbq.AnswerCardType).DEFAULT;
        case (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY:
        case (0, $zzZbq.QueryIntent).KEYWORD_OR_ACRONYM:
        default:
            return (0, $zzZbq.AnswerCardType).SAIN;
    }
};












var $hpFQM = parcelRequire("hpFQM");


var $7AtIp = parcelRequire("7AtIp");


var $i5c0A = parcelRequire("i5c0A");




// Types for agent data structure
const $a8292cdc307d0451$export$da698a596bf7d462 = 'KnowledgeCardAgentSearchQuery';
const $a8292cdc307d0451$export$1bee71aceca6bc6 = `
query ${$a8292cdc307d0451$export$da698a596bf7d462}($cloudId: String!, $input: AgentStudioAgentQueryInput!, $limit: Int!) {
    agentStudio_getAgents(cloudId: $cloudId, input: $input, first: $limit) 
    @optIn(to: "AgentStudio")
    {
      edges {
        node {
          id
          identityAccountId
          name
          description
          creator {
            canonicalAccountId
            accountId
            accountStatus
            id
            name
          }
          creatorType
          externalConfigReference
          instructions
          conversationStarters
        }
      }
    }
  }`;


const $7af6e4b8739a3031$var$getAgentSearchInput = (query)=>{
    // Extract agent name from query if it's in a specific format
    // For now, use the query as-is, but this could be enhanced to parse specific formats
    return query.trim();
};
const $7af6e4b8739a3031$export$9cab63c7e0de7ad8 = ({ query: query, limit: limit, sourceProduct: sourceProduct, cloudId: cloudId, workspaceId: workspaceId, traceHeaders: traceHeaders })=>{
    const agentSearchInput = $7af6e4b8739a3031$var$getAgentSearchInput(query);
    return (0, $i5c0A.fetchAggResponse)({
        graphQuery: (0, $a8292cdc307d0451$export$1bee71aceca6bc6),
        variables: {
            cloudId: cloudId,
            input: {
                name: agentSearchInput
            },
            limit: limit
        },
        operationName: (0, $a8292cdc307d0451$export$da698a596bf7d462),
        headers: {
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then((response)=>{
        if (response.errors) throw new Error(`GraphQL errors: ${JSON.stringify(response.errors)}`);
        const edges = response.data?.agentStudio_getAgents?.edges || [];
        const agents = edges.map((edge)=>{
            const agent = edge.node;
            return {
                ...agent,
                // Normalize agent ID by splitting on "/" and taking the last item
                id: agent.id.split('/').pop(),
                // Replace creator object with just the creator ID
                creator: agent.creator?.id,
                creator_type: agent.creatorType,
                identity_account_id: agent.identityAccountId
            };
        });
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(agents),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                ...(0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation') ? {
                    extraAPIAnalyticsAttributes: {
                        requestId: response.extensions?.gateway?.request_id ?? null,
                        traceId: response.extensions?.gateway?.trace_id ?? null
                    }
                } : {}
            }
        };
    }).catch((error)=>{
        if ((0, $iDrrr.fg)('kd_enable_networkerror_logging')) (0, $cuvLu.logger).error({
            error: error,
            functionName: 'fetchAgentCardData'
        });
        return Promise.resolve({
            nlpSearch: {
                errorState: (0, $htnqN.NLPSearchErrorState).NetworkError,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        });
    });
};






var $eW61a = parcelRequire("eW61a");




















var $1AuMq = parcelRequire("1AuMq");

const $df52b12138df743d$var$MAX_CONTRIBUTORS = 3;
const $df52b12138df743d$export$737fdf482f7ddb38 = (recentWork)=>{
    const uniqRecents = new Set();
    return recentWork.reduce((result, recentWorkItem)=>{
        const containerName = recentWorkItem.containers.length > 0 ? recentWorkItem.containers[0].name : recentWorkItem.object.product;
        // creating a key with the container name and title to
        // prevent the posibilty of multiple items with the same name
        const key = `${containerName}:${recentWorkItem.object.name || ''}`;
        if (uniqRecents.has(key)) return result;
        uniqRecents.add(key);
        const curRecentWorkItem = {
            title: recentWorkItem.object.name || '',
            url: recentWorkItem.object.url,
            containerName: containerName,
            event: recentWorkItem.eventType,
            timestamp: recentWorkItem.timestamp,
            iconUrl: !!recentWorkItem.object.icon ? recentWorkItem.object.icon.value : '',
            contributors: recentWorkItem.contributors.slice(0, 3).map((contributor)=>({
                    name: contributor.name,
                    id: contributor.accountId
                })),
            othersCount: recentWorkItem.contributors.length > $df52b12138df743d$var$MAX_CONTRIBUTORS ? recentWorkItem.contributors.length - $df52b12138df743d$var$MAX_CONTRIBUTORS : 0,
            contentTypeName: recentWorkItem.object.__typename
        };
        return result.concat(curRecentWorkItem);
    }, []);
};
const $df52b12138df743d$export$b8d37f4ee3cee5b6 = ({ locale: locale, zoneInfo: zoneInfo })=>{
    return zoneInfo ? new Date().toLocaleTimeString(locale, {
        timeZone: zoneInfo,
        hour: 'numeric',
        minute: 'numeric'
    }).replace(' ', '').toLowerCase() : undefined;
};
const $df52b12138df743d$var$ATLAS_PROD_URL = 'https://home.atlassian.com';
const $df52b12138df743d$var$ATLAS_STAGING_URL = 'https://home.stg.atlassian.com';
const $df52b12138df743d$var$getAtlasHost = ()=>{
    const host = window.location.host;
    const isStaging = host.includes('localhost') || host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
    return isStaging ? $df52b12138df743d$var$ATLAS_STAGING_URL : $df52b12138df743d$var$ATLAS_PROD_URL;
};
const $df52b12138df743d$var$getAtlasURL = (orgId)=>{
    const atlasHost = $df52b12138df743d$var$getAtlasHost();
    return orgId ? `${atlasHost}/o/${orgId}` : atlasHost;
};
const $df52b12138df743d$export$d00d38d973440568 = (agent, orgId)=>{
    const atlasURL = $df52b12138df743d$var$getAtlasURL(orgId);
    return `${atlasURL}/people/agent/${agent.id}`;
};
const $df52b12138df743d$export$782629dc0d11ee5c = (teamId, orgId)=>{
    const atlasURL = $df52b12138df743d$var$getAtlasURL(orgId);
    return `${atlasURL}/people/team/${teamId}`;
};


const $6b0fc42a17642d56$export$5d21e0d2847bfa41 = 'KnowledgeCardUserSearchQuery';
const $6b0fc42a17642d56$export$15ff3b6f089f4729 = `
query ${$6b0fc42a17642d56$export$5d21e0d2847bfa41}($userQuery: String!, $siteId: String!) {
  knowledgeDiscovery {
   	searchUser (
        userQuery: $userQuery
        siteId: $siteId
    ) @optIn(to: "KnowledgeDiscovery Search User"){
      ... on KnowledgeDiscoveryUsers {
        users {
            name
            id
            avatarUrl
            title
            zoneInfo
            location
        }
      }
      ... on QueryError {
        message
      }
    }
  }
}
`;
const $6b0fc42a17642d56$export$4401a05b6c351189 = 'KnowledgeCardPrimaryUserDataQuery';
const $6b0fc42a17642d56$export$10a5d89b90ea01b3 = `
    query ${$6b0fc42a17642d56$export$4401a05b6c351189}(
        $accountId: String!
        $accountIdARI: ID!
        $tenantId: String!
        $requestingUserId: String!
        $featureServiceModel: String!
        ) {
        user(accountId: $accountIdARI) {
            id
            picture
            name
            accountStatus
            ... on AtlassianAccountUser {
                email
                zoneinfo
                extendedProfile {
                    jobTitle
                    department
                    organization
                    location
                }
            }
        }
        smarts {
            recommendedUser(recommendationsQuery: {
            context: {
                userId: $accountId, tenantId: $tenantId
            },
            modelRequestParams: {
                caller: "search-ai",
                experience: "CgUserNearbyUser"
                featureServiceModel: $featureServiceModel
            },
            requestingUserId: $requestingUserId,
            maxNumberOfResults: 8
            }
            ) {
            id
            user {
                id
                picture
                name
                accountStatus
                ... on AtlassianAccountUser {
                email
                extendedProfile {
                    jobTitle
                    department
                }
                }
            }
            }
        }
    }
`;


const $634e333e90210143$export$b40bb50f32e7d452 = ({ personQuery: personQuery, tenantId: tenantId, sourceProduct: sourceProduct, workspaceId: workspaceId, traceHeaders: traceHeaders })=>{
    const siteARI = sourceProduct ? `ari:cloud:${sourceProduct}::site/${tenantId}` : '';
    return (0, $i5c0A.fetchAggResponse)({
        graphQuery: (0, $6b0fc42a17642d56$export$15ff3b6f089f4729),
        variables: {
            userQuery: personQuery,
            siteId: siteARI
        },
        operationName: (0, $6b0fc42a17642d56$export$5d21e0d2847bfa41),
        headers: {
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: tenantId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then(({ data: data, errors: errors })=>{
        const users = data?.knowledgeDiscovery?.searchUser?.users || [];
        const message = data?.knowledgeDiscovery?.searchUser?.message;
        if (errors || message) throw new Error(JSON.stringify({
            errors: errors,
            message: message
        }));
        const mappedResults = users.map((user)=>({
                id: user.id,
                name: user.name,
                avatarUrl: user.avatarUrl || '',
                title: user.title || '',
                zoneInfo: user.zoneInfo || '',
                location: user.location || ''
            }));
        const finalResult = {
            user_metadata_only_cards: mappedResults
        };
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(finalResult),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON
            }
        };
    }).catch((error)=>{
        if ((0, $iDrrr.fg)('kd_enable_networkerror_logging')) (0, $cuvLu.logger).error({
            error: error,
            functionName: 'fetchPersonKnowledgeCardDataWithPostFiltering'
        });
        return Promise.resolve({
            nlpSearch: {
                errorState: (0, $htnqN.NLPSearchErrorState).NetworkError,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        });
    });
};
const $634e333e90210143$export$3b2275a59c992e87 = async ({ personQuery: personQuery, tenantId: tenantId, sourceProduct: sourceProduct, workspaceId: workspaceId, traceHeaders: traceHeaders })=>{
    const siteARI = sourceProduct ? `ari:cloud:${sourceProduct}::site/${tenantId}` : '';
    return (0, $i5c0A.fetchAggResponse)({
        graphQuery: (0, $6b0fc42a17642d56$export$15ff3b6f089f4729),
        variables: {
            userQuery: personQuery,
            siteId: siteARI
        },
        operationName: (0, $6b0fc42a17642d56$export$5d21e0d2847bfa41),
        headers: {
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: tenantId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then(({ data: data, errors: errors, extensions: extensions })=>{
        const users = data?.knowledgeDiscovery?.searchUser?.users || [];
        const message = data?.knowledgeDiscovery?.searchUser?.message;
        if (errors || message) throw new Error(JSON.stringify({
            errors: errors,
            message: message
        }));
        const mappedResults = users.map((user)=>({
                id: user.id,
                name: user.name,
                avatarUrl: user.avatarUrl || '',
                title: user.title || '',
                zoneInfo: user.zoneInfo || '',
                location: user.location || ''
            }));
        const finalResult = {
            user_metadata_only_cards: mappedResults
        };
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(finalResult),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                extraAPIAnalyticsAttributes: {
                    requestId: extensions?.gateway?.request_id ?? null,
                    traceId: extensions?.gateway?.trace_id ?? null
                }
            }
        };
    }).catch((error)=>{
        if ((0, $iDrrr.fg)('kd_enable_networkerror_logging')) (0, $cuvLu.logger).error({
            error: error,
            functionName: 'fetchPersonKnowledgeCardDataWithPostFiltering'
        });
        return Promise.resolve({
            nlpSearch: {
                errorState: (0, $htnqN.NLPSearchErrorState).NetworkError,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        });
    });
};
const $634e333e90210143$export$3e632a26e137d79e = ({ accountId: accountId, tenantId: tenantId, requestingUserId: requestingUserId, activityClient: activityClient, locale: locale, workspaceId: workspaceId, product: product, traceHeaders: traceHeaders })=>{
    const featureServiceModel = (0, $7DMz5.SAINFeatureControl).getCollabGraphExperimentModel();
    const aggPromise = (0, $i5c0A.fetchAggResponse)({
        graphQuery: (0, $6b0fc42a17642d56$export$10a5d89b90ea01b3),
        variables: {
            accountId: accountId,
            accountIdARI: `ari:cloud:identity::user/${accountId}`,
            tenantId: tenantId,
            requestingUserId: requestingUserId,
            featureServiceModel: featureServiceModel
        },
        operationName: (0, $6b0fc42a17642d56$export$4401a05b6c351189),
        headers: {
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: tenantId,
                product: product ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    });
    const activityPromise = activityClient.fetchActivities([
        100
    ], {
        limit: 50,
        actors: [
            `ari:cloud:identity::user/${accountId}`
        ]
    }, [
        'workedOn'
    ], false);
    const toUserProfile = (toAccountId)=>(0, $eW61a.navigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: toAccountId
            },
            cloudId: tenantId
        }).href;
    // Handle the primary user data first, then attempt to fetch activity data
    return Promise.allSettled([
        aggPromise,
        activityPromise
    ]).then((results)=>{
        const [aggResult, activityResult] = results;
        // Handle GraphQL call failure
        if (aggResult.status === 'rejected') throw new Error('Failed to fetch user data');
        const aggResponse = aggResult.value;
        // Create the base user data structure
        const primaryUserData = {
            account_id: accountId,
            name: aggResponse.data?.user.name || '',
            job_title: aggResponse.data?.user.extendedProfile?.jobTitle,
            profile_url: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? toUserProfile(accountId) : `/people/${accountId}`,
            avatar_url: aggResponse.data?.user.picture,
            email: aggResponse.data?.user.email,
            location: aggResponse.data?.user.extendedProfile?.location,
            department: aggResponse.data?.user.extendedProfile?.department,
            organization: aggResponse.data?.user.extendedProfile?.organization,
            time: aggResponse.data?.user.zoneinfo ? (0, $df52b12138df743d$export$b8d37f4ee3cee5b6)({
                locale: locale,
                zoneInfo: aggResponse.data.user.zoneinfo
            }) : undefined,
            collaborators: aggResponse.data?.smarts.recommendedUser.reduce((acc, node)=>{
                if ((0, $1AuMq.trimARI)(node.user.id) !== accountId) acc.push({
                    name: node.user.name,
                    picture: node.user.picture,
                    title: !!node.user.extendedProfile?.jobTitle ? node.user.extendedProfile.jobTitle : null,
                    url: !!node.user.id ? (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? toUserProfile((0, $1AuMq.trimARI)(node.user.id)) : `/people/${(0, $1AuMq.trimARI)(node.user.id)}` : null,
                    accountId: node.user.id,
                    department: !!node.user.extendedProfile?.department ? node.user.extendedProfile.department : null,
                    email: !!node.user.email ? node.user.email : null
                });
                return acc;
            }, []),
            viewAllLink: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? toUserProfile(accountId) : `/people/${accountId}`,
            recentActivity: []
        };
        // Add activity data if the call succeeded
        if (activityResult.status === 'fulfilled' && activityResult.value.workedOn && activityResult.value.workedOn.length > 0) primaryUserData.recentActivity = (0, $df52b12138df743d$export$737fdf482f7ddb38)(activityResult.value.workedOn);
        return primaryUserData;
    });
};
























const $cd3be417d12ec829$export$330a89c6d5120b7c = 'KnowledgeCardTeamSearchQuery';
const $cd3be417d12ec829$export$f20269ab1c2af3aa = `
query ${$cd3be417d12ec829$export$330a89c6d5120b7c}($teamQuery: String!, $orgId: String!, $siteId: String!) {
  knowledgeDiscovery {
   	searchTeam (
        teamName: $teamQuery
        orgId: $orgId
        siteId: $siteId
    ) @optIn(to: "KnowledgeDiscovery Search Team"){
      ... on KnowledgeDiscoveryTeam {
        id
      }
      ... on QueryError {
        message
      }
    }
  }
}
`;
const $cd3be417d12ec829$export$1cc3d8f1a53775f = 'KnowledgeCardTeamDataQuery';
const $cd3be417d12ec829$export$b98556be52d17f2f = `
query ${$cd3be417d12ec829$export$1cc3d8f1a53775f}($teamId: ID!, $siteId: String!) {
    team {
      teamV2 (
        id: $teamId
        siteId: $siteId
      ) @optIn(to: "Team-v2") {
        id
        displayName
        smallAvatarImageUrl
        members {
          nodes {
            member {
              id
              accountId
              name
              picture
              ... on AtlassianAccountUser {
                email
                extendedProfile {
                  jobTitle
                  department
                }
              }
            }
            state
          }
        }
      }
    }
  }
`;


const $2bf628be7eb8a184$export$588cacdc66ef53ad = {
    team_metadata: {
        id: '',
        name: '',
        avatarUrl: null,
        url: null,
        memberCount: 0,
        members: [],
        recentActivity: []
    }
};


const $5440ea745c72f677$var$NO_TEAM_MESSAGE = 'NO_TEAM';
const $5440ea745c72f677$export$1d3fe260188fa7d9 = ({ activityClient: activityClient, teamQuery: teamQuery, orgId: orgId, siteId: siteId, sourceProduct: sourceProduct, workspaceId: workspaceId, traceHeaders: traceHeaders })=>{
    let teamResult;
    let teamData;
    let activityResult;
    const siteARI = sourceProduct ? `ari:cloud:${sourceProduct}::site/${siteId}` : '';
    const toTeam = (teamId)=>(0, $eW61a.navigateToTeamsApp)({
            type: 'TEAM',
            payload: {
                teamId: teamId
            },
            cloudId: siteId,
            orgId: orgId
        }).href;
    let actors = [];
    return (0, $i5c0A.fetchAggResponse)({
        graphQuery: (0, $cd3be417d12ec829$export$f20269ab1c2af3aa),
        variables: {
            teamQuery: teamQuery,
            orgId: orgId,
            siteId: siteARI
        },
        operationName: (0, $cd3be417d12ec829$export$330a89c6d5120b7c),
        headers: {
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: siteId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then(({ data: data, errors: errors })=>{
        const id = data?.knowledgeDiscovery.searchTeam?.id;
        if (!errors && id) teamResult = id;
        else throw new Error($5440ea745c72f677$var$NO_TEAM_MESSAGE);
        return (0, $i5c0A.fetchAggResponse)({
            graphQuery: (0, $cd3be417d12ec829$export$b98556be52d17f2f),
            variables: {
                teamId: teamResult,
                siteId: siteId
            },
            operationName: (0, $cd3be417d12ec829$export$1cc3d8f1a53775f),
            headers: {
                ...(0, $7AtIp.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: siteId,
                    product: sourceProduct ?? ''
                }),
                ...traceHeaders ?? undefined
            }
        });
    }).then(({ data: data, errors: errors })=>{
        if (!errors && data?.team.teamV2?.id) teamData = data;
        else throw new Error($5440ea745c72f677$var$NO_TEAM_MESSAGE);
        actors = teamData.team.teamV2?.members?.nodes?.map((node)=>node.member ? node.member.id : '').filter((member)=>!!member) || [];
        return activityClient.fetchActivities([
            100
        ], {
            limit: 100,
            actors: actors,
            rootContainerIds: [
                `ari:cloud:platform::site/${siteId}`
            ]
        }, [
            'workedOn'
        ], false);
    }).then((data)=>{
        if (data.workedOn && data.workedOn.length > 0) activityResult = data.workedOn;
        const filteredActivityResult = $5440ea745c72f677$export$bd0b250fe24a4365(activityResult || [], actors);
        const finalResult = {
            team_metadata: {
                id: teamData?.team.teamV2?.id || '',
                name: teamData?.team.teamV2?.displayName || '',
                avatarUrl: teamData?.team.teamV2?.smallAvatarImageUrl || null,
                url: teamData?.team.teamV2?.id ? (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? toTeam(teamData?.team.teamV2?.id) : `/people/team/${(0, $1AuMq.trimARI)(teamData?.team.teamV2?.id)}` : null,
                memberCount: teamData?.team.teamV2?.members.nodes.length || 0,
                members: teamData?.team.teamV2?.members?.nodes ? $5440ea745c72f677$var$sanitizeAndMapTeamMembers(teamData.team.teamV2.members.nodes) : [],
                recentActivity: filteredActivityResult ? (0, $df52b12138df743d$export$737fdf482f7ddb38)(filteredActivityResult) : []
            }
        };
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(finalResult),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON
            }
        };
    }).catch((error)=>{
        if (error instanceof Object && 'message' in error && error.message === $5440ea745c72f677$var$NO_TEAM_MESSAGE) return {
            nlpSearch: {
                nlpResult: JSON.stringify((0, $2bf628be7eb8a184$export$588cacdc66ef53ad)),
                errorState: null,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        };
        if ((0, $iDrrr.fg)('kd_enable_networkerror_logging')) (0, $cuvLu.logger).error({
            error: error,
            functionName: 'fetchTeamKnowledgeCardDataWithRanking'
        });
        return Promise.reject(error);
    });
};
const $5440ea745c72f677$export$b9b0423f67d54dce = async ({ activityClient: activityClient, teamQuery: teamQuery, orgId: orgId, siteId: siteId, sourceProduct: sourceProduct, workspaceId: workspaceId, traceHeaders: traceHeaders })=>{
    const siteARI = sourceProduct ? `ari:cloud:${sourceProduct}::site/${siteId}` : '';
    const toTeam = (teamId)=>(0, $eW61a.navigateToTeamsApp)({
            type: 'TEAM',
            payload: {
                teamId: teamId
            },
            cloudId: siteId,
            orgId: orgId
        }).href;
    return (0, $i5c0A.fetchAggResponse)({
        graphQuery: (0, $cd3be417d12ec829$export$f20269ab1c2af3aa),
        variables: {
            teamQuery: teamQuery,
            orgId: orgId,
            siteId: siteARI
        },
        operationName: (0, $cd3be417d12ec829$export$330a89c6d5120b7c),
        headers: {
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: siteId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then(({ data: data, errors: errors })=>{
        const id = data?.knowledgeDiscovery.searchTeam?.id;
        if (errors || !id) throw new Error($5440ea745c72f677$var$NO_TEAM_MESSAGE);
        return (0, $i5c0A.fetchAggResponse)({
            graphQuery: (0, $cd3be417d12ec829$export$b98556be52d17f2f),
            variables: {
                teamId: id,
                siteId: siteId
            },
            operationName: (0, $cd3be417d12ec829$export$1cc3d8f1a53775f),
            headers: {
                ...(0, $7AtIp.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: siteId,
                    product: sourceProduct ?? ''
                }),
                ...traceHeaders ?? undefined
            }
        });
    }).then(async ({ data: data, errors: errors, extensions: extensions })=>{
        if (errors || !data?.team.teamV2?.id) throw new Error($5440ea745c72f677$var$NO_TEAM_MESSAGE);
        const actors = data.team.teamV2?.members?.nodes?.map((node)=>node.member ? node.member.id : '').filter((member)=>!!member) || [];
        const activityData = await activityClient.fetchActivities([
            100
        ], {
            limit: 100,
            actors: actors,
            rootContainerIds: [
                `ari:cloud:platform::site/${siteId}`
            ]
        }, [
            'workedOn'
        ], false);
        return {
            activityData: activityData,
            actors: actors,
            extensions: extensions,
            teamData: data
        };
    }).then(({ activityData: activityData, actors: actors, extensions: extensions, teamData: teamData })=>{
        let activityResult = [];
        if (activityData.workedOn && activityData.workedOn.length > 0) activityResult = activityData.workedOn;
        const filteredActivityResult = $5440ea745c72f677$export$bd0b250fe24a4365(activityResult, actors);
        const finalResult = {
            team_metadata: {
                id: teamData?.team.teamV2?.id || '',
                name: teamData?.team.teamV2?.displayName || '',
                avatarUrl: teamData?.team.teamV2?.smallAvatarImageUrl || null,
                url: teamData?.team.teamV2?.id ? (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? toTeam(teamData?.team.teamV2?.id) : `/people/team/${(0, $1AuMq.trimARI)(teamData?.team.teamV2?.id)}` : null,
                memberCount: teamData?.team.teamV2?.members.nodes.length || 0,
                members: teamData?.team.teamV2?.members?.nodes ? $5440ea745c72f677$var$sanitizeAndMapTeamMembers(teamData.team.teamV2.members.nodes) : [],
                recentActivity: filteredActivityResult ? (0, $df52b12138df743d$export$737fdf482f7ddb38)(filteredActivityResult) : []
            }
        };
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(finalResult),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                extraAPIAnalyticsAttributes: {
                    requestId: extensions?.gateway?.request_id ?? null,
                    traceId: extensions?.gateway?.trace_id ?? null
                }
            }
        };
    }).catch((error)=>{
        if (error instanceof Object && 'message' in error && error.message === $5440ea745c72f677$var$NO_TEAM_MESSAGE) return {
            nlpSearch: {
                nlpResult: JSON.stringify((0, $2bf628be7eb8a184$export$588cacdc66ef53ad)),
                errorState: null,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        };
        if ((0, $iDrrr.fg)('kd_enable_networkerror_logging')) (0, $cuvLu.logger).error({
            error: error,
            functionName: 'fetchTeamKnowledgeCardDataWithRanking'
        });
        return Promise.reject(error);
    });
};
const $5440ea745c72f677$var$sanitizeAndMapTeamMembers = (members)=>{
    return members.reduce(function(result, memberNode) {
        if (!!memberNode.member) return result.concat({
            name: memberNode.member.name || '',
            picture: memberNode.member.picture || null,
            title: memberNode.member.extendedProfile?.jobTitle || null,
            url: !!memberNode.member.id ? `/people/${(0, $1AuMq.trimARI)(memberNode.member.id)}` : null,
            accountId: !!memberNode.member.id ? (0, $1AuMq.trimARI)(memberNode.member.id) : null,
            department: memberNode.member.extendedProfile?.department || null,
            email: memberNode.member.email || null
        });
        return result;
    }, []);
};
const $5440ea745c72f677$var$excludedEventTypes = [
    'commented',
    'updated'
];
const $5440ea745c72f677$export$bd0b250fe24a4365 = (activityResult, members)=>{
    const teamMemberSet = new Set(members);
    return activityResult.reduce((filtered, activity)=>{
        const involvedTeamMembers = activity.contributors.filter((contributor)=>teamMemberSet.has(`ari:cloud:identity::user/${contributor.accountId}`));
        if (involvedTeamMembers.length >= 1 && !$5440ea745c72f677$var$excludedEventTypes.includes(activity.eventType)) filtered.push({
            ...activity,
            contributors: involvedTeamMembers
        });
        return filtered;
    }, []);
};




















const $9386e59ea9a4ea77$export$f928298386dd496b = 'KnowledgeDiscoveryPlatformTopicByIdQuery';
const $9386e59ea9a4ea77$export$9c5339bca50e4652 = `
	query ${$9386e59ea9a4ea77$export$f928298386dd496b}($cloudId: String!, $topicId: String!, $userCount: Int!) {
		knowledgeDiscovery {
			topic(cloudId: $cloudId, id: $topicId) {
				...on KnowledgeDiscoveryTopic {
					id
					name
					description
				}
				...on QueryError {
					message
				}
			}
			users: relatedEntities(
				cloudId: $cloudId
				entityId: $topicId
				entityType: TOPIC
				relatedEntityType: USER
				first: $userCount
			) @optIn(to: "KnowledgeDiscovery Get Related Entities") {
				...on KnowledgeDiscoveryRelatedEntityConnection {
					nodes {
						...on KnowledgeDiscoveryUser {
							user {
								id
								name
								picture
								accountId
								accountStatus
								...on AtlassianAccountUser {
									extendedProfile {
										jobTitle
									}
								}
							}
						}
					}
				}
				...on QueryError {
					message
				}
			}
		}
	}
`;


const $f015000a0fe91d29$var$getTopicId = (topicIds)=>{
    const list = JSON.parse(topicIds);
    if (Array.isArray(list) && list.length) return list[0];
    return '';
};
const $f015000a0fe91d29$var$NO_TOPIC_FOUND_MESSAGE = 'No topic found for id:';
const $f015000a0fe91d29$export$d25837238feb3ab6 = ({ cloudId: cloudId, query: query, workspaceId: workspaceId, sourceProduct: sourceProduct, traceHeaders: traceHeaders })=>{
    const userCount = 5;
    // transformedQuery from intent detection passed as query prop to SearchAIDialog from SearchPage
    // transformedQuery is a str e.g. "["f6aac8a1-7907-4fb0-88ca-d7a564b45db3"]" and need to extract id
    const topicId = $f015000a0fe91d29$var$getTopicId(query);
    return (0, $i5c0A.fetchAggResponse)({
        graphQuery: (0, $9386e59ea9a4ea77$export$9c5339bca50e4652),
        variables: {
            cloudId: cloudId,
            topicId: topicId,
            userCount: userCount
        },
        operationName: (0, $9386e59ea9a4ea77$export$f928298386dd496b),
        headers: {
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: sourceProduct ?? ''
            }),
            ...traceHeaders ?? undefined
        }
    }).then(({ data: data, errors: errors })=>{
        const message = data?.knowledgeDiscovery.topic.message;
        // if message includes no topic found, we move forward to rendering card
        // in no topic found state (right now is nothing similar to People/Team card)
        if (errors || message && !message.includes($f015000a0fe91d29$var$NO_TOPIC_FOUND_MESSAGE)) throw new Error(JSON.stringify({
            errors: errors,
            message: message
        }));
        const topicUserData = data?.knowledgeDiscovery || {};
        return {
            nlpSearch: {
                nlpResult: JSON.stringify(topicUserData),
                uniqueSources: [],
                disclaimer: null,
                errorState: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON
            }
        };
    }).catch((error)=>{
        if ((0, $iDrrr.fg)('kd_enable_networkerror_logging')) (0, $cuvLu.logger).error({
            error: error,
            functionName: 'fetchTopicCardData'
        });
        return Promise.resolve({
            nlpSearch: {
                errorState: (0, $htnqN.NLPSearchErrorState).NetworkError,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                uniqueSources: []
            }
        });
    });
};






var $70CUF = parcelRequire("70CUF");


var $3hVWe = parcelRequire("3hVWe");







/* JiraNlToJqlCard.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $I7hWB = parcelRequire("I7hWB");


var $5HApy = parcelRequire("5HApy");











var $b3ffN = parcelRequire("b3ffN");




const $d6ee00d3c7ff7f25$export$10fed66da45c02f6 = ({ searchSessionId: searchSessionId, queryHash: queryHash, brand: brand, source: source, query: query, loadTime: loadTime, success: success, answerCardType: answerCardType, answerString: answerString, endState: endState, jiraNlToJqlCardVariant: jiraNlToJqlCardVariant, nlToJqlLoadTime: nlToJqlLoadTime, issueSearchLoadTime: issueSearchLoadTime, phaseTimingSource: phaseTimingSource })=>{
    return {
        action: 'loaded',
        actionSubject: 'aiAnswerJiraNlToJqlCard',
        source: source,
        eventType: 'track',
        attributes: {
            searchSessionId: searchSessionId,
            queryHash: queryHash,
            brand: brand,
            source: source,
            loadTime: loadTime,
            success: success,
            answerCardType: answerCardType,
            endState: endState,
            jiraNlToJqlCardVariant: jiraNlToJqlCardVariant,
            nlToJqlLoadTime: nlToJqlLoadTime,
            issueSearchLoadTime: issueSearchLoadTime,
            phaseTimingSource: phaseTimingSource
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};


const $fce67a5f4fe3c54f$export$447238500b8bc926 = ({ searchSessionId: searchSessionId, queryHash: queryHash, brand: brand, source: source, query: query, answerCardType: answerCardType, answerString: answerString })=>{
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerJiraCardViewAll',
        source: source,
        eventType: 'ui',
        attributes: {
            searchSessionId: searchSessionId,
            queryHash: queryHash,
            brand: brand,
            source: source,
            answerCardType: answerCardType
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};



var $aYqz2 = parcelRequire("aYqz2");


var $uY2pq = parcelRequire("uY2pq");








var $8tNXq = parcelRequire("8tNXq");











var $9oghv = parcelRequire("9oghv");


var $kpjET = parcelRequire("kpjET");


var $aiIBH = parcelRequire("aiIBH");













const $04e88a3273a73ea1$export$d77346a16f68afc1 = `
query IssueSearchStable($cloudId: ID!, $first: Int, $issueSearchInput: JiraIssueSearchInput!) {
  jira {
    issueSearchStable(
      cloudId: $cloudId
      first: $first
      issueSearchInput: $issueSearchInput
    ) {
      totalIssueSearchResultCount
      totalCount
      edges {
        node {
          key
          webUrl
          summary
          issueTypeField {
            issueType {
              name
              avatar {
                xsmall
                small
                medium
                large
              }
            }
          }
          status {
            name
            statusCategory {
              name
              colorName
              statusCategoryId
            }
          }
          assigneeField {
            user {
              picture
              name
              accountId
            }
          }
          priorityField {
            priority {
              name
              iconUrl
              color
            }
          }
        }
      }
    }
  }
}
`;


const $b2c833a5b9632464$var$MAIN_ISSUE_SEARCH_QUERY_OPERATION_NAME = 'IssueSearchStable';
const $b2c833a5b9632464$var$fetchIssueSearchQuery = async ({ variables: variables, workspaceId: workspaceId, product: product })=>{
    return (0, $i5c0A.fetchAggResponse)({
        variables: variables,
        graphQuery: (0, $04e88a3273a73ea1$export$d77346a16f68afc1),
        operationName: $b2c833a5b9632464$var$MAIN_ISSUE_SEARCH_QUERY_OPERATION_NAME,
        headers: {
            'X-ExperimentalApi': 'JiraIssueSearch',
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: variables.cloudId,
                product: product
            })
        }
    }).then((response)=>{
        return {
            data: response.data,
            extensions: response.extensions
        };
    }).catch((error)=>{
        (0, $cuvLu.logger).error({
            error: error,
            functionName: 'useIssueSearchQuery'
        });
        // rethrow error to be handled by the caller
        throw error;
    });
};
const $b2c833a5b9632464$export$11659072884978f5 = ({ cloudId: cloudId, jql: jql, workspaceId: workspaceId, product: product })=>{
    const [loading, setIsLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(false);
    const [issues, setIssues] = (0, $cozmU.useState)();
    const [totalIssuesCount, setTotalIssuesCount] = (0, $cozmU.useState)();
    const [extensions, setExtensions] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                setIsLoading(true);
                const { data: data, extensions: extensions } = await $b2c833a5b9632464$var$fetchIssueSearchQuery({
                    variables: {
                        cloudId: cloudId,
                        first: 5,
                        issueSearchInput: {
                            jql: jql || ''
                        }
                    },
                    workspaceId: workspaceId,
                    product: product
                });
                if (data?.errors?.length) {
                    setError(true);
                    throw new Error(data.errors[0].message || 'Unknown error');
                }
                setIssues(data?.jira?.issueSearchStable?.edges || []);
                setTotalIssuesCount(data?.jira?.issueSearchStable?.totalIssueSearchResultCount);
                setExtensions(extensions);
            } catch (e) {
                (0, $cuvLu.logger).error({
                    error: e,
                    functionName: 'useIssueNavigatorQuery'
                });
                setError(true);
            } finally{
                setIsLoading(false);
            }
        };
        if (Boolean(jql)) fetchData();
    }, [
        cloudId,
        jql,
        workspaceId,
        product
    ]);
    return {
        issues: issues,
        extensions: extensions,
        totalIssuesCount: totalIssuesCount,
        loading: loading,
        error: error
    };
};












var $gABt9 = parcelRequire("gABt9");


var $jarkA = parcelRequire("jarkA");

async function $e0e4b115d41f7a74$export$180c897189be2f25({ variables: variables, operationName: operationName, aggUrl: url, headers: headers, cache: cache }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers ? {
                    ...headers
                } : {}
            },
            body: JSON.stringify({
                operationName: operationName,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName,
                // `operation` is added alongside `q` so UFO's Jira resource-timing
                // `sanitiseEndpoints` keys this fetch by its operation name instead
                // of collapsing it into the anonymous `gateway_api_graphql` bucket.
                ...(0, $iDrrr.fg)('kd_fe_ufo_named_agg_resources') && {
                    operation: operationName
                }
            }
        }
    };
    // if there's a ttl use fetch with in-mem cacheing
    if (cache && (0, $iDrrr.fg)('kd_fe_enable_agg_cache')) return $e0e4b115d41f7a74$var$fetchPersistedAggResponseWithCache({
        cache: cache,
        aggUrl: url,
        options: options
    });
    return (0, $gABt9.utils).requestService({
        url: url
    }, options);
}
async function $e0e4b115d41f7a74$var$fetchPersistedAggResponseWithCache({ aggUrl: url, cache: cache, options: options }) {
    let cachedResponse = (0, $jarkA.InMemCache).getData(cache.key);
    if (cachedResponse && (0, $jarkA.InMemCache).isValid(cache.key)) return Promise.resolve(cachedResponse);
    // return a pending promise that was cached earlier
    const inflightRequest = (0, $jarkA.InMemCache).getInflightRequest(cache.key);
    if (inflightRequest) return inflightRequest;
    // cache miss, fetch data from agg and store ref to promise
    const request = new Promise(async (resolve, reject)=>{
        try {
            const response = await (0, $gABt9.utils).requestService({
                url: url
            }, options);
            (0, $jarkA.InMemCache).setData({
                key: cache.key,
                response: response,
                ttl: cache.ttl
            });
            resolve(response);
        } catch (error) {
            reject(error);
        } finally{
            (0, $jarkA.InMemCache).removeInflightRequest(cache.key);
        }
    });
    (0, $jarkA.InMemCache).setInflightRequest({
        key: cache.key,
        request: request
    });
    return request;
}





const $2cca25495c5a9447$var$OPERATION_NAME = 'useNaturalLanguageToJqlQuery';
const $2cca25495c5a9447$var$fetchNaturalLanguageToJqlQuery = async ({ variables: variables, workspaceId: workspaceId, product: product })=>{
    return (0, $e0e4b115d41f7a74$export$180c897189be2f25)({
        variables: variables,
        operationName: $2cca25495c5a9447$var$OPERATION_NAME,
        aggUrl: '/gateway/api/graphql/slow/pq/0d32e3740e78f81c3620f117dc1c654e0d259815cecf53bfdaf62665b57d126b',
        headers: {
            'X-ExperimentalApi': 'JiraIssueSearch',
            'x-atlassian-capability': 'NIN_NEW_ISSUE_NAVIGATOR--other',
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: variables.cloudId,
                product: product
            })
        },
        cache: {
            key: `${$2cca25495c5a9447$var$OPERATION_NAME}.${variables.naturalLanguageInput}`,
            ttl: 300000
        }
    }).then((response)=>response.data);
};
const $2cca25495c5a9447$export$eca952b1040f8ff3 = ({ cloudId: cloudId, query: query, workspaceId: workspaceId, product: product, enabled: enabled = true })=>{
    const [loading, setIsLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(false);
    const [jql, setJql] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) {
            setIsLoading(false);
            setError(false);
            setJql(undefined);
            return;
        }
        const fetchData = async ()=>{
            try {
                setIsLoading(true);
                const data = await $2cca25495c5a9447$var$fetchNaturalLanguageToJqlQuery({
                    variables: {
                        cloudId: cloudId,
                        naturalLanguageInput: query,
                        iteration: 'ITERATION_2',
                        project: null
                    },
                    workspaceId: workspaceId,
                    product: product
                });
                const generatedJQL = data?.jira?.naturalLanguageToJql?.generatedJQL || undefined;
                if (data?.jira?.naturalLanguageToJql?.generatedJQLError) {
                    setError(true);
                    throw new Error(data.jira.naturalLanguageToJql.generatedJQLError.message);
                }
                if (data?.errors?.length) {
                    setError(true);
                    throw new Error(data.errors[0].message || 'Unknown error');
                }
                // catch all
                if (!Boolean(generatedJQL)) {
                    setError(true);
                    throw new Error('No JQL generated');
                }
                setJql(generatedJQL);
            } catch (e) {
                (0, $cuvLu.logger).error({
                    error: e,
                    functionName: 'useNaturalLanguageToJqlQuery'
                });
                setError(true);
            } finally{
                setIsLoading(false);
            }
        };
        if (!!cloudId) fetchData();
    }, [
        enabled,
        cloudId,
        query,
        product,
        workspaceId
    ]);
    return {
        jql: jql,
        loading: loading,
        error: error
    };
};


/**
 * Build a deterministic keyword JQL query of the form `textfields ~ "<query>*"`.
 *
 * This mirrors the NIN translation strategy used when a query goes from Quick
 * Find to the new Issue Navigator and is the FE counterpart to the backend's
 * `JIRA_NLQ_KEYWORD` suppression path introduced in xp-knowledge-discovery
 * PR #1611.
 *
 * The user query is sanitised before being interpolated so that the resulting
 * JQL is always well-formed AND only the trailing `*` we explicitly append is
 * treated as a wildcard. Specifically:
 *
 *  - Surrounding whitespace is trimmed.
 *  - Backslashes are escaped first (`\` → `\\`).
 *  - Double quotes are escaped so the surrounding quoted JQL string stays
 *    valid (`"` → `\"`).
 *  - The Lucene/JQL wildcard characters `*` and `?` inside the user query are
 *    escaped (`*` → `\*`, `?` → `\?`) so they are matched literally and do
 *    not turn into unintended wildcards in the middle of a term. For example,
 *    the input `fix * login` becomes `textfields ~ "fix \* login*"` instead
 *    of `textfields ~ "fix * login*"`, which would otherwise match far more
 *    issues than the user intended.
 *
 * If the query is empty or whitespace-only the function returns `null` so the
 * caller can decide how to handle the no-op case (e.g. surface an error card).
 */ const $76b1398b70af7db1$export$4ab7a1642c5a2b25 = (rawQuery)=>{
    const trimmed = rawQuery.trim();
    if (trimmed.length === 0) return null;
    // Escape backslashes first so the subsequent escapes don't get re-escaped,
    // then escape double quotes (string delimiter) and the JQL wildcards `*`
    // and `?` so user input is matched literally inside the quoted Lucene
    // query. The only wildcard we want in the resulting JQL is the trailing
    // `*` that we append ourselves.
    const escaped = trimmed.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\*/g, '\\*').replace(/\?/g, '\\?');
    return `textfields ~ "${escaped}*"`;
};


/* ErrorCard.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");







var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $j9bgP = parcelRequire("j9bgP");




const $6ee04b9bd73a1654$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    headerWork: {
        id: "search_ai.jira_nl_to_jql_card.table_header.work",
        defaultMessage: "Work"
    },
    headerStatus: {
        id: "search_ai.jira_nl_to_jql_card.table_header.status",
        defaultMessage: "Status"
    },
    headerAssignee: {
        id: "search_ai.jira_nl_to_jql_card.table_header.assignee",
        defaultMessage: "Assignee"
    },
    headerPriority: {
        id: "search_ai.jira_nl_to_jql_card.table_header.priority",
        defaultMessage: "Priority"
    },
    cardTitle: {
        id: "search_ai.jira_nl_to_jql_card.card.title",
        defaultMessage: "Top Jira work items"
    },
    smartlinkCardTitle: {
        id: "search_ai.jira_nl_to_jql_smartlink_card.card.title",
        defaultMessage: "Answer"
    },
    errorMessage: {
        id: "search_ai.jira_nl_to_jql_card.error",
        defaultMessage: "Rovo couldn't generate an answer for \"{title}\". Try rephrasing your query."
    },
    errorMessageWithViewAll: {
        id: "search_ai.jira_nl_to_jql_error_card.error_with_view_all",
        defaultMessage: "Rovo couldn't generate an answer for \"{query}\". Try rephrasing your query or navigate to Jira work items to reformulate your query."
    },
    noResultsMessage: {
        id: "search_ai.jira_nl_to_jql_card.no_results",
        defaultMessage: "No results found"
    },
    unassigned: {
        id: "search_ai.jira_nl_to_jql_card.unassigned",
        defaultMessage: "Unassigned"
    },
    viewAll: {
        id: "search_ai.jira_nl_to_jql_card.viewall",
        defaultMessage: "{totalCount, plural, one {View {totalCount, number} work item} other {View all {totalCount, number} work items}}"
    },
    viewAllNoCount: {
        id: "search_ai.jira_nl_to_jql_card.viewall_no_count",
        defaultMessage: "View all work items"
    },
    close: {
        id: "search_ai.jira_nl_to_jql_card.close",
        defaultMessage: "Close"
    },
    expand: {
        id: "search_ai.jira_nl_to_jql_card.expand",
        defaultMessage: "Expand table"
    },
    collapse: {
        id: "search_ai.jira_nl_to_jql_card.collapse",
        defaultMessage: "Collapse table"
    },
    dismiss: {
        id: "search_ai.jira_nl_to_jql_card.dismiss",
        defaultMessage: "Dismiss"
    },
    hide: {
        id: "search_ai.jira_nl_to_jql_card.hide",
        defaultMessage: "Hide table"
    },
    unhide: {
        id: "search_ai.jira_nl_to_jql_card.unhide",
        defaultMessage: "Show table"
    }
});


const $c7397925ebe4947f$var$styles = {
    container: "_0bjKvDKxmn _30huDKOeNX _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    onlineDebuggerButtonContainer: "_2XsHFMIZbP _39xV02E6Kk"
};
const $c7397925ebe4947f$export$a2c93507c97cd090 = ({ query: query })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(true);
    const showOnlineDebuggerButton = (0, $iDrrr.fg)('kd_sain_online_debugger');
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, isOpen ? /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: $c7397925ebe4947f$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "bold"
    }, formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).errorMessage, {
        title: query
    })), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).close),
        onClick: ()=>setIsOpen(false)
    })), showOnlineDebuggerButton && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $c7397925ebe4947f$var$styles.onlineDebuggerButtonContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $j9bgP.OnlineDebuggerButton), null))) : null);
};


/* IssueTable.tsx generated by @compiled/babel-plugin v2.0.0 */ 













/* IssueKeyNode.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $7vK9E = parcelRequire("7vK9E");




var $jLxvy = parcelRequire("jLxvy");

const $a682b9c97392c96a$export$ea403d9edffb26a2 = ({ searchSessionId: searchSessionId, queryHash: queryHash, brand: brand, source: source, query: query, issuekey: issuekey, answerCardType: answerCardType, answerString: answerString, isAuxClick: isAuxClick, isContextMenu: isContextMenu })=>{
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerJiraCardWorkItemLink',
        source: source,
        eventType: 'ui',
        attributes: {
            searchSessionId: searchSessionId,
            queryHash: queryHash,
            brand: brand,
            source: source,
            answerCardType: answerCardType,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        },
        nonPrivacySafeAttributes: {
            answerString: answerString,
            query: query,
            issuekey: issuekey
        }
    };
};












var $jtIlq = parcelRequire("jtIlq");

const $1eaffb3e826a5326$var$styles = {
    noWrap: "_1ANEUSLRg7"
};
const $1eaffb3e826a5326$export$227b36be34e771c5 = ({ issuekey: issuekey, url: url, analyticsAttributes: analyticsAttributes, fireEngagementEvent: fireEngagementEvent })=>{
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        const isAuxClick = e?.button === 1;
        const isContextMenu = e?.button === 2;
        if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $a682b9c97392c96a$export$ea403d9edffb26a2)({
            ...analyticsAttributes,
            issuekey: issuekey,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        }));
        fireAnalyticsEvent((0, $jtIlq.onNonGenerativeKnowledgeCardLinkClick)({
            ...analyticsAttributes,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        }));
        if ((0, $iDrrr.fg)('kd_fix_nl2jql_mau_instrumentation')) fireEngagementEvent((0, $bZMnB.SainAction).JIRA_NL_TO_JQL_WORK_ITEM_CLICKED);
    }, [
        fireAnalyticsEvent,
        fireEngagementEvent,
        analyticsAttributes,
        issuekey
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        onAuxClick: (e)=>{
            if (e.button !== 1) return;
            handleClick(e);
        },
        onContextMenu: handleClick
    }, /*#__PURE__*/ $cozmU.createElement((0, $jLxvy.StandaloneHoverCard), {
        url: url
    }, /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
        href: url,
        xcss: $1eaffb3e826a5326$var$styles.noWrap,
        onClick: handleClick
    }, issuekey)));
};


/* IssuePriorityNode.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $lpNn5 = parcelRequire("lpNn5");

const $c41d65128d47dc0a$export$a62149baee0d175c = ({ IssuePriorityField: IssuePriorityField })=>{
    if (!IssuePriorityField?.priority) return null;
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        alignInline: "start"
    }, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: IssuePriorityField.priority.name,
        // tooltip content is the same as the items content
        isScreenReaderAnnouncementDisabled: true
    }, /*#__PURE__*/ $cozmU.createElement("img", {
        height: "16",
        width: "16",
        src: IssuePriorityField.priority.iconUrl,
        alt: IssuePriorityField.priority.name
    })));
};


/* IssueStatusNode.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $9KSWX = parcelRequire("9KSWX");

const $30e068cd4e7a88d9$export$47dfea36fbf85d70 = ({ status: status })=>{
    if (!status?.name || !status?.statusCategory.statusCategoryId) return null;
    let appearance = 'neutral';
    switch(status.statusCategory.statusCategoryId){
        case '2':
            appearance = 'neutral';
            break;
        case '4':
            appearance = 'information';
            break;
        case '3':
            appearance = 'success';
            break;
    }
    return /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: true
    }, status.name.toUpperCase());
};


/* IssueTextNode.tsx generated by @compiled/babel-plugin v2.0.0 */ 










const $a0e14a339a2fec66$var$styles = {
    container: "_39xV02N91d"
};
const $a0e14a339a2fec66$export$e899559221712ff = ({ text: text })=>{
    const textRef = (0, $cozmU.useRef)(null);
    if (!text) return /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, "\xa0");
    return /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: text,
        // tooltip content is the same as the items content
        isScreenReaderAnnouncementDisabled: true,
        canAppear: ()=>{
            const element = textRef.current; // Only showing the tooltip for this item when
            // the element has been clamped.
            return !!element && element.scrollHeight > element.clientHeight;
        }
    }, (props)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            ...props,
            xcss: $a0e14a339a2fec66$var$styles.container
        }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            ref: textRef,
            maxLines: 1
        }, text)));
};


/* IssueTypeNode.tsx generated by @compiled/babel-plugin v2.0.0 */ 


const $c8a42c076811fe29$export$e34e3b13a9b68282 = ({ IssueTypeField: IssueTypeField })=>{
    return /*#__PURE__*/ $cozmU.createElement("img", {
        height: "16",
        width: "16",
        src: IssueTypeField.issueType.avatar.small,
        alt: IssueTypeField.issueType.name
    });
};


/* IssueUserNode.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $2QrXF = parcelRequire("2QrXF");

var $arQY7 = parcelRequire("arQY7");











const $89f5bca3f8de55ba$var$styles = {
    avatar: "_2XsHFM4F84"
};
const $89f5bca3f8de55ba$export$ab6075737389532b = ({ user: user })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const User = !Boolean(user) ? /*#__PURE__*/ $cozmU.createElement((0, $2QrXF.default), {
        avatar: /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
            appearance: "circle",
            size: "small",
            name: "unassigned"
        }),
        primaryText: formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).unassigned)
    }) : /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: user?.name,
        // tooltip content is the same as the items content
        isScreenReaderAnnouncementDisabled: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $2QrXF.default), {
        avatar: /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
            appearance: "circle",
            src: user?.picture,
            size: "small",
            name: user?.name
        }),
        primaryText: user?.name
    }));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($89f5bca3f8de55ba$var$styles.avatar)
    }, User);
};



const $12f16ca3035f7e90$var$styles = {
    tableWrapper: "_0bjKvD8fU6 _3hxITi6wH8 _3vBAKH9r67 _2V7sgONvrM _4bt5LAIZbP",
    table: "_3hxITinQyn _3Kbj8ay1CL",
    header: "_3hxITiYbGa",
    headerCell: "_2sNsIgd8bj _3hxITi6wH8 _3vBAKH9r67 _2V7sgONvrM _1UtDYzZpcK _0KLXrunmFW _0Of8r2Pgdg _1Znuxb2ADO _1wydGWPgdg _2Zuz6Q2ADO _0jFU0VUF4f _1RrJLit2nV",
    cell: "_4bt5LAnQyn _2WAcuGnQyn _3hxITi6wH8 _3vBAKH9r67 _2V7sgONvrM _0Of8r2Pgdg _1Znuxb2ADO _1wydGWPgdg _2Zuz6Q2ADO _39xV02N91d _0jFU0VUF4f"
};
const $12f16ca3035f7e90$var$HeaderRow = ({ headerLabels: headerLabels })=>{
    return headerLabels.map((item, index)=>{
        return /*#__PURE__*/ $cozmU.createElement("th", {
            key: `issue.header.${index}`,
            style: {
                width: item.width,
                // Override to avoid global first child padding
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                ...index === 0 && {
                    paddingLeft: "var(--ds-space-100, 8px)"
                }
            },
            className: (0, $hekY6.default)([
                $12f16ca3035f7e90$var$styles.headerCell
            ])
        }, item.label);
    });
};
const $12f16ca3035f7e90$var$BodyRows = ({ issues: issues, analyticsAttributes: analyticsAttributes, fireEngagementEvent: fireEngagementEvent })=>issues.map((issue, rowIndex)=>{
        const issueNode = issue.node;
        const issueTypeField = issueNode.issueTypeField;
        const issueStatus = issueNode.status;
        const issueAssignee = issueNode.assigneeField.user;
        const issuePriority = issueNode.priorityField;
        return /*#__PURE__*/ $cozmU.createElement("tr", {
            key: `issue.row.${rowIndex}`
        }, /*#__PURE__*/ $cozmU.createElement("td" // Override to avoid global first child padding
        , {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: {
                paddingLeft: "var(--ds-space-100, 8px)"
            },
            className: (0, $hekY6.default)([
                $12f16ca3035f7e90$var$styles.cell
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            alignInline: "start",
            space: "space.075"
        }, /*#__PURE__*/ $cozmU.createElement((0, $c8a42c076811fe29$export$e34e3b13a9b68282), {
            IssueTypeField: issueTypeField
        }), /*#__PURE__*/ $cozmU.createElement((0, $1eaffb3e826a5326$export$227b36be34e771c5), {
            url: issueNode.webUrl,
            issuekey: issueNode.key,
            analyticsAttributes: analyticsAttributes,
            fireEngagementEvent: fireEngagementEvent
        }), /*#__PURE__*/ $cozmU.createElement((0, $a0e14a339a2fec66$export$e899559221712ff), {
            text: issueNode.summary
        }))), /*#__PURE__*/ $cozmU.createElement("td", {
            className: (0, $hekY6.default)([
                $12f16ca3035f7e90$var$styles.cell
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $30e068cd4e7a88d9$export$47dfea36fbf85d70), {
            status: issueStatus
        })), /*#__PURE__*/ $cozmU.createElement("td", {
            className: (0, $hekY6.default)([
                $12f16ca3035f7e90$var$styles.cell
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $89f5bca3f8de55ba$export$ab6075737389532b), {
            user: issueAssignee
        })), /*#__PURE__*/ $cozmU.createElement("td", {
            className: (0, $hekY6.default)([
                $12f16ca3035f7e90$var$styles.cell
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $c41d65128d47dc0a$export$a62149baee0d175c), {
            IssuePriorityField: issuePriority
        })));
    });
const $12f16ca3035f7e90$export$548da6a0023fca70 = ({ issues: issues, analyticsAttributes: analyticsAttributes, fireEngagementEvent: fireEngagementEvent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const headerLabels = [
        {
            label: formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).headerWork),
            width: '60%'
        },
        {
            label: formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).headerStatus),
            width: '15%'
        },
        {
            label: formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).headerAssignee),
            width: '15%'
        },
        {
            label: formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).headerPriority),
            width: '10%'
        }
    ];
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $12f16ca3035f7e90$var$styles.tableWrapper
    }, /*#__PURE__*/ $cozmU.createElement("table", {
        "data-testid": "issue-table",
        className: (0, $hekY6.default)([
            $12f16ca3035f7e90$var$styles.table
        ])
    }, /*#__PURE__*/ $cozmU.createElement("thead", {
        className: (0, $hekY6.default)([
            $12f16ca3035f7e90$var$styles.header
        ])
    }, /*#__PURE__*/ $cozmU.createElement("tr", null, /*#__PURE__*/ $cozmU.createElement($12f16ca3035f7e90$var$HeaderRow, {
        headerLabels: headerLabels
    }))), /*#__PURE__*/ $cozmU.createElement("tbody", null, issues.length > 0 ? /*#__PURE__*/ $cozmU.createElement($12f16ca3035f7e90$var$BodyRows, {
        issues: issues,
        analyticsAttributes: analyticsAttributes,
        fireEngagementEvent: fireEngagementEvent
    }) : /*#__PURE__*/ $cozmU.createElement("tr", null, /*#__PURE__*/ $cozmU.createElement("td", {
        align: "center",
        colSpan: headerLabels.length,
        className: (0, $hekY6.default)([
            $12f16ca3035f7e90$var$styles.cell
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        alignInline: "center"
    }, formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).noResultsMessage)))))));
};










var $eKMV3 = parcelRequire("eKMV3");


var $bltJZ = parcelRequire("bltJZ");





const $f0ebab6d2240cdcf$export$28a2392dc2b2dd58 = (props)=>{
    const { totalIssuesCount: totalIssuesCount, url: url, callback: callback, spacing: spacing = 'default' } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        href: url,
        appearance: "default",
        onClick: callback,
        onAuxClick: callback,
        onContextMenu: callback,
        testId: "view-all-button",
        spacing: spacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        alignBlock: "center",
        alignInline: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
        appearance: "brand",
        shouldUseNewLogoDesign: true,
        size: "xxsmall"
    }), totalIssuesCount !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $6ee04b9bd73a1654$export$defe85febe8b728c).viewAll,
        values: {
            totalCount: totalIssuesCount
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6ee04b9bd73a1654$export$defe85febe8b728c).viewAllNoCount)));
};


const $f0bc144b7e8592f4$var$styles = {
    container: "_0bjKvDKxmn _30huDKOeNX",
    tableContainer: "_0bjKvD8fU6 _1mT5xdRAKS _2XsHFM5zaO _0adFHs5zaO _1DCdHi2ADO",
    sidePadding: "_2Zuz6Q5zaO _1Znuxb5zaO",
    headerContainer: "_0Of8r28HPE _1Znuxb5zaO _1wydGW2ADO",
    footer: "_2Y7lL45zaO _0xmtko8HPE",
    viewAllContainer: "_0Of8r21Y8M _1wydGW1Y8M _2fwxA5ecOK"
};
const $f0bc144b7e8592f4$var$buildJiraLink = ({ issueUrl: issueUrl, jql: jql })=>{
    const hostname = new URL(issueUrl).hostname;
    const jiraLink = new URL(`https://${hostname}/issues/`);
    jiraLink.searchParams.append('jql', jql);
    return jiraLink.toString();
};
const $f0bc144b7e8592f4$export$ba6b7dafd54d334 = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const renderStartTime = (0, $cozmU.useRef)(performance.now());
    const analyticsFiredRef = (0, $cozmU.useRef)(false);
    const nlToJqlEndTimeRef = (0, $cozmU.useRef)(undefined);
    const issueSearchStartTimeRef = (0, $cozmU.useRef)(undefined);
    const { query: query, title: title, cloudId: cloudId, aiBrand: aiBrand, searchSessionId: searchSessionId, workspaceId: workspaceId, product: product, onFMPReached: onFMPReached, bypassWithKeywordJql: bypassWithKeywordJql = false } = props;
    const [issueUrl, setIssueUrl] = (0, $cozmU.useState)(null);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $cXLoX.useAIEventsInstrumentation)();
    const { commonAttributes: commonAttributes, setData: setData, callbacks: callbacks } = (0, $3hVWe.useAIAnswerContext)();
    const onSainJqlResolved = callbacks?.onSainJqlResolved; // When bypassing the agentic NL→JQL flow (JIRA_NLQ_KEYWORD intent), compute
    // the deterministic keyword JQL synchronously and skip the network call.
    const keywordJql = (0, $cozmU.useMemo)(()=>bypassWithKeywordJql ? (0, $76b1398b70af7db1$export$4ab7a1642c5a2b25)(query) : null, [
        bypassWithKeywordJql,
        query
    ]);
    const nlResult = (0, $2cca25495c5a9447$export$eca952b1040f8ff3)({
        cloudId: cloudId,
        query: query,
        workspaceId: workspaceId,
        product: product,
        enabled: !bypassWithKeywordJql
    });
    const jqlLoading = bypassWithKeywordJql ? false : nlResult.loading; // In bypass mode, only the empty-query case is treated as an error here;
    // downstream `issues?.length === 0` still drives the empty-state UI.
    const jqlError = bypassWithKeywordJql ? keywordJql === null : nlResult.error;
    const jql = bypassWithKeywordJql ? keywordJql ?? undefined : nlResult.jql;
    (0, $cozmU.useEffect)(()=>{
        onSainJqlResolved?.(jql ?? null);
    }, [
        jql,
        onSainJqlResolved
    ]);
    const { issues: issues, totalIssuesCount: totalIssuesCount, loading: issuesLoading, error: issuesError, extensions: issuesExtensions } = (0, $b2c833a5b9632464$export$11659072884978f5)({
        cloudId: cloudId,
        jql: jql,
        workspaceId: workspaceId,
        product: product
    });
    const analyticsAttributes = (0, $cozmU.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $9oghv.sha256Hash)(query),
            brand: aiBrand,
            source: 'jira_nl_2_jql_card',
            query: query,
            answerString: jql || '',
            answerCardType: (0, $zzZbq.AnswerCardType).JIRA_NATURAL_LANGUAGE_QUERY,
            queryLength: query.length,
            wordCount: (query.match(/\w+/g) || []).length,
            queryIntent: commonAttributes.queryIntent,
            jiraNlToJqlCardVariant: 'issue-table'
        }), [
        searchSessionId,
        query,
        aiBrand,
        jql,
        commonAttributes.queryIntent
    ]);
    const analyticsAttributesWithoutUGC = (0, $cozmU.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $9oghv.sha256Hash)(query),
            brand: aiBrand,
            source: 'jira_nl_2_jql_card',
            answerCardType: (0, $zzZbq.AnswerCardType).JIRA_NATURAL_LANGUAGE_QUERY
        }), [
        searchSessionId,
        query,
        aiBrand
    ]);
    const fireJiraNlToJqlCardLoaded = (0, $cozmU.useCallback)(({ success: success, endState: endState })=>{
        const apiLoadedTime = performance.now();
        const totalDuration = apiLoadedTime - renderStartTime.current;
        const nlToJqlLoadTime = nlToJqlEndTimeRef.current !== undefined ? nlToJqlEndTimeRef.current - renderStartTime.current : undefined;
        const issueSearchLoadTime = issueSearchStartTimeRef.current !== undefined ? apiLoadedTime - issueSearchStartTimeRef.current : undefined;
        const phaseTimingAttributes = (0, $iDrrr.fg)('kd_sain_jira_card_phase_timing') ? {
            nlToJqlLoadTime: nlToJqlLoadTime,
            issueSearchLoadTime: issueSearchLoadTime,
            ...nlToJqlLoadTime !== undefined || issueSearchLoadTime !== undefined ? {
                phaseTimingSource: 'measured'
            } : {}
        } : {};
        fireAnalyticsEvent((0, $d6ee00d3c7ff7f25$export$10fed66da45c02f6)({
            ...analyticsAttributes,
            success: success,
            loadTime: totalDuration,
            endState: endState,
            jiraNlToJqlCardVariant: 'issue-table',
            ...phaseTimingAttributes
        }));
        (0, $7DMz5.SAINFeatureControl).triggerNonPrimaryClickTrackingExposure();
    }, [
        fireAnalyticsEvent,
        analyticsAttributes
    ]); // using the first issue's webUrl to build a jira url for the view all 'x' items button
    (0, $cozmU.useEffect)(()=>{
        if (!issuesLoading && !issuesError && issues?.length && issues[0]) try {
            const firstIssueUrl = issues[0].node.webUrl;
            setIssueUrl($f0bc144b7e8592f4$var$buildJiraLink({
                issueUrl: firstIssueUrl || '',
                jql: jql || ''
            }));
        } catch (error) {
            (0, $cuvLu.logger).error({
                error: error,
                functionName: 'JiraNlToJqlCard'
            });
        }
    }, [
        issuesLoading,
        issuesError,
        issues,
        jql
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('kd_sain_jira_card_phase_timing')) return;
        if (jqlLoading) return;
        if (jqlError && nlToJqlEndTimeRef.current === undefined) {
            nlToJqlEndTimeRef.current = performance.now();
            return;
        }
        if (jql && nlToJqlEndTimeRef.current === undefined) {
            const now = performance.now();
            nlToJqlEndTimeRef.current = now;
            issueSearchStartTimeRef.current = now;
        }
    }, [
        jqlLoading,
        jqlError,
        jql
    ]);
    (0, $cozmU.useEffect)(()=>{
        trackAIInteractionInit();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []); // Set debug data for online debugger when API response is available
    // Separate from analytics effect to avoid infinite loop with commonAttributes
    (0, $cozmU.useEffect)(()=>{
        if (!issuesLoading && issuesExtensions?.gateway && (0, $iDrrr.fg)('kd_sain_online_debugger')) setData({
            errorState: null,
            format: null,
            uniqueSources: [],
            disclaimer: null,
            extraAPIAnalyticsAttributes: {
                traceId: issuesExtensions.gateway.trace_id ?? null,
                requestId: issuesExtensions.gateway.request_id ?? null
            }
        });
    }, [
        issuesLoading,
        issuesExtensions?.gateway,
        setData
    ]); // fire Analytics Events on final state changes
    (0, $cozmU.useEffect)(()=>{
        if (analyticsFiredRef.current) return;
        if (!jqlLoading && !jqlError && !issuesLoading && !issuesError && issues?.length && issues[0]) {
            /*
       * * Success block
       */ analyticsFiredRef.current = true;
            onFMPReached();
            fireJiraNlToJqlCardLoaded({
                success: true,
                endState: 'answered'
            });
            if ((0, $iDrrr.fg)('kd_fix_nl2jql_mau_instrumentation')) fireSAINUsageEvent({
                commonAttributes: {
                    ...commonAttributes,
                    extraAttributes: {
                        ...commonAttributes?.extraAttributes,
                        requestId: issuesExtensions?.gateway?.request_id ?? null
                    }
                }
            });
            else fireSAINUsageEvent({
                commonAttributes: commonAttributes
            });
        } else if (!jqlLoading && jqlError) {
            /*
       * * JQL error block
       */ analyticsFiredRef.current = true;
            fireJiraNlToJqlCardLoaded({
                success: false,
                endState: 'jql-error'
            });
        } else if (!issuesLoading && issuesError) {
            /*
       * * Issues error block
       */ analyticsFiredRef.current = true;
            fireJiraNlToJqlCardLoaded({
                success: false,
                endState: 'issues-error'
            });
        } else if (!jqlLoading && !issuesLoading && issues?.length === 0) {
            /*
       * * No issues block,
       * * while this is not an error, we're still marking it as a failure cause the user sees an error card
       */ analyticsFiredRef.current = true;
            fireJiraNlToJqlCardLoaded({
                success: false,
                endState: 'no-issues'
            });
        }
    }, [
        jqlLoading,
        issuesLoading,
        issuesError,
        jqlError,
        issues,
        onFMPReached,
        fireJiraNlToJqlCardLoaded,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        commonAttributes,
        issuesExtensions?.gateway?.request_id
    ]);
    const fireEngagementEvent = (0, $cozmU.useCallback)((sainAction)=>{
        fireSAINUsageEvent({
            metCriteria: sainAction,
            commonAttributes: {
                ...commonAttributes,
                extraAttributes: {
                    ...commonAttributes?.extraAttributes,
                    requestId: issuesExtensions?.gateway?.request_id ?? null
                }
            }
        });
    }, [
        fireSAINUsageEvent,
        commonAttributes,
        issuesExtensions?.gateway?.request_id
    ]);
    const onViewAllButtonClicked = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $fce67a5f4fe3c54f$export$447238500b8bc926)({
            ...analyticsAttributes,
            totalIssuesCount: totalIssuesCount || 0
        }));
        if ((0, $iDrrr.fg)('kd_fix_nl2jql_mau_instrumentation')) fireEngagementEvent((0, $bZMnB.SainAction).JIRA_NL_TO_JQL_VIEW_ALL);
    }, [
        fireAnalyticsEvent,
        fireEngagementEvent,
        analyticsAttributes,
        totalIssuesCount
    ]);
    if (jqlLoading || issuesLoading) return /*#__PURE__*/ $cozmU.createElement((0, $b3ffN.AnimatedWrapper), null, /*#__PURE__*/ $cozmU.createElement((0, $aiIBH.SmartAnswerCardBodyGenerating), {
        heightOverride: "jiraNlToJqlCard"
    }));
    if (jqlError || issuesError || issues?.length === 0) return /*#__PURE__*/ $cozmU.createElement((0, $c7397925ebe4947f$export$a2c93507c97cd090), {
        query: query
    });
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $f0bc144b7e8592f4$var$styles.container,
        testId: "jira-nl-to-jql-card-wrapper"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($f0bc144b7e8592f4$var$styles.headerContainer, $f0bc144b7e8592f4$var$styles.sidePadding)
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, title || formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).cardTitle))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $f0bc144b7e8592f4$var$styles.tableContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: {
            attributes: {
                ...analyticsAttributesWithoutUGC,
                location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_JIRA_NL_TO_JQL_CARD
            },
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_JIRA_NL_TO_JQL_CARD
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ $cozmU.createElement((0, $12f16ca3035f7e90$export$548da6a0023fca70), {
        issues: issues || [],
        analyticsAttributes: analyticsAttributes,
        fireEngagementEvent: fireEngagementEvent
    })))), totalIssuesCount && totalIssuesCount > 0 && issueUrl ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($f0bc144b7e8592f4$var$styles.viewAllContainer, $f0bc144b7e8592f4$var$styles.sidePadding)
    }, /*#__PURE__*/ $cozmU.createElement((0, $f0ebab6d2240cdcf$export$28a2392dc2b2dd58), {
        totalIssuesCount: totalIssuesCount,
        url: issueUrl,
        callback: onViewAllButtonClicked
    })) : null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $f0bc144b7e8592f4$var$styles.footer
    }, /*#__PURE__*/ $cozmU.createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true
    })));
});


/* JiraNlToJqlSmartlinkCard.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $3d3WW = parcelRequire("3d3WW");








var $f0b2F = parcelRequire("f0b2F");


var $3UfFE = parcelRequire("3UfFE");


var $a79Sy = parcelRequire("a79Sy");


var $bsSbN = parcelRequire("bsSbN");


var $4ESzI = parcelRequire("4ESzI");


var $lmL4n = parcelRequire("lmL4n");

var $b1qV0 = parcelRequire("b1qV0");





var $4dGdo = parcelRequire("4dGdo");


















var $4Tg3t = parcelRequire("4Tg3t");

const $5df1629f53f4597d$export$d5927f4d78af7f29 = (props)=>{
    const { query: query, answerString: answerString, source: source, jiraNlToJqlCardVariant: jiraNlToJqlCardVariant } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerCollapse',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            jiraNlToJqlCardVariant: jiraNlToJqlCardVariant
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};








const $e14deeb67bd569aa$export$a499208a458c0e59 = (props)=>{
    const { query: query, answerString: answerString, source: source, jiraNlToJqlCardVariant: jiraNlToJqlCardVariant } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerExpand',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            jiraNlToJqlCardVariant: jiraNlToJqlCardVariant
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};





const $a020d6fc16168401$export$93f0009a720af69b = (props)=>{
    const { source: source, query: query, answerString: answerString, elementInteracted: elementInteracted, jiraNlToJqlCardVariant: jiraNlToJqlCardVariant, isAuxClick: isAuxClick, isContextMenu: isContextMenu } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            elementInteracted: elementInteracted,
            jiraNlToJqlCardVariant: jiraNlToJqlCardVariant,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
















































const $db35164133ee90b3$var$JIRA_AGENT_GENERATE_JQL_PATH = '/api/rovo/v1/jira-ticket-retrieval/generate-jql';
const $db35164133ee90b3$var$JIRA_AGENT_GENERATE_JQL_URL = `${(0, $zzZbq.ASSISTANCE_SERVICE_API_BASE_URL)}${$db35164133ee90b3$var$JIRA_AGENT_GENERATE_JQL_PATH}`;
async function $db35164133ee90b3$var$fetchJiraAgentGenerateJql({ request: request, workspaceId: workspaceId, cloudId: cloudId, product: product, traceHeaders: traceHeaders }) {
    const response = await fetch($db35164133ee90b3$var$JIRA_AGENT_GENERATE_JQL_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Product': product,
            'X-Experience-Id': 'sain',
            ...(0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: product
            }),
            ...traceHeaders
        },
        body: JSON.stringify(request)
    });
    if (!response.ok) throw new Error(`Jira Agent generate-jql failed: ${response.status} ${response.statusText}`);
    const data = await response.json();
    return data;
}
const $db35164133ee90b3$export$2cc525a82b3249e7 = ({ query: query, cloudId: cloudId, workspaceId: workspaceId, product: product, traceHeaders: traceHeaders, enabled: enabled = true })=>{
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [error, setError] = (0, $cozmU.useState)(false);
    const [jql, setJql] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) {
            setLoading(false);
            setError(false);
            setJql(undefined);
            return;
        }
        if (!query.trim() || !cloudId) {
            setLoading(false);
            setError(false);
            setJql(undefined);
            return;
        }
        let cancelled = false;
        const fetchData = async ()=>{
            setLoading(true);
            setError(false);
            try {
                const data = await $db35164133ee90b3$var$fetchJiraAgentGenerateJql({
                    request: {
                        query: query.trim()
                    },
                    workspaceId: workspaceId,
                    cloudId: cloudId,
                    product: product,
                    traceHeaders: traceHeaders
                });
                if (cancelled) return;
                const generatedJql = 'JQL' in data ? data.JQL : undefined;
                const error = 'error' in data ? data.error : undefined;
                if (!generatedJql || error) {
                    setError(true);
                    setJql(undefined);
                    return;
                }
                setJql(generatedJql);
                setError(false);
            } catch (e) {
                if (!cancelled) {
                    (0, $cuvLu.logger).error({
                        error: e,
                        functionName: 'useJiraAgent'
                    });
                    setError(true);
                    setJql(undefined);
                }
            } finally{
                if (!cancelled) setLoading(false);
            }
        };
        fetchData();
        return ()=>{
            cancelled = true;
        };
    }, [
        enabled,
        query,
        cloudId,
        workspaceId,
        product,
        traceHeaders
    ]);
    return {
        jql: jql,
        loading: loading,
        error: error
    };
};



const $acc42ef9a5028623$export$ac77cca39f27bb5f = (query, jql)=>{
    const trimmedQuery = query.trim();
    if (jql) return `/issues/?jql=${encodeURIComponent(jql)}&text=${encodeURIComponent(trimmedQuery)}&referrer=sain`;
    const params = new URLSearchParams({
        searchString: trimmedQuery,
        referrer: 'sain'
    });
    return `/jira/search?${params.toString()}`;
};



/* JiraNlToJqlErrorCard.tsx generated by @compiled/babel-plugin v2.0.0 */ 




























const $162db3c479f357e1$var$styles = {
    container: "_0bjKvD8fU6 _30huDKOeNX _0KLXruoI2d _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    messageContainer: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2Zuz6Q1Y8M _1Znuxb1Y8M",
    viewAllContainer: "_2fwxA5ecOK"
};
function $162db3c479f357e1$export$bcbdfb57198b378b({ query: query, viewAllUrl: viewAllUrl, onViewAllClick: onViewAllClick }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(true);
    if (!isOpen) return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null);
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.200",
        xcss: $162db3c479f357e1$var$styles.container,
        testId: "jira-nl-to-jql-error-card"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "start",
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $162db3c479f357e1$var$styles.messageContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).errorMessageWithViewAll, {
        query: query
    }))), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).close),
        onClick: ()=>setIsOpen(false),
        testId: "jira-nl-to-jql-error-card-close"
    })), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $162db3c479f357e1$var$styles.viewAllContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $f0ebab6d2240cdcf$export$28a2392dc2b2dd58), {
        url: viewAllUrl,
        callback: onViewAllClick ?? (()=>{}),
        spacing: "compact"
    })), (0, $iDrrr.fg)('kd_sain_online_debugger') && /*#__PURE__*/ $cozmU.createElement((0, $j9bgP.OnlineDebuggerButton), null)));
}









const $9ac56043691df2ab$export$b7c741dc710857de = 240;
const $9ac56043691df2ab$export$aa6e67a972e6a35d = 495;
const $9ac56043691df2ab$var$TABLE_RESIZE_DURATION_MS = (0, $4dGdo.durations).medium;
/** Cubic ease-in-out for progress 0–1 (matches easeInOut curve feel). */ function $9ac56043691df2ab$var$easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}
function $9ac56043691df2ab$export$a2a5ea5cc7c20545(animationsEnabled, options) {
    const expandToAuto = options?.expandToAuto ?? false;
    const [isHidden, setIsHidden] = (0, $cozmU.useState)(false);
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const [contentWrapperTransitioning, setContentWrapperTransitioning] = (0, $cozmU.useState)(false);
    const [justRevealed, setJustRevealed] = (0, $cozmU.useState)(false);
    const [revealHeightZero, setRevealHeightZero] = (0, $cozmU.useState)(false);
    const [animatedTableHeight, setAnimatedTableHeight] = (0, $cozmU.useState)($9ac56043691df2ab$export$b7c741dc710857de);
    const tableHeightRef = (0, $cozmU.useRef)($9ac56043691df2ab$export$b7c741dc710857de);
    const tableAnimationFrameRef = (0, $cozmU.useRef)(null);
    tableHeightRef.current = animatedTableHeight;
    // Expand/collapse: when expandToAuto we keep height at COLLAPSED so the card uses height:auto and collapse doesn't jump
    (0, $cozmU.useEffect)(()=>{
        const expandedTarget = expandToAuto && isExpanded ? $9ac56043691df2ab$export$b7c741dc710857de : $9ac56043691df2ab$export$aa6e67a972e6a35d;
        const targetHeight = isExpanded ? expandedTarget : $9ac56043691df2ab$export$b7c741dc710857de;
        const startHeight = tableHeightRef.current;
        if (startHeight === targetHeight) return;
        if (!animationsEnabled) {
            tableHeightRef.current = targetHeight;
            setAnimatedTableHeight(targetHeight);
            return;
        }
        if (tableAnimationFrameRef.current !== null) cancelAnimationFrame(tableAnimationFrameRef.current);
        const startTime = performance.now();
        const tick = (now)=>{
            const elapsed = now - startTime;
            const progress = Math.min(elapsed / $9ac56043691df2ab$var$TABLE_RESIZE_DURATION_MS, 1);
            const eased = $9ac56043691df2ab$var$easeInOutCubic(progress);
            const current = Math.round(startHeight + (targetHeight - startHeight) * eased);
            tableHeightRef.current = current;
            setAnimatedTableHeight(current);
            if (progress < 1) tableAnimationFrameRef.current = requestAnimationFrame(tick);
            else tableAnimationFrameRef.current = null;
        };
        tableAnimationFrameRef.current = requestAnimationFrame(tick);
        return ()=>{
            if (tableAnimationFrameRef.current !== null) {
                cancelAnimationFrame(tableAnimationFrameRef.current);
                tableAnimationFrameRef.current = null;
            }
        };
    }, [
        isExpanded,
        animationsEnabled,
        expandToAuto
    ]);
    // After reveal, clear both flags in one frame so opacity and height stay in sync
    (0, $cozmU.useEffect)(()=>{
        if (!justRevealed && !revealHeightZero) return;
        const frameId = requestAnimationFrame(()=>{
            setJustRevealed(false);
            setRevealHeightZero(false);
        });
        return ()=>cancelAnimationFrame(frameId);
    }, [
        justRevealed,
        revealHeightZero
    ]);
    const onHideClick = (0, $cozmU.useCallback)(()=>{
        if (animationsEnabled) setContentWrapperTransitioning(true);
        setIsHidden(true);
    }, [
        animationsEnabled
    ]);
    const onRevealClick = (0, $cozmU.useCallback)(()=>{
        if (animationsEnabled) {
            setJustRevealed(true);
            setRevealHeightZero(true);
            setContentWrapperTransitioning(true);
        }
        setIsHidden(false);
    }, [
        animationsEnabled
    ]);
    const onExpandClick = (0, $cozmU.useCallback)(()=>{
        setIsExpanded(true);
    }, []);
    const onCollapseClick = (0, $cozmU.useCallback)(()=>{
        setIsExpanded(false);
    }, []);
    const onContentWrapperTransitionEnd = (0, $cozmU.useCallback)((e)=>{
        if (e.propertyName === 'height') setContentWrapperTransitioning(false);
    }, []);
    return {
        isHidden: isHidden,
        isExpanded: isExpanded,
        contentWrapperTransitioning: contentWrapperTransitioning,
        justRevealed: justRevealed,
        revealHeightZero: revealHeightZero,
        animatedTableHeight: animatedTableHeight,
        onHideClick: onHideClick,
        onRevealClick: onRevealClick,
        onExpandClick: onExpandClick,
        onCollapseClick: onCollapseClick,
        onContentWrapperTransitionEnd: onContentWrapperTransitionEnd
    };
}



const $51159ee7c0863918$var$styles = {
    container: "_0bjKvD8fU6 _2Y7lL45zaO _0KLXrunmFW _0Of8r25zaO _1wydGW5zaO",
    tableContainer: "_0bjKvD8fU6 _30huDKOeNX _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS",
    viewAllContainer: "_2fwxA5ecOK",
    resizingContentWrapper: "_4bt5LAnQyn _2WAcuGnQyn"
}; /** Scroll area height while datasource is loading; matches collapsed resolved table height (TABLE_HEIGHT_COLLAPSED). */ 
const $51159ee7c0863918$var$DATASOURCE_LOADING_TABLE_HEIGHT = (0, $9ac56043691df2ab$export$b7c741dc710857de); /** Height of DatasourceTableView footer (item count, refresh, etc.) so container wraps table + footer. */ 
const $51159ee7c0863918$var$TABLE_FOOTER_HEIGHT = 41; /** Stack gap (space.150) + disclaimer section so we can drive content wrapper height in sync with table expand. */ 
const $51159ee7c0863918$var$CONTENT_BELOW_TABLE_HEIGHT = 36; /** space.150 in px; added to wrapper height when paddingTop is used so content is not cut off (border-box). */ 
const $51159ee7c0863918$var$CONTENT_WRAPPER_PADDING_TOP_PX = 12;
const $51159ee7c0863918$var$DATASOURCE_RESOLVE_TIMEOUT_MS = 10000;
const $51159ee7c0863918$var$EXPAND_BUTTON_ROW_THRESHOLD = 4; /** When expanded and row count is in this range, use height: auto instead of fixed expanded height. */ 
const $51159ee7c0863918$var$EXPAND_TO_AUTO_ROW_THRESHOLD = 10;
const $51159ee7c0863918$var$CONTENT_WRAPPER_TRANSITION_MS = (0, $4dGdo.durations).large;
const $51159ee7c0863918$var$CONTENT_WRAPPER_TRANSITION_EASING = 'cubic-bezier(0.15, 1, 0.3, 1)';
const $51159ee7c0863918$var$CONTENT_WRAPPER_OPACITY_TRANSITION = `opacity ${$51159ee7c0863918$var$CONTENT_WRAPPER_TRANSITION_MS}ms ${$51159ee7c0863918$var$CONTENT_WRAPPER_TRANSITION_EASING}`;
const $51159ee7c0863918$var$CONTENT_WRAPPER_HEIGHT_TRANSITION = `height ${$51159ee7c0863918$var$CONTENT_WRAPPER_TRANSITION_MS}ms ${$51159ee7c0863918$var$CONTENT_WRAPPER_TRANSITION_EASING}`;
const $51159ee7c0863918$var$CONTENT_WRAPPER_PADDING_TOP_TRANSITION = `padding-top ${$51159ee7c0863918$var$CONTENT_WRAPPER_TRANSITION_MS}ms ${$51159ee7c0863918$var$CONTENT_WRAPPER_TRANSITION_EASING}`;
const $51159ee7c0863918$export$68d51edc6150de19 = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const renderStartTime = (0, $cozmU.useRef)(performance.now());
    const analyticsFiredRef = (0, $cozmU.useRef)(false);
    const nlToJqlEndTimeRef = (0, $cozmU.useRef)(undefined);
    const { query: query, cloudId: cloudId, aiBrand: aiBrand, searchSessionId: searchSessionId, workspaceId: workspaceId, product: product, onFMPReached: onFMPReached, bypassWithKeywordJql: bypassWithKeywordJql = false } = props;
    const tableScrollContainerRef = (0, $cozmU.useRef)(null);
    const [showExpandButton, setShowExpandButton] = (0, $cozmU.useState)(false);
    const [tableRowCount, setTableRowCount] = (0, $cozmU.useState)(0);
    const [isDatasourceResolved, setIsDatasourceResolved] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $cXLoX.useAIEventsInstrumentation)();
    const { commonAttributes: commonAttributes, setData: setData, traceHeaders: traceHeaders, callbacks: callbacks } = (0, $3hVWe.useAIAnswerContext)();
    const onSainJqlResolved = callbacks?.onSainJqlResolved;
    const animationsEnabled = (0, $iDrrr.fg)('kd_sain_jira_card_animations');
    const expandToAuto = showExpandButton && tableRowCount <= $51159ee7c0863918$var$EXPAND_TO_AUTO_ROW_THRESHOLD;
    const animation = (0, $9ac56043691df2ab$export$a2a5ea5cc7c20545)(animationsEnabled, {
        expandToAuto: expandToAuto
    }); // When bypassing the agentic NL→JQL flow (JIRA_NLQ_KEYWORD intent), compute
    // the deterministic keyword JQL synchronously and skip both BE calls.
    const keywordJql = (0, $cozmU.useMemo)(()=>bypassWithKeywordJql ? (0, $76b1398b70af7db1$export$4ab7a1642c5a2b25)(query) : null, [
        bypassWithKeywordJql,
        query
    ]);
    const useJiraAgentApi = (0, $iDrrr.fg)('kd_sain_jira_card_migrate_jira_agent');
    const jiraAgentResult = (0, $db35164133ee90b3$export$2cc525a82b3249e7)({
        query: query,
        cloudId: cloudId,
        workspaceId: workspaceId,
        product: product,
        traceHeaders: traceHeaders,
        enabled: !bypassWithKeywordJql && useJiraAgentApi
    });
    const nlResult = (0, $2cca25495c5a9447$export$eca952b1040f8ff3)({
        cloudId: cloudId,
        query: query,
        workspaceId: workspaceId,
        product: product,
        enabled: !bypassWithKeywordJql && !useJiraAgentApi
    });
    const jqlLoading = bypassWithKeywordJql ? false : useJiraAgentApi ? jiraAgentResult.loading : nlResult.loading;
    const jqlError = bypassWithKeywordJql ? keywordJql === null : useJiraAgentApi ? jiraAgentResult.error : nlResult.error;
    const jql = bypassWithKeywordJql ? keywordJql ?? undefined : useJiraAgentApi ? jiraAgentResult.jql : nlResult.jql;
    (0, $cozmU.useEffect)(()=>{
        onSainJqlResolved?.(jql ?? null);
    }, [
        jql,
        onSainJqlResolved
    ]);
    const jiraSearchUrl = (0, $cozmU.useMemo)(()=>jql ? (0, $acc42ef9a5028623$export$ac77cca39f27bb5f)(query, jql) : null, [
        jql,
        query
    ]); /** URL for "View all work items" on the error card (no JQL, search by query text only). */ 
    const errorCardViewAllUrl = (0, $cozmU.useMemo)(()=>(0, $acc42ef9a5028623$export$ac77cca39f27bb5f)(query), [
        query
    ]);
    const analyticsAttributes = (0, $cozmU.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $9oghv.sha256Hash)(query),
            brand: aiBrand,
            source: 'jira_nl_2_jql_card',
            query: query,
            answerString: jql ? (0, $9oghv.sha256Hash)(jql) : '',
            answerCardType: (0, $zzZbq.AnswerCardType).JIRA_NATURAL_LANGUAGE_QUERY,
            queryLength: query.length,
            wordCount: (query.match(/\w+/g) || []).length,
            queryIntent: commonAttributes.queryIntent,
            jiraNlToJqlCardVariant: 'smartlink'
        }), [
        searchSessionId,
        query,
        aiBrand,
        jql,
        commonAttributes.queryIntent
    ]);
    const analyticsAttributesWithoutUGC = (0, $cozmU.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $9oghv.sha256Hash)(query),
            brand: aiBrand,
            source: 'jira_nl_2_jql_card',
            answerCardType: (0, $zzZbq.AnswerCardType).JIRA_NATURAL_LANGUAGE_QUERY,
            queryLength: query.length,
            wordCount: (query.match(/\w+/g) || []).length,
            queryIntent: commonAttributes.queryIntent,
            jiraNlToJqlCardVariant: 'smartlink'
        }), [
        searchSessionId,
        query,
        aiBrand,
        commonAttributes.queryIntent
    ]);
    const fireJiraNlToJqlCardLoaded = (0, $cozmU.useCallback)(({ success: success, endState: endState })=>{
        const apiLoadedTime = performance.now();
        const totalDuration = apiLoadedTime - renderStartTime.current;
        const nlToJqlLoadTime = nlToJqlEndTimeRef.current !== undefined ? nlToJqlEndTimeRef.current - renderStartTime.current : undefined; // Only derive issueSearchLoadTime when an issue search actually occurred
        // (i.e. not on jql-error, where the JQL phase failed before issue search started)
        const issueSearchLoadTime = nlToJqlLoadTime !== undefined && endState !== 'jql-error' ? totalDuration - nlToJqlLoadTime : undefined;
        const phaseTimingAttributes = (0, $iDrrr.fg)('kd_sain_jira_card_phase_timing') ? {
            nlToJqlLoadTime: nlToJqlLoadTime,
            issueSearchLoadTime: issueSearchLoadTime,
            ...nlToJqlLoadTime !== undefined || issueSearchLoadTime !== undefined ? {
                phaseTimingSource: 'derived'
            } : {}
        } : {};
        fireAnalyticsEvent((0, $d6ee00d3c7ff7f25$export$10fed66da45c02f6)({
            ...analyticsAttributes,
            success: success,
            loadTime: totalDuration,
            endState: endState,
            jiraNlToJqlCardVariant: 'smartlink',
            ...phaseTimingAttributes
        }));
        (0, $7DMz5.SAINFeatureControl).triggerNonPrimaryClickTrackingExposure();
    }, [
        fireAnalyticsEvent,
        analyticsAttributes
    ]);
    const updateDOMDerivedState = (0, $cozmU.useCallback)(()=>{
        const el = tableScrollContainerRef.current;
        if (!el) return;
        const dataRows = el.querySelectorAll('table tbody tr');
        const count = dataRows.length;
        setTableRowCount(count);
        setShowExpandButton(count > $51159ee7c0863918$var$EXPAND_BUTTON_ROW_THRESHOLD);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const el = tableScrollContainerRef.current;
        if (!el) return;
        updateDOMDerivedState(); // Debounce added to prevent excessive re-renders and wait for the DOM to settle
        let debounceId = null;
        const observer = new MutationObserver(()=>{
            if (debounceId !== null) clearTimeout(debounceId);
            debounceId = setTimeout(()=>{
                debounceId = null;
                updateDOMDerivedState();
            }, 150);
        });
        observer.observe(el, {
            childList: true,
            subtree: true
        });
        return ()=>{
            if (debounceId !== null) clearTimeout(debounceId);
            observer.disconnect();
        };
    }, [
        animation.isExpanded,
        jql,
        updateDOMDerivedState
    ]);
    (0, $cozmU.useEffect)(()=>{
        trackAIInteractionInit();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('kd_sain_jira_card_phase_timing')) return;
        if (!jqlLoading && (jql || jqlError) && nlToJqlEndTimeRef.current === undefined) nlToJqlEndTimeRef.current = performance.now();
    }, [
        jqlLoading,
        jql,
        jqlError
    ]); // fire Analytics Events on final state changes
    // Waits for isDatasourceResolved so loadTime includes the DatasourceTableView's own API fetch,
    // giving an accurate TTI/FMP that covers both the NL→JQL call and the issue search.
    (0, $cozmU.useEffect)(()=>{
        if (analyticsFiredRef.current) return;
        if (!jqlLoading && !jqlError && jql && isDatasourceResolved) {
            analyticsFiredRef.current = true;
            onFMPReached();
            fireJiraNlToJqlCardLoaded({
                success: true,
                endState: 'answered'
            });
            if ((0, $iDrrr.fg)('kd_fix_nl2jql_mau_instrumentation')) fireSAINUsageEvent({
                commonAttributes: commonAttributes
            });
        } else if (!jqlLoading && jqlError) {
            analyticsFiredRef.current = true;
            fireJiraNlToJqlCardLoaded({
                success: false,
                endState: 'jql-error'
            });
        }
    }, [
        jqlLoading,
        jqlError,
        jql,
        isDatasourceResolved,
        onFMPReached,
        fireJiraNlToJqlCardLoaded,
        fireSAINUsageEvent,
        commonAttributes
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isDatasourceResolved || jqlLoading || jqlError || !jql) return;
        const id = setTimeout(()=>{
            if (!analyticsFiredRef.current) {
                analyticsFiredRef.current = true;
                fireJiraNlToJqlCardLoaded({
                    success: false,
                    endState: 'datasource-timeout'
                });
            }
            setIsDatasourceResolved(true);
        }, $51159ee7c0863918$var$DATASOURCE_RESOLVE_TIMEOUT_MS);
        return ()=>clearTimeout(id);
    }, [
        isDatasourceResolved,
        jqlLoading,
        jqlError,
        jql,
        fireJiraNlToJqlCardLoaded
    ]); // Set debug data for online debugger when API response is available
    // Separate from analytics effect to avoid infinite loop with commonAttributes
    (0, $cozmU.useEffect)(()=>{
        if (!jqlLoading && jql && (0, $iDrrr.fg)('kd_sain_online_debugger')) setData({
            errorState: null,
            format: null,
            uniqueSources: [],
            disclaimer: null,
            extraAPIAnalyticsAttributes: {
                traceId: commonAttributes.extraAttributes?.requestId ?? null,
                requestId: commonAttributes.extraAttributes?.requestId ?? null
            }
        });
    }, [
        jqlLoading,
        jql,
        setData,
        commonAttributes.extraAttributes?.requestId
    ]);
    const fireEngagementEvent = (0, $cozmU.useCallback)((sainAction)=>{
        fireSAINUsageEvent({
            metCriteria: sainAction,
            commonAttributes: commonAttributes
        });
    }, [
        fireSAINUsageEvent,
        commonAttributes
    ]);
    const handleDatasourceAnalyticsEvent = (0, $cozmU.useCallback)((event)=>{
        const { payload: payload } = event;
        if (payload.action === 'renderSuccess' && payload.actionSubject === 'datasource') setIsDatasourceResolved(true);
        if (payload.action === 'clicked') {
            if (payload.actionSubject === 'link') fireAnalyticsEvent((0, $jtIlq.onNonGenerativeKnowledgeCardLinkClick)({
                ...analyticsAttributes,
                isAuxClick: payload.attributes?.clickType === 'middle',
                isContextMenu: payload.attributes?.clickType === 'right',
                elementInteracted: 'jira-issue-key'
            }));
            else fireAnalyticsEvent((0, $jtIlq.onNonGenerativeKnowledgeCardLinkClick)({
                ...analyticsAttributes,
                isAuxClick: payload.attributes?.clickType === 'middle',
                isContextMenu: payload.attributes?.clickType === 'right',
                elementInteracted: payload.actionSubject
            }));
            if ((0, $iDrrr.fg)('kd_fix_nl2jql_mau_instrumentation')) {
                if (payload.actionSubject === 'link') {
                    fireEngagementEvent((0, $bZMnB.SainAction).JIRA_NL_TO_JQL_WORK_ITEM_CLICKED);
                    fireAnalyticsEvent((0, $a020d6fc16168401$export$93f0009a720af69b)({
                        ...commonAttributes,
                        elementInteracted: 'jira-issue-key',
                        answerString: jql ? (0, $9oghv.sha256Hash)(jql) : '',
                        jiraNlToJqlCardVariant: 'smartlink',
                        isAuxClick: payload.attributes?.clickType === 'middle'
                    }));
                } else {
                    fireEngagementEvent((0, $bZMnB.SainAction).JIRA_NL_TO_JQL_CLICKED);
                    fireAnalyticsEvent((0, $a020d6fc16168401$export$93f0009a720af69b)({
                        ...commonAttributes,
                        elementInteracted: payload.actionSubject,
                        jiraNlToJqlCardVariant: 'smartlink'
                    }));
                }
            }
        }
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireEngagementEvent,
        jql,
        analyticsAttributes
    ]);
    const onViewAllButtonClicked = (0, $cozmU.useCallback)((e)=>{
        const isAuxClick = e?.button === 1;
        const isContextMenu = e?.button === 2;
        if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $a020d6fc16168401$export$93f0009a720af69b)({
            ...commonAttributes,
            elementInteracted: 'jira-view-all-button',
            answerString: jql ? (0, $9oghv.sha256Hash)(jql) : '',
            jiraNlToJqlCardVariant: 'smartlink',
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        }));
        if ((0, $iDrrr.fg)('kd_fix_nl2jql_mau_instrumentation')) fireEngagementEvent((0, $bZMnB.SainAction).JIRA_NL_TO_JQL_VIEW_ALL);
    }, [
        fireAnalyticsEvent,
        fireEngagementEvent,
        commonAttributes,
        jql
    ]);
    const onExpandButtonClicked = (0, $cozmU.useCallback)(()=>{
        animation.onExpandClick();
        fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)({
            ...commonAttributes,
            jiraNlToJqlCardVariant: 'smartlink'
        }));
        fireEngagementEvent((0, $bZMnB.SainAction).EXPAND_CLICKED);
    }, [
        animation,
        fireAnalyticsEvent,
        commonAttributes,
        fireEngagementEvent
    ]);
    const onCollapseButtonClicked = (0, $cozmU.useCallback)(()=>{
        animation.onCollapseClick();
        fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)({
            ...commonAttributes,
            jiraNlToJqlCardVariant: 'smartlink'
        }));
    }, [
        animation,
        fireAnalyticsEvent,
        commonAttributes
    ]);
    const onHideButtonClicked = (0, $cozmU.useCallback)(()=>{
        animation.onHideClick();
        fireAnalyticsEvent((0, $a020d6fc16168401$export$93f0009a720af69b)({
            ...commonAttributes,
            elementInteracted: 'jira-hide-table-button',
            jiraNlToJqlCardVariant: 'smartlink'
        }));
    }, [
        animation,
        fireAnalyticsEvent,
        commonAttributes
    ]);
    const onRevealButtonClicked = (0, $cozmU.useCallback)(()=>{
        animation.onRevealClick();
        fireAnalyticsEvent((0, $a020d6fc16168401$export$93f0009a720af69b)({
            ...commonAttributes,
            elementInteracted: 'jira-reveal-table-button',
            jiraNlToJqlCardVariant: 'smartlink'
        }));
    }, [
        animation,
        fireAnalyticsEvent,
        commonAttributes
    ]);
    if (jqlLoading) return /*#__PURE__*/ $cozmU.createElement((0, $b3ffN.AnimatedWrapper), null, /*#__PURE__*/ $cozmU.createElement((0, $aiIBH.SmartAnswerCardBodyGenerating), {
        heightOverride: "jiraNlToJqlSmartlinkCard"
    }));
    if (jqlError || !jql) return /*#__PURE__*/ $cozmU.createElement((0, $162db3c479f357e1$export$bcbdfb57198b378b), {
        query: query,
        viewAllUrl: errorCardViewAllUrl,
        onViewAllClick: onViewAllButtonClicked
    });
     // When expanded with 5–10 rows, use height auto so the table isn't stuck at a fixed tall height
    const useAutoHeightWhenExpanded = expandToAuto && animation.isExpanded;
    const useFixedTableHeight = !isDatasourceResolved || showExpandButton && !useAutoHeightWhenExpanded;
    const tableScrollHeight = isDatasourceResolved ? animation.animatedTableHeight : $51159ee7c0863918$var$DATASOURCE_LOADING_TABLE_HEIGHT;
    const tableContainerHeight = useFixedTableHeight ? tableScrollHeight + $51159ee7c0863918$var$TABLE_FOOTER_HEIGHT : 'auto';
    const scrollableContainerHeight = useFixedTableHeight ? tableScrollHeight : undefined;
    const contentWrapperHeight = animation.revealHeightZero || animation.isHidden ? 0 : useFixedTableHeight ? tableScrollHeight + $51159ee7c0863918$var$TABLE_FOOTER_HEIGHT + $51159ee7c0863918$var$CONTENT_BELOW_TABLE_HEIGHT + $51159ee7c0863918$var$CONTENT_WRAPPER_PADDING_TOP_PX : 'auto';
    const headerSection = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
        label: "AI Content",
        size: "medium"
    }), /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xsmall",
        as: "h2"
    }, formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).smartlinkCardTitle))), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, jiraSearchUrl ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $51159ee7c0863918$var$styles.viewAllContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $f0ebab6d2240cdcf$export$28a2392dc2b2dd58), {
        url: jiraSearchUrl,
        callback: onViewAllButtonClicked,
        spacing: "compact"
    })) : null, !animation.isHidden && showExpandButton && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "default",
        onClick: animation.isExpanded ? onCollapseButtonClicked : onExpandButtonClicked,
        testId: "jira-sain-card-expand-collapse-button",
        icon: animation.isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($3UfFE))) : (0, (/*@__PURE__*/$parcel$interopDefault($4ESzI))),
        spacing: "compact",
        label: animation.isExpanded ? formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).collapse) : formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).expand),
        isTooltipDisabled: false
    }), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "default",
        onClick: animation.isHidden ? onRevealButtonClicked : onHideButtonClicked,
        testId: animation.isHidden ? 'jira-sain-card-reveal-button' : 'jira-sain-card-hide-button',
        icon: animation.isHidden ? (0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))) : (0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))),
        spacing: "compact",
        label: animation.isHidden ? formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).unhide) : formatMessage((0, $6ee04b9bd73a1654$export$defe85febe8b728c).hide),
        isTooltipDisabled: false
    })));
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $51159ee7c0863918$var$styles.container,
        testId: "jira-nl-to-jql-card-wrapper"
    }, headerSection, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $51159ee7c0863918$var$styles.resizingContentWrapper,
        testId: "jira-nl-to-jql-content-wrapper",
        style: {
            paddingTop: animation.revealHeightZero || animation.isHidden ? 0 : "var(--ds-space-150, 12px)",
            // this is a false positive, the height is not static
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            height: contentWrapperHeight,
            transition: animationsEnabled && (animation.isHidden || animation.contentWrapperTransitioning) ? `${$51159ee7c0863918$var$CONTENT_WRAPPER_HEIGHT_TRANSITION}, ${$51159ee7c0863918$var$CONTENT_WRAPPER_PADDING_TOP_TRANSITION}` : 'none'
        },
        onTransitionEnd: animation.onContentWrapperTransitionEnd
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- opacity transition for hide/reveal
    ), {
        style: {
            opacity: animationsEnabled && (animation.isHidden || animation.justRevealed) ? 0 : 1,
            transition: animationsEnabled && (animation.isHidden || animation.contentWrapperTransitioning) ? $51159ee7c0863918$var$CONTENT_WRAPPER_OPACITY_TRANSITION : 'none'
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $51159ee7c0863918$var$styles.tableContainer,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            height: tableContainerHeight
        },
        ref: tableScrollContainerRef
    }, /*#__PURE__*/ $cozmU.createElement((0, $3d3WW.default), {
        channel: "media",
        onEvent: handleDatasourceAnalyticsEvent
    }, /*#__PURE__*/ $cozmU.createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: {
            attributes: {
                ...analyticsAttributesWithoutUGC,
                location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_JIRA_NL_TO_JQL_CARD
            },
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_JIRA_NL_TO_JQL_CARD
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ $cozmU.createElement((0, $lmL4n.default), {
        datasourceId: (0, $b1qV0.JIRA_LIST_OF_LINKS_DATASOURCE_ID),
        parameters: {
            cloudId: cloudId,
            jql: jql
        },
        url: jiraSearchUrl ?? undefined,
        scrollableContainerHeight: scrollableContainerHeight
    }))))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true,
        showCopyButton: true,
        copyText: jiraSearchUrl ?? ''
    }))))));
});



var $dsm4u = parcelRequire("dsm4u");

/* VisualKnowledgeCard.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $cJ0FD = parcelRequire("cJ0FD");












var $eN8p6 = parcelRequire("eN8p6");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");








var $a9aSv = parcelRequire("a9aSv");


var $jttUL = parcelRequire("jttUL");

const $7e6c8f186625f3e4$var$DEFAULT_SKELETON_COUNT = 4;
const $7e6c8f186625f3e4$var$styles = {
    skeletonItem: "_3YEZNOdnbC _39xV024chP"
}; /**
    * __ImagesSkeleton__
    *
    * A skeleton placeholder that mirrors the layout of the `Images` component
    * while image data is loading. Renders shimmering placeholders inside a
    * `Carousel` container.
    *
    * Provide `aria-label` with a translated string such as "Loading related images"
    * to announce the loading state to screen readers.
    */ 
const $7e6c8f186625f3e4$export$83c1b29561e0555a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ImagesSkeleton(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { heading: heading, "aria-label": ariaLabel } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = Array.from({
            length: $7e6c8f186625f3e4$var$DEFAULT_SKELETON_COUNT
        }, $7e6c8f186625f3e4$var$_temp);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== heading) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $jttUL.Carousel), {
            heading: heading
        }, t1);
        $[1] = heading;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== ariaLabel || $[4] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            role: "status",
            "aria-label": ariaLabel,
            "aria-busy": "true"
        }, t2);
        $[3] = ariaLabel;
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function ImagesSkeleton({ heading: heading, 'aria-label': ariaLabel }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        role: "status",
        "aria-label": ariaLabel,
        "aria-busy": "true"
    }, /*#__PURE__*/ $cozmU.createElement((0, $jttUL.Carousel), {
        heading: heading
    }, Array.from({
        length: $7e6c8f186625f3e4$var$DEFAULT_SKELETON_COUNT
    }, (_, index)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: index,
            xcss: $7e6c8f186625f3e4$var$styles.skeletonItem
        }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            width: "100%",
            height: "150px",
            borderRadius: "var(--ds-radius-large, 8px)",
            isShimmering: true,
            testId: `images-skeleton-item-${index}`
        })))));
};
function $7e6c8f186625f3e4$var$_temp(_, index) {
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        key: index,
        xcss: $7e6c8f186625f3e4$var$styles.skeletonItem
    }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        width: "100%",
        height: "150px",
        borderRadius: "var(--ds-radius-large, 8px)",
        isShimmering: true,
        testId: `images-skeleton-item-${index}`
    }));
}






var $1mpi6 = parcelRequire("1mpi6");
















function $0c511e94a5ddad93$export$b49ab013235250d9() {
    const lastRunKey = (0, $cozmU.useRef)(null);
    return (0, $cozmU.useCallback)((key, action)=>{
        if (key === null || key === undefined) return;
        if (lastRunKey.current === key) return;
        lastRunKey.current = key;
        action();
    }, []);
}














const $0de40b4d8c1636a6$var$IMAGE_SEARCH_URL = '/gateway/api/assist/api/rovo/v1/image-search';
const $0de40b4d8c1636a6$var$DEFAULT_IMAGE_SEARCH_LIMIT = 10;
async function $0de40b4d8c1636a6$export$be0d73ca56f1a1d({ searchQuery: searchQuery, cloudId: cloudId, workspaceId: workspaceId, product: product, limit: limit = $0de40b4d8c1636a6$var$DEFAULT_IMAGE_SEARCH_LIMIT }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': product,
                'X-Experience-Id': 'ai-mate',
                'X-Cloudid': cloudId,
                ...(0, $7AtIp.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudId,
                    product: product
                })
            },
            body: JSON.stringify({
                searchQuery: searchQuery,
                limit: limit
            })
        }
    };
    return (0, $gABt9.utils).requestService({
        url: $0de40b4d8c1636a6$var$IMAGE_SEARCH_URL
    }, options);
}


const $a2b5d773fabc49f3$export$316e28c88346523f = ({ searchQuery: searchQuery, cloudId: cloudId, workspaceId: workspaceId, product: product })=>{
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(false);
    const [images, setImages] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                setLoading(true);
                setError(false);
                const data = await (0, $0de40b4d8c1636a6$export$be0d73ca56f1a1d)({
                    searchQuery: searchQuery,
                    cloudId: cloudId,
                    workspaceId: workspaceId,
                    product: product
                });
                const filteredImages = data.images.filter((image)=>image.url && image.thumbnailUrl);
                setImages(filteredImages);
            } catch (e) {
                (0, $cuvLu.logger).error({
                    error: e,
                    functionName: 'useImages'
                });
                setError(true);
            } finally{
                setLoading(false);
            }
        };
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        images: images,
        loading: loading,
        error: error
    };
};


var $b574ea4305b1efef$exports = {};
$b574ea4305b1efef$exports = new URL("visual-knowledge-card-empty-dark.4b1b4fc7.svg", import.meta.url).toString();


var $6821377106e67a2b$exports = {};
$6821377106e67a2b$exports = new URL("visual-knowledge-card-empty-light.74a7204b.svg", import.meta.url).toString();


var $feed221c694a57aa$exports = {};
$feed221c694a57aa$exports = new URL("visual-knowledge-card-error-dark.86770ffd.svg", import.meta.url).toString();


var $a170e3a0c9804798$exports = {};
$a170e3a0c9804798$exports = new URL("visual-knowledge-card-error-light.a73803d2.svg", import.meta.url).toString();


const $472bcf0ba3d83c5e$export$776be90c8b2f701e = 4;
const $472bcf0ba3d83c5e$var$IMAGE_THUMBNAIL_LOCATION = 'imageThumbnail';
const $472bcf0ba3d83c5e$var$IMAGE_SOURCE_LINK_LOCATION = 'imageSourceLink';
const $472bcf0ba3d83c5e$var$IMAGE_CAROUSEL_ARROW_LOCATION = 'imageCarouselArrow';
const $472bcf0ba3d83c5e$var$messages = (0, $kSwu1.defineMessages)({
    heading: {
        id: "search_ai.visual_knowledge_card.heading",
        defaultMessage: "Images"
    },
    loadingLabel: {
        id: "search_ai.visual_knowledge_card.loading_label",
        defaultMessage: "Loading images"
    },
    statusBodyText: {
        id: "search_ai.visual_knowledge_card.body_text",
        defaultMessage: "Try searching again."
    },
    errorTitle: {
        id: "search_ai.visual_knowledge_card.error_title",
        defaultMessage: "Something went wrong and we couldn't find related images."
    },
    emptyTitle: {
        id: "search_ai.visual_knowledge_card.empty_title",
        defaultMessage: "We couldn't find any images for this search."
    }
});
const $472bcf0ba3d83c5e$var$styles = {
    stateContainer: "_0bjKvD8fU6 _0KLXrunmFW _0Of8r22ADO _1Znuxb5zaO _1wydGW2ADO _2Zuz6Q5zaO",
    title: "_2sNsIgmnOE _1UtDYzKGUX",
    body: "_2sNsIg7NXe _1UtDYzKGUX"
};
const $472bcf0ba3d83c5e$var$VisualKnowledgeCardStatusMessage = ({ heading: heading, imageSrc: imageSrc, imageSrcDark: imageSrcDark, title: title, body: body })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "xsmall"
    }, heading), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $472bcf0ba3d83c5e$var$styles.stateContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: imageSrc,
        srcDark: imageSrcDark,
        width: 72,
        height: 72,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $472bcf0ba3d83c5e$var$styles.title
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $472bcf0ba3d83c5e$var$styles.body
    }, body)))));
const $472bcf0ba3d83c5e$export$cf8f12b9d9c373ce = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId, query: query, queryHash: queryHash, workspaceId: workspaceId } = commonAttributes;
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $cXLoX.useAIEventsInstrumentation)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { images: images, loading: loading, error: error } = (0, $a2b5d773fabc49f3$export$316e28c88346523f)({
        searchQuery: query,
        cloudId: cloudId,
        workspaceId: workspaceId,
        product: sourceProduct ?? ''
    });
    const buildAnalyticsAttributes = (0, $cozmU.useCallback)(()=>({
            searchSessionId: commonAttributes.searchSessionId,
            queryHash: commonAttributes.queryHash,
            brand: commonAttributes.brand,
            source: commonAttributes.source,
            query: commonAttributes.query,
            answerString: commonAttributes.answerString,
            // The card's own identity; the dialog-level commonAttributes.answerCardType is broader (SAIN).
            answerCardType: (0, $zzZbq.AnswerCardType).VISUAL,
            imageMaxVisibleCount: $472bcf0ba3d83c5e$export$776be90c8b2f701e
        }), [
        commonAttributes
    ]);
    const runImpressionOncePerQuery = (0, $0c511e94a5ddad93$export$b49ab013235250d9)();
    const hasImages = !loading && !error && !!images && images.length > 0;
    (0, $cozmU.useEffect)(()=>{
        if (!hasImages) return;
        runImpressionOncePerQuery(queryHash, ()=>{
            trackAIInteractionInit();
            fireSAINUsageEvent({
                commonAttributes: commonAttributes
            });
            fireAnalyticsEvent((0, $1mpi6.onNonGenerativeAIAnswerResultShown)({
                ...buildAnalyticsAttributes(),
                imageCount: images.length
            }));
        });
    }, [
        hasImages,
        queryHash,
        images,
        commonAttributes,
        buildAnalyticsAttributes,
        trackAIInteractionInit,
        fireSAINUsageEvent,
        fireAnalyticsEvent,
        runImpressionOncePerQuery
    ]);
    const handleImageClick = (0, $cozmU.useCallback)((index)=>{
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        });
        fireAnalyticsEvent((0, $jtIlq.onNonGenerativeKnowledgeCardLinkClick)({
            ...buildAnalyticsAttributes(),
            location: $472bcf0ba3d83c5e$var$IMAGE_THUMBNAIL_LOCATION,
            imageIndex: index,
            imageCount: images?.length,
            imageSimilarity: images?.[index]?.similarity
        }));
    }, [
        buildAnalyticsAttributes,
        commonAttributes,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        images
    ]);
    const handleSourceLinkClick = (0, $cozmU.useCallback)((index)=>{
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        });
        fireAnalyticsEvent((0, $jtIlq.onNonGenerativeKnowledgeCardLinkClick)({
            ...buildAnalyticsAttributes(),
            location: $472bcf0ba3d83c5e$var$IMAGE_SOURCE_LINK_LOCATION,
            imageIndex: index,
            imageCount: images?.length,
            imageSimilarity: images?.[index]?.similarity
        }));
    }, [
        buildAnalyticsAttributes,
        commonAttributes,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        images
    ]);
    const handleCarouselArrowClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $jtIlq.onNonGenerativeKnowledgeCardLinkClick)({
            ...buildAnalyticsAttributes(),
            location: $472bcf0ba3d83c5e$var$IMAGE_CAROUSEL_ARROW_LOCATION,
            imageCount: images?.length
        }));
    }, [
        buildAnalyticsAttributes,
        fireAnalyticsEvent,
        images
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7e6c8f186625f3e4$export$83c1b29561e0555a), {
        heading: formatMessage($472bcf0ba3d83c5e$var$messages.heading),
        "aria-label": formatMessage($472bcf0ba3d83c5e$var$messages.loadingLabel)
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($472bcf0ba3d83c5e$var$VisualKnowledgeCardStatusMessage, {
        heading: formatMessage($472bcf0ba3d83c5e$var$messages.heading),
        imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($a170e3a0c9804798$exports))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($feed221c694a57aa$exports))),
        title: formatMessage($472bcf0ba3d83c5e$var$messages.errorTitle),
        body: formatMessage($472bcf0ba3d83c5e$var$messages.statusBodyText)
    });
    if (!images || images.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($472bcf0ba3d83c5e$var$VisualKnowledgeCardStatusMessage, {
        heading: formatMessage($472bcf0ba3d83c5e$var$messages.heading),
        imageSrc: (0, (/*@__PURE__*/$parcel$interopDefault($6821377106e67a2b$exports))),
        imageSrcDark: (0, (/*@__PURE__*/$parcel$interopDefault($b574ea4305b1efef$exports))),
        title: formatMessage($472bcf0ba3d83c5e$var$messages.emptyTitle),
        body: formatMessage($472bcf0ba3d83c5e$var$messages.statusBodyText)
    });
    const mappedImages = images.map((image)=>({
            altText: image.altText,
            imageUrl: image.thumbnailUrl,
            sourceTitle: image.title,
            sourceUrl: image.url
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eN8p6.Images), {
        heading: formatMessage($472bcf0ba3d83c5e$var$messages.heading),
        images: mappedImages,
        maxVisibleCount: $472bcf0ba3d83c5e$export$776be90c8b2f701e,
        onCarouselArrowClick: handleCarouselArrowClick,
        onImageClick: handleImageClick,
        onSourceLinkClick: handleSourceLinkClick
    });
};


/* agent-knowledge-card.tsx generated by @compiled/babel-plugin v2.0.0 */ 













var $eKpjD = parcelRequire("eKpjD");


var $6gGPb = parcelRequire("6gGPb");










/* knowledge-carousel.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $5Sv3D = parcelRequire("5Sv3D");





var $kdlgT = parcelRequire("kdlgT");


var $aRvnq = parcelRequire("aRvnq");










/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 


const $223e2747cf2a82ba$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    scrollLeft: {
        id: "search_ai.knowledge_carousel.scroll_left",
        defaultMessage: "Scroll left"
    },
    scrollRight: {
        id: "search_ai.knowledge_carousel.scroll_right",
        defaultMessage: "Scroll right"
    }
});


const $ec82c8c1e1d8eeb1$var$styles = {
    scrollContainerStyle: "_2mHwu85zaO _0hPCNLFlnN _3iDTPbQ4SZ _4bt5LAIZbP _3oUqlsYbGa _1ANEUSLRg7"
};
const $ec82c8c1e1d8eeb1$var$isScrollable = (elem)=>elem ? elem.scrollWidth > elem.clientWidth : false;
const $ec82c8c1e1d8eeb1$var$isScrollAtLeftEdge = (elem)=>elem ? elem.scrollLeft <= 1 : false;
const $ec82c8c1e1d8eeb1$var$isScrollAtRightEdge = (elem)=>elem ? elem?.scrollWidth - elem?.scrollLeft - elem?.clientWidth <= 1 : false;
const $ec82c8c1e1d8eeb1$export$61c045a5252abd1d = ({ children: children, heading: heading, scrollOffset: scrollOffset })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const scrollContainerRef = (0, $cozmU.useRef)(null);
    const [isContentScrollable, setIsContentScrollable] = (0, $cozmU.useState)(false);
    const [shouldDisableLeftArrowButton, setShouldDisableLeftArrowButton] = (0, $cozmU.useState)(true);
    const [shouldDisableRightArrowButton, setShouldDisableRightArrowButton] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setIsContentScrollable($ec82c8c1e1d8eeb1$var$isScrollable(scrollContainerRef.current));
        setShouldDisableLeftArrowButton($ec82c8c1e1d8eeb1$var$isScrollAtLeftEdge(scrollContainerRef.current));
        setShouldDisableRightArrowButton($ec82c8c1e1d8eeb1$var$isScrollAtRightEdge(scrollContainerRef.current));
    }, []);
    const [onScroll] = (0, $5Sv3D.default)(()=>{
        setShouldDisableLeftArrowButton($ec82c8c1e1d8eeb1$var$isScrollAtLeftEdge(scrollContainerRef.current));
        setShouldDisableRightArrowButton($ec82c8c1e1d8eeb1$var$isScrollAtRightEdge(scrollContainerRef.current));
    }, 10);
    const scrollLeft = ()=>{
        setShouldDisableRightArrowButton(false);
        scrollContainerRef.current?.scrollBy({
            top: 0,
            left: -scrollOffset,
            behavior: 'smooth'
        });
    };
    const scrollRight = ()=>{
        setShouldDisableLeftArrowButton(false);
        scrollContainerRef.current?.scrollBy({
            top: 0,
            left: scrollOffset,
            behavior: 'smooth'
        });
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center"
    }, typeof heading === 'string' ? /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "large",
        weight: "semibold"
    }, heading) : heading, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050"
    }, isContentScrollable ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        shape: "circle",
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        isTooltipDisabled: true,
        label: formatMessage((0, $223e2747cf2a82ba$export$defe85febe8b728c).scrollLeft),
        onClick: scrollLeft,
        spacing: "compact",
        isDisabled: shouldDisableLeftArrowButton
    }), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        shape: "circle",
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
        isTooltipDisabled: true,
        label: formatMessage((0, $223e2747cf2a82ba$export$defe85febe8b728c).scrollRight),
        onClick: scrollRight,
        spacing: "compact",
        isDisabled: shouldDisableRightArrowButton
    })) : null)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        ref: scrollContainerRef,
        onScroll: onScroll,
        xcss: $ec82c8c1e1d8eeb1$var$styles.scrollContainerStyle
    }, children));
};









var $1hQ0e = parcelRequire("1hQ0e");







const $6aa1c731e5464443$export$48c2363cbebfe859 = (props)=>{
    const { source: source, elementType: elementType } = props;
    return {
        action: 'viewed',
        actionSubject: 'aiResultHover',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            elementType: elementType
        }
    };
};





const $5a2790b37fbfb80b$export$ccaa86fdb4ea3d58 = (props)=>{
    const { source: source, elementType: elementType, hoverTime: hoverTime } = props;
    return {
        action: 'dismissed',
        actionSubject: 'aiResultHover',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            elementType: elementType,
            hoverTime: hoverTime
        }
    };
};





const $44276ea9228fcce0$var$document = (0, $1hQ0e.getDocument)();
// Timeout constants for hover behavior, these come from the people and teams profilecard package
const $44276ea9228fcce0$var$HOVER_START_DELAY = 800; // Delay before starting hover on trigger
const $44276ea9228fcce0$var$HOVER_END_DELAY = 250; // Delay before ending hover when mouse leaves elements
const $44276ea9228fcce0$export$79db6a77ac4a8ace = ({ elementType: elementType, onHoverStart: onHoverStart, onHoverStop: onHoverStop, hoverCardSelector: hoverCardSelector, hoverStartDelay: hoverStartDelay = $44276ea9228fcce0$var$HOVER_START_DELAY, hoverEndDelay: hoverEndDelay = $44276ea9228fcce0$var$HOVER_END_DELAY })=>{
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [isHovering, setIsHovering] = (0, $cozmU.useState)(false);
    const hoverStartTimeRef = (0, $cozmU.useRef)(null);
    const isOnTriggerRef = (0, $cozmU.useRef)(false);
    const isOnHoverCardRef = (0, $cozmU.useRef)(false);
    /**
   * Checks if the mouse is currently over the hover card element.
   */ const isMouseOnHoverCard = (0, $cozmU.useCallback)((event)=>{
        if (!$44276ea9228fcce0$var$document) return false;
        const hoverCardElement = $44276ea9228fcce0$var$document.querySelector(hoverCardSelector);
        if (!hoverCardElement) return false;
        return hoverCardElement.contains(event.target);
    }, [
        hoverCardSelector
    ]);
    /**
   * Handles mouse movement to track position relative to hover card and manage hover state.
   */ const handleMouseMove = (0, $cozmU.useCallback)((event)=>{
        const isOnHoverCard = isMouseOnHoverCard(event);
        isOnHoverCardRef.current = isOnHoverCard;
        // If mouse leaves hover card, check if we should end hover after delay
        if (!isOnHoverCard) setTimeout(()=>{
            // End hover if mouse is not on either element after delay
            if (!isOnHoverCardRef.current && hoverStartTimeRef.current && !isOnTriggerRef.current) {
                const hoverTime = Date.now() - hoverStartTimeRef.current;
                hoverStartTimeRef.current = null;
                if (onHoverStop) onHoverStop(hoverTime);
                else fireAnalyticsEvent((0, $5a2790b37fbfb80b$export$ccaa86fdb4ea3d58)({
                    elementType: elementType,
                    hoverTime: hoverTime,
                    ...commonAttributes
                }));
                setIsHovering(false);
            }
        }, hoverEndDelay);
    }, [
        isMouseOnHoverCard,
        onHoverStop,
        fireAnalyticsEvent,
        commonAttributes,
        elementType,
        hoverEndDelay
    ]);
    /**
   * Handles the start of a hover interaction on the trigger.
   * Manages hover state and prevents duplicate hover interactions.
   */ const handleHoverStart = (0, $cozmU.useCallback)((event)=>{
        // Don't start hover if mouse is already on hover card
        const isOnHoverCard = isMouseOnHoverCard(event.nativeEvent);
        if (isOnHoverCard) return;
        // Check if hover card is currently open
        let anyHoverCardOpen;
        if ($44276ea9228fcce0$var$document) anyHoverCardOpen = $44276ea9228fcce0$var$document.querySelector(hoverCardSelector);
        // If hover card is open and we're already hovering, continue existing hover
        if (anyHoverCardOpen && isHovering) {
            isOnTriggerRef.current = true;
            return;
        }
        // Don't start new hover if hover card is already open
        if (anyHoverCardOpen) return;
        isOnTriggerRef.current = true;
        // Start hover after delay to prevent premature triggering
        setTimeout(()=>{
            // Only start hover if user is still on trigger after delay
            if (!isHovering && isOnTriggerRef.current) {
                const startTime = Date.now();
                hoverStartTimeRef.current = startTime;
                setIsHovering(true);
                if (onHoverStart) onHoverStart();
                else fireAnalyticsEvent((0, $6aa1c731e5464443$export$48c2363cbebfe859)({
                    elementType: elementType,
                    ...commonAttributes
                }));
            }
        }, hoverStartDelay);
    }, [
        elementType,
        onHoverStart,
        fireAnalyticsEvent,
        commonAttributes,
        isHovering,
        isMouseOnHoverCard,
        hoverCardSelector,
        hoverStartDelay
    ]);
    /**
   * Handles the end of a hover interaction on the trigger.
   * Updates trigger state to track mouse position.
   */ const handleHoverLeave = (0, $cozmU.useCallback)(()=>{
        isOnTriggerRef.current = false;
    }, []);
    // Set up global mouse move tracking
    (0, $cozmU.useEffect)(()=>{
        if (!$44276ea9228fcce0$var$document) return;
        const removeMouseMoveListener = (0, $cbY7C.bind)($44276ea9228fcce0$var$document, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        return ()=>{
            removeMouseMoveListener();
        };
    }, [
        handleMouseMove
    ]);
    return {
        isHovering: isHovering,
        handleHoverStart: handleHoverStart,
        handleHoverLeave: handleHoverLeave
    };
};






var $jXQUy = parcelRequire("jXQUy");

/* knowledge-card-loading.tsx generated by @compiled/babel-plugin v2.0.0 */ 




























var $7qJqb = parcelRequire("7qJqb");




const $935ec00e5e72a55d$export$91710431dd421e57 = (props, isAnimated)=>{
    const { query: query, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'knowledgeCardLoadingDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            isAnimated: isAnimated
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};









var $9LgVw = parcelRequire("9LgVw");

const $4fd6fa5a10eca60c$var$styles = {
    containerNewSAINLoading: "_1Znuxb5zaO _2Zuz6Q5zaO _0Of8r25zaO _1wydGW5zaO _0jFU0Vk3g7",
    inline: "_2Zuz6Q2ADO _1Znuxb2ADO _0jFU0VUF4f",
    agentCardHeightOverride: "_0jFU0VEayI"
};
const $4fd6fa5a10eca60c$var$messages = (0, $kSwu1.defineMessages)({
    knowledge_card_loading: {
        id: "search_ai.knowledge_card_loading",
        defaultMessage: "Searching across your connected apps"
    },
    knowledge_card_rovo_is_thinking: {
        id: "search_ai.knowledge_card_rovo_is_thinking",
        defaultMessage: "Rovo is thinking"
    }
});
function $4fd6fa5a10eca60c$export$a08238eb59773648({ queryIntent: queryIntent }) {
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent((0, $935ec00e5e72a55d$export$91710431dd421e57)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3ffN.AnimatedWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: (0, $w6R6I.cx)($4fd6fa5a10eca60c$var$styles.containerNewSAINLoading, queryIntent === (0, $zzZbq.QueryIntent).AGENT && $4fd6fa5a10eca60c$var$styles.agentCardHeightOverride),
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: 'space.100',
        xcss: $4fd6fa5a10eca60c$var$styles.inline,
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9LgVw))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: 'color.text.subtle'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4fd6fa5a10eca60c$var$messages.knowledge_card_rovo_is_thinking)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7qJqb.RovoGeneratingAnimation), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "16px",
        color: "var(--ds-skeleton-subtle, #17171708)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "16px",
        color: "var(--ds-skeleton-subtle, #17171708)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "90%",
        height: "16px",
        color: "var(--ds-skeleton-subtle, #17171708)"
    })));
}



var $9T3jg = parcelRequire("9T3jg");




const $d80ef16958371a2e$export$885a78bb6bce677d = (props)=>{
    const { source: source, agentId: agentId, position: position } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAgentKnowledgeCardCarousel',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            agentId: agentId,
            position: position
        }
    };
};





const $9dbfa7cbc81cad25$export$6266151addd8e413 = (props)=>{
    const { source: source, agentCount: agentCount } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAgentKnowledgeCardCarousel',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            agentCount: agentCount
        }
    };
};





const $46b3e6d1a35c49a1$export$4ce3543705832c97 = (props)=>{
    const { source: source, agentId: agentId } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAgentKnowledgeCard',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            agentId: agentId
        }
    };
};





const $19a6060145576e12$export$44d9aa4134474084 = (props)=>{
    const { source: source, cardType: cardType } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerDialog',
        actionSubjectId: 'knowledgeCard',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            cardType: cardType
        }
    };
};


/* separator-line.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $8ba51f29bf3689a9$var$styles = {
    lineRefresh: "_0jFU0VHZdu _39xV02N91d _0KLXruG6qS"
};
const $8ba51f29bf3689a9$export$4fb305a2fc986af3 = ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $8ba51f29bf3689a9$var$styles.lineRefresh
    });




























var $cb86z = parcelRequire("cb86z");


var $3TiFP = parcelRequire("3TiFP");











var $j9SBi = parcelRequire("j9SBi");


var $15IyG = parcelRequire("15IyG");




const $0c4b83a6aec4026d$var$youSingularWorkedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.worked.today",
        defaultMessage: "You worked on this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.worked.yesterday",
        defaultMessage: "You worked on this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.worked.otherTime",
        defaultMessage: "You worked on this {time}"
    }
});
const $0c4b83a6aec4026d$var$youSingularCreatedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.created.today",
        defaultMessage: "You created this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.created.yesterday",
        defaultMessage: "You created this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.created.otherTime",
        defaultMessage: "You created this on {time}"
    }
});
const $0c4b83a6aec4026d$var$youSingularEditedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.edited.today",
        defaultMessage: "You edited this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.edited.yesterday",
        defaultMessage: "You edited this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.edited.otherTime",
        defaultMessage: "You edited this on {time}"
    }
});
const $0c4b83a6aec4026d$var$youSingularCommentedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.commented.today",
        defaultMessage: "You commented here today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.commented.yesterday",
        defaultMessage: "You commented here yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.commented.otherTime",
        defaultMessage: "You commented here on {time}"
    }
});
const $0c4b83a6aec4026d$var$youSingularUpdatedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.updated.today",
        defaultMessage: "You updated this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.updated.yesterday",
        defaultMessage: "You updated this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_singular.updated.otherTime",
        defaultMessage: "You updated this on {time}"
    }
});
const $0c4b83a6aec4026d$var$otherSingularWorkedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.worked.today",
        defaultMessage: "{name} worked on this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.worked.yesterday",
        defaultMessage: "{name} worked on this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.worked.otherTime",
        defaultMessage: "{name} worked on this on {time}"
    }
});
const $0c4b83a6aec4026d$var$otherSingularCreatedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.created.today",
        defaultMessage: "{name} created this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.created.yesterday",
        defaultMessage: "{name} created this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.created.otherTime",
        defaultMessage: "{name} created this on {time}"
    }
});
const $0c4b83a6aec4026d$var$otherSingularEditedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.edited.today",
        defaultMessage: "{name} edited this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.edited.yesterday",
        defaultMessage: "{name} edited this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.edited.otherTime",
        defaultMessage: "{name} edited this on {time}"
    }
});
const $0c4b83a6aec4026d$var$otherSingularCommentedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.commented.today",
        defaultMessage: "{name} commented here today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.commented.yesterday",
        defaultMessage: "{name} commented here yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.commented.otherTime",
        defaultMessage: "{name} commented here on {time}"
    }
});
const $0c4b83a6aec4026d$var$otherSingularUpdatedMessages = (0, $kSwu1.defineMessages)({
    today: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.updated.today",
        defaultMessage: "{name} updated this today"
    },
    yesterday: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.updated.yesterday",
        defaultMessage: "{name} updated this yesterday"
    },
    otherTime: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_singular.updated.otherTime",
        defaultMessage: "{name} updated this on {time}"
    }
});
const $0c4b83a6aec4026d$var$youPluralActivityMessages = (0, $kSwu1.defineMessages)({
    double: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_plural.double",
        defaultMessage: "You and {name1} have both worked on this"
    },
    triple: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_plural.triple",
        defaultMessage: "You, {name1}, and {name2} have all worked on this"
    },
    many: {
        id: "search_ai.ai_answer_dialog.recent_work_list.you_plural.many",
        defaultMessage: "You, {name1}, and {count} others have all worked on this"
    }
});
const $0c4b83a6aec4026d$var$otherPluralActivityMessages = (0, $kSwu1.defineMessages)({
    double: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_plural.double",
        defaultMessage: "{name1} and {name2} have both worked on this"
    },
    triple: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_plural.triple",
        defaultMessage: "{name1}, {name2}, and {name3} have all worked on this"
    },
    many: {
        id: "search_ai.ai_answer_dialog.recent_work_list.other_plural.many",
        defaultMessage: "{name1}, {name2}, and {count} others have all worked on this"
    }
});
const $0c4b83a6aec4026d$export$97eb62906ce0e051 = {
    worked: $0c4b83a6aec4026d$var$youSingularWorkedMessages,
    created: $0c4b83a6aec4026d$var$youSingularCreatedMessages,
    edited: $0c4b83a6aec4026d$var$youSingularEditedMessages,
    commented: $0c4b83a6aec4026d$var$youSingularCommentedMessages,
    updated: $0c4b83a6aec4026d$var$youSingularUpdatedMessages
};
const $0c4b83a6aec4026d$export$fca5bc54abc98673 = {
    worked: $0c4b83a6aec4026d$var$otherSingularWorkedMessages,
    created: $0c4b83a6aec4026d$var$otherSingularCreatedMessages,
    edited: $0c4b83a6aec4026d$var$otherSingularEditedMessages,
    commented: $0c4b83a6aec4026d$var$otherSingularCommentedMessages,
    updated: $0c4b83a6aec4026d$var$otherSingularUpdatedMessages
};
const $0c4b83a6aec4026d$export$b9d6808884fda53b = {
    you: $0c4b83a6aec4026d$var$youPluralActivityMessages,
    other: $0c4b83a6aec4026d$var$otherPluralActivityMessages
};


const $998049cf2dbeb756$export$4d98da88c6a5014a = ({ currentUserId: currentUserId, event: event, contributors: contributors, othersCount: othersCount, timestamp: timestamp, formatMessage: formatMessage, formatDate: formatDate })=>{
    const involvesCurrentUser = contributors.some((contributor)=>contributor.id === currentUserId);
    // If the event is singular with a single contributor
    if (contributors.length === 1) {
        const formattedDate = formatDate(timestamp, {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
        });
        let message;
        switch(event){
            case 'created':
                message = involvesCurrentUser ? (0, $0c4b83a6aec4026d$export$97eb62906ce0e051).created : (0, $0c4b83a6aec4026d$export$fca5bc54abc98673).created;
                break;
            case 'edited':
                message = involvesCurrentUser ? (0, $0c4b83a6aec4026d$export$97eb62906ce0e051).edited : (0, $0c4b83a6aec4026d$export$fca5bc54abc98673).edited;
                break;
            case 'commented':
                message = involvesCurrentUser ? (0, $0c4b83a6aec4026d$export$97eb62906ce0e051).commented : (0, $0c4b83a6aec4026d$export$fca5bc54abc98673).commented;
                break;
            case 'updated':
                message = involvesCurrentUser ? (0, $0c4b83a6aec4026d$export$97eb62906ce0e051).updated : (0, $0c4b83a6aec4026d$export$fca5bc54abc98673).updated;
                break;
            case 'worked':
            default:
                message = involvesCurrentUser ? (0, $0c4b83a6aec4026d$export$97eb62906ce0e051).worked : (0, $0c4b83a6aec4026d$export$fca5bc54abc98673).worked;
                break;
        }
        if ((0, $j9SBi.default)(timestamp)) return involvesCurrentUser ? formatMessage(message.today) : formatMessage(message.today, {
            name: contributors[0].name
        });
        else if ((0, $15IyG.default)(timestamp)) return involvesCurrentUser ? formatMessage(message.yesterday) : formatMessage(message.yesterday, {
            name: contributors[0].name
        });
        else return involvesCurrentUser ? formatMessage(message.otherTime, {
            time: formattedDate
        }) : formatMessage(message.yesterday, {
            name: contributors[0].name,
            time: formattedDate
        });
    } else if (involvesCurrentUser) {
        const contributorsWithoutCurrentUser = contributors.filter((contributor)=>contributor.id !== currentUserId);
        if (othersCount > 0) return formatMessage((0, $0c4b83a6aec4026d$export$b9d6808884fda53b).you.many, {
            name1: contributorsWithoutCurrentUser[0].name,
            count: othersCount
        });
        else return contributors.length === 2 ? formatMessage((0, $0c4b83a6aec4026d$export$b9d6808884fda53b).you.double, {
            name1: contributorsWithoutCurrentUser[0].name
        }) : formatMessage((0, $0c4b83a6aec4026d$export$b9d6808884fda53b).you.triple, {
            name1: contributorsWithoutCurrentUser[0].name,
            name2: contributorsWithoutCurrentUser[1].name
        });
    } else {
        if (othersCount > 0) return formatMessage((0, $0c4b83a6aec4026d$export$b9d6808884fda53b).other.many, {
            name1: contributors[0].name,
            name2: contributors[1].name,
            count: othersCount
        });
        else return contributors.length === 2 ? formatMessage((0, $0c4b83a6aec4026d$export$b9d6808884fda53b).other.double, {
            name1: contributors[0].name,
            name2: contributors[1].name
        }) : formatMessage((0, $0c4b83a6aec4026d$export$b9d6808884fda53b).other.triple, {
            name1: contributors[0].name,
            name2: contributors[1].name,
            name3: contributors[2].name
        });
    }
};









var $aqqYN = parcelRequire("aqqYN");


var $1UlLI = parcelRequire("1UlLI");


const $cce772d1072e95eb$var$HoverCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("e5LDW")).then(({ HoverCard: HoverCard })=>({
            default: HoverCard
        })));
const $cce772d1072e95eb$export$65943680306d629 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ item: activity, onClickCallback: onClickCallback, searchAIAnalyticsContextData: searchAIAnalyticsContextData })=>{
    const { userDetails: { id: searcherId } } = (0, $3hVWe.useAIAnswerContext)();
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: searchAIAnalyticsContextData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cce772d1072e95eb$var$HoverCard, {
        url: activity.url,
        key: `knowledge-card-activity-${activity.url}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aqqYN.KnowledgeCardsRowRefresh), {
        primaryText: activity.title,
        secondaryText: `${activity.containerName} \u{2022} ${(0, $998049cf2dbeb756$export$4d98da88c6a5014a)({
            currentUserId: searcherId || '',
            event: activity.event,
            contributors: activity.contributors,
            othersCount: activity.othersCount,
            formatMessage: formatMessage,
            formatDate: formatDate,
            timestamp: new Date(activity.timestamp)
        })}`,
        pictureUrl: activity.iconUrl,
        type: (0, $1UlLI.KnowledgeCardsRowType).WORK,
        contentTypeName: activity.contentTypeName,
        onClick: ()=>{
            onClickCallback?.();
            window.open(activity.url, '_self', 'noopener, noreferrer');
        },
        onAuxClick: (e)=>{
            if (e.button !== 1) return;
            onClickCallback?.({
                isAuxClick: true
            });
            window.open(activity.url, '_blank', 'noopener, noreferrer');
        },
        onContextMenu: ()=>{
            onClickCallback?.({
                isContextMenu: true
            });
        }
    })))));
});


/* knowledge-card-body.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $ad7Ou = parcelRequire("ad7Ou");







var $i1t43 = parcelRequire("i1t43");



















const $572d81ab3ae88f65$export$b02bdd5f3105358f = ({ location: location, commonAttributes: commonAttributes })=>{
    const filtered = (0, $4Tg3t.filterCommonAttributes)(commonAttributes);
    return {
        location: location,
        attributes: {
            ...filtered,
            location: location
        }
    };
};












var $lPcf8 = parcelRequire("lPcf8");










const $acbcdb4ca700ade0$var$CardBodyWrapper = {
    default: "_1mT5xdRAKS _1Znuxb5zaO _2Zuz6Q5zaO"
};
const $acbcdb4ca700ade0$var$ColumnBottomPadding = {
    default: "_1wydGW1Y8M"
};
const $acbcdb4ca700ade0$var$DynamicRowStyling = {
    column: "_3iDTPbQ4SZ _0aFT5vbt8w _42d1HA1Y8M _17lj8p1Y8M",
    grid: "_3iDTPbgBM8 _2iEGP2Lmr7 _17lj8p5zaO _42d1HA1Y8M"
};
const $acbcdb4ca700ade0$var$EXPANDED_MAX_ITEMS_SHOWN = 6;
const $acbcdb4ca700ade0$var$MAX_ITEMS_SHOWN = 2;
const $acbcdb4ca700ade0$var$SINGLE_COLUMN_MAX_ITEMS_SHOWN = 4; // 2 rows * 2 items per row
const $acbcdb4ca700ade0$var$SINGLE_COLUMN_EXPANDED_MAX_ITEMS_SHOWN = 12; // 6 rows * 2 items per row
const $acbcdb4ca700ade0$export$ef08b123bd77f721 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ columnsConfig: columnsConfig, profileUrl: profileUrl, footerButtonText: footerButtonText, footerButtonAction: footerButtonAction, testId: testId })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setExpanded] = (0, $cozmU.useState)(false); // Determine if we should show a single column layout (when only one column has data)
    const hasDataColumns = columnsConfig.filter((config)=>config.data.length > 0);
    const showSingleColumn = hasDataColumns.length === 1; // Calculate total items across all columns for expand logic
    const totalItems = columnsConfig.reduce((sum, config)=>sum + config.data.length, 0);
    const shouldShowExpandButton = showSingleColumn ? totalItems > $acbcdb4ca700ade0$var$SINGLE_COLUMN_MAX_ITEMS_SHOWN : totalItems > $acbcdb4ca700ade0$var$MAX_ITEMS_SHOWN * columnsConfig.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $acbcdb4ca700ade0$var$CardBodyWrapper.default,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.200"
    }, columnsConfig.map((columnConfig, columnIndex)=>{
        if (columnConfig.data.length === 0) return null;
        const maxItems = !isExpanded ? showSingleColumn ? $acbcdb4ca700ade0$var$SINGLE_COLUMN_MAX_ITEMS_SHOWN : $acbcdb4ca700ade0$var$MAX_ITEMS_SHOWN : Math.min(columnConfig.data.length, showSingleColumn ? $acbcdb4ca700ade0$var$SINGLE_COLUMN_EXPANDED_MAX_ITEMS_SHOWN : $acbcdb4ca700ade0$var$EXPANDED_MAX_ITEMS_SHOWN);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            key: columnIndex,
            grow: "fill",
            space: "space.050",
            xcss: $acbcdb4ca700ade0$var$ColumnBottomPadding.default
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            paddingInlineStart: "space.200",
            paddingInlineEnd: "space.200",
            paddingBlockEnd: "space.075"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            spread: "space-between",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall",
            as: "h3"
        }, columnConfig.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: columnConfig.viewAllLinkHref,
            appearance: "subtle",
            onClick: (e)=>{
                columnConfig.viewAllLinkOnClick(e);
            },
            onAuxClick: (e)=>{
                if (e.button !== 1) return;
                columnConfig.viewAllLinkOnClick(e);
            },
            onContextMenu: (e)=>{
                columnConfig.viewAllLinkOnClick(e);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtle"
        }, formatMessage((0, $cb86z.messages).knowledge_cards_view_all_link))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: showSingleColumn ? $acbcdb4ca700ade0$var$DynamicRowStyling.grid : $acbcdb4ca700ade0$var$DynamicRowStyling.column
        }, columnConfig.data.slice(0, maxItems).map((item, index)=>{
            // Calculate if this item is shown after card body expansion
            // For single column layout: items with index >= 4 are shown after expansion
            // For multi-column layout: items with index >= 2 are shown after expansion
            const shownAfterCardBodyExpanded = showSingleColumn ? index >= $acbcdb4ca700ade0$var$SINGLE_COLUMN_MAX_ITEMS_SHOWN && isExpanded : index >= $acbcdb4ca700ade0$var$MAX_ITEMS_SHOWN && isExpanded;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(columnConfig.component, {
                key: index,
                item: item,
                maxItems: maxItems,
                onClickCallback: columnConfig?.onClickCallback ? (opts)=>columnConfig.onClickCallback(index, shownAfterCardBodyExpanded, opts) : undefined,
                searchAIAnalyticsContextData: columnConfig.searchAIAnalyticsContextLocation ? (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
                    location: columnConfig.searchAIAnalyticsContextLocation,
                    commonAttributes: commonAttributes
                }) : undefined
            });
        }))))));
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, shouldShowExpandButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignInline: "center",
        space: "space.025"
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        href: profileUrl || '',
        onClick: ()=>{
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'footer-view-all'
            }));
            fireSAINUsageEvent({
                metCriteria: footerButtonAction,
                commonAttributes: commonAttributes
            });
        },
        onAuxClick: (e)=>{
            if (e.button !== 1) return;
            if (!(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'footer-view-all',
                isAuxClick: true
            }));
            fireSAINUsageEvent({
                metCriteria: footerButtonAction,
                commonAttributes: commonAttributes
            });
        },
        onContextMenu: ()=>{
            if (!(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'footer-view-all',
                isContextMenu: true
            }));
            fireSAINUsageEvent({
                metCriteria: footerButtonAction,
                commonAttributes: commonAttributes
            });
        },
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        weight: "medium"
    }, footerButtonText)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: ()=>{
            setExpanded((e)=>!e);
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'show-more'
            }));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).EXPAND_CLICKED,
                commonAttributes: commonAttributes
            });
        },
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        weight: "medium"
    }, formatMessage((0, $cb86z.messages).ai_answer_expand_button_label)))) : null));
});












var $7y6O1 = parcelRequire("7y6O1");















const $4e4c19c18699fbff$export$40f705aca7f6b285 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ item: teamData, onClickCallback: onClickCallback })=>{
    const { commonAttributes: commonAttributes, userDetails: userDetails } = (0, $3hVWe.useAIAnswerContext)();
    const { orgId: orgId } = commonAttributes;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const team = teamData.team;
    const teamUrl = (0, $df52b12138df743d$export$782629dc0d11ee5c)(team.id.split('/').pop() || team.id, orgId);
    const handleTeamClick = (e)=>{
        const isAuxClick = 'button' in e && e.button === 1;
        if (isAuxClick) window.open(teamUrl, '_blank', 'noopener,noreferrer');
        else window.open(teamUrl, '_self', 'noopener, noreferrer');
    };
    const { handleHoverStart: handleHoverStart, handleHoverLeave: handleHoverLeave } = (0, $44276ea9228fcce0$export$79db6a77ac4a8ace)({
        elementType: 'team',
        hoverCardSelector: '[data-testid="team-profilecard"]'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7y6O1.TeamProfileCardWithTrigger), {
        trigger: "hover",
        teamAri: team.id,
        cloudId: commonAttributes.cloudId,
        placement: "bottom-start",
        userId: userDetails.id || ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onMouseEnter: handleHoverStart,
        onMouseLeave: handleHoverLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aqqYN.KnowledgeCardsRowRefresh), {
        primaryText: team.displayName,
        secondaryText: formatMessage((0, $cb86z.messages).knowledge_cards_team_member_count, {
            count: teamData.memberCount
        }),
        pictureUrl: team.smallAvatarImageUrl,
        type: (0, $1UlLI.KnowledgeCardsRowType).AGENT,
        onClick: (e)=>{
            onClickCallback?.();
            handleTeamClick(e);
        },
        onAuxClick: (e)=>{
            if (e.button !== 1) return;
            onClickCallback?.({
                isAuxClick: true
            });
            handleTeamClick(e);
        },
        onContextMenu: ()=>{
            onClickCallback?.({
                isContextMenu: true
            });
        }
    })));
});


const $5c155516f42291cf$export$e35364d8cf1f1804 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ currentUserId: _currentUserId, teamsData: teamsData, activityData: activityData, profileUrl: profileUrl, viewAllUrl: _viewAllUrl })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const handleRecentWorkViewAllClick = (0, $cozmU.useMemo)(()=>(e)=>{
            const isAuxClick = 'button' in e && e.button === 1;
            const isContextMenu = 'button' in e && e.button === 2;
            if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'recent-work-view-all',
                isAuxClick: isAuxClick,
                isContextMenu: isContextMenu
            }));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).RECENT_WORK_CLICKED,
                commonAttributes: commonAttributes
            });
        }, [
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        commonAttributes
    ]);
    const handleAgentTeamsViewAllClick = (0, $cozmU.useMemo)(()=>(e)=>{
            const isAuxClick = 'button' in e && e.button === 1;
            const isContextMenu = 'button' in e && e.button === 2;
            if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'agent-teams-view-all',
                isAuxClick: isAuxClick,
                isContextMenu: isContextMenu
            }));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).TEAM_LIST_CLICKED,
                commonAttributes: commonAttributes
            });
        }, [
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        commonAttributes
    ]);
    // Determine which columns to render
    const hasRecentActivity = (0, $cozmU.useMemo)(()=>activityData && Array.isArray(activityData) && activityData.length > 0, [
        activityData
    ]);
    const hasTeams = (0, $cozmU.useMemo)(()=>teamsData?.teamSearch?.nodes && teamsData.teamSearch.nodes.length > 0, [
        teamsData?.teamSearch?.nodes
    ]);
    const columnsConfig = (0, $cozmU.useMemo)(()=>[
            // Teams Column
            ...hasTeams && teamsData?.teamSearch?.nodes ? [
                {
                    viewAllLinkOnClick: handleAgentTeamsViewAllClick,
                    viewAllLinkHref: profileUrl,
                    data: teamsData.teamSearch.nodes,
                    component: (0, $4e4c19c18699fbff$export$40f705aca7f6b285),
                    header: formatMessage((0, $cb86z.messages).knowledge_cards_teams_subheader),
                    onClickCallback: (position, shownAfterCardBodyExpanded, opts)=>{
                        if ((opts?.isAuxClick || opts?.isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
                        fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                            ...commonAttributes,
                            location: 'team-list-item',
                            position: position,
                            shownAfterCardBodyExpanded: shownAfterCardBodyExpanded,
                            isAuxClick: opts?.isAuxClick,
                            isContextMenu: opts?.isContextMenu
                        }));
                        fireSAINUsageEvent({
                            metCriteria: (0, $bZMnB.SainAction).TEAM_LIST_ITEM_CLICKED,
                            commonAttributes: commonAttributes
                        });
                    }
                }
            ] : [],
            // Recent Activity Column
            ...hasRecentActivity ? [
                {
                    viewAllLinkOnClick: handleRecentWorkViewAllClick,
                    viewAllLinkHref: profileUrl,
                    data: activityData,
                    component: (0, $cce772d1072e95eb$export$65943680306d629),
                    header: formatMessage((0, $cb86z.messages).knowledge_cards_worked_on_subheader),
                    onClickCallback: (position, shownAfterCardBodyExpanded, opts)=>{
                        if ((opts?.isAuxClick || opts?.isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
                        fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                            ...commonAttributes,
                            location: 'recent-work-item',
                            position: position,
                            shownAfterCardBodyExpanded: shownAfterCardBodyExpanded,
                            isAuxClick: opts?.isAuxClick,
                            isContextMenu: opts?.isContextMenu
                        }));
                        fireSAINUsageEvent({
                            metCriteria: (0, $bZMnB.SainAction).RECENT_WORK_CLICKED,
                            commonAttributes: commonAttributes
                        });
                    },
                    searchAIAnalyticsContextLocation: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_AGENT_CARD
                }
            ] : []
        ], [
        hasTeams,
        teamsData?.teamSearch.nodes,
        handleAgentTeamsViewAllClick,
        profileUrl,
        formatMessage,
        hasRecentActivity,
        handleRecentWorkViewAllClick,
        activityData,
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acbcdb4ca700ade0$export$ef08b123bd77f721), {
        columnsConfig: columnsConfig,
        profileUrl: profileUrl,
        footerButtonText: formatMessage((0, $cb86z.messages).knowledge_cards_view_agent),
        footerButtonAction: (0, $bZMnB.SainAction).VIEW_PROFILE_CLICKED,
        testId: "agent-card-body"
    });
});



















var $hdBxM = parcelRequire("hdBxM");


var $aihbI = parcelRequire("aihbI");


var $eHdk6 = parcelRequire("eHdk6");







/* knowledge-card-header.tsx generated by @compiled/babel-plugin v2.0.0 */ 














var $ldb9Z = parcelRequire("ldb9Z");






























const $371756d199ccc649$export$f7dcb977daa6621d = (email)=>{
    // try catch is for the clipboard function
    try {
        navigator.clipboard.writeText(email);
    } catch (error) {
        (0, $cuvLu.logger).error({
            error: error,
            functionName: 'onEmailCopy'
        });
    }
};


const $ff2c12cd5348c884$var$HeaderWrapper = {
    default: "_2Zuz6Q5zaO _1Znuxb5zaO"
};
const $ff2c12cd5348c884$var$PrimaryInfoWrapper = {
    default: "_3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d _0aFT5vbt8w _37wbyuDIqT"
};
const $ff2c12cd5348c884$var$HeaderActionsWrapper = {
    default: "_3YEZNOdnbC _2XsHFMIZbP"
};
const $ff2c12cd5348c884$export$c7c90b1402552129 = ({ name: name, email: email, profileUrl: profileUrl, profileLinkText: profileLinkText, media: media, orgText: orgText, additionalInfo: additionalInfo, onLinkClick: onLinkClick, headerActions: headerActions, testId: testId })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const emailTooltip = {
        position: 'bottom',
        content: formatMessage((0, $cb86z.messages).knowledge_cards_copy_email_address),
        hideTooltipOnClick: true
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        xcss: $ff2c12cd5348c884$var$HeaderWrapper.default,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignInline: "start",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.200",
        alignBlock: "center"
    }, media, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: $ff2c12cd5348c884$var$PrimaryInfoWrapper.default
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "small",
        as: "h2"
    }, name), orgText && orgText, additionalInfo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        xcss: $ff2c12cd5348c884$var$HeaderActionsWrapper.default
    }, headerActions, !!email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ldb9Z))), {
                ...props,
                color: "var(--ds-icon, #292A2E)"
            }),
        label: formatMessage((0, $cb86z.messages).ai_answer_who_questions_hover_email_icon),
        onClick: ()=>{
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'header-copy-email'
            }));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).COPY_CLICKED,
                commonAttributes: commonAttributes
            });
            (0, $371756d199ccc649$export$f7dcb977daa6621d)(email);
        },
        isTooltipDisabled: false,
        tooltip: emailTooltip
    }), profileUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        href: profileUrl,
        onClick: (e)=>{
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'header-view-profile'
            }));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).VIEW_PROFILE_CLICKED,
                commonAttributes: commonAttributes
            });
            onLinkClick?.(e);
        },
        onAuxClick: (e)=>{
            if (e.button !== 1) return;
            if (!(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'header-view-profile',
                isAuxClick: true
            }));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).VIEW_PROFILE_CLICKED,
                commonAttributes: commonAttributes
            });
        },
        onContextMenu: ()=>{
            if (!(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
            fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                ...commonAttributes,
                location: 'header-view-profile',
                isContextMenu: true
            }));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).VIEW_PROFILE_CLICKED,
                commonAttributes: commonAttributes
            });
        }
    }, profileLinkText)));
};



const $6a152749034bfcee$export$162531e7c7ccb21f = ({ agent: agent })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId, orgId: orgId } = commonAttributes;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const media = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
        agentId: agent.id,
        agentNamedId: agent.id,
        agentIdentityAccountId: agent.identity_account_id,
        size: "xlarge"
    }));
    const additionalInfo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        maxLines: 2
    }, agent.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage((0, $cb86z.messages).knowledge_cards_rovo_agent_by)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aihbI.AgentCreatedBy), {
        agent: agent,
        siteId: cloudId,
        simplified: true
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff2c12cd5348c884$export$c7c90b1402552129), {
        name: agent.name,
        profileUrl: (0, $df52b12138df743d$export$d00d38d973440568)(agent, orgId),
        profileLinkText: formatMessage((0, $cb86z.messages).knowledge_cards_view_agent),
        media: media,
        additionalInfo: additionalInfo,
        testId: "agent-card-header",
        headerActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eHdk6.FollowUpButton), {
            followUpIndex: 0,
            followUpType: "agent",
            followUpText: "Chat to agent",
            experienceId: "sain",
            onClick: ()=>{
                publish({
                    type: 'chat-new',
                    source: 'sain',
                    data: {
                        agentId: agent.id,
                        dialogues: [],
                        sourceId: commonAttributes.searchSessionId,
                        name: `Chat with ${agent.name}`
                    }
                });
            }
        }))
    });
};

















const $c3b283c365a749e4$export$bfb683339256dc9e = 'KnowledgeCardAgentTeamsQuery';
const $c3b283c365a749e4$var$KNOWLEDGE_CARD_AGENT_TEAMS_QUERY = `
  query ${$c3b283c365a749e4$export$bfb683339256dc9e}(
    $first: Int,
    $after: String,
    $organizationId: ID!,
    $query: String = "",
    $memberIds: [ID] = [],
    $sortBy: [TeamSort],
    $siteId: String!,
    $showEmptyTeams: Boolean = false
  ) {
    team {
      teamSearch: teamSearchV2(
        first: $first
        after: $after
        organizationId: $organizationId
        filter: { query: $query, membership: { memberIds: $memberIds } }
        sortBy: $sortBy
        siteId: $siteId
        showEmptyTeams: $showEmptyTeams
      ) @optIn(to: ["Team-search-v2"]) {
        nodes {
          ...TeamNodeV2
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }

  fragment TeamNodeV2 on TeamSearchResultV2 {
		team {
			id
			organizationId
			membershipSettings
			description
			displayName
			state
			largeAvatarImageUrl
			smallAvatarImageUrl
			largeHeaderImageUrl
			smallHeaderImageUrl
			isVerified
			members {
				nodes {
					member {
						id
						accountStatus
						name
						picture
					}
				}
			}
		}
		memberCount
		includesYou
	}
`;
const $c3b283c365a749e4$export$76c925f889384cac = (agent)=>{
    const { commonAttributes: commonAttributes, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId, workspaceId: workspaceId, orgId: orgId } = commonAttributes;
    // Loading states
    const [loading, setLoading] = (0, $cozmU.useState)(false);
    const [teamsLoading, setTeamsLoading] = (0, $cozmU.useState)(false);
    const [activityLoading, setActivityLoading] = (0, $cozmU.useState)(false);
    // Data states
    const [teamsData, setTeamsData] = (0, $cozmU.useState)(null);
    const [activityData, setActivityData] = (0, $cozmU.useState)(null);
    // Error states
    const [error, setError] = (0, $cozmU.useState)(null);
    const [teamsError, setTeamsError] = (0, $cozmU.useState)(null);
    const [activityError, setActivityError] = (0, $cozmU.useState)(null);
    // Refetch counter to trigger refetches
    const [refetchCounter, setRefetchCounter] = (0, $cozmU.useState)(0);
    // Fetch teams data
    const fetchTeamsData = (0, $cozmU.useCallback)(async ()=>{
        if (!agent?.id || !cloudId) return;
        setTeamsLoading(true);
        setTeamsError(null);
        try {
            const response = await (0, $i5c0A.fetchAggResponse)({
                graphQuery: $c3b283c365a749e4$var$KNOWLEDGE_CARD_AGENT_TEAMS_QUERY,
                variables: {
                    first: 12,
                    organizationId: `ari:cloud:platform::org/${orgId}`,
                    siteId: cloudId,
                    showEmptyTeams: true,
                    memberIds: [
                        agent.identity_account_id?.split('/').pop() || ''
                    ]
                },
                operationName: $c3b283c365a749e4$export$bfb683339256dc9e,
                headers: (0, $7AtIp.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudId,
                    product: sourceProduct ?? ''
                })
            });
            const { data: data, errors: errors } = response;
            if (errors && errors.length > 0) throw new Error(errors.map((e)=>e.message).join(', '));
            if (data?.team) setTeamsData(data.team);
            else throw new Error('No teams data received');
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Failed to fetch teams data';
            setTeamsError(errorMessage);
            setError(errorMessage);
        } finally{
            setTeamsLoading(false);
        }
    }, [
        agent?.id,
        agent?.identity_account_id,
        cloudId,
        workspaceId,
        sourceProduct,
        orgId
    ]);
    const activityClient = (0, $k8VpS.useActivityClient)('v3', 'people');
    // Fetch activity data
    const fetchActivityData = (0, $cozmU.useCallback)(async ()=>{
        if (!agent?.identity_account_id) return;
        setActivityLoading(true);
        setActivityError(null);
        try {
            const activityData = await activityClient.fetchActivities([
                100
            ], {
                limit: 50,
                actors: [
                    agent.identity_account_id.startsWith('ari:cloud:identity::user/') ? agent.identity_account_id : `ari:cloud:identity::user/${agent.identity_account_id}`
                ]
            }, [
                'workedOn'
            ], false);
            setActivityData(activityData.workedOn);
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Failed to fetch activity data';
            setActivityError(errorMessage);
            setError(errorMessage);
        } finally{
            setActivityLoading(false);
        }
    }, [
        agent?.identity_account_id,
        activityClient
    ]);
    // Combined loading state - true if either API is loading
    const combinedLoading = teamsLoading || activityLoading;
    // Refetch function
    const refetch = (0, $cozmU.useCallback)(()=>{
        setRefetchCounter((prev)=>prev + 1);
    }, []);
    // Effect to fetch data when agent changes or refetch is triggered
    (0, $cozmU.useEffect)(()=>{
        if (!agent?.id) {
            // Reset all states when no agent is provided
            setTeamsData(null);
            setActivityData(null);
            setTeamsError(null);
            setActivityError(null);
            setError(null);
            return;
        }
        // Reset error states when starting new fetch
        setError(null);
        // Fetch data conditionally based on available dependencies
        const fetchData = async ()=>{
            const promises = [];
            // Only fetch teams if we have the required data
            if (agent.identity_account_id && cloudId && orgId) promises.push(fetchTeamsData());
            // Only fetch activity if we have the required data
            if (agent.identity_account_id) promises.push(fetchActivityData());
            // Execute available fetches in parallel
            if (promises.length > 0) await Promise.all(promises);
        };
        fetchData();
    }, [
        agent?.id,
        agent?.identity_account_id,
        cloudId,
        orgId,
        fetchTeamsData,
        fetchActivityData,
        refetchCounter
    ]);
    // Update combined loading state
    (0, $cozmU.useEffect)(()=>{
        setLoading(combinedLoading);
    }, [
        combinedLoading
    ]);
    return {
        loading: loading,
        teamsLoading: teamsLoading,
        activityLoading: activityLoading,
        teamsData: teamsData,
        activityData: activityData,
        error: error,
        teamsError: teamsError,
        activityError: activityError,
        refetch: refetch
    };
};


const $a6a88c586e988f54$var$CardContainerStyles = {
    refresh: "_0bjKvDKxmn _2mHwu85zaO _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0Of8r25zaO _1wydGW5zaO",
    disclaimer: "_2Zuz6Q5zaO _1Znuxb5zaO"
};
const $a6a88c586e988f54$var$AgentCardWrapperStyles = {
    wrapper: "_0bjKvD8fU6 _23rrnHDRYy _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _1bHrqEWD6W _2O5VijdnbC _3YEZNOdnbC _39xV02WD6W _4ouGXIoaux _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _1mT5xdRAKS _1ANEUSzUZr _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0ReiIH7zJH _4ezyzhQiA2 _1pwPA0pFbM _0t5mr7N8t6 _3s1x1CUaiG"
};
const $a6a88c586e988f54$var$AGENTS_SCROLL_OFFSET = 392;
const $a6a88c586e988f54$var$messages = (0, $kSwu1.defineMessages)({
    multiple_agents_matches_header: {
        id: "search_ai.knowledge_cards.multiple_agents_matches_header",
        defaultMessage: "Agent matches"
    }
});
const $a6a88c586e988f54$var$IndividualAgentKnowledgeCard = ({ agent: agent })=>{
    const { teamsData: teamsData, activityData: activityData, loading: loading } = (0, $c3b283c365a749e4$export$76c925f889384cac)(agent);
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { orgId: orgId } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)(); // Fire analytics event when individual agent knowledge card is shown
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (agent) fireAnalyticsEvent((0, $46b3e6d1a35c49a1$export$4ce3543705832c97)({
            ...commonAttributes,
            agentId: agent.id
        }));
    }, [
        agent,
        commonAttributes,
        fireAnalyticsEvent
    ]);
    if (!agent) return null;
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4fd6fa5a10eca60c$export$a08238eb59773648), {
        queryIntent: (0, $zzZbq.QueryIntent).AGENT
    });
    const showKnowledgeCardBody = teamsData?.teamSearch?.nodes && teamsData.teamSearch.nodes.length > 0 || activityData && Array.isArray(activityData) && activityData.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $a6a88c586e988f54$var$CardContainerStyles.refresh
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6a152749034bfcee$export$162531e7c7ccb21f), {
        agent: agent
    }), showKnowledgeCardBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8ba51f29bf3689a9$export$4fb305a2fc986af3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, showKnowledgeCardBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5c155516f42291cf$export$e35364d8cf1f1804), {
        currentUserId: agent.identity_account_id || '',
        teamsData: teamsData,
        activityData: activityData,
        profileUrl: (0, $df52b12138df743d$export$d00d38d973440568)(agent, orgId)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a6a88c586e988f54$var$CardContainerStyles.disclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true
    })))));
};
const $a6a88c586e988f54$export$f3d65ac3e9ec58cd = ({ onFMPReached: onFMPReached })=>{
    const { commonAttributes: commonAttributes, loading: loading, userDetails: userDetails } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId } = commonAttributes;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const [selectedAgent, setSelectedAgent] = (0, $cozmU.useState)();
    const { answerString: answerString } = commonAttributes; // Parses the answerString to extract agent results, returning an empty array if parsing fails or if the result is not an array.
    const agentResults = (0, $cozmU.useMemo)(()=>{
        if (!answerString) return [];
        try {
            const parsed = JSON.parse(answerString);
            return Array.isArray(parsed) ? parsed : [];
        } catch  {
            return [];
        }
    }, [
        answerString
    ]); // Fire analytics event when carousel is shown (only when multiple agents exist)
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (agentResults && agentResults.length > 1) fireAnalyticsEvent((0, $9dbfa7cbc81cad25$export$6266151addd8e413)({
            ...commonAttributes,
            agentCount: agentResults.length
        }));
    }, [
        agentResults,
        commonAttributes,
        fireAnalyticsEvent
    ]);
    const profileClient = (0, $cozmU.useMemo)(()=>(0, $jXQUy.createProfileClient)(cloudId), [
        cloudId
    ]);
    const getHandleSelectAgent = (0, $cozmU.useCallback)((index)=>()=>{
            const selectedAgentData = agentResults[index];
            setSelectedAgent(selectedAgentData); // Fire analytics event for carousel item click
            fireAnalyticsEvent((0, $d80ef16958371a2e$export$885a78bb6bce677d)({
                ...commonAttributes,
                agentId: selectedAgentData.id,
                position: index
            }));
        }, [
        agentResults,
        commonAttributes,
        fireAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (agentResults.length === 1) setSelectedAgent(agentResults[0]);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        agentResults
    ]);
    (0, $cozmU.useEffect)(()=>{
        onFMPReached?.();
        fireAnalyticsEvent((0, $19a6060145576e12$export$44d9aa4134474084)({
            ...commonAttributes,
            cardType: (0, $9T3jg.KnowledgeCardsIntentType).AGENT
        })); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { handleHoverStart: handleHoverStart, handleHoverLeave: handleHoverLeave } = (0, $44276ea9228fcce0$export$79db6a77ac4a8ace)({
        elementType: 'agent',
        hoverCardSelector: '[data-testid="agent-knowledge-card-trigger"]'
    });
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4fd6fa5a10eca60c$export$a08238eb59773648), null);
    if (agentResults.length === 0) return null;
    if (selectedAgent !== undefined || agentResults.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a6a88c586e988f54$var$IndividualAgentKnowledgeCard, {
        agent: selectedAgent
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ec82c8c1e1d8eeb1$export$61c045a5252abd1d), {
        heading: formatMessage($a6a88c586e988f54$var$messages.multiple_agents_matches_header),
        scrollOffset: $a6a88c586e988f54$var$AGENTS_SCROLL_OFFSET
    }, agentResults.map((agent, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            onClick: getHandleSelectAgent(index),
            testId: "agent-knowledge-card-wrapper",
            key: agent.id,
            xcss: $a6a88c586e988f54$var$AgentCardWrapperStyles.wrapper,
            onMouseEnter: handleHoverStart,
            onMouseLeave: handleHoverLeave
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKpjD.AgentProfileCardTrigger), {
            trigger: "hover",
            agentId: agent.id,
            resourceClient: profileClient,
            cloudId: cloudId,
            viewingUserId: userDetails.id,
            disabledAriaAttributes: true,
            testId: "agent-knowledge-card-trigger"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gGPb.AgentAvatar), {
            agentId: agent.id,
            agentNamedId: agent.id,
            agentIdentityAccountId: agent.identity_account_id,
            size: "xxlarge"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100",
            alignInline: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: 1,
            size: "medium",
            weight: "medium",
            align: "center"
        }, agent.name), agent.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: 1,
            size: "medium",
            color: "color.text.subtlest",
            align: "center"
        }, agent.description))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true
    }));
};



/* person-knowledge-card.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $9EOlJ = parcelRequire("9EOlJ");


















var $8aG6j = parcelRequire("8aG6j");





















var $1LXnB = parcelRequire("1LXnB");



















const $3a9123b42ae8c5e9$var$wrapperStyles = {
    root: "_0bjKvD8fU6 _23rrnHDRYy _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _39xV02N91d _0jFU0VN91d _4ouGXIoaux _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _1mT5xdRAKS _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0ReiIH7zJH _4ezyzhQiA2 _1pwPA0pFbM _0t5mr7N8t6 _3s1x1CUaiG"
};
const $3a9123b42ae8c5e9$export$a3474cd1dd8e70a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { id: id, children: children, testId: testId } = t0;
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($3a9123b42ae8c5e9$var$wrapperStyles.root);
        $[0] = t1;
    } else t1 = $[0];
    const t2 = isHovered ? "elevation.surface.hovered" : "elevation.surface";
    let t3;
    let t4;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsHovered(true);
        t4 = ()=>setIsHovered(false);
        $[1] = t3;
        $[2] = t4;
    } else {
        t3 = $[1];
        t4 = $[2];
    }
    const t5 = testId || `person-card-${id}`;
    let t6;
    if ($[3] !== children || $[4] !== t2 || $[5] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t1,
            backgroundColor: t2,
            onMouseEnter: t3,
            onMouseLeave: t4,
            testId: t5,
            children: children
        });
        $[3] = children;
        $[4] = t2;
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    return t6;
} : ({ id: id, children: children, testId: testId })=>{
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3a9123b42ae8c5e9$var$wrapperStyles.root),
        backgroundColor: isHovered ? 'elevation.surface.hovered' : 'elevation.surface',
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        testId: testId || `person-card-${id}`,
        children: children
    });
};


const $67cd5bff95eb1aaf$var$AVATAR_BREAKPOINT = 180;
const $67cd5bff95eb1aaf$var$unbouncedStyles = {
    name: "_2sNsIgEqul _4bt5LAnQyn _2WAcuGnQyn _1kk5Tkf7mX _2fwxA5DIqT _39HuIbz8Lp _3iDTPbgJ9S _1U1ZhbbI28 _4Gn54RiZR3"
};
const $67cd5bff95eb1aaf$var$styles = {
    emptyLine: "_0jFU0VSPN1"
};
const $67cd5bff95eb1aaf$export$4c094c8f61edecb4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PersonCard(t0) {
    const $ = (0, $bDgLe.c)(27);
    const { data: t1 } = t0;
    const { avatarUrl: avatarUrl, id: id, name: name, jobTitle: jobTitle, location: location, localTime: localTime } = t1;
    const shouldShowEmptyLine = !jobTitle && !location && !localTime;
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(0);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1LXnB.WidthObserver), {
            setWidth: setWidth
        });
        $[0] = t2;
    } else t2 = $[0];
    const t3 = width < $67cd5bff95eb1aaf$var$AVATAR_BREAKPOINT ? "xlarge" : "xxlarge";
    let t4;
    if ($[1] !== avatarUrl || $[2] !== name || $[3] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
            src: avatarUrl,
            name: name,
            size: t3
        });
        $[1] = avatarUrl;
        $[2] = name;
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== name) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "h2",
            xcss: $67cd5bff95eb1aaf$var$unbouncedStyles.name,
            children: name
        });
        $[5] = name;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== jobTitle) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            maxLines: 2,
            size: "small",
            color: "color.text.subtlest",
            align: "center",
            children: jobTitle
        });
        $[7] = jobTitle;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== localTime || $[10] !== location) {
        t7 = [
            location,
            localTime
        ].filter(Boolean);
        $[9] = localTime;
        $[10] = location;
        $[11] = t7;
    } else t7 = $[11];
    const t8 = t7.join(" ");
    let t9;
    if ($[12] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            maxLines: 1,
            size: "small",
            color: "color.text.subtlest",
            align: "center",
            children: t8
        });
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== shouldShowEmptyLine) {
        t10 = shouldShowEmptyLine && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $67cd5bff95eb1aaf$var$styles.emptyLine
        });
        $[14] = shouldShowEmptyLine;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== t10 || $[17] !== t5 || $[18] !== t6 || $[19] !== t9) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
            space: "space.050",
            alignInline: "center",
            children: [
                t5,
                t6,
                t9,
                t10
            ]
        });
        $[16] = t10;
        $[17] = t5;
        $[18] = t6;
        $[19] = t9;
        $[20] = t11;
    } else t11 = $[20];
    let t12;
    if ($[21] !== t11 || $[22] !== t4) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
            space: "space.150",
            alignInline: "center",
            children: [
                t4,
                t11
            ]
        });
        $[21] = t11;
        $[22] = t4;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== id || $[25] !== t12) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $3a9123b42ae8c5e9$export$a3474cd1dd8e70a), {
            id: id,
            children: [
                t2,
                t12
            ]
        });
        $[24] = id;
        $[25] = t12;
        $[26] = t13;
    } else t13 = $[26];
    return t13;
} : function PersonCard({ data: { avatarUrl: avatarUrl, id: id, name: name, jobTitle: jobTitle, location: location, localTime: localTime } }) {
    const shouldShowEmptyLine = !jobTitle && !location && !localTime;
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(0);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $3a9123b42ae8c5e9$export$a3474cd1dd8e70a), {
        id: id,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1LXnB.WidthObserver), {
                setWidth: setWidth
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                space: "space.150",
                alignInline: "center",
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $arQY7.default), {
                        src: avatarUrl,
                        name: name,
                        size: width < $67cd5bff95eb1aaf$var$AVATAR_BREAKPOINT ? 'xlarge' : 'xxlarge'
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
                        space: "space.050",
                        alignInline: "center",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                as: "h2",
                                xcss: $67cd5bff95eb1aaf$var$unbouncedStyles.name,
                                children: name
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                maxLines: 2,
                                size: "small",
                                color: "color.text.subtlest",
                                align: "center",
                                children: jobTitle
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                maxLines: 1,
                                size: "small",
                                color: "color.text.subtlest",
                                align: "center",
                                children: [
                                    location,
                                    localTime
                                ].filter(Boolean).join(' ')
                            }),
                            shouldShowEmptyLine && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $67cd5bff95eb1aaf$var$styles.emptyLine
                            })
                        ]
                    })
                ]
            })
        ]
    });
};






var $b5HfQ = parcelRequire("b5HfQ");

var $7Uv0v = parcelRequire("7Uv0v");


var $kjetH = parcelRequire("kjetH");


var $kEVoQ = parcelRequire("kEVoQ");













var $d227efab07c2b9f0$export$eae917983a0398aa = /*#__PURE__*/ function(NLPSearchJSONResultFormat) {
    NLPSearchJSONResultFormat["WHO"] = "who";
    NLPSearchJSONResultFormat["WORK"] = "work";
    NLPSearchJSONResultFormat["TEAM"] = "team";
    NLPSearchJSONResultFormat["PERSON"] = "person";
    NLPSearchJSONResultFormat["AGENT"] = "agent";
    return NLPSearchJSONResultFormat;
}({});


const $d325f5b9eeee6e40$export$d905ae2a714518e8 = ({ answerString: answerString, smartAnswersRoute: smartAnswersRoute })=>{
    const parsed = JSON.parse(answerString);
    if ('user_metadata' in parsed && !!parsed.user_metadata) return {
        parsedResult: parsed.user_metadata,
        parsedType: (0, $d227efab07c2b9f0$export$eae917983a0398aa).WHO
    };
    else if ('user_metadata_only_cards' in parsed && !!parsed.user_metadata_only_cards) return {
        parsedResult: parsed.user_metadata_only_cards,
        parsedType: (0, $d227efab07c2b9f0$export$eae917983a0398aa).PERSON
    };
    else if ('user_metadata_with_activity' in parsed && !!parsed.user_metadata_with_activity) return {
        parsedResult: parsed.user_metadata_with_activity,
        parsedType: (0, $d227efab07c2b9f0$export$eae917983a0398aa).WORK
    };
    else if ('team_metadata' in parsed && !!parsed.team_metadata) return {
        parsedResult: parsed.team_metadata,
        parsedType: (0, $d227efab07c2b9f0$export$eae917983a0398aa).TEAM
    };
    else if (Array.isArray(parsed) && parsed.length > 0 && smartAnswersRoute === (0, $zzZbq.QueryIntent).AGENT) return {
        parsedResult: parsed,
        parsedType: (0, $d227efab07c2b9f0$export$eae917983a0398aa).AGENT
    };
    else // This line should never be reached, this means that an unsupported type was in the JSON result
    return {
        parsedResult: parsed,
        parsedType: undefined
    };
};


























const $26d7d2244f378b33$var$PEOPLE_TEAMS_LOCATION_MAP = {
    userProfilePreview: {
        thirdPartyMessage: 'userProfilePreview-thirdPartyMessage',
        reportingLines: 'userProfilePreview-reportingLines',
        viewProfile: 'userProfilePreview-view-profile',
        recentWorkSection: 'userProfilePreview-recentWork',
        collaboratorsSection: 'userProfilePreview-collaborators'
    },
    userInlinePreview: {
        thirdPartyMessage: 'userInlinePreview-thirdPartyMessage',
        reportingLines: 'userInlinePreview-reportingLines',
        viewProfile: 'userInlinePreview-viewProfile'
    },
    hierarchyChart: {
        managerNode: 'hierarchyChart-managerNode',
        directReportNode: 'hierarchyChart-directReportNode',
        peerNode: 'hierarchyChart-peerNode',
        overflow: 'hierarchyChart-overflow',
        viewFullReportingLine: 'hierarchyChart-viewFullReportingLine'
    }
};
const $26d7d2244f378b33$var$USER_PROFILE_PREVIEW_TAB_LOCATION_MAP = {
    recentWork: 'userProfilePreview-recentWorkTab',
    reportingLine: 'userProfilePreview-reportingLineTab',
    collaborators: 'userProfilePreview-collaboratorsTab'
};
const $26d7d2244f378b33$var$PEOPLE_TEAMS_ACTION_MAP = {
    userProfilePreview: {
        thirdPartyMessage: (0, $bZMnB.SainAction).THIRD_PARTY_MESSAGE_CLICKED,
        reportingLines: (0, $bZMnB.SainAction).REPORTING_LINES_CLICKED,
        viewProfile: (0, $bZMnB.SainAction).VIEW_PROFILE_CLICKED,
        recentWorkSection: (0, $bZMnB.SainAction).PROFILE_SECTION_CLICKED,
        collaboratorsSection: (0, $bZMnB.SainAction).PROFILE_SECTION_CLICKED
    },
    userInlinePreview: {
        thirdPartyMessage: (0, $bZMnB.SainAction).THIRD_PARTY_MESSAGE_CLICKED,
        reportingLines: (0, $bZMnB.SainAction).REPORTING_LINES_CLICKED,
        viewProfile: (0, $bZMnB.SainAction).VIEW_PROFILE_CLICKED
    },
    hierarchyChart: {
        managerNode: (0, $bZMnB.SainAction).HIERARCHY_NODE_CLICKED,
        directReportNode: (0, $bZMnB.SainAction).HIERARCHY_NODE_CLICKED,
        peerNode: (0, $bZMnB.SainAction).HIERARCHY_NODE_CLICKED,
        overflow: (0, $bZMnB.SainAction).REPORTING_LINES_CLICKED,
        viewFullReportingLine: (0, $bZMnB.SainAction).REPORTING_LINES_CLICKED
    }
};
const $26d7d2244f378b33$export$987bf6a808c14d7d = (payload)=>{
    if (payload.action !== 'clicked') return undefined;
    let location;
    let tabSainAction;
    if (payload.actionSubject === 'userProfilePreview' && payload.actionSubjectId === 'tab') {
        const tab = payload.attributes?.tab ?? '';
        location = $26d7d2244f378b33$var$USER_PROFILE_PREVIEW_TAB_LOCATION_MAP[tab];
        if (location) tabSainAction = (0, $bZMnB.SainAction).PROFILE_TAB_CLICKED;
    } else {
        const locationMap = $26d7d2244f378b33$var$PEOPLE_TEAMS_LOCATION_MAP[payload.actionSubject ?? ''];
        location = locationMap?.[payload.actionSubjectId ?? ''];
    }
    if (!location) return undefined;
    const isCollaborator = payload.actionSubject === 'userInlinePreview' && payload.renderContext === 'collaborator';
    if (isCollaborator) location = `${location}-collaborator`;
    const sainAction = isCollaborator ? (0, $bZMnB.SainAction).COLLABORATOR_CLICKED : tabSainAction ?? $26d7d2244f378b33$var$PEOPLE_TEAMS_ACTION_MAP[payload.actionSubject ?? '']?.[payload.actionSubjectId ?? ''];
    return {
        location: location,
        sainAction: sainAction
    };
};





const $016c76767add6663$export$3d5fec32962921db = ({ children: children })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const handlePeopleTeamsEvent = (0, $cozmU.useCallback)((event)=>{
        const resolved = (0, $26d7d2244f378b33$export$987bf6a808c14d7d)(event.payload);
        if (!resolved) return;
        // Fire the `aiAnswerDialog clicked` track event (existing location-based pattern).
        fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
            ...commonAttributes,
            location: resolved.location
        }));
        // Fire the matching SAIN usage (MAU) event for parity with the existing person card
        // instrumentation in person-card-body.tsx.
        if (resolved.sainAction) fireSAINUsageEvent({
            metCriteria: resolved.sainAction,
            commonAttributes: commonAttributes
        });
    }, [
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        commonAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        channel: "peopleTeams",
        onEvent: handlePeopleTeamsEvent
    }, children);
};






























const $9815e23bc9044028$export$5ee3eeb70eb524d1 = (props)=>{
    const { source: source, personCardVariant: personCardVariant, errorMessage: errorMessage } = props;
    return {
        action: 'errored',
        actionSubject: 'aiAnswerPersonKnowledgeCard',
        source: source,
        eventType: 'operational',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            personCardVariant: personCardVariant,
            errorMessage: errorMessage
        }
    };
};





const $2c764823b2ef4dc8$export$c59cd1b0c182839c = (props)=>{
    const { source: source, personCardVariant: personCardVariant, loadTime: loadTime } = props;
    return {
        action: 'loaded',
        actionSubject: 'aiAnswerPersonKnowledgeCard',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            personCardVariant: personCardVariant,
            loadTime: loadTime
        }
    };
};























































var $hSs5g = parcelRequire("hSs5g");


var $9zU5G = parcelRequire("9zU5G");
























var $66eSg = parcelRequire("66eSg");

const $17582a7702efaf6e$export$87f3c1fc8ab2e681 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ item: user, onClickCallback: onClickCallback })=>{
    const { commonAttributes: commonAttributes, userDetails: userDetails } = (0, $3hVWe.useAIAnswerContext)();
    const { toUser: toUser } = (0, $66eSg.useTeamsAppLinks)({
        type: (0, $9T3jg.KnowledgeCardsIntentType).PERSON,
        currentUserId: user.accountId || '',
        cloudId: commonAttributes.cloudId
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const userUrl = `/people/${(0, $1AuMq.trimARI)(user.accountId || '')}`;
    const handleUserClick = (e)=>{
        if ((0, $iDrrr.fg)('platform-adopt-teams-nav-config')) toUser(user.accountId || '').onNavigate(e);
        else window.open(user.url || userUrl, '_self', 'noopener, noreferrer');
    };
    const profileClient = (0, $cozmU.useMemo)(()=>(0, $jXQUy.createProfileClient)(commonAttributes.cloudId), [
        commonAttributes.cloudId
    ]);
    const agent = (0, $cozmU.useMemo)(()=>({
            resourceClient: profileClient
        }), [
        profileClient
    ]);
    const { handleHoverStart: handleHoverStart, handleHoverLeave: handleHoverLeave } = (0, $44276ea9228fcce0$export$79db6a77ac4a8ace)({
        elementType: 'collaborator',
        hoverCardSelector: '[data-testid="profilecard"]'
    });
    if ((0, $iDrrr.fg)('people-teams_migrate-user-profile-card') || (0, $cXtTj.default).getExperimentValue('pt_user_profile_card_migration_exp', 'isEnabled', false)) {
        const rowContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            onMouseEnter: handleHoverStart,
            onMouseLeave: handleHoverLeave
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aqqYN.KnowledgeCardsRowRefresh), {
            primaryText: user.name,
            secondaryText: !!user.title || !!user.department ? [
                user.title,
                user.department
            ].filter((str)=>!!str).join(', ') : '',
            pictureUrl: user.picture || '',
            type: (0, $1UlLI.KnowledgeCardsRowType).PERSON,
            onClick: (e)=>{
                onClickCallback?.();
                handleUserClick(e);
            },
            onAuxClick: (e)=>{
                if (e.button !== 1) return;
                onClickCallback?.({
                    isAuxClick: true
                });
                window.open(user.url || userUrl, '_blank', 'noopener,noreferrer');
            },
            onContextMenu: ()=>{
                onClickCallback?.({
                    isContextMenu: true
                });
            }
        }));
        if (!commonAttributes.orgId || !userDetails.id) return rowContent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9zU5G.UserProfileCardWithTrigger), {
            userId: (0, $1AuMq.trimARI)(user.accountId || ''),
            cloudId: commonAttributes.cloudId,
            orgId: commonAttributes.orgId,
            viewerId: userDetails.id,
            placement: "bottom-end",
            trigger: "hover",
            agent: agent,
            onProfileClick: ()=>onClickCallback?.()
        }, rowContent);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSs5g.default), {
        userId: (0, $1AuMq.trimARI)(user.accountId || ''),
        resourceClient: profileClient,
        actions: [
            {
                label: formatMessage((0, $cb86z.messages).knowledge_cards_person_hover_profile_link),
                link: toUser(user.accountId || '').href,
                callback: (e)=>{
                    onClickCallback?.();
                    toUser(user.accountId || '').onNavigate(e);
                }
            }
        ],
        ariaLabel: user.name,
        position: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onMouseEnter: handleHoverStart,
        onMouseLeave: handleHoverLeave
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aqqYN.KnowledgeCardsRowRefresh), {
        primaryText: user.name,
        secondaryText: !!user.title || !!user.department ? [
            user.title,
            user.department
        ].filter((str)=>!!str).join(', ') : '',
        pictureUrl: user.picture || '',
        type: (0, $1UlLI.KnowledgeCardsRowType).PERSON,
        onClick: (e)=>{
            onClickCallback?.();
            handleUserClick(e);
        },
        onAuxClick: (e)=>{
            if (e.button !== 1) return;
            onClickCallback?.({
                isAuxClick: true
            });
            window.open(user.url || userUrl, '_blank', 'noopener,noreferrer');
        },
        onContextMenu: ()=>{
            onClickCallback?.({
                isContextMenu: true
            });
        }
    })));
});








const $3ffa4c5e2a30b7df$export$2460aa15a0a1d61e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ currentUserId: currentUserId, recommendedUsers: recommendedUsers, recentActivity: recentActivity, profileUrl: profileUrl, viewAllUrl: viewAllUrl })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { viewAllLink: viewAllLink, viewAllOnNavigate: viewAllOnNavigate, worksWithHref: worksWithHref, worksWithOnNavigate: worksWithOnNavigate, profileHref: profileHref } = (0, $66eSg.useTeamsAppLinks)({
        type: (0, $9T3jg.KnowledgeCardsIntentType).PERSON,
        currentUserId: currentUserId,
        viewAllUrl: viewAllUrl,
        cloudId: commonAttributes.cloudId
    });
    const handleRecentWorkViewAllClick = (e)=>{
        const isAuxClick = 'button' in e && e.button === 1;
        const isContextMenu = 'button' in e && e.button === 2;
        if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
            ...commonAttributes,
            location: 'recent-work-view-all',
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).RECENT_WORK_CLICKED,
            commonAttributes: commonAttributes
        });
        if (!isAuxClick && !isContextMenu && (0, $iDrrr.fg)('platform-adopt-teams-nav-config')) viewAllOnNavigate(e);
    };
    const handleCollaboratorsViewAllClick = (e)=>{
        const isAuxClick = 'button' in e && e.button === 1;
        const isContextMenu = 'button' in e && e.button === 2;
        if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
            ...commonAttributes,
            location: 'reporting-lines-link',
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).REPORTING_LINES_CLICKED,
            commonAttributes: commonAttributes
        });
        if (!isAuxClick && !isContextMenu && (0, $iDrrr.fg)('platform-adopt-teams-nav-config')) worksWithOnNavigate(e);
    };
    const columnsConfig = [
        // Recent Activity Column
        ...recentActivity.length > 0 ? [
            {
                viewAllLinkOnClick: handleRecentWorkViewAllClick,
                viewAllLinkHref: viewAllLink,
                data: recentActivity,
                component: (0, $cce772d1072e95eb$export$65943680306d629),
                header: formatMessage((0, $cb86z.messages).knowledge_cards_recent_work_subheader),
                onClickCallback: (position, shownAfterCardBodyExpanded, opts)=>{
                    if ((opts?.isAuxClick || opts?.isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
                    fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                        ...commonAttributes,
                        location: 'recent-work-item',
                        position: position,
                        shownAfterCardBodyExpanded: shownAfterCardBodyExpanded,
                        isAuxClick: opts?.isAuxClick,
                        isContextMenu: opts?.isContextMenu
                    }));
                    fireSAINUsageEvent({
                        metCriteria: (0, $bZMnB.SainAction).RECENT_WORK_CLICKED,
                        commonAttributes: commonAttributes
                    });
                },
                searchAIAnalyticsContextLocation: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_PERSON_CARD
            }
        ] : [],
        // Recommended Users Column
        ...recommendedUsers.length > 0 ? [
            {
                viewAllLinkOnClick: handleCollaboratorsViewAllClick,
                viewAllLinkHref: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? worksWithHref : `https://hello.atlassian.net/people/${currentUserId || ''}#workswith`,
                data: recommendedUsers,
                component: (0, $17582a7702efaf6e$export$87f3c1fc8ab2e681),
                onClickCallback: (position, shownAfterCardBodyExpanded, opts)=>{
                    if ((opts?.isAuxClick || opts?.isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
                    fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                        ...commonAttributes,
                        location: 'user-list-item',
                        position: position,
                        shownAfterCardBodyExpanded: shownAfterCardBodyExpanded,
                        isAuxClick: opts?.isAuxClick,
                        isContextMenu: opts?.isContextMenu
                    }));
                    fireSAINUsageEvent({
                        metCriteria: (0, $bZMnB.SainAction).COLLABORATOR_CLICKED,
                        commonAttributes: commonAttributes
                    });
                },
                header: formatMessage((0, $cb86z.messages).knowledge_cards_collaborators_subheader)
            }
        ] : []
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acbcdb4ca700ade0$export$ef08b123bd77f721), {
        columnsConfig: columnsConfig,
        profileUrl: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : profileUrl,
        footerButtonText: formatMessage((0, $cb86z.messages).ai_answer_who_questions_view_profile),
        footerButtonAction: (0, $bZMnB.SainAction).VIEW_PROFILE_CLICKED,
        testId: "person-knowledge-card-body"
    });
});


/* person-card-header.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $eleTd = parcelRequire("eleTd");


var $hS5Ee = parcelRequire("hS5Ee");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");

var $aRGok = parcelRequire("aRGok");











// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cNIqP = parcelRequire("cNIqP");


var $c966fff235fbed6e$export$2e2bcd8739ae039 = (0, $cNIqP.ReportingLines);















/* knowledge-cards-picture.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $c8bcd61e8797d6ff$export$7f0e56320ea6e6ee = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _39xV02JgOI _0jFU0VJgOI",
            __cmplp.className
        ])
    });
});



var $hgyck = parcelRequire("hgyck");




const $2a40d322081356a1$export$3014182e23d6ae90 = (props)=>{
    const { source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'personCardOrgChartCard',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        }
    };
};





const $3872290fc8ee5c0c$export$c275ac680f034541 = (props)=>{
    const { source: source } = props;
    return {
        action: 'dwelled',
        actionSubject: 'personCardOrgChartModal',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        }
    };
};





const $7da0ee0a7cbf02fe$export$4dea9d9ba0f4fd15 = (props)=>{
    const { source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'personCardOrgChartModal',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        }
    };
};





const $46d8c915edc11e65$var$ORG_CHART_DWELL_THRESHOLD = 3000;
const $46d8c915edc11e65$var$IconPaddingStyles = {
    default: "_1Znuxb1Y8M _2Zuz6Q1Y8M"
};
const $46d8c915edc11e65$export$d1ac32de8e31f333 = ({ name: name, accountId: accountId, email: email, avatarUrl: avatarUrl, profileUrl: profileUrl, jobTitle: jobTitle, department: department, location: location, time: time })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { cloudId: cloudId, orgId: orgId, isHello: isHello, sessionId: sessionId } = commonAttributes;
    const showAITopics = (0, $iDrrr.fg)('kd_topics_in_person_card');
    const { profileHref: profileHref, profileOnNavigate: profileOnNavigate } = (0, $66eSg.useTeamsAppLinks)({
        type: (0, $9T3jg.KnowledgeCardsIntentType).PERSON,
        currentUserId: accountId ?? '',
        cloudId: cloudId
    });
    const [isOrgChartModalOpen, setIsOrgChartModalOpen] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        let dwellTimeout;
        if (isOrgChartModalOpen) dwellTimeout = setTimeout(()=>{
            fireAnalyticsEvent((0, $3872290fc8ee5c0c$export$c275ac680f034541)(commonAttributes));
        }, $46d8c915edc11e65$var$ORG_CHART_DWELL_THRESHOLD);
        return ()=>{
            clearTimeout(dwellTimeout);
        };
    }, [
        isOrgChartModalOpen,
        fireAnalyticsEvent,
        commonAttributes
    ]);
    const subText = [
        jobTitle,
        department
    ].filter((text)=>!!text).join(', ');
    const trimmedSubText = subText.length > 250 ? `${subText.slice(0, 250)}...` : subText;
    const orgText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, trimmedSubText);
    const timeAndLocationComponent = (location || time) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $46d8c915edc11e65$var$IconPaddingStyles.default
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hS5Ee))), {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050"
    }, location && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, location), time && location && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, "\u2022"), time && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, time))));
    const additionalInfo = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, timeAndLocationComponent, showAITopics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hgyck.KnowledgeCardsTopics), {
        cloudId: cloudId,
        userId: accountId ?? '',
        userName: name,
        sessionId: sessionId,
        v2styles: true
    }));
    const media = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c8bcd61e8797d6ff$export$7f0e56320ea6e6ee), {
        src: avatarUrl || '',
        alt: ""
    });
    const handleLinkClick = (e)=>{
        if ((0, $iDrrr.fg)('platform-adopt-teams-nav-config')) profileOnNavigate(e);
    };
    const openOrgChartModal = ()=>{
        setIsOrgChartModalOpen(true);
        fireAnalyticsEvent((0, $7da0ee0a7cbf02fe$export$4dea9d9ba0f4fd15)(commonAttributes));
    };
    const closeOrgChartModal = ()=>setIsOrgChartModalOpen(false);
    const orgChartButton = (isHello || (0, $iDrrr.fg)('kd_person_card_org_chart_button')) && accountId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eleTd))),
        label: formatMessage((0, $cb86z.messages).knowledge_cards_person_org_chart_label),
        isTooltipDisabled: false,
        onClick: openOrgChartModal,
        testId: "person-card-org-chart-button"
    }) : null;
    const ClickWrapper = ({ children: children, userId: userId })=>// eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: `${userId}-org-chart-card`,
            onClick: ()=>{
                fireAnalyticsEvent((0, $2a40d322081356a1$export$3014182e23d6ae90)(commonAttributes));
            }
        }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff2c12cd5348c884$export$c7c90b1402552129), {
        name: name,
        email: email,
        profileUrl: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : profileUrl || '',
        profileLinkText: formatMessage((0, $cb86z.messages).ai_answer_who_questions_view_profile),
        media: media,
        orgText: orgText,
        additionalInfo: additionalInfo,
        onLinkClick: handleLinkClick,
        headerActions: orgChartButton,
        testId: "person-knowledge-card-header"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, accountId && isOrgChartModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: closeOrgChartModal,
        testId: "person-card-org-chart-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, formatMessage((0, $cb86z.messages).knowledge_cards_person_org_chart_modal_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c966fff235fbed6e$export$2e2bcd8739ae039), {
        userId: accountId,
        product: "personKnowledgeCardOrgChart",
        cloudId: cloudId,
        orgId: orgId,
        WrappedWithProfilecard: ClickWrapper
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null))));
};


/**
 * @generated SignedSource<<35c2bcb8915a946cd54acd300e703750>>
 * @relayHash cee8aef42c4809bf7b8650e7551b3954
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 181cde876f75df92feb4611c6fe60fe79917211ed1f2052dda73533c7ff2635e
const $be09551daefe9379$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "recommendationsQuery"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "reportingLinesAaid"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "reportingLinesOrgId"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "reportingLinesSiteId"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "singleUserAccountId"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "singleUserRequestingUserId"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "singleUserTenantId"
    }, v9 = [
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v10 = [
        {
            "kind": "Variable",
            "name": "recommendationsQuery",
            "variableName": "recommendationsQuery"
        }
    ], v11 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "singleUserAccountId"
        },
        {
            "kind": "Variable",
            "name": "requestingUserId",
            "variableName": "singleUserRequestingUserId"
        },
        {
            "kind": "Variable",
            "name": "tenantId",
            "variableName": "singleUserTenantId"
        }
    ], v12 = [
        {
            "kind": "Variable",
            "name": "aaid",
            "variableName": "reportingLinesAaid"
        },
        {
            "kind": "Variable",
            "name": "orgId",
            "variableName": "reportingLinesOrgId"
        },
        {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "reportingLinesSiteId"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v14 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v14 /*: any*/ 
            }
        ],
        "type": "ConfluencePage"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceBlogPostLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v14 /*: any*/ 
            }
        ],
        "type": "ConfluenceBlogPost"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v14 /*: any*/ 
            }
        ],
        "type": "ConfluenceWhiteboard"
    }, v18 = {
        "kind": "ScalarField",
        "name": "id"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            v18 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v20 = [
        {
            "concreteType": "ConfluenceCommentLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": v14 /*: any*/ 
        },
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v13 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v19 /*: any*/ 
            ]
        }
    ], v21 = {
        "kind": "ScalarField",
        "name": "url"
    }, v22 = [
        v21 /*: any*/ 
    ], v23 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v24 = [
        v23 /*: any*/ ,
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": [
                v23 /*: any*/ ,
                v18 /*: any*/ 
            ]
        }
    ], v25 = [
        {
            "alias": "trelloUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v26 = [
        {
            "alias": "webUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v27 = [
        v21 /*: any*/ ,
        v18 /*: any*/ 
    ], v28 = [
        {
            "concreteType": "AssetsLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "web"
                }
            ]
        }
    ], v29 = {
        "kind": "ScalarField",
        "name": "name"
    }, v30 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v31 = {
        "kind": "ScalarField",
        "name": "email"
    }, v32 = {
        "kind": "ScalarField",
        "name": "jobTitle"
    }, v33 = [
        v32 /*: any*/ 
    ], v34 = [
        {
            "kind": "ScalarField",
            "name": "accountIdentifier"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfDirectReports"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfTotalReports"
        },
        {
            "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
            "kind": "LinkedField",
            "name": "pii",
            "plural": false,
            "selections": [
                v29 /*: any*/ ,
                v30 /*: any*/ ,
                {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
                    "kind": "LinkedField",
                    "name": "extendedProfile",
                    "plural": false,
                    "selections": v33 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "singlePersonKnowledgeCardRelayQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "ActivityConnection",
                            "kind": "LinkedField",
                            "name": "workedOn",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "singlePersonKnowledgeCardRelay_workedOn"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "SmartsQueryApi",
                    "kind": "LinkedField",
                    "name": "smarts",
                    "plural": false,
                    "selections": [
                        {
                            "args": v10 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "singlePersonKnowledgeCardRelay_smarts"
                        }
                    ]
                },
                {
                    "concreteType": "KnowledgeDiscoveryQueryApi",
                    "kind": "LinkedField",
                    "name": "knowledgeDiscovery",
                    "plural": false,
                    "selections": [
                        {
                            "args": v11 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "singlePersonKnowledgeCardRelay_user"
                        },
                        {
                            "args": v12 /*: any*/ ,
                            "kind": "FragmentSpread",
                            "name": "singlePersonKnowledgeCardRelay_reportingLines"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "singlePersonKnowledgeCardRelayQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "ActivityConnection",
                            "kind": "LinkedField",
                            "name": "workedOn",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ActivityItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ActivityObject",
                                                    "kind": "LinkedField",
                                                    "name": "object",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "data",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ ,
                                                                v15 /*: any*/ ,
                                                                v16 /*: any*/ ,
                                                                v17 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ConfluenceDatabaseLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": v14 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ConfluenceDatabase"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ConfluenceEmbedLinks",
                                                                            "kind": "LinkedField",
                                                                            "name": "links",
                                                                            "plural": false,
                                                                            "selections": v14 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ConfluenceEmbed"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v20 /*: any*/ ,
                                                                    "type": "ConfluenceFooterComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v20 /*: any*/ ,
                                                                    "type": "ConfluenceInlineComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "TownsquareGoal"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "TownsquareProject"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "TownsquareComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v23 /*: any*/ 
                                                                    ],
                                                                    "type": "JiraIssue"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v24 /*: any*/ ,
                                                                    "type": "JiraPlatformComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v24 /*: any*/ ,
                                                                    "type": "JiraServiceManagementComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v25 /*: any*/ ,
                                                                    "type": "TrelloBoard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v25 /*: any*/ ,
                                                                    "type": "TrelloCard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v26 /*: any*/ ,
                                                                    "type": "DevOpsDocument"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "ExternalDocument"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v27 /*: any*/ ,
                                                                    "type": "DevOpsPullRequestDetails"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "ExternalPullRequest"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v26 /*: any*/ ,
                                                                    "type": "DevOpsDesign"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "ExternalRemoteLink"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "MercuryFocusArea"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v27 /*: any*/ ,
                                                                    "type": "MercuryPortfolio"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "RadarPosition"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "RadarView"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v22 /*: any*/ ,
                                                                    "type": "CompassComponent"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "href"
                                                                        }
                                                                    ],
                                                                    "type": "BitbucketPullRequest"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": "loomUrl",
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ],
                                                                    "type": "LoomVideo"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v28 /*: any*/ ,
                                                                    "type": "AssetsObject"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v28 /*: any*/ ,
                                                                    "type": "AssetsObjectType"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": v28 /*: any*/ ,
                                                                    "type": "AssetsSchema"
                                                                },
                                                                v19 /*: any*/ 
                                                            ]
                                                        },
                                                        v18 /*: any*/ 
                                                    ]
                                                },
                                                v18 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "SmartsQueryApi",
                    "kind": "LinkedField",
                    "name": "smarts",
                    "plural": false,
                    "selections": [
                        {
                            "args": v10 /*: any*/ ,
                            "concreteType": "SmartsRecommendedUser",
                            "kind": "LinkedField",
                            "name": "recommendedUser",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "accountId"
                                        },
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v31 /*: any*/ ,
                                                {
                                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                                    "kind": "LinkedField",
                                                    "name": "extendedProfile",
                                                    "plural": false,
                                                    "selections": v33 /*: any*/ 
                                                }
                                            ],
                                            "type": "AtlassianAccountUser"
                                        },
                                        v18 /*: any*/ 
                                    ]
                                },
                                v18 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "KnowledgeDiscoveryQueryApi",
                    "kind": "LinkedField",
                    "name": "knowledgeDiscovery",
                    "plural": false,
                    "selections": [
                        {
                            "args": v11 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "singleUser",
                            "plural": false,
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "KnowledgeDiscoveryUserProfile",
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                v29 /*: any*/ ,
                                                v30 /*: any*/ ,
                                                v31 /*: any*/ ,
                                                v32 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "department"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "location"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "organization"
                                                },
                                                {
                                                    "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                                                    "kind": "LinkedField",
                                                    "name": "thirdPartyIntegrations",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "externalId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "integrationId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "product"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "KnowledgeDiscoverySingleUser"
                                }
                            ]
                        },
                        {
                            "args": v12 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "reportingLines",
                            "plural": false,
                            "selections": [
                                v13 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": v34 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                            "kind": "LinkedField",
                                            "name": "managers",
                                            "plural": true,
                                            "selections": v34 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                            "kind": "LinkedField",
                                            "name": "reports",
                                            "plural": true,
                                            "selections": v34 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                            "kind": "LinkedField",
                                            "name": "peers",
                                            "plural": true,
                                            "selections": v34 /*: any*/ 
                                        }
                                    ],
                                    "type": "KnowledgeDiscoveryReportingLines"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "181cde876f75df92feb4611c6fe60fe79917211ed1f2052dda73533c7ff2635e",
            "metadata": {},
            "name": "singlePersonKnowledgeCardRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$be09551daefe9379$var$node.hash = "3b96d2345c405f05720744ecd857cd6a";
var $be09551daefe9379$export$2e2bcd8739ae039 = $be09551daefe9379$var$node;






var $6SsN4 = parcelRequire("6SsN4");


var $kTGj5 = parcelRequire("kTGj5");




/**
 * @generated SignedSource<<942a6fcca9c99ab8b7c4808afef95d2a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $eee0f08de115290a$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "accountIdentifier"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfDirectReports"
        },
        {
            "kind": "ScalarField",
            "name": "numberOfTotalReports"
        },
        {
            "concreteType": "KnowledgeDiscoveryReportingLinesUserPII",
            "kind": "LinkedField",
            "name": "pii",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "picture"
                },
                {
                    "concreteType": "KnowledgeDiscoveryReportingLinesUserExtendedProfile",
                    "kind": "LinkedField",
                    "name": "extendedProfile",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "jobTitle"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "aaid"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "orgId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "siteId"
            }
        ],
        "kind": "Fragment",
        "name": "singlePersonKnowledgeCardRelay_reportingLines",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "aaid",
                        "variableName": "aaid"
                    },
                    {
                        "kind": "Variable",
                        "name": "orgId",
                        "variableName": "orgId"
                    },
                    {
                        "kind": "Variable",
                        "name": "siteId",
                        "variableName": "siteId"
                    }
                ],
                "kind": "LinkedField",
                "name": "reportingLines",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": v0 /*: any*/ 
                            },
                            {
                                "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                "kind": "LinkedField",
                                "name": "managers",
                                "plural": true,
                                "selections": v0 /*: any*/ 
                            },
                            {
                                "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                "kind": "LinkedField",
                                "name": "reports",
                                "plural": true,
                                "selections": v0 /*: any*/ 
                            },
                            {
                                "concreteType": "KnowledgeDiscoveryReportingLinesUser",
                                "kind": "LinkedField",
                                "name": "peers",
                                "plural": true,
                                "selections": v0 /*: any*/ 
                            }
                        ],
                        "type": "KnowledgeDiscoveryReportingLines"
                    }
                ]
            }
        ],
        "type": "KnowledgeDiscoveryQueryApi"
    };
}();
$eee0f08de115290a$var$node.hash = "39f148778c4afeaf5cb148a80dda3216";
var $eee0f08de115290a$export$2e2bcd8739ae039 = $eee0f08de115290a$var$node;


/**
 * @generated SignedSource<<add60e1b72821839e1e75acab7f1460b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ba33f4e727d0804$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "recommendationsQuery"
        }
    ],
    "kind": "Fragment",
    "name": "singlePersonKnowledgeCardRelay_smarts",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "recommendationsQuery",
                    "variableName": "recommendationsQuery"
                }
            ],
            "concreteType": "SmartsRecommendedUser",
            "kind": "LinkedField",
            "name": "recommendedUser",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "picture"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "email"
                                },
                                {
                                    "concreteType": "AtlassianAccountUserExtendedProfile",
                                    "kind": "LinkedField",
                                    "name": "extendedProfile",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "jobTitle"
                                        }
                                    ]
                                }
                            ],
                            "type": "AtlassianAccountUser"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "SmartsQueryApi"
};
$6ba33f4e727d0804$var$node.hash = "28c563bfe5ced2c4dbd6c2c333de65db";
var $6ba33f4e727d0804$export$2e2bcd8739ae039 = $6ba33f4e727d0804$var$node;


/**
 * @generated SignedSource<<329ebe2174b6fc6e11dfc526241ea5c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $727e3fba3b87bad8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v2 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v1 /*: any*/ 
            }
        ],
        "type": "ConfluencePage"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceBlogPostLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v1 /*: any*/ 
            }
        ],
        "type": "ConfluenceBlogPost"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v1 /*: any*/ 
            }
        ],
        "type": "ConfluenceWhiteboard"
    }, v5 = [
        {
            "concreteType": "ConfluenceCommentLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": v1 /*: any*/ 
        },
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ]
        }
    ], v6 = [
        {
            "kind": "ScalarField",
            "name": "url"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v8 = [
        v7 /*: any*/ 
    ], v9 = [
        v7 /*: any*/ ,
        {
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issue",
            "plural": false,
            "selections": v8 /*: any*/ 
        }
    ], v10 = [
        {
            "alias": "trelloUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v11 = [
        {
            "alias": "webUrl",
            "kind": "ScalarField",
            "name": "url"
        }
    ], v12 = [
        {
            "concreteType": "AssetsLinks",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "web"
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "singlePersonKnowledgeCardRelay_workedOn",
        "selections": [
            {
                "concreteType": "ActivityItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "ActivityNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ActivityObject",
                                "kind": "LinkedField",
                                "name": "object",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "data",
                                        "plural": false,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            v2 /*: any*/ ,
                                            v3 /*: any*/ ,
                                            v4 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "concreteType": "ConfluenceDatabaseLinks",
                                                        "kind": "LinkedField",
                                                        "name": "links",
                                                        "plural": false,
                                                        "selections": v1 /*: any*/ 
                                                    }
                                                ],
                                                "type": "ConfluenceDatabase"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "concreteType": "ConfluenceEmbedLinks",
                                                        "kind": "LinkedField",
                                                        "name": "links",
                                                        "plural": false,
                                                        "selections": v1 /*: any*/ 
                                                    }
                                                ],
                                                "type": "ConfluenceEmbed"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v5 /*: any*/ ,
                                                "type": "ConfluenceFooterComment"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v5 /*: any*/ ,
                                                "type": "ConfluenceInlineComment"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "TownsquareGoal"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "TownsquareProject"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "TownsquareComment"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v8 /*: any*/ ,
                                                "type": "JiraIssue"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v9 /*: any*/ ,
                                                "type": "JiraPlatformComment"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v9 /*: any*/ ,
                                                "type": "JiraServiceManagementComment"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v10 /*: any*/ ,
                                                "type": "TrelloBoard"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v10 /*: any*/ ,
                                                "type": "TrelloCard"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v11 /*: any*/ ,
                                                "type": "DevOpsDocument"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "ExternalDocument"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "DevOpsPullRequestDetails"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "ExternalPullRequest"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v11 /*: any*/ ,
                                                "type": "DevOpsDesign"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "ExternalRemoteLink"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "MercuryFocusArea"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "MercuryPortfolio"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "RadarPosition"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "RadarView"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v6 /*: any*/ ,
                                                "type": "CompassComponent"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "href"
                                                    }
                                                ],
                                                "type": "BitbucketPullRequest"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "alias": "loomUrl",
                                                        "kind": "ScalarField",
                                                        "name": "url"
                                                    }
                                                ],
                                                "type": "LoomVideo"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v12 /*: any*/ ,
                                                "type": "AssetsObject"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v12 /*: any*/ ,
                                                "type": "AssetsObjectType"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": v12 /*: any*/ ,
                                                "type": "AssetsSchema"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "ActivityConnection"
    };
}();
$727e3fba3b87bad8$var$node.hash = "6cdfa05c014885d351d287fd9d7b82fd";
var $727e3fba3b87bad8$export$2e2bcd8739ae039 = $727e3fba3b87bad8$var$node;


/**
 * @generated SignedSource<<22dafd04d97ca73d62d23d3cc4ccedb7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e46448ac261f2dd1$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "requestingUserId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "tenantId"
        }
    ],
    "kind": "Fragment",
    "name": "singlePersonKnowledgeCardRelay_user",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                },
                {
                    "kind": "Variable",
                    "name": "requestingUserId",
                    "variableName": "requestingUserId"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "tenantId"
                }
            ],
            "kind": "LinkedField",
            "name": "singleUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "concreteType": "KnowledgeDiscoveryUserProfile",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "picture"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "email"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "jobTitle"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "department"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "location"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "organization"
                                },
                                {
                                    "concreteType": "KnowledgeDiscoveryThirdPartyIntegration",
                                    "kind": "LinkedField",
                                    "name": "thirdPartyIntegrations",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "externalId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "integrationId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "product"
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "type": "KnowledgeDiscoverySingleUser"
                }
            ]
        }
    ],
    "type": "KnowledgeDiscoveryQueryApi"
};
$e46448ac261f2dd1$var$node.hash = "6ce4ebed91636a0266cbdadf5eac8632";
var $e46448ac261f2dd1$export$2e2bcd8739ae039 = $e46448ac261f2dd1$var$node;









var $kvxgH = parcelRequire("kvxgH");








/**
 * Same as recent-work-client Flight Deck hydrator: `url: ['links.base', 'links.webUi']`
 * resolved with `hydratedValueToString` → `join('')` (plain concat, not `new URL`).
 */ function $b61a377fe745300a$export$4f8728684e01b4ef(base, webUi) {
    return `${base ?? ''}${webUi ?? ''}`;
}


/**
 * Derives a canonical URL for a recent-activity object, covering every
 * URL-bearing activity type returned by the full profile-page query. Returns
 * an empty string when the object type has no resolvable URL.
 */ function $930b2ed464e2fa0e$var$extractActivityUrl(objectData) {
    if (!objectData) return '';
    switch(objectData.__typename){
        case 'ConfluencePage':
        case 'ConfluenceBlogPost':
        case 'ConfluenceWhiteboard':
        case 'ConfluenceDatabase':
        case 'ConfluenceEmbed':
        case 'ConfluenceFooterComment':
        case 'ConfluenceInlineComment':
            return objectData.links?.base && objectData.links?.webUi ? (0, $b61a377fe745300a$export$4f8728684e01b4ef)(objectData.links.base, objectData.links.webUi) : '';
        case 'JiraIssue':
        case 'JiraPlatformComment':
        case 'JiraServiceManagementComment':
        case 'DevOpsDocument':
        case 'DevOpsDesign':
            return objectData.webUrl ?? '';
        case 'TrelloBoard':
        case 'TrelloCard':
            return objectData.trelloUrl ?? '';
        case 'TownsquareGoal':
        case 'TownsquareProject':
        case 'TownsquareComment':
        case 'ExternalDocument':
        case 'DevOpsPullRequestDetails':
        case 'ExternalPullRequest':
        case 'ExternalRemoteLink':
        case 'MercuryFocusArea':
        case 'MercuryPortfolio':
        case 'RadarPosition':
        case 'RadarView':
        case 'CompassComponent':
            return objectData.url ?? '';
        case 'BitbucketPullRequest':
            return objectData.href ?? '';
        case 'LoomVideo':
            return objectData.loomUrl ?? '';
        case 'AssetsObject':
        case 'AssetsObjectType':
        case 'AssetsSchema':
            return objectData.links?.web ?? '';
        default:
            return '';
    }
}
/**
 * Computes the de-duplication key for a recent-activity object, mirroring the
 * full profile page's `deduplicateId` behaviour:
 * - Confluence comments de-duplicate on their container (page/blog/whiteboard),
 *   so multiple comments on the same page collapse to a single entry
 *   (equivalent to `deduplicateId: ['container.id']`).
 * - Jira comments de-duplicate on their parent issue
 *   (equivalent to `deduplicateId: ['issue.id']`).
 * - Everything else de-duplicates on its own URL
 *   (equivalent to `deduplicateId: ['objectId']`).
 *
 * Falls back to the object's own URL when the container/issue is unavailable.
 */ function $930b2ed464e2fa0e$var$getActivityDedupeKey(objectData) {
    const ownUrl = $930b2ed464e2fa0e$var$extractActivityUrl(objectData);
    if (!objectData) return ownUrl;
    switch(objectData.__typename){
        case 'ConfluenceFooterComment':
        case 'ConfluenceInlineComment':
            {
                const container = objectData.container;
                const containerUrl = container && 'links' in container && container.links?.base && container.links?.webUi ? (0, $b61a377fe745300a$export$4f8728684e01b4ef)(container.links.base, container.links.webUi) : '';
                return containerUrl || ownUrl;
            }
        case 'JiraPlatformComment':
        case 'JiraServiceManagementComment':
            return objectData.issue?.webUrl || ownUrl;
        default:
            return ownUrl;
    }
}
function $930b2ed464e2fa0e$export$1b2f203bdf0d1ed4(data) {
    // De-duplicate by the profile page's `deduplicateId` key (comments collapse
    // onto their container/issue), keeping the first occurrence, then resolve
    // each survivor to its display URL.
    const seenKeys = new Set();
    const result = [];
    for (const edge of data.edges){
        const objectData = edge?.node?.object?.data;
        const url = $930b2ed464e2fa0e$var$extractActivityUrl(objectData);
        if (!url) continue;
        const dedupeKey = $930b2ed464e2fa0e$var$getActivityDedupeKey(objectData);
        if (seenKeys.has(dedupeKey)) continue;
        seenKeys.add(dedupeKey);
        result.push(url);
    }
    return result;
}
/** `user` / `managers` / `reports` rows — same shape as `singlePersonKnowledgeCardRelay_reportingLines` fragment data. */ function $930b2ed464e2fa0e$var$mapKdReportingLinesUser(u) {
    if (!u?.accountIdentifier) return null;
    return {
        accountId: u.accountIdentifier,
        name: u.pii?.name ?? '',
        avatarUrl: u.pii?.picture ?? null,
        jobTitle: u.pii?.extendedProfile?.jobTitle ?? null,
        numberOfDirectReports: u.numberOfDirectReports ?? undefined,
        numberOfTotalReports: u.numberOfTotalReports ?? undefined
    };
}
function $930b2ed464e2fa0e$export$c698f9fc75f3cde8(data) {
    if (!data?.reportingLines) return undefined;
    const rl = data.reportingLines;
    if (rl.__typename !== 'KnowledgeDiscoveryReportingLines') return undefined;
    const user = $930b2ed464e2fa0e$var$mapKdReportingLinesUser(rl.user);
    if (!user) return undefined;
    const managers = (rl.managers ?? []).map((manager)=>$930b2ed464e2fa0e$var$mapKdReportingLinesUser(manager)).filter((manager)=>manager != null);
    const reports = rl.reports?.map((report)=>$930b2ed464e2fa0e$var$mapKdReportingLinesUser(report)).filter((report)=>report != null) ?? [];
    const peers = rl.peers?.map((peer)=>$930b2ed464e2fa0e$var$mapKdReportingLinesUser(peer)).filter((peer)=>peer != null) ?? [];
    return {
        managers: managers.length ? managers : undefined,
        user: user,
        reports: reports.length ? reports : undefined,
        peers: peers.length ? peers : undefined
    };
}
function $930b2ed464e2fa0e$export$2161bdc2400ab463(data, accountId) {
    const recommended = data.recommendedUser ?? [];
    if (!recommended.length) return [];
    return recommended.reduce((acc, node)=>{
        const user = node?.user;
        if (!user) return acc;
        const id = user.accountId;
        if (!id || accountId && id === accountId) return acc;
        acc.push({
            accountId: id ?? null,
            name: user.name ?? null,
            avatarUrl: user.picture ?? null,
            email: user.email ?? null,
            jobTitle: user.extendedProfile?.jobTitle ?? null
        });
        return acc;
    }, []);
}
function $930b2ed464e2fa0e$export$2a6e620fcada89b7({ userFragment: userFragment, workedOnFragment: workedOnFragment, smartsFragment: smartsFragment, reportingLinesFragment: reportingLinesFragment, ...props }) {
    const userProfileData = (0, $6SsN4.useFragment)((0, $e46448ac261f2dd1$export$2e2bcd8739ae039), userFragment ?? null);
    const workedOnData = (0, $6SsN4.useFragment)((0, $727e3fba3b87bad8$export$2e2bcd8739ae039), workedOnFragment ?? null);
    const smartsData = (0, $6SsN4.useFragment)((0, $6ba33f4e727d0804$export$2e2bcd8739ae039), smartsFragment ?? null);
    const reportingLinesData = (0, $6SsN4.useFragment)((0, $eee0f08de115290a$export$2e2bcd8739ae039), reportingLinesFragment ?? null);
    const relayHierarchyData = (0, $cozmU.useMemo)(()=>$930b2ed464e2fa0e$export$c698f9fc75f3cde8(reportingLinesData), [
        reportingLinesData
    ]);
    const recentWorkData = (0, $cozmU.useMemo)(()=>{
        if (!workedOnData) return undefined;
        const mapped = $930b2ed464e2fa0e$export$1b2f203bdf0d1ed4(workedOnData);
        return mapped.length ? mapped : undefined;
    }, [
        workedOnData
    ]);
    const relayProfileData = (0, $cozmU.useMemo)(()=>{
        const result = userProfileData?.singleUser;
        if (!result || result.__typename !== 'KnowledgeDiscoverySingleUser') return undefined;
        const user = result.user;
        if (!user?.id) return undefined;
        return {
            accountId: user.id,
            name: user.name ?? '',
            avatarUrl: user.picture ?? null,
            email: user.email ?? null,
            jobTitle: user.jobTitle ?? null,
            department: user.department ?? null,
            location: user.location ?? null,
            organization: user.organization ?? null,
            thirdPartyIntegrations: user.thirdPartyIntegrations?.map((integration)=>({
                    externalId: integration.externalId,
                    integrationId: integration.integrationId,
                    product: integration.product
                })) ?? null
        };
    }, [
        userProfileData
    ]);
    const relayCollaborators = (0, $cozmU.useMemo)(()=>{
        if (!smartsData) return undefined;
        const mapped = $930b2ed464e2fa0e$export$2161bdc2400ab463(smartsData, relayProfileData?.accountId);
        return mapped.length ? mapped : undefined;
    }, [
        smartsData,
        relayProfileData?.accountId
    ]);
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const hasFiredLoadedEventRef = (0, $cozmU.useRef)(false);
    const resolvedProfileData = relayProfileData ?? props.profileData;
    const hasResolvedProfile = Boolean(resolvedProfileData?.name || resolvedProfileData?.accountId);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredLoadedEventRef.current || !hasResolvedProfile) return;
        hasFiredLoadedEventRef.current = true;
        fireAnalyticsEvent((0, $2c764823b2ef4dc8$export$c59cd1b0c182839c)({
            ...commonAttributes,
            personCardVariant: 'singlePerson'
        }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasResolvedProfile
    ]);
    if (!hasResolvedProfile) throw new Error('SAIN SinglePersonKnowledgeCard: no user profile data resolved');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvxgH.UserProfilePreview), {
        ...props,
        profileData: resolvedProfileData,
        hierarchyData: relayHierarchyData ?? props.hierarchyData,
        recentWorkData: recentWorkData,
        collaborators: relayCollaborators ?? props.collaborators
    });
}


function $70ed9c87fe720217$var$buildSiteAri(cloudId, sourceProduct) {
    if (sourceProduct) return `ari:cloud:${sourceProduct}::site/${cloudId}`;
    return cloudId;
}
/**
 * Builds the collaboration-context ARI used to scope the recent-work (`workedOn`)
 * query to the origin site, so activity from other sites the person belongs to is
 * not returned. Returns `null` when the site ID is missing or invalid so the query
 * safely falls back to unscoped behaviour.
 */ function $70ed9c87fe720217$var$buildCollabContextId(cloudId) {
    if (!cloudId) return null;
    try {
        return (0, $kTGj5.PlatformSiteAri).create({
            siteId: cloudId
        }).toString();
    } catch  {
        return null;
    }
}
function $70ed9c87fe720217$export$2e495c58d0c267e2(props) {
    const { accountId: accountId, cloudId: cloudId, orgId: orgId, requestingUserId: requestingUserId, sourceProduct: sourceProduct, onLinkClick: onLinkClick } = props;
    const accountIdARI = `ari:cloud:identity::user/${accountId}`;
    const featureServiceModel = (0, $7DMz5.SAINFeatureControl).getCollabGraphExperimentModel();
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $be09551daefe9379$export$2e2bcd8739ae039), {
        first: 50,
        singleUserAccountId: accountId,
        singleUserRequestingUserId: requestingUserId,
        singleUserTenantId: cloudId,
        filter: {
            actors: [
                accountIdARI
            ],
            collabContextId: $70ed9c87fe720217$var$buildCollabContextId(cloudId)
        },
        recommendationsQuery: {
            context: {
                userId: accountId,
                tenantId: cloudId
            },
            modelRequestParams: {
                caller: 'search-ai',
                experience: 'CgUserNearbyUser',
                featureServiceModel: featureServiceModel
            },
            requestingUserId: requestingUserId,
            maxNumberOfResults: 8
        },
        reportingLinesAaid: accountId,
        reportingLinesOrgId: orgId,
        reportingLinesSiteId: $70ed9c87fe720217$var$buildSiteAri(cloudId, sourceProduct)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $930b2ed464e2fa0e$export$2a6e620fcada89b7), {
        userFragment: data.knowledgeDiscovery ?? undefined,
        workedOnFragment: data.activity?.workedOn ?? undefined,
        smartsFragment: data.smarts ?? undefined,
        reportingLinesFragment: data.knowledgeDiscovery ?? undefined,
        cloudId: cloudId,
        orgId: orgId,
        siteId: $70ed9c87fe720217$var$buildSiteAri(cloudId, sourceProduct),
        requestingUserId: requestingUserId,
        testId: "individual-person-knowledge-card",
        onLinkClick: onLinkClick
    });
}


const $da688014b5e1873c$var$CardContainerStyles = {
    refresh: "_0bjKvDKxmn _2mHwu85zaO _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0Of8r25zaO _1wydGW5zaO",
    disclaimer: "_2Zuz6Q5zaO _1Znuxb5zaO"
};
const $da688014b5e1873c$var$PersonCardWrapperStyles = {
    default: "_39xV02WD6W _39HuIbz8Lp _1ANEUSzUZr",
    flex: "_1bHrqEWD6W _2O5VijdnbC _3YEZNOdnbC",
    inlineWrapper: "_39xV02N91d _0wOv4Q7zJH"
};
const $da688014b5e1873c$var$USERS_SCROLL_OFFSET = 392;
const $da688014b5e1873c$var$messages = (0, $kSwu1.defineMessages)({
    multiple_people_matches_header: {
        id: "search_ai.knowledge_cards.multiple_people_matches_header",
        defaultMessage: "People matches"
    },
    ai_answer_component_topics_not_relevant_checkbox_label: {
        id: "search_ai.ai_answer_component_topics_not_relevant_checkbox_label",
        defaultMessage: "The topics are not relevant to this person."
    }
});
const $da688014b5e1873c$var$IndividualPersonKnowledgeCard = ({ primaryUser: primaryUser })=>{
    if (!primaryUser) return null;
    const showKnowledgeCardBody = (primaryUser?.recentActivity?.length || 0) > 0 || (primaryUser?.collaborators?.length || 0) > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $da688014b5e1873c$var$CardContainerStyles.refresh,
        testId: "individual-person-knowledge-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $46d8c915edc11e65$export$d1ac32de8e31f333), {
        accountId: primaryUser.account_id,
        name: primaryUser.name,
        email: primaryUser.email,
        avatarUrl: primaryUser.avatar_url,
        profileUrl: primaryUser.profile_url,
        jobTitle: primaryUser.job_title,
        department: primaryUser.department,
        location: primaryUser.location,
        time: primaryUser.time
    }), showKnowledgeCardBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8ba51f29bf3689a9$export$4fb305a2fc986af3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, showKnowledgeCardBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3ffa4c5e2a30b7df$export$2460aa15a0a1d61e), {
        currentUserId: primaryUser.account_id ?? '',
        recommendedUsers: primaryUser.collaborators || [],
        recentActivity: primaryUser.recentActivity || [],
        profileUrl: primaryUser.profile_url || ''
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $da688014b5e1873c$var$CardContainerStyles.disclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true
    })))));
};
const $da688014b5e1873c$export$8cdcd522f66fdfa8 = ({ onFMPReached: onFMPReached })=>{
    const { commonAttributes: commonAttributes, userDetails: { id: requestingUserId }, setData: setData, sourceProduct: sourceProduct, loading: loading, traceHeaders: traceHeaders } = (0, $3hVWe.useAIAnswerContext)();
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const activityClient = (0, $k8VpS.useActivityClient)('v3', 'people');
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [selectedUser, setSelectedUser] = (0, $cozmU.useState)();
    const [primaryUser, setPrimaryUser] = (0, $cozmU.useState)();
    const { answerString: answerString, cloudId: cloudId, orgId: orgId, workspaceId: workspaceId } = commonAttributes;
    const [isPersonCardLoading, setIsPersonCardLoading] = (0, $cozmU.useState)(false);
    const shouldRenderPTPersonUX = (0, $7DMz5.SAINFeatureControl).isPeopleConnectorUXEnabled();
    const userResults = (0, $d325f5b9eeee6e40$export$d905ae2a714518e8)({
        answerString: answerString
    }).parsedResult;
    const getHandleSelectUser = (0, $cozmU.useCallback)((index)=>()=>{
            setSelectedUser(index);
            if ((0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).PERSON_SELECTED,
                commonAttributes: commonAttributes
            });
        }, [
        commonAttributes,
        fireSAINUsageEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (userResults.length === 1) setSelectedUser(0);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        userResults
    ]);
    (0, $cozmU.useEffect)(()=>{
        const fetchData = async ()=>{
            if (!shouldRenderPTPersonUX && selectedUser !== undefined) {
                setIsPersonCardLoading(true);
                return (0, $634e333e90210143$export$3e632a26e137d79e)({
                    accountId: userResults[selectedUser].id,
                    tenantId: cloudId,
                    requestingUserId: requestingUserId || '',
                    activityClient: activityClient,
                    locale: locale,
                    workspaceId: workspaceId,
                    product: sourceProduct ?? '',
                    traceHeaders: traceHeaders
                }).then((data)=>{
                    setPrimaryUser(data);
                }).catch((error)=>{
                    setData({
                        errorState: (0, $htnqN.NLPSearchErrorState).NetworkError,
                        disclaimer: null,
                        format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                        nlpResults: [],
                        uniqueSources: [],
                        nlpFollowUpResults: null
                    });
                    if ((0, $iDrrr.fg)('kd_enable_networkerror_logging')) (0, $cuvLu.logger).error({
                        error: error,
                        functionName: 'fetchPrimaryUserData: PersonKnowledgeCard'
                    });
                }).finally(()=>{
                    setIsPersonCardLoading(false);
                });
            }
        };
        fetchData(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedUser,
        shouldRenderPTPersonUX
    ]);
    (0, $cozmU.useEffect)(()=>{
        onFMPReached?.();
        fireAnalyticsEvent((0, $19a6060145576e12$export$44d9aa4134474084)({
            ...commonAttributes,
            cardType: (0, $9T3jg.KnowledgeCardsIntentType).PERSON
        })); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Fire a one-shot `aiAnswerPersonKnowledgeCard loaded` track event when the multi-person
    // `UserInlinePreviewList` variant is rendered. `success` reflects whether non-empty rows
    // were returned. Mirrors the `singlePerson` variant event fired from
    // `SinglePersonKnowledgeCardRelay`, and the `userInlinePreview` operational request events
    // fired by `@atlassian/user-inline-preview` itself.
    const hasFiredMultiPersonLoadedEventRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldRenderPTPersonUX) return;
         // Single-person branch fires its own event from `SinglePersonKnowledgeCardRelay`.
        if (selectedUser !== undefined || userResults.length <= 1) return;
        if (hasFiredMultiPersonLoadedEventRef.current) return;
        hasFiredMultiPersonLoadedEventRef.current = true; // The multi-person list only renders when `userResults.length > 1`, so reaching here
        // always means a successful load — fire `success: true`.
        fireAnalyticsEvent((0, $2c764823b2ef4dc8$export$c59cd1b0c182839c)({
            ...commonAttributes,
            personCardVariant: 'multiPerson'
        }));
    }, [
        shouldRenderPTPersonUX,
        selectedUser,
        userResults,
        fireAnalyticsEvent,
        commonAttributes
    ]); // Handle recent work link clicks from the LinkList component inside UserProfilePreview.
    // Fires `aiAnswerDialog clicked` with `location: 'recent-work-item'` and `answerCardType: 'people'`
    // to match the old person card instrumentation and feed SSRv5 `aiPeopleCardClicks`.
    const handleRecentWorkLinkClick = (0, $cozmU.useCallback)((url, index, opts)=>{
        fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
            ...commonAttributes,
            location: 'recent-work-item',
            position: index,
            answerCardType: (0, $zzZbq.AnswerCardType).PERSON,
            isAuxClick: opts?.isAuxClick,
            isContextMenu: opts?.isContextMenu
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).RECENT_WORK_CLICKED,
            commonAttributes: commonAttributes
        });
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent
    ]);
    if (loading || !shouldRenderPTPersonUX && isPersonCardLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4fd6fa5a10eca60c$export$a08238eb59773648), null);
    if (userResults.length === 0) return null;
    if (selectedUser !== undefined || userResults.length === 1) {
        if (shouldRenderPTPersonUX) {
            const index = selectedUser ?? 0;
            const accountId = userResults[index]?.id;
            if (!accountId) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $016c76767add6663$export$3d5fec32962921db), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.150"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
                onError: ()=>{
                    fireAnalyticsEvent((0, $9815e23bc9044028$export$5ee3eeb70eb524d1)({
                        ...commonAttributes,
                        personCardVariant: 'singlePerson'
                    }));
                },
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kjetH.ErrorCard), null)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kEVoQ.LoadingSkeleton), null)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70ed9c87fe720217$export$2e495c58d0c267e2), {
                accountId: accountId,
                cloudId: cloudId,
                orgId: orgId,
                requestingUserId: requestingUserId || '',
                sourceProduct: sourceProduct,
                onLinkClick: handleRecentWorkLinkClick
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
                showFeedbackButtons: true
            })))));
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da688014b5e1873c$var$IndividualPersonKnowledgeCard, {
            primaryUser: primaryUser
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, shouldRenderPTPersonUX ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $016c76767add6663$export$3d5fec32962921db), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "large",
        weight: "semibold"
    }, formatMessage($da688014b5e1873c$var$messages.multiple_people_matches_header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Uv0v.UserInlinePreviewList), {
        layout: "grid",
        testId: "person-knowledge-card-user-inline-list"
    }, userResults.map((user, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: user.id,
            onClick: getHandleSelectUser(index),
            xcss: $da688014b5e1873c$var$PersonCardWrapperStyles.inlineWrapper,
            testId: `person-knowledge-card-wrapper-${user.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b5HfQ.UserInlinePreview), {
            data: {
                accountId: user.id,
                name: user.name,
                avatarUrl: user.avatarUrl ?? null,
                jobTitle: user.title ?? null
            },
            cloudId: cloudId,
            requestingUserId: requestingUserId || undefined,
            testId: `person-knowledge-card-user-inline-${user.id}`
        })))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ec82c8c1e1d8eeb1$export$61c045a5252abd1d), {
        heading: formatMessage($da688014b5e1873c$var$messages.multiple_people_matches_header),
        scrollOffset: $da688014b5e1873c$var$USERS_SCROLL_OFFSET
    }, userResults.map((user, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            onClick: getHandleSelectUser(index),
            xcss: (0, $w6R6I.cx)($da688014b5e1873c$var$PersonCardWrapperStyles.default, $da688014b5e1873c$var$PersonCardWrapperStyles.flex),
            testId: "person-knowledge-card-wrapper",
            key: user.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67cd5bff95eb1aaf$export$4c094c8f61edecb4), {
            data: {
                id: user.id,
                name: user.name,
                jobTitle: user.title ?? '',
                avatarUrl: user.avatarUrl,
                localTime: (0, $df52b12138df743d$export$b8d37f4ee3cee5b6)({
                    locale: locale,
                    zoneInfo: user.zoneInfo
                }),
                location: user.location ?? ''
            }
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true
    })));
};


/* team-knowledge-card.tsx generated by @compiled/babel-plugin v2.0.0 */ 

















var $1VhsF = parcelRequire("1VhsF");

















// Taken from https://gist.github.com/keesey/e09d0af833476385b9ee13b6d26a2b84 to avoid adding a package dependency for a single static function
function $f535bbbe86185acd$var$getEditDistance(a, b) {
    const an = a ? a.length : 0;
    const bn = b ? b.length : 0;
    if (an === 0) return bn;
    if (bn === 0) return an;
    const matrix = new Array(bn + 1);
    for(let i = 0; i <= bn; ++i){
        let row = matrix[i] = new Array(an + 1);
        row[0] = i;
    }
    const firstRow = matrix[0];
    for(let j = 1; j <= an; ++j)firstRow[j] = j;
    for(let i = 1; i <= bn; ++i){
        for(let j = 1; j <= an; ++j)if (b.charAt(i - 1) === a.charAt(j - 1)) matrix[i][j] = matrix[i - 1][j - 1];
        else matrix[i][j] = Math.min(matrix[i - 1][j - 1], matrix[i][j - 1], matrix[i - 1][j]) + 1;
    }
    return matrix[bn][an];
}
const $f535bbbe86185acd$export$ebacab8290144e11 = (query, teamName)=>{
    return $f535bbbe86185acd$var$getEditDistance(query, teamName) / query.length;
};

















































const $3676c19248632e27$export$21ff1f39b993b08e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ currentUserId: currentUserId, recommendedUsers: recommendedUsers, recentActivity: recentActivity, profileUrl: profileUrl, viewAllUrl: viewAllUrl, teamId: teamId })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { viewAllLink: viewAllLink, viewAllOnNavigate: viewAllOnNavigate, profileHref: profileHref } = (0, $66eSg.useTeamsAppLinks)({
        type: (0, $9T3jg.KnowledgeCardsIntentType).TEAM,
        currentUserId: currentUserId,
        viewAllUrl: viewAllUrl,
        cloudId: commonAttributes.cloudId,
        teamId: teamId
    });
    const handleRecentWorkViewAllClick = (e)=>{
        const isAuxClick = 'button' in e && e.button === 1;
        const isContextMenu = 'button' in e && e.button === 2;
        if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
            ...commonAttributes,
            location: 'recent-work-view-all',
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).RECENT_WORK_CLICKED,
            commonAttributes: commonAttributes
        });
        if (!isAuxClick && !isContextMenu && (0, $iDrrr.fg)('platform-adopt-teams-nav-config')) viewAllOnNavigate(e);
    };
    const handleTeamMembersViewAllClick = (e)=>{
        const isAuxClick = 'button' in e && e.button === 1;
        const isContextMenu = 'button' in e && e.button === 2;
        if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
            ...commonAttributes,
            location: 'team-members-view-all',
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).TEAM_MEMBER_CLICKED,
            commonAttributes: commonAttributes
        });
        if (!isAuxClick && !isContextMenu && (0, $iDrrr.fg)('platform-adopt-teams-nav-config')) viewAllOnNavigate(e);
    };
    // Determine which columns to render
    const hasRecentActivity = recentActivity.length > 0;
    const hasTeamMembers = recommendedUsers.length > 0;
    const columnsConfig = [
        // Recent Activity Column
        ...hasRecentActivity ? [
            {
                viewAllLinkOnClick: handleRecentWorkViewAllClick,
                viewAllLinkHref: viewAllLink,
                data: recentActivity,
                component: (0, $cce772d1072e95eb$export$65943680306d629),
                header: formatMessage((0, $cb86z.messages).knowledge_cards_recent_work_subheader),
                onClickCallback: (position, shownAfterCardBodyExpanded, opts)=>{
                    if ((opts?.isAuxClick || opts?.isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
                    fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                        ...commonAttributes,
                        location: 'recent-work-item',
                        position: position,
                        shownAfterCardBodyExpanded: shownAfterCardBodyExpanded,
                        isAuxClick: opts?.isAuxClick,
                        isContextMenu: opts?.isContextMenu
                    }));
                    fireSAINUsageEvent({
                        metCriteria: (0, $bZMnB.SainAction).RECENT_WORK_CLICKED,
                        commonAttributes: commonAttributes
                    });
                },
                searchAIAnalyticsContextLocation: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_TEAM_CARD
            }
        ] : [],
        // Team Members Column
        ...hasTeamMembers ? [
            {
                viewAllLinkOnClick: handleTeamMembersViewAllClick,
                viewAllLinkHref: viewAllLink,
                data: recommendedUsers,
                component: (0, $17582a7702efaf6e$export$87f3c1fc8ab2e681),
                onClickCallback: (position, shownAfterCardBodyExpanded, opts)=>{
                    if ((opts?.isAuxClick || opts?.isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
                    fireAnalyticsEvent((0, $3TiFP.onKnowledgeCardLinkClick)({
                        ...commonAttributes,
                        location: 'user-list-item',
                        position: position,
                        shownAfterCardBodyExpanded: shownAfterCardBodyExpanded,
                        isAuxClick: opts?.isAuxClick,
                        isContextMenu: opts?.isContextMenu
                    }));
                    fireSAINUsageEvent({
                        metCriteria: (0, $bZMnB.SainAction).TEAM_MEMBER_CLICKED,
                        commonAttributes: commonAttributes
                    });
                },
                header: formatMessage((0, $cb86z.messages).knowledge_cards_team_members_subheader)
            }
        ] : []
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $acbcdb4ca700ade0$export$ef08b123bd77f721), {
        columnsConfig: columnsConfig,
        profileUrl: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : profileUrl,
        footerButtonText: formatMessage((0, $cb86z.messages).knowledge_cards_view_team),
        footerButtonAction: (0, $bZMnB.SainAction).VIEW_TEAM_PAGE_CLICKED,
        testId: 'team-knowledge-card-body'
    });
});


/* team-card-header.tsx generated by @compiled/babel-plugin v2.0.0 */ 



















var $2c3Eq = parcelRequire("2c3Eq");














const $22e3062f2f0456b9$var$styles = {
    orgIcon: "_1Znuxb1Y8M _2Zuz6Q1Y8M"
};
const $22e3062f2f0456b9$export$972f15901814fb3d = ({ name: name, accountId: accountId, email: email, avatarUrl: avatarUrl, teamId: teamId, profileUrl: profileUrl })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { cloudId: cloudId } = commonAttributes;
    const { profileHref: profileHref, profileOnNavigate: profileOnNavigate } = (0, $66eSg.useTeamsAppLinks)({
        type: (0, $9T3jg.KnowledgeCardsIntentType).TEAM,
        currentUserId: accountId ?? '',
        cloudId: cloudId,
        teamId: teamId
    });
    const media = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2c3Eq.default), {
        size: "xlarge",
        src: avatarUrl || undefined,
        name: name
    }));
    const orgText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $22e3062f2f0456b9$var$styles.orgIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eleTd))), {
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage((0, $cb86z.messages).knowledge_cards_team_subheader)));
    const handleLinkClick = (e)=>{
        if ((0, $iDrrr.fg)('platform-adopt-teams-nav-config')) profileOnNavigate(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff2c12cd5348c884$export$c7c90b1402552129), {
        name: name,
        email: email,
        profileUrl: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : profileUrl || '',
        profileLinkText: formatMessage((0, $cb86z.messages).knowledge_cards_view_team),
        media: media,
        orgText: orgText,
        onLinkClick: handleLinkClick,
        testId: 'team-knowledge-card-header'
    });
};


const $39464719bc90ad90$var$CardContainerStyles = {
    default: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    refresh: "_0bjKvDKxmn _2mHwu85zaO _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0Of8r25zaO _1wydGW5zaO",
    disclaimer: "_2Zuz6Q5zaO _1Znuxb5zaO"
};
const $39464719bc90ad90$export$224d36db19d00a29 = /*#__PURE__*/ (0, $cozmU.memo)(({ onFMPReached: onFMPReached })=>{
    const { commonAttributes: commonAttributes, userDetails: { id: currentUserId } } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { answerString: answerString, query: query } = commonAttributes;
    const data = (0, $d325f5b9eeee6e40$export$d905ae2a714518e8)({
        answerString: answerString
    }).parsedResult;
    const editDistanceRatio = (0, $f535bbbe86185acd$export$ebacab8290144e11)(query, data.name);
    (0, $cozmU.useEffect)(()=>{
        if (data.id) {
            onFMPReached?.();
            fireSAINUsageEvent({
                commonAttributes: commonAttributes
            });
            fireAnalyticsEvent((0, $19a6060145576e12$export$44d9aa4134474084)({
                ...commonAttributes,
                cardType: (0, $9T3jg.KnowledgeCardsIntentType).TEAM,
                extraAttributes: {
                    editDistance: editDistanceRatio
                }
            }));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const showKnowledgeCardBody = (data.recentActivity?.length || 0) > 0 || (data.members?.length || 0) > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, (0, $iDrrr.fg)('enable_team_site_assignment') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $cb86z.messages).ai_answer_dialog_teams_not_found_message), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: "https://support.atlassian.com/platform-experiences/docs/understanding-team-visibility/"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $cb86z.messages).ai_answer_dialog_teams_not_found_message_link))), data.id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $39464719bc90ad90$var$CardContainerStyles.refresh,
        testId: "team-knowledge-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22e3062f2f0456b9$export$972f15901814fb3d), {
        name: data.name,
        avatarUrl: data.avatarUrl,
        profileUrl: data.url,
        teamId: data.id
    }), showKnowledgeCardBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8ba51f29bf3689a9$export$4fb305a2fc986af3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, showKnowledgeCardBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3676c19248632e27$export$21ff1f39b993b08e), {
        currentUserId: currentUserId || '',
        recentActivity: data.recentActivity,
        recommendedUsers: data.members,
        viewAllUrl: data.url || '',
        teamId: data.id
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $39464719bc90ad90$var$CardContainerStyles.disclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true
    })))) : null);
});


const $0d6d5a5257f57329$export$ab2444a256fc8a9b = ({ onFMPReached: onFMPReached })=>{
    const { isAnswered: isAnswered, hasError: hasError, smartAnswersRoute: smartAnswersRoute, loading: loading, commonAttributes: commonAttributes, baseQuery: baseQuery, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId, brand: brand, searchSessionId: searchSessionId, workspaceId: workspaceId, query: query } = commonAttributes;
    // Visual Knowledge Card fetches its own data, so it doesn't rely on isAnswered/hasError from the AI answer flow
    if (smartAnswersRoute === (0, $zzZbq.QueryIntent).VISUAL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $472bcf0ba3d83c5e$export$cf8f12b9d9c373ce), null);
    // Jira NL to JQL Card doesn't populate the context with hasError, isAnswered so we use a separate condition.
    // JIRA_NLQ_KEYWORD renders the same Jira SAIN card but bypasses the agentic NL→JQL flow
    // and instead issues a deterministic keyword JQL of the form `textfields ~ "<query>*"`.
    if (smartAnswersRoute === (0, $zzZbq.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY || smartAnswersRoute === (0, $zzZbq.QueryIntent).JIRA_NLQ_KEYWORD) {
        const bypassWithKeywordJql = smartAnswersRoute === (0, $zzZbq.QueryIntent).JIRA_NLQ_KEYWORD;
        const showJiraSAINCardSmartlink = (0, $7DMz5.SAINFeatureControl).isJiraSAINCardSmartLinkEnabled({
            sourceProduct: sourceProduct
        });
        if (showJiraSAINCardSmartlink) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $51159ee7c0863918$export$68d51edc6150de19), {
            query: baseQuery ?? '',
            cloudId: cloudId,
            aiBrand: brand,
            searchSessionId: searchSessionId,
            workspaceId: workspaceId,
            product: sourceProduct ?? '',
            onFMPReached: onFMPReached,
            bypassWithKeywordJql: bypassWithKeywordJql
        });
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f0bc144b7e8592f4$export$ba6b7dafd54d334), {
            title: query,
            query: baseQuery ?? '',
            cloudId: cloudId,
            aiBrand: brand,
            searchSessionId: searchSessionId,
            workspaceId: workspaceId,
            product: sourceProduct ?? '',
            onFMPReached: onFMPReached,
            bypassWithKeywordJql: bypassWithKeywordJql
        });
    }
    if (loading) switch(smartAnswersRoute){
        case (0, $zzZbq.QueryIntent).PERSON:
            if ((0, $7DMz5.SAINFeatureControl).isPeopleConnectorUXEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70CUF.LoadingSkeleton), {
                columnCount: 2,
                itemCount: 10
            });
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4fd6fa5a10eca60c$export$a08238eb59773648), {
                queryIntent: smartAnswersRoute
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4fd6fa5a10eca60c$export$a08238eb59773648), {
                queryIntent: smartAnswersRoute
            });
    }
    if (isAnswered && !hasError) switch(smartAnswersRoute){
        case (0, $zzZbq.QueryIntent).TEAM:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39464719bc90ad90$export$224d36db19d00a29), {
                onFMPReached: onFMPReached
            });
        case (0, $zzZbq.QueryIntent).PERSON:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $da688014b5e1873c$export$8cdcd522f66fdfa8), {
                onFMPReached: onFMPReached
            });
        case (0, $zzZbq.QueryIntent).TOPIC:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dsm4u.TopicKnowledgeCard), {
                onFMPReached: onFMPReached
            });
        case (0, $zzZbq.QueryIntent).AGENT:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6a88c586e988f54$export$f3d65ac3e9ec58cd), {
                onFMPReached: onFMPReached
            });
        case (0, $zzZbq.QueryIntent).ORG_CHART:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $da688014b5e1873c$export$8cdcd522f66fdfa8), {
                onFMPReached: onFMPReached
            });
        default:
            return null;
    }
    return null;
};





/* smart-answer-card-minimized.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $9kbTQ = parcelRequire("9kbTQ");




















var $d2UzA = parcelRequire("d2UzA");























var $b8pma = parcelRequire("b8pma");





var $2Zool = parcelRequire("2Zool");


var $fhQlP = parcelRequire("fhQlP");


var $1V59x = parcelRequire("1V59x");


var $7zn5c = parcelRequire("7zn5c");


var $3Luzz = parcelRequire("3Luzz");





























/* streaming-early-stop-card.tsx generated by @compiled/babel-plugin v2.0.0 */ 
































const $bdb16ab7e4fe1cd4$export$d0aa7585daee6b3c = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'dismissed',
        actionSubject: 'aiAnswerStreamingEarlyStopCard',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $523511d140ea25e9$export$efbf193d50ae9f9b = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerStreamingEarlyStopCard',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};









var $i3wdq = parcelRequire("i3wdq");





var $5OgwG = parcelRequire("5OgwG");

const $7af86847637791a4$var$styles = {
    root: "_39xV02N91d",
    onlineDebuggerButtonContainer: "_2XsHFMIZbP _39xV02E6Kk"
};
const $7af86847637791a4$export$97b52c363fbe053e = ()=>{
    const [dismissed, setDismissed] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { baseQuery: baseQuery, commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        const cachedAnswer = (0, $6JEx2.getSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY)); // Only fire analytics event once per cached answer
        if (cachedAnswer) {
            (0, $6JEx2.deleteSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY));
            fireAnalyticsEvent((0, $523511d140ea25e9$export$efbf193d50ae9f9b)(commonAttributes));
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const dismissCard = (0, $cozmU.useCallback)(()=>{
        setDismissed(true);
        fireAnalyticsEvent((0, $bdb16ab7e4fe1cd4$export$d0aa7585daee6b3c)(commonAttributes));
    }, [
        fireAnalyticsEvent,
        commonAttributes
    ]);
    const showOnlineDebuggerButton = (0, $iDrrr.fg)('kd_sain_online_debugger');
    if (dismissed) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i3wdq.KnowledgeCard), {
        name: "sain-streaming-early-stop-card",
        size: "full",
        testId: "sain-streaming-early-stop-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: $7af86847637791a4$var$styles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, formatMessage((0, $5OgwG.messages).ai_answer_card_early_stop_text, {
        searchQuery: baseQuery
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage((0, $5OgwG.messages).ai_answer_card_early_stop_close_button_label),
        onClick: dismissCard,
        appearance: "subtle",
        spacing: "compact",
        testId: "sain-early-stop-error-card-dismiss-button"
    })), showOnlineDebuggerButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $7af86847637791a4$var$styles.onlineDebuggerButtonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j9bgP.OnlineDebuggerButton), null))));
};


/* definition-error.tsx generated by @compiled/babel-plugin v2.0.0 */ 

















var $4ez2K = parcelRequire("4ez2K");










const $15c17b140b3e21b2$export$59da2b3b71a076c7 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $15c17b140b3e21b2$export$96cc4126cdc27248 = 'https://www.atlassian.com/legal/acceptable-use-policy';
const $15c17b140b3e21b2$export$50e6b843de210064 = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $15c17b140b3e21b2$export$2c1028e1e7bf5557 = 'https://www.atlassian.com/software/rovo';
const $15c17b140b3e21b2$export$dd87179defae3659 = 'https://support.atlassian.com/organization-administration/docs/the-hipaa-implementation-guide/';
const $15c17b140b3e21b2$export$d04cd98bb7625919 = 'customfield_10047';
const $15c17b140b3e21b2$export$dd6343c56092a345 = '3655ce1d-16b8-4630-9e93-6c39069625fa';









var $a2foB = parcelRequire("a2foB");

var $lqtHz = parcelRequire("lqtHz");


var $chu6R = parcelRequire("chu6R");




const $92e081508525c627$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    edit_definition_modal_header_edit: {
        id: "search_ai.edit_definition_modal_header_edit",
        defaultMessage: "Edit definition"
    },
    edit_definition_modal_header_create: {
        id: "search_ai.edit_definition_modal_header_create",
        defaultMessage: "Add a definition"
    },
    edit_definition_modal_subheader_text: {
        id: "search_ai.edit_definition_modal_subheader_text",
        defaultMessage: "You can edit definitions to help teammates better understand terms."
    },
    edit_definition_modal_subheader_link_text: {
        id: "search_ai.edit_definition_modal_subheader_link_text",
        defaultMessage: "More on editing definitions"
    },
    edit_definition_text_box_label: {
        id: "search_ai.edit_definition_text_box_label",
        defaultMessage: "Definition"
    },
    edit_definition_text_box_label_with_count: {
        id: "search_ai.edit_definition_text_box_label_with_count",
        defaultMessage: "Edit definition, {count} of {max} characters used. Start typing to enter text."
    },
    edit_definition_no_definition: {
        id: "search_ai.edit_definition_no_definition",
        defaultMessage: "Enter definition"
    },
    edit_definition_over_max_length: {
        id: "search_ai.edit_definition_over_max_length",
        defaultMessage: "Definition must be {max} characters or fewer."
    },
    edit_definition_source_label: {
        id: "search_ai.edit_definition_source_label",
        defaultMessage: "Source"
    },
    edit_definition_add_source_label: {
        id: "search_ai.edit_definition_add_source_label",
        defaultMessage: "Add a source (optional)"
    },
    edit_definition_restricted_to_label: {
        id: "search_ai.edit_definition_restricted_to_label",
        defaultMessage: "Show this definition"
    },
    edit_definition_restricted_to_space_subline: {
        id: "search_ai.edit_definition_restricted_to_space_subline",
        defaultMessage: "Previous definition will still show in other spaces."
    },
    edit_definition_restricted_to_site_subline: {
        id: "search_ai.edit_definition_restricted_to_site_subline",
        defaultMessage: "Previous definition will still show on other sites."
    },
    edit_definition_restricted_to_project_subline: {
        id: "search_ai.edit_definition_restricted_to_project_subline",
        defaultMessage: "Previous definition will still show in other projects."
    },
    edit_definition_restricted_to_page_subline: {
        id: "search_ai.edit_definition_restricted_to_page_subline",
        defaultMessage: "Previous definition will still show on other pages."
    },
    edit_definition_restricted_to_blogpost_subline: {
        id: "search_ai.edit_definition_restricted_to_blogpost_subline",
        defaultMessage: "Previous definition will still show on other blogposts."
    },
    edit_definition_source_search_box_placeholder: {
        id: "search_ai.edit_definition_source_search_box_placeholder",
        defaultMessage: "Search or paste a Confluence link"
    },
    edit_definition_back_button: {
        id: "search_ai.edit_definition_back_button",
        defaultMessage: "Back"
    },
    edit_definition_update_button: {
        id: "search_ai.edit_definition_update_button",
        defaultMessage: "Update"
    },
    edit_definition_source_option_metadata_updated_text: {
        id: "search_ai.edit_definition_source_option_metadata_updated_text",
        defaultMessage: "Updated"
    },
    edit_definition_update_confirmation_title: {
        id: "search_ai.edit_definition_update_confirmation_title",
        defaultMessage: "Definition updated \uD83C\uDF89"
    },
    edit_definition_update_confirmation_description: {
        id: "search_ai.edit_definition_update_confirmation_description",
        defaultMessage: "You've made work clearer for your teammates."
    },
    edit_definition_restricted_to_project_subline_galaxia: {
        id: "search_ai.edit_definition_restricted_to_project_subline-galaxia",
        defaultMessage: "Previous definition will still show in other spaces."
    }
});


const $6cecfbe2a7b0bbf1$export$7475d9ffda76c69b = ({ onDismissed: onDismissed, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), {
        onDismissed: ()=>onDismissed()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a2foB.default), {
        id: "definition-update-success-adflag",
        title: formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_update_confirmation_title),
        description: formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_update_confirmation_description),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            label: "Success",
            color: "var(--ds-icon-success, #6A9A23)"
        }),
        testId: testId
    }));
};


/* edit-definition-modal.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $eiLi2 = parcelRequire("eiLi2");











var $kB5K2 = parcelRequire("kB5K2");


var $24dy7 = parcelRequire("24dy7");

























var $47D8u = parcelRequire("47D8u");

var $6wGOF = parcelRequire("6wGOF");


var $ieeJu = parcelRequire("ieeJu");










const $cd19353ea4c45398$export$ae4ae603f16dcf42 = ({ commonAttributes: commonAttributes, newDefinition: newDefinition, restrictedScope: restrictedScope, sourceSelected: sourceSelected, aiDefinitionEdited: aiDefinitionEdited })=>{
    const { query: keyPhrase, answerString: oldDefinition, extraAttributes: extraAttributes, source: source } = commonAttributes;
    const { contentId: contentId, readingAidsSessionId: readingAidsSessionId } = extraAttributes || {};
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionUpdateButton',
        source: source,
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: readingAidsSessionId,
            restrictedScope: restrictedScope,
            sourceSelected: sourceSelected,
            newDefinitionLength: newDefinition.length,
            aiDefinitionEdited: // whether the user is editing an AI answer or already edited definition
            aiDefinitionEdited
        },
        nonPrivacySafeAttributes: {
            keyPhrase: keyPhrase,
            oldDefinition: oldDefinition,
            newDefinition: newDefinition
        }
    };
};





const $e8986d45874ae352$export$ef8b7cdd9a33efb4 = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiCuratedDefinitionUpdate',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};



var $jkdKe = parcelRequire("jkdKe");





var $jlRK6 = parcelRequire("jlRK6");


var $d7j1D = parcelRequire("d7j1D");


var $4nt1R = parcelRequire("4nt1R");


var $dVPAB = parcelRequire("dVPAB");


var $c9zHD = parcelRequire("c9zHD");


var $HGu9Y = parcelRequire("HGu9Y");


var $hFvHs = parcelRequire("hFvHs");


var $1171P = parcelRequire("1171P");





var $6FNab = parcelRequire("6FNab");


var $9DPMp = parcelRequire("9DPMp");

// throwing up the validation that an empty definition was valid CCSEARCH-4472
const $7e4b253a4704aa2d$export$7f32babab6e8c339 = (str)=>{
    return str.replace(/[\u200c]/g, '');
};


const $2858a64524f41982$export$18a9461578883ec4 = ({ value: value, setValue: setValue, setCharCount: setCharCount, assistiveLabel: assistiveLabel, assistiveDescribedBy: assistiveDescribedBy })=>{
    const { preset: preset } = (0, $dVPAB.usePreset)(()=>(0, $4nt1R.createDefaultPreset)({
            allowUndoRedoButtons: true,
            textFormatting: {
                responsiveToolbarMenu: true
            }
        }).add((0, $HGu9Y.indentationPlugin)).add((0, $hFvHs.listPlugin)).add([
            (0, $1171P.toolbarListsIndentationPlugin),
            {
                showIndentationButtons: true,
                allowHeadingAndParagraphIndentation: false
            }
        ]), []);
    const adfEncoder = (0, $cozmU.useMemo)(()=>new (0, $6FNab.ADFEncoder)((schema)=>new (0, $c9zHD.MarkdownTransformer)(schema)), []);
    const initializeEditor = (0, $cozmU.useCallback)((actions)=>{
        const encodedValue = adfEncoder.encode(value);
        actions.replaceDocument(encodedValue);
    }, [
        value,
        adfEncoder
    ]);
    const onEditorChange = (0, $cozmU.useCallback)((editorView)=>{
        const { markdown: markdown } = (0, $9DPMp.convertProsemirrorToMarkdown)({
            editorView: editorView,
            fragment: editorView.state.doc.content
        });
        // ? Editor component seems to add invisible characters in certain cases. Using this function to remove them and set back to the definition state.
        const markdownWithoutInvisibleChars = (0, $7e4b253a4704aa2d$export$7f32babab6e8c339)(markdown);
        setValue(markdownWithoutInvisibleChars);
        setCharCount?.(markdownWithoutInvisibleChars.length);
    }, [
        setValue,
        setCharCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jlRK6.ComposableEditor), {
        appearance: "comment",
        preset: preset,
        shouldFocus: true,
        quickInsert: false,
        minHeight: 170,
        maxHeight: 90,
        onEditorReady: initializeEditor,
        onChange: onEditorChange,
        assistiveLabel: assistiveLabel,
        assistiveDescribedBy: assistiveDescribedBy
    }))));
};



/* radial-progress-bar.tsx generated by @compiled/babel-plugin v2.0.0 */ 





// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5db288be4e514131$var$Wrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _39xV02SPN1 _0jFU0VSPN1",
            __cmplp.className
        ])
    });
});
const $5db288be4e514131$var$CanvasWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _39xV02gZxp _0jFU0VgZxp _2IhTonZnY9 _3OE6xYZnY9 _1VJPcaHI3g",
            __cmplp.className
        ])
    });
});
const $5db288be4e514131$export$a4badf890ec26dc0 = ({ current: current, max: max })=>{
    const canvasRef = (0, $cozmU.useRef)(null);
    // Draw the current circle progress bar
    (0, $cozmU.useEffect)(()=>{
        const ctx = canvasRef.current?.getContext('2d');
        if (ctx) {
            if (current >= max) {
                ctx.beginPath();
                ctx.strokeStyle = '#E91618';
                ctx.lineWidth = 20;
                ctx.arc(100, 100, 80, 0, 2 * Math.PI);
                ctx.stroke();
            } else {
                ctx.beginPath();
                ctx.strokeStyle = '#DCDFE4';
                ctx.lineWidth = 20;
                ctx.arc(100, 100, 80, 0, 2 * Math.PI);
                ctx.stroke();
                ctx.beginPath();
                ctx.strokeStyle = '#22A06B';
                ctx.lineWidth = 20;
                ctx.arc(100, 100, 80, -0.5 * Math.PI, 2 * Math.PI * (current / max) - 0.5 * Math.PI);
                ctx.stroke();
            }
        }
    }, [
        current,
        max
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5db288be4e514131$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5db288be4e514131$var$CanvasWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("canvas", {
        ref: canvasRef,
        height: 200,
        width: 200
    })));
};


/* restriction-option-formatter.tsx generated by @compiled/babel-plugin v2.0.0 */ 







const $661e00bd00ca3cb9$var$styles = {
    optionWrapper: "_2sNsIgmnOE _1UtDYzy7kJ"
};
const $661e00bd00ca3cb9$export$66608c4e05327916 = (option)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $661e00bd00ca3cb9$var$styles.optionWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.100"
    }, option.icon, option.label));
};


/* source-option-formatter.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $2Fmt9 = parcelRequire("2Fmt9");





var $9zxkL = parcelRequire("9zxkL");





var $ai0Ge = parcelRequire("ai0Ge");


var $6LZT4 = parcelRequire("6LZT4");












const $54d4d093910d9874$var$styles = {
    sourceOptionWrapper: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _24h04i2Njc _0wOv4Q7zJH _1eOmH6d1Zr _0ReiIH7zJH",
    sourceOptionTitle: "_2sNsIgmnOE _1UtDYzy7kJ",
    sourceOptionMetadata: "_2sNsIg7NXe _3iDTPbQ4SZ _1UtDYzKGUX",
    sourceOptionMetatadataSeparator: "_2XsHFM1Y8M _0adFHs1Y8M",
    sourceImageContainer: "_0jFU0VoWWg _39xV02oWWg"
};
const $54d4d093910d9874$var$SourceSpaceImage = ({ source: source })=>{
    return source.iconUrl ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $54d4d093910d9874$var$styles.sourceImageContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $cJ0FD.default), {
        src: source.iconUrl,
        alt: ""
    })) : /*#__PURE__*/ $cozmU.createElement((0, $2Fmt9.IconTile), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9zxkL))),
        label: "",
        appearance: "blueBold",
        size: "small"
    });
};
const $54d4d093910d9874$export$bd0bc6e060a5a86f = ({ source: source, canClear: canClear, onClickSource: onClickSource, onRemoveSource: onRemoveSource })=>{
    const { formatDate: formatDate, formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let sourceIcon = /*#__PURE__*/ $cozmU.createElement((0, $6LZT4.default), {
        size: "small",
        label: ""
    });
    if (source.type === 'space') sourceIcon = /*#__PURE__*/ $cozmU.createElement($54d4d093910d9874$var$SourceSpaceImage, {
        source: source
    });
    else if (source.type === 'blogpost') sourceIcon = /*#__PURE__*/ $cozmU.createElement((0, $ai0Ge.default), {
        size: "small",
        label: ""
    });
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $54d4d093910d9874$var$styles.sourceOptionWrapper,
        onClick: onClickSource
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.150"
    }, sourceIcon, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        direction: "column"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $54d4d093910d9874$var$styles.sourceOptionTitle
    }, source.title), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $54d4d093910d9874$var$styles.sourceOptionMetadata
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, source.container), source.lastModified && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $54d4d093910d9874$var$styles.sourceOptionMetatadataSeparator
    }, `\u{2022}`), source.lastModified && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, `${formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_source_option_metadata_updated_text)} ${formatDate(source.lastModified, {
        year: 'numeric',
        month: 'short',
        day: '2-digit'
    })}`)))), canClear ? /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        testId: `remove-source-${source.id}`,
        appearance: "subtle",
        onClick: onRemoveSource,
        label: (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true) ? 'Remove source option' : 'remove-source-option-button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH)))
    }) : /*#__PURE__*/ $cozmU.createElement("div", null));
};

















const $64ff2c3c45ef8800$export$41f2c817c42b2303 = `
	mutation CreateDefinitionMutation(
		$workspaceId: String!
		$keyPhrase: String!
		$editedDefinition: String!
		$scope: KnowledgeDiscoveryDefinitionScope!
		$entityIdInScope: String!
		$referenceContentId: String
		$referenceUrl: String
		) {
		knowledgeDiscovery {
			createDefinition(
				input: {
				workspaceId: $workspaceId
				keyPhrase: $keyPhrase
				definition: $editedDefinition
				scope: $scope
				entityIdInScope: $entityIdInScope
				referenceContentId: $referenceContentId
				referenceUrl: $referenceUrl
				}
			) @optIn(to: "KnowledgeDiscovery Create definition") {
			success
			errors {
				message
			}
			definitionDetails {
				keyPhrase
				definition
				editor {
					... on User {
						name
						accountId
					}
				}
				referenceUrl
				confluenceEntity {
					... on ConfluencePage {
					id
					type
					title
					space {
						name
					}
					}
					... on ConfluenceBlogPost {
					id
					type
					title
					space {
						name
					}
					}
				}
			}
		}
	}
  }
`;





const $571acb4b4ef932b1$export$248ff3a730ef0924 = ({ selectedScope: selectedScope, productScopes: productScopes, cloudId: cloudId })=>{
    let contentARI = '';
    let spaceARI = '';
    let projectARI = '';
    if ('contentARI' in productScopes) {
        contentARI = productScopes.contentARI;
        spaceARI = productScopes.spaceARI;
    }
    if ('projectARI' in productScopes) projectARI = productScopes.projectARI;
    switch(selectedScope){
        case (0, $jkdKe.EditedDefinitionScope).PAGE:
        case (0, $jkdKe.EditedDefinitionScope).BLOGPOST:
            return contentARI;
        case (0, $jkdKe.EditedDefinitionScope).SPACE:
            return spaceARI;
        case (0, $jkdKe.EditedDefinitionScope).PROJECT:
            return projectARI;
        default:
            return cloudId;
    }
};





const $9420450cf7eee89d$export$40e11c80593ec8d4 = (definitionDetails)=>{
    const definitionReferenceDetails = definitionDetails.confluenceEntity;
    return {
        nlpResult: definitionDetails.definition,
        uniqueSources: definitionDetails.confluenceEntity ? [
            {
                id: definitionReferenceDetails?.id || '',
                title: definitionReferenceDetails?.title || '',
                url: definitionDetails.referenceUrl || '',
                type: definitionReferenceDetails?.type || '',
                // for now we only allow users to add a source from Confluence
                product: 'Confluence',
                lastModified: '',
                iconUrl: '',
                spaceName: definitionReferenceDetails?.space?.name || '',
                spaceUrl: null
            }
        ] : [],
        nlpResultEditor: {
            name: definitionDetails.editor?.name || '',
            id: definitionDetails.editor?.accountId || ''
        },
        disclaimer: null,
        errorState: null,
        format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN
    };
};


const $6a77ceaa0d40bc29$export$4c5c8822f1a42b9f = ({ curatedDefinitionScopeConfig: curatedDefinitionScopeConfig })=>{
    const { commonAttributes: commonAttributes, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const createDefinition = (0, $cozmU.useCallback)(async ({ keyPhrase: keyPhrase, editedDefinition: editedDefinition, scope: scope, referenceContentId: referenceContentId, referenceUrl: referenceUrl })=>{
        const { cloudId: cloudId } = commonAttributes;
        const { workspaceId: workspaceId, productScopes: productScopes } = curatedDefinitionScopeConfig;
        const entityIdInScope = (0, $571acb4b4ef932b1$export$248ff3a730ef0924)({
            selectedScope: scope,
            cloudId: cloudId,
            productScopes: productScopes
        });
        // check needed to account for Spaces being added as sources and submitted
        const contentId = 'contentARI' in productScopes && referenceContentId === entityIdInScope ? productScopes.contentARI : referenceContentId;
        return (0, $i5c0A.fetchAggResponse)({
            graphQuery: (0, $64ff2c3c45ef8800$export$41f2c817c42b2303),
            variables: {
                workspaceId: workspaceId || '',
                keyPhrase: keyPhrase,
                editedDefinition: editedDefinition,
                scope: scope,
                entityIdInScope: entityIdInScope,
                referenceContentId: contentId,
                referenceUrl: referenceUrl
            },
            headers: (0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: sourceProduct ?? ''
            })
        }).then((response)=>{
            if (response?.data?.knowledgeDiscovery.createDefinition?.success) {
                const definitionDetails = response.data.knowledgeDiscovery.createDefinition.definitionDetails;
                return definitionDetails && (0, $9420450cf7eee89d$export$40e11c80593ec8d4)(definitionDetails) || {
                    nlpResult: '',
                    format: (0, $hpFQM.NLPSearchResultFormat).PLAINTEXT,
                    uniqueSources: [],
                    errorState: null,
                    disclaimer: null
                };
            } else throw new Error('createDefinition mutation unsuccessful');
        });
    }, [
        commonAttributes,
        curatedDefinitionScopeConfig,
        sourceProduct
    ]);
    return {
        createDefinition: createDefinition
    };
};















var $jDZkE = parcelRequire("jDZkE");

const $4cc1094b17bfa51f$export$beaccb66a6ac7cc5 = `
	query ReadingAidsReferenceSearchQuery(
			$experience: String!
			$analytics: SearchAnalyticsInput
			$query: String!
			$filters: SearchFilterInput!
			$first: Int
		) {
		search {
			results: search(
				experience: $experience
				analytics: $analytics
				query: $query
				filters: $filters
				first: $first
			) {
				edges {
					node {
						type
						id
						title
						url
						iconUrl
						... on SearchConfluencePageBlogAttachment {
							lastModified
							space {
								name
							}
						}
						... on SearchConfluenceSpace {
							id
							title
							url
						}
					}
				}
			}
		}
	}
`;


const $8635b0acf53038fc$export$3b4150834edadf59 = (query)=>{
    const pageOrBlogRegex = /spaces\/.*\/(pages|blog)/;
    const spaceRegex = /https:\/\/[^\/]+\/wiki\/spaces\/(?!.*\/(pages|blog)).*/;
    // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    const confluenceTinyRegex = RegExp("\\/wiki\\/x\\/(?<resourceId>[^\\/(?)]+)$");
    const queryParts = query.split('/');
    const queryParamsRemoved = query.split('?')[0];
    if (query.match(pageOrBlogRegex)) // e.g. https://hello.atlassian.net/wiki/spaces/AAI/pages/3665fakeId/Test+Page+Title
    return {
        searchQuery: queryParts[queryParts.length - 1],
        entities: [
            'ati:cloud:confluence:page',
            'ati:cloud:confluence:blogpost'
        ],
        spacesFilter: undefined
    };
    else if (query.match(spaceRegex)) {
        // e.g. https://hello.atlassian.net/wiki/spaces/SK1/overview
        const spacesIndex = queryParts.indexOf('spaces');
        return {
            searchQuery: '',
            entities: [
                'ati:cloud:confluence:space'
            ],
            spacesFilter: [
                spacesIndex > -1 ? queryParts[spacesIndex + 1] : ''
            ]
        };
    } else if (queryParamsRemoved.match(confluenceTinyRegex)) // e.g. https://hello.atlassian.net/wiki/x/4c942w
    return {
        searchQuery: '',
        entities: [
            'ati:cloud:confluence:page',
            'ati:cloud:confluence:blogpost'
        ],
        spacesFilter: undefined,
        needsLinkResolution: true
    };
    return {
        searchQuery: query,
        entities: [
            'ati:cloud:confluence:page',
            'ati:cloud:confluence:blogpost',
            'ati:cloud:confluence:space'
        ],
        spacesFilter: undefined
    };
};


const $4cd3e1a874bd33ba$var$OBJECT_RESOLVE_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';
const $4cd3e1a874bd33ba$export$11c4e3b6769b440d = ()=>{
    const { commonAttributes: commonAttributes, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId, extraAttributes: extraAttributes, workspaceId: workspaceId } = commonAttributes;
    const { readingAidsSessionId: readingAidsSessionId } = extraAttributes;
    const searchSources = (0, $cozmU.useCallback)(async (query)=>{
        const { searchQuery: searchQuery, entities: entities, spacesFilter: spacesFilter, needsLinkResolution: needsLinkResolution } = (0, $8635b0acf53038fc$export$3b4150834edadf59)(query);
        let details;
        if (needsLinkResolution) details = await (0, $jDZkE.fetchRestResponse)({
            url: $4cd3e1a874bd33ba$var$OBJECT_RESOLVE_ENDPOINT,
            body: [
                {
                    resourceUrl: query.split('?')[0]
                }
            ]
        });
        return (0, $i5c0A.fetchAggResponse)({
            graphQuery: (0, $4cc1094b17bfa51f$export$beaccb66a6ac7cc5),
            variables: {
                experience: 'curated-definition-source-search',
                analytics: {
                    searchSessionId: readingAidsSessionId
                },
                query: details?.[0]?.body?.data?.name ?? searchQuery,
                filters: {
                    entities: entities,
                    locations: [
                        cloudId ? `ari:cloud:confluence::site/${cloudId}` : ''
                    ],
                    confluenceFilters: {
                        titleMatchOnly: true,
                        spacesFilter: spacesFilter
                    }
                },
                first: 5
            },
            headers: (0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: sourceProduct ?? ''
            })
        }).then((response)=>{
            if (response.data) return response.data.search.results.edges.map((edge)=>({
                    id: edge.node?.id || '',
                    type: edge.node?.type || '',
                    title: edge.node?.title || '',
                    container: edge.node?.space?.name || '',
                    url: edge.node?.url || '',
                    iconUrl: edge.node?.iconUrl || '',
                    lastModified: edge.node?.lastModified || ''
                }));
            return [];
        });
    }, [
        cloudId,
        readingAidsSessionId,
        workspaceId,
        sourceProduct
    ]);
    return {
        searchSources: searchSources
    };
};


const $46b3319f0a259942$var$MAX_DEFINITION_LENGTH = 500;
const $46b3319f0a259942$var$editDefintionModalStyles = {
    editDefinitionTextboxLabelContainer: "_0xmtko1Y8M",
    editDefinitionTextboxErrorMessageContainer: "_46hvQm1Y8M",
    radialProgressBarContainer: "_0xmtkoFQfX",
    restrictionSelectSublineContainer: "_46hvQm1Y8M"
};
const $46b3319f0a259942$export$ea8c8594ad1f3bf3 = ({ curatedDefinitionScopeConfig: curatedDefinitionScopeConfig, closeEditModal: closeEditModal, openFeedbackOptionsModal: openFeedbackOptionsModal, isCreateDefinition: isCreateDefinition, onSaveEditModal: onSaveEditModal })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes, setData: setData, answerEditor: answerEditor, additionalQueryContext: additionalQueryContext } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString, query: keyPhrase } = commonAttributes;
    const [editedDefinition, setEditedDefinition] = (0, $cozmU.useState)(answerString);
    const [charCount, setCharCount] = (0, $cozmU.useState)(0);
    const emptyDefinition = editedDefinition.trim() === '';
    const definitionOverMaxLength = charCount > $46b3319f0a259942$var$MAX_DEFINITION_LENGTH;
    const updateDefinitionDisabled = emptyDefinition || definitionOverMaxLength;
    const [sourceSearchInput, setSourceSearchInput] = (0, $cozmU.useState)('');
    const [source, setSource] = (0, $cozmU.useState)(null);
    const sourceSelectRef = (0, $cozmU.useRef)(null);
    const [sourceJustRemoved, setSourceJustRemoved] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (sourceJustRemoved && sourceSelectRef.current && (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true)) {
            sourceSelectRef.current.focus();
            setSourceJustRemoved(false);
        }
    }, [
        sourceJustRemoved
    ]);
    const { definitionRestrictionOptions: definitionRestrictionOptions } = curatedDefinitionScopeConfig;
    const defaultRestrictionOption = definitionRestrictionOptions[0];
    const [audienceRestriction, setAudienceRestriction] = (0, $cozmU.useState)(defaultRestrictionOption.value);
    const [updateDefinitionLoading, setUpdateDefinitionLoading] = (0, $cozmU.useState)(false);
    const setDefinition = (0, $cozmU.useCallback)((value)=>{
        setEditedDefinition(value);
    }, [
        setEditedDefinition
    ]);
    const { searchSources: searchSources } = (0, $4cd3e1a874bd33ba$export$11c4e3b6769b440d)();
    const onSourceSearchInputChange = (input, actionMeta)=>{
        if (actionMeta.action === 'input-change') setSourceSearchInput(input);
    };
    const onSelectSource = (newValue, actionMeta)=>{
        if (actionMeta.action === 'select-option') setSource(newValue);
    };
    const onSelectRestrictionOption = (newValue, actionMeta)=>{
        if (actionMeta.action === 'select-option') setAudienceRestriction(newValue?.value || (0, $jkdKe.EditedDefinitionScope).ORGANIZATION);
    };
    const { createDefinition: createDefinition } = (0, $6a77ceaa0d40bc29$export$4c5c8822f1a42b9f)({
        curatedDefinitionScopeConfig: curatedDefinitionScopeConfig
    });
    const onUpdateDefinition = async ()=>{
        setUpdateDefinitionLoading(true);
        try {
            const updatedDefinition = await createDefinition({
                keyPhrase: keyPhrase,
                editedDefinition: editedDefinition,
                scope: audienceRestriction,
                referenceContentId: source ? source.id : null,
                referenceUrl: source ? source.url : null
            });
            setUpdateDefinitionLoading(false);
            setSource(null);
            fireAnalyticsEvent((0, $cd19353ea4c45398$export$ae4ae603f16dcf42)({
                commonAttributes: commonAttributes,
                newDefinition: editedDefinition,
                restrictedScope: audienceRestriction,
                sourceSelected: !!source,
                aiDefinitionEdited: !!!answerEditor
            }));
            setData(updatedDefinition);
            (0, $6JEx2.setSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
                query: keyPhrase,
                additionalContext: additionalQueryContext || '',
                data: updatedDefinition
            }));
            closeEditModal();
            onSaveEditModal?.();
        } catch (error) {
            fireAnalyticsEvent((0, $e8986d45874ae352$export$ef8b7cdd9a33efb4)(error, commonAttributes));
            setUpdateDefinitionLoading(false);
        }
    };
    let conditionalSublineMessage;
    switch(audienceRestriction){
        case (0, $jkdKe.EditedDefinitionScope).SPACE:
            conditionalSublineMessage = (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_restricted_to_space_subline;
            break;
        case (0, $jkdKe.EditedDefinitionScope).PROJECT:
            conditionalSublineMessage = (0, $cXtTj.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_restricted_to_project_subline_galaxia : (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_restricted_to_project_subline;
            break;
        case (0, $jkdKe.EditedDefinitionScope).PAGE:
            conditionalSublineMessage = (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_restricted_to_page_subline;
            break;
        case (0, $jkdKe.EditedDefinitionScope).BLOGPOST:
            conditionalSublineMessage = (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_restricted_to_space_subline;
            break;
        case (0, $jkdKe.EditedDefinitionScope).ORGANIZATION:
            conditionalSublineMessage = (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_restricted_to_site_subline;
            break;
        default:
            conditionalSublineMessage = (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_restricted_to_site_subline;
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: closeEditModal,
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, formatMessage(isCreateDefinition ? (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_modal_header_create : (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_modal_header_edit))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p",
        color: "color.text.subtle"
    }, formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_modal_subheader_text), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: "https://support.atlassian.com/rovo/docs/add-or-edit-a-definition/"
    }, formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_modal_subheader_link_text))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        grow: "fill",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $46b3319f0a259942$var$editDefintionModalStyles.editDefinitionTextboxLabelContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        weight: "bold",
        size: "small"
    }, formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_text_box_label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        size: "small",
        color: "color.text.subtle"
    }, charCount, "/", $46b3319f0a259942$var$MAX_DEFINITION_LENGTH), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $46b3319f0a259942$var$editDefintionModalStyles.radialProgressBarContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5db288be4e514131$export$a4badf890ec26dc0), {
        current: charCount,
        max: $46b3319f0a259942$var$MAX_DEFINITION_LENGTH
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2858a64524f41982$export$18a9461578883ec4), {
        value: editedDefinition,
        setValue: setDefinition,
        setCharCount: setCharCount,
        assistiveLabel: formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_text_box_label_with_count, {
            count: charCount,
            max: $46b3319f0a259942$var$MAX_DEFINITION_LENGTH
        }),
        assistiveDescribedBy: "edit-definition-text-box-error-message"
    }), updateDefinitionDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050",
        xcss: $46b3319f0a259942$var$editDefintionModalStyles.editDefinitionTextboxErrorMessageContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        label: "",
        color: "var(--ds-text-danger, #AE2E24)",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.danger",
        size: "small",
        id: "edit-definition-text-box-error-message"
    }, emptyDefinition ? formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_no_definition) : formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_over_max_length, {
        max: $46b3319f0a259942$var$MAX_DEFINITION_LENGTH
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: "edit-definition-source-select"
    }, formatMessage(source ? (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_source_label : (0, $92e081508525c627$export$defe85febe8b728c).edit_definition_add_source_label)), source ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $54d4d093910d9874$export$bd0bc6e060a5a86f), {
        source: source,
        onClickSource: ()=>{
            window.open(source.url, '_blank')?.focus();
        },
        canClear: true,
        onRemoveSource: (e)=>{
            e.stopPropagation();
            setSource(null);
            if ((0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true)) setSourceJustRemoved(true);
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $47D8u.default), {
        ref: sourceSelectRef,
        components: {
            DropdownIndicator: ()=>null
        },
        loadOptions: (0, (/*@__PURE__*/$parcel$interopDefault($eiLi2)))((input)=>searchSources(input), 500),
        formatOptionLabel: (sourceOption)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $54d4d093910d9874$export$bd0bc6e060a5a86f), {
                source: sourceOption,
                canClear: false
            }),
        onChange: onSelectSource,
        inputValue: sourceSearchInput,
        onInputChange: onSourceSearchInputChange,
        placeholder: formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_source_search_box_placeholder),
        menuPosition: "fixed",
        inputId: "edit-definition-source-select"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kB5K2.Label), {
        htmlFor: "edit-definition-restriction-select"
    }, formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_restricted_to_label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
        options: definitionRestrictionOptions,
        defaultValue: defaultRestrictionOption,
        onChange: onSelectRestrictionOption,
        formatOptionLabel: (0, $661e00bd00ca3cb9$export$66608c4e05327916),
        isSearchable: false,
        menuPosition: "fixed",
        inputId: "edit-definition-restriction-select",
        descriptionId: "edit-definition-restriction-subline"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $46b3319f0a259942$var$editDefintionModalStyles.restrictionSelectSublineContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, formatMessage(conditionalSublineMessage)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, openFeedbackOptionsModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: ()=>{
            closeEditModal();
            openFeedbackOptionsModal();
        }
    }, formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_back_button)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: updateDefinitionDisabled ? 'default' : 'primary',
        isLoading: updateDefinitionLoading,
        onClick: onUpdateDefinition,
        isDisabled: updateDefinitionDisabled
    }, formatMessage((0, $92e081508525c627$export$defe85febe8b728c).edit_definition_update_button))));
};





const $5e3b152f98329dbd$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    definition_no_answer_error: {
        id: "search_ai.definition_no_answer_error",
        defaultMessage: "{brand} doesn\u2019t have enough data to provide a definition right now. It\u2019s possible that we couldn\u2019t find the relevant information in your company\u2019s knowledge base."
    },
    definition_no_answer_acceptable_use_error: {
        id: "search_ai.definition_no_answer_acceptable_use_error",
        defaultMessage: "{brand} can\u2019t provide you with a definition, as it might go against {acceptableUseLink}"
    },
    definition_no_answer_acceptable_use_link: {
        id: "search_ai.definition_no_answer_acceptable_use_link",
        defaultMessage: "Atlassian's acceptable use policy"
    },
    definition_no_answer_network_error: {
        id: "search_ai.definition_no_answer_network_error",
        defaultMessage: "{brand} can't provide a definition right now. Read more in our {supportLink}"
    },
    definitions_support_link_text: {
        id: "search_ai.definitions_support_link_text",
        defaultMessage: "support documentation"
    },
    definition_no_answer_add_definition_button: {
        id: "search_ai.definition_no_answer_add_definition_button",
        defaultMessage: "Add definition"
    },
    definitions_no_answer_error_state_hipaa: {
        id: "search_ai.definitions_no_answer_error_state_hipaa",
        defaultMessage: "Due to HIPAA compliance, we can\u2019t provide an answer. {supportLink}."
    },
    definitions_no_answer_hipaa_compliance_link: {
        id: "search_ai.definitions_no_answer_hipaa_compliance_link",
        defaultMessage: "Find out more about HIPAA"
    }
});


const $9aa0fbefc962e4d5$var$styles = {
    errorPadding: "_1wydGW2ADO",
    errorMessage: "_2sNsIgmnOE _1UtDYzy7kJ"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9aa0fbefc962e4d5$var$InfoLink = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYz66Yw",
            __cmplp.className
        ])
    });
});
const $9aa0fbefc962e4d5$export$f874592093e19f27 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { brand: brand, commonAttributes: { errorState: errorState }, readingAidsOptions: readingAidsOptions } = (0, $3hVWe.useAIAnswerContext)();
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const createDefinitionEnabled = !!definitionCurationOptions;
    const [showEditDefinitionModal, setShowEditDefinitionModal] = (0, $cozmU.useState)(false);
    const [displaySuccessFlag, setDisplaySuccessFlag] = (0, $cozmU.useState)(false);
    const showAddDefinitionButton = createDefinitionEnabled && (errorState === (0, $htnqN.NLPSearchErrorState).NoAnswer || errorState === (0, $htnqN.NLPSearchErrorState).NoAnswerKeywords || errorState === (0, $htnqN.NLPSearchErrorState).NoAnswerSearchResults || errorState === (0, $htnqN.NLPSearchErrorState).NoAnswerHydration || errorState === (0, $htnqN.NLPSearchErrorState).NoAnswerRelevantContent || errorState === (0, $htnqN.NLPSearchErrorState).Default);
    const errorMessage = (0, $cozmU.useMemo)(()=>{
        switch(errorState){
            case (0, $htnqN.NLPSearchErrorState).AcceptableUseViolation:
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $5e3b152f98329dbd$export$defe85febe8b728c).definition_no_answer_acceptable_use_error,
                    values: {
                        acceptableUseLink: /*#__PURE__*/ $cozmU.createElement($9aa0fbefc962e4d5$var$InfoLink, {
                            href: (0, $15c17b140b3e21b2$export$96cc4126cdc27248),
                            target: '_blank'
                        }, formatMessage((0, $5e3b152f98329dbd$export$defe85febe8b728c).definition_no_answer_acceptable_use_link)),
                        brand: brand === (0, $zzZbq.AiBrand).AI ? 'Atlassian Intelligence' : 'Rovo'
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).NetworkError:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerOpenAIResponseError:
            case (0, $htnqN.NLPSearchErrorState).AIDisabled:
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $5e3b152f98329dbd$export$defe85febe8b728c).definition_no_answer_network_error,
                    values: {
                        brand: brand === (0, $zzZbq.AiBrand).AI ? 'Atlassian Intelligence' : 'Rovo',
                        supportLink: /*#__PURE__*/ $cozmU.createElement($9aa0fbefc962e4d5$var$InfoLink, {
                            href: (0, $15c17b140b3e21b2$export$50e6b843de210064),
                            target: '_blank'
                        }, formatMessage((0, $5e3b152f98329dbd$export$defe85febe8b728c).definitions_support_link_text))
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).HIPAAError:
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $5e3b152f98329dbd$export$defe85febe8b728c).definitions_no_answer_error_state_hipaa,
                    values: {
                        supportLink: /*#__PURE__*/ $cozmU.createElement($9aa0fbefc962e4d5$var$InfoLink, {
                            href: (0, $15c17b140b3e21b2$export$dd87179defae3659),
                            target: '_blank'
                        }, formatMessage((0, $5e3b152f98329dbd$export$defe85febe8b728c).definitions_no_answer_hipaa_compliance_link))
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).NoAnswer:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerKeywords:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerSearchResults:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerHydration:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerRelevantContent:
            case (0, $htnqN.NLPSearchErrorState).Default:
            default:
                return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $5e3b152f98329dbd$export$defe85febe8b728c).definition_no_answer_error,
                    values: {
                        brand: brand === (0, $zzZbq.AiBrand).AI ? 'Atlassian Intelligence' : 'Rovo'
                    }
                });
        }
    }, [
        errorState,
        formatMessage,
        brand
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9aa0fbefc962e4d5$var$styles.errorPadding
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9aa0fbefc962e4d5$var$styles.errorMessage
    }, errorMessage), showAddDefinitionButton && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        justifyContent: "end",
        alignItems: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: ()=>setShowEditDefinitionModal(true)
    }, formatMessage((0, $5e3b152f98329dbd$export$defe85febe8b728c).definition_no_answer_add_definition_button)))), /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, showEditDefinitionModal && showAddDefinitionButton && /*#__PURE__*/ $cozmU.createElement((0, $46b3319f0a259942$export$ea8c8594ad1f3bf3), {
        curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
        closeEditModal: ()=>setShowEditDefinitionModal(false),
        isCreateDefinition: true,
        onSaveEditModal: ()=>setDisplaySuccessFlag(true)
    })), displaySuccessFlag && /*#__PURE__*/ $cozmU.createElement((0, $6cecfbe2a7b0bbf1$export$7475d9ffda76c69b), {
        onDismissed: ()=>setDisplaySuccessFlag(false)
    }));
};








/* ai-answer-result-section.tsx generated by @compiled/babel-plugin v2.0.0 */ 










const $dc507febe9bd909d$export$d74b491f1ba95e72 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isReadingAids: isReadingAids, serveDefinitionUXExp: serveDefinitionUXExp, isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_17h6egw": (0, $9aYkv.default)(__cmplp.serveDefinitionUXExp ? "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)" : "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"),
            "--_4xki78": (0, $9aYkv.default)(__cmplp.serveDefinitionUXExp ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $zzZbq.READING_AIDS_DIALOG_WIDTH) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `calc(${0, $zzZbq.READING_AIDS_DIALOG_WIDTH} - 40px)`),
            "--_1wfhr4q": (0, $9aYkv.default)(__cmplp.isExpanded ? 'fit-content' : '120px')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "",
            __cmplp.isReadingAids ? "_2sNsIgLMcr _1UtDYzyXux _1EqgXlX4J4 _0NUa3rm0pH _2WAcuGnQyn _1AiXLTxAvX" : "_2sNsIgmnOE _1UtDYzUktF _2WAcuGIZbP _39xV02N91d",
            __cmplp.className
        ])
    });
});


/* info-link.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $99356d7abc78c115$export$aef3857145d55f98 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _1UtDYz66Yw",
            __cmplp.className
        ])
    });
});


const $f366b75433df2895$export$ffa24cd7196ce1b0 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { advancedSearchUrl: advancedSearchUrl, commonAttributes: commonAttributes, isReadingAids: isReadingAids, brand: brand, smartAnswersRoute: smartAnswersRoute, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const { errorState: errorState, errorCode: errorCode, answerCardType: answerCardType, source: source, apiSource: apiSource, searchSessionId: searchSessionId, sessionId: sessionId, queryHash: queryHash } = commonAttributes;
    const { trackAIResultError: trackAIResultError } = (0, $cXLoX.useAIEventsInstrumentation)();
    (0, $cozmU.useEffect)(()=>{
        if (errorState !== (0, $htnqN.NLPSearchErrorState).Default) {
            trackAIResultError({
                aiErrorMessage: errorState || '',
                aiErrorCode: errorCode ?? 0
            }, {
                attributes: {
                    aiExperienceName: (0, $b8dde4ad487d9f98$export$38439c13a4683ecf)(smartAnswersRoute),
                    aiFeatureName: isReadingAids ? `Definitions ${sourceProduct ? `(${sourceProduct})` : ''}` : 'smartAnswers',
                    aiInteractionId: isReadingAids ? undefined : searchSessionId,
                    aiInteractionType: isReadingAids ? undefined : 'searchSessionId'
                }
            });
            if ((0, $iDrrr.fg)('kd_enable_networkerror_logging')) (0, $cuvLu.logger).error({
                error: {
                    errorState: errorState,
                    errorCode: errorCode,
                    answerCardType: answerCardType,
                    source: source,
                    apiSource: apiSource,
                    sessionId: sessionId,
                    queryHash: queryHash
                },
                functionName: 'AIAnswerError'
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const brandName = brand === (0, $zzZbq.AiBrand).ROVO ? 'Rovo' : 'Atlassian Intelligence';
    const errorMessage = (0, $cozmU.useMemo)(()=>{
        switch(errorState){
            case (0, $htnqN.NLPSearchErrorState).NoAnswer:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerSearchResults:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerHydration:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerRelevantContent:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_error_state_no_answer,
                    values: {
                        brandName: brandName,
                        learnMoreLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99356d7abc78c115$export$aef3857145d55f98), {
                            href: (0, $zzZbq.ATLASSIAN_INTELLIGENCE_SEARCH_INFO_LINK),
                            target: '_blank'
                        }, formatMessage((0, $cb86z.messages).ai_answer_onboarding_banner_tooltip_link))
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).NoAnswerKeywords:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_error_state_keyword,
                    values: {
                        brandName: brandName,
                        learnMoreLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99356d7abc78c115$export$aef3857145d55f98), {
                            href: (0, $zzZbq.ATLASSIAN_INTELLIGENCE_SEARCH_INFO_LINK),
                            target: '_blank'
                        }, formatMessage((0, $cb86z.messages).ai_answer_onboarding_banner_tooltip_link))
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).AcceptableUseViolation:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_error_state_acceptable_use,
                    values: {
                        brandName: brandName,
                        acceptableUseLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99356d7abc78c115$export$aef3857145d55f98), {
                            href: (0, $zzZbq.ATLASSIAN_ACCEPTABLE_USE_POLICY_LINK),
                            target: '_blank'
                        }, formatMessage((0, $cb86z.messages).ai_answer_component_error_state_acceptable_use_link))
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).SubjectiveQuery:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_error_state_subjective_query,
                    values: {
                        brandName: brandName
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).NoAnswerOpenAIRateLimitUserAbuse:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_open_ai_rate_limit_error,
                    values: {
                        brandName: brandName,
                        supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99356d7abc78c115$export$aef3857145d55f98), {
                            href: (0, $zzZbq.ATLASSIAN_AI_USAGE_LIMITS_LINK),
                            target: '_blank'
                        }, formatMessage((0, $cb86z.messages).ai_answer_component_support_link))
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).NoAnswerWhoQuestion:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_error_state_no_who_is_answer,
                    values: {
                        brandName: brandName
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).NetworkError:
            case (0, $htnqN.NLPSearchErrorState).NoAnswerOpenAIResponseError:
            case (0, $htnqN.NLPSearchErrorState).AIDisabled:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_error_state_network,
                    values: {
                        brandName: brandName,
                        supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99356d7abc78c115$export$aef3857145d55f98), {
                            href: (0, $zzZbq.ATLASSIAN_AI_TROUBLESHOOT_LINK),
                            target: '_blank'
                        }, formatMessage((0, $cb86z.messages).ai_answer_component_support_link))
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).HIPAAError:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_error_state_hipaa,
                    values: {
                        supportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $99356d7abc78c115$export$aef3857145d55f98), {
                            href: (0, $zzZbq.ATLASSIAN_HIPAA_COMPLICANCE_LINK),
                            target: '_blank'
                        }, formatMessage((0, $cb86z.messages).ai_answer_component_hipaa_compliance_link))
                    }
                });
            case (0, $htnqN.NLPSearchErrorState).EarlyStop:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7af86847637791a4$export$97b52c363fbe053e), null);
            case (0, $htnqN.NLPSearchErrorState).Default:
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $cb86z.messages).ai_answer_component_result_error_text,
                    values: {
                        brandName: brandName,
                        advancedSearchLink: !!advancedSearchUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                            href: advancedSearchUrl
                        }, formatMessage((0, $cb86z.messages).ai_answer_component_result_error_advanced_search_link)) : formatMessage((0, $cb86z.messages).ai_answer_component_result_error_advanced_search_link)
                    }
                });
        }
    }, [
        advancedSearchUrl,
        errorState,
        formatMessage,
        brandName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "ai-answer-error-container"
    }, isReadingAids ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9aa0fbefc962e4d5$export$f874592093e19f27), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dc507febe9bd909d$export$d74b491f1ba95e72), {
        isReadingAids: isReadingAids,
        isExpanded: true
    }, errorMessage)));
};














var $2uDbg = parcelRequire("2uDbg");










/* open-chat-button.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $bLfHG = parcelRequire("bLfHG");








var $jPaq9 = parcelRequire("jPaq9");











var $dDQsD = parcelRequire("dDQsD");



















const $17ec11618fdbd65e$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ai_answer_component_ai_answer_open_chat: {
        id: "search_ai.ai_answer_open_chat",
        defaultMessage: "Open chat"
    },
    ai_answer_component_ai_answer_ask_more_chat: {
        id: "search_ai.ai_answer_ask_more_chat",
        defaultMessage: "Ask more in Chat"
    },
    ai_answer_component_ai_answer_ask_more_chat_submit: {
        id: "search_ai.ai_answer_ask_more_chat_submit",
        defaultMessage: "Submit"
    }
});


const $1781bd9c74b8683a$var$styles = {
    chatButtonContainer: "_39xV02E6Kk"
};
const $1781bd9c74b8683a$export$dc40dedc9df6e59f = ({ prompt: prompt, answerString: answerString, query: query, source: source })=>{
    const { commonAttributes: commonAttributes, isReadingAids: isReadingAids, onClose: onClose, readingAidsOptions: readingAidsOptions } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    const onOpenChatClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $dDQsD.onOpenChatButtonClick)({
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).OPEN_CHAT_CLICKED,
            commonAttributes: commonAttributes
        });
        // callback is shared with followups
        // used in the issue model view to open up chat in a new tab
        // this is because we don't have access to dismiss the issue view modal
        if (readingAidsOptions?.onFollowUpCallback) {
            readingAidsOptions.onFollowUpCallback(prompt);
            return;
        }
        publish({
            type: 'chat-new',
            source: source,
            data: {
                name: query.substring(0, 30),
                dialogues: [
                    {
                        human_message: {
                            content: prompt
                        },
                        agent_message: {
                            content: answerString
                        }
                    }
                ],
                sourceId: commonAttributes.searchSessionId
            }
        });
        onClose?.();
    }, [
        query,
        answerString,
        publish,
        onClose,
        commonAttributes,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        prompt,
        source,
        readingAidsOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    }, serveDefinitionUXUpdates && isReadingAids || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1781bd9c74b8683a$var$styles.chatButtonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))),
        spacing: (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() ? 'default' : 'compact',
        shouldFitContainer: false,
        onClick: onOpenChatClick,
        testId: "definition-open-chat-button"
    }, formatMessage((0, $17ec11618fdbd65e$export$defe85febe8b728c).ai_answer_component_ai_answer_open_chat))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jPaq9.ChatPill), {
        onClick: onOpenChatClick
    }, formatMessage((0, $17ec11618fdbd65e$export$defe85febe8b728c).ai_answer_component_ai_answer_open_chat)));
};











/* definition-footer.tsx generated by @compiled/babel-plugin v2.0.0 */ 

































/* edit-history-modal.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $RfroO = parcelRequire("RfroO");





var $kkFbH = parcelRequire("kkFbH");


var $7A1BE = parcelRequire("7A1BE");


var $kpuvJ = parcelRequire("kpuvJ");


var $ds2zu = parcelRequire("ds2zu");


var $d4GYd = parcelRequire("d4GYd");
















var $iW3KC = parcelRequire("iW3KC");


var $2qJQZ = parcelRequire("2qJQZ");












var $lfoFx = parcelRequire("lfoFx");

























const $c9690aea5fb0b0a7$export$4d25b49b6dc1b540 = (locale)=>{
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from invalid Locale');
    const [, language, country] = match;
    return {
        language: language.toLowerCase(),
        // when country code is missed, let it empty and we will use language/locale to find language file
        country: country ? country.toUpperCase() : ''
    };
};


function $4a1753bc458304c7$export$5ac26fa9b941854e(locale, fetchLanguageFile) {
    const [messages, setMessages] = (0, $cozmU.useState)({});
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        async function startToFetchMessagesByLocale() {
            const { language: language, country: country } = (0, $c9690aea5fb0b0a7$export$4d25b49b6dc1b540)(locale);
            // don't load English messages
            if (language === 'en') return;
            try {
                setIsLoading(true);
                const finalLocale = country ? `${language}-${country}` : language;
                const languageFile = await fetchLanguageFile(finalLocale);
                const newMessages = languageFile.default || languageFile;
                setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            } finally{
                setIsLoading(false);
            }
        }
        startToFetchMessagesByLocale();
    }, [
        fetchLanguageFile,
        locale
    ]);
    return {
        messages: messages,
        isLoading: isLoading
    };
}
const $4a1753bc458304c7$var$WithMessages = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, fetchLanguageFile: fetchLanguageFile } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { messages: messages } = $4a1753bc458304c7$export$5ac26fa9b941854e(intl.locale, fetchLanguageFile);
    let t1;
    if ($[0] !== children || $[1] !== intl.locale || $[2] !== messages) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            messages: messages,
            locale: intl.locale
        }, children);
        $[0] = children;
        $[1] = intl.locale;
        $[2] = messages;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children, fetchLanguageFile: fetchLanguageFile })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { messages: messages } = $4a1753bc458304c7$export$5ac26fa9b941854e(intl.locale, fetchLanguageFile);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        messages: messages,
        locale: intl.locale
    }, children);
};
function $4a1753bc458304c7$export$45d3ca664b6e3027(Component, fetchLanguageFile) {
    return (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4a1753bc458304c7$var$WithMessages, {
            fetchLanguageFile: fetchLanguageFile
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props));
    };
}



























function $7a8fa43e2e417c08$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("8cQty"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("7Ktzp"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("3OvSI"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("3KmhA"));
        case 'et-EE':
        case 'et':
            return (parcelRequire("1AEVX"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("gQR0I"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("fZZNg"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("85e4s"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("5aiwI"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("d0yG9"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("566HE"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("7hJxV"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("8Yv6U"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("6KeUd"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("Xhn9f"));
        case 'pt-PT':
            return (parcelRequire("lKGOU"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("51a3b"));
        case 'sk-SK':
        case 'sk':
            return (parcelRequire("drfHK"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("i8A0w"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("bYxqJ"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("fMBja"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("lFCIm"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("3OZQe"));
        case 'zh-TW':
        case 'zh-HK':
        case 'zh':
            return (parcelRequire("iytmX"));
        case 'zh-ZH':
        case 'zh-CN':
            return (parcelRequire("1sS5a"));
    }
    return Promise.resolve({
        default: {}
    });
}





const $6871b3025cf26e91$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    justNow: {
        id: "com.atlassian.migrations-platform.mpt-timeago.ui.just-now",
        defaultMessage: "just now"
    }
});


const $742565d3da98c155$var$SECOND = 1;
const $742565d3da98c155$var$MINUTE = 60;
const $742565d3da98c155$var$HOUR = $742565d3da98c155$var$MINUTE * 60;
const $742565d3da98c155$var$DAY = $742565d3da98c155$var$HOUR * 24;
const $742565d3da98c155$var$WEEK = $742565d3da98c155$var$DAY * 7;
const $742565d3da98c155$var$MONTH = $742565d3da98c155$var$WEEK * 4.345;
const $742565d3da98c155$var$YEAR = $742565d3da98c155$var$MONTH * 12;
const $742565d3da98c155$var$units = [
    [
        'year',
        $742565d3da98c155$var$YEAR
    ],
    [
        'month',
        $742565d3da98c155$var$MONTH
    ],
    [
        'week',
        $742565d3da98c155$var$WEEK
    ],
    [
        'day',
        $742565d3da98c155$var$DAY
    ],
    [
        'hour',
        $742565d3da98c155$var$HOUR
    ],
    [
        'minute',
        $742565d3da98c155$var$MINUTE
    ],
    [
        'second',
        $742565d3da98c155$var$SECOND
    ]
];
const $742565d3da98c155$var$getRelativeTimeProps = (timeDifferenceInSeconds)=>{
    const relevantUnit = $742565d3da98c155$var$units.find((unit)=>{
        return timeDifferenceInSeconds >= unit[1];
    }) || $742565d3da98c155$var$units[0];
    let props = {
        value: -Math.floor(timeDifferenceInSeconds / relevantUnit[1]),
        unit: relevantUnit[0]
    };
    // Only create the update interval if time difference in seconds, minutes or hours
    // FormattedRelativeTime no longer supports higher than 'hour' for interval update
    // read "Limitation" on https://formatjs.io/docs/react-intl/components/#formattedrelativetime
    if ([
        'second',
        'minute',
        'hour'
    ].includes(relevantUnit[0])) return {
        ...props,
        updateIntervalInSeconds: 60
    };
    return props;
};
const $742565d3da98c155$var$TimeAgo = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { date: date } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = new Date().getTime();
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== date) {
        t2 = new Date(date).getTime();
        $[1] = date;
        $[2] = t2;
    } else t2 = $[2];
    const differenceInSeconds = Math.floor((t1 - t2) / 1000);
    const isLessThanOneMinuteAgo = differenceInSeconds < 60;
    const [showJustNow, setShowJustNow] = (0, $cozmU.useState)(isLessThanOneMinuteAgo);
    let t3;
    let t4;
    if ($[3] !== differenceInSeconds || $[4] !== isLessThanOneMinuteAgo) {
        t3 = ()=>{
            let timeout;
            if (isLessThanOneMinuteAgo) {
                setShowJustNow(true);
                const refreshTime = (60 - differenceInSeconds) * 1000;
                timeout = setTimeout(()=>{
                    setShowJustNow(false);
                }, refreshTime);
            }
            return ()=>{
                if (timeout) clearTimeout(timeout);
            };
        };
        t4 = [
            differenceInSeconds,
            isLessThanOneMinuteAgo
        ];
        $[3] = differenceInSeconds;
        $[4] = isLessThanOneMinuteAgo;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (showJustNow) {
        let t5;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6871b3025cf26e91$export$defe85febe8b728c).justNow);
            $[7] = t5;
        } else t5 = $[7];
        return t5;
    }
    let t5;
    if ($[8] !== differenceInSeconds) {
        t5 = $742565d3da98c155$var$getRelativeTimeProps(differenceInSeconds);
        $[8] = differenceInSeconds;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedRelativeTime), {
            numeric: "always",
            ...t5
        });
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
} : ({ date: date })=>{
    const differenceInSeconds = Math.floor((new Date().getTime() - new Date(date).getTime()) / 1000);
    const isLessThanOneMinuteAgo = differenceInSeconds < 60;
    const [showJustNow, setShowJustNow] = (0, $cozmU.useState)(isLessThanOneMinuteAgo);
    (0, $cozmU.useEffect)(()=>{
        let timeout;
        if (isLessThanOneMinuteAgo) {
            setShowJustNow(true);
            // gonna refresh only once after difference time has passed
            const refreshTime = (60 - differenceInSeconds) * 1000;
            timeout = setTimeout(()=>{
                setShowJustNow(false);
            }, refreshTime);
        }
        return ()=>{
            if (timeout) clearTimeout(timeout);
        };
    }, [
        differenceInSeconds,
        isLessThanOneMinuteAgo
    ]);
    if (showJustNow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $6871b3025cf26e91$export$defe85febe8b728c).justNow);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedRelativeTime), {
        numeric: "always",
        ...$742565d3da98c155$var$getRelativeTimeProps(differenceInSeconds)
    });
};
const $742565d3da98c155$var$_default_1 = (0, $4a1753bc458304c7$export$45d3ca664b6e3027)($742565d3da98c155$var$TimeAgo, (0, $7a8fa43e2e417c08$export$c08b58fa4727b0d2));
var $742565d3da98c155$export$2e2bcd8739ae039 = $742565d3da98c155$var$_default_1;











const $4db956e6a63d7d59$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    readingAidsEditHistoryHeader: {
        id: "contextual-reading-aids.edit-history.header.text",
        defaultMessage: "Edit History"
    },
    readingAidsEditHistoryDescription: {
        id: "contextual-reading-aids.edit-history.description.text",
        defaultMessage: "See all the edits for {queryText}"
    },
    readingAidsEditHistoryCardEdited: {
        id: "contextual-reading-aids.edit-history.card.edited",
        defaultMessage: "{editorName} edited"
    },
    readingAidsEditHistoryCardErrorText: {
        id: "contextual-reading-aids.edit-history.card.error-text",
        defaultMessage: "An error has occurred. Please try again later."
    },
    readingAidsEditHistoryVisibilityTextOrg: {
        id: "contextual-reading-aids.edit-history.visibility.text.org",
        defaultMessage: "This definition is visible to anyone in the entire organization"
    },
    readingAidsEditHistoryVisibilitySpace: {
        id: "contextual-reading-aids.edit-history.visibility.text.space",
        defaultMessage: "This definition is visible to anyone in this space"
    },
    readingAidsEditHistoryVisibilityPage: {
        id: "contextual-reading-aids.edit-history.visibility.text.page",
        defaultMessage: "This definition is visible to anyone viewing this page"
    },
    readingAidsEditHistoryVisibilityBlog: {
        id: "contextual-reading-aids.edit-history.visibility.text.blog",
        defaultMessage: "This definition is visible to anyone viewing this blog"
    },
    readingAidsEditHistoryVisibilityProject: {
        id: "contextual-reading-aids.edit-history.visibility.text.Project",
        defaultMessage: "This definition is visible to anyone viewing this project"
    },
    readingAidsEditHistoryVisibilityProjectGalaxia: {
        id: "contextual-reading-aids.edit-history.visibility.text.Project-galaxia",
        defaultMessage: "This definition is visible to anyone viewing this space"
    }
});











const $f5827dc44319185b$var$DefinitionEditHistoryQuery = `
query DefinitionEditHistoryQuery(
  $workspaceId: String!
  $keyPhrase: String!
	$confluenceScopeId: KnowledgeDiscoveryDefinitionScopeIdConfluence
	$jiraScopeId: KnowledgeDiscoveryDefinitionScopeIdJira
) {
  knowledgeDiscovery {
    definitionHistory(
      workspaceId: $workspaceId
      keyPhrase: $keyPhrase
      confluenceScopeId: $confluenceScopeId
			jiraScopeId: $jiraScopeId
    ) @optIn(to: "KnowledgeDiscovery Get definition history") {
      __typename
      ... on KnowledgeDiscoveryDefinitionList {
        definitions {
          keyPhrase
          definition
          createdAt
          scope
          editor {
            name
            accountId
            picture
          }
          referenceUrl
          confluenceEntity {
            ... on ConfluencePage {
              id
              type
              title
            }
            ... on ConfluenceBlogPost {
              id
              type
              title
            }
          }
        }
      }
      ... on QueryError {
        message
      }
    }
  }
}
`;
const $f5827dc44319185b$export$9ad350b72fa486e = {
    operationName: 'DefinitionEditHistoryQuery',
    query: $f5827dc44319185b$var$DefinitionEditHistoryQuery
};


const $4bf56896f978fce8$export$fd57168bc668244 = (productScopes)=>{
    if ('contentARI' in productScopes) return {
        confluenceScopeId: {
            contentId: productScopes.contentARI,
            spaceId: productScopes.spaceARI
        }
    };
    else return {
        jiraScopeId: {
            projectId: productScopes.projectARI
        }
    };
};


const $bb81ba0ae582511f$export$584199b95393a773 = ({ query: query, curatedDefinitionScopeConfig: curatedDefinitionScopeConfig })=>{
    const [data, setData] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const loading = data === undefined && error === undefined;
    const scopeIds = (0, $4bf56896f978fce8$export$fd57168bc668244)(curatedDefinitionScopeConfig.productScopes);
    (0, $cozmU.useEffect)(()=>{
        const fireRequest = async ()=>{
            try {
                const res = await (0, $i5c0A.fetchAggResponse)({
                    graphQuery: (0, $f5827dc44319185b$export$9ad350b72fa486e).query,
                    operationName: (0, $f5827dc44319185b$export$9ad350b72fa486e).operationName,
                    variables: {
                        workspaceId: curatedDefinitionScopeConfig.workspaceId,
                        keyPhrase: query,
                        ...scopeIds
                    },
                    headers: (0, $7AtIp.createAtlAttributionHeader)({
                        atlWorkspaceId: curatedDefinitionScopeConfig.workspaceId,
                        tenantId: curatedDefinitionScopeConfig.cloudId,
                        product: curatedDefinitionScopeConfig.product
                    })
                });
                const { data: data, errors: errors } = res;
                if (!errors && !!data) setData(data);
                else throw new Error(errors?.map((e)=>e.message).join(', '));
            } catch (e) {
                setError(e);
            }
        };
        fireRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const definitions = !error && !data?.knowledgeDiscovery?.definitionHistory?.message ? data?.knowledgeDiscovery?.definitionHistory?.definitions || [] : [];
    return {
        definitions: definitions,
        loading: loading
    };
};


const $e1f862b35321d870$var$styles = {
    loadingSpinner: "_3iDTPbQ4SZ _37wbyuDIqT _0jFU0VN91d _39xV02N91d",
    editHistoryWrapper: "_2mHwu85zaO _2sNsIgmnOE _3iDTPbQ4SZ _0aFT5vbt8w _1wydGWkG2W",
    editHistoryDescription: "_2mHwu81Y8M _1UtDYzy7kJ",
    editedDefinitionCardContainer: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5vbt8w",
    editedDefinitionScopeText: "_3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _1UtDYzKGUX",
    editedDefinitionCard: "_0bjKvDaOBN _2mHwu85zaO _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLchRC _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    editedDefinitionAvatar: "_0bjKvDh73D",
    editedDefinitionCardBody: "_2sNsIgmnOE _2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w _39xV02N91d _1UtDYzy7kJ",
    editedDefinitionCardHeaderWrapper: "_2mHwu8Pgdg _3iDTPbQ4SZ _0aFT5vbt8w",
    editedDefinitionCardHeader: "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _1UtDYzZpcK _1DCdHi2ADO",
    editedDefinitionCardEditor: "_1kk5Tk7GSX _1UtDYzy7kJ",
    editedDefinitionCardReference: "_3iDTPbQ4SZ _0hPCNLDIqT",
    editedDefinitionCardReferenceTitle: "_2XsHFM1Y8M",
    editedDefinitionCardHeaderSpacer: "_39xV02N91d _1UtDYzot27 _313842FQfX _1DCdHidnbC"
};

const $e1f862b35321d870$var$MarkdownRenderer = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("039lM")).then(({ default: ReactMarkdown })=>{
        return {
            default: ReactMarkdown
        };
    }));
const $e1f862b35321d870$var$ScopeDescription = ({ scope: scope })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let scopeDescription = '';
    let ScopeIcon;
    switch(scope){
        case (0, $jkdKe.EditedDefinitionScope).ORGANIZATION:
            scopeDescription = formatMessage((0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryVisibilityTextOrg);
            ScopeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($kpuvJ)));
            break;
        case (0, $jkdKe.EditedDefinitionScope).SPACE:
            scopeDescription = formatMessage((0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryVisibilitySpace);
            ScopeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($ds2zu)));
            break;
        case (0, $jkdKe.EditedDefinitionScope).PAGE:
            scopeDescription = formatMessage((0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryVisibilityPage);
            ScopeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($kkFbH)));
            break;
        case (0, $jkdKe.EditedDefinitionScope).BLOGPOST:
            scopeDescription = formatMessage((0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryVisibilityBlog);
            ScopeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd)));
            break;
        case (0, $jkdKe.EditedDefinitionScope).PROJECT:
            scopeDescription = formatMessage((0, $cXtTj.default).getExperimentValue('project-terminology-refresh', 'isEnabled', false) ? (0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryVisibilityProjectGalaxia : (0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryVisibilityProject);
            ScopeIcon = ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7A1BE))), {
                    color: "var(--ds-icon, #292A2E)",
                    label: ""
                });
            break;
        default:
            return null;
    }
    return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $e1f862b35321d870$var$styles.editedDefinitionScopeText,
        space: "space.050"
    }, scopeDescription, " ", /*#__PURE__*/ $cozmU.createElement(ScopeIcon, {
        label: ""
    }));
};
const $e1f862b35321d870$export$6c43ad171ca78b4f = ({ curatedDefinitionScopeConfig: curatedDefinitionScopeConfig, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { commonAttributes: { query: query } } = (0, $3hVWe.useAIAnswerContext)();
    const { definitions: definitions, loading: loading } = (0, $bb81ba0ae582511f$export$584199b95393a773)({
        query: query,
        curatedDefinitionScopeConfig: curatedDefinitionScopeConfig
    });
    const hasError = definitions.length === 0 && !loading;
    return /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: onClose,
        height: 600
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, formatMessage((0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryHeader))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $e1f862b35321d870$var$styles.editHistoryWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        xcss: $e1f862b35321d870$var$styles.editHistoryDescription
    }, formatMessage((0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryDescription, {
        queryText: /*#__PURE__*/ $cozmU.createElement("b", null, query)
    })), hasError || loading ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $e1f862b35321d870$var$styles.loadingSpinner
    }, loading && /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "large",
        testId: "definition-history-loading-spinner"
    }), hasError && /*#__PURE__*/ $cozmU.createElement((0, $RfroO.default), {
        header: formatMessage((0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryCardErrorText)
    })) : definitions.map((item, index)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e1f862b35321d870$var$styles.editedDefinitionCardContainer,
            key: `edited-definition-history-card-${index}`
        }, /*#__PURE__*/ $cozmU.createElement($e1f862b35321d870$var$ScopeDescription, {
            scope: item.scope
        }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e1f862b35321d870$var$styles.editedDefinitionCard
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e1f862b35321d870$var$styles.editedDefinitionAvatar
        }, /*#__PURE__*/ $cozmU.createElement("img", {
            src: item.editor?.picture || '',
            width: "32px",
            height: "32px"
        })), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e1f862b35321d870$var$styles.editedDefinitionCardBody
        }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e1f862b35321d870$var$styles.editedDefinitionCardHeaderWrapper
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            xcss: $e1f862b35321d870$var$styles.editedDefinitionCardHeader
        }, formatMessage((0, $4db956e6a63d7d59$export$defe85febe8b728c).readingAidsEditHistoryCardEdited, {
            editorName: /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                xcss: $e1f862b35321d870$var$styles.editedDefinitionCardEditor
            }, item.editor?.name || '')
        }), " \u2219 ", /*#__PURE__*/ $cozmU.createElement((0, $742565d3da98c155$export$2e2bcd8739ae039), {
            date: Number(item.createdAt) * 1000
        })), /*#__PURE__*/ $cozmU.createElement("hr", {
            role: "presentation",
            className: (0, $hekY6.default)([
                $e1f862b35321d870$var$styles.editedDefinitionCardHeaderSpacer
            ])
        })), /*#__PURE__*/ $cozmU.createElement("span", {
            "data-testid": `rendered-markdown-definition-${index}`
        }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
        }, /*#__PURE__*/ $cozmU.createElement($e1f862b35321d870$var$MarkdownRenderer, {
            disallowedElements: (0, $iDrrr.fg)('hybrid_orchestrator_enable_image_search') ? undefined : [
                'img'
            ]
        }, item.definition))), item.referenceUrl && item.confluenceEntity?.title && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e1f862b35321d870$var$styles.editedDefinitionCardReference
        }, /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
            appearance: "subtle",
            target: "_blank",
            href: item.referenceUrl
        }, item.confluenceEntity.type === 'BLOG_POST' ? /*#__PURE__*/ $cozmU.createElement((0, $iW3KC.default), {
            label: ""
        }) : /*#__PURE__*/ $cozmU.createElement((0, $2qJQZ.default), {
            label: ""
        }), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            xcss: $e1f862b35321d870$var$styles.editedDefinitionCardReferenceTitle
        }, item.confluenceEntity.title || ''))))))))), /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null));
};





const $bc9bd53230eb9105$export$bfe6deae035e3ea7 = (props)=>({
        action: 'clicked',
        actionSubject: 'aiDefinitionsDisableDefinition',
        source: 'viewPageScreen',
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        }
    });





const $7abdbf6c5e9a205a$export$48200d71a3e25afe = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiDefinitionToggle',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};









var $7ZB0A = parcelRequire("7ZB0A");


var $93fnf = parcelRequire("93fnf");


var $c8bBH = parcelRequire("c8bBH");






















const $034e96ea26fdac56$export$c4c8b81ee90e6af2 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDislikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};





const $b74522729de50e18$export$5b155f527aff26b9 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerLikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};


/* feedback-button-icon-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 







const $d21263489499d51e$export$5d384d799a8fb604 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_169wk05": (0, $9aYkv.default)(__cmplp.active ? "var(--ds-text-accent-blue, #1558BC)" : "var(--ds-text-subtlest, #6B6E76)"),
            "--_hohrgu": (0, $9aYkv.default)(__cmplp.isDisabled ? 'not-allowed' : 'default')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0wOv4Qb84s _3VB8wb5uWe",
            __cmplp.className
        ])
    });
});





const $260c725c14a7c456$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    definition_footer_defined_by_text: {
        id: "search_ai.definition_footer_defined_by_text",
        defaultMessage: "Defined by"
    },
    definition_footer_see_edit_history: {
        id: "search_ai.definition_footer_see_edit_history",
        defaultMessage: "See all edit history"
    },
    definition_footer_like_button_tooltip: {
        id: "search_ai.definition_footer_like_button_tooltip",
        defaultMessage: "Good response"
    },
    definition_footer_dislike_button_tooltip: {
        id: "search_ai.definition_footer_dislike_button_tooltip",
        defaultMessage: "Bad response"
    },
    definition_footer_hide_term_definition_message: {
        id: "search_ai.definition_footer_hide_term_definition_message",
        defaultMessage: "Don't define this again"
    },
    definition_footer_beta_status_label: {
        id: "search_ai.definition_footer.beta_status_label",
        defaultMessage: "Beta"
    },
    definition_footer_disclaimer: {
        id: "search_ai.definition_footer_disclaimer",
        defaultMessage: "Uses AI. Verify results."
    },
    definition_footer_powered_by_AI: {
        id: "search_ai.definition_footer_powered_by_AI",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    definition_footer_rovo_label: {
        id: "search_ai.definition_footer_rovo_label",
        defaultMessage: "Rovo"
    },
    definition_footer_editor_handle: {
        id: "search_ai.definition_footer_editor_handle",
        defaultMessage: "@{name}"
    },
    definition_footer_feedback_options_modal_header_feedback_only: {
        id: "search_ai.definition_footer_feedback_options_modal_header_feedback_only",
        defaultMessage: "Leave feedback"
    },
    definition_footer_feedback_options_modal_header: {
        id: "search_ai.definition_footer_feedback_options_modal_header",
        defaultMessage: "Correct definition or leave feedback"
    },
    definition_footer_feedback_options_edit_definition_option: {
        id: "search_ai.definition_footer_feedback_options_edit_definition_option",
        defaultMessage: "I want to edit this definition"
    },
    definition_footer_feedback_options_edit_definition_option_subtext: {
        id: "search_ai.definition_footer_feedback_options_edit_definition_option_subtext",
        defaultMessage: "Update the definition."
    },
    definition_footer_feedback_options_leave_feedback_option: {
        id: "search_ai.definition_footer_feedback_options_leave_feedback_option",
        defaultMessage: "I want to leave feedback about this feature"
    },
    definition_footer_feedback_options_leave_feedback_option_subtext: {
        id: "search_ai.definition_footer_feedback_options_leave_feedback_option_subtext",
        defaultMessage: "Share your feedback so we can improve these experiences."
    },
    definition_footer_feedback_modal_header: {
        id: "search_ai.definition_footer_feedback_modal_header",
        defaultMessage: "Help us improve Definitions"
    },
    definition_footer_feedback_consent_checkbox_label: {
        id: "search_ai.definition_footer_feedback_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    definition_footer_feedback_report_label: {
        id: "search_ai.definition_footer_feedback_report_label",
        defaultMessage: "Was there a problem with this definition? Let us know what happened."
    },
    definition_footer_feedback_report_details_label: {
        id: "search_ai.definition_footer_feedback_report_details_label",
        defaultMessage: "Describe the issue"
    },
    definition_footer_feedback_report_empty_option_share_label: {
        id: "search_ai.definition_footer_feedback_report_empty_option_share_label",
        defaultMessage: "I want to share..."
    },
    definition_footer_feedback_report_relevance_option_label: {
        id: "search_ai.definition_footer_feedback_report_relevance_option_label",
        defaultMessage: "This isn\u2019t relevant or isn\u2019t what I expected"
    },
    definition_footer_feedback_report_inaccurate_option_label: {
        id: "search_ai.definition_footer_feedback_report_inaccurate_option_label",
        defaultMessage: "This is inaccurate or misleading"
    },
    definition_footer_feedback_report_offensive_option_label: {
        id: "search_ai.definition_footer_feedback_report_offensive_option_label",
        defaultMessage: "This is offensive or harmful"
    },
    definition_footer_feedback_report_other_option_label: {
        id: "search_ai.definition_footer_feedback_report_other_option_label",
        defaultMessage: "Something else"
    },
    definition_footer_feedback_summary_placeholder_label: {
        id: "search_ai.definition_footer_feedback_summary_placeholder_label",
        defaultMessage: "Explain the problem you experienced"
    },
    definition_footer_feedback_flag_description: {
        id: "search_ai.definition_footer_feedback_flag_descriptionl",
        defaultMessage: "We appreciate you taking the time to send this feedback"
    }
});


/* rotate180-icon-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $6da3784cdd7e473f$export$8b5c58bc12f52d53 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2xvoozl236",
            __cmplp.className
        ])
    });
});


const $48778ee853c2cfa9$var$FeedbackButton = ({ active: active, isDisabled: isDisabled, onClick: onClickHandler, tooltipContent: tooltipContent, testId: testId, icon: icon })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: 'top',
        content: tooltipContent
    }, ({ onClick: _onClick, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            "aria-label": tooltipContent,
            spacing: 'none',
            appearance: isDisabled ? 'subtle-link' : 'subtle',
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d21263489499d51e$export$5d384d799a8fb604), {
                active: active,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    cursor: 'pointer'
                },
                ...testId && {
                    'data-testid': testId
                },
                isDisabled: isDisabled || false
            }, icon),
            ...!isDisabled && {
                onClick: onClickHandler
            },
            ...tooltipProps
        }));
};
const $48778ee853c2cfa9$export$c633fc044a8b8981 = ({ setShowFeedbackOptionsModal: setShowFeedbackOptionsModal, setDisplayFlag: setDisplayFlag })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, updateContextCache: updateContextCache, liked: liked, setLiked: setLiked, likesDisabled: likesDisabled, setLikesDisabled: setLikesDisabled } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    // Using a single state to represent both like/dislike states
    // true - liked, false - disliked, undefined - neither are selected
    const likeButtonCallback = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        setDisplayFlag(true);
        setLiked(true);
        setLikesDisabled(true);
        updateContextCache({
            collapsed: false,
            liked: true
        });
        fireAnalyticsEvent((0, $b74522729de50e18$export$5b155f527aff26b9)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).POSITIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    }, [
        setLiked,
        setLikesDisabled,
        fireAnalyticsEvent,
        commonAttributes,
        updateContextCache,
        setDisplayFlag,
        fireSAINUsageEvent
    ]);
    const dislikeButtonCallback = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        setShowFeedbackOptionsModal(true);
        setLiked(false);
        setLikesDisabled(true);
        updateContextCache({
            collapsed: false,
            liked: false
        });
        fireAnalyticsEvent((0, $034e96ea26fdac56$export$c4c8b81ee90e6af2)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).NEGATIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    }, [
        setLiked,
        setLikesDisabled,
        fireAnalyticsEvent,
        commonAttributes,
        updateContextCache,
        setShowFeedbackOptionsModal,
        fireSAINUsageEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($48778ee853c2cfa9$var$FeedbackButton, {
        active: liked === true,
        onClick: likeButtonCallback,
        tooltipContent: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_like_button_tooltip),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)",
            size: serveDefinitionUXUpdates ? 'small' : 'medium'
        }),
        isDisabled: liked && likesDisabled,
        testId: "definition-footer-like-button"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($48778ee853c2cfa9$var$FeedbackButton, {
        active: liked === false,
        onClick: dislikeButtonCallback,
        tooltipContent: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_dislike_button_tooltip),
        icon: serveDefinitionUXUpdates ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
            label: "",
            spacing: "spacious",
            size: "small",
            color: "var(--ds-icon, #292A2E)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6da3784cdd7e473f$export$8b5c58bc12f52d53), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)"
        })),
        isDisabled: !liked && likesDisabled,
        testId: "definition-footer-dislike-button"
    }));
};


/* feedback-modal.tsx generated by @compiled/babel-plugin v2.0.0 */ 
















const $e66bc4e4b70c4191$var$styles = {
    root: "_1wydGW5zaO"
};

const $e66bc4e4b70c4191$var$AkFeedbackCollector = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hUVfy")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $e66bc4e4b70c4191$export$5efdacda4e928df9 = ({ setFeedbackModal: setFeedbackModal, isCuratedDefinition: isCuratedDefinition, setDisplayFlag: setDisplayFlag })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, readingAidsOptions: readingAidsOptions, userDetails: { name: name, id: id } } = (0, $3hVWe.useAIAnswerContext)();
    const { errorState: errorState } = commonAttributes;
    const [hasConsent, setConsent] = (0, $cozmU.useState)(false);
    const feedbackContextObject = {
        source: commonAttributes.source,
        queryHash: commonAttributes.queryHash,
        cloudId: commonAttributes.cloudId,
        prompt: hasConsent ? commonAttributes.query : undefined,
        answer: hasConsent ? commonAttributes.answerString : undefined,
        documentId: readingAidsOptions?.contentARI,
        errorState: errorState,
        isCuratedDefinition: isCuratedDefinition
    };
    const feedbackContext = Object.entries(feedbackContextObject).map(([key, value])=>`${key}: ${value}`).join(', ');
    const toggleConsentCheckbox = (0, $cozmU.useCallback)(()=>{
        setConsent(!hasConsent);
    }, [
        hasConsent
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement($e66bc4e4b70c4191$var$AkFeedbackCollector, {
        locale: locale,
        onClose: ()=>setFeedbackModal(false),
        onSubmit: ()=>{
            setDisplayFlag(true);
        },
        customContent: isCuratedDefinition ? undefined : /*#__PURE__*/ $cozmU.createElement((0, $2uDbg.Checkbox), {
            label: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_consent_checkbox_label),
            onChange: toggleConsentCheckbox,
            isChecked: hasConsent
        }),
        atlassianAccountId: id,
        name: name,
        entrypointId: (0, $15c17b140b3e21b2$export$dd6343c56092a345),
        additionalFields: [
            {
                id: (0, $15c17b140b3e21b2$export$d04cd98bb7625919),
                value: feedbackContext
            }
        ],
        feedbackTitle: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_modal_header),
        feedbackTitleDetails: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $e66bc4e4b70c4191$var$styles.root
        }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_label)),
        feedbackGroupLabels: {
            empty: {
                fieldLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_details_label),
                selectOptionLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_empty_option_share_label)
            },
            question: {
                fieldLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_details_label),
                selectOptionLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_relevance_option_label)
            },
            comment: {
                fieldLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_details_label),
                selectOptionLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_inaccurate_option_label)
            },
            bug: {
                fieldLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_details_label),
                selectOptionLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_offensive_option_label)
            },
            suggestion: {
                fieldLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_details_label),
                selectOptionLabel: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_report_other_option_label)
            }
        },
        summaryPlaceholder: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_summary_placeholder_label)
    })));
};


/* feedback-options-modal.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $gC2EJ = parcelRequire("gC2EJ");


var $gVrmv = parcelRequire("gVrmv");















var $hBYtq = parcelRequire("hBYtq");





const $4f71e91a4b682fe6$var$styles = {
    feedbackOptionsWrapper: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _1wydGWNHnM",
    feedbackOption: "_0bjKvDKxmn _39xV02N91d _0jFU0VmdCj _0KLXru66of _1eOmH6o126",
    feedbackOptionIconWrapper: "_0bjKvDcjp5 _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VUofl _39xV02Uofl",
    feedbackOptionText: "_2sNsIgmnOE _1UtDYzy7kJ",
    feedbackOptionSubText: "_2sNsIg7NXe _1UtDYzKGUX"
};
const $4f71e91a4b682fe6$export$dc5d3996368c6525 = ({ setShowFeedbackOptionsModal: setShowFeedbackOptionsModal, setShowEditDefinitionModal: setShowEditDefinitionModal, setShowFeedbackModal: setShowFeedbackModal, editDefinitionEnabled: editDefinitionEnabled })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: ()=>setShowFeedbackOptionsModal(false),
        shouldReturnFocus: (0, $ieeJu.expValEquals)('a11y-fixes-week1-june-2026', 'isEnabled', true)
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), null, formatMessage(editDefinitionEnabled ? (0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_options_modal_header : (0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_options_modal_header_feedback_only))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOptionsWrapper
    }, editDefinitionEnabled && /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOption,
        onClick: ()=>{
            setShowFeedbackOptionsModal(false);
            setShowEditDefinitionModal(true);
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        backgroundColor: "color.background.accent.blue.subtle",
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOptionIconWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    })), /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        direction: "column",
        gap: "space.025",
        alignItems: "start"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOptionText
    }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_options_edit_definition_option)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOptionSubText
    }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_options_edit_definition_option_subtext))))), /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOption,
        onClick: ()=>{
            setShowFeedbackOptionsModal(false);
            setShowFeedbackModal(true);
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        backgroundColor: "color.background.accent.blue.subtle",
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOptionIconWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gVrmv))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-inverse, #FFFFFF)"
    })), /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        direction: "column",
        gap: "space.025",
        alignItems: "start"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOptionText
    }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_options_leave_feedback_option)), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4f71e91a4b682fe6$var$styles.feedbackOptionSubText
    }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_options_leave_feedback_option_subtext))))))));
};


/* footer-section.tsx generated by @compiled/babel-plugin v2.0.0 */ 















var $gC0KQ = parcelRequire("gC0KQ");


var $1NXxl = parcelRequire("1NXxl");


var $fodiz = parcelRequire("fodiz");


















var $lRkXe = parcelRequire("lRkXe");


var $22Zs7 = parcelRequire("22Zs7");


var $IOtUu = parcelRequire("IOtUu");














/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // want color of icon to be the same for regular/light/dark modes



const $3f9ffb3b57d400e5$export$eaf821108be3620b = ({ size: size = 'small', greyed: greyed = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        height: size === 'smaller' ? '16' : size === 'small' ? '18' : size === 'medium' ? '20' : '24',
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.5 15.3L17.5 18.3",
        stroke: "#626F86",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M9.5 15.3L6.5 18.3",
        stroke: "#626F86",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M9.5 10.3L6.5 7.30002",
        stroke: "#626F86",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M14.5 10.3L17.5 7.30002",
        stroke: "#626F86",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.0001 16.8V19.8",
        stroke: "#626F86",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M8.00012 12.8L5.00012 12.8",
        stroke: "#626F86",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M12.0001 8.80003L12.0001 5.8",
        stroke: "#626F86",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.0002 12.8L19.0002 12.8",
        stroke: "#626F86",
        strokeWidth: "1.5"
    }));




const $28f26dee3ae80794$export$d80f83cdfda72179 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    const { contentId: contentId, readingAidsSessionId: readingAidsSessionId } = extraAttributes || {};
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionSeeEditHistoryButton',
        source: source,
        eventType: 'ui',
        attributes: {
            contentId: contentId,
            readingAidsSessionId: readingAidsSessionId
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};






const $6fa35d25205670c8$var$styles = {
    aiFooter: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0Of8r21Y8M _1wydGW1Y8M _2Zuz6QkG2W _1ZnuxbkG2W _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _39xV02N91d",
    aiFooterUpdates: "_2Zuz6Q5zaO _1Znuxb5zaO",
    rovoWrapper: "_0Of8r21Y8M _1wydGW1Y8M",
    contentMayVaryWrapper: "_2mHwu81Y8M _2sNsIg7NXe _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYzKGUX",
    brandWrapper: "_2sNsIg7NXe _3iDTPbQ4SZ _0hPCNLDIqT _1UtDYzKGUX",
    editedByFooter: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0Of8r28HPE _1wydGW8HPE _2Zuz6QkG2W _1ZnuxbkG2W _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    editedByWrapper: "_0bjKvDS5Zs _3iDTPbQ4SZ _0KLXruDMqu _2Zuz6Q1Y8M _1Znuxb1Y8M _2XsHFM1Y8M _0wOv4Q7zJH _1eOmH6KcZT",
    definedByWrapper: "_2XsHFM2ADO",
    activeEditedByWrapper: "_0bjKvDS5Zs _3iDTPbQ4SZ _0KLXruKcZT _2Zuz6Q1Y8M _1Znuxb1Y8M _2XsHFM1Y8M _0wOv4Q7zJH",
    editHistoryWrapper: "_2sNsIg7NXe _3iDTPbQ4SZ _1UtDYzM7Tp _2Zuz6QNHnM _0wOv4Q7zJH _0KLXru66of _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8"
};

const $6fa35d25205670c8$var$AkFeedbackFlag = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hUVfy")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $6fa35d25205670c8$export$8c09939f07ae58e2 = ()=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const { answerEditor: answerEditor, brand: brand, readingAidsOptions: readingAidsOptions } = (0, $3hVWe.useAIAnswerContext)();
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editDefinitionEnabled = !!definitionCurationOptions;
    const [showFeedbackOptionsModal, setShowFeedbackOptionsModal] = (0, $cozmU.useState)(false);
    const [showEditDefinitionModal, setShowEditDefinitionModal] = (0, $cozmU.useState)(false);
    const [showFeedbackModal, setShowFeedbackModal] = (0, $cozmU.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $cozmU.useState)(false);
    const [displaySuccessFlag, setDisplaySuccessFlag] = (0, $cozmU.useState)(false);
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($6fa35d25205670c8$var$styles.aiFooter, serveDefinitionUXUpdates && $6fa35d25205670c8$var$styles.aiFooterUpdates)
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6fa35d25205670c8$var$styles.contentMayVaryWrapper
    }, brand === (0, $zzZbq.AiBrand).ROVO ? null : /*#__PURE__*/ $cozmU.createElement((0, $IOtUu.default), {
        text: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_beta_status_label),
        isRemovable: false,
        migration_fallback: "lozenge"
    }), /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        size: "small"
    }), /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
        rel: "noopener noreferrer",
        appearance: "subtle",
        href: (0, $15c17b140b3e21b2$export$59da2b3b71a076c7)
    }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_disclaimer))), !serveDefinitionUXUpdates && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6fa35d25205670c8$var$styles.brandWrapper
    }, brand === (0, $zzZbq.AiBrand).ROVO ? /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), null, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.025"
    }, /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
        rel: "noopener noreferrer",
        appearance: "subtle",
        href: (0, $15c17b140b3e21b2$export$2c1028e1e7bf5557)
    }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_rovo_label)), /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC0KQ))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        spacing: "spacious"
    }))) : /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        gap: "space.025"
    }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_powered_by_AI), /*#__PURE__*/ $cozmU.createElement((0, $3f9ffb3b57d400e5$export$eaf821108be3620b), {
        greyed: true,
        size: "large"
    }))), serveDefinitionUXUpdates && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $48778ee853c2cfa9$export$c633fc044a8b8981), {
        setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
        setDisplayFlag: setDisplayFlag
    }))), /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, showFeedbackOptionsModal && /*#__PURE__*/ $cozmU.createElement((0, $4f71e91a4b682fe6$export$dc5d3996368c6525), {
        setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
        setShowEditDefinitionModal: setShowEditDefinitionModal,
        setShowFeedbackModal: setShowFeedbackModal,
        editDefinitionEnabled: editDefinitionEnabled
    }), showFeedbackModal && /*#__PURE__*/ $cozmU.createElement((0, $e66bc4e4b70c4191$export$5efdacda4e928df9), {
        setFeedbackModal: setShowFeedbackModal,
        isCuratedDefinition: !!answerEditor,
        setDisplayFlag: setDisplayFlag
    }), showEditDefinitionModal && editDefinitionEnabled && /*#__PURE__*/ $cozmU.createElement((0, $46b3319f0a259942$export$ea8c8594ad1f3bf3), {
        curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
        closeEditModal: ()=>setShowEditDefinitionModal(false),
        openFeedbackOptionsModal: ()=>setShowFeedbackOptionsModal(true),
        onSaveEditModal: ()=>setDisplaySuccessFlag(true)
    })), displayFlag && /*#__PURE__*/ $cozmU.createElement((0, $lqtHz.default), {
        onDismissed: ()=>setDisplayFlag(false)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement($6fa35d25205670c8$var$AkFeedbackFlag, {
        locale: locale,
        description: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_flag_description)
    }))), displaySuccessFlag && /*#__PURE__*/ $cozmU.createElement((0, $6cecfbe2a7b0bbf1$export$7475d9ffda76c69b), {
        onDismissed: ()=>setDisplaySuccessFlag(false)
    }));
};
const $6fa35d25205670c8$var$DEFAULT_GRAPHQL_DIRECTORY_ENDPOINT = '/gateway/api/directory/graphql';
const $6fa35d25205670c8$var$profileClient = new (0, $lRkXe.default)({
    url: $6fa35d25205670c8$var$DEFAULT_GRAPHQL_DIRECTORY_ENDPOINT
}); // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
const $6fa35d25205670c8$export$686a5e20bce13f8f = ({ setShowEditHistoryModal: setShowEditHistoryModal })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [editorActive, setEditorActive] = (0, $cozmU.useState)(false);
    const { answerEditor: answerEditor, commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, userDetails: userDetails } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId, orgId: orgId } = commonAttributes;
    if (!answerEditor) return null; // This line should not be reachable since the component is only rendered when answerEditor is defined
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    const editedByLabel = formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_editor_handle, {
        name: answerEditor.name
    });
    const editedByChip = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: editorActive ? $6fa35d25205670c8$var$styles.activeEditedByWrapper : $6fa35d25205670c8$var$styles.editedByWrapper
    }, editedByLabel);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6fa35d25205670c8$var$styles.editedByFooter
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        gap: "space.100",
        alignItems: "start",
        direction: "column"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($1NXxl))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6fa35d25205670c8$var$styles.definedByWrapper
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_defined_by_text))), (0, $iDrrr.fg)('people-teams_migrate-user-profile-card') || (0, $cXtTj.default).getExperimentValue('pt_user_profile_card_migration_exp', 'isEnabled', false) ? /*#__PURE__*/ $cozmU.createElement((0, $9zU5G.UserProfileCardWithTrigger), {
        userId: answerEditor.id,
        cloudId: cloudId,
        orgId: orgId,
        viewerId: userDetails.id,
        trigger: "click"
    }, editedByChip) : /*#__PURE__*/ $cozmU.createElement((0, $22Zs7.default), {
        userId: answerEditor.id,
        cloudId: cloudId,
        resourceClient: $6fa35d25205670c8$var$profileClient,
        trigger: "click",
        onVisibilityChange: setEditorActive
    }, editedByChip)), !serveDefinitionUXUpdates && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $6fa35d25205670c8$var$styles.editHistoryWrapper,
        onClick: ()=>{
            fireAnalyticsEvent((0, $28f26dee3ae80794$export$d80f83cdfda72179)(commonAttributes));
            setShowEditHistoryModal(true);
        }
    }, formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_see_edit_history))));
};












const $32db7c8b5692d4b1$export$8a69382ce91c952a = `
	mutation ToggleDefinitionMutation(
		$workspaceId: String!
		$keyPhrase: String!
		$isDisabled: Boolean
		) {
		knowledgeDiscovery {
			updateUserKeyPhraseInteraction(
				input: {
					workspaceId: $workspaceId
					keyPhrase: $keyPhrase
					isDisabled: $isDisabled
				}
			) @optIn(to: "KnowledgeDiscovery Update User KeyPhrase Interaction") {
				success
				errors {
					message
				}
			}
		}
	}
`;


const $8ed7fc4a26d403e8$export$6e73bcf8826d31a5 = ()=>{
    const toggleDefinition = (0, $cozmU.useCallback)(async ({ workspaceId: workspaceId, keyPhrase: keyPhrase, isDisabled: isDisabled, cloudId: cloudId, product: product })=>{
        return (0, $i5c0A.fetchAggResponse)({
            graphQuery: (0, $32db7c8b5692d4b1$export$8a69382ce91c952a),
            variables: {
                workspaceId: workspaceId,
                keyPhrase: keyPhrase,
                isDisabled: isDisabled
            },
            headers: (0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: product
            })
        }).then((response)=>{
            if (response?.data?.knowledgeDiscovery.updateUserKeyPhraseInteraction?.success) return {
                toggleDefinitionSuccess: true
            };
            else throw new Error('toggleDefinition mutation unsuccessful');
        });
    }, []);
    return {
        toggleDefinition: toggleDefinition
    };
};


const $bd504f15d238fab3$var$styles = {
    root: "_2sNsIgmnOE _3iDTPbQ4SZ _0hPCNLDIqT _1DCdHi1Y8M _1UtDYzUktF _2Zuz6QNHnM _1ZnuxbNHnM"
};

const $bd504f15d238fab3$var$AkFeedbackFlag = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hUVfy")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $bd504f15d238fab3$var$AI_DEFINITION_TOGGLE_CACHE_KEY = 'atlassian.search-ai.ai-definition-toggle';
const $bd504f15d238fab3$export$9de8ba80314e4213 = ()=>{
    const { answerEditor: answerEditor, fireAnalyticsEvent: fireAnalyticsEvent, readingAidsOptions: readingAidsOptions, isAnswered: isAnswered, hasError: hasError, commonAttributes: commonAttributes, definitionToggleEnabled: definitionToggleEnabled, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const { query: keyPhrase, workspaceId: workspaceId, cloudId: cloudId } = commonAttributes;
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const [showFeedbackOptionsModal, setShowFeedbackOptionsModal] = (0, $cozmU.useState)(false);
    const [showEditDefinitionModal, setShowEditDefinitionModal] = (0, $cozmU.useState)(false);
    const [showFeedbackModal, setShowFeedbackModal] = (0, $cozmU.useState)(false);
    const [showEditHistoryModal, setShowEditHistoryModal] = (0, $cozmU.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $cozmU.useState)(false);
    const [displaySuccessFlag, setDisplaySuccessFlag] = (0, $cozmU.useState)(false);
    const cachedTermDefinitionDisabled = JSON.parse((0, $6JEx2.getSessionItem)($bd504f15d238fab3$var$AI_DEFINITION_TOGGLE_CACHE_KEY) || '{}');
    const [termDefinitionDisabled, setTermDefinitionDisabled] = (0, $cozmU.useState)(cachedTermDefinitionDisabled.keyPhrase === keyPhrase);
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editDefinitionEnabled = !!definitionCurationOptions;
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    const { toggleDefinition: toggleDefinition } = (0, $8ed7fc4a26d403e8$export$6e73bcf8826d31a5)();
    const onToggleDefinitionDisable = async ()=>{
        try {
            setTermDefinitionDisabled((current)=>!current);
            await toggleDefinition({
                workspaceId: workspaceId,
                keyPhrase: keyPhrase,
                isDisabled: !termDefinitionDisabled,
                cloudId: cloudId,
                product: sourceProduct ?? ''
            });
            if (termDefinitionDisabled) (0, $6JEx2.deleteSessionItem)($bd504f15d238fab3$var$AI_DEFINITION_TOGGLE_CACHE_KEY);
            else {
                fireAnalyticsEvent((0, $bc9bd53230eb9105$export$bfe6deae035e3ea7)(commonAttributes));
                (0, $6JEx2.setSessionItem)($bd504f15d238fab3$var$AI_DEFINITION_TOGGLE_CACHE_KEY, JSON.stringify({
                    keyPhrase: keyPhrase
                }));
            }
        } catch (error) {
            setTermDefinitionDisabled((current)=>!current);
            fireAnalyticsEvent((0, $7abdbf6c5e9a205a$export$48200d71a3e25afe)(error, commonAttributes));
        }
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, !hasError && isAnswered && !serveDefinitionUXUpdates && /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        xcss: $bd504f15d238fab3$var$styles.root,
        testId: "definition-answer-card-footer"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $48778ee853c2cfa9$export$c633fc044a8b8981), {
        setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
        setDisplayFlag: setDisplayFlag
    })), definitionToggleEnabled && /*#__PURE__*/ $cozmU.createElement((0, $2uDbg.Checkbox), {
        isChecked: termDefinitionDisabled,
        label: (0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_hide_term_definition_message.defaultMessage,
        value: (0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_hide_term_definition_message.defaultMessage,
        onChange: onToggleDefinitionDisable
    })), answerEditor ? /*#__PURE__*/ $cozmU.createElement((0, $6fa35d25205670c8$export$686a5e20bce13f8f), {
        setShowEditHistoryModal: setShowEditHistoryModal
    }) : /*#__PURE__*/ $cozmU.createElement((0, $6fa35d25205670c8$export$8c09939f07ae58e2), null), /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, showEditHistoryModal && editDefinitionEnabled && /*#__PURE__*/ $cozmU.createElement((0, $e1f862b35321d870$export$6c43ad171ca78b4f), {
        curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
        onClose: ()=>setShowEditHistoryModal(false)
    }), showFeedbackOptionsModal && /*#__PURE__*/ $cozmU.createElement((0, $4f71e91a4b682fe6$export$dc5d3996368c6525), {
        setShowFeedbackOptionsModal: setShowFeedbackOptionsModal,
        setShowEditDefinitionModal: setShowEditDefinitionModal,
        setShowFeedbackModal: setShowFeedbackModal,
        editDefinitionEnabled: editDefinitionEnabled
    }), showFeedbackModal && /*#__PURE__*/ $cozmU.createElement((0, $e66bc4e4b70c4191$export$5efdacda4e928df9), {
        setFeedbackModal: setShowFeedbackModal,
        isCuratedDefinition: !!answerEditor,
        setDisplayFlag: setDisplayFlag
    }), showEditDefinitionModal && editDefinitionEnabled && /*#__PURE__*/ $cozmU.createElement((0, $46b3319f0a259942$export$ea8c8594ad1f3bf3), {
        curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
        closeEditModal: ()=>setShowEditDefinitionModal(false),
        openFeedbackOptionsModal: ()=>setShowFeedbackOptionsModal(true),
        onSaveEditModal: ()=>setDisplaySuccessFlag(true)
    })), displayFlag && /*#__PURE__*/ $cozmU.createElement((0, $lqtHz.default), {
        onDismissed: ()=>setDisplayFlag(false)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement($bd504f15d238fab3$var$AkFeedbackFlag, {
        locale: locale,
        description: formatMessage((0, $260c725c14a7c456$export$defe85febe8b728c).definition_footer_feedback_flag_description)
    }))), displaySuccessFlag && /*#__PURE__*/ $cozmU.createElement((0, $6cecfbe2a7b0bbf1$export$7475d9ffda76c69b), {
        onDismissed: ()=>setDisplaySuccessFlag(false)
    }));
};




















const $e286cb72bb7ab9cd$export$4bb2ae9dc67cd713 = ({ additionalMatchUserName: additionalMatchUserName, additionalMatchTitle: additionalMatchTitle, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerWhoAdditionalMatchViewProfile',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            additionalMatchUserName: additionalMatchUserName,
            additionalMatchTitle: additionalMatchTitle
        }
    };
};





const $47fbc20224d5557b$export$caffb77a39b6cd1 = ({ additionalMatchUserName: additionalMatchUserName, additionalMatchTitle: additionalMatchTitle, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerWhoAdditionalMatchViewProfile',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            additionalMatchUserName: additionalMatchUserName,
            additionalMatchTitle: additionalMatchTitle
        }
    };
};



const $17e86b4a203450c0$var$mapRecentActivity = (activity)=>({
        title: activity.title,
        url: activity.url,
        containerName: activity.containerName,
        event: activity.event,
        timestamp: activity.timestamp,
        iconUrl: activity.iconUrl,
        contributors: activity.contributors.slice(0, $17e86b4a203450c0$var$MAX_OTHERS_TO_SHOW).map((contributor)=>({
                name: contributor.name,
                id: contributor.accountId
            })),
        othersCount: activity.othersCount
    });
const $17e86b4a203450c0$var$mapTeam = (team)=>({
        name: team.displayName,
        avatarUrl: team.smallAvatarImageUrl,
        url: `/wiki/people/team/${team.id}`,
        memberCount: team.memberCount
    });
const $17e86b4a203450c0$var$mapAdditionalMatch = (match)=>{
    return {
        name: match.name,
        avatar_url: match.avatar_url,
        profile_url: match.profile_url,
        job_title: match.title,
        email: match.email ?? ''
    };
};
// Collaborators, contributors and additional matches are expected to be at most 3
const $17e86b4a203450c0$var$MAX_OTHERS_TO_SHOW = 3;
const $17e86b4a203450c0$export$b273f870e024eb5d = (answerString)=>{
    const parsed = JSON.parse(answerString);
    if ('enriched_activity_output' in parsed) {
        const { main_user_profile: main_user_profile, additional_matches: additional_matches } = parsed.enriched_activity_output;
        return {
            parsedResult: [
                {
                    name: main_user_profile.user_base_data.name,
                    email: main_user_profile.user_base_data.email,
                    time: main_user_profile.time,
                    profile_url: main_user_profile.user_base_data.profile_url,
                    avatar_url: main_user_profile.user_base_data.avatar_url,
                    recentActivity: main_user_profile.recent_activity.map($17e86b4a203450c0$var$mapRecentActivity),
                    department: main_user_profile.user_base_data.extended_profile?.department,
                    job_title: main_user_profile.user_base_data.extended_profile?.job_title,
                    location: main_user_profile.user_base_data.extended_profile?.location,
                    organization: main_user_profile.user_base_data.extended_profile?.organization,
                    viewAllLink: main_user_profile.view_all_activity_url
                },
                ...additional_matches.slice(0, $17e86b4a203450c0$var$MAX_OTHERS_TO_SHOW).map((x)=>({
                        ...$17e86b4a203450c0$var$mapAdditionalMatch(x),
                        recentActivity: [],
                        viewAllLink: ''
                    }))
            ],
            parsedType: (0, $d227efab07c2b9f0$export$eae917983a0398aa).WORK
        };
    } else if ('enriched_profile_output' in parsed) {
        const { main_user_profile: main_user_profile, additional_matches: additional_matches } = parsed.enriched_profile_output;
        return {
            parsedResult: [
                {
                    account_id: main_user_profile.user_base_data.account_id,
                    name: main_user_profile.user_base_data.name,
                    email: main_user_profile.user_base_data.email,
                    profile_url: main_user_profile.user_base_data.profile_url,
                    avatar_url: main_user_profile.user_base_data.avatar_url,
                    job_title: main_user_profile.user_base_data.extended_profile?.job_title,
                    location: main_user_profile.user_base_data.extended_profile?.location,
                    department: main_user_profile.user_base_data.extended_profile?.department,
                    organization: main_user_profile.user_base_data.extended_profile?.organization,
                    time: main_user_profile.time,
                    collaborators: main_user_profile.collaborators.slice(0, 6).map((user)=>({
                            name: user.name,
                            picture: user.avatar_url,
                            title: user.extended_profile?.job_title ?? null,
                            url: user.profile_url,
                            accountId: user.account_id,
                            department: user.extended_profile?.department ?? null,
                            email: user.email
                        })),
                    containers: main_user_profile.collaboration_spaces.map((container)=>({
                            name: container.name,
                            containerType: container.container_type,
                            url: container.url,
                            iconUrl: container.icon_url
                        })),
                    recentActivity: main_user_profile.recent_activity?.map($17e86b4a203450c0$var$mapRecentActivity),
                    viewAllLink: main_user_profile.view_all_activity_url,
                    teams: main_user_profile.teams?.map($17e86b4a203450c0$var$mapTeam)
                },
                ...additional_matches.slice(0, $17e86b4a203450c0$var$MAX_OTHERS_TO_SHOW).map($17e86b4a203450c0$var$mapAdditionalMatch)
            ],
            parsedType: (0, $d227efab07c2b9f0$export$eae917983a0398aa).WHO
        };
    } else if ('team_metadata' in parsed) return {
        parsedResult: parsed.team_metadata,
        parsedType: (0, $d227efab07c2b9f0$export$eae917983a0398aa).TEAM
    };
    else // This line should never be reached, this means that an unsupported type was in the JSON result
    return {
        parsedResult: {},
        parsedType: undefined
    };
};


/* ai-who-answer-footer.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $ac0808825763ce07$export$8aac4e350897fa7 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2bqfgdOeNX _0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM _39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _24h04i2Njc",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-footer-header.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $438e3836aeef8420$export$12179e87966a5f65 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgd8bj _1UtDYzKGUX",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-footer-result.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $aad6fd04426facc3$export$e2651635b6d243b0 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_30huDKkzjp _0bjKvDKTcp _3iDTPbQ4SZ _0hPCNLDIqT _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _24h04i2Njc _0KLXru7Cj1 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _3fSdSTGk8v",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-footer-result-info-header.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $c655fbb849c7fe62$export$a9060ca8bb68e9b6 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgEqul _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _39xV02N91d _39HuIbz8Lp _1ANEUSLRg7",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-footer-result-info-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $cfe7fa596079821c$export$da4b6fad053f23b9 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuZHm0 _0hPCNLchRC _0jFU0VN91d _39xV02N91d _2XsHFM2ADO _39HuIbz8Lp _1ANEUSLRg7",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-footer-result-metadata.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $bb6fa724382b9d9c$export$eadd90c494f8440c = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzKGUX _39xV02N91d _39HuIbz8Lp _1ANEUSLRg7",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-footer-results-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $2667d2ef32797259$export$ca13badcf6359d46 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _3iDTPbgBM8 _2iEGP2byVk _39xV02N91d _0jFU0VmdCj _3138422ADO",
            __cmplp.className
        ])
    });
});


const $f831fa9e697ed056$export$b03d109098afe32f = ()=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, onNavigate: onNavigate } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    // answerString should have at least one result or else <AIAnswerError /> will be rendered
    const { parsedResult: parsedResult } = (0, $17e86b4a203450c0$export$b273f870e024eb5d)(answerString);
    const additionalUserResults = parsedResult.slice(1);
    const numAdditionalUserResults = additionalUserResults.length;
    return numAdditionalUserResults ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ac0808825763ce07$export$8aac4e350897fa7), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $438e3836aeef8420$export$12179e87966a5f65), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $cb86z.messages).ai_answer_who_questions_footer_header,
        values: {
            numMatches: numAdditionalUserResults
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2667d2ef32797259$export$ca13badcf6359d46), null, additionalUserResults.map((userResult)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aad6fd04426facc3$export$e2651635b6d243b0), {
            key: userResult.name,
            href: userResult.profile_url || undefined,
            onClick: (event)=>{
                onNavigate(event);
                fireAnalyticsEvent((0, $e286cb72bb7ab9cd$export$4bb2ae9dc67cd713)({
                    ...commonAttributes,
                    additionalMatchUserName: userResult.name,
                    additionalMatchTitle: userResult.job_title || ''
                }));
            },
            onContextMenu: (event)=>{
                onNavigate(event);
                fireAnalyticsEvent((0, $47fbc20224d5557b$export$caffb77a39b6cd1)({
                    ...commonAttributes,
                    additionalMatchUserName: userResult.name,
                    additionalMatchTitle: userResult.job_title || ''
                }));
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: userResult.avatar_url || undefined,
            size: "medium",
            testId: userResult.name
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfe7fa596079821c$export$da4b6fad053f23b9), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c655fbb849c7fe62$export$a9060ca8bb68e9b6), null, userResult.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bb6fa724382b9d9c$export$eadd90c494f8440c), null, userResult.job_title)))))) : null;
};



























var $f9PMs = parcelRequire("f9PMs");










/* ai-answer-footer-content-warning-link.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $872be9e531212fbd$export$6f442c0ed7b594b3 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _1UtDYzKGUX _3TGfC9HnLE _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMKGUX",
            __cmplp.className
        ])
    });
});


/* ai-answer-footer-information-content-vary.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $ea67ca1f91728569$export$573f5509d5798c1e = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _2sNsIg7NXe _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _1UtDYzKGUX",
            __cmplp.className
        ])
    });
});


/* ai-answer-footer-information-content-vary-link-text.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $4031c559faf0cf84$export$bc95f3ac1425888f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe",
            __cmplp.className
        ])
    });
});


/* ai-answer-footer-powered-by.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $f2b402d9d55ae121$export$2b5d58c880974a8a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _1UtDYzKGUX _3TGfC9HnLE",
            __cmplp.className
        ])
    });
});


/* ai-answer-footer-powered-by-ai-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $251708df5e70ad5b$export$ef38e90ca3d2a41d = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu8FQfX _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});


/* ai-answer-footer-powered-by-link.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $13cc1ad6061a0b53$export$7c69b4b5db21f97c = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _1UtDYzKGUX _3TGfC9HnLE _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMKGUX",
            __cmplp.className
        ])
    });
});


/* styled.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $f21780de4c6eb211$var$AIAnswerContentBrandBase = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0Of8r21Y8M _1ZnuxbNHnM _1wydGW1Y8M _2Zuz6QNHnM",
            __cmplp.className
        ])
    });
});
const $f21780de4c6eb211$export$f32f097f63664c4b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $f21780de4c6eb211$var$AIAnswerContentBrandBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_37wbyuI7V3",
            __cmplp.className
        ])
    });
});
const $f21780de4c6eb211$export$5d9a293726695cdb = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = $f21780de4c6eb211$var$AIAnswerContentBrandBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_37wbyuDIqT",
            __cmplp.className
        ])
    });
});


const $78943e0b983101cb$export$9e8b51119c9a7742 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { brand: brand, cardTemplate: cardTemplate, sourceProduct: sourceProduct, showGenericFooter: showGenericFooter } = (0, $3hVWe.useAIAnswerContext)();
    const isSacWithCenteredFooter = sourceProduct === 'sac';
    const BrandWrapper = isSacWithCenteredFooter ? (0, $f21780de4c6eb211$export$5d9a293726695cdb) : (0, $f21780de4c6eb211$export$f32f097f63664c4b);
    if (showGenericFooter) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f21780de4c6eb211$export$f32f097f63664c4b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ea67ca1f91728569$export$573f5509d5798c1e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
        text: formatMessage((0, $cb86z.messages).ai_answer_dialog_footer_beta_tag),
        isRemovable: false,
        migration_fallback: "lozenge"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4031c559faf0cf84$export$bc95f3ac1425888f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $872be9e531212fbd$export$6f442c0ed7b594b3), {
        rel: "noopener noreferrer",
        href: (0, $zzZbq.SAC_ATLASSIAN_INTELLIGENCE_TRUST_LINK),
        target: "_blank"
    }, formatMessage((0, $cb86z.messages).ai_answer_dialog_footer_content_quality_short)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2b402d9d55ae121$export$2b5d58c880974a8a), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $251708df5e70ad5b$export$ef38e90ca3d2a41d), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13cc1ad6061a0b53$export$7c69b4b5db21f97c), {
        rel: "noopener noreferrer",
        href: (0, $zzZbq.SAC_ATLASSIAN_INTELLIGENCE_TRUST_LINK),
        target: "_blank"
    }, formatMessage((0, $cb86z.messages).ai_answer_dialog_loaded_footer_sac)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BrandWrapper, {
        "data-testid": isSacWithCenteredFooter ? 'ai-answer-brand-wrapper-centered' : 'ai-answer-brand-wrapper'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ea67ca1f91728569$export$573f5509d5798c1e), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4031c559faf0cf84$export$bc95f3ac1425888f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        rel: "noopener noreferrer",
        appearance: "subtle",
        href: sourceProduct === 'sac' ? (0, $zzZbq.SAC_ATLASSIAN_INTELLIGENCE_TRUST_LINK) : (0, $zzZbq.ATLASSIAN_INTELLIGENCE_TRUST_LINK)
    }, formatMessage(cardTemplate === (0, $zzZbq.CardTemplate).RIGHT_PANEL ? (0, $cb86z.messages).ai_answer_dialog_footer_content_quality_short : (0, $cb86z.messages).ai_answer_dialog_footer_content_quality_long)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2b402d9d55ae121$export$2b5d58c880974a8a), null, brand === (0, $zzZbq.AiBrand).ROVO ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        rel: "noopener noreferrer",
        appearance: "subtle",
        href: (0, $zzZbq.ATLASSIAN_ROVO_LINK)
    }, "Rovo"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC0KQ))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        spacing: "spacious"
    })) : sourceProduct !== 'sac' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $251708df5e70ad5b$export$ef38e90ca3d2a41d), null, formatMessage((0, $cb86z.messages).ai_answer_dialog_loaded_footer), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f9PMs.default), {
        greyed: true,
        size: 'large'
    }))));
};


/* ai-answer-feedback-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides








const $6b6108766d435190$export$71c5dacfc0533c82 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompact: isCompact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hm6gxd": (0, $9aYkv.default)(__cmplp.isCompact ? `0px ${"var(--ds-space-300, 24px)"}` : 'unset')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _4FKVYEvN50 _3iDTPbQ4SZ _0hPCNLDIqT _3138422ADO _1DCdHi2ADO _1UtDYzUktF",
            __cmplp.className
        ])
    });
});


/* ai-answer-footer-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $a108aa903244750b$export$89b1508f9c43b29e = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _2bqfgdOeNX _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _0Of8r28HPE _1ZnuxbNHnM _1wydGW8HPE _2Zuz6QNHnM _3TGfC9HnLE",
            __cmplp.className
        ])
    });
});


/* ai-answer-report-description-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $b4f59c2c581899e2$export$8b91051e793e6316 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1wydGW5zaO",
            __cmplp.className
        ])
    });
});






























var $bIZaC = parcelRequire("bIZaC");


var $7z5N5 = parcelRequire("7z5N5");

/* feedback-button-icon-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides








const $530f7caa273f1db1$export$5d384d799a8fb604 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_169wk05": (0, $9aYkv.default)(__cmplp.active ? "var(--ds-text-accent-blue, #1558BC)" : "var(--ds-text-subtlest, #6B6E76)"),
            "--_hohrgu": (0, $9aYkv.default)(__cmplp.isDisabled ? 'not-allowed' : 'default')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0wOv4Qb84s _3VB8wb5uWe",
            __cmplp.className
        ])
    });
});


/* rotate180-icon-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $438b714a832405b9$export$8b5c58bc12f52d53 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2xvoozl236",
            __cmplp.className
        ])
    });
});


const $004bf88ef698cf7f$var$FeedbackButton = ({ active: active, isDisabled: isDisabled, onClick: onClickHandler, tooltipContent: tooltipContent, testId: testId, icon: icon, isReadingAids: isReadingAids })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: 'top',
        content: tooltipContent
    }, ({ onClick: _onClick, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            "aria-label": tooltipContent,
            spacing: 'none',
            appearance: isDisabled ? 'subtle-link' : 'subtle',
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $530f7caa273f1db1$export$5d384d799a8fb604), {
                active: active,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    cursor: 'pointer'
                },
                ...testId && {
                    'data-testid': testId
                },
                isDisabled: isDisabled || false,
                isReadingAids: isReadingAids || false
            }, icon),
            ...!isDisabled && {
                onClick: onClickHandler
            },
            ...tooltipProps
        }));
};
const $004bf88ef698cf7f$export$c633fc044a8b8981 = ({ setDisplayFlag: setDisplayFlag, setFeedbackModal: setFeedbackModal })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, updateContextCache: updateContextCache, liked: liked, setLiked: setLiked, likesDisabled: likesDisabled, setLikesDisabled: setLikesDisabled, isReadingAids: isReadingAids } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    // Using a single state to represent both like/dislike states
    // true - liked, false - disliked, undefined - neither are selected
    const likeButtonCallback = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        setDisplayFlag(true);
        setLiked(true);
        setLikesDisabled(true);
        updateContextCache({
            collapsed: false,
            liked: true
        });
        fireAnalyticsEvent((0, $7z5N5.onLikeButtonClick)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).POSITIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    }, [
        setLiked,
        setLikesDisabled,
        fireAnalyticsEvent,
        commonAttributes,
        updateContextCache,
        setDisplayFlag,
        fireSAINUsageEvent
    ]);
    const dislikeButtonCallback = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        setFeedbackModal(true);
        setLiked(false);
        setLikesDisabled(true);
        updateContextCache({
            collapsed: false,
            liked: false
        });
        fireAnalyticsEvent((0, $bIZaC.onDislikeButtonClick)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).NEGATIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    }, [
        setLiked,
        setLikesDisabled,
        fireAnalyticsEvent,
        commonAttributes,
        updateContextCache,
        setFeedbackModal,
        fireSAINUsageEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($004bf88ef698cf7f$var$FeedbackButton, {
        active: liked === true,
        onClick: likeButtonCallback,
        tooltipContent: formatMessage((0, $cb86z.messages).ai_answer_component_like_button_tooltip),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)"
        }),
        isDisabled: liked && likesDisabled,
        testId: "ai-answer-like-button",
        isReadingAids: isReadingAids
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($004bf88ef698cf7f$var$FeedbackButton, {
        active: liked === false,
        onClick: dislikeButtonCallback,
        tooltipContent: formatMessage((0, $cb86z.messages).ai_answer_component_dislike_button_tooltip),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $438b714a832405b9$export$8b5c58bc12f52d53), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
            label: "",
            spacing: "spacious",
            color: "var(--ds-icon, #292A2E)"
        })),
        isDisabled: !liked && likesDisabled,
        testId: "ai-answer-dislike-button",
        isReadingAids: isReadingAids
    }));
};


/* followup-suggestion-footer.tsx generated by @compiled/babel-plugin v2.0.0 */ 


















var $hAgam = parcelRequire("hAgam");




































const $ee9ece46b1b323f4$export$c1460cbf6075b68 = ({ showErrorStateSuggestedQueries: showErrorStateSuggestedQueries, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiErrorStateSuggestedQueries',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            showErrorStateSuggestedQueries: showErrorStateSuggestedQueries
        }
    };
};








const $8450870f643523fa$export$97c5ff7b106e0023 = ({ errorStateSuggestedQuery: errorStateSuggestedQuery, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiErrorStateSuggestedQuery',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            errorStateSuggestedQueryHash: (0, $9oghv.sha256Hash)(errorStateSuggestedQuery)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            errorStateSuggestedQuery: errorStateSuggestedQuery
        }
    };
};





const $728210eecf84aa8d$export$e6174e7fdfd73609 = ({ expandButtonSource: expandButtonSource, ...props })=>{
    const { query: query } = props;
    return {
        action: 'clicked',
        actionSubject: 'expandButton',
        actionSubjectId: expandButtonSource,
        source: props.source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};








const $234e19cc92be917b$export$f1956b3bd380b51e = ({ followUpString: followUpString, destination: destination, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiFollowUpSuggestion',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            followUpHash: (0, $9oghv.sha256Hash)(followUpString),
            destination: destination
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            followUpString: followUpString
        }
    };
};


/* ai-answer-follow-up-pill.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $998a72255fc1cd90$export$ff0eb486c968b1bb = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _0bjKvDS5Zs _30huDKS6k6 _3iDTPbQ4SZ _0Of8r2FQfX _1Znuxb2ADO _1wydGWFQfX _2Zuz6Q2ADO _1UtDYzZpcK _0KLXru7Cj1 _37wbyuchRC _0hPCNLDIqT _0KOPe2S6k6 _0ReiIH7zJH _1eOmH6qWX3",
            __cmplp.className
        ])
    });
});


/* ai-answer-follow-up-pill-text.tsx generated by @compiled/babel-plugin v2.0.0 */ // eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides






const $41bfb9aa0fe17bb9$export$5d787e808dded622 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2XsHFM1Y8M",
            __cmplp.className
        ])
    });
});





const $75504fd7fe2b8992$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ai_answer_followup_see_more: {
        id: "search_ai.followup_see_more",
        defaultMessage: "See more"
    }
});





const $ca576dd46a8697bd$export$2160f22747f80da3 = ()=>{
    const containerRef = (0, $cozmU.useRef)(null);
    const [isOverflowing, setIsOverflowing] = (0, $cozmU.useState)(false);
    // Stores the total natural (uncollapsed) width of all pills + gaps
    const naturalWidthRef = (0, $cozmU.useRef)(0);
    const measureNaturalWidth = (0, $cozmU.useCallback)(()=>{
        const el = containerRef.current;
        if (!el) return;
        const pills = Array.from(el.querySelectorAll('[data-pill]'));
        if (pills.length === 0) {
            naturalWidthRef.current = 0;
            return;
        }
        // Temporarily override display on all pills so scrollWidth reflects the full
        // natural width. We use 'inline-flex' so pills maintain their row layout
        // during measurement (using 'block' would stack them vertically, giving an
        // incorrect scrollWidth). After reading scrollWidth, we restore the original
        // inline style value ('' for pills that had no prior inline style, which lets
        // the CSS class re-assert display:none correctly).
        const prevDisplays = pills.map((p)=>p.style.display);
        pills.forEach((p)=>{
            p.style.display = 'inline-flex';
        });
        naturalWidthRef.current = el.scrollWidth;
        pills.forEach((p, i)=>{
            p.style.display = prevDisplays[i];
        });
    }, []);
    const checkOverflow = (0, $cozmU.useCallback)(()=>{
        const el = containerRef.current;
        if (!el) return;
        setIsOverflowing(naturalWidthRef.current > el.clientWidth);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const el = containerRef.current;
        if (!el) return;
        // MutationObserver re-measures natural widths when pill content changes
        const mutationObserver = new MutationObserver(()=>{
            measureNaturalWidth();
            checkOverflow();
        });
        mutationObserver.observe(el, {
            childList: true,
            subtree: true
        });
        // ResizeObserver re-measures AND re-checks on every container resize.
        // Re-measurement is required (not just re-checking) because the hidden pills
        // are excluded from scrollWidth — so naturalWidthRef must be refreshed against
        // the current DOM state each time the container changes size.
        const resizeObserver = new ResizeObserver(()=>{
            measureNaturalWidth();
            checkOverflow();
        });
        resizeObserver.observe(el);
        // Defer initial measurement until after layout has settled.
        // Running synchronously risks measuring against a temporarily narrow
        // clientWidth (e.g. while a dialog is animating open), which would
        // produce a false-positive overflow that never self-corrects.
        const rafId = requestAnimationFrame(()=>{
            measureNaturalWidth();
            checkOverflow();
        });
        return ()=>{
            cancelAnimationFrame(rafId);
            mutationObserver.disconnect();
            resizeObserver.disconnect();
        };
    }, [
        measureNaturalWidth,
        checkOverflow
    ]);
    return {
        containerRef: containerRef,
        isOverflowing: isOverflowing
    };
};


const $a921764ae1a692a7$var$stylesCompiled = {
    pillLineHeight: "_26BoRwey7F"
};
const $a921764ae1a692a7$var$styles = {
    button: "_0bjKvDKxmn _2sNsIgmnOE _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _1UtDYzZpcK _0Of8r2gVvo _1Znuxb8HPE _1wydGWgVvo _2Zuz6Q8HPE _1kk5Tkf7mX _39HuIbz8Lp _1ANEUSLRg7 _3YEZNO7dHp _0KLXru66of _1eOmH6o126 _3gzVzLN4oS",
    queryText: "_3W2Oc8wPeg _2fwxA5ecOK _09eJsYMRGa",
    whiteSpacePreWrap: "_1ANEUSlpBW",
    luminaFollowUpButtonStyleOverrides: "_0bjKvDKxmn _2O5VijdnbC _3YEZNO7dHp _1bHrqEIZbP _0KLXrunmFW _4ouGXIdnbC",
    luminaFollowUpButtonStyleOverridesImproved: "_0KLXrulfZc",
    luminaFollowUpButtonNoShrink: "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP",
    pillHidden: "_3iDTPbYbGa",
    pillContainer: "_2mHwu82ADO _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _3TGfC9LRg7",
    pillContainerExpanded: "_4bt5LAYvD1 _2WAcuGYvD1 _3TGfC9HnLE",
    pillContainerInner: "_2mHwu82ADO _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _3YEZNO7dHp _4ouGXIdnbC",
    upliftWrapper: "_39xV02N91d"
};
const $a921764ae1a692a7$export$f087ce3403d54eb5 = ({ omitDialogues: omitDialogues = false })=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, setQuery: setQuery, updateContextCache: updateContextCache, onClose: onClose, closeParentDialog: closeParentDialog, callbacks: callbacks, showChatFollowUps: showChatFollowUps } = (0, $3hVWe.useAIAnswerContext)();
    const { followUps: followUps, query: query, answerString: answerString, searchSessionId: searchSessionId, errorStateSuggestedQueries: errorStateSuggestedQueries } = commonAttributes;
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isUXUplift = (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled();
    const isImprovedChatOptions = (0, $7DMz5.SAINFeatureControl).isImprovedChatOptionsEnabled();
    const [showMore, setShowMore] = (0, $cozmU.useState)(false);
    const { containerRef: containerRef, isOverflowing: isOverflowing } = (0, $ca576dd46a8697bd$export$2160f22747f80da3)(); // Reset expanded state when follow-ups change (e.g. new query).
    // Use a stable string comparison instead of the array reference to avoid resetting
    // on every render when commonAttributes produces a new array object each time.
    const followUpsKey = followUps.join('\x00');
    (0, $cozmU.useEffect)(()=>{
        setShowMore(false); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        followUpsKey
    ]);
    const showNLPFollowUps = followUps.length > 0;
    const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_sain_show_no_answer_suggestions_exp'
    });
    const visibleFollowUps = (0, $cozmU.useMemo)(()=>{
        return showNLPFollowUps ? followUps.slice(0, 2) : serveErrorStateSuggestedQueriesExp ? errorStateSuggestedQueries.slice(0, 2) : [];
    }, [
        showNLPFollowUps,
        followUps,
        errorStateSuggestedQueries,
        serveErrorStateSuggestedQueriesExp
    ]);
    const showErrorStateSuggestedQueries = visibleFollowUps.length > 0 && !showNLPFollowUps;
    const onPillClick = (0, $cozmU.useCallback)((followUp)=>{
        if (showChatFollowUps) publish({
            type: 'chat-new',
            source: 'sain',
            data: {
                name: followUp.substring(0, 30),
                dialogues: omitDialogues ? [] : [
                    {
                        human_message: {
                            content: query
                        },
                        agent_message: {
                            content: answerString
                        }
                    }
                ],
                prompt: followUp,
                sourceId: searchSessionId
            }
        });
        else {
            setQuery(followUp);
            updateContextCache({
                fromFollowUp: true
            });
        }
        fireAnalyticsEvent((0, $234e19cc92be917b$export$f1956b3bd380b51e)({
            ...commonAttributes,
            followUpString: followUp,
            destination: 'chat'
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).FOLLOWUP_CLICKED,
            commonAttributes: commonAttributes
        });
        onClose?.();
        closeParentDialog?.();
        callbacks?.onFollowUpSuggestionClick?.();
    }, [
        fireSAINUsageEvent,
        fireAnalyticsEvent,
        commonAttributes,
        onClose,
        closeParentDialog,
        callbacks,
        publish,
        query,
        answerString,
        searchSessionId,
        setQuery,
        updateContextCache,
        showChatFollowUps,
        omitDialogues
    ]);
    const onSuggestedQueryClick = (0, $cozmU.useCallback)((e, suggestedQuery)=>{
        e.preventDefault();
        e.stopPropagation();
        setQuery(suggestedQuery);
        fireAnalyticsEvent((0, $8450870f643523fa$export$97c5ff7b106e0023)({
            ...commonAttributes,
            errorStateSuggestedQuery: suggestedQuery
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).ERROR_STATE_SUGGESTED_QUERY_CLICKED,
            commonAttributes: commonAttributes
        });
        onClose?.();
        closeParentDialog?.();
    }, [
        setQuery,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        onClose,
        closeParentDialog,
        commonAttributes
    ]);
    const onSeeMoreClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $728210eecf84aa8d$export$e6174e7fdfd73609)({
            ...commonAttributes,
            expandButtonSource: 'followupSeeMore'
        }));
        setShowMore(true);
    }, [
        fireAnalyticsEvent,
        commonAttributes
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (showErrorStateSuggestedQueries) fireAnalyticsEvent((0, $ee9ece46b1b323f4$export$c1460cbf6075b68)({
            ...commonAttributes,
            showErrorStateSuggestedQueries: visibleFollowUps
        }));
    }, [
        showErrorStateSuggestedQueries,
        fireAnalyticsEvent,
        commonAttributes,
        visibleFollowUps
    ]);
    if (isUXUplift && showChatFollowUps) {
        const allFollowUps = isImprovedChatOptions ? followUps.slice(0, 2) : followUps.slice(0, 1); // Collapse only when gate is on, there are multiple follow-ups, and they overflow
        const isCollapsed = isImprovedChatOptions && isOverflowing && allFollowUps.length > 1;
        const pillBox = (followUp, hidden)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                "data-pill": true,
                xcss: (0, $w6R6I.cx)(hidden && $a921764ae1a692a7$var$styles.pillHidden, $a921764ae1a692a7$var$styles.luminaFollowUpButtonNoShrink, $a921764ae1a692a7$var$styles.luminaFollowUpButtonStyleOverrides, isImprovedChatOptions && $a921764ae1a692a7$var$styles.luminaFollowUpButtonStyleOverridesImproved),
                key: followUp
            }, /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
                content: followUp,
                position: "top"
            }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))),
                onClick: ()=>onPillClick(followUp),
                testId: "smart-answer-follow-up-button"
            }, followUp)));
        if (isImprovedChatOptions) return [
            /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $a921764ae1a692a7$var$styles.upliftWrapper,
                key: "uplift-wrapper"
            }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: $a921764ae1a692a7$var$styles.pillContainer
            }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                ref: containerRef,
                xcss: (0, $w6R6I.cx)($a921764ae1a692a7$var$styles.pillContainerInner, showMore && $a921764ae1a692a7$var$styles.pillContainerExpanded)
            }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                "data-pill": true,
                xcss: (0, $w6R6I.cx)($a921764ae1a692a7$var$styles.luminaFollowUpButtonStyleOverrides, $a921764ae1a692a7$var$styles.luminaFollowUpButtonNoShrink, $a921764ae1a692a7$var$styles.luminaFollowUpButtonStyleOverridesImproved)
            }, /*#__PURE__*/ $cozmU.createElement((0, $1781bd9c74b8683a$export$dc40dedc9df6e59f), {
                prompt: query,
                query: query,
                answerString: answerString,
                source: "sain"
            })), allFollowUps.map((followUp, i)=>pillBox(followUp, isCollapsed && i > 0 && !showMore))), isCollapsed && !showMore && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($a921764ae1a692a7$var$styles.luminaFollowUpButtonStyleOverrides, $a921764ae1a692a7$var$styles.luminaFollowUpButtonStyleOverridesImproved)
            }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
                appearance: "default",
                onClick: onSeeMoreClick,
                testId: "smart-answer-follow-up-expand-button"
            }, formatMessage((0, $75504fd7fe2b8992$export$defe85febe8b728c).ai_answer_followup_see_more)))))
        ];
        return [
            /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($a921764ae1a692a7$var$styles.luminaFollowUpButtonStyleOverrides, $a921764ae1a692a7$var$styles.luminaFollowUpButtonNoShrink),
                key: "open-chat"
            }, /*#__PURE__*/ $cozmU.createElement((0, $1781bd9c74b8683a$export$dc40dedc9df6e59f), {
                prompt: query,
                query: query,
                answerString: answerString,
                source: "sain"
            })),
            ...allFollowUps.map((followUp)=>pillBox(followUp, false))
        ];
    }
    return visibleFollowUps.length > 0 ? visibleFollowUps.map((followUp, index)=>{
        if (showChatFollowUps && !showErrorStateSuggestedQueries) return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            key: followUp
        }, /*#__PURE__*/ $cozmU.createElement((0, $eHdk6.FollowUpButton), {
            onClick: ()=>onPillClick(followUp),
            followUpText: followUp,
            followUpIndex: index,
            followUpType: "UNAVAILABLE",
            experienceId: "sain"
        }));
        if (showErrorStateSuggestedQueries) return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            key: followUp
        }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
            xcss: $a921764ae1a692a7$var$styles.button,
            onClick: (e)=>onSuggestedQueryClick(e, followUp)
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $a921764ae1a692a7$var$stylesCompiled.pillLineHeight
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.075",
            alignBlock: "baseline"
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            color: "currentColor",
            label: ""
        }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($a921764ae1a692a7$var$styles.queryText, $a921764ae1a692a7$var$styles.whiteSpacePreWrap)
        }, followUp)))));
        return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            key: followUp
        }, /*#__PURE__*/ $cozmU.createElement((0, $998a72255fc1cd90$export$ff0eb486c968b1bb), {
            onClick: ()=>onPillClick(followUp)
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hAgam))), {
            label: "",
            color: "var(--ds-icon, #292A2E)"
        }), /*#__PURE__*/ $cozmU.createElement((0, $41bfb9aa0fe17bb9$export$5d787e808dded622), null, followUp)));
    }) : null;
};



const $34e9b06075b84401$var$AkFeedbackCollector = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hUVfy")).then((module)=>{
        return {
            default: module.default
        };
    }));

const $34e9b06075b84401$var$AkFeedbackFlag = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hUVfy")).then(({ FeedbackFlag: FeedbackFlag })=>{
        return {
            default: FeedbackFlag
        };
    }));
const $34e9b06075b84401$export$3553ee90c7edebc9 = ({ showOpenChat: showOpenChat })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { query: query, answerString: answerString } = commonAttributes;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a108aa903244750b$export$89b1508f9c43b29e), null, showOpenChat && !(0, $iDrrr.fg)('rovo_ai_mode_entrypoints_enabled') && !(0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1781bd9c74b8683a$export$dc40dedc9df6e59f), {
        prompt: query,
        query: query,
        answerString: answerString,
        source: 'sain'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a921764ae1a692a7$export$f087ce3403d54eb5), null));
};
const $34e9b06075b84401$var$AIAnswerBaseFooter = ({ showWhoAnswer: showWhoAnswer, showOpenChat: showOpenChat })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, userDetails: { name: name, id: id }, readingAidsOptions: readingAidsOptions, loading: loading, brand: brand, isAnswered: isAnswered, showChatFollowUps: showChatFollowUps, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const { errorState: errorState, answerFormat: answerFormat, followUps: followUps } = commonAttributes;
    const [showFeedbackModal, setFeedbackModal] = (0, $cozmU.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $cozmU.useState)(false);
    const [hasConsent, setConsent] = (0, $cozmU.useState)(false);
    const [topicsNotRelevant, setTopicsNotRelevant] = (0, $cozmU.useState)(false);
    const feedbackContextObject = {
        searchSessionId: commonAttributes.searchSessionId,
        source: commonAttributes.source,
        queryHash: commonAttributes.queryHash,
        cloudId: commonAttributes.cloudId,
        prompt: hasConsent ? commonAttributes.query : undefined,
        answer: hasConsent ? commonAttributes.answerString : undefined,
        documentId: readingAidsOptions?.contentARI,
        errorState: errorState,
        topicsNotRelevant: topicsNotRelevant ? true : undefined
    };
    const feedbackContext = Object.entries(feedbackContextObject).map(([key, value])=>`${key}: ${value}`).join(', ');
    const toggleConsentCheckbox = (0, $cozmU.useCallback)(()=>{
        setConsent(!hasConsent);
    }, [
        hasConsent
    ]);
    const toggleTopicsNotRelevantCheckbox = (0, $cozmU.useCallback)(()=>{
        setTopicsNotRelevant(!topicsNotRelevant);
    }, [
        topicsNotRelevant
    ]);
    const topicsEnabled = (0, $iDrrr.fg)('kd_topics_in_person_card');
    const brandName = brand === (0, $zzZbq.AiBrand).ROVO ? 'Rovo' : sourceProduct === 'sac' ? '' : 'Atlassian Intelligence';
    const renderOpenChatButton = showOpenChat && showChatFollowUps && !loading && isAnswered && (0, $iDrrr.fg)('kd_smart_answers_open_chat');
    // Custom feedback options
    const SAC_CUSTOM_FEEDBACK_OPTIONS = [
        {
            label: formatMessage((0, $cb86z.messages).ai_answer_sac_feedback_option_not_relevant),
            value: 'not_relevant'
        },
        {
            label: formatMessage((0, $cb86z.messages).ai_answer_sac_feedback_option_not_accurate),
            value: 'not_accurate'
        },
        {
            label: formatMessage((0, $cb86z.messages).ai_answer_sac_feedback_option_too_slow),
            value: 'too_slow'
        },
        {
            label: formatMessage((0, $cb86z.messages).ai_answer_sac_feedback_option_unhelpful),
            value: 'unuseful_links'
        },
        {
            label: formatMessage((0, $cb86z.messages).ai_answer_sac_feedback_option_other),
            value: 'other'
        }
    ];
    const GENERIC_FEEDBACK_GROUPS_LABELS = {
        empty: {
            fieldLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_details_label),
            selectOptionLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_empty_option_share_label)
        },
        question: {
            fieldLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_details_label),
            selectOptionLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_relevance_option_label)
        },
        comment: {
            fieldLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_details_label),
            selectOptionLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_inaccurate_option_label)
        },
        bug: {
            fieldLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_details_label),
            selectOptionLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_offensive_option_label)
        },
        suggestion: {
            fieldLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_details_label),
            selectOptionLabel: formatMessage((0, $cb86z.messages).ai_answer_component_report_other_option_label)
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, showWhoAnswer && answerFormat === (0, $hpFQM.NLPSearchResultFormat).JSON && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f831fa9e697ed056$export$b03d109098afe32f), null), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6b6108766d435190$export$71c5dacfc0533c82), {
        isCompact: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $004bf88ef698cf7f$export$c633fc044a8b8981), {
        setDisplayFlag: setDisplayFlag,
        setFeedbackModal: setFeedbackModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $78943e0b983101cb$export$9e8b51119c9a7742), null), (renderOpenChatButton || followUps.length > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34e9b06075b84401$export$3553ee90c7edebc9, {
        showOpenChat: renderOpenChatButton
    }), showFeedbackModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    }, sourceProduct === 'sac' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34e9b06075b84401$var$AkFeedbackCollector, {
        locale: locale,
        onClose: ()=>setFeedbackModal(false),
        onSubmit: ()=>{
            setDisplayFlag(true);
        },
        customContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, sourceProduct !== 'sac' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            label: formatMessage((0, $cb86z.messages).ai_answer_component_report_consent_checkbox_label),
            onChange: toggleConsentCheckbox,
            isChecked: hasConsent
        }), topicsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            label: formatMessage((0, $cb86z.messages).ai_answer_component_topics_not_relevant_checkbox_label),
            onChange: toggleTopicsNotRelevantCheckbox,
            isChecked: topicsNotRelevant
        })),
        atlassianAccountId: id,
        name: name,
        entrypointId: (0, $zzZbq.FEEDBACK_ENTRYPOINT_ID_SAIN),
        additionalFields: [
            {
                id: (0, $zzZbq.FEEDBACK_CONTEXT_CF),
                value: feedbackContext
            }
        ],
        feedbackTitle: formatMessage((0, $cb86z.messages).ai_answer_component_report_modal_title, {
            brandName: brandName
        }),
        feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b4f59c2c581899e2$export$8b91051e793e6316), null, formatMessage((0, $cb86z.messages).ai_answer_component_report_summary_label)),
        customFeedbackOptions: SAC_CUSTOM_FEEDBACK_OPTIONS,
        showDefaultTextFields: sourceProduct !== 'sac',
        descriptionDefaultValue: sourceProduct === 'sac' ? 'sac feedback' : '',
        summaryPlaceholder: formatMessage((0, $cb86z.messages).ai_answer_component_summary_placeholder_label)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34e9b06075b84401$var$AkFeedbackCollector, {
        locale: locale,
        onClose: ()=>setFeedbackModal(false),
        onSubmit: ()=>{
            setDisplayFlag(true);
        },
        customContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.050"
        }, sourceProduct !== 'sac' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            label: formatMessage((0, $cb86z.messages).ai_answer_component_report_consent_checkbox_label),
            onChange: toggleConsentCheckbox,
            isChecked: hasConsent
        }), topicsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            label: formatMessage((0, $cb86z.messages).ai_answer_component_topics_not_relevant_checkbox_label),
            onChange: toggleTopicsNotRelevantCheckbox,
            isChecked: topicsNotRelevant
        })),
        atlassianAccountId: id,
        name: name,
        entrypointId: (0, $zzZbq.FEEDBACK_ENTRYPOINT_ID_SAIN),
        additionalFields: [
            {
                id: (0, $zzZbq.FEEDBACK_CONTEXT_CF),
                value: feedbackContext
            }
        ],
        feedbackTitle: formatMessage((0, $cb86z.messages).ai_answer_component_report_modal_title, {
            brandName: brandName
        }),
        feedbackTitleDetails: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b4f59c2c581899e2$export$8b91051e793e6316), null, formatMessage((0, $cb86z.messages).ai_answer_component_report_summary_label)),
        feedbackGroupLabels: GENERIC_FEEDBACK_GROUPS_LABELS,
        summaryPlaceholder: formatMessage((0, $cb86z.messages).ai_answer_component_summary_placeholder_label)
    })) : null, displayFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.default), {
        onDismissed: ()=>setDisplayFlag(false)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34e9b06075b84401$var$AkFeedbackFlag, {
        locale: locale,
        description: formatMessage((0, $cb86z.messages).ai_answer_component_feedback_flag_description)
    }))));
};
const $34e9b06075b84401$export$74b8b3463af67a4d = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34e9b06075b84401$var$AIAnswerBaseFooter, {
        showOpenChat: true
    });
};
const $34e9b06075b84401$var$AIAnswerDialogFooter = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34e9b06075b84401$var$AIAnswerBaseFooter, {
        showWhoAnswer: true
    });
};
const $34e9b06075b84401$export$37858bd8fa3d5915 = ()=>{
    const { isReadingAids: isReadingAids, cardTemplate: cardTemplate } = (0, $3hVWe.useAIAnswerContext)();
    switch(cardTemplate){
        case (0, $zzZbq.CardTemplate).SMART_ANSWER:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34e9b06075b84401$export$74b8b3463af67a4d, null);
        default:
            return isReadingAids ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd504f15d238fab3$export$9de8ba80314e4213), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34e9b06075b84401$var$AIAnswerDialogFooter, null);
    }
};







const $d58a262274d16c7a$export$f3109245f09f7746 = (props)=>{
    const { query: query, answerString: answerString, source: source, answerHeight: answerHeight, containerHeight: containerHeight, whitespaceHeight: whitespaceHeight, queryIntent: queryIntent } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerResultComplete',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            answerHeight: answerHeight,
            containerHeight: containerHeight,
            whitespaceHeight: whitespaceHeight,
            queryIntent: queryIntent
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};





const $bd6e42147a6848a8$export$c68095583a3c17cc = (props)=>{
    const { query: query, answerString: answerString, source: source, timeToFirstByte: timeToFirstByte } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerResultFirstByte',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            timeToFirstByte: timeToFirstByte
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};








const $a7fd7127c63cb2fc$export$5671a2e254c14222 = ({ linkType: linkType, authorityUiMetadata: authorityUiMetadata, ...props })=>{
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerSourceLink',
        source: props.source,
        eventType: 'ui',
        // Intentionally non-UGC only: no query/answerString nonPrivacySafeAttributes.
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            clickOrigin: 'authoritativeAnswerPanel',
            linkType: linkType,
            ...(0, $fhQlP.getAuthorityAttributes)(authorityUiMetadata)
        }
    };
};

















/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 


















var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");




















var $aUgOE = parcelRequire("aUgOE");



















/* knowledge-smart-card.tsx generated by @compiled/babel-plugin v2.0.0 */ 















var $krxYo = parcelRequire("krxYo");


var $V3JOP = parcelRequire("V3JOP");
















var $4yYAm = parcelRequire("4yYAm");

var $l8wPz = parcelRequire("l8wPz");

var $aKJEB = parcelRequire("aKJEB");

var $i1503 = parcelRequire("i1503");

var $es2gJ = parcelRequire("es2gJ");

var $jdA6O = parcelRequire("jdA6O");


var $QXwxo = parcelRequire("QXwxo");

const $736ac3075308471f$export$a3b7216c107a7a1 = (sourceUrl)=>{
    let url;
    try {
        url = new URL(sourceUrl);
    } catch  {
        return undefined;
    }
    return url.hostname;
};






var $1xWgP = parcelRequire("1xWgP");




var $c7e955c1204bae2f$export$c32f46c9d34bc809 = /*#__PURE__*/ function(CardVariant) {
    CardVariant["COMPACT"] = "COMPACT";
    CardVariant["FULL"] = "FULL";
    CardVariant["DROPDOWN_SOURCE"] = "DROPDOWN_SOURCE";
    CardVariant["ACTION_CARD"] = "ACTION_CARD";
    return CardVariant;
}({});


const $9fdd133452866a73$export$61d53a7e0f2f3df1 = {
    'Google Drive': 'Google Drive',
    Loom: 'Loom',
    Google: 'Google',
    GoogleDrive: 'GoogleDrive'
};


const $688ab9534bb3cc83$var$messages = (0, $kSwu1.defineMessages)({
    navigate_button: {
        id: "search_ai.action_card_navigate_button",
        defaultMessage: "Navigate"
    }
});
const $688ab9534bb3cc83$var$unboundStyles = {
    compactContainer: "_0bjKvD8fU6 _313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _0KLXru66of _0wOv4Q7zJH _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _1EqgXlwBC3 _4kiQYAL04q _0noGBPN91d _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _1eOmH6o126",
    actionCardContainer: "_0bjKvD8fU6 _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _0KLXru66of _3iDTPbQ4SZ _0hPCNLDIqT _1EqgXlwBC3 _39xV02N91d _0Of8r28HPE _1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO",
    actionCardButton: "_2fwxA50dzo",
    fallbackContainer: "_0Of8r28HPE _1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO",
    embeddedCardContainer: "_39xV02N91d _21jNvKdnbC _0ED33gdnbC _00uLJWdnbC _0rVPxUdnbC _1a8zX6NCjk _3IuyDD8fU6 _2Qfy9J2Njc _0DHSz398eZ _2gOGE7YbGa _2dHj5OT6kp _2grDAeN91d",
    richSourceCardContainer: "_39xV02N91d _2z0KhOdnbC _3q4PvXdnbC _0wmW9LdnbC _3tAKcndnbC _4udW8o8fU6 _1h9OOm2Njc _2grDAeN91d _3cqaQkIZbP",
    titleBlockCss: "_2mHwu82ADO _2C9dkJ7GSX _0c6yoiM7Tp",
    compactTitleBlockCss: "_3wKy9BEqul _2AsftyFQfX",
    footerBlockCss: "_0jFU0V9DVM _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLz9WS _4xdlr0FlnN"
};
function $688ab9534bb3cc83$var$constructSourceUrl({ source: source, searchSessionId: searchSessionId }) {
    if (source.product === 'Confluence' && !!searchSessionId) {
        const url = new URL(source.url);
        url.searchParams.append('search_id', searchSessionId);
        return url.toString();
    }
    return source.url;
}
const $688ab9534bb3cc83$var$createCardClickHandler = (source, index, searchSessionId, onClickHandler, sourceCardType)=>(e)=>{
        onClickHandler?.({
            index: index,
            source: source,
            hostname: (0, $736ac3075308471f$export$a3b7216c107a7a1)(source.url),
            sourceCardType: sourceCardType
        });
        e.preventDefault();
        window.open($688ab9534bb3cc83$var$constructSourceUrl({
            source: source,
            searchSessionId: searchSessionId
        }), '_blank', 'noopener, noreferrer');
    };
const $688ab9534bb3cc83$var$createCardErrorHandler = (componentName)=>()=>{
        (0, $cuvLu.logger).error({
            error: new Error(`Error rendering ${componentName}`),
            functionName: componentName
        });
    };
function $688ab9534bb3cc83$var$SimpleFallbackCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    const handleClick = (e)=>{
        onClickHandler?.({
            index: index,
            source: source,
            hostname: (0, $736ac3075308471f$export$a3b7216c107a7a1)(source.url),
            sourceCardType: 'compact'
        });
        e.preventDefault();
        window.open($688ab9534bb3cc83$var$constructSourceUrl({
            source: source,
            searchSessionId: searchSessionId
        }), '_blank', 'noopener, noreferrer');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: source.url,
        xcss: $688ab9534bb3cc83$var$unboundStyles.compactContainer,
        onClick: handleClick,
        testId: "knowledge-smart-card-fallback"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $688ab9534bb3cc83$var$unboundStyles.fallbackContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1xWgP.AppIcon), {
        app: source.product,
        size: "large"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium",
        maxLines: 1
    }, source.title || source.url), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1
    }, source.product || '')))));
}
function $688ab9534bb3cc83$var$ActionCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $688ab9534bb3cc83$var$unboundStyles.actionCardContainer,
        testId: "knowledge-smart-card-action-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Fmt9.IconTile), {
        label: "",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($krxYo))),
        appearance: "gray",
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "medium",
        maxLines: 1
    }, source.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: source.url,
        target: "_blank",
        rel: "noopener noreferrer",
        appearance: "subtle"
    }, source.url)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $688ab9534bb3cc83$var$unboundStyles.actionCardButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
        href: source.url,
        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        onClick: $688ab9534bb3cc83$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'action-card')
    }, formatMessage($688ab9534bb3cc83$var$messages.navigate_button)))));
}
function $688ab9534bb3cc83$var$CompactKnowledgeSmartCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $688ab9534bb3cc83$var$unboundStyles.compactContainer,
        testId: "knowledge-smart-card-compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $QXwxo.CardSSR), {
        appearance: "block",
        url: source.url,
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            size: (0, $4yYAm.SmartLinkSize).Medium,
            removeBlockRestriction: true
        },
        fallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($688ab9534bb3cc83$var$SimpleFallbackCard, {
                source: source,
                index: index,
                searchSessionId: searchSessionId,
                onClickHandler: onClickHandler
            }),
        onClick: $688ab9534bb3cc83$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'compact'),
        onError: $688ab9534bb3cc83$var$createCardErrorHandler('CompactKnowledgeSmartCard')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
        maxLines: 1,
        size: (0, $4yYAm.SmartLinkSize).Small,
        subtitle: [
            {
                name: (0, $4yYAm.ElementName).Provider
            }
        ],
        position: (0, $4yYAm.SmartLinkPosition).Center,
        hideIcon: true,
        className: (0, $hekY6.default)([
            $688ab9534bb3cc83$var$unboundStyles.compactTitleBlockCss
        ])
    }))));
}
function $688ab9534bb3cc83$var$StandardKnowledgeSmartCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    const footerActions = (0, $cozmU.useMemo)(()=>[
            {
                name: (0, $4yYAm.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $4yYAm.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $4yYAm.ActionName).DownloadAction,
                hideIcon: true
            }
        ], []);
    const topMetadata = [
        {
            name: (0, $4yYAm.ElementName).AuthorGroup
        },
        {
            name: (0, $4yYAm.ElementName).AssignedTo
        },
        {
            name: (0, $4yYAm.ElementName).CreatedBy
        },
        {
            name: (0, $4yYAm.ElementName).ModifiedOn
        }
    ];
    const titleMetadata = [
        {
            name: (0, $4yYAm.ElementName).State
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $688ab9534bb3cc83$var$unboundStyles.richSourceCardContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        appearance: "block",
        url: source.url,
        fallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($688ab9534bb3cc83$var$SimpleFallbackCard, {
                source: source,
                index: index,
                searchSessionId: searchSessionId,
                onClickHandler: onClickHandler
            }),
        ui: {
            removeBlockRestriction: true
        },
        onClick: $688ab9534bb3cc83$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'rich-flexible'),
        onError: $688ab9534bb3cc83$var$createCardErrorHandler('StandardKnowledgeSmartCard')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
        maxLines: 1,
        metadata: titleMetadata,
        className: (0, $hekY6.default)([
            $688ab9534bb3cc83$var$unboundStyles.titleBlockCss
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
        primary: topMetadata,
        maxLines: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $es2gJ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aKJEB.default), {
        actions: footerActions,
        className: (0, $hekY6.default)([
            $688ab9534bb3cc83$var$unboundStyles.footerBlockCss
        ])
    }))));
}
function $688ab9534bb3cc83$var$EmbeddedKnowledgeSmartCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $688ab9534bb3cc83$var$unboundStyles.embeddedCardContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        appearance: "embed",
        fallbackComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($688ab9534bb3cc83$var$SimpleFallbackCard, {
                source: source,
                index: index,
                searchSessionId: searchSessionId,
                onClickHandler: onClickHandler
            }),
        inheritDimensions: true,
        frameStyle: "show",
        url: source.url,
        onClick: $688ab9534bb3cc83$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'embedded'),
        onError: $688ab9534bb3cc83$var$createCardErrorHandler('EmbeddedKnowledgeSmartCard')
    })));
}
function $688ab9534bb3cc83$var$DropdownSourceSmartCard({ source: source, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        appearance: "block",
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: true,
            hideBackground: true,
            hideElevation: true,
            hidePadding: true,
            size: (0, $4yYAm.SmartLinkSize).Medium,
            removeBlockRestriction: true
        },
        url: source.url,
        onClick: $688ab9534bb3cc83$var$createCardClickHandler(source, index, searchSessionId, onClickHandler, 'dropdown-source'),
        onError: $688ab9534bb3cc83$var$createCardErrorHandler('DropdownSourceSmartCard')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
        maxLines: 1,
        size: (0, $4yYAm.SmartLinkSize).Medium
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $es2gJ.default), {
        maxLines: 2
    })));
} /**
   * @deprecated Use KnowledgeSmartCard from @atlassian/lumina instead.
   *
   * @example
   * import { KnowledgeSmartCard } from '@atlassian/lumina';
   */ 
const $688ab9534bb3cc83$export$dfe41ae7345cd34b = ({ source: source, variant: variant, index: index, searchSessionId: searchSessionId, onClickHandler: onClickHandler })=>{
    // Apply defaults for internal components
    const internalProps = {
        source: source,
        index: index || 0,
        searchSessionId: searchSessionId || '',
        onClickHandler: onClickHandler || (()=>{})
    };
    if (variant === (0, $c7e955c1204bae2f$export$c32f46c9d34bc809).COMPACT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($688ab9534bb3cc83$var$CompactKnowledgeSmartCard, internalProps);
    if (variant === (0, $c7e955c1204bae2f$export$c32f46c9d34bc809).DROPDOWN_SOURCE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($688ab9534bb3cc83$var$DropdownSourceSmartCard, internalProps);
    if (variant === (0, $c7e955c1204bae2f$export$c32f46c9d34bc809).ACTION_CARD) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($688ab9534bb3cc83$var$ActionCard, internalProps);
    const shouldUseEmbedded = source.product && source.product in (0, $9fdd133452866a73$export$61d53a7e0f2f3df1);
    if (shouldUseEmbedded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($688ab9534bb3cc83$var$EmbeddedKnowledgeSmartCard, internalProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($688ab9534bb3cc83$var$StandardKnowledgeSmartCard, internalProps);
};





const $59f8e361f9553c0b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    sources_title: {
        id: "search_ai.sources_label",
        // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
        defaultMessage: "{numSources, plural, =1 {Source} other {Sources}}"
    },
    related_links_title: {
        id: "search_ai.related_links_label",
        defaultMessage: "Related links"
    }
});


/* source-card.tsx generated by @compiled/babel-plugin v2.0.0 */ 










const $1b1a8e20e360a5ba$var$Card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("bE9h1")).then(({ Card: Card })=>({
            default: Card
        })));
const $1b1a8e20e360a5ba$var$resolveUrlPlaceholder = (url)=>{
    const textFragmentRegex = new RegExp('#:~:text=.*$', 'g');
    const urlWithoutTextFragment = url?.replace(textFragmentRegex, '');
    const maxLength = 30;
    const truncatedUrl = urlWithoutTextFragment.length > maxLength ? urlWithoutTextFragment.slice(0, maxLength) + '...' : urlWithoutTextFragment;
    return truncatedUrl;
};
const $1b1a8e20e360a5ba$var$constructSourceUrl = ({ source: source, searchSessionId: searchSessionId })=>{
    if (source.product === 'Confluence') {
        const url = new URL(source.url);
        url.searchParams.append('search_id', searchSessionId);
        return url.toString();
    } else return source.url;
};
const $1b1a8e20e360a5ba$var$fallbackComponent = ({ index: index, source: source, searchSessionId: searchSessionId, onClickHandler: onClickHandler })=>()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: $1b1a8e20e360a5ba$var$constructSourceUrl({
                source: source,
                searchSessionId: searchSessionId
            }),
            onClick: ()=>onClickHandler(index, source, (0, $736ac3075308471f$export$a3b7216c107a7a1)(source.url)),
            rel: "noopener noreferrer",
            target: "_blank"
        }, source.title ?? source.url);
    };
const $1b1a8e20e360a5ba$export$c74cbf75d6285884 = ({ index: index, source: source, searchSessionId: searchSessionId, onClickHandler: onClickHandler, enableSmartLinkSources: enableSmartLinkSources })=>{
    const SmartLinkSource = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1b1a8e20e360a5ba$var$Card, {
        appearance: "inline",
        url: source.url,
        removeTextHighlightingFromTitle: true,
        showHoverPreview: true,
        fallbackComponent: $1b1a8e20e360a5ba$var$fallbackComponent({
            index: index,
            source: source,
            searchSessionId: searchSessionId,
            onClickHandler: onClickHandler
        }),
        onClick: (e)=>{
            onClickHandler(index, source, (0, $736ac3075308471f$export$a3b7216c107a7a1)(source.url));
            e.preventDefault();
            window.open($1b1a8e20e360a5ba$var$constructSourceUrl({
                source: source,
                searchSessionId: searchSessionId
            }), '_blank', 'noopener, noreferrer');
        },
        onError: ()=>{},
        resolvingPlaceholder: $1b1a8e20e360a5ba$var$resolveUrlPlaceholder(source.url),
        placeholder: $1b1a8e20e360a5ba$var$resolveUrlPlaceholder(source.url)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, enableSmartLinkSources ? SmartLinkSource : $1b1a8e20e360a5ba$var$fallbackComponent({
        index: index,
        source: source,
        searchSessionId: searchSessionId,
        onClickHandler: onClickHandler
    })());
};


const $ce789c5dd436d96e$var$CAROUSEL_SOURCE_CARD_WIDTH = 350;
const $ce789c5dd436d96e$var$CAROUSEL_SOURCE_OFFSET = $ce789c5dd436d96e$var$CAROUSEL_SOURCE_CARD_WIDTH + 16; // width + gap
const $ce789c5dd436d96e$var$styles = {
    cardTitle: "_3138428HPE _1DCdHi5zaO",
    container: "_39xV02N91d _313842gVvo",
    carouselSourceCardContainer: "_4bt5LAnQyn _2WAcuGnQyn _1bHrqEaQBb _2O5VijdnbC _3YEZNOdnbC _1ANEUSJfqQ _39xV02aQBb _1EqgXlaQBb"
};
const $ce789c5dd436d96e$var$unboundStyles = {
    smartCard: "_0jFU0V6Aep _2opLeZ6Aep _0ZwTMg6Aep"
};
const $ce789c5dd436d96e$var$sourcesContainerStyles = null;
const $ce789c5dd436d96e$var$freeFlowLinksStyles = null;
const $ce789c5dd436d96e$var$Sources = ({ sources: sources, searchSessionId: searchSessionId, onClickHandler: onClickHandler, allowFreeflowLayout: allowFreeflowLayout, verticalLayout: verticalLayout, enableSmartLinkSources: enableSmartLinkSources = true })=>{
    const [showAllSources, setShowAllSources] = (0, $cozmU.useState)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const canExpand = sources.length > 1 && verticalLayout;
    const visibleSources = showAllSources || !verticalLayout ? sources : sources.slice(0, 1);
    const onExpandButtonClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $728210eecf84aa8d$export$e6174e7fdfd73609)({
            ...commonAttributes,
            expandButtonSource: 'sources'
        }));
        setShowAllSources(!showAllSources);
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        showAllSources
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, visibleSources.map((source, index)=>/*#__PURE__*/ $cozmU.createElement("div", {
            key: `ai-answer-source-${index}`,
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0aFT5v1qpb _0GwItXDIqT _17lj8p1Y8M",
                allowFreeflowLayout && "_3iDTPbS8kF _26BoRwiZR3 _0adFHsgVvo"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $1b1a8e20e360a5ba$export$c74cbf75d6285884), {
            index: index,
            key: `search-ai-answer-source-${index}`,
            source: source,
            searchSessionId: searchSessionId,
            onClickHandler: onClickHandler,
            enableSmartLinkSources: enableSmartLinkSources
        }), index === 0 && canExpand && /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            onClick: onExpandButtonClick,
            icon: (iconProps)=>showAllSources ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps,
                    color: "currentColor",
                    testId: "collapse-sources-icon",
                    size: "small"
                }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    ...iconProps,
                    color: "currentColor",
                    testId: "expand-sources-icon",
                    size: "small"
                }),
            label: showAllSources ? (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true) ? 'Collapse sources' : 'Collapse sources button' : (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true) ? 'Expand sources' : 'Expand sources button',
            spacing: "compact",
            appearance: "subtle"
        }))));
};
const $ce789c5dd436d96e$var$LayoutWrapper = (props)=>{
    if (props.allowFreeflowLayout) return /*#__PURE__*/ $cozmU.createElement("div", null, props.children);
    else if (props.verticalLayout) return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, props.children);
    else return /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.075",
        shouldWrap: true
    }, props.children);
};
const $ce789c5dd436d96e$export$bbbfd63fa7f32357 = (props)=>{
    const { sources: ogSources, searchSessionId: searchSessionId, title: title, onClickHandler: onClickHandler = ()=>{}, allowFreeflowLayout: allowFreeflowLayout = false, verticalLayout: verticalLayout = false, limit: limit, enableSmartLinkSources: enableSmartLinkSources, isReadingAids: isReadingAids = false } = props;
    const sourcesTitle = title ?? (0, $59f8e361f9553c0b$export$defe85febe8b728c).sources_title;
    const sources = limit ? ogSources.slice(0, limit) : ogSources;
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const MaybeSmartCardProvider = enableSmartLinkSources !== false ? (0, $5HApy.SmartCardProvider) : (0, $cozmU.Fragment);
    if (!sources.length) return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null);
    return /*#__PURE__*/ $cozmU.createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $ce789c5dd436d96e$var$styles.cardTitle
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        as: "h2",
        size: "xxsmall"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small",
        weight: "bold"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...sourcesTitle,
        values: {
            numSources: sources.length
        }
    })))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $ce789c5dd436d96e$var$styles.container
    }, /*#__PURE__*/ $cozmU.createElement($ce789c5dd436d96e$var$LayoutWrapper, {
        allowFreeflowLayout: allowFreeflowLayout,
        verticalLayout: verticalLayout
    }, /*#__PURE__*/ $cozmU.createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: isReadingAids ? (0, $uY2pq.SearchAIAnalyticsContextLocation).AI_DEFINITION : (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ $cozmU.createElement(MaybeSmartCardProvider, null, /*#__PURE__*/ $cozmU.createElement($ce789c5dd436d96e$var$Sources, {
        sources: sources,
        searchSessionId: searchSessionId,
        onClickHandler: onClickHandler,
        allowFreeflowLayout: allowFreeflowLayout,
        verticalLayout: verticalLayout,
        enableSmartLinkSources: enableSmartLinkSources
    })))))));
};
function $ce789c5dd436d96e$var$AISourcesCarouselHeading({ numSources: numSources }) {
    const headingMessage = (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() ? (0, $59f8e361f9553c0b$export$defe85febe8b728c).related_links_title : (0, $59f8e361f9553c0b$export$defe85febe8b728c).sources_title;
    return /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...headingMessage,
        values: {
            numSources: numSources
        }
    }));
}
function $ce789c5dd436d96e$export$919320f9832aec1d(props) {
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { sources: sources, searchSessionId: searchSessionId, onClickHandler: onClickHandler, isReadingAids: isReadingAids = false } = props;
    return /*#__PURE__*/ $cozmU.createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $ce789c5dd436d96e$var$styles.container,
        testId: "ai-sources-carousel"
    }, /*#__PURE__*/ $cozmU.createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: isReadingAids ? (0, $uY2pq.SearchAIAnalyticsContextLocation).AI_DEFINITION : (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ $cozmU.createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ $cozmU.createElement((0, $ec82c8c1e1d8eeb1$export$61c045a5252abd1d), {
        heading: /*#__PURE__*/ $cozmU.createElement($ce789c5dd436d96e$var$AISourcesCarouselHeading, {
            numSources: sources.length
        }),
        scrollOffset: $ce789c5dd436d96e$var$CAROUSEL_SOURCE_OFFSET
    }, sources.map((source, index)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: `search-ai-answer-source-${index}`,
            xcss: (0, $w6R6I.cx)($ce789c5dd436d96e$var$styles.carouselSourceCardContainer, $ce789c5dd436d96e$var$unboundStyles.smartCard)
        }, (0, $iDrrr.fg)('kd_use_common_knowledge_card') ? /*#__PURE__*/ $cozmU.createElement((0, $aUgOE.KnowledgeSmartCard), {
            index: index,
            source: source,
            searchSessionId: searchSessionId,
            onClickHandler: onClickHandler
        }) : /*#__PURE__*/ $cozmU.createElement((0, $688ab9534bb3cc83$export$dfe41ae7345cd34b), {
            index: index,
            source: source,
            searchSessionId: searchSessionId,
            onClickHandler: onClickHandler
        })))))))));
}











const $c581527c64231606$export$aef55698754fc321 = ({ sourceIndex: sourceIndex, isCitation: isCitation, isAuxClick: isAuxClick, isContextMenu: isContextMenu, hostname: hostname, sourceCardType: sourceCardType, sourceProduct: sourceProduct, is3PSource: is3PSource, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerSourceLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            sourceIndex: sourceIndex,
            isCitation: isCitation,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu,
            sourceCardType: sourceCardType,
            sourceProduct: sourceProduct,
            is3PSource: is3PSource,
            ...hostname ? {
                metadata: {
                    hostname: hostname
                }
            } : {}
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};














const $280875adc8c5626f$export$6be22f9840eb8748 = ({ aiAnswerDialogContext: aiAnswerDialogContext, isCitation: isCitation = false })=>{
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    // Validate context
    if (!aiAnswerDialogContext || !aiAnswerDialogContext.commonAttributes) throw new Error("useKnowledgeSmartCardAnalytics requires a valid AIAnswerContext. Ensure you pass the context from useAIAnswerContext().");
    const { commonAttributes: commonAttributes, callbacks: callbacks } = aiAnswerDialogContext;
    const handleSmartCardClick = (0, $cozmU.useCallback)(({ index: index, source: source, hostname: hostname, sourceCardType: sourceCardType, isAuxClick: isAuxClick, isContextMenu: isContextMenu })=>{
        if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: index,
            hostname: hostname,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu,
            sourceCardType: sourceCardType,
            sourceProduct: source?.product || '',
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source?.product),
            isCitation: !!isCitation,
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source?.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks,
        isCitation
    ]);
    return {
        handleSmartCardClick: handleSmartCardClick,
        searchSessionId: commonAttributes.searchSessionId
    };
};


/* sources-bar.tsx generated by @compiled/babel-plugin v2.0.0 */ 












var $kUFQ0 = parcelRequire("kUFQ0");




















var $dmWtJ = parcelRequire("dmWtJ");

function $1885669c9a19ffc2$export$fb422644050f6872(product, url) {
    if (product === 'Microsoft') {
        if (url.includes('sharepoint.com')) return 'sharepoint';
        if (url.includes('powerbi.com')) return 'power-bi';
        if (url.includes('teams.microsoft.com')) return 'teams';
    }
    return product ?? '';
}


const $f0122fe4f75fa739$var$DEFAULT_MAX_SOURCES_IN_STACK = 3;
function $f0122fe4f75fa739$export$ebff7094edd1bb81({ maxSourcesInStack: maxSourcesInStack, sources: sources, showNumAddtlSources: showNumAddtlSources, testId: testId, addEditorStyleOverrides: addEditorStyleOverrides, shuffled: shuffled = false }) {
    if (sources.length === 0) return null;
    const sourcesForIconStack = [];
    const sourceProductsMap = {};
    maxSourcesInStack = maxSourcesInStack ?? $f0122fe4f75fa739$var$DEFAULT_MAX_SOURCES_IN_STACK;
    for(let i = 0; i < sources.length; i++){
        const source = sources[i];
        const appKey = (0, $1885669c9a19ffc2$export$fb422644050f6872)(source.product, source.url) || 'Unknown';
        if (!sourceProductsMap[appKey]) {
            sourcesForIconStack.push(source);
            sourceProductsMap[appKey] = true;
        }
        if (sourcesForIconStack.length === maxSourcesInStack) break;
    }
    const appIcons = sourcesForIconStack.map((source)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1xWgP.AppIcon), {
            // still need to convert product to correct subproduct e.g. for Microsoft
            app: (0, $1885669c9a19ffc2$export$fb422644050f6872)(source.product, source.url),
            "data-testid": `app-icon-${source.ari}`,
            key: source.ari,
            size: "xxsmall"
        }));
    // want to display the number of additional sources that are not included in the appIcons stack
    const numAddtlSources = sources.length - appIcons.length;
    return appIcons.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dmWtJ.IconStack), {
        testId: testId,
        addEditorStyleOverrides: addEditorStyleOverrides,
        shuffled: shuffled
    }, appIcons), showNumAddtlSources && numAddtlSources > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, "+", numAddtlSources)) : null;
}


const $7fd6a1524e779285$var$messages = (0, $kSwu1.defineMessages)({
    referencing: {
        id: "search_ai.sources_bar_referencing",
        defaultMessage: "Referencing"
    },
    sources_count: {
        id: "search_ai.sources_bar_sources_count",
        defaultMessage: "{numSources} {numSources, plural, one {source} other {sources}}"
    }
});
const $7fd6a1524e779285$var$styles = {
    button: "_0bjKvDKTcp _4c065U2ADO _2Y7lL42ADO _1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _39xV02N91d _0KLXrunmFW _3CkH9oww0T _3OqcjTZYp7 _1DJ2rV2jUH",
    flippedIcon: "_1VJPcal236 _3iDTPbccYA"
};
const $7fd6a1524e779285$export$e754cddb4d3a7903 = ({ sources: sources, numSources: numSources, onClick: onClick, triggerRef: triggerRef })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        xcss: $7fd6a1524e779285$var$styles.button,
        onClick: onClick,
        testId: "sources-bar-button",
        ref: triggerRef
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            $7fd6a1524e779285$var$styles.flippedIcon
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($kUFQ0))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    })), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        size: "small"
    }, formatMessage($7fd6a1524e779285$var$messages.referencing)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small",
        weight: "medium"
    }, formatMessage($7fd6a1524e779285$var$messages.sources_count, {
        numSources: numSources
    })))), /*#__PURE__*/ $cozmU.createElement((0, $f0122fe4f75fa739$export$ebff7094edd1bb81), {
        sources: sources,
        maxSourcesInStack: 4,
        shuffled: true
    })), /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }));
};


/* sources-side-panel.tsx generated by @compiled/babel-plugin v2.0.0 */ 






























var $bGNkz = parcelRequire("bGNkz");




























var $1WRnE = parcelRequire("1WRnE");

const $f76c30d78079e3b2$var$styles = {
    container: ""
};
const $f76c30d78079e3b2$var$unboundStyles = {
    titleBlockCss: "_3wKy9BmnOE _2C9dkJ7GSX _0c6yoiy7kJ _31SDeSy7kJ",
    metadataBlockCss: "_4keetJKGUX",
    snippetBlockCss: "_4keetJZpcK"
};
const $f76c30d78079e3b2$export$554b5f10e8e833c8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { source: source, index: index, onClickHandler: onClickHandler, onError: onError, searchSessionId: searchSessionId } = t0;
    let t1;
    if ($[0] !== index || $[1] !== onClickHandler || $[2] !== searchSessionId || $[3] !== source) {
        t1 = (e)=>{
            const isAuxClick = e.button === 1;
            const isContextMenu = e.button === 2;
            onClickHandler?.({
                index: index,
                source: source,
                sourceCardType: "side-panel-source",
                isAuxClick: isAuxClick,
                isContextMenu: isContextMenu
            });
            if (!isContextMenu) {
                e.preventDefault();
                const url = (0, $1WRnE.constructSourceUrl)({
                    source: source,
                    searchSessionId: searchSessionId
                });
                window.open(url, "_blank", "noopener, noreferrer");
            }
        };
        $[0] = index;
        $[1] = onClickHandler;
        $[2] = searchSessionId;
        $[3] = source;
        $[4] = t1;
    } else t1 = $[4];
    const handleClick = t1;
    let t2;
    if ($[5] !== handleClick) {
        t2 = (e_0)=>{
            if (e_0.button !== 1) return;
            handleClick(e_0);
        };
        $[5] = handleClick;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: true,
            hideElevation: true,
            hidePadding: true
        };
        $[7] = t3;
    } else t3 = $[7];
    const t4 = onError || $f76c30d78079e3b2$var$_temp;
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [
            {
                name: (0, $4yYAm.ActionName).CopyLinkAction,
                hideContent: true
            },
            {
                name: (0, $4yYAm.ActionName).PreviewAction,
                hideContent: true
            }
        ];
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
            maxLines: 1,
            actions: t5,
            showActionOnHover: true,
            position: (0, $4yYAm.SmartLinkPosition).Center,
            className: (0, $hekY6.default)([
                $f76c30d78079e3b2$var$unboundStyles.titleBlockCss
            ])
        });
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = [
            {
                name: (0, $4yYAm.ElementName).ModifiedOn
            },
            {
                name: (0, $4yYAm.ElementName).ModifiedBy
            },
            {
                name: (0, $4yYAm.ElementName).OwnedBy
            }
        ];
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
            primary: t7,
            maxLines: 1,
            className: (0, $hekY6.default)([
                $f76c30d78079e3b2$var$unboundStyles.metadataBlockCss
            ])
        });
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $es2gJ.default), {
            maxLines: 2,
            className: (0, $hekY6.default)([
                $f76c30d78079e3b2$var$unboundStyles.snippetBlockCss
            ])
        });
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== handleClick || $[14] !== source.url || $[15] !== t4) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
            appearance: "block",
            showHoverPreview: false,
            ui: t3,
            url: source.url,
            onClick: handleClick,
            onError: t4
        }, t6, t8, t9);
        $[13] = handleClick;
        $[14] = source.url;
        $[15] = t4;
        $[16] = t10;
    } else t10 = $[16];
    let t11;
    if ($[17] !== handleClick || $[18] !== t10 || $[19] !== t2) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f76c30d78079e3b2$var$styles.container,
            onAuxClick: t2,
            onContextMenu: handleClick
        }, t10);
        $[17] = handleClick;
        $[18] = t10;
        $[19] = t2;
        $[20] = t11;
    } else t11 = $[20];
    return t11;
} : ({ source: source, index: index, onClickHandler: onClickHandler, onError: onError, searchSessionId: searchSessionId })=>{
    const handleClick = (e)=>{
        const isAuxClick = e.button === 1;
        const isContextMenu = e.button === 2;
        onClickHandler?.({
            index: index,
            source: source,
            sourceCardType: 'side-panel-source',
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        });
        if (!isContextMenu) {
            e.preventDefault();
            const url = (0, $1WRnE.constructSourceUrl)({
                source: source,
                searchSessionId: searchSessionId
            });
            window.open(url, '_blank', 'noopener, noreferrer');
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f76c30d78079e3b2$var$styles.container,
        onAuxClick: (e_0)=>{
            if (e_0.button !== 1) return;
            handleClick(e_0);
        },
        onContextMenu: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8wPz.Card), {
        appearance: "block",
        showHoverPreview: false,
        ui: {
            theme: (0, $4yYAm.SmartLinkTheme).Black,
            clickableContainer: true,
            hideElevation: true,
            hidePadding: true
        },
        url: source.url,
        onClick: handleClick,
        onError: onError || (()=>{})
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdA6O.default), {
        maxLines: 1,
        actions: [
            {
                name: (0, $4yYAm.ActionName).CopyLinkAction,
                hideContent: true
            },
            {
                name: (0, $4yYAm.ActionName).PreviewAction,
                hideContent: true
            }
        ],
        showActionOnHover: true,
        position: (0, $4yYAm.SmartLinkPosition).Center,
        className: (0, $hekY6.default)([
            $f76c30d78079e3b2$var$unboundStyles.titleBlockCss
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1503.default), {
        primary: [
            {
                name: (0, $4yYAm.ElementName).ModifiedOn
            },
            {
                name: (0, $4yYAm.ElementName).ModifiedBy
            },
            {
                name: (0, $4yYAm.ElementName).OwnedBy
            }
        ],
        maxLines: 1,
        className: (0, $hekY6.default)([
            $f76c30d78079e3b2$var$unboundStyles.metadataBlockCss
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $es2gJ.default), {
        maxLines: 2,
        className: (0, $hekY6.default)([
            $f76c30d78079e3b2$var$unboundStyles.snippetBlockCss
        ])
    })));
};
function $f76c30d78079e3b2$var$_temp() {}

















const $fe4d4049968826dc$var$messages = (0, $kSwu1.defineMessages)({
    sources_button_text: {
        id: "search_ai.sources_side_panel_button_text",
        defaultMessage: "{numSources, plural, one {Source} other {Sources}}"
    },
    sources_panel_title: {
        id: "search_ai.sources_side_panel_title",
        defaultMessage: "{numSources, plural, one {{numSources, number} Source} other {{numSources, number} Sources}}"
    },
    close_panel: {
        id: "search_ai.sources_side_panel_close",
        defaultMessage: "Close sources panel"
    }
});
const $fe4d4049968826dc$var$styles = {
    panel: "_1mT5xdy1CL _2IhTonp0Oa _4ApkO2Pgdg _0Bm75GPgdg _39xV02N6MY _0KLXruoI2d _1Vs123NvrM _421I1o6wH8 _0obpEh9r67 _3iDTPbQ4SZ _0aFT5vbt8w",
    panelHeader: "_37wbyuI7V3 _0hPCNLDIqT _0jFU0VStgI _3YEZNOdnbC _1Znuxb5zaO _2Zuz6Q5zaO _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67",
    panelContent: "_2mHwu88HPE _2WAcuGIZbP _2O5Vij7dHp _0Of8r22ADO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    sourceItem: "_0Of8r22ADO _1wydGW2ADO"
};
const $fe4d4049968826dc$export$7552c1f78575b57c = ({ renderTrigger: renderTrigger } = {})=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const context = (0, $3hVWe.useAIAnswerContext)();
    const { commonAttributes: commonAttributes } = context;
    const { sources: sources } = commonAttributes;
    const { handleSmartCardClick: handleSmartCardClick, searchSessionId: searchSessionId } = (0, $280875adc8c5626f$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context
    });
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const panelRef = (0, $cozmU.useRef)(null);
    const triggerRef = (0, $cozmU.useRef)(null);
    const { mounted: isChatMounted } = (0, $bGNkz.useUIStore)();
    const prevChatMounted = (0, $cozmU.useRef)(isChatMounted);
    (0, $cozmU.useEffect)(()=>{
        if (isChatMounted && !prevChatMounted.current) setIsOpen(false);
        prevChatMounted.current = isChatMounted;
    }, [
        isChatMounted
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isOpen && panelRef.current) panelRef.current.focus();
    }, [
        isOpen
    ]);
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const handleToggle = (0, $cozmU.useCallback)(()=>{
        setIsOpen((prev)=>{
            if (!prev) {
                fireAnalyticsEvent((0, $a020d6fc16168401$export$93f0009a720af69b)({
                    ...commonAttributes,
                    elementInteracted: 'sources-side-panel-button'
                }));
                fireSAINUsageEvent({
                    metCriteria: (0, $bZMnB.SainAction).VIEW_ALL_SOURCES,
                    commonAttributes: commonAttributes
                });
                if (isChatMounted) publish({
                    type: 'chat-close',
                    source: 'sain',
                    data: {}
                });
            }
            return !prev;
        });
    }, [
        isChatMounted,
        publish,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        commonAttributes
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
        triggerRef.current?.focus();
    }, []);
    if (!sources || sources.length === 0) return null;
    const numSources = sources.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderTrigger ? renderTrigger(handleToggle, triggerRef) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: handleToggle,
        testId: "sources-side-panel-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f0122fe4f75fa739$export$ebff7094edd1bb81), {
        sources: sources
    }), formatMessage($fe4d4049968826dc$var$messages.sources_button_text, {
        numSources: numSources
    }))), isOpen && /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fe4d4049968826dc$var$styles.panel,
        testId: "sources-side-panel",
        ref: panelRef,
        tabIndex: -1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $fe4d4049968826dc$var$styles.panelHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "xsmall"
    }, formatMessage($fe4d4049968826dc$var$messages.sources_panel_title, {
        numSources: numSources
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage($fe4d4049968826dc$var$messages.close_panel),
        onClick: handleClose
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $fe4d4049968826dc$var$styles.panelContent
    }, sources.map((source, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: source.url || index,
            xcss: $fe4d4049968826dc$var$styles.sourceItem,
            testId: `sources-side-panel-item-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f76c30d78079e3b2$export$554b5f10e8e833c8), {
            source: source,
            index: index,
            searchSessionId: searchSessionId,
            onClickHandler: handleSmartCardClick
        }))))), document.body));
};












function $d3e29575f8ad4c54$export$8f4f0a9c358684c2(streamedTextToDisplay, isStreamComplete = false) {
    const [bufferedContent, setBufferedContent] = (0, $cozmU.useState)('');
    (0, $cozmU.useEffect)(()=>{
        // When streamed text is cleared reset buffered content
        if (!streamedTextToDisplay && bufferedContent && (0, $iDrrr.fg)('kd_fix_abort_errors')) {
            setBufferedContent('');
            return;
        }
        // Split by newlines to handle various line endings
        const lines = streamedTextToDisplay.split(/\r?\n|\r/);
        // If stream is complete, include all content including the last line
        if (isStreamComplete) {
            const allContent = lines.join('\n');
            if (allContent !== bufferedContent) {
                const delay = bufferedContent === '' ? 0 : 250;
                setTimeout(()=>{
                    setBufferedContent(allContent);
                }, delay);
            }
            return;
        }
        // Only update if we have more than one line (complete sections)
        if (lines.length > 1) {
            // Take everything except the last line (incomplete section)
            const completeSections = lines.slice(0, -1).join('\n');
            // Only update if the complete sections are different from what we already have
            if (completeSections !== bufferedContent) {
                // First section appears immediately, subsequent sections have delay
                const delay = bufferedContent === '' ? 0 : 250;
                setTimeout(()=>{
                    setBufferedContent(completeSections);
                }, delay);
            }
        }
    }, [
        streamedTextToDisplay,
        bufferedContent,
        isStreamComplete
    ]);
    return bufferedContent;
}








function $1dee242400437624$export$fd29db098e42c3fc(observeTargetRef, resizeObserverCallback, pollInterval = 100, additionalDeps = []) {
    const resizeObserverRef = (0, $cozmU.useRef)(null);
    const pollIntervalRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const observeDelayedTarget = ()=>{
            if (!observeTargetRef.current) return;
            // clear polling once target is ready
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
            resizeObserverRef.current = new ResizeObserver(resizeObserverCallback);
            resizeObserverRef.current.observe(observeTargetRef.current);
        };
        // start polling for the target
        observeDelayedTarget(); // check immediately
        pollIntervalRef.current = setInterval(observeDelayedTarget, pollInterval);
        return ()=>{
            if (pollIntervalRef.current) clearInterval(pollIntervalRef.current);
            if (resizeObserverRef.current) resizeObserverRef.current.disconnect();
        };
    }, [
        ...additionalDeps
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}


function $6df3d09e09b61b24$export$d112da4490f261ea(contentRef, containerRef, collapsed, additionalDeps = []) {
    const [isContentTruncated, setIsContentTruncated] = (0, $cozmU.useState)(false);
    // Only measure when collapsed is true
    const measureTruncation = (0, $cozmU.useCallback)(()=>{
        if (!collapsed) return;
        if (contentRef.current && containerRef.current) {
            const contentHeight = contentRef.current.getBoundingClientRect().height;
            const containerHeight = containerRef.current.getBoundingClientRect().height;
            setIsContentTruncated(contentHeight > containerHeight);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collapsed,
        contentRef,
        containerRef,
        ...additionalDeps
    ]);
    // Measure truncation and reset state when collapsed state changes
    (0, $cozmU.useEffect)(()=>{
        if (!collapsed) {
            setIsContentTruncated(false);
            return;
        }
        measureTruncation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        collapsed,
        contentRef,
        containerRef,
        ...additionalDeps
    ]);
    (0, $1dee242400437624$export$fd29db098e42c3fc)(contentRef, measureTruncation);
    return isContentTruncated;
}



/* ai-collapse.tsx generated by @compiled/babel-plugin v2.0.0 */ 















var $j6vyT = parcelRequire("j6vyT");


























const $4217877a0025dc35$var$styles = {
    collapsableContainer: "_4bt5LAnQyn _2WAcuGnQyn _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r22ADO",
    header: "_2Zuz6Q5zaO _1Znuxb5zaO _0Of8r28HPE",
    pointer: "_0wOv4Q7zJH",
    rootCollapsed: "_0jFU0Vv6H3 _3X9j4qyIAw",
    rootCollapsedWithReadMore: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VaXQy _39HuIbz8Lp _3X9j4qyIAw",
    rootExpanded: "_4kiQYAJK6w",
    pressable: "_0KLXru66of _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0wOv4Q18ZR _39xV02N91d",
    luminaContainerOverrides: "_2Zuz6QPgdg _1ZnuxbPgdg _0Of8r2Pgdg",
    luminaHeaderOverrides: "_2Zuz6QPgdg _1ZnuxbPgdg _0Of8r2Pgdg",
    luminaFullHeightOverrides: "_4kiQYAheo5",
    luminaOverrides: "_4kiQYAaG3x",
    luminaTextAnswerOverrides: "_0jFU0Voaux",
    headerWithButton: "_4kiQYAUF4f"
};
const $4217877a0025dc35$export$127e64693c41156a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, isCollapsed: isCollapsed, onExpandCollapse: onExpandCollapse, title: title, showReadMoreButton: showReadMoreButton, luminaAnswerType: luminaAnswerType }, forwardedRef)=>{
    const containerRef = (0, $cozmU.useRef)(null);
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const onExpand = ()=>{
        fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).EXPAND_CLICKED,
            commonAttributes: commonAttributes
        });
    };
    const onCollapse = ()=>fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)(commonAttributes));
    const handleExpandCollapse = ()=>{
        if (isCollapsed) onExpand();
        else onCollapse();
        onExpandCollapse?.();
    };
    const handleExpandCollapseButtonClick = (event)=>{
        event.stopPropagation();
        handleExpandCollapse?.();
    };
    const onContainerClick = (event)=>{
        const selection = window.getSelection()?.toString() ?? ''; // Highlighting text should not expand the card
        const hasHighlightedText = selection.length > 0; // Clicking in a feedback modal or flag should not expand the card
        const isClickingOnContainer = containerRef.current?.contains(event.target) ?? false;
        if (isCollapsed && !hasHighlightedText && isClickingOnContainer) handleExpandCollapse?.();
    };
    return(// This Box click handler is just a convenience for mouse users; there's a keyboard-accessible button that supports the same functionality
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onClick: onContainerClick,
        ref: containerRef,
        xcss: (0, $w6R6I.cx)($4217877a0025dc35$var$styles.pressable, isCollapsed && $4217877a0025dc35$var$styles.pointer),
        role: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        xcss: (0, $w6R6I.cx)($4217877a0025dc35$var$styles.header, luminaAnswerType && $4217877a0025dc35$var$styles.luminaHeaderOverrides, (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && $4217877a0025dc35$var$styles.headerWithButton)
    }, title ? title : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null), luminaAnswerType || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: isCollapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))),
        label: formatMessage(isCollapsed ? (0, $5OgwG.messages).ai_answer_card_expand_button : (0, $5OgwG.messages).ai_answer_card_collapse_button),
        spacing: "compact",
        onClick: handleExpandCollapseButtonClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: forwardedRef,
        xcss: (0, $w6R6I.cx)($4217877a0025dc35$var$styles.collapsableContainer, isCollapsed ? showReadMoreButton ? $4217877a0025dc35$var$styles.rootCollapsedWithReadMore : $4217877a0025dc35$var$styles.rootCollapsed : $4217877a0025dc35$var$styles.rootExpanded, luminaAnswerType && $4217877a0025dc35$var$styles.luminaContainerOverrides, luminaAnswerType === 'LUMINA' && ((0, $7DMz5.SAINFeatureControl).isFullHeightLuminaEnabled() ? $4217877a0025dc35$var$styles.luminaFullHeightOverrides : $4217877a0025dc35$var$styles.luminaOverrides), isCollapsed && luminaAnswerType === 'STANDARD' && $4217877a0025dc35$var$styles.luminaTextAnswerOverrides),
        testId: "ai-collapse-container"
    }, children))));
});





/* animated-single-line-show-more.tsx generated by @compiled/babel-plugin v2.0.0 */ 






















var $IQ4Dz = parcelRequire("IQ4Dz");







const $bb4a8344422431c3$export$f0624d0c866f1dff = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerReadMoreButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $ad1269dfeb562305$export$8aac675f87e67286 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerReadMoreButton',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};














var $f420039341622608$var$UpdatedDarkThemeStops = /*#__PURE__*/ function(UpdatedDarkThemeStops) {
    UpdatedDarkThemeStops["ORANGE"] = "#FCA700";
    UpdatedDarkThemeStops["GREEN"] = "#82B536";
    UpdatedDarkThemeStops["BLUE"] = "#357DE8";
    UpdatedDarkThemeStops["PURPLE"] = "#BF63F3";
    return UpdatedDarkThemeStops;
}($f420039341622608$var$UpdatedDarkThemeStops || {});
var $f420039341622608$var$UpdatedLightThemeStops = /*#__PURE__*/ function(UpdatedLightThemeStops) {
    UpdatedLightThemeStops["ORANGE"] = "#FCA700";
    UpdatedLightThemeStops["GREEN"] = "#6A9A23";
    UpdatedLightThemeStops["BLUE"] = "#1868DB";
    UpdatedLightThemeStops["PURPLE"] = "#AF59E0";
    return UpdatedLightThemeStops;
}($f420039341622608$var$UpdatedLightThemeStops || {})// Helper function to convert hex color to rgba with alpha
;
const $f420039341622608$var$hexToRgba = (hex, alpha)=>{
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}; // This injects a CSS property into the document for the --gradient-angle variable.
// This is needed so the browser understands how to animate the gradient-angle as an angle
// value. This is done this way because compiled doesn't support CSS variables at this time.
let $f420039341622608$var$propertyInjected = false;
const $f420039341622608$var$useGradientAngleProperty = ()=>{
    (0, $cozmU.useEffect)(()=>{
        if ($f420039341622608$var$propertyInjected) return;
        $f420039341622608$var$propertyInjected = true;
        try {
            const style = document.createElement('style');
            style.innerHTML = `
				@property --gradient-angle {
					syntax: '<angle>';
					initial-value: 0deg;
					inherits: false;
				}
			`;
            document.head.appendChild(style); // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {}
    }, []);
};
const $f420039341622608$var$unboundedStyles = {
    root: "_1mT5xdRAKS",
    lineStyles: "_0jFU0VHZdu",
    lineNotStreamingStyles: "_0KLXru9r67",
    showMoreButtonWrapperStyles: "_49OCfRdnbC _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    showMoreButtonStyles: "_0bjKvDKTcp _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _0KLXrulfZc _24h04i2Njc _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _39xV02ymWf _0jFU0VUofl _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0ReiIH7zJH"
}; // Keyframes for rotating the gradient angle
// ts-ignore because jira build is failing, but this is legit
// @ts-ignore
const $f420039341622608$var$rotateGradient = null;
const $f420039341622608$var$lineAnimation = null;
const $f420039341622608$var$lightModeAnimatedStyles = null;
const $f420039341622608$var$darkModeAnimatedStyles = null;
const $f420039341622608$export$8a1fad5d74d43878 = ({ isStreaming: isStreaming, showMoreButtonVisible: showMoreButtonVisible, fireShownEvent: fireShownEvent, onClickShowMoreButton: onClickShowMoreButton })=>{
    $f420039341622608$var$useGradientAngleProperty();
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)(); // Fire analytics event when button is shown
    // to keep in parity with old read more button - used for SSR
    (0, $cozmU.useEffect)(()=>{
        const shouldFire = fireShownEvent !== undefined ? fireShownEvent : showMoreButtonVisible;
        if (shouldFire) fireAnalyticsEvent((0, $ad1269dfeb562305$export$8aac675f87e67286)(commonAttributes));
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fireShownEvent,
        showMoreButtonVisible
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $bb4a8344422431c3$export$f0624d0c866f1dff)(commonAttributes));
        if (!(0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).READ_MORE_BUTTON_CLICKED,
            commonAttributes: commonAttributes
        });
        onClickShowMoreButton?.();
    }, [
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        onClickShowMoreButton,
        commonAttributes
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $f420039341622608$var$unboundedStyles.root
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $f420039341622608$var$unboundedStyles.lineStyles,
            "_2fBhte9NQ3",
            isStreaming ? colorMode === 'dark' ? "_2uo31fqVVN" : "_2uo31fazsC" : $f420039341622608$var$unboundedStyles.lineNotStreamingStyles
        ]),
        style: {
            "--_1i41aq5": (0, $9aYkv.default)($f420039341622608$var$hexToRgba("#1868DB", 1)),
            "--_ki6hwq": (0, $9aYkv.default)($f420039341622608$var$hexToRgba("#357DE8", 1)),
            "--_1vk81z2": (0, $9aYkv.default)($f420039341622608$var$hexToRgba("#82B536", 1)),
            "--_92idzx": (0, $9aYkv.default)($f420039341622608$var$hexToRgba("#FCA700", 1)),
            "--_9dqj5t": (0, $9aYkv.default)($f420039341622608$var$hexToRgba("#BF63F3", 1)),
            "--_t9jq7i": (0, $9aYkv.default)($f420039341622608$var$hexToRgba("#6A9A23", 1)),
            "--_1456abr": (0, $9aYkv.default)($f420039341622608$var$hexToRgba("#FCA700", 1)),
            "--_wnwy7": (0, $9aYkv.default)($f420039341622608$var$hexToRgba("#AF59E0", 1))
        }
    }), showMoreButtonVisible && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $f420039341622608$var$unboundedStyles.showMoreButtonWrapperStyles
        ])
    }, /*#__PURE__*/ $cozmU.createElement("button", {
        onClick: handleClick,
        className: (0, $hekY6.default)([
            $f420039341622608$var$unboundedStyles.showMoreButtonStyles
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: ''
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        weight: "medium"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $5OgwG.messages).ai_answer_card_show_more_button))))));
};



var $j8bJ5 = parcelRequire("j8bJ5");

/* react-renderer.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $eNbr2 = parcelRequire("eNbr2");














var $9GVkD = parcelRequire("9GVkD");


var $6rwn6 = parcelRequire("6rwn6");





var $7fxzU = parcelRequire("7fxzU");


var $b6fxF = parcelRequire("b6fxF");


var $lEgaq = parcelRequire("lEgaq");







/* inline-citation-group.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $3vgx3 = parcelRequire("3vgx3");

























const $1c582c9fdb181286$var$messages = (0, $kSwu1.defineMessages)({
    inline_citations_group_title: {
        id: "search_ai.inline_citations_group_title",
        defaultMessage: "{numCitations, plural, one {{numCitations, number} Source} other {{numCitations, number} Sources}}"
    },
    inline_citations_close_dropdown_label: {
        id: "search_ai.inline_citations_close_dropdown_label",
        defaultMessage: "Close the dropdown"
    }
});
const $1c582c9fdb181286$var$styles = {
    citationGroup: "_0bjKvDKTcp _0Of8r21Y8M _1ZnuxbgVvo _1wydGW1Y8M _2Zuz6QgVvo _0KLXruDMqu _1RrJLiYXK7 _3138425UaJ _1DCdHi5UaJ",
    citationDropdownContainer: "_39xV02Hakr _3WbItzf7mX _2TH8g8y7kJ",
    citationDropdownHeader: "_1x1D3gOeNX _0Of8r25zaO _1Znuxb5zaO _1wydGW8HPE _2Zuz6Q5zaO"
};
const $1c582c9fdb181286$export$94da02477787e5c = ({ parsedSources: parsedSources })=>{
    const [isCitationsOpen, setIsCitationsOpen] = (0, $cozmU.useState)(false); // ref to keep track of whether user opens dropdown by clicking
    const dropdownOpenByClick = (0, $cozmU.useRef)(false);
    const closeDropdownTimeoutRef = (0, $cozmU.useRef)(null);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (closeDropdownTimeoutRef.current) clearTimeout(closeDropdownTimeoutRef.current);
        };
    }, []);
    const context = (0, $3hVWe.useAIAnswerContext)();
    const { handleSmartCardClick: handleSmartCardClick, searchSessionId: searchSessionId } = (0, $280875adc8c5626f$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context,
        isCitation: true
    });
    const handlePressableClick = (e)=>{
        e.stopPropagation(); // only close if user had originally opened dropdown by clicking
        // without this, it causes unwanted behavior with the hover behavior
        if (isCitationsOpen && dropdownOpenByClick.current) setIsCitationsOpen(false);
        dropdownOpenByClick.current = !dropdownOpenByClick.current;
    }; // set timer to close to avoid closing when user is moving mouse
    // between pressable and dropdown (small space in between)
    const handlePressableMouseLeave = ()=>{
        closeDropdownTimeoutRef.current = setTimeout(()=>{
            if (!dropdownOpenByClick.current) setIsCitationsOpen(false);
        }, 150);
    }; // clear timer above once moving mouse to dropdown
    const handleDropdownMouseEnter = ()=>{
        if (closeDropdownTimeoutRef.current) clearTimeout(closeDropdownTimeoutRef.current);
    }; // prevent closing dropdown if user had originally opened dropdown by clicking
    const handleDropdownMouseLeave = ()=>{
        if (!dropdownOpenByClick.current) setIsCitationsOpen(false);
        return;
    }; // callback for when user clicks outside of trigger pressable component
    const handleDropdownOpenChange = (attrs)=>{
        if (!attrs.isOpen) dropdownOpenByClick.current = false;
        setIsCitationsOpen(attrs.isOpen);
    };
    const handleButtonClose = ()=>{
        dropdownOpenByClick.current = false;
        setIsCitationsOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
                ref: triggerRef,
                ...props,
                xcss: $1c582c9fdb181286$var$styles.citationGroup,
                onClick: handlePressableClick,
                onMouseEnter: ()=>setIsCitationsOpen(true),
                onMouseLeave: handlePressableMouseLeave,
                testId: "smart-answer-inline-citation-group",
                "aria-label": formatMessage($1c582c9fdb181286$var$messages.inline_citations_group_title, {
                    numCitations: parsedSources.length
                }),
                [(0, $lEgaq.SAIN_CITATION_ATTRIBUTE)]: 'true'
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f0122fe4f75fa739$export$ebff7094edd1bb81), {
                sources: parsedSources,
                maxSourcesInStack: 2,
                showNumAddtlSources: true,
                addEditorStyleOverrides: true
            }))),
        shouldFlip: true,
        isOpen: isCitationsOpen,
        onOpenChange: handleDropdownOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        onMouseEnter: handleDropdownMouseEnter,
        onMouseLeave: handleDropdownMouseLeave,
        xcss: $1c582c9fdb181286$var$styles.citationDropdownContainer,
        testId: "smart-answer-inline-citation-dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1c582c9fdb181286$var$styles.citationDropdownHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage($1c582c9fdb181286$var$messages.inline_citations_group_title, {
        numCitations: parsedSources.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage($1c582c9fdb181286$var$messages.inline_citations_close_dropdown_label),
        onClick: handleButtonClose,
        spacing: "compact",
        testId: "smart-answer-inline-citation-dropdown-close-button"
    }))), parsedSources.map((source, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aUgOE.KnowledgeSmartCard), {
            source: source,
            variant: (0, $aUgOE.CardVariant).DROPDOWN_SOURCE,
            index: index,
            searchSessionId: searchSessionId,
            onClickHandler: handleSmartCardClick
        }))));
};


const $ba9b602d2037f879$export$e190835f8c06a181 = ({ localId: localId })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { sources: sources } = commonAttributes;
    const inlineCitationData = (0, $cozmU.useMemo)(()=>{
        if (!sources || sources.length === 0) return undefined;
        try {
            const parsedCitationIndices = JSON.parse(localId);
            const parsedSources = parsedCitationIndices.map((idx)=>sources[idx - 1]);
            const citationUrls = parsedSources.map((source)=>source.url);
            return {
                citationUrls: citationUrls,
                parsedSources: parsedSources
            };
        } catch  {
            return undefined;
        }
    }, [
        sources,
        localId
    ]);
    return !!inlineCitationData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1c582c9fdb181286$export$94da02477787e5c), {
        parsedSources: inlineCitationData.parsedSources
    }) : null;
};


/* status-citation.tsx generated by @compiled/babel-plugin v2.0.0 */ 































const $e2862f0d359af03a$var$styles = {
    root: "_30huDKYbGa _0KLXrujOvk _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0ReiIH7zJH"
};
const $e2862f0d359af03a$var$convertColorAppearance = (color)=>{
    switch(color){
        case 'blue':
            return 'information';
        case 'green':
            return 'success';
        case 'red':
            return 'danger';
        case 'yellow':
            return 'warning';
        case 'purple':
            return 'discovery';
        default:
            return 'neutral';
    }
};
const $e2862f0d359af03a$export$21553c57082a6434 = ({ localId: localId, text: text, color: color = 'blue' })=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3hVWe.useAIAnswerContext)();
    const sources = commonAttributes.sources;
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { source: source, idx: idx } = (0, $cozmU.useMemo)(()=>{
        if (!localId.includes('citation')) return {};
        const idx = parseInt(localId.split('-')?.[1]);
        return {
            source: sources[idx - 1],
            idx: idx
        };
    }, [
        localId,
        sources
    ]);
    const handleClick = (0, $cozmU.useCallback)((source, idx, e)=>{
        const isAuxClick = e?.button === 1;
        const isContextMenu = e?.button === 2;
        if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: idx,
            isCitation: true,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu,
            hostname: (0, $736ac3075308471f$export$a3b7216c107a7a1)(source.url),
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source.product),
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes
        });
        if (!isContextMenu) window.open(source.url, '_blank', 'noopener, noreferrer');
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        fireSAINUsageEvent
    ]);
    if (!!source) return /*#__PURE__*/ $cozmU.createElement((0, $jLxvy.StandaloneHoverCard), {
        url: source.url
    }, /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        [(0, $lEgaq.SAIN_CITATION_ATTRIBUTE)]: 'true',
        xcss: $e2862f0d359af03a$var$styles.root,
        onClick: (e)=>{
            handleClick(source, idx, e);
        },
        onAuxClick: (e)=>{
            if (e.button !== 1) return;
            handleClick(source, idx, e);
        },
        onContextMenu: (e)=>{
            handleClick(source, idx, e);
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
        appearance: "information"
    }, idx)));
    // Standard lozenge for status nodes
    return /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), {
        appearance: $e2862f0d359af03a$var$convertColorAppearance(color)
    }, text);
};
























var $3d581288ec05f499$export$255ec938a30a2b3 = /*#__PURE__*/ function(StreamAnswerGenerationTypes) {
    StreamAnswerGenerationTypes["LUMINA"] = "LUMINA";
    StreamAnswerGenerationTypes["STANDARD"] = "STANDARD";
    return StreamAnswerGenerationTypes;
}({});



var $7s8U5 = parcelRequire("7s8U5");


var $hZTED = parcelRequire("hZTED");




const $f2af7a532cac1c29$var$getCorrelationAttributes = (context)=>{
    if (!context || !(0, $iDrrr.fg)('kd_granular_network_errors')) return {};
    return {
        ...context.searchSessionId && {
            searchSessionId: context.searchSessionId
        },
        ...context.queryHash && {
            queryHash: context.queryHash
        },
        ...context.sourceProduct && {
            sourceProduct: context.sourceProduct
        },
        ...context.isReadingAids !== undefined && {
            isReadingAids: context.isReadingAids
        },
        ...context.queryIntent && {
            queryIntent: context.queryIntent
        }
    };
};
const $f2af7a532cac1c29$export$ee4edf16a7c39598 = (error, source, correlationContext)=>{
    const correlationAttrs = $f2af7a532cac1c29$var$getCorrelationAttributes(correlationContext);
    if (error instanceof Error) return {
        action: 'failed',
        actionSubject: 'aiAnswerDialogStreamFetch',
        source: source,
        eventType: 'track',
        attributes: {
            errorName: error.name,
            errorMessage: error.message,
            errorStack: error.stack?.split('\n').at(1) || '',
            ...'details' in error && {
                details: error.details
            },
            ...'errorCode' in error && {
                errorCode: error.errorCode
            },
            ...correlationAttrs
        }
    };
    if (error instanceof Object && 'error' in error) return {
        action: 'failed',
        actionSubject: 'aiAnswerDialogStreamFetch',
        source: source,
        eventType: 'track',
        attributes: {
            errorName: error.error instanceof Error ? error.error.name : '',
            errorMessage: error.error instanceof Error ? error.error.message : typeof error === 'string' ? error : '',
            errorStack: error.error instanceof Error ? error.error.stack?.split('\n').at(1) : '',
            reason: 'reason' in error ? error.reason : '',
            details: 'details' in error ? error.details : '',
            ...correlationAttrs
        }
    };
    return {
        action: 'failed',
        actionSubject: 'aiAnswerDialogStreamFetch',
        source: source,
        eventType: 'track',
        attributes: {
            reason: error instanceof Object && 'reason' in error ? error.reason : '',
            details: error instanceof Object && 'details' in error ? error.details : '',
            ...correlationAttrs
        }
    };
};
const $f2af7a532cac1c29$export$13b0ccf9f6015e4c = (error, source, correlationContext)=>{
    const correlationAttrs = $f2af7a532cac1c29$var$getCorrelationAttributes(correlationContext);
    return {
        action: 'failed',
        actionSubject: 'aiAnswerDialogNonStreamFetch',
        source: source,
        eventType: 'track',
        attributes: {
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : '',
            ...correlationAttrs
        }
    };
};



var $kqQyU = parcelRequire("kqQyU");







const $b6b6ac34f723c99f$export$80be2adf18435a80 = (prev, traceData)=>{
    const { messageTemplate: messageTemplate, stepId: stepId } = traceData;
    if (!messageTemplate || !stepId) return prev;
    // `existing` is the current state of this step (if it has arrived before,
    // e.g. TITLE arrived and now CONTENT is streaming in). `isNewStep` flags
    // that this is the very first message for this stepId.
    // `order` preserves the insertion sequence across all steps so the UI can
    // sort them chronologically — re-uses the existing order if already set,
    // otherwise takes the next available integer after the highest current order.
    // `baseStep` merges existing state with required defaults so every switch
    // branch below can safely spread it and only override what changed.
    const existing = prev[stepId];
    const isNewStep = !existing;
    const order = existing?.order ?? (Object.values(prev).length ? Math.max(...Object.values(prev).map((s)=>s.order)) + 1 : 1);
    const baseStep = {
        ...existing,
        stepId: stepId,
        roundId: existing?.roundId ?? traceData.roundId ?? 0,
        order: order,
        separatedContent: existing?.separatedContent ?? []
    };
    switch(messageTemplate){
        case 'RESEARCH_STEP_TITLE':
        case 'RESEARCH_STEP_TITLE_SHORT':
            return {
                ...prev,
                [stepId]: {
                    ...baseStep,
                    title: traceData.title,
                    roundId: traceData.roundId ?? baseStep.roundId,
                    toolIcon: traceData.toolIcon ?? undefined,
                    toolName: traceData.toolName ?? undefined,
                    completed: baseStep.completed ?? false
                }
            };
        case 'RESEARCH_STEP':
        case 'RESEARCH_STEP_CONTENT':
            {
                const chunk = traceData.content ?? '';
                const concatenated = (baseStep.content ?? '') + chunk;
                return {
                    ...prev,
                    [stepId]: {
                        ...baseStep,
                        roundId: traceData.roundId ?? baseStep.roundId,
                        content: concatenated,
                        separatedContent: [
                            ...baseStep.separatedContent ?? [],
                            chunk
                        ],
                        // Orphan content (content arriving for a step that has no title yet) is
                        // considered already-complete to avoid hanging in an unfinished state.
                        // Also preserve completed=true if RESEARCH_STEP_COMPLETE arrived out-of-order.
                        completed: baseStep.completed ?? (isNewStep && !baseStep.title)
                    }
                };
            }
        case 'RESEARCH_STEP_SOURCE':
            return {
                ...prev,
                [stepId]: {
                    ...baseStep,
                    sources: traceData.sources ?? baseStep.sources
                }
            };
        case 'RESEARCH_STEP_ICONS':
            {
                const ICON_BASE_URL = '/gateway/api/assist/rovo/v1/resources/icon/';
                const products = traceData.products ?? [];
                return {
                    ...prev,
                    [stepId]: {
                        ...baseStep,
                        sourceIcons: products.map((p)=>p.startsWith('/') || p.startsWith('data:') ? p : `${ICON_BASE_URL}${p}`)
                    }
                };
            }
        case 'RESEARCH_STEP_COMPLETE':
            return {
                ...prev,
                [stepId]: {
                    ...baseStep,
                    completed: true
                }
            };
        default:
            return prev;
    }
};








// Type guards for intent classification
const $117a17190f14c8c7$var$isPersonIntent = (data)=>data.classification === (0, $zzZbq.QueryIntent).PERSON;
/**
 * Registry mapping QueryIntent classification to skip handlers.
 * Add new handlers here to support additional intent types.
 */ const $117a17190f14c8c7$var$intentSkipHandlers = {
    /**
   * PERSON intent: Skip API call if persons array has data.
   * Transform Person[] from intent to NLPSearchPersonResultType format.
   */ [(0, $zzZbq.QueryIntent).PERSON]: (intentData)=>{
        if (!$117a17190f14c8c7$var$isPersonIntent(intentData) || intentData.persons === undefined || intentData.persons === null) return {
            skip: false
        };
        // Transform intent persons to the format expected by knowledge cards
        const mappedPersons = {
            user_metadata_only_cards: intentData.persons.map((person)=>({
                    id: person.accountId,
                    name: person.name,
                    title: person.jobTitle || undefined,
                    avatarUrl: person.picture || undefined,
                    location: person.location || undefined,
                    zoneInfo: person.zoneInfo || undefined
                }))
        };
        return {
            skip: true,
            data: {
                nlpResult: JSON.stringify(mappedPersons),
                format: (0, $hpFQM.NLPSearchResultFormat).JSON,
                errorState: null,
                disclaimer: null,
                uniqueSources: [],
                extraAPIAnalyticsAttributes: {
                    skippedViaIntentClassification: true,
                    intentClassification: intentData.classification
                }
            }
        };
    }
};
const $117a17190f14c8c7$export$75cd51191584b8ce = (intentData)=>{
    if (!intentData) return {
        skip: false
    };
    const handler = $117a17190f14c8c7$var$intentSkipHandlers[intentData.classification];
    if (!handler) return {
        skip: false
    };
    return handler(intentData);
};


class $b9b2682ba0353829$export$fc5c9343c5342824 extends Error {
    constructor(message, opts){
        super(message);
        this.details = void 0;
        this.errorCode = void 0;
        this.reason = void 0;
        this.backendFailureType = void 0;
        this.name = 'StreamFailedError';
        this.details = opts?.details;
        this.errorCode = opts?.errorCode;
        this.reason = opts?.reason;
        this.backendFailureType = opts?.backendFailureType;
    }
}


const $b2270b423e154e70$export$84f2194b2008422 = "\u25D0";
const $b2270b423e154e70$export$192ba1edc601a546 = "\u25D1";
const $b2270b423e154e70$export$ea5ceaf3fa709ad4 = '\n\n[^lumina^]\n\n';
const $b2270b423e154e70$export$b2ac4f39739d467d = 'lumina-';
const $b2270b423e154e70$var$getLuminaComponents = ()=>[
        {
            key: 'lumina',
            startTag: $b2270b423e154e70$export$84f2194b2008422,
            endTag: $b2270b423e154e70$export$192ba1edc601a546,
            placeholderTag: $b2270b423e154e70$export$ea5ceaf3fa709ad4,
            isEnabled: (0, $iDrrr.fg)('kd_sain_enable_inline_lumina')
        }
    ];
const $b2270b423e154e70$export$6dbb893b575831e8 = async ({ cloudId: // eslint-disable-next-line @typescript-eslint/no-unused-vars
cloudId, locale: locale, query: query, additional_context: additional_context, source: source, followUpsEnabled: followUpsEnabled = false, getAIAnswer: getAIAnswer, setLoading: setLoading, partialResponse: partialResponse, partialResponseAbortControllerRef: partialResponseAbortControllerRef, setPartialResponse: setPartialResponse, setData: setData, setAnswerStreamed: setAnswerStreamed, parsedFilters: parsedFilters, selectedProduct: selectedProduct, isReadingAids: isReadingAids, fireAnalyticsEvent: fireAnalyticsEvent, setQueryReasoning: setQueryReasoning, setResearchSteps: setResearchSteps, setDynamicLayoutSubAgentMessages: setDynamicLayoutSubAgentMessages, setIsLuminaAnswer: setIsLuminaAnswer, setLuminaContentMap: setLuminaContentMap, experimentContext: experimentContext, queryIntentClassificationData: queryIntentClassificationData, referrer: referrer, searchSessionId: searchSessionId, sourceProduct: sourceProduct, queryIntent: queryIntent })=>{
    if (!getAIAnswer) return;
    if (partialResponse?.partialNlpResult) // clean up any old partial responses
    setPartialResponse(undefined);
    // end any old partial response streams
    partialResponseAbortControllerRef.current?.abort();
    const abortController = new AbortController();
    partialResponseAbortControllerRef.current = abortController;
    // Check if we can skip the AI answer call based on intent classification data.
    // If the intent already has the data we need (e.g., PersonIntent with persons[]),
    // use it directly instead of making another API call.
    if ((0, $iDrrr.fg)('kd_fe_persons_intent_detection_els')) {
        const skipResult = (0, $117a17190f14c8c7$export$75cd51191584b8ce)(queryIntentClassificationData);
        if (skipResult.skip) {
            setData(skipResult.data);
            (0, $6JEx2.setSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
                query: query,
                data: skipResult.data
            }));
            setAnswerStreamed(true);
            setLoading(false);
            return;
        }
    }
    // For graphQL getAIAnswer fns we expect each product to pass their own cloudIdARI in order for this component to be more product agnostic
    const aiAnswer = getAIAnswer({
        variables: {
            query: query,
            additional_context: additional_context,
            locale: locale,
            filters: parsedFilters,
            selectedProduct: selectedProduct,
            experience: isReadingAids ? 'readingAids' : source,
            followUpsEnabled: followUpsEnabled,
            experimentContext: experimentContext,
            ...(0, $7DMz5.SAINFeatureControl).isZeroQuerySuggestionsV1Enabled(sourceProduct) && referrer === 'zeroQuery' ? {
                isQuerySuggestion: true
            } : {}
        }
    });
    // Legacy version of processStreamResponse - used when feature gate is off
    const processStreamResponse = async (answer)=>{
        try {
            let next = await answer.stream.next();
            let answerFormat;
            // Local variable to track if answer is Lumina format (used for cache enablement)
            let isLuminaAnswerLocal = false;
            // Guard so the research-step failsafe only fires on the first AnswerPart
            let hasCompletedAllSteps = false;
            const processStreamMarkdownMultiTag = (0, $f3OgL.createMarkdownProcessorMultiTags)($b2270b423e154e70$var$getLuminaComponents);
            const luminaContentMap = {};
            while(!next.done){
                // setLoading needed here for instances where stream gets interrupted and restarts, ensuring loading state is set while stream is active
                setLoading(true);
                const streamEvent = next.value;
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerType) answerFormat = streamEvent.message.format;
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).GenerationType && (0, $7DMz5.SAINFeatureControl).canRenderLumina()) {
                    if (streamEvent.message.answer_generation_type === (0, $3d581288ec05f499$export$255ec938a30a2b3).LUMINA) {
                        isLuminaAnswerLocal = true;
                        setIsLuminaAnswer(true);
                    }
                }
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).Trace) {
                    if (answerFormat !== (0, $hpFQM.NLPSearchResultFormat).MARKDOWN) throw new Error(`Unexpected format: ${answerFormat}`);
                    setQueryReasoning(streamEvent.message);
                    // When the new FG is on and the BE sent a structured RESEARCH_STEP_*
                    // trace, merge it into the local research-step state.
                    if (streamEvent.traceData && setResearchSteps && ((0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled() || (0, $7DMz5.SAINFeatureControl).isSAINLoadingStateTracesUpdateEnabled())) {
                        const traceData = streamEvent.traceData;
                        setResearchSteps((prev)=>(0, $b6b6ac34f723c99f$export$80be2adf18435a80)(prev, traceData));
                    }
                }
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerPart) {
                    if (answerFormat !== (0, $hpFQM.NLPSearchResultFormat).MARKDOWN) throw new Error(`Unexpected format: ${answerFormat}`);
                    // Failsafe (mirrors Chat's `completeAllSteps`): when the answer
                    // starts streaming, mark every research step complete in case the
                    // BE skipped any `RESEARCH_STEP_COMPLETE` messages. Prevents the
                    // shimmer animation from getting stuck on incomplete steps.
                    if (!hasCompletedAllSteps && setResearchSteps && ((0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled() || (0, $7DMz5.SAINFeatureControl).isSAINLoadingStateTracesUpdateEnabled())) {
                        hasCompletedAllSteps = true;
                        setResearchSteps((prev)=>{
                            let mutated = false;
                            const next = {};
                            for (const [id, step] of Object.entries(prev))if (!step.completed) {
                                next[id] = {
                                    ...step,
                                    completed: true
                                };
                                mutated = true;
                            } else next[id] = step;
                            return mutated ? next : prev;
                        });
                    }
                    if ((0, $iDrrr.fg)('kd_sain_enable_inline_lumina')) {
                        const { processedText: processedText, markdownData: markdownData } = processStreamMarkdownMultiTag(streamEvent.message.nlpResult);
                        if (Object.keys(markdownData).length > 0) {
                            Object.entries(markdownData).forEach(([key, { content: content }])=>{
                                luminaContentMap[key] = (luminaContentMap[key] ?? '') + content;
                            });
                            setLuminaContentMap({
                                ...luminaContentMap
                            });
                        }
                        setPartialResponse((previousPartialResponse)=>({
                                format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
                                partialNlpResult: (previousPartialResponse?.partialNlpResult ?? '') + processedText
                            }));
                    } else setPartialResponse((previousPartialResponse)=>{
                        let previousPartialNlpResult = previousPartialResponse?.partialNlpResult || '';
                        return {
                            format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
                            partialNlpResult: previousPartialNlpResult + streamEvent.message.nlpResult
                        };
                    });
                }
                if ((0, $7DMz5.SAINFeatureControl).canRenderLumina()) {
                    if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) setDynamicLayoutSubAgentMessages((prevMessages)=>[
                            ...prevMessages,
                            streamEvent.message
                        ]);
                }
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse) {
                    const authorityUiMetadata = streamEvent.message.authority_ui_metadata ?? null;
                    if ((0, $iDrrr.fg)('kd_sain_enable_inline_lumina')) {
                        const { boundaryContents: boundaryContents } = (0, $f3OgL.extractMarkdownText)(streamEvent.message.nlpResult ?? '', $b2270b423e154e70$export$84f2194b2008422, $b2270b423e154e70$export$192ba1edc601a546, $b2270b423e154e70$export$ea5ceaf3fa709ad4);
                        const luminaContentMap = {};
                        boundaryContents.forEach((content, index)=>{
                            luminaContentMap[`${$b2270b423e154e70$export$b2ac4f39739d467d}${index}`] = content;
                        });
                        setLuminaContentMap(luminaContentMap);
                        setData({
                            ...streamEvent.message,
                            authority_ui_metadata: authorityUiMetadata
                        });
                    } else setData({
                        ...streamEvent.message,
                        authority_ui_metadata: authorityUiMetadata
                    });
                    setPartialResponse(undefined);
                    setLoading(false);
                }
                next = await answer.stream.next();
                if (abortController.signal.aborted) // eslint-disable-next-line no-throw-literal
                throw 'Aborted';
            }
            const streamEnd = next.value;
            if (abortController.signal.aborted) // eslint-disable-next-line no-throw-literal
            throw streamEnd;
            if (streamEnd.state === 'complete') {
                if ((0, $iDrrr.fg)('kd_sain_enable_inline_lumina')) {
                    const { boundaryContents: boundaryContents } = (0, $f3OgL.extractMarkdownText)(streamEnd.value.message.nlpResult ?? '', $b2270b423e154e70$export$84f2194b2008422, $b2270b423e154e70$export$192ba1edc601a546, $b2270b423e154e70$export$ea5ceaf3fa709ad4);
                    const luminaContentMap = {};
                    boundaryContents.forEach((content, index)=>{
                        luminaContentMap[`${$b2270b423e154e70$export$b2ac4f39739d467d}${index}`] = content;
                    });
                    setLuminaContentMap(luminaContentMap);
                    setData(streamEnd.value.message);
                } else setData(streamEnd.value.message);
                setPartialResponse(undefined);
                // Only store to cache if not a Lumina answer
                if (isReadingAids || !isLuminaAnswerLocal) (0, $6JEx2.setSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
                    query: query,
                    data: streamEnd.value.message
                }));
            } else {
                if (streamEnd.reason === 'timeout') {
                    setPartialResponse(undefined);
                    setData({
                        errorState: (0, $htnqN.NLPSearchErrorState).TimeoutError,
                        errorCode: 0,
                        format: null,
                        disclaimer: null,
                        nlpResults: [],
                        uniqueSources: [],
                        nlpFollowUpResults: null
                    });
                } else throw streamEnd;
            }
        } catch (error) {
            fireAnalyticsEvent((0, $f2af7a532cac1c29$export$ee4edf16a7c39598)(error, source));
            if (error === 'Aborted') return;
            setPartialResponse(undefined);
            setData({
                errorState: typeof error === 'object' && error !== null && 'details' in error && error?.details === (0, $kqQyU.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR ? (0, $htnqN.NLPSearchErrorState).HIPAAError : (0, $htnqN.NLPSearchErrorState).NetworkError,
                errorCode: error?.errorCode ? error.errorCode : 0,
                format: null,
                disclaimer: null,
                nlpResults: [],
                uniqueSources: [],
                nlpFollowUpResults: null,
                nlpSuggestedQueries: []
            });
        } finally{
            setAnswerStreamed(true);
            setLoading(false);
        }
    };
    // New version with improved error handling using standard JS Error objects
    const processStreamResponseImprovedErrorHandling = async (answer)=>{
        const fetchStartTime = Date.now();
        let streamEventsReceived = 0;
        try {
            let next = await answer.stream.next();
            let answerFormat;
            // Local variable to track if answer is Lumina format (used for cache enablement)
            let isLuminaAnswerLocal = false;
            // Guard so the research-step failsafe only fires on the first AnswerPart
            let hasCompletedAllSteps = false;
            const processStreamMarkdownMultiTag = (0, $f3OgL.createMarkdownProcessorMultiTags)($b2270b423e154e70$var$getLuminaComponents);
            const luminaContentMap = {};
            while(!next.done){
                // setLoading needed here for instances where stream gets interrupted and restarts, ensuring loading state is set while stream is active
                setLoading(true);
                streamEventsReceived++;
                const streamEvent = next.value;
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerType) answerFormat = streamEvent.message.format;
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).GenerationType && (0, $7DMz5.SAINFeatureControl).canRenderLumina()) {
                    if (streamEvent.message.answer_generation_type === (0, $3d581288ec05f499$export$255ec938a30a2b3).LUMINA) {
                        isLuminaAnswerLocal = true;
                        setIsLuminaAnswer(true);
                    }
                }
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).Trace) {
                    if (answerFormat !== (0, $hpFQM.NLPSearchResultFormat).MARKDOWN) throw new Error(`Unexpected format: ${answerFormat}`);
                    setQueryReasoning(streamEvent.message);
                    // When the new FG is on and the BE sent a structured RESEARCH_STEP_*
                    // trace, merge it into the local research-step state.
                    if (streamEvent.traceData && setResearchSteps && ((0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled() || (0, $7DMz5.SAINFeatureControl).isSAINLoadingStateTracesUpdateEnabled())) {
                        const traceData = streamEvent.traceData;
                        setResearchSteps((prev)=>(0, $b6b6ac34f723c99f$export$80be2adf18435a80)(prev, traceData));
                    }
                }
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerPart) {
                    if (answerFormat !== (0, $hpFQM.NLPSearchResultFormat).MARKDOWN) throw new Error(`Unexpected format: ${answerFormat}`);
                    // Failsafe (mirrors Chat's `completeAllSteps`): when the answer
                    // starts streaming, mark every research step complete in case the
                    // BE skipped any `RESEARCH_STEP_COMPLETE` messages. Prevents the
                    // shimmer animation from getting stuck on incomplete steps.
                    if (!hasCompletedAllSteps && setResearchSteps && ((0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled() || (0, $7DMz5.SAINFeatureControl).isSAINLoadingStateTracesUpdateEnabled())) {
                        hasCompletedAllSteps = true;
                        setResearchSteps((prev)=>{
                            let mutated = false;
                            const next = {};
                            for (const [id, step] of Object.entries(prev))if (!step.completed) {
                                next[id] = {
                                    ...step,
                                    completed: true
                                };
                                mutated = true;
                            } else next[id] = step;
                            return mutated ? next : prev;
                        });
                    }
                    if ((0, $iDrrr.fg)('kd_sain_enable_inline_lumina')) {
                        const { processedText: processedText, markdownData: markdownData } = processStreamMarkdownMultiTag(streamEvent.message.nlpResult);
                        if (Object.keys(markdownData).length > 0) {
                            Object.entries(markdownData).forEach(([key, { content: content }])=>{
                                luminaContentMap[key] = (luminaContentMap[key] ?? '') + content;
                            });
                            setLuminaContentMap({
                                ...luminaContentMap
                            });
                        }
                        setPartialResponse((previousPartialResponse)=>({
                                format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
                                partialNlpResult: (previousPartialResponse?.partialNlpResult ?? '') + processedText
                            }));
                    } else setPartialResponse((previousPartialResponse)=>{
                        let previousPartialNlpResult = previousPartialResponse?.partialNlpResult || '';
                        return {
                            format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
                            partialNlpResult: previousPartialNlpResult + streamEvent.message.nlpResult
                        };
                    });
                }
                if ((0, $7DMz5.SAINFeatureControl).canRenderLumina()) {
                    if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) setDynamicLayoutSubAgentMessages((prevMessages)=>[
                            ...prevMessages,
                            streamEvent.message
                        ]);
                }
                if (streamEvent.type === (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse) {
                    const msg = streamEvent.message;
                    const authorityUiMetadata = msg.authority_ui_metadata ?? null;
                    if ((0, $iDrrr.fg)('kd_sain_enable_inline_lumina')) {
                        const { boundaryContents: boundaryContents } = (0, $f3OgL.extractMarkdownText)(streamEvent.message.nlpResult ?? '', $b2270b423e154e70$export$84f2194b2008422, $b2270b423e154e70$export$192ba1edc601a546, $b2270b423e154e70$export$ea5ceaf3fa709ad4);
                        const luminaContentMap = {};
                        boundaryContents.forEach((content, index)=>{
                            luminaContentMap[`${$b2270b423e154e70$export$b2ac4f39739d467d}${index}`] = content;
                        });
                        setLuminaContentMap(luminaContentMap);
                        setData(msg.errorState && msg.errorState !== (0, $htnqN.NLPSearchErrorState).Default ? {
                            ...msg,
                            streamEventsReceived: streamEventsReceived,
                            networkErrorDuration: Date.now() - fetchStartTime,
                            authority_ui_metadata: authorityUiMetadata
                        } : {
                            ...msg,
                            authority_ui_metadata: authorityUiMetadata
                        });
                    } else setData(msg.errorState && msg.errorState !== (0, $htnqN.NLPSearchErrorState).Default ? {
                        ...msg,
                        streamEventsReceived: streamEventsReceived,
                        networkErrorDuration: Date.now() - fetchStartTime,
                        authority_ui_metadata: authorityUiMetadata
                    } : {
                        ...msg,
                        authority_ui_metadata: authorityUiMetadata
                    });
                    setPartialResponse(undefined);
                    setLoading(false);
                }
                next = await answer.stream.next();
                if (abortController.signal.aborted) throw new Error('Aborted');
            }
            const streamEnd = next.value;
            if (abortController.signal.aborted) throw new Error(streamEnd.state === 'failed' ? streamEnd.reason : 'Aborted');
            if (streamEnd.state === 'complete') {
                const streamEndFinalMessage = streamEnd.value.message;
                if ((0, $iDrrr.fg)('kd_sain_enable_inline_lumina')) {
                    const { boundaryContents: boundaryContents } = (0, $f3OgL.extractMarkdownText)(streamEnd.value.message.nlpResult ?? '', $b2270b423e154e70$export$84f2194b2008422, $b2270b423e154e70$export$192ba1edc601a546, $b2270b423e154e70$export$ea5ceaf3fa709ad4);
                    const luminaContentMap = {};
                    boundaryContents.forEach((content, index)=>{
                        luminaContentMap[`${$b2270b423e154e70$export$b2ac4f39739d467d}${index}`] = content;
                    });
                    setLuminaContentMap(luminaContentMap);
                    setData(streamEndFinalMessage);
                } else setData(streamEndFinalMessage);
                setPartialResponse(undefined);
                // Only store to cache if not a Lumina answer
                if (isReadingAids || !isLuminaAnswerLocal) (0, $6JEx2.setSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
                    query: query,
                    data: streamEndFinalMessage
                }));
            } else {
                if (streamEnd.reason === 'timeout') {
                    setPartialResponse(undefined);
                    setData({
                        errorState: (0, $htnqN.NLPSearchErrorState).TimeoutError,
                        errorCode: 0,
                        format: null,
                        disclaimer: null,
                        nlpResults: [],
                        uniqueSources: [],
                        nlpFollowUpResults: null
                    });
                } else throw new (0, $b9b2682ba0353829$export$fc5c9343c5342824)(`Stream failed: ${streamEnd.reason}`, {
                    details: 'details' in streamEnd ? streamEnd.details : undefined,
                    errorCode: 'errorCode' in streamEnd ? streamEnd.errorCode : undefined,
                    reason: streamEnd.reason,
                    backendFailureType: 'backendFailureType' in streamEnd ? streamEnd.backendFailureType : undefined
                });
            }
        } catch (error) {
            const networkErrorDuration = Date.now() - fetchStartTime;
            fireAnalyticsEvent((0, $f2af7a532cac1c29$export$ee4edf16a7c39598)(error, source, {
                searchSessionId: searchSessionId,
                queryHash: (0, $9oghv.sha256Hash)(query),
                sourceProduct: sourceProduct,
                isReadingAids: isReadingAids,
                queryIntent: queryIntent
            }));
            setPartialResponse(undefined);
            if (error instanceof Error && error.message === 'Aborted') {
                if ((0, $iDrrr.fg)('kd_fix_abort_errors')) // Don't  set error data on client-initiated abort
                return;
                setData({
                    errorState: (0, $htnqN.NLPSearchErrorState).NetworkError,
                    networkErrorReason: 'client_aborted',
                    streamEventsReceived: streamEventsReceived,
                    networkErrorDuration: networkErrorDuration,
                    format: null,
                    disclaimer: null,
                    nlpResults: [],
                    uniqueSources: [],
                    nlpFollowUpResults: null,
                    nlpSuggestedQueries: []
                });
                return;
            }
            const details = error instanceof (0, $b9b2682ba0353829$export$fc5c9343c5342824) ? error.details : undefined;
            const errorCode = error instanceof (0, $b9b2682ba0353829$export$fc5c9343c5342824) ? error.errorCode ?? 0 : 0;
            const networkErrorReason = error instanceof (0, $b9b2682ba0353829$export$fc5c9343c5342824) ? error.reason : undefined;
            const networkErrorDetails = error instanceof (0, $b9b2682ba0353829$export$fc5c9343c5342824) ? error.details : undefined;
            const backendFailureType = error instanceof (0, $b9b2682ba0353829$export$fc5c9343c5342824) ? error.backendFailureType : undefined;
            setData({
                errorState: details === (0, $kqQyU.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR ? (0, $htnqN.NLPSearchErrorState).HIPAAError : (0, $htnqN.NLPSearchErrorState).NetworkError,
                errorCode: errorCode,
                networkErrorReason: networkErrorReason,
                networkErrorDetails: networkErrorDetails,
                backendFailureType: backendFailureType,
                streamEventsReceived: streamEventsReceived,
                networkErrorDuration: networkErrorDuration,
                format: null,
                disclaimer: null,
                nlpResults: [],
                uniqueSources: [],
                nlpFollowUpResults: null,
                nlpSuggestedQueries: []
            });
        } finally{
            // Don't update loading/streamed state for aborted streams
            if (!abortController.signal.aborted || !(0, $iDrrr.fg)('kd_fix_abort_errors')) {
                setAnswerStreamed(true);
                setLoading(false);
            }
        }
    };
    // If aiAnswer is an object with a type property -- it's a getAIAnswer
    // and we need to handle the new streaming response
    if ('type' in aiAnswer) {
        if ((0, $iDrrr.fg)('kd_sain_improved_fetch_errors')) processStreamResponseImprovedErrorHandling(aiAnswer);
        else processStreamResponse(aiAnswer);
        return;
    }
    await aiAnswer.then((data)=>{
        if ('type' in data) {
            processStreamResponse(data);
            return;
        }
        setData(data?.nlpSearch || (0, $hZTED.DEFAULT_EMPTY_NLP_SEARCH_STATE));
        // Only store to cache if Lumina is disabled
        if (isReadingAids || !(0, $7DMz5.SAINFeatureControl).canRenderLumina()) (0, $6JEx2.setSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
            query: query,
            data: data?.nlpSearch || (0, $hZTED.DEFAULT_EMPTY_NLP_SEARCH_STATE)
        }));
        setLoading(false);
    }).catch((error)=>{
        fireAnalyticsEvent((0, $f2af7a532cac1c29$export$13b0ccf9f6015e4c)(error, source, {
            searchSessionId: searchSessionId,
            queryHash: (0, $9oghv.sha256Hash)(query),
            sourceProduct: sourceProduct,
            isReadingAids: isReadingAids,
            queryIntent: queryIntent
        }));
        const isTimeout = error instanceof DOMException && error.name === 'TimeoutError';
        setData({
            errorState: isTimeout ? (0, $htnqN.NLPSearchErrorState).TimeoutError : (0, $htnqN.NLPSearchErrorState).NetworkError,
            ...!isTimeout && (0, $iDrrr.fg)('kd_granular_network_errors') && {
                networkErrorReason: 'fetch_error',
                networkErrorDetails: error instanceof Error ? error.message : undefined
            },
            format: null,
            disclaimer: null,
            nlpResults: [],
            uniqueSources: [],
            nlpFollowUpResults: null
        });
        setLoading(false);
    });
};


const $63458847df53b6c8$var$MARKDOWN_FENCED_CODE_BLOCK_REGEX = /```[\s\S]*?```/g;
const $63458847df53b6c8$var$MARKDOWN_INLINE_CODE_REGEX = /`[^`\n]*`/g;
const $63458847df53b6c8$var$MARKDOWN_BLUE_LINK_REGEX = RegExp("(?<!!)\\[([^\\]]+)\\]\\(([^)]+)\\)", "g");
const $63458847df53b6c8$export$9b73daf8fd4da40f = (markdown)=>(markdown.replace($63458847df53b6c8$var$MARKDOWN_FENCED_CODE_BLOCK_REGEX, '').replace($63458847df53b6c8$var$MARKDOWN_INLINE_CODE_REGEX, '').match($63458847df53b6c8$var$MARKDOWN_BLUE_LINK_REGEX) ?? []).length;


















var $1rNZu = parcelRequire("1rNZu");

















var $6O5Et = parcelRequire("6O5Et");














/**
 * Shared implementation for the inline-Lumina source click handler. Pulled out of
 * the hook so both the stable (ref-backed) and legacy (dependency-backed) variants
 * can reuse exactly the same behaviour.
 */ const $69db6f2ab6839786$var$runSourceClick = (event, deps)=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes, fireSAINUsageEvent: fireSAINUsageEvent, onAIAnswerSourceClickCallback: onAIAnswerSourceClickCallback } = deps;
    if (!commonAttributes) return;
    const { url: url, componentType: componentType, indexInContainer: indexInContainer, isAuxClick: isAuxClick, isContextMenu: isContextMenu, isCopy: isCopy } = event;
    if ((isAuxClick || isContextMenu) && !(0, $7DMz5.SAINFeatureControl).isNonPrimaryClickTrackingEnabled()) return;
    // Copy interactions reuse the existing `aiAnswerCopy clicked` event.
    if (isCopy) {
        fireAnalyticsEvent((0, $6O5Et.onAIAnswerCopyButtonClicked)(commonAttributes, 'inline-lumina-link-embed'));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).COPY_CLICKED,
            commonAttributes: commonAttributes
        });
        onAIAnswerSourceClickCallback?.();
        return;
    }
    const sourceCardType = componentType === 'linkList' ? 'inline-lumina-link-list' : componentType === 'linkEmbed' ? 'inline-lumina-link-embed' : undefined;
    let hostname;
    try {
        hostname = new URL(url).hostname;
    } catch  {
        hostname = undefined;
    }
    const sourceProduct = commonAttributes.sourceProduct ?? '';
    fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
        // Spread first so per-click fields below override context values.
        ...commonAttributes,
        sourceIndex: indexInContainer,
        hostname: hostname,
        isAuxClick: isAuxClick,
        isContextMenu: isContextMenu,
        sourceCardType: sourceCardType,
        sourceProduct: sourceProduct,
        isCitation: false
    }));
    fireSAINUsageEvent({
        metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
        commonAttributes: commonAttributes,
        sourceProduct: sourceProduct
    });
    onAIAnswerSourceClickCallback?.();
};
const $69db6f2ab6839786$export$e2fbe4dcb5b88963 = ({ aiAnswerDialogContext: aiAnswerDialogContext })=>{
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const commonAttributes = aiAnswerDialogContext?.commonAttributes;
    const onAIAnswerSourceClickCallback = aiAnswerDialogContext?.callbacks?.onAIAnswerSourceClick;
    // `commonAttributes` gets a new reference on every streamed chunk (it depends on
    // the growing answer string). When this handler lists it as a `useCallback`
    // dependency, the handler identity changes every chunk and is passed as a new
    // `onSourceClick` prop into `LuminaLayout` / the inline link list, causing it to
    // re-render on every chunk while streaming. Keeping the volatile values in a ref
    // lets the handler stay stable while still reading fresh values at click time.
    const isStreamingFlickerFixEnabled = (0, $iDrrr.fg)('kd_link_list_streaming_flicker_fix');
    const latestDepsRef = (0, $cozmU.useRef)({
        fireAnalyticsEvent: fireAnalyticsEvent,
        commonAttributes: commonAttributes,
        fireSAINUsageEvent: fireSAINUsageEvent,
        onAIAnswerSourceClickCallback: onAIAnswerSourceClickCallback
    });
    latestDepsRef.current = {
        fireAnalyticsEvent: fireAnalyticsEvent,
        commonAttributes: commonAttributes,
        fireSAINUsageEvent: fireSAINUsageEvent,
        onAIAnswerSourceClickCallback: onAIAnswerSourceClickCallback
    };
    const stableHandler = (0, $cozmU.useCallback)((event)=>$69db6f2ab6839786$var$runSourceClick(event, latestDepsRef.current), // Intentionally stable: reads the latest values via `latestDepsRef`.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const legacyHandler = (0, $cozmU.useCallback)((event)=>$69db6f2ab6839786$var$runSourceClick(event, {
            fireAnalyticsEvent: fireAnalyticsEvent,
            commonAttributes: commonAttributes,
            fireSAINUsageEvent: fireSAINUsageEvent,
            onAIAnswerSourceClickCallback: onAIAnswerSourceClickCallback
        }), [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        onAIAnswerSourceClickCallback
    ]);
    return isStreamingFlickerFixEnabled ? stableHandler : legacyHandler;
};


const $df13fecb6fd21b0f$var$LUMINA_START_TAG = '<lumina>';
const $df13fecb6fd21b0f$var$LUMINA_END_TAG = '</lumina>';

const $df13fecb6fd21b0f$var$LuminaLayout = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("ibV84")).then((mod)=>({
            default: mod.LuminaLayout
        })));
const $df13fecb6fd21b0f$var$InlineLuminaLayout = ({ luminaContent: luminaContent, cloudId: cloudId, orgId: orgId, requestingUserId: requestingUserId, sourceProduct: sourceProduct })=>{
    const aiAnswerDialogContext = (0, $3hVWe.useAIAnswerContext)();
    const onSourceClick = (0, $69db6f2ab6839786$export$e2fbe4dcb5b88963)({
        aiAnswerDialogContext: aiAnswerDialogContext
    });
    const { sessionId: sessionId } = aiAnswerDialogContext.commonAttributes;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df13fecb6fd21b0f$var$LuminaLayout, {
        luminaTagResponse: `${$df13fecb6fd21b0f$var$LUMINA_START_TAG}${luminaContent}${$df13fecb6fd21b0f$var$LUMINA_END_TAG}`,
        source: "luminaSAIN",
        smartLinkRenderer: "embed",
        cloudId: cloudId,
        orgId: orgId,
        requestingUserId: requestingUserId,
        sourceProduct: sourceProduct,
        sessionId: sessionId,
        onSourceClick: onSourceClick
    });
};
const $df13fecb6fd21b0f$export$d182b2243055abe1 = (props, markdownData, appContext, userId)=>{
    if ((0, $1rNZu.isInlineLuminaStatus)(props.localId)) {
        // retrieve idx of status node created by extension
        const luminaIdx = parseInt(props.text.replace((0, $1rNZu.INLINE_LUMINA_STATUS_PREFIX), ''), 10);
        // map idx to content from markdownData created during streaming
        const luminaContent = markdownData?.[`${0, $b2270b423e154e70$export$b2ac4f39739d467d}${luminaIdx}`] ?? '';
        if (luminaContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($df13fecb6fd21b0f$var$InlineLuminaLayout, {
            luminaContent: luminaContent,
            cloudId: appContext.cloudId,
            orgId: appContext.orgId,
            requestingUserId: userId,
            sourceProduct: appContext.sourceProduct
        });
    }
    if ((0, $7DMz5.SAINFeatureControl).isInlineCitationsUpdateEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ba9b602d2037f879$export$e190835f8c06a181), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2862f0d359af03a$export$21553c57082a6434), props);
};


const $6c5ac787bcb31d21$var$messages = (0, $kSwu1.defineMessages)({
    linksOpenInNewTab: {
        id: "search-ai.v2.common.react-renderer.linksOpenInNewTab",
        defaultMessage: "Links in this answer open in a new tab."
    }
});

const $6c5ac787bcb31d21$var$AkReactRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("7ydRw")).then(({ ReactRenderer: ReactRenderer })=>{
        return {
            default: ReactRenderer
        };
    }));
const $6c5ac787bcb31d21$var$fadeIn = null;
const $6c5ac787bcb31d21$var$animatedStyles = {
    container: "_2fBhteWDhd"
};
const $6c5ac787bcb31d21$var$unboundAnimatedStyles = {
    container: "_1YKVNsdnbC",
    listItem: "_08tqxzWDhd _0R6HAadnbC"
};
const $6c5ac787bcb31d21$var$StaggeredChild = /*#__PURE__*/ (0, $cozmU.memo)(({ children: children, index: index })=>{
    // If children is a string longer than 10 characters, split it into 3 parts
    if (typeof children === 'string' && children.length > 10) {
        const chunkSize = Math.ceil(children.length / 3);
        const parts = [
            children.slice(0, chunkSize),
            children.slice(chunkSize, chunkSize * 2),
            children.slice(chunkSize * 2)
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, parts.map((part, partIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                key: partIndex,
                style: {
                    animationDelay: `${index * 200 + partIndex * 100}ms`
                },
                className: (0, $hekY6.default)([
                    $6c5ac787bcb31d21$var$animatedStyles.container,
                    $6c5ac787bcb31d21$var$unboundAnimatedStyles.container
                ])
            }, part)));
    } // For non-strings or short strings, render normally
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            animationDelay: `${index * 200}ms`
        },
        className: (0, $hekY6.default)([
            $6c5ac787bcb31d21$var$animatedStyles.container,
            $6c5ac787bcb31d21$var$unboundAnimatedStyles.container
        ])
    }, children);
});
$6c5ac787bcb31d21$var$StaggeredChild.displayName = 'StaggeredChild';
const $6c5ac787bcb31d21$var$StaggeredAnimatedParagraph = /*#__PURE__*/ (0, $cozmU.memo)(({ children: children })=>{
    // Convert children to array to handle staggering
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, childrenArray.map((child, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c5ac787bcb31d21$var$StaggeredChild, {
            key: index,
            index: index
        }, child)));
});
$6c5ac787bcb31d21$var$StaggeredAnimatedParagraph.displayName = 'StaggeredAnimatedParagraph';
const $6c5ac787bcb31d21$var$AnimatedOrderedList = /*#__PURE__*/ (0, $cozmU.memo)(({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ol", {
        ...props,
        className: (0, $hekY6.default)([
            $6c5ac787bcb31d21$var$animatedStyles.container,
            $6c5ac787bcb31d21$var$unboundAnimatedStyles.container,
            $6c5ac787bcb31d21$var$unboundAnimatedStyles.listItem
        ])
    }, children);
});
$6c5ac787bcb31d21$var$AnimatedOrderedList.displayName = 'AnimatedOrderedList';
const $6c5ac787bcb31d21$var$AnimatedBulletedList = /*#__PURE__*/ (0, $cozmU.memo)(({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        ...props,
        className: (0, $hekY6.default)([
            $6c5ac787bcb31d21$var$animatedStyles.container,
            $6c5ac787bcb31d21$var$unboundAnimatedStyles.container,
            $6c5ac787bcb31d21$var$unboundAnimatedStyles.listItem
        ])
    }, children);
});
$6c5ac787bcb31d21$var$AnimatedBulletedList.displayName = 'AnimatedBulletedList';
const $6c5ac787bcb31d21$var$AnimatedHeading = /*#__PURE__*/ (0, $cozmU.memo)(({ children: children, ...props })=>{
    // Extract heading level from props (h1, h2, h3, etc.)
    const headingLevel = props.level || 1;
    const HeadingTag = `h${headingLevel}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(HeadingTag, {
        ...props,
        className: (0, $hekY6.default)([
            $6c5ac787bcb31d21$var$animatedStyles.container,
            $6c5ac787bcb31d21$var$unboundAnimatedStyles.container
        ])
    }, children);
});
$6c5ac787bcb31d21$var$AnimatedHeading.displayName = 'AnimatedHeading'; // Create stable component references to prevent recreation
const $6c5ac787bcb31d21$var$StatusComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2862f0d359af03a$export$21553c57082a6434), props));
$6c5ac787bcb31d21$var$StatusComponent.displayName = 'StatusComponent';
const $6c5ac787bcb31d21$var$StatusComponentInlineCitation = /*#__PURE__*/ (0, $cozmU.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ba9b602d2037f879$export$e190835f8c06a181), props));
$6c5ac787bcb31d21$var$StatusComponentInlineCitation.displayName = 'StatusComponentInlineCitation';
const $6c5ac787bcb31d21$var$MediaComponent = /*#__PURE__*/ (0, $cozmU.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null));
$6c5ac787bcb31d21$var$MediaComponent.displayName = 'MediaComponent';
const $6c5ac787bcb31d21$var$MediaSingleComponent = /*#__PURE__*/ (0, $cozmU.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null));
$6c5ac787bcb31d21$var$MediaSingleComponent.displayName = 'MediaSingleComponent'; // Create stable component references
const $6c5ac787bcb31d21$var$StreamingParagraphComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c5ac787bcb31d21$var$StaggeredAnimatedParagraph, props));
$6c5ac787bcb31d21$var$StreamingParagraphComponent.displayName = 'StreamingParagraphComponent';
const $6c5ac787bcb31d21$var$StreamingOrderedListComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c5ac787bcb31d21$var$AnimatedOrderedList, props));
$6c5ac787bcb31d21$var$StreamingOrderedListComponent.displayName = 'StreamingOrderedListComponent';
const $6c5ac787bcb31d21$var$StreamingBulletedListComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c5ac787bcb31d21$var$AnimatedBulletedList, props));
$6c5ac787bcb31d21$var$StreamingBulletedListComponent.displayName = 'StreamingBulletedListComponent';
const $6c5ac787bcb31d21$var$StreamingHeadingComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c5ac787bcb31d21$var$AnimatedHeading, props));
$6c5ac787bcb31d21$var$StreamingHeadingComponent.displayName = 'StreamingHeadingComponent';
function $6c5ac787bcb31d21$export$687d546b0584d31b({ markdown: markdown, animateComponents: animateComponents = false }) {
    const { luminaContentMap: luminaContentMap, commonAttributes: commonAttributes, userDetails: userDetails } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const rendererContainerRef = (0, $cozmU.useRef)(null);
    const blueLinkAnalyticsContextRef = (0, $cozmU.useRef)({
        commonAttributes: commonAttributes,
        fireAnalyticsEvent: fireAnalyticsEvent,
        fireSAINUsageEvent: fireSAINUsageEvent
    });
    blueLinkAnalyticsContextRef.current = {
        commonAttributes: commonAttributes,
        fireAnalyticsEvent: fireAnalyticsEvent,
        fireSAINUsageEvent: fireSAINUsageEvent
    };
    const useInlineCitations = (0, $7DMz5.SAINFeatureControl).isInlineCitationsUpdateEnabled();
    const luminaInMarkdownDataRef = (0, $cozmU.useRef)(luminaContentMap);
    luminaInMarkdownDataRef.current = luminaContentMap; // Keep the latest app context / user id in refs so that the memoized `status`
    // node component below can read fresh values without changing its identity on
    // every streamed chunk. `commonAttributes` gets a new reference on every chunk
    // (it depends on the growing answer string), so depending on it directly would
    // recreate the `status` component type each chunk and force the ADF renderer to
    // unmount/remount every inline status node (including the inline Lumina link
    // list), causing a resolved <-> loading flicker while streaming.
    const statusAppContextRef = (0, $cozmU.useRef)({
        orgId: commonAttributes.orgId,
        cloudId: commonAttributes.cloudId,
        sourceProduct: commonAttributes.sourceProduct ?? '',
        userId: userDetails?.id ?? ''
    });
    statusAppContextRef.current = {
        orgId: commonAttributes.orgId,
        cloudId: commonAttributes.cloudId,
        sourceProduct: commonAttributes.sourceProduct ?? '',
        userId: userDetails?.id ?? ''
    };
    const enableImageSearch = (0, $iDrrr.fg)('hybrid_orchestrator_enable_image_search');
    const isBlueLinkAnalyticsEnabled = (0, $iDrrr.fg)('kd_sain_blue_links_analytics');
    const hasBlueLinks = (0, $cozmU.useMemo)(()=>isBlueLinkAnalyticsEnabled && (0, $63458847df53b6c8$export$9b73daf8fd4da40f)(markdown) > 0, [
        isBlueLinkAnalyticsEnabled,
        markdown
    ]);
    const docContent = (0, $cozmU.useMemo)(()=>{
        const processedMarkdown = (0, $iDrrr.fg)('kd_sain_enable_inline_lumina') ? (0, $f3OgL.extractMarkdownText)(markdown, (0, $b2270b423e154e70$export$84f2194b2008422), (0, $b2270b423e154e70$export$192ba1edc601a546), (0, $b2270b423e154e70$export$ea5ceaf3fa709ad4)).processedText : markdown;
        return (0, $6rwn6.encodeAdf)(processedMarkdown, true, undefined, undefined, useInlineCitations || undefined);
    }, [
        markdown,
        useInlineCitations
    ]); // The inline Lumina `status` node component. We build BOTH variants below (each
    // with a constant-length dependency array, so React's hook book-keeping is never
    // disturbed) and select between them via the feature gate. This keeps the
    // behaviour change gated per experimentation policy without introducing a
    // variable-length `useMemo` dependency array.
    const isStreamingFlickerFixEnabled = (0, $iDrrr.fg)('kd_link_list_streaming_flicker_fix'); // Fix ON: stable component identity for the renderer's lifetime. It reads the
    // latest app context / user id from `statusAppContextRef` (synchronised every
    // render above), so it never needs to be recreated as the answer streams in. A
    // stable `status` component type lets the ADF renderer reconcile status nodes in
    // place instead of unmounting/remounting them (and the inline Lumina link list)
    // on every chunk, which is what causes the resolved <-> loading flicker.
    const stableStatusComponent = (0, $cozmU.useMemo)(()=>{
        return (props)=>{
            const { orgId: orgId, cloudId: cloudId, sourceProduct: sourceProduct, userId: userId } = statusAppContextRef.current;
            return (0, $df13fecb6fd21b0f$export$d182b2243055abe1)(props, luminaInMarkdownDataRef.current, {
                orgId: orgId,
                cloudId: cloudId,
                sourceProduct: sourceProduct
            }, userId);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Fix OFF: original behaviour — the component is recreated whenever
    // `commonAttributes` / user id change (which happens on every streamed chunk).
    const legacyStatusComponent = (0, $cozmU.useMemo)(()=>{
        return (props)=>{
            return (0, $df13fecb6fd21b0f$export$d182b2243055abe1)(props, luminaInMarkdownDataRef.current, {
                orgId: commonAttributes.orgId,
                cloudId: commonAttributes.cloudId,
                sourceProduct: commonAttributes.sourceProduct ?? ''
            }, userDetails?.id ?? '');
        };
    }, [
        commonAttributes,
        userDetails?.id
    ]);
    const StatusComponentMemoized = isStreamingFlickerFixEnabled ? stableStatusComponent : legacyStatusComponent;
    const config = (0, $cozmU.useMemo)(()=>{
        const statusComponent = (0, $iDrrr.fg)('kd_sain_enable_inline_lumina') ? StatusComponentMemoized : useInlineCitations ? $6c5ac787bcb31d21$var$StatusComponentInlineCitation : $6c5ac787bcb31d21$var$StatusComponent; // Create stable nodeComponents objects
        const staticNodeComponents = {
            status: statusComponent,
            media: $6c5ac787bcb31d21$var$MediaComponent,
            mediaSingle: $6c5ac787bcb31d21$var$MediaSingleComponent
        };
        const animatedNodeComponents = {
            status: statusComponent,
            media: $6c5ac787bcb31d21$var$MediaComponent,
            mediaSingle: $6c5ac787bcb31d21$var$MediaSingleComponent,
            paragraph: $6c5ac787bcb31d21$var$StreamingParagraphComponent,
            orderedList: $6c5ac787bcb31d21$var$StreamingOrderedListComponent,
            bulletList: $6c5ac787bcb31d21$var$StreamingBulletedListComponent,
            heading: $6c5ac787bcb31d21$var$StreamingHeadingComponent
        };
        const nodeComponents = animateComponents ? {
            ...animatedNodeComponents
        } : {
            ...staticNodeComponents
        }; // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { media: media, mediaSingle: mediaSingle, ...nodeComponentsWithoutMediaOverrides } = nodeComponents;
        return {
            document: docContent,
            nodeComponents: enableImageSearch ? nodeComponentsWithoutMediaOverrides : nodeComponents,
            smartLinks: {
                ssr: true
            }
        };
    }, [
        docContent,
        animateComponents,
        enableImageSearch,
        useInlineCitations,
        StatusComponentMemoized
    ]);
    const cloudId = commonAttributes.cloudId;
    const orgId = commonAttributes.orgId;
    const productKey = commonAttributes.sourceProduct;
    const viewerId = userDetails?.id;
    const dataProviders = (0, $cozmU.useMemo)(()=>{
        if (!(0, $iDrrr.fg)('kd_sain_clickable_user_mentions') || !cloudId || !productKey) return undefined;
        const mentionProvider = Promise.resolve(new (0, $7fxzU.default)({
            productKey: productKey,
            siteId: cloudId,
            orgId: orgId,
            includeTeams: true,
            includeUsers: true,
            shouldHighlightMention (mention) {
                return mention.id === viewerId;
            }
        }));
        const profilecardProvider = Promise.resolve({
            cloudId: cloudId,
            resourceClient: new (0, $lRkXe.default)({
                url: '/gateway/api/directory/graphql',
                cloudId: cloudId,
                productIdentifier: productKey
            }),
            getActions: ()=>[],
            ...(0, $iDrrr.fg)('people-teams_migrate-user-profile-card') || (0, $cXtTj.default).getExperimentValue('pt_user_profile_card_migration_exp', 'isEnabled', false) ? {
                renderUserMentionCard: ({ userId: userId, cloudId: mentionCloudId, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b6fxF.UserProfileCardForMention), {
                        userId: userId,
                        cloudId: mentionCloudId,
                        orgId: orgId ?? '',
                        viewerId: viewerId ?? ''
                    }, children)
            } : {}
        });
        return (0, $eNbr2.default).create({
            mentionProvider: mentionProvider,
            profilecardProvider: profilecardProvider
        });
    }, [
        cloudId,
        orgId,
        productKey,
        viewerId
    ]); // AkReactRenderer only exposes primary link clicks through eventHandlers.link.onClick.
    // Attach native listeners on the container to capture aux-click and context-menu
    // interactions that bypass the ADF link onClick path.
    (0, $cozmU.useEffect)(()=>{
        if (!isBlueLinkAnalyticsEnabled) return;
        const container = rendererContainerRef.current;
        if (!container) return;
        const fireBlueLinkClick = ({ url: url, isAuxClick: isAuxClick, isContextMenu: isContextMenu })=>{
            const { commonAttributes: latestCommonAttributes, fireAnalyticsEvent: latestFireAnalyticsEvent, fireSAINUsageEvent: latestFireSAINUsageEvent } = blueLinkAnalyticsContextRef.current;
            latestFireAnalyticsEvent((0, $a020d6fc16168401$export$93f0009a720af69b)({
                ...latestCommonAttributes,
                elementInteracted: 'bluelink',
                isAuxClick: isAuxClick,
                isContextMenu: isContextMenu
            }));
            latestFireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).BLUE_LINK_CLICKED,
                commonAttributes: latestCommonAttributes
            });
        };
        const getContainedAnchorUrl = (event)=>{
            const target = event.target;
            if (!(target instanceof Element)) return;
            const anchor = target.closest('a[href]');
            if (!anchor || !container.contains(anchor)) return;
            const citationRoot = anchor.closest((0, $lEgaq.SAIN_CITATION_SELECTOR));
            if (citationRoot && container.contains(citationRoot)) return;
            return anchor.getAttribute('href') || undefined;
        };
        const onAuxClick = (event)=>{
            if (event.button !== 1) return;
            const url = getContainedAnchorUrl(event);
            if (!url) return;
            fireBlueLinkClick({
                url: url,
                isAuxClick: true,
                isContextMenu: false
            });
        };
        const onContextMenu = (event)=>{
            const url = getContainedAnchorUrl(event);
            if (!url) return;
            fireBlueLinkClick({
                url: url,
                isAuxClick: false,
                isContextMenu: true
            });
        }; // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        container.addEventListener('auxclick', onAuxClick); // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        container.addEventListener('contextmenu', onContextMenu);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            container.removeEventListener('auxclick', onAuxClick); // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            container.removeEventListener('contextmenu', onContextMenu);
        };
    }, [
        isBlueLinkAnalyticsEnabled
    ]);
    const eventHandlers = (0, $cozmU.useMemo)(()=>{
        if (!isBlueLinkAnalyticsEnabled) return undefined;
        return {
            link: {
                onClick: (event, url)=>{
                    if (!url) return;
                    const mouseEvent = event.nativeEvent; // Middle-clicks are handled by the native auxclick listener above;
                    // other non-primary buttons are intentionally ignored.
                    if (mouseEvent.button !== 0) return;
                    const isModifiedNavigation = mouseEvent.metaKey || mouseEvent.ctrlKey || mouseEvent.shiftKey;
                    const { commonAttributes: latestCommonAttributes, fireAnalyticsEvent: latestFireAnalyticsEvent, fireSAINUsageEvent: latestFireSAINUsageEvent } = blueLinkAnalyticsContextRef.current;
                    latestFireAnalyticsEvent((0, $a020d6fc16168401$export$93f0009a720af69b)({
                        ...latestCommonAttributes,
                        elementInteracted: 'bluelink',
                        isAuxClick: false,
                        isContextMenu: false
                    }));
                    latestFireSAINUsageEvent({
                        metCriteria: (0, $bZMnB.SainAction).BLUE_LINK_CLICKED,
                        commonAttributes: latestCommonAttributes
                    }); // For unmodified left clicks, the page would normally navigate away before
                    // the analytics request can be dispatched, so we intercept and open the link
                    // manually in a new tab. Modifier-key clicks (cmd/ctrl/shift) are left to the
                    // browser to honour the user's intent (background tab, new window, etc.) —
                    // the analytics event still fires above.
                    if (!isModifiedNavigation) {
                        event.preventDefault();
                        window.open(url, '_blank', 'noopener,noreferrer');
                    }
                }
            }
        };
    }, [
        isBlueLinkAnalyticsEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: rendererContainerRef
    }, isBlueLinkAnalyticsEnabled && hasBlueLinks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $6c5ac787bcb31d21$var$messages.linksOpenInNewTab)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c5ac787bcb31d21$var$AkReactRenderer, {
        ...config,
        eventHandlers: eventHandlers,
        dataProviders: dataProviders
    })));
}


/* read-more-button.tsx generated by @compiled/babel-plugin v2.0.0 */ 
































const $ed12dd693731600a$var$styles = {
    container: "_2Y7lL45zaO _3iDTPbQ4SZ _0Of8r2gVvo",
    readMoreButton: "_2Y7lL4Pgdg _1kk5Tkf7mX _1UtDYzM7Tp _0KLXru66of _1ANEUSLRg7 _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMAwSC _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _0CMRbkAwSC"
};
function $ed12dd693731600a$export$e68719f9c8487320({ onClick: onClick }) {
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)(); // Fire analytics event when button is shown
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent((0, $ad1269dfeb562305$export$8aac675f87e67286)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Handle click with analytics
    const handleClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $bb4a8344422431c3$export$f0624d0c866f1dff)(commonAttributes));
        if (!(0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).READ_MORE_BUTTON_CLICKED,
            commonAttributes: commonAttributes
        });
        onClick();
    }, [
        fireAnalyticsEvent,
        onClick,
        commonAttributes,
        fireSAINUsageEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ed12dd693731600a$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: handleClick,
        xcss: $ed12dd693731600a$var$styles.readMoreButton,
        testId: "read-more-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        color: "color.link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5OgwG.messages).ai_answer_card_read_more_button))));
}



var $24oKg = parcelRequire("24oKg");




const $619bd3e23d17df21$export$816a5214860a0c40 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerMinimizedCollapseButton',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $57db223fb661d84a$export$b19cbf041d35e6cc = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerMinimizedExpandButton',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $57ae65a71649f2c5$export$7f9024bb8c6bf2c3 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerMinimizedScrollUpButton',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};


/* smart-answer-card-minimized-loading.tsx generated by @compiled/babel-plugin v2.0.0 */ 




























var $kSORO = parcelRequire("kSORO");







const $e2d90c16cb0d52c9$export$db586d8c7b1541e0 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerMinimizedLoadingCollapseButton',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $7ad80c56fa109a71$export$95c4fee0614a7136 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerMinimizedLoadingExpandButton',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};






var $lvJXz = parcelRequire("lvJXz");

var $2976c97aa2bab989$exports = {};
$2976c97aa2bab989$exports = JSON.parse("{\"v\":\"5.7.1\",\"fr\":30,\"ip\":0,\"op\":108,\"w\":100,\"h\":100,\"nm\":\"Shape Morph\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":1,\"ty\":4,\"nm\":\"Morph Shape\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100},\"r\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":27,\"s\":[180],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":54,\"s\":[240],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":80,\"s\":[360],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":107,\"s\":[450]}]},\"p\":{\"a\":0,\"k\":[50,50,0]},\"a\":{\"a\":0,\"k\":[0,0,0]},\"s\":{\"a\":0,\"k\":[100,100,100]}},\"ao\":0,\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"ind\":0,\"ty\":\"sh\",\"ix\":1,\"ks\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[6.499999999999993,-49.6],[12.899999999999999,-48.3],[19.099999999999994,-46.2],[25,-43.3],[30.400000000000006,-39.7],[35.400000000000006,-35.4],[39.7,-30.4],[43.3,-25],[46.2,-19.1],[48.3,-12.899999999999999],[49.599999999999994,-6.5],[50,0],[49.599999999999994,6.499999999999993],[48.3,12.899999999999999],[46.2,19.099999999999994],[43.3,25],[39.7,30.400000000000006],[35.400000000000006,35.400000000000006],[30.400000000000006,39.7],[25,43.3],[19.099999999999994,46.2],[12.899999999999999,48.3],[6.499999999999993,49.599999999999994],[0,50],[-6.5,49.599999999999994],[-12.899999999999999,48.3],[-19.1,46.2],[-25,43.3],[-30.4,39.7],[-35.4,35.400000000000006],[-39.7,30.400000000000006],[-43.3,25],[-46.2,19.099999999999994],[-48.3,12.899999999999999],[-49.6,6.499999999999993],[-50,0],[-49.6,-6.5],[-48.3,-12.899999999999999],[-46.2,-19.1],[-43.3,-25],[-39.7,-30.4],[-35.4,-35.4],[-30.4,-39.7],[-25,-43.3],[-19.1,-46.2],[-12.899999999999999,-48.3],[-6.5,-49.6]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":27,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[-50,-50],[-41.7,-50],[-33.3,-50],[-25,-50],[-16.700000000000003,-50],[-8.299999999999997,-50],[0,-50],[8.299999999999997,-50],[16.700000000000003,-50],[25,-50],[33.3,-50],[41.7,-50],[50,-50],[50,-41.7],[50,-33.3],[50,-25],[50,-16.700000000000003],[50,-8.299999999999997],[50,0],[50,8.299999999999997],[50,16.700000000000003],[50,25],[50,33.3],[50,41.7],[50,50],[41.7,50],[33.3,50],[25,50],[16.700000000000003,50],[8.299999999999997,50],[0,50],[-8.299999999999997,50],[-16.700000000000003,50],[-25,50],[-33.3,50],[-41.7,50],[-50,50],[-50,41.7],[-50,33.3],[-50,25],[-50,16.700000000000003],[-50,8.299999999999997],[-50,0],[-50,-8.299999999999997],[-50,-16.700000000000003],[-50,-25],[-50,-33.3],[-50,-41.7]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":54,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[5.3999999999999915,-46.9],[10.799999999999997,-43.7],[16.200000000000003,-40.6],[21.700000000000003,-37.5],[27.099999999999994,-34.4],[32.5,-31.2],[37.900000000000006,-28.1],[43.3,-25],[43.3,-18.7],[43.3,-12.5],[43.3,-6.200000000000003],[43.3,0],[43.3,6.299999999999997],[43.3,12.5],[43.3,18.799999999999997],[43.3,25],[37.900000000000006,28.099999999999994],[32.5,31.299999999999997],[27.099999999999994,34.400000000000006],[21.700000000000003,37.5],[16.200000000000003,40.599999999999994],[10.799999999999997,43.8],[5.3999999999999915,46.900000000000006],[0,50],[-5.399999999999999,46.900000000000006],[-10.799999999999997,43.8],[-16.200000000000003,40.599999999999994],[-21.699999999999996,37.5],[-27.1,34.400000000000006],[-32.5,31.299999999999997],[-37.9,28.099999999999994],[-43.3,25],[-43.3,18.799999999999997],[-43.3,12.5],[-43.3,6.299999999999997],[-43.3,0],[-43.3,-6.200000000000003],[-43.3,-12.5],[-43.3,-18.8],[-43.3,-25],[-37.9,-28.1],[-32.5,-31.3],[-27.1,-34.4],[-21.699999999999996,-37.5],[-16.200000000000003,-40.6],[-10.799999999999997,-43.7],[-5.399999999999999,-46.9]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":80,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[3.1000000000000014,-43.7],[6.299999999999997,-37.5],[9.399999999999999,-31.2],[12.5,-25],[15.599999999999994,-18.7],[18.799999999999997,-12.5],[21.900000000000006,-6.200000000000003],[25,0],[28.099999999999994,6.299999999999997],[31.299999999999997,12.5],[34.400000000000006,18.799999999999997],[37.5,25],[40.599999999999994,31.299999999999997],[43.8,37.5],[46.900000000000006,43.8],[50,50],[43.8,50],[37.5,50],[31.299999999999997,50],[25,50],[18.799999999999997,50],[12.5,50],[6.299999999999997,50],[0,50],[-6.200000000000003,50],[-12.5,50],[-18.7,50],[-25,50],[-31.2,50],[-37.5,50],[-43.7,50],[-50,50],[-46.9,43.8],[-43.7,37.5],[-40.6,31.299999999999997],[-37.5,25],[-34.4,18.799999999999997],[-31.2,12.5],[-28.1,6.299999999999997],[-25,0],[-21.9,-6.200000000000003],[-18.7,-12.5],[-15.600000000000001,-18.7],[-12.5,-25],[-9.399999999999999,-31.2],[-6.200000000000003,-37.5],[-3.1000000000000014,-43.7]],\"c\":true}],\"o\":{\"x\":[0.25],\"y\":[0]},\"i\":{\"x\":[0.5],\"y\":[1]}},{\"t\":107,\"s\":[{\"i\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"o\":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],\"v\":[[0,-50],[6.499999999999993,-49.6],[12.899999999999999,-48.3],[19.099999999999994,-46.2],[25,-43.3],[30.400000000000006,-39.7],[35.400000000000006,-35.4],[39.7,-30.4],[43.3,-25],[46.2,-19.1],[48.3,-12.899999999999999],[49.599999999999994,-6.5],[50,0],[49.599999999999994,6.499999999999993],[48.3,12.899999999999999],[46.2,19.099999999999994],[43.3,25],[39.7,30.400000000000006],[35.400000000000006,35.400000000000006],[30.400000000000006,39.7],[25,43.3],[19.099999999999994,46.2],[12.899999999999999,48.3],[6.499999999999993,49.599999999999994],[0,50],[-6.5,49.599999999999994],[-12.899999999999999,48.3],[-19.1,46.2],[-25,43.3],[-30.4,39.7],[-35.4,35.400000000000006],[-39.7,30.400000000000006],[-43.3,25],[-46.2,19.099999999999994],[-48.3,12.899999999999999],[-49.6,6.499999999999993],[-50,0],[-49.6,-6.5],[-48.3,-12.899999999999999],[-46.2,-19.1],[-43.3,-25],[-39.7,-30.4],[-35.4,-35.4],[-30.4,-39.7],[-25,-43.3],[-19.1,-46.2],[-12.899999999999999,-48.3],[-6.5,-49.6]],\"c\":true}]}]},\"nm\":\"Path\",\"mn\":\"ADBE Vector Shape - Group\"},{\"ty\":\"fl\",\"c\":{\"a\":1,\"k\":[{\"t\":0,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":5,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":11,\"s\":[0.5098039215686274,0.7098039215686275,0.21176470588235294],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":32,\"s\":[0.5098039215686274,0.7098039215686275,0.21176470588235294],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":37,\"s\":[0.09411764705882353,0.40784313725490196,0.8588235294117647],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":59,\"s\":[0.09411764705882353,0.40784313725490196,0.8588235294117647],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":64,\"s\":[0.7490196078431373,0.38823529411764707,0.9529411764705882],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":86,\"s\":[0.7490196078431373,0.38823529411764707,0.9529411764705882],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":91,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433],\"o\":{\"x\":[0.5],\"y\":[0.5]},\"i\":{\"x\":[0.5],\"y\":[0.5]}},{\"t\":107,\"s\":[0.9607843137254902,0.6509803921568628,0.13725490196078433]}]},\"o\":{\"a\":0,\"k\":100},\"r\":1,\"nm\":\"Fill\"},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[0,0]},\"a\":{\"a\":0,\"k\":[0,0]},\"s\":{\"a\":0,\"k\":[100,100]},\"r\":{\"a\":0,\"k\":0},\"o\":{\"a\":0,\"k\":100}}],\"nm\":\"Shape Group\",\"np\":3}],\"ip\":0,\"op\":108,\"st\":0,\"bm\":0}]}");


const $9e5f31f7d389abdf$var$CONTAINER_STYLE = {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'visible'
};
const $9e5f31f7d389abdf$var$LOTTIE_WRAPPER_STYLE = {
    width: 16,
    height: 16
};
const $9e5f31f7d389abdf$export$c07a397cf5c24cd8 = ({ testId: testId })=>{
    const containerRef = (0, $cozmU.useRef)(null);
    // Use refs instead of module-level variables so each component instance
    // maintains its own animation state, scoped to its own lifecycle.
    const savedFrameRef = (0, $cozmU.useRef)(0);
    const hasPlayedBeforeRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        const currentRef = containerRef.current;
        if (!currentRef) return;
        const baseAnimationConfig = {
            container: currentRef,
            animationData: (0, (/*@__PURE__*/$parcel$interopDefault($2976c97aa2bab989$exports))),
            renderer: 'svg',
            loop: true
        };
        let animationInstance;
        if (hasPlayedBeforeRef.current) {
            // Remount — resume from saved frame for smooth animation continuity
            animationInstance = (0, (/*@__PURE__*/$parcel$interopDefault($lvJXz))).loadAnimation({
                ...baseAnimationConfig,
                autoplay: false
            });
            animationInstance.goToAndPlay(savedFrameRef.current, true);
        } else // First mount — start from scratch
        animationInstance = (0, (/*@__PURE__*/$parcel$interopDefault($lvJXz))).loadAnimation({
            ...baseAnimationConfig,
            autoplay: true
        });
        hasPlayedBeforeRef.current = true;
        return ()=>{
            // Save current frame before destroying so we can resume on remount
            savedFrameRef.current = animationInstance.currentFrame;
            animationInstance.destroy();
        };
    }, []);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- static styles for lottie container
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: $9e5f31f7d389abdf$var$CONTAINER_STYLE,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: $9e5f31f7d389abdf$var$LOTTIE_WRAPPER_STYLE,
        ref: containerRef
    })));
};


/* research-step-row.tsx generated by @compiled/babel-plugin v2.0.0 */ 









/* shimmer-text.tsx generated by @compiled/babel-plugin v2.0.0 */ 








const $14633d638bf89cef$var$shimmerAnimation = null;
const $14633d638bf89cef$var$shimmerGradient = null; /** Single-line ellipsis + flex/grid-safe width. */ 
const $14633d638bf89cef$var$truncateSingleLine = null;
const $14633d638bf89cef$export$f35c7d979dec8662 = ({ children: children, size: size = 'medium', weight: weight = 'regular', truncate: truncate = false })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2uo31fSyNX _2fBhteTUTt _3OqcjTzGaF _02U3A5JxkL _1CY1NjjOvk _07XDTDJxkL",
            truncate && "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7 _4ouGXIdnbC _39xV02N91d _1EqgXlN91d"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: size,
        weight: weight,
        color: "color.text.subtlest"
    }, children));
};


const $65efb4030898c062$var$styles = {
    stepRow: "_3iDTPbQ4SZ _0aFT5v1qpb _39xV02N91d _17lj8p2ADO _0hPCNLFlnN _1mT5xdRAKS",
    iconColumn: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02oWWg _3YEZNOdnbC _4xdlr0FlnN",
    ruleSlot: "_2O5Vij7dHp _39xV02dnbC",
    ruleSlotWithLine: "_3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _2O5Vij7dHp _39xV02dnbC",
    stepContent: "_2O5Vij7dHp _4ouGXIdnbC _0Of8r22ADO _1wydGW2ADO"
};
const $65efb4030898c062$export$f22a8a5ea07141e0 = ({ step: step, showTopConnector: showTopConnector = false, showBottomConnector: showBottomConnector = false, hideIcon: hideIcon = false, testId: testId })=>{
    const [iconError, setIconError] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $65efb4030898c062$var$styles.stepRow,
        testId: testId
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $65efb4030898c062$var$styles.iconColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: showTopConnector ? $65efb4030898c062$var$styles.ruleSlotWithLine : $65efb4030898c062$var$styles.ruleSlot
    }), step.toolIcon && !iconError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        src: step.toolIcon,
        alt: "",
        width: 16,
        height: 16,
        onError: ()=>setIconError(true)
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: showBottomConnector ? $65efb4030898c062$var$styles.ruleSlotWithLine : $65efb4030898c062$var$styles.ruleSlot
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $65efb4030898c062$var$styles.stepContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.025"
    }, step.title ? step.completed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        color: "color.text.subtlest"
    }, step.title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14633d638bf89cef$export$f35c7d979dec8662), {
        size: "medium"
    }, step.title) : null, step.separatedContent && step.separatedContent.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, step.separatedContent[step.separatedContent.length - 1].trim()) : null)));
};



const $1175367593db581d$var$getRenderableSteps = (steps)=>{
    if (!steps) return [];
    return Object.values(steps).filter((s)=>!!s.title).sort((a, b)=>a.order - b.order);
};
const $1175367593db581d$var$styles = {
    shimmerWrapper: "_2O5Vij7dHp _4ouGXIdnbC",
    expandedContent: "_0Of8r2Pgdg _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE _0KLXrunmFW _1v9SsVKxmn _3XDz3BKxmn",
    buttonPlaceholder: "_1YKVNsdnbC _1pp6NdYbGa _3YEZNOdnbC",
    collapsedRow: "_0bjKvDKxmn _3iDTPbQ4SZ _0aFT5v1qpb _39xV02N91d _17lj8p2ADO _0hPCNLDIqT _0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _24h04i2Njc _0jFU0V9LX5 _0KLXrunmFW",
    collapsedLoaderIconColumn: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _3YEZNOdnbC",
    expandedLoaderRow: "_3iDTPbQ4SZ _0aFT5v1qpb _39xV02N91d _17lj8p2ADO _0hPCNLFlnN _0Of8r22ADO _1wydGWPgdg _2Zuz6Q8HPE _1Znuxb8HPE _24h04i2Njc _0jFU0V9LX5 _0KLXrunmFW _2C2kUQKxmn _1Lz9loKxmn",
    loaderIconColumn: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02oWWg _3YEZNOdnbC _4xdlr0FlnN",
    loaderRuleSlotTop: "_2O5Vij7dHp _39xV02dnbC",
    loaderRuleSlotWithLine: "_3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _2O5Vij7dHp _39xV02dnbC",
    loaderContent: "_2O5Vij7dHp _4ouGXIdnbC _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _17lj8p2ADO"
};
const $1175367593db581d$var$messages = (0, $kSwu1.defineMessages)({
    thinking_deeper: {
        id: "search-ai.smart-answer-card-minimized-loading.thinking-deeper",
        defaultMessage: "Thinking deeper and analyzing your question..."
    },
    expand_answer: {
        id: "search-ai.smart-answer-card-minimized-loading.expand-answer",
        defaultMessage: "Expand answer"
    },
    collapse_answer: {
        id: "search-ai.smart-answer-card-minimized-loading.collapse-answer",
        defaultMessage: "Hide answer"
    }
});
const $1175367593db581d$var$MAX_EXPANDED_STEPS = 2;
function $1175367593db581d$export$2cc326b559e5a3cf({ onExpandClick: onExpandClick, userExpandedDuringLoading: userExpandedDuringLoading = false, commonAttributes: commonAttributes, testId: testId }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { researchSteps: researchSteps } = (0, $3hVWe.useAIAnswerContext)();
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent((0, $kSORO.onAIAnswerLoadingDialogShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleExpandClick = ()=>{
        fireAnalyticsEvent((0, $7ad80c56fa109a71$export$95c4fee0614a7136)(commonAttributes));
        onExpandClick?.();
    };
    const handleCollapseClick = ()=>{
        fireAnalyticsEvent((0, $e2d90c16cb0d52c9$export$db586d8c7b1541e0)(commonAttributes));
        onExpandClick?.();
    };
    const renderableSteps = $1175367593db581d$var$getRenderableSteps(researchSteps); // Expanded view: take the last MAX_EXPANDED_STEPS renderable steps in
    // oldest-first order so the most recent step appears at the bottom.
    const recentStepsForExpanded = renderableSteps.slice(-$1175367593db581d$var$MAX_EXPANDED_STEPS); // The header row contains the MorphingShapeLoader, the shimmer/step text,
    // and the expand/collapse toggle button. This row is rendered in both
    // collapsed and expanded states.
    const headerRow = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.collapsedRow,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.collapsedLoaderIconColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e5f31f7d389abdf$export$c07a397cf5c24cd8), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        grow: "fill",
        xcss: $1175367593db581d$var$styles.shimmerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14633d638bf89cef$export$f35c7d979dec8662), {
        size: "medium",
        truncate: true
    }, formatMessage($1175367593db581d$var$messages.thinking_deeper))), !userExpandedDuringLoading && renderableSteps.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.buttonPlaceholder,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        spacing: "compact",
        tabIndex: -1,
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))), {
                ...iconProps,
                size: "small"
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($1175367593db581d$var$messages.expand_answer)))) : userExpandedDuringLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        spacing: "compact",
        onClick: handleCollapseClick,
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), {
                ...iconProps,
                size: "small"
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($1175367593db581d$var$messages.collapse_answer))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        spacing: "compact",
        onClick: handleExpandClick,
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))), {
                ...iconProps,
                size: "small"
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($1175367593db581d$var$messages.expand_answer))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3ffN.AnimatedWrapper), null, userExpandedDuringLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, recentStepsForExpanded.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.expandedLoaderRow,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.loaderIconColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.loaderRuleSlotTop
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e5f31f7d389abdf$export$c07a397cf5c24cd8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.loaderRuleSlotWithLine
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.loaderContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.shimmerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14633d638bf89cef$export$f35c7d979dec8662), {
        size: "medium",
        truncate: true
    }, formatMessage($1175367593db581d$var$messages.thinking_deeper))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        spacing: "compact",
        onClick: handleCollapseClick,
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), {
                ...iconProps,
                size: "small"
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($1175367593db581d$var$messages.collapse_answer))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.collapsedRow,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.collapsedLoaderIconColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e5f31f7d389abdf$export$c07a397cf5c24cd8), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        grow: "fill",
        xcss: $1175367593db581d$var$styles.shimmerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14633d638bf89cef$export$f35c7d979dec8662), {
        size: "medium",
        truncate: true
    }, formatMessage($1175367593db581d$var$messages.thinking_deeper))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        spacing: "compact",
        onClick: handleCollapseClick,
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), {
                ...iconProps,
                size: "small"
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($1175367593db581d$var$messages.collapse_answer)))), recentStepsForExpanded.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1175367593db581d$var$styles.expandedContent
    }, recentStepsForExpanded.map((step, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65efb4030898c062$export$f22a8a5ea07141e0), {
            key: step.stepId,
            step: step,
            // loader); bottom connector on all but the last step.
            showTopConnector: true,
            showBottomConnector: index < recentStepsForExpanded.length - 1,
            testId: testId ? `${testId}-step-${step.stepId}` : undefined
        })))) : headerRow);
}


/* smart-answer-ready.tsx generated by @compiled/babel-plugin v2.0.0 */ 


















var $f6cdQ = parcelRequire("f6cdQ");














const $35b517b5dcf10511$var$styles = {
    container: "_0bjKvD8fU6 _0Of8r28HPE _1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO _4kiQYAUF4f _24h04i2Njc _0KLXrunmFW",
    answerLabel: "_3YEZNOdnbC",
    containerWithShadow: "_2OUyjtGk8v"
}; // Optical nudge to vertically align the Lozenge text with adjacent body text.
const $35b517b5dcf10511$var$lozengeWrapperStyle = null;
const $35b517b5dcf10511$var$messages = (0, $kSwu1.defineMessages)({
    answer: {
        id: "search-ai.smart-answer-card-minimized-ready.answer",
        defaultMessage: "Answer"
    },
    ready: {
        id: "search-ai.smart-answer-card-minimized-ready.ready",
        defaultMessage: "Ready"
    },
    scroll_up: {
        id: "search-ai.smart-answer-card-minimized-ready.scroll-up",
        defaultMessage: "Scroll up"
    },
    expand_answer: {
        id: "search-ai.smart-answer-card-minimized-ready.expand-answer",
        defaultMessage: "Expand"
    }
});
function $35b517b5dcf10511$export$6219b6e404cffa4a({ onScrollUpClick: onScrollUpClick, onExpandClick: onExpandClick, appearance: appearance, testId: testId }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const resolvedAppearance = appearance ?? (onExpandClick ? 'expand' : 'scrollUp');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100",
        xcss: (0, $w6R6I.cx)($35b517b5dcf10511$var$styles.container, resolvedAppearance === 'scrollUp' && $35b517b5dcf10511$var$styles.containerWithShadow),
        grow: "fill",
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $35b517b5dcf10511$var$styles.answerLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
        label: "",
        size: "medium"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "medium",
        weight: "medium"
    }, formatMessage($35b517b5dcf10511$var$messages.answer)), resolvedAppearance !== 'expand' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _1mT5xdRAKS _2IhTonHZdu"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "success"
    }, formatMessage($35b517b5dcf10511$var$messages.ready)))), resolvedAppearance === 'expand' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onExpandClick,
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a79Sy))), iconProps),
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($35b517b5dcf10511$var$messages.expand_answer))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: onScrollUpClick,
        iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))), iconProps),
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($35b517b5dcf10511$var$messages.scroll_up))));
}


const $c6a21b3a2fe9d946$var$MemoizedRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(function MemoizedRenderer({ contentToRender: contentToRender, showAnimation: showAnimation }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c5ac787bcb31d21$export$687d546b0584d31b), {
        key: "stable-renderer",
        markdown: contentToRender,
        animateComponents: showAnimation
    });
});
const $c6a21b3a2fe9d946$var$styles = {
    fullWidth: "_39xV02qUim _1EqgXlN91d _1DCdHi8HPE",
    interactive: "_0wOv4Q7zJH",
    root: "_4kiQYAk3g7",
    fullHeight: "_0jFU0VN91d",
    disclaimer: "_1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r21Y8M",
    followUpChatInputSectionStyles: "_3138425zaO",
    followUpChatInputSectionWithBarStyles: "_3138422ADO",
    disclaimerWrapperStyles: "_1wydGW8HPE _2Zuz6Q5zaO _0Of8r21Y8M _2IVJ4M6wH8 _3zygPU9r67 _22sfPnNvrM",
    sectionContainer: "_1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r21Y8M",
    sourcesTopPadding: "_0Of8r21Y8M",
    linkListContainer: "_313842gVvo",
    nonInteractive: "_1pp6NdYbGa",
    loadingPaddingOverrides: "_2Zuz6Q8HPE _1Znuxb8HPE",
    standardSAINMarginOverrides: "_1DCdHi2ADO"
};
function $c6a21b3a2fe9d946$var$SmartAnswerCardMinimizedComponent({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, onAnswerMinimizedChange: onAnswerMinimizedChange, queryIntent: queryIntent, floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef }) {
    // Tracks whether the user clicked "Expand answer" while the answer was loading
    // Used to decide if the answer should appear in the collapsed or fully expanded state
    // when streaming begins, and is also kept in sync with isAnswerMinimized after loading so the
    // show-more button is hidden when the answer is intentionally expanded.
    // - false (default): user has NOT requested expansion during loading
    // - true: user clicked "Expand answer" during loading
    const [userExpandedDuringLoading, setUserExpandedDuringLoading] = (0, $cozmU.useState)(false); // Tracks whether the answer is currently "minimized" — i.e. the loaded answer is
    // hidden and the SmartAnswerReady component is shown.
    // This is distinct from `userExpandedDuringLoading` which is about the loading-state
    // expand/collapse toggle. While loading this is always false; it only flips to
    // true post-load when the user explicitly hides the answer.
    const [isAnswerMinimized, setIsAnswerMinimized] = (0, $cozmU.useState)(false); // state for whether loaded answer is fully expanded or collapsed
    const [collapsed, setCollapsed] = (0, $cozmU.useState)(true);
    const containerRef = (0, $cozmU.useRef)(null);
    const [didUserTriggerCollapse, setDidUserTriggerCollapse] = (0, $cozmU.useState)(false);
    const [isVisibleTextComplete, setIsVisibleTextComplete] = (0, $cozmU.useState)(false);
    const [showAnimation, setShowAnimation] = (0, $cozmU.useState)(false);
    const componentRenderTimeRef = (0, $cozmU.useRef)(Date.now());
    const firstByteEventFiredRef = (0, $cozmU.useRef)(false);
    const context = (0, $3hVWe.useAIAnswerContext)();
    const { commonAttributes: commonAttributes, hasError: hasError, isAnswered: isAnswered, loading: loading, partialResponse: partialResponse, luminaContentMap: luminaContentMap } = context;
    const { queryHash: queryHash, searchSessionId: searchSessionId, answerString: answerString, sources: sources, errorStateSuggestedQueries: errorStateSuggestedQueries } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const streamingText = partialResponse?.partialNlpResult ?? '';
    const [streamingTextToDisplay, setStreamingTextToDisplay] = (0, $cozmU.useState)(streamingText); // Refs for content truncation detection
    const isVisibleTextCompleteRef = (0, $cozmU.useRef)(false); // Measures only answer text height (excludes sources and chat input) so onReadMoreButtonShown
    // fires only when the text itself is truncated, not due to other content
    const textContentRef = (0, $cozmU.useRef)(null);
    const completeAnswerAnalyticsEventFiredRef = (0, $cozmU.useRef)(false);
    const renderedContentRef = (0, $cozmU.useRef)(null);
    const contentContainerRef = (0, $cozmU.useRef)(null);
    const hasLinksInAnswer = !!(luminaContentMap && Object.keys(luminaContentMap).length > 0) && (0, $iDrrr.fg)('kd_sain_enable_inline_lumina');
    (0, $cozmU.useEffect)(()=>{
        // If streaming stopped but buffered content still exists, clear it to reset the display
        if (!streamingText && streamingTextToDisplay && (0, $iDrrr.fg)('kd_fix_abort_errors')) {
            setStreamingTextToDisplay('');
            setIsVisibleTextComplete(false);
            return;
        }
        if (collapsed && !isVisibleTextComplete) setStreamingTextToDisplay(streamingText);
        else if (!collapsed) setStreamingTextToDisplay(streamingText);
    }, [
        collapsed,
        isVisibleTextComplete,
        streamingText,
        streamingTextToDisplay
    ]); // Notify context when collapsed state changes
    (0, $cozmU.useEffect)(()=>{
        onAnswerExpandedChange?.(!collapsed);
    }, [
        collapsed,
        onAnswerExpandedChange
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !hasError && !isVisibleTextComplete) {
            setIsVisibleTextComplete(true);
            onFMPReached?.(); // Mark FMP as reached for cached answers
        }
    }, [
        loading,
        hasError,
        isVisibleTextComplete,
        onFMPReached
    ]); // Track if we should show animations (if loading or partialResponse are true)
    (0, $cozmU.useEffect)(()=>{
        if (!showAnimation && loading && partialResponse) setShowAnimation(true);
        if (loading && !partialResponse && showAnimation && (0, $iDrrr.fg)('kd_fix_abort_errors')) {
            setShowAnimation(false);
            firstByteEventFiredRef.current = false;
            completeAnswerAnalyticsEventFiredRef.current = false;
        }
    }, [
        loading,
        partialResponse,
        showAnimation
    ]); // use useEffect to trigger analytics event in order to avoid needing to
    // pass commonAttributes as a dependency to handleExpandCollapseButtonClick
    // and thus avoid re-rendering SmartAnswerCardBodyStreaming with every
    // update to commonAttributes (which gets updated with the streamed text)
    (0, $cozmU.useEffect)(()=>{
        if (didUserTriggerCollapse) fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)(commonAttributes));
    }, [
        didUserTriggerCollapse,
        commonAttributes,
        fireAnalyticsEvent
    ]); // Detect if content is truncated when collapsed
    const isContentTruncated = (0, $6df3d09e09b61b24$export$d112da4490f261ea)(renderedContentRef, contentContainerRef, collapsed, [
        streamingText
    ]);
    const isTextTruncated = (0, $6df3d09e09b61b24$export$d112da4490f261ea)(textContentRef, contentContainerRef, collapsed, [
        streamingText
    ]); // Complete answer analytics
    (0, $cozmU.useEffect)(()=>{
        // Only fire once and ensure DOM element is ready with meaningful content
        if (completeAnswerAnalyticsEventFiredRef.current || !renderedContentRef.current) return;
        const answerHeight = renderedContentRef.current.getBoundingClientRect().height;
        const containerHeight = contentContainerRef.current?.getBoundingClientRect().height ?? 0;
        const whitespaceHeight = Math.max(containerHeight - answerHeight, 0); // Only fire if we have meaningful height (content is rendered)
        if (answerHeight > 0 && containerHeight > 0) {
            fireAnalyticsEvent((0, $d58a262274d16c7a$export$f3109245f09f7746)({
                ...commonAttributes,
                answerHeight: answerHeight,
                containerHeight: containerHeight,
                whitespaceHeight: whitespaceHeight,
                queryIntent: queryIntent
            }));
            completeAnswerAnalyticsEventFiredRef.current = true;
        }
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        queryIntent,
        isContentTruncated
    ]); // SAIN usage event
    (0, $cozmU.useEffect)(()=>{
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Callback bound to the expand/collapse buttons in SmartAnswerCardMinimizedLoading.
    // Only toggles `userExpandedDuringLoading`; never sets `isAnswerMinimized` (which is only
    // used for the post-load minimize flow). Tracks whether the user has requested expansion
    // during loading.
    const handleFoldAnswerButtonClick = (0, $cozmU.useCallback)(()=>{
        setUserExpandedDuringLoading((prev)=>!prev);
    }, []); // Tracks whether the answer card is currently within the viewport
    // Used to decide whether to render the SmartAnswerReady component at the top of the search
    // results when the user has scrolled the answer card out of view.
    const [isCardInViewport, setIsCardInViewport] = (0, $cozmU.useState)(true); // Scrolls the answer card back into view and expands it fully.
    // Resets isAnswerMinimized so the answer is un-minimized, and sets
    // userExpandedDuringLoading=true so the in-flow card renders fully expanded.
    const handleScrollUpClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $57ae65a71649f2c5$export$7f9024bb8c6bf2c3)(commonAttributes));
        setIsAnswerMinimized(false);
        setUserExpandedDuringLoading(true);
        setCollapsed(false);
        const node = containerRef.current;
        if (!node) return;
         // The "Scroll up" button only appears on the floating banner, which is only
        // rendered when the card is scrolled out of view (isCardInViewport === false).
        // So reaching this handler means the card is effectively out of view (or hidden
        // behind the fixed banner) and we should always scroll it back to the top.
        //
        // We intentionally avoid an isOutOfViewport short-circuit here: the previous
        // `rect.bottom <= 0` guard failed the edge case where the card's bottom edge
        // sits a few pixels below the viewport top (positive rect.bottom) but the card
        // is still visually hidden behind the fixed floating banner — in that case the
        // guard skipped the scroll and the user was never taken back to the answer.
        node.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }, [
        commonAttributes,
        fireAnalyticsEvent
    ]); // Notify parent (ai-answer-dialog) whenever the "answer minimized" state changes
    // so dwell tracking can be gated on whether the user can actually see the answer.
    (0, $cozmU.useEffect)(()=>{
        onAnswerMinimizedChange?.(isAnswerMinimized);
    }, [
        isAnswerMinimized,
        onAnswerMinimizedChange
    ]); // Toggles the answer minimized state for the "Hide answer" and in-flow "Expand"
    // buttons. `minimized=true` hides the answer behind the SmartAnswerReady component;
    // `minimized=false` re-shows the answer in fully expanded form. Also resets the
    // loading-time expand state so visual states stay in sync.
    const handleAnswerHiddenToggle = (0, $cozmU.useCallback)((minimized)=>{
        if (minimized) fireAnalyticsEvent((0, $619bd3e23d17df21$export$816a5214860a0c40)(commonAttributes));
        else fireAnalyticsEvent((0, $57db223fb661d84a$export$b19cbf041d35e6cc)(commonAttributes));
        setIsAnswerMinimized(minimized); // userExpandedDuringLoading mirrors the inverse — minimized=true means the user
        // has NOT expanded; minimized=false means they have explicitly expanded.
        setUserExpandedDuringLoading(!minimized);
        setCollapsed(minimized);
    }, [
        commonAttributes,
        fireAnalyticsEvent
    ]); // callback to expand/collapse loaded answer
    const handleExpandCollapseButtonClick = (0, $cozmU.useCallback)(()=>{
        if (collapsed) {
            setCollapsed(false);
            setDidUserTriggerCollapse(false);
        } else {
            setCollapsed(true);
            setDidUserTriggerCollapse(true);
        }
    }, [
        collapsed
    ]);
    const handleVisibleTextComplete = (0, $cozmU.useCallback)(()=>{
        setIsVisibleTextComplete(true);
        onFMPReached?.(); // Mark FMP as reached for streaming answers
    }, [
        onFMPReached
    ]);
    const handleContainerClick = (0, $cozmU.useCallback)((event)=>{
        const selection = window.getSelection()?.toString() ?? ''; // Highlighting text should not expand the card
        const hasHighlightedText = selection.length > 0; // Clicking in a feedback modal or flag should not expand the card
        const isClickingOnContainer = containerRef.current?.contains(event.target) ?? false;
        if (collapsed && !hasHighlightedText && isClickingOnContainer) {
            setCollapsed(false); // Clicking anywhere in the container while loading is treated the same as
            // clicking "Expand answer" — so the show more button hides for the rest of
            // the streaming session.
            setUserExpandedDuringLoading(true);
            fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)(commonAttributes));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).EXPAND_CLICKED,
                commonAttributes: commonAttributes
            });
        }
    }, [
        collapsed,
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent
    ]);
    const { handleSmartCardClick: handleSmartCardClick } = (0, $280875adc8c5626f$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context
    }); // UFO resize observer for streaming
    const resizeObserverCallback = (0, $cozmU.useCallback)(()=>{
        if (!isVisibleTextCompleteRef.current && renderedContentRef.current && contentContainerRef.current && !!streamingTextToDisplay) {
            const renderedContentRefHeight = renderedContentRef.current.getBoundingClientRect().height;
            const contentContainerRefHeight = contentContainerRef.current.getBoundingClientRect().height;
            const isVisibleTextComplete = renderedContentRefHeight > contentContainerRefHeight;
            if (isVisibleTextComplete) {
                handleVisibleTextComplete();
                isVisibleTextCompleteRef.current = true;
            }
        }
    }, [
        handleVisibleTextComplete,
        streamingTextToDisplay
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1dee242400437624$export$fd29db098e42c3fc)(renderedContentRef, resizeObserverCallback, 100, [
        streamingTextToDisplay
    ]);
    const bufferedContent = (0, $d3e29575f8ad4c54$export$8f4f0a9c358684c2)(streamingTextToDisplay, isAnswered && !loading); // If the user clicked "Expand answer" during loading, show the answer uncollapsed
    // as soon as streaming begins (bufferedContent has content) and keep it uncollapsed when done.
    (0, $cozmU.useEffect)(()=>{
        if (userExpandedDuringLoading && bufferedContent.length > 0) setCollapsed(false);
    }, [
        userExpandedDuringLoading,
        bufferedContent
    ]); // Track whether the answer is in the viewport so we can render
    // SmartAnswerReady when the user has scrolled past the answer card.
    // Do not show SmartAnswerReady if the user has already seen the answer
    // in expanded state.
    (0, $cozmU.useEffect)(()=>{
        if (!isAnswered || hasError || isAnswerMinimized) return;
        if (!containerRef.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setIsCardInViewport(entry.isIntersecting);
            });
        }, {
            threshold: 0
        });
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        isAnswered,
        hasError,
        isAnswerMinimized
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (bufferedContent.length > 0 && !firstByteEventFiredRef.current) {
            fireAnalyticsEvent((0, $bd6e42147a6848a8$export$c68095583a3c17cc)({
                ...commonAttributes,
                timeToFirstByte: Date.now() - componentRenderTimeRef.current
            }));
            firstByteEventFiredRef.current = true;
        }
    }, [
        bufferedContent,
        commonAttributes,
        fireAnalyticsEvent
    ]); // Use answerString when complete, bufferedContent when streaming
    const contentToRender = isAnswered ? answerString : bufferedContent; // Experiments
    const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_sain_show_no_answer_suggestions_exp'
    });
    const showReadMoreButton = collapsed && isContentTruncated; // Single return statement with React component for main content
    const isStreaming = !isAnswered && (loading || loading === undefined); // Early return for error state
    if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c6a21b3a2fe9d946$var$styles.fullWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f366b75433df2895$export$ffa24cd7196ce1b0), null));
     // Early return for generating state
    if (!isAnswered && (loading || loading === undefined)) {
        if (!partialResponse || bufferedContent.length < 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "search-ai-dialog-all-text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "search-ai-dialog-all-text-loading",
            hold: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "search-ai-dialog-visible-text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "search-ai-dialog-visible-text-loading",
            hold: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1175367593db581d$export$2cc326b559e5a3cf), {
            onExpandClick: handleFoldAnswerButtonClick,
            userExpandedDuringLoading: userExpandedDuringLoading,
            commonAttributes: commonAttributes
        })));
    } // When the user has minimized the answer (clicked "Hide answer" on the loaded card),
    // render the SmartAnswerReady component in place of the full answer.
    if (isAnswerMinimized) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35b517b5dcf10511$export$6219b6e404cffa4a), {
        onExpandClick: ()=>handleAnswerHiddenToggle(false)
    });
     // Render SmartAnswerReady at the top of the search results when:
    // - the answer has finished loading and is not in an error/no-answer state
    // - the answer card is currently scrolled out of the viewport
    // - the answer is currently in its collapsed state
    // - do not render if user expanded then collapsed answer
    const notifySmartAnswerReady = isAnswered && !hasError && !isCardInViewport && collapsed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($c6a21b3a2fe9d946$var$styles.fullWidth, ((0, $iDrrr.fg)('kd_team_26_sain_borderless_update') || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled()) && $c6a21b3a2fe9d946$var$styles.loadingPaddingOverrides),
        testId: "smart-answer-card-minimized"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "search-ai-dialog-all-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "search-ai-dialog-all-text-loading",
        hold: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "search-ai-dialog-visible-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "search-ai-dialog-visible-text-loading",
        hold: !isVisibleTextComplete
    }), (0, $iDrrr.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "queryHash",
        value: queryHash
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "searchSessionId",
        value: searchSessionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "queryIntent",
        value: queryIntent
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            queryIntent: queryIntent
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c6a21b3a2fe9d946$var$SmartAnswerCardMinimizedContent, {
        isStreaming: isStreaming,
        collapsed: collapsed,
        showReadMoreButton: showReadMoreButton,
        handleExpandCollapseButtonClick: handleExpandCollapseButtonClick,
        onHideAnswer: ()=>handleAnswerHiddenToggle(true),
        contentContainerRef: contentContainerRef,
        renderedContentRef: renderedContentRef,
        textContentRef: textContentRef,
        isTextTruncated: isTextTruncated,
        sources: sources,
        searchSessionId: searchSessionId,
        sourceClickCallback: handleSmartCardClick,
        errorStateSuggestedQueries: errorStateSuggestedQueries,
        serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp,
        commonAttributes: commonAttributes,
        contentToRender: contentToRender,
        showAnimation: showAnimation,
        handleContainerClick: handleContainerClick,
        containerRef: containerRef,
        hasLinksInAnswer: hasLinksInAnswer,
        userExpandedDuringLoading: userExpandedDuringLoading
    })))), notifySmartAnswerReady && floatingSmartAnswerReadyPortalRef?.current && /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35b517b5dcf10511$export$6219b6e404cffa4a), {
        appearance: "scrollUp",
        onScrollUpClick: handleScrollUpClick,
        testId: "smart-answer-ready-floating"
    }), floatingSmartAnswerReadyPortalRef.current));
}
function $c6a21b3a2fe9d946$var$SmartAnswerCardMinimizedContent({ isStreaming: isStreaming, collapsed: collapsed, showReadMoreButton: showReadMoreButton, handleExpandCollapseButtonClick: handleExpandCollapseButtonClick, contentContainerRef: contentContainerRef, renderedContentRef: renderedContentRef, textContentRef: textContentRef, isTextTruncated: isTextTruncated, sources: sources, searchSessionId: searchSessionId, sourceClickCallback: sourceClickCallback, errorStateSuggestedQueries: errorStateSuggestedQueries, serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp, commonAttributes: commonAttributes, contentToRender: contentToRender, showAnimation: showAnimation, onHideAnswer: onHideAnswer, handleContainerClick: handleContainerClick, containerRef: containerRef, hasLinksInAnswer: hasLinksInAnswer, userExpandedDuringLoading: userExpandedDuringLoading }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { authorityUiMetadata: authorityUiMetadata } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId, queryHash: queryHash, extraAttributes: extraAttributes, source: source } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const isHighlyAuthoritative = (0, $iDrrr.fg)('rovo_authoritative_answer_attribution') && !!authorityUiMetadata?.isHighlyAuthoritative;
    const handleAuthorityPanelShown = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $fhQlP.buildAuthoritativeAnswerPanelShownEvent)({
            product: 'sain',
            source: source,
            correlationAttributes: {
                cloudId: cloudId,
                searchSessionId: searchSessionId,
                queryHash: queryHash,
                traceId: extraAttributes?.requestId
            },
            authorityUiMetadata: authorityUiMetadata
        }));
    }, [
        fireAnalyticsEvent,
        source,
        cloudId,
        searchSessionId,
        queryHash,
        extraAttributes?.requestId,
        authorityUiMetadata
    ]);
    const fireAuthorityLinkClick = (0, $cozmU.useCallback)((linkType)=>{
        fireAnalyticsEvent((0, $a7fd7127c63cb2fc$export$5671a2e254c14222)({
            ...commonAttributes,
            linkType: linkType,
            authorityUiMetadata: authorityUiMetadata
        })); // Credits the click towards SAIN's success metric (SSRv5).
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes
        });
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        authorityUiMetadata,
        fireSAINUsageEvent
    ]);
    const isBorderlessUX = (0, $iDrrr.fg)('kd_team_26_sain_borderless_update') || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled(); // URL patterns for sources known not to resolve as rich smart cards.
    const UNRESOLVABLE_URL_PATTERNS = [
        'viewpageattachments.action'
    ];
    const isUnresolvableSource = (url)=>UNRESOLVABLE_URL_PATTERNS.some((pattern)=>url.includes(pattern)); // Filter sources whose URLs are known not to resolve as rich smart cards.
    // Uses URL pattern matching since the NlpSearchResultType enum does not include 'attachment'.
    // https://switcheroo.atlassian.com/ui/gates/f309f0ca-53a0-4c56-9767-fec898813e99/key/kd_sain_filter_attachment_sources
    const filteredSources = (0, $iDrrr.fg)('kd_sain_filter_attachment_sources') ? sources.filter((source)=>!isUnresolvableSource(source.url)) : sources;
    const sourcesSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, !isStreaming && filteredSources.length > 0 && (0, $7DMz5.SAINFeatureControl).isSourcesInShortSAINAnswersEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($c6a21b3a2fe9d946$var$styles.sourcesTopPadding, collapsed && $c6a21b3a2fe9d946$var$styles.nonInteractive)
    }, (0, $7DMz5.SAINFeatureControl).isLinkListSourcesEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: $c6a21b3a2fe9d946$var$styles.linkListContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).related_links_title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Luzz.LinkList), {
        urls: filteredSources.map((source)=>source.url),
        maxSources: 5,
        showExpand: false,
        onLinkClick: (url, index, opts)=>{
            const source = filteredSources[index];
            if (source) sourceClickCallback({
                index: index,
                source: source,
                hostname: (0, $736ac3075308471f$export$a3b7216c107a7a1)(url),
                sourceCardType: 'link-list',
                isAuxClick: opts?.isAuxClick,
                isContextMenu: opts?.isContextMenu
            });
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ce789c5dd436d96e$export$919320f9832aec1d), {
        sources: filteredSources,
        searchSessionId: searchSessionId,
        onClickHandler: sourceClickCallback
    })));
    const handleContainerKeyDown = (0, $cozmU.useCallback)((event)=>{
        if (collapsed && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            handleContainerClick(event);
        }
    }, [
        collapsed,
        handleContainerClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(collapsed ? $c6a21b3a2fe9d946$var$styles.interactive : undefined, isBorderlessUX && $c6a21b3a2fe9d946$var$styles.standardSAINMarginOverrides),
        onClick: handleContainerClick,
        onKeyDown: collapsed ? handleContainerKeyDown : undefined,
        tabIndex: collapsed ? 0 : undefined,
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        xcss: isStreaming && !isBorderlessUX ? $c6a21b3a2fe9d946$var$styles.root : $c6a21b3a2fe9d946$var$styles.fullHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        xcss: $c6a21b3a2fe9d946$var$styles.fullHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4217877a0025dc35$export$127e64693c41156a), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            spread: "space-between",
            alignBlock: "center",
            grow: "fill",
            xcss: (0, $w6R6I.cx)(((0, $iDrrr.fg)('kd_team_26_sain_borderless_update') || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled()) && $c6a21b3a2fe9d946$var$styles.standardSAINMarginOverrides)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050",
            shouldWrap: true
        }, isHighlyAuthoritative && authorityUiMetadata ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
            label: "",
            size: "medium",
            color: "var(--ds-icon-success, #6A9A23)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Zool.AuthoritativeAnswerAttribution), {
            sources: authorityUiMetadata.sources ?? [],
            domainExperts: authorityUiMetadata.domainExperts ?? [],
            overallReasoning: authorityUiMetadata.overallReasoning,
            labelVariant: "answer",
            cloudId: cloudId,
            surface: "sain",
            // use the taller panel to avoid cramping the feedback form.
            panelSize: "tall",
            onPanelOpen: handleAuthorityPanelShown,
            onSourceClick: ()=>fireAuthorityLinkClick('source'),
            onExpertClick: ()=>fireAuthorityLinkClick('expert'),
            onFeedbackSubmit: (submission)=>{
                // Submit authority-answer feedback to the Feedback Collector API
                // using SAIN's existing entrypoint (same destination as SAIN's
                // footer feedback). Analytics wiring is handled separately.
                (0, $1V59x.submitAuthorityFeedback)({
                    submission: submission,
                    entrypointId: (0, $1V59x.FEEDBACK_ENTRYPOINT_ID_SAIN),
                    origin: (0, $1V59x.AUTHORITY_FEEDBACK_ORIGIN_SAIN),
                    cloudId: cloudId,
                    debugAttributes: {
                        traceId: extraAttributes?.requestId,
                        searchSessionId: searchSessionId,
                        queryHash: queryHash
                    }
                });
            }
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
            label: "AI Content",
            size: "medium"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h1",
            size: "xsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).smart_answer_card_title)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, !collapsed && !isStreaming && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            spacing: "compact",
            appearance: "subtle",
            onClick: onHideAnswer,
            iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), {
                    ...iconProps,
                    size: "small"
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, formatMessage((0, $24oKg.messages).hide_answer))))),
        isCollapsed: collapsed,
        onExpandCollapse: handleExpandCollapseButtonClick,
        ref: contentContainerRef,
        showReadMoreButton: isBorderlessUX ? collapsed : showReadMoreButton,
        luminaAnswerType: (0, $iDrrr.fg)('kd_team_26_sain_borderless_update') || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() ? 'STANDARD' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: renderedContentRef,
        id: "ai-answer-result-section",
        testId: "sain-fmp-target"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: textContentRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c6a21b3a2fe9d946$var$MemoizedRenderer, {
        contentToRender: contentToRender,
        showAnimation: showAnimation
    })))), !hasLinksInAnswer && sourcesSection)), showReadMoreButton && !(0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ed12dd693731600a$export$e68719f9c8487320), {
        onClick: handleExpandCollapseButtonClick
    }), (collapsed || showReadMoreButton || isStreaming) && (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f420039341622608$export$8a1fad5d74d43878), {
        isStreaming: isStreaming,
        showMoreButtonVisible: collapsed || isStreaming && !userExpandedDuringLoading,
        fireShownEvent: isTextTruncated,
        onClickShowMoreButton: handleExpandCollapseButtonClick
    })), !isStreaming && !collapsed && sources.length > 0 && !(0, $7DMz5.SAINFeatureControl).isSourcesInShortSAINAnswersEnabled() && !hasLinksInAnswer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c6a21b3a2fe9d946$var$styles.sectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ce789c5dd436d96e$export$919320f9832aec1d), {
        sources: sources,
        searchSessionId: searchSessionId,
        onClickHandler: sourceClickCallback
    })), (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && !isStreaming && !collapsed && sources.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c6a21b3a2fe9d946$var$styles.followUpChatInputSectionWithBarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe4d4049968826dc$export$7552c1f78575b57c), {
        renderTrigger: (onToggle, triggerRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7fd6a1524e779285$export$e754cddb4d3a7903), {
                sources: sources,
                numSources: sources.length,
                onClick: onToggle,
                triggerRef: triggerRef
            })
    })), !collapsed && !showReadMoreButton && !isStreaming && (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        xcss: $c6a21b3a2fe9d946$var$styles.followUpChatInputSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a921764ae1a692a7$export$f087ce3403d54eb5), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j8bJ5.OpenChatInputBox), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c6a21b3a2fe9d946$var$styles.disclaimerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: !isStreaming,
        showCopyButton: false,
        renderedContentRef: renderedContentRef
    }))), !(0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c6a21b3a2fe9d946$var$styles.disclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: !isStreaming,
        showCopyButton: !isStreaming,
        renderedContentRef: renderedContentRef
    }))), !isStreaming && !(0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && (!collapsed || errorStateSuggestedQueries.length > 0 && serveErrorStateSuggestedQueriesExp) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34e9b06075b84401$export$3553ee90c7edebc9), {
        showOpenChat: true
    }) : null));
}
function $c6a21b3a2fe9d946$export$2b53936d5706be63({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, onAnswerMinimizedChange: onAnswerMinimizedChange, queryIntent: queryIntent, floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "smart-answer-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c6a21b3a2fe9d946$var$SmartAnswerCardMinimizedComponent, {
        onFMPReached: onFMPReached,
        onAnswerExpandedChange: onAnswerExpandedChange,
        onAnswerMinimizedChange: onAnswerMinimizedChange,
        queryIntent: queryIntent,
        floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef
    }));
}


/* smart-answer-card.tsx generated by @compiled/babel-plugin v2.0.0 */ 

















































/* smart-answer-card-body-complete.tsx generated by @compiled/babel-plugin v2.0.0 */ 

























































const $18d1f6bb8f76e7b1$var$styles = {
    fullHeight: "_0jFU0VN91d",
    sectionContainer: "_1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r21Y8M",
    sourcesTopPadding: "_0Of8r21Y8M",
    nonInteractive: "_1pp6NdYbGa"
};
function $18d1f6bb8f76e7b1$export$41d38529b1c47f4e({ collapsed: collapsed, onExpandCollapseButtonClick: onExpandCollapseButtonClick, queryIntent: queryIntent }) {
    const context = (0, $3hVWe.useAIAnswerContext)();
    const { commonAttributes: commonAttributes } = context;
    const { answerString: answerString, sources: sources, errorStateSuggestedQueries: errorStateSuggestedQueries, searchSessionId: searchSessionId } = commonAttributes;
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const renderedContentRef = (0, $cozmU.useRef)(null);
    const contentContainerRef = (0, $cozmU.useRef)(null);
    const completeAnswerAnalyticsEventFiredRef = (0, $cozmU.useRef)(false); // Detect if content is truncated when collapsed
    const isContentTruncated = (0, $6df3d09e09b61b24$export$d112da4490f261ea)(renderedContentRef, contentContainerRef, collapsed, [
        answerString
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Only fire once and ensure DOM element is ready with meaningful content
        if (completeAnswerAnalyticsEventFiredRef.current || !renderedContentRef.current) return;
        const answerHeight = renderedContentRef.current.getBoundingClientRect().height;
        const containerHeight = contentContainerRef.current?.getBoundingClientRect().height ?? 0;
        const whitespaceHeight = Math.max(containerHeight - answerHeight, 0); // Only fire if we have meaningful height (content is rendered)
        if (answerHeight > 0 && containerHeight > 0) {
            fireAnalyticsEvent((0, $d58a262274d16c7a$export$f3109245f09f7746)({
                ...commonAttributes,
                answerHeight: answerHeight,
                containerHeight: containerHeight,
                whitespaceHeight: whitespaceHeight,
                queryIntent: queryIntent
            }));
            completeAnswerAnalyticsEventFiredRef.current = true;
        }
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        queryIntent,
        isContentTruncated
    ]);
    const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_sain_show_no_answer_suggestions_exp'
    });
    const showReadMoreButton = collapsed && isContentTruncated;
    (0, $cozmU.useEffect)(()=>{
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { handleSmartCardClick: handleSmartCardClick } = (0, $280875adc8c5626f$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        testId: "smart-answer-card-body-complete",
        xcss: $18d1f6bb8f76e7b1$var$styles.fullHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        xcss: $18d1f6bb8f76e7b1$var$styles.fullHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4217877a0025dc35$export$127e64693c41156a), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "xxsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            size: "small",
            weight: "bold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).smart_answer_card_title))),
        isCollapsed: collapsed,
        onExpandCollapse: onExpandCollapseButtonClick,
        ref: contentContainerRef,
        showReadMoreButton: showReadMoreButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        id: "ai-answer-result-section",
        ref: renderedContentRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c5ac787bcb31d21$export$687d546b0584d31b), {
        markdown: answerString
    })))), sources.length > 0 && (0, $7DMz5.SAINFeatureControl).isSourcesInShortSAINAnswersEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($18d1f6bb8f76e7b1$var$styles.sourcesTopPadding, collapsed && $18d1f6bb8f76e7b1$var$styles.nonInteractive)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ce789c5dd436d96e$export$919320f9832aec1d), {
        sources: sources,
        searchSessionId: searchSessionId,
        onClickHandler: handleSmartCardClick
    })) : null), showReadMoreButton && !(0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ed12dd693731600a$export$e68719f9c8487320), {
        onClick: onExpandCollapseButtonClick
    })), !collapsed && sources.length > 0 && !(0, $7DMz5.SAINFeatureControl).isSourcesInShortSAINAnswersEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $18d1f6bb8f76e7b1$var$styles.sectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ce789c5dd436d96e$export$919320f9832aec1d), {
        sources: sources,
        searchSessionId: searchSessionId,
        onClickHandler: handleSmartCardClick
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $18d1f6bb8f76e7b1$var$styles.sectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true,
        showCopyButton: true,
        renderedContentRef: renderedContentRef
    }))), !collapsed || errorStateSuggestedQueries.length > 0 && serveErrorStateSuggestedQueriesExp ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34e9b06075b84401$export$3553ee90c7edebc9), {
        showOpenChat: true
    }) : null);
}


/* smart-answer-card-body-streaming.tsx generated by @compiled/babel-plugin v2.0.0 */ 
































const $f7d449528e58320a$var$styles = {
    root: "_4kiQYAk3g7",
    fullHeight: "_0jFU0VN91d",
    disclaimer: "_1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r21Y8M"
};
const $f7d449528e58320a$export$3c0eed9572e528c8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(function SmartAnswerCardBodyStreaming({ collapsed: collapsed, onExpandCollapseButtonClick: onExpandCollapseButtonClick, onVisibleTextComplete: onVisibleTextComplete, streamedTextToDisplay: streamedTextToDisplay }) {
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    const resizeObserverTargetContainerRef = (0, $cozmU.useRef)(null);
    const resizeObserverTargetRef = (0, $cozmU.useRef)(null);
    const isVisibleTextCompleteRef = (0, $cozmU.useRef)(false); // Detect if content is truncated when collapsed
    const isContentTruncated = (0, $6df3d09e09b61b24$export$d112da4490f261ea)(resizeObserverTargetRef, resizeObserverTargetContainerRef, collapsed, [
        answerString
    ]);
    const showReadMoreButton = collapsed && isContentTruncated;
    const resizeObserverCallback = (0, $cozmU.useCallback)(()=>{
        if (!isVisibleTextCompleteRef.current && resizeObserverTargetRef.current && resizeObserverTargetContainerRef.current) {
            const resizeObserverTargetRefHeight = resizeObserverTargetRef.current.getBoundingClientRect().height;
            const resizeObserverTargetContainerRefHeight = resizeObserverTargetContainerRef.current.getBoundingClientRect().height;
            const isVisibleTextComplete = resizeObserverTargetRefHeight > resizeObserverTargetContainerRefHeight;
            if (isVisibleTextComplete) {
                onVisibleTextComplete();
                isVisibleTextCompleteRef.current = true;
            }
        }
    }, [
        onVisibleTextComplete
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1dee242400437624$export$fd29db098e42c3fc)(resizeObserverTargetRef, resizeObserverCallback);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        testId: "smart-answer-card-body-streaming",
        xcss: $f7d449528e58320a$var$styles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        xcss: $f7d449528e58320a$var$styles.fullHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4217877a0025dc35$export$127e64693c41156a), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "xxsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            size: "small",
            weight: "bold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).smart_answer_card_title))),
        isCollapsed: collapsed,
        onExpandCollapse: onExpandCollapseButtonClick,
        ref: resizeObserverTargetContainerRef,
        showReadMoreButton: showReadMoreButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: resizeObserverTargetRef,
        testId: "sain-fmp-target"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c5ac787bcb31d21$export$687d546b0584d31b), {
        markdown: streamedTextToDisplay
    }))))), showReadMoreButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ed12dd693731600a$export$e68719f9c8487320), {
        onClick: onExpandCollapseButtonClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f7d449528e58320a$var$styles.disclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: false
    }))));
}, (prevProps, nextProps)=>{
    return prevProps.collapsed === nextProps.collapsed && prevProps.streamedTextToDisplay === nextProps.streamedTextToDisplay;
});


const $2243051d7b6c86e9$var$styles = {
    fullWidth: "_39xV02qUim _1EqgXlN91d",
    interactive: "_0wOv4Q7zJH",
    loadingPaddingOverrides: "_2Zuz6Q8HPE _1Znuxb8HPE"
};
function $2243051d7b6c86e9$var$SmartAnswerCardComponent({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, queryIntent: queryIntent }) {
    const [collapsed, setCollapsed] = (0, $cozmU.useState)(true);
    const containerRef = (0, $cozmU.useRef)(null);
    const [didUserTriggerCollapse, setDidUserTriggerCollapse] = (0, $cozmU.useState)(false);
    const [isVisibleTextComplete, setIsVisibleTextComplete] = (0, $cozmU.useState)(false);
    const componentRenderTimeRef = (0, $cozmU.useRef)(Date.now());
    const firstByteEventFiredRef = (0, $cozmU.useRef)(false);
    const { commonAttributes: commonAttributes, hasError: hasError, isAnswered: isAnswered, loading: loading, partialResponse: partialResponse } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId, queryHash: queryHash, searchSessionId: searchSessionId } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const streamingText = partialResponse?.partialNlpResult ?? '';
    const [streamingTextToDisplay, setStreamingTextToDisplay] = (0, $cozmU.useState)(streamingText);
    (0, $cozmU.useEffect)(()=>{
        if (streamingText.length > 0 && !firstByteEventFiredRef.current) {
            fireAnalyticsEvent((0, $bd6e42147a6848a8$export$c68095583a3c17cc)({
                ...commonAttributes,
                timeToFirstByte: Date.now() - componentRenderTimeRef.current
            }));
            firstByteEventFiredRef.current = true;
        }
    }, [
        streamingText,
        commonAttributes,
        fireAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (collapsed && !isVisibleTextComplete) setStreamingTextToDisplay(streamingText);
        else if (!collapsed) setStreamingTextToDisplay(streamingText);
    }, [
        collapsed,
        isVisibleTextComplete,
        streamingText
    ]); // Notify context when collapsed state changes
    (0, $cozmU.useEffect)(()=>{
        onAnswerExpandedChange?.(!collapsed);
    }, [
        collapsed,
        onAnswerExpandedChange
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !hasError && !isVisibleTextComplete) {
            setIsVisibleTextComplete(true);
            onFMPReached?.(); // Mark FMP as reached for cached answers
        }
    }, [
        loading,
        hasError,
        isVisibleTextComplete,
        onFMPReached
    ]); // use useEffect to trigger analytics event in order to avoid needing to
    // pass commonAttributes as a dependency to handleExpandCollapseButtonClick
    // and thus avoid re-rendering SmartAnswerCardBodyStreaming with every
    // update to commonAttributes (which gets updated with the streamed text)
    (0, $cozmU.useEffect)(()=>{
        if (didUserTriggerCollapse) fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)(commonAttributes));
    }, [
        didUserTriggerCollapse,
        commonAttributes,
        fireAnalyticsEvent
    ]);
    const handleExpandCollapseButtonClick = (0, $cozmU.useCallback)(()=>{
        if (collapsed) {
            setCollapsed(false);
            setDidUserTriggerCollapse(false);
        } else {
            setCollapsed(true);
            setDidUserTriggerCollapse(true);
        }
    }, [
        collapsed
    ]);
    const handleVisibleTextComplete = (0, $cozmU.useCallback)(()=>{
        setIsVisibleTextComplete(true);
        onFMPReached?.(); // Mark FMP as reached for streaming answers
    }, [
        onFMPReached
    ]);
    const handleContainerClick = (event)=>{
        const selection = window.getSelection()?.toString() ?? ''; // Highlighting text should not expand the card
        const hasHighlightedText = selection.length > 0; // Clicking in a feedback modal or flag should not expand the card
        const isClickingOnContainer = containerRef.current?.contains(event.target) ?? false;
        if (collapsed && !hasHighlightedText && isClickingOnContainer) {
            setCollapsed(false);
            fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)(commonAttributes));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).EXPAND_CLICKED,
                commonAttributes: commonAttributes
            });
        }
    };
    if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2243051d7b6c86e9$var$styles.fullWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f366b75433df2895$export$ffa24cd7196ce1b0), null));
    let content = null;
    if (!isAnswered && (loading || loading === undefined)) {
        if (!partialResponse) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aiIBH.SmartAnswerCardBodyGenerating), null);
        else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7d449528e58320a$export$3c0eed9572e528c8), {
            cloudId: cloudId,
            collapsed: collapsed,
            onExpandCollapseButtonClick: handleExpandCollapseButtonClick,
            onVisibleTextComplete: handleVisibleTextComplete,
            streamedTextToDisplay: streamingTextToDisplay
        });
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "search-ai-dialog-all-text-loading"
        }), (0, $iDrrr.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
            dataKey: "queryHash",
            value: queryHash
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
            dataKey: "searchSessionId",
            value: searchSessionId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
            dataKey: "queryIntent",
            value: queryIntent
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
            data: {
                queryHash: queryHash,
                searchSessionId: searchSessionId,
                queryIntent: queryIntent
            }
        }), content);
    } else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: collapsed ? $2243051d7b6c86e9$var$styles.interactive : undefined,
        onClick: handleContainerClick,
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $18d1f6bb8f76e7b1$export$41d38529b1c47f4e), {
        collapsed: collapsed,
        onExpandCollapseButtonClick: handleExpandCollapseButtonClick,
        queryIntent: queryIntent
    })));
    content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "search-ai-dialog-all-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "search-ai-dialog-visible-text"
    }, isVisibleTextComplete ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "search-ai-dialog-visible-text-loading"
    }), (0, $iDrrr.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "queryHash",
        value: queryHash
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "searchSessionId",
        value: searchSessionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "queryIntent",
        value: queryIntent
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            queryIntent: queryIntent
        }
    }), content));
    if ((0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled()) {
        if (!isAnswered && (loading || loading === undefined)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($2243051d7b6c86e9$var$styles.fullWidth, $2243051d7b6c86e9$var$styles.loadingPaddingOverrides)
        }, content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f420039341622608$export$8a1fad5d74d43878), {
            isStreaming: true,
            showMoreButtonVisible: false
        }));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2243051d7b6c86e9$var$styles.fullWidth
        }, content);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3ffN.AnimatedWrapper), {
        isAnswerComplete: isAnswered && !loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2243051d7b6c86e9$var$styles.fullWidth
    }, content));
}
function $2243051d7b6c86e9$export$827de04ba3667da0({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, queryIntent: queryIntent }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "smart-answer-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2243051d7b6c86e9$var$SmartAnswerCardComponent, {
        onFMPReached: onFMPReached,
        onAnswerExpandedChange: onAnswerExpandedChange,
        queryIntent: queryIntent
    }));
}


/* smart-answer-card-consolidated.tsx generated by @compiled/babel-plugin v2.0.0 */ 

































































































































/* smart-answer-card-minimized-loading-v2.tsx generated by @compiled/babel-plugin v2.0.0 */ 

































const $cb359678c785e7d4$var$getRenderableSteps = (steps)=>{
    if (!steps) return [];
    return Object.values(steps).filter((s)=>!!s.title).sort((a, b)=>a.order - b.order);
};
const $cb359678c785e7d4$var$styles = {
    container: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKxmn _3iDTPbQ4SZ _0aFT5vbt8w _24h04i2Njc _0KLXrunmFW _0jFU0VqfN2",
    shimmerWrapper: "_2O5Vij7dHp _4ouGXIdnbC",
    expandedContent: "_2O5Vij7dHp _4kiQYAdnbC _0Of8r2Pgdg _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE",
    skeletonPlaceholder: "_2O5Vij7dHp _4kiQYAdnbC _3iDTPbQ4SZ _0aFT5v1qpb _17lj8p2ADO _0Of8r2Pgdg _1wydGW8HPE _2Zuz6Q8HPE _1Znuxb8HPE",
    skeletonLines: "_2O5Vij7dHp _4ouGXIdnbC",
    collapsedRow: "_3iDTPbQ4SZ _0aFT5v1qpb _39xV02N91d _17lj8p2ADO _0hPCNLDIqT _0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _24h04i2Njc _0jFU0V9LX5 _3YEZNOdnbC",
    collapsedLoaderIconColumn: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _3YEZNOdnbC",
    expandedLoaderRow: "_3iDTPbQ4SZ _0aFT5v1qpb _39xV02N91d _17lj8p2ADO _0hPCNLFlnN _0Of8r22ADO _1wydGWPgdg _2Zuz6Q8HPE _1Znuxb8HPE _24h04i2Njc _0jFU0V9LX5 _3YEZNOdnbC",
    loaderIconColumn: "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _39xV02oWWg _3YEZNOdnbC _4xdlr0FlnN",
    loaderRuleSlotTop: "_2O5Vij7dHp _39xV02dnbC",
    loaderRuleSlotWithLine: "_3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _2O5Vij7dHp _39xV02dnbC _1bHrqE2ADO",
    loaderContent: "_2O5Vij7dHp _4ouGXIdnbC _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _17lj8p2ADO _1wydGW2ADO"
};
const $cb359678c785e7d4$var$messages = (0, $kSwu1.defineMessages)({
    thinking_deeper: {
        id: "search-ai.smart-answer-card-minimized-loading.thinking-deeper",
        defaultMessage: "Thinking deeper and analyzing your question..."
    }
});
const $cb359678c785e7d4$var$MAX_EXPANDED_STEPS = 2;
const $cb359678c785e7d4$var$SKELETON_HEIGHT_LINE = '16px';
const $cb359678c785e7d4$var$SKELETON_BORDER_RADIUS = "var(--ds-radius-medium, 6px)"; /**
                                                                * Placeholder skeleton lines shown beneath the header row while there are no
                                                                * research steps yet, so the (fixed-height) loading card doesn't read as a large
                                                                * empty box. Mirrors the borderless UX skeleton in `smart-answer-card-body-generating`
                                                                * (two full-width lines + one 75% line).
                                                                */ 
const $cb359678c785e7d4$var$skeletonLines = [
    {
        width: '100%',
        height: $cb359678c785e7d4$var$SKELETON_HEIGHT_LINE
    },
    {
        width: '100%',
        height: $cb359678c785e7d4$var$SKELETON_HEIGHT_LINE
    },
    {
        width: '75%',
        height: $cb359678c785e7d4$var$SKELETON_HEIGHT_LINE
    }
]; /**
     * Entrance animation for a research step. Fades in with a small upward slide.
     * Because each step row is keyed by `stepId`, only a newly-mounted step runs
     * this mount animation — a surviving step that merely shifts position in the
     * rolling window keeps its DOM node and does NOT re-animate.
     */ 
const $cb359678c785e7d4$var$stepEnterKeyframes = null;
const $cb359678c785e7d4$var$stepEnterStyles = null;
function $cb359678c785e7d4$export$89ba1a078457ae7b({ commonAttributes: commonAttributes, testId: testId }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { researchSteps: researchSteps } = (0, $3hVWe.useAIAnswerContext)();
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent((0, $kSORO.onAIAnswerLoadingDialogShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const renderableSteps = $cb359678c785e7d4$var$getRenderableSteps(researchSteps); // Take the last MAX_EXPANDED_STEPS renderable steps in oldest-first order so
    // the most recent step appears at the bottom.
    const recentStepsForExpanded = renderableSteps.slice(-$cb359678c785e7d4$var$MAX_EXPANDED_STEPS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3ffN.AnimatedWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.container
    }, recentStepsForExpanded.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.expandedLoaderRow,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.loaderIconColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.loaderRuleSlotTop
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e5f31f7d389abdf$export$c07a397cf5c24cd8), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.loaderRuleSlotWithLine
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.loaderContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.shimmerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14633d638bf89cef$export$f35c7d979dec8662), {
        size: "medium",
        truncate: true
    }, formatMessage($cb359678c785e7d4$var$messages.thinking_deeper))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.collapsedRow,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.collapsedLoaderIconColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9e5f31f7d389abdf$export$c07a397cf5c24cd8), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        grow: "fill",
        xcss: $cb359678c785e7d4$var$styles.shimmerWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14633d638bf89cef$export$f35c7d979dec8662), {
        size: "medium",
        truncate: true
    }, formatMessage($cb359678c785e7d4$var$messages.thinking_deeper)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.skeletonPlaceholder,
        testId: testId ? `${testId}-skeleton` : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.collapsedLoaderIconColumn
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $cb359678c785e7d4$var$styles.skeletonLines,
        space: "space.200"
    }, $cb359678c785e7d4$var$skeletonLines.map((line, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            key: index,
            width: line.width,
            height: line.height,
            color: "var(--ds-skeleton-subtle, #17171708)",
            borderRadius: $cb359678c785e7d4$var$SKELETON_BORDER_RADIUS
        }))))), recentStepsForExpanded.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb359678c785e7d4$var$styles.expandedContent
    }, recentStepsForExpanded.map((step, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: step.stepId,
            className: (0, $hekY6.default)([
                "_1gBibym8DQ _0nFVCGDsjo _43vdfT1fFG _3Y6bKpZSoF _39Ohv4YbGa"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65efb4030898c062$export$f22a8a5ea07141e0), {
            step: step,
            // loader); bottom connector on all but the last step.
            showTopConnector: true,
            showBottomConnector: index < recentStepsForExpanded.length - 1,
            testId: testId ? `${testId}-step-${step.stepId}` : undefined
        }))))));
}



const $fd49c31ba41c686c$var$MemoizedRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(function MemoizedRenderer({ contentToRender: contentToRender, showAnimation: showAnimation }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c5ac787bcb31d21$export$687d546b0584d31b), {
        key: "stable-renderer",
        markdown: contentToRender,
        animateComponents: showAnimation
    });
});
const $fd49c31ba41c686c$var$styles = {
    fullWidth: "_39xV02qUim _1EqgXlN91d _1DCdHi8HPE",
    interactive: "_0wOv4Q7zJH",
    root: "_4kiQYAk3g7",
    fullHeight: "_0jFU0VN91d",
    disclaimer: "_1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r21Y8M",
    followUpChatInputSectionStyles: "_3138425zaO",
    followUpChatInputSectionWithBarStyles: "_3138422ADO",
    disclaimerWrapperStyles: "_1wydGW8HPE _2Zuz6Q5zaO _0Of8r21Y8M _2IVJ4M6wH8 _3zygPU9r67 _22sfPnNvrM",
    sectionContainer: "_1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r21Y8M",
    sourcesTopPadding: "_0Of8r21Y8M",
    linkListContainer: "_313842gVvo",
    nonInteractive: "_1pp6NdYbGa",
    loadingPaddingOverrides: "_2Zuz6Q8HPE _1Znuxb8HPE",
    standardSAINMarginOverrides: "_1DCdHi2ADO"
};
function $fd49c31ba41c686c$var$SmartAnswerCardConsolidatedComponent({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, queryIntent: queryIntent, onAnswerMinimizedChange: onAnswerMinimizedChange, floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef }) {
    const [collapsed, setCollapsed] = (0, $cozmU.useState)(true); // Tracks whether the answer is currently "minimized" — i.e. the loaded answer
    // is hidden and the SmartAnswerReady component is shown in its place. Only
    // flips to true post-load when the user explicitly hides the answer.
    const [isAnswerMinimized, setIsAnswerMinimized] = (0, $cozmU.useState)(false);
    const containerRef = (0, $cozmU.useRef)(null);
    const [didUserTriggerCollapse, setDidUserTriggerCollapse] = (0, $cozmU.useState)(false);
    const [isVisibleTextComplete, setIsVisibleTextComplete] = (0, $cozmU.useState)(false);
    const [showAnimation, setShowAnimation] = (0, $cozmU.useState)(false); // Tracks whether the answer card is currently within the viewport.
    // Used to decide whether to render the SmartAnswerReady banner at the top of the
    // search results when the user has scrolled the answer card out of view.
    const [isCardInViewport, setIsCardInViewport] = (0, $cozmU.useState)(true);
    const componentRenderTimeRef = (0, $cozmU.useRef)(Date.now());
    const firstByteEventFiredRef = (0, $cozmU.useRef)(false);
    const context = (0, $3hVWe.useAIAnswerContext)();
    const { commonAttributes: commonAttributes, hasError: hasError, isAnswered: isAnswered, loading: loading, partialResponse: partialResponse, luminaContentMap: luminaContentMap } = context;
    const { queryHash: queryHash, searchSessionId: searchSessionId, answerString: answerString, sources: sources, errorStateSuggestedQueries: errorStateSuggestedQueries } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const streamingText = partialResponse?.partialNlpResult ?? '';
    const [streamingTextToDisplay, setStreamingTextToDisplay] = (0, $cozmU.useState)(streamingText); // Refs for content truncation detection
    const isVisibleTextCompleteRef = (0, $cozmU.useRef)(false);
    const visibleTextCompletionRecordedRef = (0, $cozmU.useRef)(false);
    const [visibleTextCompletionData, setVisibleTextCompletionData] = (0, $cozmU.useState)(null);
    const contentToRenderRef = (0, $cozmU.useRef)('');
    const visibleTextEverStreamedRef = (0, $cozmU.useRef)(false); // Measures only answer text height (excludes sources and chat input) so onReadMoreButtonShown
    // fires only when the text itself is truncated, not due to other content
    const textContentRef = (0, $cozmU.useRef)(null);
    const completeAnswerAnalyticsEventFiredRef = (0, $cozmU.useRef)(false);
    const renderedContentRef = (0, $cozmU.useRef)(null);
    const contentContainerRef = (0, $cozmU.useRef)(null);
    const hasLinksInAnswer = !!(luminaContentMap && Object.keys(luminaContentMap).length > 0) && (0, $iDrrr.fg)('kd_sain_enable_inline_lumina');
    const recordVisibleTextCompletion = (0, $cozmU.useCallback)((source)=>{
        if (visibleTextCompletionRecordedRef.current) return;
        visibleTextCompletionRecordedRef.current = true;
        setVisibleTextCompletionData({
            visibleTextCompletionSource: source,
            visibleTextCompletionMs: Date.now() - componentRenderTimeRef.current,
            visibleTextDisplayedLength: contentToRenderRef.current.length,
            visibleTextEverStreamed: visibleTextEverStreamedRef.current
        });
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!visibleTextEverStreamedRef.current && (loading || partialResponse)) visibleTextEverStreamedRef.current = true;
    }, [
        loading,
        partialResponse
    ]);
    const bufferedContent = (0, $d3e29575f8ad4c54$export$8f4f0a9c358684c2)(streamingTextToDisplay, isAnswered && !loading);
    const contentToRender = isAnswered ? answerString : bufferedContent;
    (0, $cozmU.useEffect)(()=>{
        contentToRenderRef.current = contentToRender;
    }, [
        contentToRender
    ]);
    (0, $cozmU.useEffect)(()=>{
        // If streaming stopped but buffered content still exists, clear it to reset the display
        if (!streamingText && streamingTextToDisplay && (0, $iDrrr.fg)('kd_fix_abort_errors')) {
            setStreamingTextToDisplay('');
            setIsVisibleTextComplete(false);
            return;
        }
        if (collapsed && !isVisibleTextComplete) setStreamingTextToDisplay(streamingText);
        else if (!collapsed) setStreamingTextToDisplay(streamingText);
    }, [
        collapsed,
        isVisibleTextComplete,
        streamingText,
        streamingTextToDisplay
    ]); // Notify context when collapsed state changes
    (0, $cozmU.useEffect)(()=>{
        onAnswerExpandedChange?.(!collapsed);
    }, [
        collapsed,
        onAnswerExpandedChange
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !hasError && !isVisibleTextComplete) {
            recordVisibleTextCompletion('loading-complete');
            setIsVisibleTextComplete(true);
            onFMPReached?.(); // Mark FMP as reached for cached answers
        }
    }, [
        loading,
        hasError,
        isVisibleTextComplete,
        onFMPReached,
        recordVisibleTextCompletion
    ]); // Track if we should show animations (if loading or partialResponse are true)
    (0, $cozmU.useEffect)(()=>{
        if (!showAnimation && loading && partialResponse) setShowAnimation(true);
        if (loading && !partialResponse && showAnimation && (0, $iDrrr.fg)('kd_fix_abort_errors')) {
            setShowAnimation(false);
            firstByteEventFiredRef.current = false;
            completeAnswerAnalyticsEventFiredRef.current = false;
        }
    }, [
        loading,
        partialResponse,
        showAnimation
    ]); // use useEffect to trigger analytics event in order to avoid needing to
    // pass commonAttributes as a dependency to handleExpandCollapseButtonClick
    // and thus avoid re-rendering SmartAnswerCardBodyStreaming with every
    // update to commonAttributes (which gets updated with the streamed text)
    (0, $cozmU.useEffect)(()=>{
        if (didUserTriggerCollapse) fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)(commonAttributes));
    }, [
        didUserTriggerCollapse,
        commonAttributes,
        fireAnalyticsEvent
    ]); // Detect if content is truncated when collapsed
    const isContentTruncated = (0, $6df3d09e09b61b24$export$d112da4490f261ea)(renderedContentRef, contentContainerRef, collapsed, [
        streamingText
    ]);
    const isTextTruncated = (0, $6df3d09e09b61b24$export$d112da4490f261ea)(textContentRef, contentContainerRef, collapsed, [
        streamingText
    ]); // Complete answer analytics
    (0, $cozmU.useEffect)(()=>{
        // Only fire once and ensure DOM element is ready with meaningful content
        if (completeAnswerAnalyticsEventFiredRef.current || !renderedContentRef.current) return;
        const answerHeight = renderedContentRef.current.getBoundingClientRect().height;
        const containerHeight = contentContainerRef.current?.getBoundingClientRect().height ?? 0;
        const whitespaceHeight = Math.max(containerHeight - answerHeight, 0); // Only fire if we have meaningful height (content is rendered)
        if (answerHeight > 0 && containerHeight > 0) {
            fireAnalyticsEvent((0, $d58a262274d16c7a$export$f3109245f09f7746)({
                ...commonAttributes,
                answerHeight: answerHeight,
                containerHeight: containerHeight,
                whitespaceHeight: whitespaceHeight,
                queryIntent: queryIntent
            }));
            completeAnswerAnalyticsEventFiredRef.current = true;
        }
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        queryIntent,
        isContentTruncated
    ]); // SAIN usage event
    (0, $cozmU.useEffect)(()=>{
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Notify parent (ai-answer-dialog) whenever the "answer minimized" state
    // changes so dwell tracking can be gated on whether the user can actually see
    // the answer.
    (0, $cozmU.useEffect)(()=>{
        onAnswerMinimizedChange?.(isAnswerMinimized);
    }, [
        isAnswerMinimized,
        onAnswerMinimizedChange
    ]); // Toggles the answer minimized state for the "Hide answer" button and the
    // in-flow "Expand" (SmartAnswerReady) affordance. `minimized=true` hides the
    // answer behind the SmartAnswerReady component; `minimized=false` re-shows the
    // answer. Fires the corresponding analytics event and updates the state.
    // NOTE: unlike SmartAnswerCardMinimized, this intentionally does NOT touch
    // `userExpandedDuringLoading`/`collapsed` — those are loading-time concerns
    // that don't apply to the consolidated card's minimize flow.
    const handleAnswerHiddenToggle = (0, $cozmU.useCallback)((minimized)=>{
        if (minimized) fireAnalyticsEvent((0, $619bd3e23d17df21$export$816a5214860a0c40)(commonAttributes));
        else fireAnalyticsEvent((0, $57db223fb661d84a$export$b19cbf041d35e6cc)(commonAttributes));
        setIsAnswerMinimized(minimized);
    }, [
        commonAttributes,
        fireAnalyticsEvent
    ]);
    const handleExpandCollapseButtonClick = (0, $cozmU.useCallback)(()=>{
        if (collapsed) {
            setCollapsed(false);
            setDidUserTriggerCollapse(false);
        } else {
            setCollapsed(true);
            setDidUserTriggerCollapse(true);
        }
    }, [
        collapsed
    ]); // Scrolls the answer card back into view and expands it fully when the user
    // clicks "Scroll up" on the floating SmartAnswerReady banner.
    const handleScrollUpClick = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $57ae65a71649f2c5$export$7f9024bb8c6bf2c3)(commonAttributes));
        fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)(commonAttributes));
        setCollapsed(false);
        setDidUserTriggerCollapse(false);
        const node = containerRef.current;
        if (!node) return;
         // The "Scroll up" button only appears on the floating banner, which is only
        // rendered when the card is scrolled out of view (isCardInViewport === false).
        // So reaching this handler means the card is effectively out of view (or hidden
        // behind the fixed banner) and we should always scroll it back to the top.
        //
        // We intentionally avoid an isOutOfViewport short-circuit here: the previous
        // `rect.bottom <= 0` guard failed the edge case where the card's bottom edge
        // sits a few pixels below the viewport top (positive rect.bottom) but the card
        // is still visually hidden behind the fixed floating banner — in that case the
        // guard skipped the scroll and the user was never taken back to the answer.
        node.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }, [
        commonAttributes,
        fireAnalyticsEvent
    ]); // Track whether the answer card is in the viewport so we can render
    // SmartAnswerReady at the top of the search results when the user has scrolled
    // past the answer card. Only observe once the answer has finished loading and
    // is not in an error/no-answer state. Gated on the scroll-up feature since this
    // observer only exists to drive the floating SmartAnswerReady banner. Mirrors the
    // OR gating in smart-answers/index.tsx so the observer runs whenever the floating
    // portal ref is provided (either the scroll-up gate OR the broader updated-flow
    // experiment is on).
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $7DMz5.SAINFeatureControl).isSAINScrollUpEnabled() && !(0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled()) return;
        if (!isAnswered || hasError) return;
        if (!containerRef.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setIsCardInViewport(entry.isIntersecting);
            });
        }, {
            threshold: 0
        });
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        isAnswered,
        hasError
    ]);
    const handleVisibleTextComplete = (0, $cozmU.useCallback)(()=>{
        setIsVisibleTextComplete(true);
        onFMPReached?.(); // Mark FMP as reached for streaming answers
    }, [
        onFMPReached
    ]);
    const handleContainerClick = (0, $cozmU.useCallback)((event)=>{
        const selection = window.getSelection()?.toString() ?? ''; // Highlighting text should not expand the card
        const hasHighlightedText = selection.length > 0; // Clicking in a feedback modal or flag should not expand the card
        const isClickingOnContainer = containerRef.current?.contains(event.target) ?? false;
        if (collapsed && !hasHighlightedText && isClickingOnContainer) {
            setCollapsed(false);
            fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)(commonAttributes));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).EXPAND_CLICKED,
                commonAttributes: commonAttributes
            });
        }
    }, [
        collapsed,
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent
    ]);
    const { handleSmartCardClick: handleSmartCardClick } = (0, $280875adc8c5626f$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context
    }); // UFO resize observer for streaming
    const resizeObserverCallback = (0, $cozmU.useCallback)(()=>{
        if (!isVisibleTextCompleteRef.current && renderedContentRef.current && contentContainerRef.current && !!streamingTextToDisplay) {
            const renderedContentRefHeight = renderedContentRef.current.getBoundingClientRect().height;
            const contentContainerRefHeight = contentContainerRef.current.getBoundingClientRect().height;
            const isVisibleTextComplete = renderedContentRefHeight > contentContainerRefHeight;
            if (isVisibleTextComplete) {
                recordVisibleTextCompletion('overflow');
                handleVisibleTextComplete();
                isVisibleTextCompleteRef.current = true;
            }
        }
    }, [
        handleVisibleTextComplete,
        recordVisibleTextCompletion,
        streamingTextToDisplay
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1dee242400437624$export$fd29db098e42c3fc)(renderedContentRef, resizeObserverCallback, 100, [
        streamingTextToDisplay
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (bufferedContent.length > 0 && !firstByteEventFiredRef.current) {
            fireAnalyticsEvent((0, $bd6e42147a6848a8$export$c68095583a3c17cc)({
                ...commonAttributes,
                timeToFirstByte: Date.now() - componentRenderTimeRef.current
            }));
            firstByteEventFiredRef.current = true;
        }
    }, [
        bufferedContent,
        commonAttributes,
        fireAnalyticsEvent
    ]); // Experiments
    const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_sain_show_no_answer_suggestions_exp'
    });
    const showReadMoreButton = collapsed && isContentTruncated; // Single return statement with React component for main content
    const isStreaming = !isAnswered && (loading || loading === undefined); // Early return for error state
    if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fd49c31ba41c686c$var$styles.fullWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f366b75433df2895$export$ffa24cd7196ce1b0), null));
     // Keep one UFO segment shell across loading/done states to avoid duplicate `_1`
    // lifecycles in the parent `ufo-unified-search` payload.
    const isGenerating = !isAnswered && (loading || loading === undefined) && (!partialResponse || bufferedContent.length < 1);
    const isSainUxUpliftEnabled = (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled();
    const isSAINLoadingStateTracesUpdateEnabled = (0, $7DMz5.SAINFeatureControl).isSAINLoadingStateTracesUpdateEnabled();
    const visibleTextCompletionSourceData = visibleTextCompletionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: visibleTextCompletionData
    }) : null; // Render SmartAnswerReady at the top of the search results when:
    // - the answer has finished loading and is not in an error/no-answer state
    // - the answer card is currently scrolled out of the viewport
    // - the answer is currently in its collapsed state (user hasn't expanded it)
    const notifySmartAnswerReady = isAnswered && !hasError && !isCardInViewport && collapsed;
    const floatingSmartAnswerReadyPortal = notifySmartAnswerReady && floatingSmartAnswerReadyPortalRef?.current ? /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35b517b5dcf10511$export$6219b6e404cffa4a), {
        appearance: "scrollUp",
        onScrollUpClick: handleScrollUpClick,
        testId: "smart-answer-ready-floating"
    }), floatingSmartAnswerReadyPortalRef.current) : null;
    const answerCardContent = isGenerating ? isSAINLoadingStateTracesUpdateEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cb359678c785e7d4$export$89ba1a078457ae7b), {
        commonAttributes: commonAttributes
    }) : isSainUxUpliftEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aiIBH.SmartAnswerCardBodyGenerating), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f420039341622608$export$8a1fad5d74d43878), {
        isStreaming: true,
        showMoreButtonVisible: false
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3ffN.AnimatedWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aiIBH.SmartAnswerCardBodyGenerating), null)) : isSainUxUpliftEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fd49c31ba41c686c$var$SmartAnswerCardContent, {
        isStreaming: isStreaming,
        collapsed: collapsed,
        showReadMoreButton: showReadMoreButton,
        handleExpandCollapseButtonClick: handleExpandCollapseButtonClick,
        contentContainerRef: contentContainerRef,
        renderedContentRef: renderedContentRef,
        textContentRef: textContentRef,
        isTextTruncated: isTextTruncated,
        sources: sources,
        searchSessionId: searchSessionId,
        sourceClickCallback: handleSmartCardClick,
        errorStateSuggestedQueries: errorStateSuggestedQueries,
        serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp,
        commonAttributes: commonAttributes,
        contentToRender: contentToRender,
        showAnimation: showAnimation,
        onHideAnswer: ()=>handleAnswerHiddenToggle(true),
        handleContainerClick: handleContainerClick,
        containerRef: containerRef,
        hasLinksInAnswer: hasLinksInAnswer
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3ffN.AnimatedWrapper), {
        isAnswerComplete: isAnswered && !loading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fd49c31ba41c686c$var$SmartAnswerCardContent, {
        isStreaming: isStreaming,
        collapsed: collapsed,
        showReadMoreButton: showReadMoreButton,
        handleExpandCollapseButtonClick: handleExpandCollapseButtonClick,
        contentContainerRef: contentContainerRef,
        textContentRef: textContentRef,
        isTextTruncated: isTextTruncated,
        renderedContentRef: renderedContentRef,
        sources: sources,
        searchSessionId: searchSessionId,
        sourceClickCallback: handleSmartCardClick,
        errorStateSuggestedQueries: errorStateSuggestedQueries,
        serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp,
        commonAttributes: commonAttributes,
        contentToRender: contentToRender,
        showAnimation: showAnimation,
        onHideAnswer: ()=>handleAnswerHiddenToggle(true),
        handleContainerClick: handleContainerClick,
        containerRef: containerRef,
        hasLinksInAnswer: hasLinksInAnswer
    })); // Gate off keeps the legacy remounting structure for holdback comparison.
    // When the user has minimized the answer (clicked "Hide answer" on the loaded
    // card), render the SmartAnswerReady component in place of the full answer.
    // Clicking it re-shows the answer via handleAnswerHiddenToggle(false).
    // No need to also guard on !isGenerating: `isAnswerMinimized` can only become
    // true via the Hide answer button, which is only shown when !collapsed &&
    // !isStreaming (i.e. the answer is already loaded).
    if (isAnswerMinimized) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35b517b5dcf10511$export$6219b6e404cffa4a), {
        onExpandClick: ()=>handleAnswerHiddenToggle(false)
    });
    if (!(0, $iDrrr.fg)('kd_sain_fix_visible_text_ttai')) {
        if (isGenerating) return isSainUxUpliftEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($fd49c31ba41c686c$var$styles.fullWidth, $fd49c31ba41c686c$var$styles.loadingPaddingOverrides)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "search-ai-dialog-all-text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "search-ai-dialog-all-text-loading",
            hold: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "search-ai-dialog-visible-text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "search-ai-dialog-visible-text-loading",
            hold: true
        }), isSAINLoadingStateTracesUpdateEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cb359678c785e7d4$export$89ba1a078457ae7b), {
            commonAttributes: commonAttributes
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aiIBH.SmartAnswerCardBodyGenerating), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f420039341622608$export$8a1fad5d74d43878), {
            isStreaming: true,
            showMoreButtonVisible: false
        }))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $fd49c31ba41c686c$var$styles.fullWidth
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "search-ai-dialog-all-text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "search-ai-dialog-all-text-loading",
            hold: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "search-ai-dialog-visible-text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "search-ai-dialog-visible-text-loading",
            hold: true
        }), isSAINLoadingStateTracesUpdateEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cb359678c785e7d4$export$89ba1a078457ae7b), {
            commonAttributes: commonAttributes
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3ffN.AnimatedWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aiIBH.SmartAnswerCardBodyGenerating), null)))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $016c76767add6663$export$3d5fec32962921db), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($fd49c31ba41c686c$var$styles.fullWidth, isSainUxUpliftEnabled && $fd49c31ba41c686c$var$styles.loadingPaddingOverrides),
            testId: "smart-answer-card-consolidated"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "search-ai-dialog-all-text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "search-ai-dialog-all-text-loading",
            hold: loading
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "search-ai-dialog-visible-text"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "search-ai-dialog-visible-text-loading",
            hold: !isVisibleTextComplete
        }), (0, $iDrrr.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
            dataKey: "queryHash",
            value: queryHash
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
            dataKey: "searchSessionId",
            value: searchSessionId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
            dataKey: "queryIntent",
            value: queryIntent
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
            data: {
                queryHash: queryHash,
                searchSessionId: searchSessionId,
                queryIntent: queryIntent
            }
        }), visibleTextCompletionSourceData, answerCardContent))), floatingSmartAnswerReadyPortal);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($fd49c31ba41c686c$var$styles.fullWidth, isSainUxUpliftEnabled && $fd49c31ba41c686c$var$styles.loadingPaddingOverrides),
        testId: "smart-answer-card-consolidated"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "search-ai-dialog-all-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "search-ai-dialog-all-text-loading",
        hold: loading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "search-ai-dialog-visible-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "search-ai-dialog-visible-text-loading",
        hold: !isVisibleTextComplete
    }), (0, $iDrrr.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "queryHash",
        value: queryHash
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "searchSessionId",
        value: searchSessionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "queryIntent",
        value: queryIntent
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            queryIntent: queryIntent
        }
    }), visibleTextCompletionSourceData, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $016c76767add6663$export$3d5fec32962921db), null, answerCardContent))), floatingSmartAnswerReadyPortal);
}
function $fd49c31ba41c686c$var$SmartAnswerCardContent({ isStreaming: isStreaming, collapsed: collapsed, showReadMoreButton: showReadMoreButton, handleExpandCollapseButtonClick: handleExpandCollapseButtonClick, contentContainerRef: contentContainerRef, renderedContentRef: renderedContentRef, textContentRef: textContentRef, isTextTruncated: isTextTruncated, sources: sources, searchSessionId: searchSessionId, sourceClickCallback: sourceClickCallback, errorStateSuggestedQueries: errorStateSuggestedQueries, serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp, commonAttributes: commonAttributes, contentToRender: contentToRender, showAnimation: showAnimation, onHideAnswer: onHideAnswer, handleContainerClick: handleContainerClick, containerRef: containerRef, hasLinksInAnswer: hasLinksInAnswer }) {
    const isBorderlessUX = (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled();
    const { authorityUiMetadata: authorityUiMetadata } = (0, $3hVWe.useAIAnswerContext)();
    const { cloudId: cloudId, queryHash: queryHash, extraAttributes: extraAttributes, source: source } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const isHighlyAuthoritative = (0, $iDrrr.fg)('rovo_authoritative_answer_attribution') && !!authorityUiMetadata?.isHighlyAuthoritative;
    const handleAuthorityPanelShown = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $fhQlP.buildAuthoritativeAnswerPanelShownEvent)({
            product: 'sain',
            source: source,
            correlationAttributes: {
                cloudId: cloudId,
                searchSessionId: searchSessionId,
                queryHash: queryHash,
                traceId: extraAttributes?.requestId
            },
            authorityUiMetadata: authorityUiMetadata
        }));
    }, [
        fireAnalyticsEvent,
        source,
        cloudId,
        searchSessionId,
        queryHash,
        extraAttributes?.requestId,
        authorityUiMetadata
    ]);
    const fireAuthorityLinkClick = (0, $cozmU.useCallback)((linkType)=>{
        fireAnalyticsEvent((0, $a7fd7127c63cb2fc$export$5671a2e254c14222)({
            ...commonAttributes,
            linkType: linkType,
            authorityUiMetadata: authorityUiMetadata
        })); // Credits the click towards SAIN's success metric (SSRv5).
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes
        });
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        authorityUiMetadata,
        fireSAINUsageEvent
    ]); // URL patterns for sources known not to resolve as rich smart cards.
    const UNRESOLVABLE_URL_PATTERNS = [
        'viewpageattachments.action'
    ];
    const isUnresolvableSource = (url)=>UNRESOLVABLE_URL_PATTERNS.some((pattern)=>url.includes(pattern)); // Filter sources whose URLs are known not to resolve as rich smart cards.
    // Uses URL pattern matching since the NlpSearchResultType enum does not include 'attachment'.
    // https://switcheroo.atlassian.com/ui/gates/f309f0ca-53a0-4c56-9767-fec898813e99/key/kd_sain_filter_attachment_sources
    const filteredSources = (0, $iDrrr.fg)('kd_sain_filter_attachment_sources') ? sources.filter((source)=>!isUnresolvableSource(source.url)) : sources;
    const sourcesSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, !isStreaming && filteredSources.length > 0 && (0, $7DMz5.SAINFeatureControl).isSourcesInShortSAINAnswersEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($fd49c31ba41c686c$var$styles.sourcesTopPadding, collapsed && $fd49c31ba41c686c$var$styles.nonInteractive)
    }, (0, $7DMz5.SAINFeatureControl).isLinkListSourcesEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: $fd49c31ba41c686c$var$styles.linkListContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).related_links_title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Luzz.LinkList), {
        urls: filteredSources.map((source)=>source.url),
        maxSources: 5,
        showExpand: false,
        onLinkClick: (url, index, opts)=>{
            const source = filteredSources[index];
            if (source) sourceClickCallback({
                index: index,
                source: source,
                hostname: (0, $736ac3075308471f$export$a3b7216c107a7a1)(url),
                sourceCardType: 'link-list',
                isAuxClick: opts?.isAuxClick,
                isContextMenu: opts?.isContextMenu
            });
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ce789c5dd436d96e$export$919320f9832aec1d), {
        sources: filteredSources,
        searchSessionId: searchSessionId,
        onClickHandler: sourceClickCallback
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(collapsed ? $fd49c31ba41c686c$var$styles.interactive : undefined, isBorderlessUX && $fd49c31ba41c686c$var$styles.standardSAINMarginOverrides),
        onClick: handleContainerClick,
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        xcss: isStreaming && !isBorderlessUX ? $fd49c31ba41c686c$var$styles.root : $fd49c31ba41c686c$var$styles.fullHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        xcss: $fd49c31ba41c686c$var$styles.fullHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4217877a0025dc35$export$127e64693c41156a), {
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            spread: "space-between",
            alignBlock: "center",
            grow: "fill",
            xcss: (0, $w6R6I.cx)((0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && $fd49c31ba41c686c$var$styles.standardSAINMarginOverrides)
        }, (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050",
            shouldWrap: true
        }, isHighlyAuthoritative && authorityUiMetadata ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
            label: "",
            size: "medium",
            color: "var(--ds-icon-success, #6A9A23)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Zool.AuthoritativeAnswerAttribution), {
            sources: authorityUiMetadata.sources ?? [],
            domainExperts: authorityUiMetadata.domainExperts ?? [],
            overallReasoning: authorityUiMetadata.overallReasoning,
            labelVariant: "answer",
            cloudId: cloudId,
            surface: "sain",
            // use the taller panel to avoid cramping the feedback form.
            panelSize: "tall",
            onPanelOpen: handleAuthorityPanelShown,
            onSourceClick: ()=>fireAuthorityLinkClick('source'),
            onExpertClick: ()=>fireAuthorityLinkClick('expert'),
            onFeedbackSubmit: (submission)=>{
                // Submit authority-answer feedback to the Feedback Collector API
                // using SAIN's existing entrypoint (same destination as SAIN's
                // footer feedback). Analytics wiring is handled separately.
                (0, $1V59x.submitAuthorityFeedback)({
                    submission: submission,
                    entrypointId: (0, $1V59x.FEEDBACK_ENTRYPOINT_ID_SAIN),
                    origin: (0, $1V59x.AUTHORITY_FEEDBACK_ORIGIN_SAIN),
                    cloudId: cloudId,
                    debugAttributes: {
                        traceId: extraAttributes?.requestId,
                        searchSessionId: searchSessionId,
                        queryHash: queryHash
                    }
                });
            }
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
            label: "AI Content",
            size: "medium"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h1",
            size: "xsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).smart_answer_card_dynamic_layout_title)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "xxsmall"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            size: "small",
            weight: "bold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).smart_answer_card_title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, (0, $7DMz5.SAINFeatureControl).isSAINLoadingStateTracesUpdateEnabled() && !isStreaming && onHideAnswer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            spacing: "compact",
            appearance: "subtle",
            onClick: (e)=>{
                // The button lives inside the AICollapse header, which expands
                // the answer when clicked anywhere. Stop propagation so
                // clicking "Hide answer" only hides the answer (and shows
                // SmartAnswerReady) without also expanding it.
                e.stopPropagation();
                onHideAnswer();
            },
            iconAfter: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), {
                    ...iconProps,
                    size: "small"
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).hide_answer))))),
        isCollapsed: collapsed,
        onExpandCollapse: handleExpandCollapseButtonClick,
        ref: contentContainerRef,
        showReadMoreButton: isBorderlessUX ? collapsed : showReadMoreButton,
        luminaAnswerType: (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() ? 'STANDARD' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: renderedContentRef,
        id: "ai-answer-result-section",
        testId: "sain-fmp-target"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: textContentRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fd49c31ba41c686c$var$MemoizedRenderer, {
        contentToRender: contentToRender,
        showAnimation: showAnimation
    })))), !hasLinksInAnswer && sourcesSection)), showReadMoreButton && !(0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ed12dd693731600a$export$e68719f9c8487320), {
        onClick: handleExpandCollapseButtonClick
    }), (collapsed || showReadMoreButton || isStreaming) && (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f420039341622608$export$8a1fad5d74d43878), {
        isStreaming: isStreaming,
        showMoreButtonVisible: collapsed,
        fireShownEvent: isTextTruncated,
        onClickShowMoreButton: handleExpandCollapseButtonClick
    })), !isStreaming && !collapsed && filteredSources.length > 0 && !(0, $7DMz5.SAINFeatureControl).isSourcesInShortSAINAnswersEnabled() && !hasLinksInAnswer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fd49c31ba41c686c$var$styles.sectionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ce789c5dd436d96e$export$919320f9832aec1d), {
        sources: filteredSources,
        searchSessionId: searchSessionId,
        onClickHandler: sourceClickCallback
    })), (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && !isStreaming && !collapsed && filteredSources.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fd49c31ba41c686c$var$styles.followUpChatInputSectionWithBarStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe4d4049968826dc$export$7552c1f78575b57c), {
        renderTrigger: (onToggle, triggerRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7fd6a1524e779285$export$e754cddb4d3a7903), {
                sources: filteredSources,
                numSources: filteredSources.length,
                onClick: onToggle,
                triggerRef: triggerRef
            })
    })), !collapsed && !showReadMoreButton && !isStreaming && (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        xcss: $fd49c31ba41c686c$var$styles.followUpChatInputSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a921764ae1a692a7$export$f087ce3403d54eb5), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j8bJ5.OpenChatInputBox), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fd49c31ba41c686c$var$styles.disclaimerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true,
        showCopyButton: !hasLinksInAnswer,
        renderedContentRef: textContentRef
    }))), !(0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fd49c31ba41c686c$var$styles.disclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: !isStreaming,
        showCopyButton: !isStreaming && !hasLinksInAnswer,
        renderedContentRef: textContentRef
    }))), !isStreaming && !(0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && (!collapsed || errorStateSuggestedQueries.length > 0 && serveErrorStateSuggestedQueriesExp) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34e9b06075b84401$export$3553ee90c7edebc9), {
        showOpenChat: true
    }) : null));
}
function $fd49c31ba41c686c$export$3698d894d0a161e5({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, queryIntent: queryIntent, onAnswerMinimizedChange: onAnswerMinimizedChange, floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "smart-answer-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fd49c31ba41c686c$var$SmartAnswerCardConsolidatedComponent, {
        onFMPReached: onFMPReached,
        onAnswerExpandedChange: onAnswerExpandedChange,
        queryIntent: queryIntent,
        onAnswerMinimizedChange: onAnswerMinimizedChange,
        floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef
    }));
}


/* smart-answer-card-dynamic-layout.tsx generated by @compiled/babel-plugin v2.0.0 */ 











































var $gmCV5 = parcelRequire("gmCV5");

var $kfIS7 = parcelRequire("kfIS7");



































/* dynamic-layout.tsx generated by @compiled/babel-plugin v2.0.0 */ 











var $bMS22 = parcelRequire("bMS22");

const $fb2afea4934d8744$var$CITATION_REGEX = /\[\^(\d+)\^\]/g;
function $fb2afea4934d8744$export$6fdccd51aa07b64f(modelOutput) {
    if (!modelOutput || typeof modelOutput !== 'string') return [];
    // Remove incomplete opening tags at the end (like "<section class="test" without closing >)
    let cleanedContent = modelOutput.replace(/<[^>]*$/, '');
    // Remove inline citation indicators from response for now
    // https://atlassian.slack.com/archives/C09KC9NV23W/p1769026048635919?thread_ts=1769020398.811119&cid=C09KC9NV23W
    cleanedContent = cleanedContent.replace($fb2afea4934d8744$var$CITATION_REGEX, '');
    // Remove unclosed carousel tags and their contents to prevent rendering children
    // before the carousel wrapper is complete (which causes visual flickering)
    const carouselOpenTags = cleanedContent.match(/<carousel[^>]*>/g);
    const carouselCloseTags = cleanedContent.match(/<\/carousel>/g);
    const hasUnclosedCarousel = (carouselOpenTags?.length || 0) > (carouselCloseTags?.length || 0);
    if (hasUnclosedCarousel) {
        // Find the last unclosed carousel and remove everything from that point onwards
        const lastCarouselIndex = cleanedContent.lastIndexOf('<carousel');
        if (lastCarouselIndex >= 0) cleanedContent = cleanedContent.substring(0, lastCarouselIndex);
    }
    try {
        const root = (0, $bMS22.parse)(cleanedContent);
        const body = root.querySelector('body') || root;
        const result = [];
        body.childNodes.forEach((element)=>{
            const jsonElement = $fb2afea4934d8744$var$elementToJson(element);
            if (jsonElement) result.push(jsonElement);
        });
        return result;
    } catch  {
        return [];
    }
}
function $fb2afea4934d8744$var$elementToJson(element) {
    // node types: https://dom.spec.whatwg.org/#dom-node-nodetype
    if (element.nodeType === 3) {
        // text node
        const text = element.text.trim();
        return text ? text : null;
    }
    // not an element node: https://dom.spec.whatwg.org/#dom-node-nodetype
    if (element.nodeType !== 1) return null;
    const htmlElement = element; // text node already processed
    const result = {
        tag: htmlElement.tagName.toLowerCase()
    };
    // Add attributes if they exist
    if (htmlElement.attributes && Object.keys(htmlElement.attributes).length > 0 && typeof result !== 'string') result.attributes = htmlElement.attributes;
    // Process children
    const children = [];
    htmlElement.childNodes.forEach((child)=>{
        // handles text + element nodes
        const childJson = $fb2afea4934d8744$var$elementToJson(child);
        if (childJson) children.push(childJson);
    });
    if (children.length > 0 && typeof result !== 'string') result.children = children;
    return result;
}


/* dynamic-layout-sections.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $k12R1 = parcelRequire("k12R1");








function $34b0857017e74170$export$52e6c7c72e88442f(element) {
    return typeof element !== 'string' && element.tag === 'h';
}


/* dynamic-layout-foldable-section.tsx generated by @compiled/babel-plugin v2.0.0 */ 



























/* dynamic-layout-carousel.tsx generated by @compiled/babel-plugin v2.0.0 */ 












var $kHija = parcelRequire("kHija");




















/* dynamic-layout-person-card.tsx generated by @compiled/babel-plugin v2.0.0 */ 




















const $336cb91c39b130b1$var$PersonCarouselCardStyles = {
    personCardContainer: "_0bjKvD8fU6 _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0aFT5vbt8w _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _1EqgXlHakr _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _1eOmH6o126",
    contactInfoSection: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _2XsHFM2ADO _4ouGXIdnbC _39HuIbz8Lp"
};
const $336cb91c39b130b1$export$da7d0a1972db5125 = ({ component: component })=>{
    const personAttributes = component.attributes;
    const { name: name, job_title: job_title, avatar_url: avatar_url, url: url } = personAttributes || {};
    const context = (0, $3hVWe.useAIAnswerContext)();
    const { handleSmartCardClick: handleSmartCardClick } = (0, $280875adc8c5626f$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context,
        isCitation: true
    });
    const handleClick = ()=>{
        handleSmartCardClick({
            sourceCardType: 'person-card',
            index: 0,
            source: null
        });
    };
    if (!url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: url,
        xcss: $336cb91c39b130b1$var$PersonCarouselCardStyles.personCardContainer,
        testId: "dynamic-layout-person-card",
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "circle",
        src: avatar_url || '',
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $336cb91c39b130b1$var$PersonCarouselCardStyles.contactInfoSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "medium",
        maxLines: 1
    }, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 1
    }, job_title)))));
};


/* dynamic-layout-smart-link.tsx generated by @compiled/babel-plugin v2.0.0 */ 












var $2vPXD = parcelRequire("2vPXD");


const $9ade015352caca2d$var$styles = {
    smartLink: "_39xV02ax1H"
};
/**
 * Convert SmartLinkElement to KnowledgeCardSource format
 */ function $9ade015352caca2d$var$convertToKnowledgeCardSource(component, resolvedData) {
    const url = component.attributes?.url || '';
    const title = component.attributes?.title;
    return {
        id: resolvedData?.['@id'] || url,
        title: title || resolvedData?.name || url,
        url: url,
        product: resolvedData?.generator?.name || null,
        type: resolvedData?.['@type'] || 'link',
        iconUrl: resolvedData?.generator?.icon?.url || null,
        lastModified: resolvedData?.dateModified || null,
        spaceName: null,
        spaceUrl: null,
        ari: resolvedData?.ari
    };
}
const $9ade015352caca2d$export$5c7864f9e8929faf = ({ component: component, variant: variant })=>{
    const url = component.attributes?.url || '';
    const isActionCard = component.attributes?.type === 'action';
    const effectiveVariant = isActionCard ? (0, $aUgOE.CardVariant).ACTION_CARD : variant;
    const { objectResolverData: objectResolverData } = (0, $2vPXD.useFetchSmartLinkData)({
        urls: [
            url
        ]
    });
    const resolvedData = objectResolverData?.[0];
    const source = $9ade015352caca2d$var$convertToKnowledgeCardSource(component, resolvedData);
    const context = (0, $3hVWe.useAIAnswerContext)();
    const { handleSmartCardClick: handleSmartCardClick, searchSessionId: searchSessionId } = (0, $280875adc8c5626f$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context,
        isCitation: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "dynamic-layout-smart-link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aUgOE.KnowledgeSmartCard), {
        source: source,
        variant: effectiveVariant,
        searchSessionId: searchSessionId,
        onClickHandler: handleSmartCardClick
    }));
};
const $9ade015352caca2d$export$6615cf55452a9648 = ({ component: component, variant: variant })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $9ade015352caca2d$var$styles.smartLink
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9ade015352caca2d$export$5c7864f9e8929faf, {
        component: component,
        variant: variant
    }));
};


/* dynamic-layout-project-highlight-card.tsx generated by @compiled/babel-plugin v2.0.0 */ 












const $f1a17e7e381eb12e$var$styles = {
    container: "_0bjKvD8fU6 _3vBAKH9r67 _2V7sgONvrM _3hxITi6wH8 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    summaryBox: "_1EqgXlPIoL"
};
const $f1a17e7e381eb12e$export$8c4de62228787a7c = ({ component: component })=>{
    const title = component?.attributes?.title || '';
    const text = component?.attributes?.content || '';
    return title || text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: (0, $w6R6I.cx)($f1a17e7e381eb12e$var$styles.container),
        space: "space.200",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050",
        xcss: $f1a17e7e381eb12e$var$styles.summaryBox
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        size: "medium",
        maxLines: 1
    }, title), text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest",
        maxLines: 1
    }, text))) : null;
};


const $006178f92ae20728$var$carouselCardWidth = 355; // card width (300px) + gap (space.200 = 16px)
const $006178f92ae20728$var$scrollWidth = ($006178f92ae20728$var$carouselCardWidth + 46) * 2;
const $006178f92ae20728$var$styles = {
    carouselStyles: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLchRC _1mT5xdRAKS _0aFT5vbt8w _39xV02N91d",
    carouselStylesSingleRow: "_3iDTPbQ4SZ _0hPCNLchRC _1mT5xdRAKS _0aFT5vbt8w _39xV02N91d _313842UgYP",
    scrollContainerStyles: "_4bt5LAIZbP _2WAcuGnQyn _3iDTPbvLZJ _39xV02N91d _3oUqlsYbGa _3h2tDz3EvU",
    scrollContainerNoScroll: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _39xV02N91d",
    cardContainerOneItem: "_2mHwu85zaO _3iDTPbgBM8 _2iEGP2UfmU",
    cardContainerTwoItems: "_2mHwu85zaO _3iDTPbgBM8 _2iEGP2Lmr7",
    cardContainerThreePlusItems: "_2mHwu85zaO _3iDTPbgBM8 _2iEGP2LaoX _293iXKbt8w _3kOVpyUfmU",
    carouselItemStyles: "_4ouGXIGNMc _1EqgXlwBC3",
    carouselItemStylesFoldable: "_4ouGXI71Z1 _1EqgXlqy1Q"
};
const $006178f92ae20728$var$CarouselItemRenderer = ({ child: child, isFoldable: isFoldable })=>{
    const isPeopleCard = typeof child !== 'string' && child.tag === 'people-card';
    const isSmartLink = typeof child !== 'string' && child.tag === 'smart-link';
    const isProjectHighlight = typeof child !== 'string' && child.tag === 'project-highlight-card';
    if (isPeopleCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "carousel-item-people-card",
        xcss: isFoldable ? $006178f92ae20728$var$styles.carouselItemStylesFoldable : $006178f92ae20728$var$styles.carouselItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $336cb91c39b130b1$export$da7d0a1972db5125), {
        component: child
    }));
    if (isSmartLink) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "carousel-item-smart-link",
        xcss: isFoldable ? $006178f92ae20728$var$styles.carouselItemStylesFoldable : $006178f92ae20728$var$styles.carouselItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ade015352caca2d$export$5c7864f9e8929faf), {
        component: child,
        variant: (0, $aUgOE.CardVariant).COMPACT
    }));
    if (isProjectHighlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "carousel-item-project-highlight-card",
        xcss: isFoldable ? $006178f92ae20728$var$styles.carouselItemStylesFoldable : $006178f92ae20728$var$styles.carouselItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1a17e7e381eb12e$export$8c4de62228787a7c), {
        component: child
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null);
};
const $006178f92ae20728$var$isScrollAtLeft = (elem)=>elem?.scrollLeft === 0;
const $006178f92ae20728$var$isScrollAtRight = (elem)=>elem ? Math.abs(elem?.scrollWidth - elem?.scrollLeft - elem?.clientWidth) <= 1 : false;
const $006178f92ae20728$export$53535a62c6d2f77b = ({ component: component, position: position, showArrows: showArrows = true, isFoldable: isFoldable = false })=>{
    const scrollContainerRef = (0, $cozmU.useRef)(null);
    const [hideLeftScroll, setHideLeftScroll] = (0, $cozmU.useState)(true);
    const [hideRightScroll, setHideRightScroll] = (0, $cozmU.useState)(false); // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key_id = (0, $cozmU.useRef)((0, $kHija.v4)());
    const carouselChildren = component.children || [];
    const shouldAlignHeader = position === 'single-column';
    const updateArrowVisibility = (0, $cozmU.useCallback)(()=>{
        if (scrollContainerRef.current) {
            setHideLeftScroll($006178f92ae20728$var$isScrollAtLeft(scrollContainerRef.current));
            setHideRightScroll($006178f92ae20728$var$isScrollAtRight(scrollContainerRef.current));
        }
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (scrollContainer && carouselChildren.length) {
            updateArrowVisibility();
            const unbind = (0, $cbY7C.bind)(scrollContainer, {
                type: 'scroll',
                listener: updateArrowVisibility
            });
            return unbind;
        }
    }, [
        carouselChildren.length,
        updateArrowVisibility
    ]);
    const onScroll = (0, $5Sv3D.default)(()=>{
        updateArrowVisibility();
    }, 30);
    const scrollLeft = ()=>{
        if (scrollContainerRef.current) scrollContainerRef.current.scrollLeft -= $006178f92ae20728$var$scrollWidth;
    };
    const scrollRight = ()=>{
        if (scrollContainerRef.current) scrollContainerRef.current.scrollLeft += $006178f92ae20728$var$scrollWidth;
    };
    if (!carouselChildren || carouselChildren.length < 2) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $k12R1.cx)(shouldAlignHeader ? $006178f92ae20728$var$styles.carouselStylesSingleRow : $006178f92ae20728$var$styles.carouselStyles),
        testId: "dynamic-layout-carousel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        grow: "fill",
        alignBlock: "center"
    }, !shouldAlignHeader && component.attributes?.title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold",
        size: "small",
        color: "color.text.accent.gray",
        testId: "carousel-title"
    }, component.attributes?.title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null), showArrows && (!hideLeftScroll || !hideRightScroll) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        label: "scroll left",
        onClick: scrollLeft,
        shape: "circle",
        appearance: "subtle",
        spacing: "compact",
        isDisabled: hideLeftScroll
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
        label: "scroll right",
        onClick: scrollRight,
        shape: "circle",
        appearance: "subtle",
        spacing: "compact",
        isDisabled: hideRightScroll
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: carouselChildren.length <= 3 ? $006178f92ae20728$var$styles.scrollContainerNoScroll : $006178f92ae20728$var$styles.scrollContainerStyles,
        ref: scrollContainerRef,
        onScroll: onScroll,
        tabIndex: carouselChildren.length > 3 ? 0 : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: carouselChildren.length === 1 ? $006178f92ae20728$var$styles.cardContainerOneItem : carouselChildren.length === 2 ? $006178f92ae20728$var$styles.cardContainerTwoItems : $006178f92ae20728$var$styles.cardContainerThreePlusItems
    }, carouselChildren.map((child, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($006178f92ae20728$var$CarouselItemRenderer, {
            key: `${key_id}-${index}`,
            child: child,
            index: index,
            isFoldable: isFoldable
        })))));
};


/* dynamic-layout-list.tsx generated by @compiled/babel-plugin v2.0.0 */ 












var $hMaHH = parcelRequire("hMaHH");


var $hQhpy = parcelRequire("hQhpy");


var $60Yxm = parcelRequire("60Yxm");
























const $c44b5563d5e5dc2c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    dynamic_layout_list_project_status_merged: {
        id: "search_ai.dynamic_layout_list_project_status_merged",
        defaultMessage: "Merged"
    },
    dynamic_layout_list_see_more: {
        id: "search_ai.dynamic_layout_list_see_more",
        defaultMessage: "See more"
    },
    dynamic_layout_list_see_less: {
        id: "search_ai.dynamic_layout_list_see_less",
        defaultMessage: "See less"
    }
});


const $44de46e11ee5730b$var$styles = {
    documentWrapper: "_1mT5xdRAKS _0Am33zKxmn _1eOmH6qWX3",
    invisibleLinkWrapper: "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _39xV02N91d _0jFU0VN91d _3CkH9oYbGa _0KLXrujOvk _034jHtYbGa _42Yu6B7dHp",
    pageIconWrapper: "_0bjKvDKxmn _0jFU0VUofl _39xV02Uofl _24h04i2Njc _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0KLXruDMqu",
    documentMetadataIconWrapper: "_313842Ll21 _0jFU0VxpxF _39xV02xpxF",
    listDocumentWrapper: "_39xV02N91d",
    showMoreButtonWrapper: "_39xV02FFh0"
};
const $44de46e11ee5730b$var$MAX_VISIBLE_DOCS = 3;
const $44de46e11ee5730b$var$InvisibleLink = ({ name: name, url: url })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7vK9E.Anchor), {
        href: url,
        xcss: $44de46e11ee5730b$var$styles.invisibleLinkWrapper,
        "aria-label": name,
        tabIndex: -1
    });
const $44de46e11ee5730b$var$getDocumentIcon = (itemData)=>{
    if (itemData.url && itemData.url.includes('docs.google.com')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
        color: "var(--ds-icon-success, #6A9A23)",
        label: ""
    });
    if (itemData.url && itemData.url.includes('loom.com')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
        color: "var(--ds-icon-discovery, #AF59E1)",
        label: ""
    });
    if (itemData.url && (itemData.url.includes('bitbucket.org') || itemData.url.includes('github.com'))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))), {
        color: "var(--ds-icon-accent-green, #22A06B)",
        label: ""
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
        color: "var(--ds-icon-brand, #1868DB)",
        label: ""
    });
};
const $44de46e11ee5730b$var$DynamicLayoutListItem = ({ itemData: itemData })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $44de46e11ee5730b$var$styles.documentWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44de46e11ee5730b$var$InvisibleLink, {
        name: itemData.name,
        url: itemData.url
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $44de46e11ee5730b$var$styles.pageIconWrapper
    }, $44de46e11ee5730b$var$getDocumentIcon(itemData)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "large",
        maxLines: 1
    }, itemData.name), itemData['atlassian:state'] === 'MERGED' && // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "success",
        isBold: true
    }, formatMessage((0, $c44b5563d5e5dc2c$export$defe85febe8b728c).dynamic_layout_list_project_status_merged))), itemData.generator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $44de46e11ee5730b$var$styles.documentMetadataIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: itemData.generator.icon?.url,
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small",
        maxLines: 1
    }, itemData.generator.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, "\u2022"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, itemData.attributedTo?.name)))));
};
const $44de46e11ee5730b$export$ad60ebd47efcfb81 = ({ component: component })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [listExpanded, setListExpanded] = (0, $cozmU.useState)(false);
    const listChildrenUrls = (0, $cozmU.useMemo)(()=>(component.children || []).map((listChild)=>listChild.attributes?.url || '').filter((url)=>!!url), [
        component.children
    ]);
    const { objectResolverData: objectResolverData } = (0, $2vPXD.useFetchSmartLinkData)({
        urls: listChildrenUrls
    });
    const showMoreButtonVisible = objectResolverData.length > $44de46e11ee5730b$var$MAX_VISIBLE_DOCS;
    const numVisibleDocs = listExpanded ? objectResolverData.length : $44de46e11ee5730b$var$MAX_VISIBLE_DOCS;
    return objectResolverData.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $44de46e11ee5730b$var$styles.listDocumentWrapper,
        testId: "dynamic-layout-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, objectResolverData.slice(0, numVisibleDocs).map((data, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44de46e11ee5730b$var$DynamicLayoutListItem, {
            itemData: data,
            key: idx
        })), showMoreButtonVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $44de46e11ee5730b$var$styles.showMoreButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        onClick: ()=>setListExpanded(!listExpanded),
        spacing: "compact"
    }, listExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $c44b5563d5e5dc2c$export$defe85febe8b728c).dynamic_layout_list_see_less)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $c44b5563d5e5dc2c$export$defe85febe8b728c).dynamic_layout_list_see_more)))))) : null;
};









var $3BY7M = parcelRequire("3BY7M");




const $1c53213988b4b655$export$a75e4056105f395f = ({ component: component })=>{
    const markdown = component.children?.[0];
    const docContent = (0, $cozmU.useMemo)(()=>markdown ? (0, $6rwn6.encodeAdf)(markdown, false) : undefined, [
        markdown
    ]);
    return docContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "dynamic-layout-markdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3BY7M.default), {
        document: docContent
    })) : null;
};













const $19fb9eea97e4f476$var$PROJECT_HIGHLIGHTS_SUB_AGENT_NAME = 'PROJECT_HIGHLIGHTS';
const $19fb9eea97e4f476$export$86abf3cfc73e361f = ()=>{
    const { loading: loading, dynamicLayoutSubAgentMessages: dynamicLayoutSubAgentMessages } = (0, $3hVWe.useAIAnswerContext)();
    const projectHighlightsMessage = (0, $cozmU.useMemo)(()=>{
        return $19fb9eea97e4f476$var$getSubAgentMessage(dynamicLayoutSubAgentMessages, $19fb9eea97e4f476$var$PROJECT_HIGHLIGHTS_SUB_AGENT_NAME);
    }, [
        dynamicLayoutSubAgentMessages
    ]);
    const carouselData = (0, $cozmU.useMemo)(()=>{
        if (!projectHighlightsMessage?.data || projectHighlightsMessage?.data === 'No Data Found') return null;
        try {
            const projectData = JSON.parse(projectHighlightsMessage.data);
            const children = projectData.highlights.map((highlight)=>({
                    tag: 'project-highlight-card',
                    attributes: {
                        title: highlight.title,
                        content: highlight.content
                    }
                }));
            const carouselComponent = {
                tag: 'carousel',
                children: children
            };
            return carouselComponent;
        } catch (error) {
            return null;
        }
    }, [
        projectHighlightsMessage?.data
    ]);
    if (loading && !projectHighlightsMessage?.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "200px",
        height: "16px",
        isShimmering: true
    });
    if (!projectHighlightsMessage?.data || projectHighlightsMessage?.data === 'No Data Found') return null;
    if (!carouselData) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $006178f92ae20728$export$53535a62c6d2f77b), {
        component: carouselData,
        position: "two-rows-bottom",
        showArrows: false
    });
};
const $19fb9eea97e4f476$var$getSubAgentMessage = (messages, subAgentName)=>{
    return messages.find((message)=>message.sub_agent_name === subAgentName);
};















const $a65d0b6a1e8182d7$var$RELATED_PEOPLE_SUB_AGENT_NAME = 'ENTITY_RELATED_PEOPLE';
const $a65d0b6a1e8182d7$export$2f4dfd3f449abf1b = ()=>{
    const { loading: loading, dynamicLayoutSubAgentMessages: dynamicLayoutSubAgentMessages } = (0, $3hVWe.useAIAnswerContext)();
    const relatedPeopleMessage = (0, $cozmU.useMemo)(()=>{
        return $a65d0b6a1e8182d7$var$getSubAgentMessage(dynamicLayoutSubAgentMessages, $a65d0b6a1e8182d7$var$RELATED_PEOPLE_SUB_AGENT_NAME);
    }, [
        dynamicLayoutSubAgentMessages
    ]);
    const carouselData = (0, $cozmU.useMemo)(()=>{
        if (!relatedPeopleMessage?.data || relatedPeopleMessage?.data === 'No Data Found') return null;
        try {
            const peopleData = JSON.parse(relatedPeopleMessage.data);
            const children = peopleData.people.map((person)=>({
                    tag: 'people-card',
                    attributes: {
                        name: person.name,
                        job_title: person.jobTitle,
                        avatar_url: person.avatarUrl,
                        url: person.url
                    }
                }));
            const carouselComponent = {
                tag: 'carousel',
                attributes: {
                    title: 'Related People'
                },
                children: children
            };
            return carouselComponent;
        } catch (error) {
            (0, $cuvLu.logger).error({
                error: error,
                functionName: 'carouselData'
            });
            return null;
        }
    }, [
        relatedPeopleMessage?.data
    ]);
    if (loading && !relatedPeopleMessage?.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "200px",
        height: "16px",
        isShimmering: true
    });
    if (!relatedPeopleMessage?.data || relatedPeopleMessage?.data === 'No Data Found') return null;
    if (!carouselData) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $006178f92ae20728$export$53535a62c6d2f77b), {
        component: carouselData,
        position: "two-rows-bottom"
    });
};
const $a65d0b6a1e8182d7$var$getSubAgentMessage = (messages, subAgentName)=>{
    return messages.find((message)=>message.sub_agent_name === subAgentName);
};


const $cf9a43f0b0d93e55$export$84b484f69b67f84e = ({ component: component, position: position, isFoldable: isFoldable = false, variant: variant })=>{
    if (!component || typeof component !== 'string' && !component.tag) return null;
    if (typeof component !== 'string') switch(component.tag){
        case 'md':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1c53213988b4b655$export$a75e4056105f395f), {
                component: component
            });
        case 'list':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $44de46e11ee5730b$export$ad60ebd47efcfb81), {
                component: component
            });
        case 'smart-link':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ade015352caca2d$export$6615cf55452a9648), {
                component: component,
                variant: variant
            });
        case 'carousel':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $006178f92ae20728$export$53535a62c6d2f77b), {
                component: component,
                position: position,
                isFoldable: isFoldable
            });
        case 'action-card':
            {
                const actionCard = component;
                // Validate component has a url and convert to smart-link
                if (actionCard.attributes?.url) {
                    const smartLinkComponent = {
                        tag: 'smart-link',
                        attributes: {
                            url: actionCard.attributes.url,
                            title: actionCard.attributes?.title,
                            type: 'action',
                            pos: actionCard.attributes?.pos
                        }
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ade015352caca2d$export$6615cf55452a9648), {
                        component: smartLinkComponent,
                        variant: variant
                    });
                }
                return null;
            }
        case 'related-people':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a65d0b6a1e8182d7$export$2f4dfd3f449abf1b), null);
        case 'project-highlights':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $19fb9eea97e4f476$export$86abf3cfc73e361f), null);
        default:
            return null;
    }
    return null;
};


const $0741daaf14376927$var$REQUIRED_ELEMENTS_COUNT = 1;
const $0741daaf14376927$export$1a9cda7e8be08d8 = ({ elements: elements, isFoldable: isFoldable = false })=>{
    if (elements.length < $0741daaf14376927$var$REQUIRED_ELEMENTS_COUNT) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf9a43f0b0d93e55$export$84b484f69b67f84e), {
        component: elements[0],
        position: "single-column",
        isFoldable: isFoldable
    });
};


const $02d37fec4a3fe277$var$unboundedStyles = {
    root: "_3138425zaO _39xV02N91d",
    contentWrapper: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w",
    contentExpanded: "_0NUa3r4DOi",
    contentCollapsed: "_4bt5LAnQyn _2WAcuGnQyn _0NUa3r9LX5 _3iDTPbgJ9S _1U1ZhbbI28 _4Gn54R7dHp",
    pointer: "_0wOv4Q7zJH"
};
const $02d37fec4a3fe277$var$styles = {
    divider: "_2IVJ4M6wH8 _22sfPnNvrM _3zygPU9r67 _3138425zaO",
    headerWrapper: "_1DCdHi2ADO"
};
const $02d37fec4a3fe277$export$1f15b0b67d49b0f6 = ({ defaultFoldedState: defaultFoldedState, header: header, content: content, children: children })=>{
    const containerRef = (0, $cozmU.useRef)(null);
    const [isFolded, setIsFolded] = (0, $cozmU.useState)(defaultFoldedState === 'collapsed');
    const sectionKey = `folded-section-${header?.children || ''}`;
    const handleKeyDown = (event)=>{
        if ((event.key === 'Enter' || event.key === ' ') && isFolded) {
            event.preventDefault();
            setIsFolded(false);
        }
    };
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": "dynamic-layout-foldable-section",
        className: (0, $hekY6.default)([
            $02d37fec4a3fe277$var$unboundedStyles.root,
            isFolded && $02d37fec4a3fe277$var$unboundedStyles.pointer
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        icon: isFolded ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))),
        label: `${isFolded ? 'expand' : 'collapsed'} section`,
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setIsFolded(!isFolded),
        testId: isFolded ? 'expand-button' : 'collapse-button',
        "aria-expanded": !isFolded
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        ref: containerRef,
        onClick: ()=>setIsFolded(false),
        onKeyDown: handleKeyDown,
        tabIndex: 0,
        role: "button",
        "data-testid": "dynamic-layout-foldable-clickable-section",
        className: (0, $hekY6.default)([
            $02d37fec4a3fe277$var$unboundedStyles.contentWrapper,
            isFolded ? $02d37fec4a3fe277$var$unboundedStyles.contentCollapsed : $02d37fec4a3fe277$var$unboundedStyles.contentExpanded
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        xcss: $02d37fec4a3fe277$var$styles.headerWrapper
    }, header && header.attributes?.show !== 'false' && content && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "bold"
    }, header && header.children)), isFolded ? /*#__PURE__*/ $cozmU.createElement((0, $0741daaf14376927$export$1a9cda7e8be08d8), {
        key: `${sectionKey}-collapsed`,
        elements: content
    }) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        key: `${sectionKey}-expanded`
    }, children))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $02d37fec4a3fe277$var$styles.divider
    }));
};



/* two-column-layout.tsx generated by @compiled/babel-plugin v2.0.0 */ 















const $4539e8c6f4231931$export$7cd3afc49691a77e = (elements, position, defaultIndex)=>{
    const result = [];
    for(let i = 0; i < elements.length; i++){
        const element = elements[i];
        if (typeof element === 'string') continue;
        if (element.attributes?.pos === position || i === defaultIndex && !element.attributes?.pos) result.push(element);
    }
    return result;
};


// Tags that represent text content
const $903a9b88cd0e7cbe$var$TEXT_CONTENT_TAGS = [
    'md',
    'list'
];
// Tags that represent smart links
const $903a9b88cd0e7cbe$var$SMART_LINK_TAGS = [
    'smart-link',
    'action-card'
];
// Max height of a full-size smart link card
const $903a9b88cd0e7cbe$var$FULL_SMART_LINK_CARD_MAX_HEIGHT = 174;
const $903a9b88cd0e7cbe$export$88261377d3b4456a = $903a9b88cd0e7cbe$var$FULL_SMART_LINK_CARD_MAX_HEIGHT * 0.75;
/**
 * Check if an element is text content (markdown or list)
 */ const $903a9b88cd0e7cbe$var$isTextContent = (element)=>typeof element !== 'string' && $903a9b88cd0e7cbe$var$TEXT_CONTENT_TAGS.includes(element.tag);
/**
 * Check if an element is a smart link
 */ const $903a9b88cd0e7cbe$var$isSmartLink = (element)=>typeof element !== 'string' && $903a9b88cd0e7cbe$var$SMART_LINK_TAGS.includes(element.tag);
function $903a9b88cd0e7cbe$export$e6011e70d0aef97f(elements) {
    const textContentRef = (0, $cozmU.useRef)(null);
    const [textHeight, setTextHeight] = (0, $cozmU.useState)(null);
    // Measure text content height after render
    const handleResize = (0, $cozmU.useCallback)((entries)=>{
        const entry = entries[0];
        if (entry) setTextHeight(entry.contentRect.height);
    }, []);
    (0, $1dee242400437624$export$fd29db098e42c3fc)(textContentRef, handleResize);
    // Separate elements by position
    const leftElements = (0, $4539e8c6f4231931$export$7cd3afc49691a77e)(elements, 'left', 0);
    const rightElements = (0, $4539e8c6f4231931$export$7cd3afc49691a77e)(elements, 'right', 1);
    // Determine which column has text content and which has smart links
    const leftHasText = leftElements.some($903a9b88cd0e7cbe$var$isTextContent);
    const rightHasSmartLink = rightElements.some($903a9b88cd0e7cbe$var$isSmartLink);
    const leftHasSmartLink = leftElements.some($903a9b88cd0e7cbe$var$isSmartLink);
    const rightHasText = rightElements.some($903a9b88cd0e7cbe$var$isTextContent);
    // Determine card variant based on measured text height
    // Default to compact card and when text content is shorter than 75% of the full-size smart card height
    const isTextMeasured = textHeight !== null;
    const useCompactCard = !isTextMeasured || isTextMeasured && textHeight <= $903a9b88cd0e7cbe$export$88261377d3b4456a;
    const cardVariant = useCompactCard ? (0, $aUgOE.CardVariant).COMPACT : (0, $aUgOE.CardVariant).FULL;
    // Determine which column should have the ref for measurement
    // Left column takes precedence when both columns would need measurement
    // (since only one ref can be attached at a time)
    const leftNeedsMeasurement = leftHasText && rightHasSmartLink;
    const rightNeedsMeasurement = rightHasText && leftHasSmartLink && !leftNeedsMeasurement;
    return {
        textContentRef: textContentRef,
        isTextMeasured: isTextMeasured,
        cardVariant: cardVariant,
        leftNeedsMeasurement: leftNeedsMeasurement,
        rightNeedsMeasurement: rightNeedsMeasurement,
        leftElements: leftElements,
        rightElements: rightElements
    };
}


const $6c6065832086e0f6$var$styles = {
    leftColumnStyles: "_2O5Vij7dHp _3YEZNO7dHp _4ouGXIdnbC",
    rightColumnStyles: "_3YEZNOdnbC _4ouGXIdnbC"
};
const $6c6065832086e0f6$var$REQUIRED_ELEMENTS_COUNT = 1;
const $6c6065832086e0f6$var$getElementKey = ({ key: key, pos: pos, index: index })=>{
    if (key && pos) return `${key}-${pos}-${index}`;
    if (key) return `${key}-${index}`;
    if (pos) return `${pos}-${index}`;
    return index;
};
const $6c6065832086e0f6$export$db5b24d9942615e8 = ({ elements: elements, key: key, isFoldable: isFoldable = false })=>{
    const { textContentRef: textContentRef, leftNeedsMeasurement: leftNeedsMeasurement, rightNeedsMeasurement: rightNeedsMeasurement, leftElements: leftElements, rightElements: rightElements, cardVariant: cardVariant } = (0, $903a9b88cd0e7cbe$export$e6011e70d0aef97f)(elements);
    if (elements.length < $6c6065832086e0f6$var$REQUIRED_ELEMENTS_COUNT) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.200",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6c6065832086e0f6$var$styles.leftColumnStyles,
        ref: leftNeedsMeasurement ? textContentRef : undefined,
        testId: "two-column-layout-left"
    }, leftElements.map((element, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf9a43f0b0d93e55$export$84b484f69b67f84e), {
            component: element,
            position: "two-columns-left",
            key: $6c6065832086e0f6$var$getElementKey({
                key: key,
                pos: element.attributes?.pos,
                index: index
            }),
            isFoldable: isFoldable,
            variant: cardVariant
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $6c6065832086e0f6$var$styles.rightColumnStyles,
        ref: rightNeedsMeasurement ? textContentRef : undefined,
        testId: "two-column-layout-right"
    }, rightElements.map((element, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf9a43f0b0d93e55$export$84b484f69b67f84e), {
            component: element,
            position: "two-columns-right",
            key: $6c6065832086e0f6$var$getElementKey({
                key: key,
                pos: element.attributes?.pos,
                index: index
            }),
            isFoldable: isFoldable,
            variant: cardVariant
        }))));
};


/* two-row-layout.tsx generated by @compiled/babel-plugin v2.0.0 */ 









const $fec5cdbb37c3f18a$var$styles = {
    rowStyle: "_39xV02N91d"
};
const $fec5cdbb37c3f18a$var$REQUIRED_ELEMENTS_COUNT = 1;
const $fec5cdbb37c3f18a$var$getElementKey = ({ key: key, pos: pos, index: index })=>{
    if (key && pos) return `${key}-${pos}-${index}`;
    if (key) return `${key}-${index}`;
    if (pos) return `${pos}-${index}`;
    return index;
};
const $fec5cdbb37c3f18a$export$1d297c974620e1b5 = ({ elements: elements, key: key, isFoldable: isFoldable = false })=>{
    if (elements.length < $fec5cdbb37c3f18a$var$REQUIRED_ELEMENTS_COUNT) return null;
    const topElements = (0, $4539e8c6f4231931$export$7cd3afc49691a77e)(elements, 'top', 0);
    const bottomElements = (0, $4539e8c6f4231931$export$7cd3afc49691a77e)(elements, 'bottom', 1);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $fec5cdbb37c3f18a$var$styles.rowStyle,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fec5cdbb37c3f18a$var$styles.rowStyle
    }, topElements.map((element, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf9a43f0b0d93e55$export$84b484f69b67f84e), {
            component: element,
            position: "two-rows-top",
            key: $fec5cdbb37c3f18a$var$getElementKey({
                key: key,
                pos: element.attributes?.pos,
                index: index
            }),
            isFoldable: isFoldable
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $fec5cdbb37c3f18a$var$styles.rowStyle
    }, bottomElements.map((element, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf9a43f0b0d93e55$export$84b484f69b67f84e), {
            component: element,
            position: "two-rows-bottom",
            key: $fec5cdbb37c3f18a$var$getElementKey({
                key: key,
                pos: element.attributes?.pos,
                index: index
            }),
            isFoldable: isFoldable
        }))));
};


const $af65131e8441cafa$var$styles = {
    overviewStyle: "_0bjKvD8fU6 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXrunmFW _1DCdHi5zaO",
    sectionWrapperStyles: "_313842NHnM"
};
const $af65131e8441cafa$export$62abb2537ec99d20 = ({ section: section, defaultFoldedState: defaultFoldedState })=>{
    const layout = section.attributes?.layout || 'one-column';
    const isOverview = section.attributes?.overview === '1';
    const isFoldable = section.attributes?.hasOwnProperty('folded');
    let header;
    let content;
    if (Array.isArray(section.children)) {
        const headerElement = section.children.filter((element)=>(0, $34b0857017e74170$export$52e6c7c72e88442f)(element));
        if (headerElement.length) header = headerElement[0];
        content = section.children?.filter((element)=>!(0, $34b0857017e74170$export$52e6c7c72e88442f)(element));
    }
    if (!content || content && !content.length) return null;
    const renderContent = ()=>{
        switch(layout){
            case 'one-column':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0741daaf14376927$export$1a9cda7e8be08d8), {
                    elements: content,
                    isFoldable: isFoldable
                });
            case 'two-columns':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c6065832086e0f6$export$db5b24d9942615e8), {
                    elements: content,
                    key: section.attributes?.n,
                    isFoldable: isFoldable
                });
            case 'two-rows':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fec5cdbb37c3f18a$export$1d297c974620e1b5), {
                    elements: content,
                    key: section.attributes?.n,
                    isFoldable: isFoldable
                });
        }
    };
    if (defaultFoldedState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $02d37fec4a3fe277$export$1f15b0b67d49b0f6), {
        defaultFoldedState: defaultFoldedState,
        header: header,
        content: content
    }, renderContent());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignInline: "start",
        xcss: (0, $k12R1.cx)(isOverview && $af65131e8441cafa$var$styles.overviewStyle),
        testId: "dynamic-layout-section",
        "data-layout": layout,
        "data-overview": isOverview
    }, header && header.attributes?.show !== 'false' && content && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        xcss: $af65131e8441cafa$var$styles.sectionWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, header && header.children)), renderContent());
};


const $1b9eacf08bc3ac89$export$8a161f487bc08d6e = (parsedAnswer)=>{
    let firstFoldableSectionIdx = -1;
    for(let i = 0; i < parsedAnswer.length; i++)if (parsedAnswer[i].attributes?.hasOwnProperty('folded')) {
        firstFoldableSectionIdx = i;
        break;
    }
    return firstFoldableSectionIdx;
};


const $d3a80726f3726740$var$styles = {
    containerStyles: "_2fwxA5ecOK"
};
const $d3a80726f3726740$export$21094bc4b0d39e4b = ({ contentToRender: contentToRender })=>{
    const parsedAnswer = (0, $fb2afea4934d8744$export$6fdccd51aa07b64f)(contentToRender);
    const firstFoldableIndex = (0, $1b9eacf08bc3ac89$export$8a161f487bc08d6e)(parsedAnswer);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d3a80726f3726740$var$styles.containerStyles,
        testId: "dynamic-layout-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, parsedAnswer && parsedAnswer.length && parsedAnswer.map((section, index)=>{
        const isFoldable = section.attributes?.hasOwnProperty('folded');
        const defaultFoldedState = isFoldable ? index === firstFoldableIndex ? 'expanded' : 'collapsed' : undefined;
        return(// TODO: rename this component to be singular
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af65131e8441cafa$export$62abb2537ec99d20), {
            key: index,
            section: section,
            defaultFoldedState: defaultFoldedState
        }));
    }))));
};


/* dynamic-layout-sources-dropdown.tsx generated by @compiled/babel-plugin v2.0.0 */ 











var $is1T6 = parcelRequire("is1T6");

var $9erVg = parcelRequire("9erVg");














const $d67afebeb1603797$var$messages = (0, $kSwu1.defineMessages)({
    sources_text: {
        id: "search_ai.dynamic_layout_sources_text",
        defaultMessage: "{numSources, plural, one {Source} other {Sources}}"
    },
    sources_group_title: {
        id: "search_ai.dynamic_layout_sources_group_title",
        defaultMessage: "{numSources, plural, one {{numSources, number} Source} other {{numSources, number} Sources}}"
    }
});
const $d67afebeb1603797$var$styles = {
    dropdownContent: "_1EqgXlHakr"
};
const $d67afebeb1603797$export$befc5243628631e7 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const context = (0, $3hVWe.useAIAnswerContext)();
    const { commonAttributes: commonAttributes } = context;
    const { sources: sources } = commonAttributes;
    const { handleSmartCardClick: handleSmartCardClick, searchSessionId: searchSessionId } = (0, $280875adc8c5626f$export$6be22f9840eb8748)({
        aiAnswerDialogContext: context
    });
    if (!sources || sources.length === 0) return null;
    const numSources = sources.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                ref: triggerRef,
                ...props
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f0122fe4f75fa739$export$ebff7094edd1bb81), {
                sources: sources
            }), formatMessage($d67afebeb1603797$var$messages.sources_text, {
                numSources: numSources
            }))),
        isOpen: isOpen,
        onOpenChange: (attrs)=>setIsOpen(attrs.isOpen)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d67afebeb1603797$var$styles.dropdownContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), {
        title: formatMessage($d67afebeb1603797$var$messages.sources_group_title, {
            numSources: numSources
        })
    }, sources.map((source, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: source.url || index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aUgOE.KnowledgeSmartCard), {
            source: source,
            variant: (0, $aUgOE.CardVariant).DROPDOWN_SOURCE,
            index: index,
            searchSessionId: searchSessionId,
            onClickHandler: handleSmartCardClick
        }))))));
};



















const $12ca716b9376ab26$var$styles = {
    fullWidth: "_39xV02qUim _1EqgXlN91d _2Zuz6Q8HPE _1Znuxb8HPE",
    container: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    interactive: "_0wOv4Q7zJH _0KLXru66of _39xV02N91d",
    expanded: "_0KLXru66of _39xV02N91d",
    root: "_4kiQYAk3g7",
    fullHeight: "_0jFU0VN91d",
    followUpChatInputSectionStyles: "_313842Va5s",
    disclaimerWrapperStyles: "_1wydGW8HPE _2Zuz6Q5zaO _2IVJ4M6wH8 _3zygPU9r67 _22sfPnNvrM",
    headerContainer: "_4kiQYAUF4f _1wydGW2ADO",
    loadingSkeletonContainer: "_3138425zaO _1DCdHi5zaO"
};
function $12ca716b9376ab26$var$SmartAnswerCardDynamicLayoutComponent({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, queryIntent: queryIntent }) {
    const [collapsed, setCollapsed] = (0, $cozmU.useState)(true);
    const [didUserTriggerCollapse, setDidUserTriggerCollapse] = (0, $cozmU.useState)(false);
    const [isVisibleTextComplete, setIsVisibleTextComplete] = (0, $cozmU.useState)(false);
    const [showAnimation, setShowAnimation] = (0, $cozmU.useState)(false);
    const componentRenderTimeRef = (0, $cozmU.useRef)(Date.now());
    const firstByteEventFiredRef = (0, $cozmU.useRef)(false);
    const { commonAttributes: commonAttributes, hasError: hasError, isAnswered: isAnswered, loading: loading, partialResponse: partialResponse, traceHeaders: traceHeaders } = (0, $3hVWe.useAIAnswerContext)();
    const { queryHash: queryHash, searchSessionId: searchSessionId, answerString: answerString, sources: sources, errorStateSuggestedQueries: errorStateSuggestedQueries } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const streamingText = partialResponse?.partialNlpResult ?? '';
    const [streamingTextToDisplay, setStreamingTextToDisplay] = (0, $cozmU.useState)(streamingText); // Refs for content truncation detection
    const isVisibleTextCompleteRef = (0, $cozmU.useRef)(false);
    const completeAnswerAnalyticsEventFiredRef = (0, $cozmU.useRef)(false);
    const renderedContentRef = (0, $cozmU.useRef)(null);
    const contentContainerRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (collapsed && !isVisibleTextComplete) setStreamingTextToDisplay(streamingText);
        else if (!collapsed) setStreamingTextToDisplay(streamingText);
    }, [
        collapsed,
        isVisibleTextComplete,
        streamingText
    ]); // Notify context when collapsed state changes
    (0, $cozmU.useEffect)(()=>{
        onAnswerExpandedChange?.(!collapsed);
    }, [
        collapsed,
        onAnswerExpandedChange
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !hasError && !isVisibleTextComplete) {
            setIsVisibleTextComplete(true);
            onFMPReached?.(); // Mark FMP as reached for cached answers
        }
    }, [
        loading,
        hasError,
        isVisibleTextComplete,
        onFMPReached
    ]); // Track if we should show animations (if loading or partialResponse are true)
    (0, $cozmU.useEffect)(()=>{
        if (!showAnimation && loading && partialResponse) setShowAnimation(true);
    }, [
        loading,
        partialResponse,
        showAnimation
    ]); // use useEffect to trigger analytics event in order to avoid needing to
    // pass commonAttributes as a dependency to handleExpandCollapseButtonClick
    // and thus avoid re-rendering SmartAnswerCardBodyStreaming with every
    // update to commonAttributes (which gets updated with the streamed text)
    (0, $cozmU.useEffect)(()=>{
        if (didUserTriggerCollapse) fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)(commonAttributes));
    }, [
        didUserTriggerCollapse,
        commonAttributes,
        fireAnalyticsEvent
    ]); // Detect if content is truncated when collapsed
    const isContentTruncated = (0, $6df3d09e09b61b24$export$d112da4490f261ea)(renderedContentRef, contentContainerRef, collapsed); // Complete answer analytics
    (0, $cozmU.useEffect)(()=>{
        // Only fire once and ensure DOM element is ready with meaningful content
        if (completeAnswerAnalyticsEventFiredRef.current || !renderedContentRef.current) return;
        const answerHeight = renderedContentRef.current.getBoundingClientRect().height;
        const containerHeight = contentContainerRef.current?.getBoundingClientRect().height ?? 0;
        const whitespaceHeight = Math.max(containerHeight - answerHeight, 0); // Only fire if we have meaningful height (content is rendered)
        if (answerHeight > 0 && containerHeight > 0) {
            fireAnalyticsEvent((0, $d58a262274d16c7a$export$f3109245f09f7746)({
                ...commonAttributes,
                answerHeight: answerHeight,
                containerHeight: containerHeight,
                whitespaceHeight: whitespaceHeight,
                queryIntent: queryIntent
            }));
            completeAnswerAnalyticsEventFiredRef.current = true;
        }
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        queryIntent,
        isContentTruncated
    ]); // SAIN usage event
    (0, $cozmU.useEffect)(()=>{
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        }); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleExpandCollapseButtonClick = (0, $cozmU.useCallback)(()=>{
        if (collapsed) {
            setCollapsed(false);
            setDidUserTriggerCollapse(false);
        } else {
            setCollapsed(true);
            setDidUserTriggerCollapse(true);
        }
    }, [
        collapsed
    ]);
    const handleVisibleTextComplete = (0, $cozmU.useCallback)(()=>{
        setIsVisibleTextComplete(true);
        onFMPReached?.(); // Mark FMP as reached for streaming answers
    }, [
        onFMPReached
    ]);
    const sourceClickCallback = (0, $cozmU.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source.product),
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent
    ]); // UFO resize observer for streaming
    const resizeObserverCallback = (0, $cozmU.useCallback)(()=>{
        if (!isVisibleTextCompleteRef.current && renderedContentRef.current && contentContainerRef.current) {
            const renderedContentRefHeight = renderedContentRef.current.getBoundingClientRect().height;
            const contentContainerRefHeight = contentContainerRef.current.getBoundingClientRect().height;
            const isVisibleTextComplete = renderedContentRefHeight > contentContainerRefHeight;
            if (isVisibleTextComplete) {
                handleVisibleTextComplete();
                isVisibleTextCompleteRef.current = true;
            }
        }
    }, [
        handleVisibleTextComplete
    ]); // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1dee242400437624$export$fd29db098e42c3fc)(renderedContentRef, resizeObserverCallback);
    const bufferedContent = (0, $d3e29575f8ad4c54$export$8f4f0a9c358684c2)(streamingTextToDisplay, isAnswered && !loading);
    (0, $cozmU.useEffect)(()=>{
        if (bufferedContent.length > 0 && !firstByteEventFiredRef.current) {
            fireAnalyticsEvent((0, $bd6e42147a6848a8$export$c68095583a3c17cc)({
                ...commonAttributes,
                timeToFirstByte: Date.now() - componentRenderTimeRef.current
            }));
            firstByteEventFiredRef.current = true;
        }
    }, [
        bufferedContent,
        commonAttributes,
        fireAnalyticsEvent
    ]); // Use answerString when complete, bufferedContent when streaming
    const contentToRender = isAnswered ? answerString : bufferedContent; // Experiments
    const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_sain_show_no_answer_suggestions_exp'
    });
    const showReadMoreButton = collapsed && isContentTruncated; // Single return statement with React component for main content
    const isStreaming = !isAnswered && (loading || loading === undefined); // Early return for error state
    if (hasError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $12ca716b9376ab26$var$styles.fullWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f366b75433df2895$export$ffa24cd7196ce1b0), null));
     // Early return for generating state
    if (!isAnswered && (loading || loading === undefined)) {
        if (!partialResponse || bufferedContent.length < 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $12ca716b9376ab26$var$styles.fullWidth
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aiIBH.SmartAnswerCardBodyGenerating), {
            heightOverride: (0, $7DMz5.SAINFeatureControl).isFullHeightLuminaEnabled() ? 'lumina' : undefined
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f420039341622608$export$8a1fad5d74d43878), {
            isStreaming: true,
            showMoreButtonVisible: false
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $12ca716b9376ab26$var$styles.fullWidth
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "search-ai-dialog-all-text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "search-ai-dialog-visible-text"
    }, isVisibleTextComplete ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "search-ai-dialog-visible-text-loading"
    }), (0, $iDrrr.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "queryHash",
        value: queryHash
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "searchSessionId",
        value: searchSessionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "queryIntent",
        value: queryIntent
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            queryIntent: queryIntent
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12ca716b9376ab26$export$3714848962bfb827, {
        isStreaming: isStreaming,
        collapsed: collapsed,
        isContentTruncated: isContentTruncated,
        showReadMoreButton: showReadMoreButton,
        handleExpandCollapseButtonClick: handleExpandCollapseButtonClick,
        contentContainerRef: contentContainerRef,
        renderedContentRef: renderedContentRef,
        sources: sources,
        searchSessionId: searchSessionId,
        sourceClickCallback: sourceClickCallback,
        errorStateSuggestedQueries: errorStateSuggestedQueries,
        serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp,
        commonAttributes: commonAttributes,
        contentToRender: contentToRender,
        showAnimation: showAnimation,
        traceHeaders: traceHeaders
    }))));
}
function $12ca716b9376ab26$export$3714848962bfb827({ isStreaming: isStreaming, collapsed: collapsed, isContentTruncated: isContentTruncated, showReadMoreButton: showReadMoreButton, handleExpandCollapseButtonClick: handleExpandCollapseButtonClick, contentContainerRef: contentContainerRef, renderedContentRef: renderedContentRef, errorStateSuggestedQueries: errorStateSuggestedQueries, serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp, commonAttributes: commonAttributes, contentToRender: contentToRender, traceHeaders: traceHeaders }) {
    const { dynamicLayoutSubAgentMessages: dynamicLayoutSubAgentMessages, userDetails: userDetails } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const handleLuminaEvent = (0, $cozmU.useCallback)((event)=>{
        if (event.payload.action === 'interacted' && event.payload.attributes.componentType === 'smartLink' && event.payload.attributes.interactionType === 'clicked') {
            const attributes = event.payload.attributes;
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
                commonAttributes: commonAttributes,
                sourceProduct: attributes.product ?? undefined
            });
        }
    }, [
        fireSAINUsageEvent,
        commonAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4217877a0025dc35$export$127e64693c41156a), {
        isCollapsed: collapsed && (isStreaming || isContentTruncated),
        onExpandCollapse: handleExpandCollapseButtonClick,
        ref: contentContainerRef,
        showReadMoreButton: showReadMoreButton,
        luminaAnswerType: "LUMINA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center",
        xcss: $12ca716b9376ab26$var$styles.headerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f0b2F))), {
        label: "AI Content",
        size: "medium"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h1",
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).smart_answer_card_dynamic_layout_title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d67afebeb1603797$export$befc5243628631e7), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: renderedContentRef,
        testId: "sain-fmp-target"
    }, (0, $iDrrr.fg)('kd_enable_lumina_package') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        channel: (0, $gmCV5.EVENT_CHANNEL),
        onEvent: handleLuminaEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kfIS7.LuminaLayout), {
        luminaTagResponse: contentToRender,
        luminaSubAgentResponse: dynamicLayoutSubAgentMessages,
        isStreaming: isStreaming,
        source: "luminaSAIN",
        traceId: traceHeaders?.['X-B3-TraceId'],
        spanId: traceHeaders?.['X-B3-SpanId'],
        cloudId: commonAttributes.cloudId,
        orgId: commonAttributes.orgId,
        requestingUserId: userDetails.id ?? '',
        sourceProduct: commonAttributes.sourceProduct
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d3a80726f3726740$export$21094bc4b0d39e4b), {
        contentToRender: contentToRender
    })), isStreaming && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200",
        xcss: $12ca716b9376ab26$var$styles.loadingSkeletonContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "16px",
        color: "var(--ds-skeleton-subtle, #17171708)",
        borderRadius: "var(--ds-radius-medium, 6px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "16px",
        color: "var(--ds-skeleton-subtle, #17171708)",
        borderRadius: "var(--ds-radius-medium, 6px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "75%",
        height: "16px",
        color: "var(--ds-skeleton-subtle, #17171708)",
        borderRadius: "var(--ds-radius-medium, 6px)"
    })))))), (showReadMoreButton || isStreaming) && (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f420039341622608$export$8a1fad5d74d43878), {
        isStreaming: isStreaming,
        showMoreButtonVisible: showReadMoreButton,
        onClickShowMoreButton: handleExpandCollapseButtonClick
    }), !isStreaming && (!collapsed || !showReadMoreButton || errorStateSuggestedQueries.length > 0 && serveErrorStateSuggestedQueriesExp) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        xcss: $12ca716b9376ab26$var$styles.followUpChatInputSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a921764ae1a692a7$export$f087ce3403d54eb5), {
        omitDialogues: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j8bJ5.OpenChatInputBox), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $12ca716b9376ab26$var$styles.disclaimerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: !isStreaming,
        showCopyButton: false,
        renderedContentRef: renderedContentRef
    }))) : null);
} // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
function $12ca716b9376ab26$export$b547d87531f467be({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange, queryIntent: queryIntent }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "smart-answer-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12ca716b9376ab26$var$SmartAnswerCardDynamicLayoutComponent, {
        onFMPReached: onFMPReached,
        onAnswerExpandedChange: onAnswerExpandedChange,
        queryIntent: queryIntent
    }));
}






var $iDdTC = parcelRequire("iDdTC");

const $a7513ed93542ee2f$export$a83a35d6598a5fb6 = (0, $iDdTC.metrics).pageSegmentLoad({
    key: 'ai-search-dialog'
});


/* ai-answer-default-loading-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 








var $6JxPX = parcelRequire("6JxPX");

const $28ffaa5aebbd61cc$export$476294a9cde8f045 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isReadingAids: isReadingAids, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_90kafy": (0, $9aYkv.default)((0, $6JxPX.grid).px)
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "",
            __cmplp.isReadingAids ? "_4FKVYENHnM _39xV02N91d _0jFU0VaXQy _24h04i2Njc" : "_39xV02aS7z _313842knUo",
            __cmplp.className
        ])
    });
});





/* definition-answer-card.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $57p4j = parcelRequire("57p4j");




















var $kYeKA = parcelRequire("kYeKA");







var $hsCD1 = parcelRequire("hsCD1");

/* DefinitionSources.tsx generated by @compiled/babel-plugin v2.0.0 */ 






































const $71f7b5ea8cb696e0$export$960f61383b799882 = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiSourceFetchSmartlinkData',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};





const $642b9c63e5969b23$var$OBJECT_RESOLVER_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';
const $642b9c63e5969b23$export$6d6d0aa8067b2c97 = ({ urls: urls })=>{
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const [objectResolverData, setObjectResolverData] = (0, $cozmU.useState)([]);
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const urlKeys = (0, $cozmU.useMemo)(()=>urls.join('|'), [
        urls
    ]);
    (0, $cozmU.useEffect)(()=>{
        const fetchObjectResolver = async ()=>{
            if (!urls.length) {
                setIsLoading(false);
                return;
            }
            try {
                const objectResolver = await (0, $jDZkE.fetchRestResponse)({
                    url: $642b9c63e5969b23$var$OBJECT_RESOLVER_ENDPOINT,
                    body: urls.map((url)=>({
                            resourceUrl: url
                        }))
                });
                if (!objectResolver) {
                    setIsLoading(false);
                    return;
                }
                const objectData = objectResolver.filter((obj)=>obj.status === 200);
                setObjectResolverData(objectData.map((objData)=>objData.body));
                setIsLoading(false);
            } catch (error) {
                if (error instanceof Object && 'message' in error) fireAnalyticsEvent((0, $71f7b5ea8cb696e0$export$960f61383b799882)(error, commonAttributes));
                setIsLoading(false);
            }
        };
        fetchObjectResolver();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        urlKeys
    ]);
    return {
        isLoading: isLoading,
        objectResolverData: objectResolverData
    };
};


/* DefinitionSource.tsx generated by @compiled/babel-plugin v2.0.0 */ 























const $3f3c55779d6f62ac$var$toTitleCase = (sourceCategory)=>sourceCategory.split(' ').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
const $3f3c55779d6f62ac$var$styles = {
    root: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8",
    sourceIconWrapperStyles: "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _39xV02ey7F _0jFU0Vey7F"
};
const $3f3c55779d6f62ac$export$c7fb9dc39c758aa3 = ({ sourceData: sourceData, index: index })=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3hVWe.useAIAnswerContext)();
    const is1PSource = sourceData.data.generator?.name === 'Confluence';
    const sourceMetadata = is1PSource ? sourceData.data.summary : sourceData.entityData?.type ? $3f3c55779d6f62ac$var$toTitleCase(sourceData.entityData.type.category) : undefined;
    const onClickSource = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: index,
            sourceProduct: sourceData.data.generator?.name.toLowerCase() || '',
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(sourceData.data.generator?.name),
            ...commonAttributes
        })); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fireAnalyticsEvent,
        commonAttributes
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $7vK9E.Anchor), {
        href: sourceData.data.url,
        xcss: $3f3c55779d6f62ac$var$styles.root,
        target: "_blank",
        onClick: onClickSource
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, sourceData.data.generator && /*#__PURE__*/ $cozmU.createElement((0, $1xWgP.AppIcon), {
        app: sourceData.data.generator.name.toLowerCase(),
        size: "xxsmall"
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text",
        maxLines: 1,
        weight: "medium"
    }, sourceData.data.name))), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        maxLines: 2,
        color: "color.text.subtle",
        size: "small"
    }, sourceMetadata))));
};


const $0c874a49d33f2b0f$var$messages = (0, $kSwu1.defineMessages)({
    definition_sources_stack_text: {
        id: "search_ai.definition_sources_stack_text",
        defaultMessage: "{numResolvedSources, plural, =1 {{numResolvedSources, number} Source} other {{numResolvedSources, number} Sources}}"
    },
    definition_source_stack_text: {
        id: "search_ai.definition_source_stack_text",
        defaultMessage: "source"
    }
});
const $0c874a49d33f2b0f$var$styles = {
    root: "_0Of8r22ADO _1Znuxb5zaO _2Zuz6Q5zaO _1wydGW2ADO",
    sourcesStackContainerStyles: "_0bjKvDKTcp _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _39xV02E6Kk _2Zuz6Q8HPE _1Znuxb8HPE _0Of8r2gVvo _1wydGWgVvo",
    dividerStyles: "_2IVJ4M6wH8 _22sfPnNvrM _3zygPU9r67"
};
const $0c874a49d33f2b0f$var$DEFINITION_MAX_SOURCES = 3;
const $0c874a49d33f2b0f$export$63e4658af6ffde25 = ({ sources: sources })=>{
    const [sourcesExpanded, setSourcesExpanded] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const sourcesUrls = sources.map((source)=>source.url).slice(0, $0c874a49d33f2b0f$var$DEFINITION_MAX_SOURCES);
    const { objectResolverData: objectResolverData } = (0, $642b9c63e5969b23$export$6d6d0aa8067b2c97)({
        urls: sourcesUrls
    });
    const numResolvedSources = objectResolverData.length;
    return numResolvedSources === 0 ? null : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $0c874a49d33f2b0f$var$styles.root
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        onClick: ()=>setSourcesExpanded(!sourcesExpanded)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $f0122fe4f75fa739$export$ebff7094edd1bb81), {
        maxSourcesInStack: $0c874a49d33f2b0f$var$DEFINITION_MAX_SOURCES,
        sources: sources.slice(0, numResolvedSources)
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, formatMessage($0c874a49d33f2b0f$var$messages.definition_sources_stack_text, {
        numResolvedSources: numResolvedSources
    })))), /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        onClick: ()=>setSourcesExpanded(!sourcesExpanded),
        icon: (iconProps)=>sourcesExpanded ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                ...iconProps,
                size: "small"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                ...iconProps,
                size: "small"
            }),
        appearance: "subtle",
        label: sourcesExpanded ? (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true) ? 'Collapse sources' : 'Collapse sources button' : (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true) ? 'Expand sources' : 'Expand sources button',
        testId: "definitions-sources-expand"
    })), sourcesExpanded && /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $0c874a49d33f2b0f$var$styles.dividerStyles
    }), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, objectResolverData.map((sourceData, idx)=>/*#__PURE__*/ $cozmU.createElement((0, $3f3c55779d6f62ac$export$c7fb9dc39c758aa3), {
            sourceData: sourceData,
            index: idx,
            key: `${sourceData.data.url}-${idx}`
        }))))));
};


/* loading-dot-wave.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $183b5c97f283e9b6$var$loadingDotWaveWrapperStyles = null;
const $183b5c97f283e9b6$export$c7f94e62a2f54f71 = ({ width: width, height: height = 15 })=>{
    const canvasRef = (0, $cozmU.useRef)(null);
    const dotsRef = (0, $cozmU.useRef)([]);
    const animationRef = (0, $cozmU.useRef)();
    const timeRef = (0, $cozmU.useRef)(0); // Calculate number of dots based on consistent spacing
    const dotRadius = 2;
    const idealSpacing = width < 18 ? 6 : 8.4;
    const availableWidth = width - dotRadius * 2;
    const maxDots = Math.floor(availableWidth / idealSpacing) + 1;
    const dotCount = Math.max(2, maxDots); // Initialize dots
    const initDots = (0, $cozmU.useCallback)(()=>{
        const dots = [];
        const centerY = height / 2; // Calculate available space for dots (subtract padding for dot radius on both sides)
        const availableWidth = width - 1 - dotRadius * 2;
        const spacing = dotCount > 1 ? availableWidth / (dotCount - 1) : 0;
        for(let i = 0; i < dotCount; i++)dots.push({
            x: dotRadius + i * spacing,
            // Start from dotRadius to avoid cutoff
            y: centerY,
            baseY: centerY,
            phase: i / dotCount * Math.PI * 2,
            size: dotRadius
        });
        return dots;
    }, [
        dotCount,
        height,
        width
    ]);
    // Gradient for dots
    const createGradient = (0, $cozmU.useCallback)((ctx, x)=>{
        const gradient = ctx.createRadialGradient(x, 0, 0, x, 0, dotRadius); // Calculate position along the available width for color interpolation
        const availableWidth = width - dotRadius * 2;
        const adjustedX = x - dotRadius;
        const position = availableWidth > 0 ? Math.max(0, Math.min(1, adjustedX / availableWidth)) : 0; // Create linear gradient with colors: #0065FF → #0267FF → #BF63F3 → #FFA900
        const colors = [
            {
                r: 0,
                g: 101,
                b: 255
            },
            // #0065FF
            {
                r: 2,
                g: 103,
                b: 255
            },
            // #0267FF
            {
                r: 191,
                g: 99,
                b: 243
            },
            // #BF63F3
            {
                r: 255,
                g: 169,
                b: 0
            }
        ];
        let color;
        if (position <= 0.33) {
            // Interpolate between #0065FF and #0267FF
            const localPos = position / 0.33;
            const color1 = colors[0];
            const color2 = colors[1];
            color = {
                r: Math.floor(color1.r + (color2.r - color1.r) * localPos),
                g: Math.floor(color1.g + (color2.g - color1.g) * localPos),
                b: Math.floor(color1.b + (color2.b - color1.b) * localPos)
            };
        } else if (position <= 0.66) {
            // Interpolate between #0267FF and #BF63F3
            const localPos = (position - 0.33) / 0.33;
            const color1 = colors[1];
            const color2 = colors[2];
            color = {
                r: Math.floor(color1.r + (color2.r - color1.r) * localPos),
                g: Math.floor(color1.g + (color2.g - color1.g) * localPos),
                b: Math.floor(color1.b + (color2.b - color1.b) * localPos)
            };
        } else {
            // Interpolate between #BF63F3 and #FFA900
            const localPos = (position - 0.66) / 0.34;
            const color1 = colors[2];
            const color2 = colors[3];
            color = {
                r: Math.floor(color1.r + (color2.r - color1.r) * localPos),
                g: Math.floor(color1.g + (color2.g - color1.g) * localPos),
                b: Math.floor(color1.b + (color2.b - color1.b) * localPos)
            };
        }
        gradient.addColorStop(0, `rgb(${color.r}, ${color.g}, ${color.b})`);
        gradient.addColorStop(1, `rgb(${Math.floor(color.r * 0.8)}, ${Math.floor(color.g * 0.8)}, ${Math.floor(color.b * 0.8)})`);
        return gradient;
    }, [
        width
    ]);
    // Animation loop
    const animate = (0, $cozmU.useCallback)(()=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        if (!ctx) return;
        // Clear canvas
        ctx.clearRect(0, 0, canvas.width, canvas.height); // Update time
        timeRef.current += 0.08; // Update and draw dots
        dotsRef.current.forEach((dot)=>{
            // Calculate wave motion
            const waveOffset = Math.sin(timeRef.current + dot.phase);
            dot.y = dot.baseY + waveOffset; // Apply gradient to this dot
            const gradient = createGradient(ctx, dot.x); // Draw dot
            ctx.beginPath();
            ctx.arc(dot.x, dot.y, dot.size, 0, Math.PI * 2);
            ctx.fillStyle = gradient;
            ctx.fill(); // Add subtle shadow
            ctx.shadowColor = 'rgba(0, 0, 0, 0.1)';
            ctx.shadowBlur = 2;
            ctx.shadowOffsetY = 1;
        });
        // Continue animation
        animationRef.current = requestAnimationFrame(animate);
    }, [
        canvasRef,
        createGradient
    ]);
    // Initialize dots when width changes
    (0, $cozmU.useEffect)(()=>{
        dotsRef.current = initDots();
    }, [
        width,
        dotCount,
        height,
        initDots
    ]);
    // Set up canvas and start animation
    (0, $cozmU.useEffect)(()=>{
        const canvas = canvasRef.current;
        if (!canvas) return;
        // Set canvas dimensions
        canvas.width = width;
        canvas.height = height; // Start animation
        animationRef.current = requestAnimationFrame(animate); // Cleanup
        return ()=>{
            if (animationRef.current) cancelAnimationFrame(animationRef.current);
        };
    }, [
        animate,
        height,
        width
    ]);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTonUgYP"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("canvas", {
        ref: canvasRef,
        width: width,
        height: height
    }));
};























/* ai-answer-body-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 







const $98e3090d57b087a8$export$373eea644718ed14 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isReadingAids: isReadingAids, serveDefinitionsUXExp: serveDefinitionsUXExp, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_9ebqy0": (0, $9aYkv.default)(__cmplp.serveDefinitionsUXExp ? `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-050, 4px)"}` : `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-050, 4px)"}`)
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "",
            __cmplp.isReadingAids ? "_2mHwu82ADO _4FKVYELb9f _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC" : "_2mHwu82ADO _4FKVYEdqw2 _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC",
            __cmplp.className
        ])
    });
});


/* ai-answer-error-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $bc3521c1c358b703$export$106e8178ce804384 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1ZnuxbNHnM",
            __cmplp.className
        ])
    });
});
















var $br26d = parcelRequire("br26d");





























const $c19df9a6f96e2f1c$export$b22e9ed865dfbcfa = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerRecentWorkListLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};





const $9b5790cac325151c$export$3eb2378888745842 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerRecentWorkListLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};


/* empty-state-text-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $c9d631ae658deba5$export$73d0188d97126121 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _3138425zaO _1UtDYzUktF",
            __cmplp.className
        ])
    });
});


/* link-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $4b1015dd26cfab9c$export$ce4b6a469c26f53f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _2XsHFM2ADO _0XEZqI7NXe _2AV1rB7NXe _4fgkWA7NXe _0Ya391DqSm _3syKoKDqSm _3ZsYrqDqSm _0DU3KTDqSm _2h7MEPDqSm _0BXPwdDqSm _1004K3DqSm _3tOQhEDqSm _3PFkzMDqSm _1aQ935DqSm _04h2sEDqSm _0DtnpGDqSm _1dLpBwS2te _1iJnp6S2te _4ACwSfS2te",
            __cmplp.className
        ])
    });
});





const $2b74ffab90174614$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    recentWorkListTitle: {
        id: "search_ai.ai_answer_dialog.recent_work_list.title",
        defaultMessage: "Recently worked on"
    },
    viewAllLink: {
        id: "search_ai.ai_answer_dialog.recent_work_list.view_all_link",
        defaultMessage: "View all"
    },
    showMore: {
        id: "search_ai.ai_answer_dialog.recent_work_list.show_more",
        defaultMessage: "Show more"
    },
    no_activity_error_text: {
        id: "search_ai.ai_answer_dialog.recent_work_list.no_activity_error_text",
        defaultMessage: "Atlassian Intelligence doesn\u2019t have enough data to provide a response right now. This may be because {user} is new and they haven't interacted with Confluence yet. In the meantime, try asking a different question."
    }
});

















const $7654c2fc49f1bf0c$export$5c8be2d1a7dc557 = ({ index: index, url: url, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerRecentWorkItem',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            index: index
        },
        nonPrivacySafeAttributes: {
            query: query,
            url: url,
            answerString: answerString
        }
    };
};





const $4b3f5fef4ad78890$export$440c60ade2f202a9 = ({ index: index, url: url, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerRecentWorkItem',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            index: index
        },
        nonPrivacySafeAttributes: {
            query: query,
            url: url,
            answerString: answerString
        }
    };
};



/* recent-work-item-body.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $4810c34de5bfdc3a$export$37f6bd651093c20a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _2XsHFM5zaO _37wbyuDIqT _4ouGXIdnbC",
            __cmplp.className
        ])
    });
});


/* recent-work-item-byline.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $6bbf6c045161468d$export$6a9e1330548eac8 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _4bt5LAnQyn _2WAcuGnQyn _1UtDYzKGUX _39HuIbz8Lp _1ANEUSLRg7 _1Znuxb2ADO _4ouGXIdnbC",
            __cmplp.className
        ])
    });
});


/* recent-work-item-container.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $33371da52face204$export$6e18a3d821f78b73 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0GBAIr6Ttf _4bqSyP1Y8M _3Ico7N1Y8M",
            __cmplp.className
        ])
    });
});


/* recent-work-item-description.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $6c0c989a27a4f633$export$a644bde83ad79b45 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "",
            __cmplp.className
        ])
    });
});


/* recent-work-item-icon.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $a18f12cc671a465a$export$c779e0225c7a4abb = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _3iDTPbQ4SZ _3YEZNOdnbC _39xV02NHnM _0jFU0VNHnM _3138422ADO _1DCdHi2ADO",
            __cmplp.className
        ])
    });
});


/* recent-work-item-link.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $273693369f6f0391$export$df8ab4b5e2ff1243 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _4bt5LAnQyn _2WAcuGnQyn _0bjKvDzXzM _1mT5xdRAKS _3iDTPbvLZJ _2Zuz6Q2ADO _1Znuxb2ADO _1zr6Dc98eZ _0htemXYbGa _067LcednbC _0ui43C5UpH _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _1eOmH6o126",
            __cmplp.className
        ])
    });
});


/* recent-work-item-title.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $ade312d40199de7f$export$398e991be65309e3 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1Znuxb2ADO _1wydGWFQfX _3iDTPbQ4SZ _0hPCNLDIqT _3zRROkEqul _0PxwN5dnbC _2ukBsMdnbC _1IqrEmdnbC _0NvCJadnbC _21mr2AnQyn _2aHgeynQyn _3oVIv4vbI6 _2waFOoy7kJ _0nAUbcz8Lp _0ohm36LRg7",
            __cmplp.className
        ])
    });
});


/* recent-work-item-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $035d4343be96ae71$export$246596915c6a37b0 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ",
            __cmplp.className
        ])
    });
});


const $ebb4db69cc755bd7$export$9adc0410c9970c44 = ({ index: index, title: title, iconUrl: iconUrl, url: url, container: container, event: event, contributors: contributors, timestamp: timestamp, othersCount: othersCount })=>{
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $kSwu1.useIntl)();
    const { userDetails: { id: currentUserId }, fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes, onNavigate: onNavigate } = (0, $3hVWe.useAIAnswerContext)();
    const description = (0, $998049cf2dbeb756$export$4d98da88c6a5014a)({
        currentUserId: !!currentUserId ? currentUserId : '',
        event: event,
        contributors: contributors,
        othersCount: othersCount,
        formatMessage: formatMessage,
        formatDate: formatDate,
        timestamp: new Date(timestamp)
    });
    const onClick = (0, $cozmU.useCallback)((event)=>{
        onNavigate(event);
        fireAnalyticsEvent((0, $7654c2fc49f1bf0c$export$5c8be2d1a7dc557)({
            index: index,
            url: url,
            ...commonAttributes
        }));
    }, [
        onNavigate,
        fireAnalyticsEvent,
        index,
        url,
        commonAttributes
    ]);
    const onContextMenuClick = (0, $cozmU.useCallback)((event)=>{
        onNavigate(event);
        fireAnalyticsEvent((0, $4b3f5fef4ad78890$export$440c60ade2f202a9)({
            index: index,
            url: url,
            ...commonAttributes
        }));
    }, [
        onNavigate,
        fireAnalyticsEvent,
        index,
        url,
        commonAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $273693369f6f0391$export$df8ab4b5e2ff1243), {
        href: url,
        onClick: onClick,
        onContextMenu: onContextMenuClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $035d4343be96ae71$export$246596915c6a37b0), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a18f12cc671a465a$export$c779e0225c7a4abb), {
        src: iconUrl,
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4810c34de5bfdc3a$export$37f6bd651093c20a), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ade312d40199de7f$export$398e991be65309e3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6bbf6c045161468d$export$6a9e1330548eac8), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33371da52face204$export$6e18a3d821f78b73), null, container), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c0c989a27a4f633$export$a644bde83ad79b45), null, description)))));
};


/* recent-work-list-title.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $824b1f7e98cbde58$export$9a485269bf2c8987 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "h5", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ",
            __cmplp.className
        ])
    });
});


/* recent-work-list-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $970b9d364788e4a8$export$3c95e3d61376d5b6 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1EqgXlN91d",
            __cmplp.className
        ])
    });
});


const $8aef00439b4d9f61$var$COLLAPSED_RECENT_WORK_ITEM_NUMBER = 5;
const $8aef00439b4d9f61$export$66aebd6b65f0e0cf = ({ name: name, activities: activities, viewAllUrl: viewAllUrl })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const cachedExpanded = JSON.parse((0, $6JEx2.getSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY)) || '{}').recentWorkListExpanded;
    const [expanded, setExpanded] = (0, $cozmU.useState)(cachedExpanded !== undefined ? cachedExpanded : false);
    const { updateContextCache: updateContextCache, fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes, onNavigate: onNavigate } = (0, $3hVWe.useAIAnswerContext)();
    const expandRecentWorkList = (0, $cozmU.useCallback)(()=>{
        setExpanded(true);
        updateContextCache({
            recentWorkListExpanded: true
        });
    }, [
        updateContextCache
    ]);
    const onLinkClick = (0, $cozmU.useCallback)((event)=>{
        onNavigate(event);
        fireAnalyticsEvent((0, $c19df9a6f96e2f1c$export$b22e9ed865dfbcfa)(commonAttributes));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        onNavigate
    ]);
    const onLinkContextMenuClick = (0, $cozmU.useCallback)((event)=>{
        onNavigate(event);
        fireAnalyticsEvent((0, $9b5790cac325151c$export$3eb2378888745842)(commonAttributes));
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        onNavigate
    ]);
    const showExpandedItems = activities.length > $8aef00439b4d9f61$var$COLLAPSED_RECENT_WORK_ITEM_NUMBER ? expanded : true;
    const shownActivities = showExpandedItems ? activities : activities.slice(0, $8aef00439b4d9f61$var$COLLAPSED_RECENT_WORK_ITEM_NUMBER);
    if (activities.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c9d631ae658deba5$export$73d0188d97126121), null, formatMessage((0, $2b74ffab90174614$export$defe85febe8b728c).no_activity_error_text, {
        user: name
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $824b1f7e98cbde58$export$9a485269bf2c8987), null, formatMessage((0, $2b74ffab90174614$export$defe85febe8b728c).recentWorkListTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $970b9d364788e4a8$export$3c95e3d61376d5b6), null, shownActivities.map((activity, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ebb4db69cc755bd7$export$9adc0410c9970c44), {
            key: `recent-work-item-${index}`,
            index: index,
            title: activity.title,
            iconUrl: activity.iconUrl,
            url: activity.url,
            container: activity.containerName,
            event: activity.event,
            contributors: activity.contributors,
            timestamp: activity.timestamp,
            othersCount: activity.othersCount
        }))), showExpandedItems ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4b1015dd26cfab9c$export$ce4b6a469c26f53f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: 'link',
        href: viewAllUrl,
        onClick: onLinkClick,
        onContextMenu: onLinkContextMenuClick
    }, formatMessage((0, $2b74ffab90174614$export$defe85febe8b728c).viewAllLink))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, !!viewAllUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4b1015dd26cfab9c$export$ce4b6a469c26f53f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "link",
        onClick: expandRecentWorkList
    }, formatMessage((0, $2b74ffab90174614$export$defe85febe8b728c).showMore)))));
};









var $4bg4c = parcelRequire("4bg4c");
















const $ce080d9929f5b8dd$export$924cae8b31b3ec43 = ({ primaryUserName: primaryUserName, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerWhoPrimaryViewProfile',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            primaryUserName: primaryUserName
        }
    };
};





const $2b50efc588696ab2$export$7bc7dfa120866cd2 = ({ primaryUserName: primaryUserName, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerWhoPrimaryViewProfile',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            primaryUserName: primaryUserName
        }
    };
};


/* profile-section-primary-user-header.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $33ba4a2fa053dcce$export$255011ab851083fa = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuI7V3 _39xV02N91d",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-user-img.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $b24ca004614a1c9f$export$dbd921847e022785 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDyzSk _39xV02L04q _0jFU0VL04q",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-user-info-text-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $13b9dbadfbb66bc3$export$4748d4ea7eaeeee9 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842FQfX _3iDTPbQ4SZ _3TGfC9HnLE _0hPCNLDIqT _39xV02N91d",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-user-info-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $fcddc648b8552772$export$509293bf46c921a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _37wbyuchRC _0hPCNLchRC _0jFU0VN91d _39xV02N91d _2XsHFM5zaO",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-user-name.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $8b6d894f3a58830a$export$2561140795d9b6bc = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgWSk4",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-user-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $086aedaf490ad910$export$455d3c20a8814267 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuchRC _0hPCNLDIqT _39xV02N91d",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-view-profile-link-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $e69c30bc58eb4b70$export$bb93002cdcc6fd86 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $43324dd00e75b059$export$32d100979bcc384a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT _39xV02N91d",
            __cmplp.className
        ])
    });
});









var $p6OqS = parcelRequire("p6OqS");


var $5ZtfK = parcelRequire("5ZtfK");



















/* profile-section-primary-user-addtl-icon-padding.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $71eda234bc5072eb$export$83dd167b9bbf48eb = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0VIeFR1Y8M",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-user-info.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $6134452c3bca165a$export$6703f231e80ecbdc = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _0adFHs2ADO",
            __cmplp.className
        ])
    });
});


/* profile-section-primary-user-info-text.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $985cbbd10a93f98c$export$56b2c11ed41d99f1 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _1UtDYzKGUX _2XsHFMFQfX",
            __cmplp.className
        ])
    });
});


var $e4bc1cab82d36a1d$export$70291e6ea210ef9 = /*#__PURE__*/ function(UserInfoTypeFormat) {
    UserInfoTypeFormat["JOBTITLE"] = "JOB_TITLE";
    UserInfoTypeFormat["DEPARTMENT"] = "DEPARTMENT";
    UserInfoTypeFormat["LOCATION"] = "LOCATION";
    UserInfoTypeFormat["TIME"] = "TIME";
    UserInfoTypeFormat["EMAIL"] = "EMAIL";
    return UserInfoTypeFormat;
}({});


const $20a35d0143afbe93$var$userInfoTypeMapper = {
    [(0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).JOBTITLE]: {
        tooltipMessage: (0, $cb86z.messages).ai_answer_who_questions_hover_role_icon,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($p6OqS))), {
            label: "",
            color: "var(--ds-text-subtlest, #6B6E76)",
            testId: "primary-user-suitcase-icon"
        })
    },
    [(0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).DEPARTMENT]: {
        tooltipMessage: (0, $cb86z.messages).ai_answer_who_questions_hover_department_icon,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eleTd))), {
            label: "",
            color: "var(--ds-text-subtlest, #6B6E76)",
            testId: "primary-user-department-icon"
        })
    },
    [(0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).LOCATION]: {
        tooltipMessage: (0, $cb86z.messages).ai_answer_who_questions_hover_location_icon,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hS5Ee))), {
            label: "",
            color: "var(--ds-text-subtlest, #6B6E76)",
            testId: "primary-user-location-icon"
        })
    },
    [(0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).TIME]: {
        tooltipMessage: (0, $cb86z.messages).ai_answer_who_questions_hover_local_time_icon,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
            label: "",
            color: "var(--ds-text-subtlest, #6B6E76)",
            testId: "primary-user-emoji-frequent-icon"
        })
    },
    [(0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).EMAIL]: {
        tooltipMessage: (0, $cb86z.messages).ai_answer_who_questions_hover_email_icon,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ldb9Z))), {
            label: "",
            color: "var(--ds-text-subtlest, #6B6E76)",
            testId: "primary-user-email-icon"
        })
    }
};
const $20a35d0143afbe93$export$aaf1b21561a4fb8b = ({ userInfo: userInfo, userInfoType: userInfoType, applyAdditionalTopIconPadding: applyAdditionalTopIconPadding })=>{
    return userInfo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6134452c3bca165a$export$6703f231e80ecbdc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "top",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $20a35d0143afbe93$var$userInfoTypeMapper[userInfoType].tooltipMessage)
    }, applyAdditionalTopIconPadding ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $71eda234bc5072eb$export$83dd167b9bbf48eb), null, $20a35d0143afbe93$var$userInfoTypeMapper[userInfoType].icon) : $20a35d0143afbe93$var$userInfoTypeMapper[userInfoType].icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $985cbbd10a93f98c$export$56b2c11ed41d99f1), null, userInfo))) : null;
};



const $08aecb4802393fa3$export$cf8aeccda7668aa5 = ({ accountId: accountId, name: name, email: email, avatarUrl: avatarUrl, profileUrl: profileUrl, jobTitle: jobTitle, department: department, location: location, time: time })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, onNavigate: onNavigate } = (0, $3hVWe.useAIAnswerContext)();
    const profileLink = commonAttributes.brand === (0, $zzZbq.AiBrand).AI ? `/wiki/people/${accountId}` : profileUrl;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $43324dd00e75b059$export$32d100979bcc384a), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $086aedaf490ad910$export$455d3c20a8814267), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b24ca004614a1c9f$export$dbd921847e022785), {
        src: avatarUrl || '',
        alt: name
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fcddc648b8552772$export$509293bf46c921a), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33ba4a2fa053dcce$export$255011ab851083fa), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8b6d894f3a58830a$export$2561140795d9b6bc), null, name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e69c30bc58eb4b70$export$bb93002cdcc6fd86), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4bg4c))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-text-accent-blue, #1558BC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: profileLink || '',
        onClick: (event)=>{
            onNavigate(event);
            fireAnalyticsEvent((0, $ce080d9929f5b8dd$export$924cae8b31b3ec43)({
                ...commonAttributes,
                primaryUserName: name
            }));
        },
        onContextMenu: (event)=>{
            onNavigate(event);
            fireAnalyticsEvent((0, $2b50efc588696ab2$export$7bc7dfa120866cd2)({
                ...commonAttributes,
                primaryUserName: name
            }));
        }
    }, formatMessage((0, $cb86z.messages).ai_answer_who_questions_view_profile)))), (jobTitle || department) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13b9dbadfbb66bc3$export$4748d4ea7eaeeee9), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20a35d0143afbe93$export$aaf1b21561a4fb8b), {
        userInfo: jobTitle || '',
        userInfoType: (0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).JOBTITLE
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20a35d0143afbe93$export$aaf1b21561a4fb8b), {
        userInfo: department || '',
        userInfoType: (0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).DEPARTMENT
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13b9dbadfbb66bc3$export$4748d4ea7eaeeee9), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20a35d0143afbe93$export$aaf1b21561a4fb8b), {
        userInfo: location || '',
        userInfoType: (0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).LOCATION
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20a35d0143afbe93$export$aaf1b21561a4fb8b), {
        userInfo: time || '',
        userInfoType: (0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).TIME,
        applyAdditionalTopIconPadding: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20a35d0143afbe93$export$aaf1b21561a4fb8b), {
        userInfo: email || '',
        userInfoType: (0, $e4bc1cab82d36a1d$export$70291e6ea210ef9).EMAIL,
        applyAdditionalTopIconPadding: true
    })))));
};

















var $722fc5d84170c752$export$7c6c2f9c68de2e45 = /*#__PURE__*/ function(NLPSearchResultContainerDataTypeContainerType) {
    NLPSearchResultContainerDataTypeContainerType["ConfluenceSpace"] = "confluenceSpace";
    NLPSearchResultContainerDataTypeContainerType["JiraProject"] = "jiraProject";
    return NLPSearchResultContainerDataTypeContainerType;
}({});





const $c7d907edb584f358$export$da5ff760e0ba649b = ({ resultSection: resultSection, resultTitle: resultTitle, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerWhoPrimaryCoordinationPill',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            resultSection: resultSection
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            resultTitle: resultTitle
        }
    };
};





const $ed389fe51a6e2620$export$305f2a0f7fa9a25f = ({ resultSection: resultSection, resultTitle: resultTitle, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'contextMenuClicked',
        actionSubject: 'aiAnswerWhoPrimaryCoordinationPill',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            resultSection: resultSection
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString,
            resultTitle: resultTitle
        }
    };
};


/* ai-who-answer-section-header.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $940369cd7573c555$export$8d7f456736fee90f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "h5", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgd8bj",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-section-result.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $3e59976130394a04$export$d0be8a9d033ca7b8 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_30huDKkzjp _0bjKvDKTcp _3iDTPbQ4SZ _0hPCNLDIqT _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _24h04i2Njc _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _3fSdSTGk8v",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-section-result-info-header.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $baf12dda6b49bc9f$export$790f6d80b0f65f30 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgEqul _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _39xV02N91d _39HuIbz8Lp _1ANEUSLRg7",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-section-result-info-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $dd1ef2556613b2d0$export$e739e9e96a0d2dd9 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuZHm0 _0hPCNLchRC _0jFU0VN91d _39xV02N91d _2XsHFM2ADO _39HuIbz8Lp _1ANEUSLRg7",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-section-result-metadata.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $73505f4b12efc097$export$7b9fc87d1d9e8ecd = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzKGUX _39xV02N91d _39HuIbz8Lp _1ANEUSLRg7",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-section-results-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $39598a14d533d2a8$export$39edbe3e7f6a9ca1 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _3iDTPbgBM8 _2iEGP2byVk _39xV02N91d _0jFU0VmdCj _3138422ADO",
            __cmplp.className
        ])
    });
});


/* ai-who-answer-section-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $51abcd58c12c68a4$export$cc8053471b180c28 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _3138425zaO _39xV02N91d",
            __cmplp.className
        ])
    });
});


const $38dd5d534a3b496e$var$WHO_SECTION_MAX_ITEMS = 3;
const $38dd5d534a3b496e$export$2fdd09f06ec66b1 = ({ sectionId: sectionId, sectionHeader: sectionHeader, sectionResults: sectionResults, avatarAppearance: avatarAppearance })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, onNavigate: onNavigate } = (0, $3hVWe.useAIAnswerContext)();
    const getSectionResultMetadata = (sectionResult)=>{
        if ('containerType' in sectionResult) switch(sectionResult.containerType){
            case (0, $722fc5d84170c752$export$7c6c2f9c68de2e45).ConfluenceSpace:
                return 'Confluence';
            case (0, $722fc5d84170c752$export$7c6c2f9c68de2e45).JiraProject:
                return 'Jira Software';
            default:
                return '';
        }
        if ('title' in sectionResult) return sectionResult.title || '';
        if ('memberCount' in sectionResult) return formatMessage((0, $cb86z.messages).ai_answer_who_question_team_section_member_count, {
            count: sectionResult.memberCount
        });
        return '';
    };
    return sectionResults && sectionResults.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $51abcd58c12c68a4$export$cc8053471b180c28), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $940369cd7573c555$export$8d7f456736fee90f), null, formatMessage(sectionHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39598a14d533d2a8$export$39edbe3e7f6a9ca1), null, sectionResults.slice(0, $38dd5d534a3b496e$var$WHO_SECTION_MAX_ITEMS).map((sectionResult)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3e59976130394a04$export$d0be8a9d033ca7b8), {
            key: sectionResult.name,
            href: sectionResult.url || undefined,
            onClick: (event)=>{
                onNavigate(event);
                fireAnalyticsEvent((0, $c7d907edb584f358$export$da5ff760e0ba649b)({
                    ...commonAttributes,
                    resultSection: sectionId,
                    resultTitle: sectionResult.name
                }));
            },
            onContextMenu: ()=>{
                fireAnalyticsEvent((0, $ed389fe51a6e2620$export$305f2a0f7fa9a25f)({
                    ...commonAttributes,
                    resultSection: sectionId,
                    resultTitle: sectionResult.name
                }));
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            appearance: avatarAppearance,
            src: sectionResult.iconUrl || sectionResult.picture || sectionResult.avatarUrl || undefined,
            size: "medium"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dd1ef2556613b2d0$export$e739e9e96a0d2dd9), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $baf12dda6b49bc9f$export$790f6d80b0f65f30), null, sectionResult.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73505f4b12efc097$export$7b9fc87d1d9e8ecd), null, getSectionResultMetadata(sectionResult))))))) : null;
};


const $2490bd4988410e64$export$f11b3e733b5a589b = ()=>{
    const { commonAttributes: commonAttributes, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString, cloudId: cloudId, sessionId: sessionId } = commonAttributes;
    // answerString should have at least one result or else <AIAnswerError /> will be rendered
    const whoResult = {
        user_metadata: (0, $17e86b4a203450c0$export$b273f870e024eb5d)(answerString).parsedResult
    };
    const userResults = whoResult.user_metadata;
    // BE will always return first object as the primary user result
    const primaryUser = userResults[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $08aecb4802393fa3$export$cf8aeccda7668aa5), {
        accountId: primaryUser.account_id,
        name: primaryUser.name,
        email: primaryUser.email,
        avatarUrl: primaryUser.avatar_url,
        profileUrl: primaryUser.profile_url,
        jobTitle: primaryUser.job_title,
        department: primaryUser.department,
        location: primaryUser.location,
        time: primaryUser.time
    }), isAdminHubAIEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $br26d.AITopicsByPerson), {
        cloudId: cloudId,
        userId: primaryUser.account_id ?? '',
        userName: primaryUser.name,
        sessionId: sessionId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38dd5d534a3b496e$export$2fdd09f06ec66b1), {
        sectionId: "frequent_locations",
        sectionHeader: (0, $cb86z.messages).ai_answer_who_questions_frequent_locations_header,
        sectionResults: primaryUser.containers,
        avatarAppearance: "square"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38dd5d534a3b496e$export$2fdd09f06ec66b1), {
        sectionId: "frequent_collaborators",
        sectionHeader: (0, $cb86z.messages).ai_answer_who_questions_frequent_collaborators_header,
        sectionResults: primaryUser.collaborators?.slice(0, 3),
        avatarAppearance: "circle"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38dd5d534a3b496e$export$2fdd09f06ec66b1), {
        sectionId: "teams",
        sectionHeader: (0, $cb86z.messages).ai_answer_who_questions_teams_header,
        sectionResults: primaryUser.teams,
        avatarAppearance: "square"
    }), primaryUser.recentActivity && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8aef00439b4d9f61$export$66aebd6b65f0e0cf), {
        name: primaryUser.name,
        activities: primaryUser.recentActivity,
        viewAllUrl: primaryUser.viewAllLink
    }));
};











const $f2d360744ad6d7ea$export$ff8068fc50f478b4 = ()=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    const workResult = {
        user_metadata_with_activity: (0, $17e86b4a203450c0$export$b273f870e024eb5d)(answerString).parsedResult
    };
    const userWorkResult = workResult.user_metadata_with_activity[0];
    const activities = userWorkResult.recentActivity;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $08aecb4802393fa3$export$cf8aeccda7668aa5), {
        name: userWorkResult.name,
        email: userWorkResult.email,
        avatarUrl: userWorkResult.avatar_url,
        profileUrl: userWorkResult.profile_url,
        jobTitle: userWorkResult.job_title,
        department: userWorkResult.department,
        location: userWorkResult.location,
        time: userWorkResult.time
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8aef00439b4d9f61$export$66aebd6b65f0e0cf), {
        name: userWorkResult.name,
        activities: activities,
        viewAllUrl: userWorkResult.viewAllLink
    }));
};


const $b7321ed56d8ec1e0$export$135cee1a1b919871 = ()=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    const { parsedType: parsedType } = (0, $17e86b4a203450c0$export$b273f870e024eb5d)(answerString);
    switch(parsedType){
        case (0, $d227efab07c2b9f0$export$eae917983a0398aa).WHO:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2490bd4988410e64$export$f11b3e733b5a589b), null);
        case (0, $d227efab07c2b9f0$export$eae917983a0398aa).WORK:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f2d360744ad6d7ea$export$ff8068fc50f478b4), null);
        case (0, $d227efab07c2b9f0$export$eae917983a0398aa).TEAM:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39464719bc90ad90$export$224d36db19d00a29), null);
        default:
            return null;
    }
};




















const $5ef0f30ecddd4119$export$e7233899affc4477 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerReturnLink',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};


/* ai-answer-close-label-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $203fd6bdee3cef4d$export$855079ed5415eeab = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _2sNsIg7NXe _3iDTPbQ4SZ _1UtDYzKGUX _0mTZRh7zJH",
            __cmplp.className
        ])
    });
});


/* ai-answer-result-blur-section.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $ae7e2b66522f56ed$export$95fe272adfa518ad = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31fEoDO _39xV02npmf _3iDTPbQ4SZ _37wbyuF05b _1mT5xdWVPG _2IhTonDQNZ _0wOv4Q7zJH _1wydGW1Y8M _0Of8r25zaO _1UtDYzy7kJ _02i86wdnbC",
            __cmplp.className
        ])
    });
});


/* ai-answer-result-blur-section-text.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $96acacb119695a8c$export$b67ed19cd3a08e2a = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31fspMb _2sNsIg20Hp _3iDTPbQ4SZ _37wbyuF05b _39xV02DC6J _1Znuxb1Y8M",
            __cmplp.className
        ])
    });
});



const $c61152461d70d823$export$f8279a5be196ce2f = ()=>{
    const [isResultOverflow, setResultOverflow] = (0, $cozmU.useState)(false);
    const [isResultExpanded, setResultExpanded] = (0, $cozmU.useState)(false);
    const wrapperRef = (0, $cozmU.useRef)(null);
    const contentRef = (0, $cozmU.useRef)(null);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, isReadingAids: isReadingAids, cardTemplate: cardTemplate, onClose: onClose } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString } = commonAttributes;
    const onCloseDialog = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $5ef0f30ecddd4119$export$e7233899affc4477)(commonAttributes));
        onClose?.();
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        onClose
    ]);
    const enableShowMoreBlur = cardTemplate === (0, $zzZbq.CardTemplate).DEFAULT && isReadingAids;
    (0, $cozmU.useEffect)(()=>{
        if (!wrapperRef.current || !contentRef.current) return;
        const resizeObserver = new ResizeObserver(()=>{
            if ((wrapperRef.current?.offsetHeight ?? 0) < (contentRef.current?.offsetHeight ?? 0)) setResultOverflow(true);
            else setResultOverflow(false);
        });
        resizeObserver.observe(contentRef.current);
        return ()=>resizeObserver.disconnect();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dc507febe9bd909d$export$d74b491f1ba95e72), {
        isReadingAids: isReadingAids && cardTemplate === (0, $zzZbq.CardTemplate).DEFAULT,
        ref: wrapperRef,
        isExpanded: isResultExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: contentRef
    }, answerString), enableShowMoreBlur && isResultOverflow && !isResultExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ae7e2b66522f56ed$export$95fe272adfa518ad), {
        onClick: ()=>setResultExpanded(true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $96acacb119695a8c$export$b67ed19cd3a08e2a), null, formatMessage((0, $cb86z.messages).ai_answer_expand_button_label)))), !isReadingAids && onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $203fd6bdee3cef4d$export$855079ed5415eeab), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $cb86z.messages).ai_answer_dialog_cancel_label,
        values: {
            searchResultsLink: // eslint-disable-next-line @atlassian/a11y/anchor-is-valid, @atlassian/a11y/click-events-have-key-events, @atlaskit/design-system/no-html-anchor, @atlassian/a11y/no-static-element-interactions
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
                onClick: onCloseDialog
            }, formatMessage((0, $cb86z.messages).ai_answer_dialog_search_results_label))
        }
    })));
};














































const $4126f49942e8f651$var$ReactRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("7ydRw")).then(({ ReactRenderer: ReactRenderer })=>{
        return {
            default: ReactRenderer
        };
    }));

const $4126f49942e8f651$var$MarkdownRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("039lM")).then(({ default: ReactMarkdown })=>{
        return {
            default: ReactMarkdown
        };
    }));
const $4126f49942e8f651$export$b6ab675c6c26c40f = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isResultOverflow, setResultOverflow] = (0, $cozmU.useState)(false);
    const [isResultExpanded, setResultExpanded] = (0, $cozmU.useState)(false);
    const wrapperRef = (0, $cozmU.useRef)(null);
    const contentRef = (0, $cozmU.useRef)(null);
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent, isReadingAids: isReadingAids, cardTemplate: cardTemplate, onClose: onClose } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString, answerFormat: answerFormat } = commonAttributes;
    const onCloseDialog = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $5ef0f30ecddd4119$export$e7233899affc4477)(commonAttributes));
        onClose?.();
    }, [
        commonAttributes,
        fireAnalyticsEvent,
        onClose
    ]);
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    const enableShowMoreBlur = cardTemplate === (0, $zzZbq.CardTemplate).DEFAULT && isReadingAids && !serveDefinitionUXUpdates;
    (0, $cozmU.useEffect)(()=>{
        if (!wrapperRef.current || !contentRef.current) return;
        if (serveDefinitionUXUpdates) return;
        const resizeObserver = new ResizeObserver(()=>{
            if ((wrapperRef.current?.offsetHeight ?? 0) < (contentRef.current?.offsetHeight ?? 0)) setResultOverflow(true);
            else setResultOverflow(false);
        });
        resizeObserver.observe(contentRef.current);
        return ()=>resizeObserver.disconnect();
    }, [
        serveDefinitionUXUpdates
    ]);
    const docContent = (0, $cozmU.useMemo)(()=>(0, $6rwn6.encodeAdf)(answerString, false), [
        answerString
    ]);
    const FormattedResult = (0, $cozmU.useMemo)(()=>{
        let content;
        switch(answerFormat){
            case (0, $hpFQM.NLPSearchResultFormat).ADF:
                content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4126f49942e8f651$var$ReactRenderer, {
                    document: JSON.parse(answerString),
                    nodeComponents: (0, $iDrrr.fg)('hybrid_orchestrator_enable_image_search') ? undefined : {
                        // Preventing media and mediaSingle from rendering images due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
                        // Followup ticket to re-enable image rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
                        media: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null),
                        mediaSingle: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
                    }
                });
                break;
            case (0, $hpFQM.NLPSearchResultFormat).MARKDOWN:
                if (!isReadingAids) {
                    content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4126f49942e8f651$var$ReactRenderer, {
                        document: docContent,
                        nodeComponents: {
                            status: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e2862f0d359af03a$export$21553c57082a6434), props),
                            // Preventing media and mediaSingle from rendering images due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
                            // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
                            ...!(0, $iDrrr.fg)('hybrid_orchestrator_enable_image_search') ? {
                                media: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null),
                                mediaSingle: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
                            } : undefined
                        }
                    });
                    break;
                }
                // Preventing img elements from rendering due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
                // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
                content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4126f49942e8f651$var$MarkdownRenderer, {
                    disallowedElements: (0, $iDrrr.fg)('hybrid_orchestrator_enable_image_search') ? undefined : [
                        'img'
                    ]
                }, answerString);
                break;
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null);
        }
        return content;
    }, [
        answerFormat,
        answerString,
        docContent,
        isReadingAids
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dc507febe9bd909d$export$d74b491f1ba95e72), {
        id: "ai-answer-result-section",
        ref: wrapperRef,
        isReadingAids: isReadingAids && cardTemplate === (0, $zzZbq.CardTemplate).DEFAULT,
        isExpanded: isResultExpanded || serveDefinitionUXUpdates,
        serveDefinitionUXExp: serveDefinitionUXUpdates
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: contentRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, FormattedResult))))), enableShowMoreBlur && isResultOverflow && !isResultExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ae7e2b66522f56ed$export$95fe272adfa518ad), {
        onClick: ()=>setResultExpanded(true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $96acacb119695a8c$export$b67ed19cd3a08e2a), null, formatMessage((0, $cb86z.messages).ai_answer_expand_button_label))), !isReadingAids && onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $203fd6bdee3cef4d$export$855079ed5415eeab), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $cb86z.messages).ai_answer_dialog_cancel_label,
        values: {
            searchResultsLink: // eslint-disable-next-line @atlaskit/design-system/no-html-anchor, @atlassian/a11y/anchor-is-valid, @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/no-static-element-interactions
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
                onClick: onCloseDialog
            }, formatMessage((0, $cb86z.messages).ai_answer_dialog_search_results_label))
        }
    })));
};


const $47d8550a555006e1$var$AIAnswerResult = ()=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { answerFormat: answerFormat } = commonAttributes;
    (0, $cozmU.useEffect)(()=>{
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const AIAnswerResultComponent = (0, $cozmU.useMemo)(()=>{
        switch(answerFormat){
            case (0, $hpFQM.NLPSearchResultFormat).ADF:
            case (0, $hpFQM.NLPSearchResultFormat).MARKDOWN:
                return 0, $4126f49942e8f651$export$b6ab675c6c26c40f;
            case (0, $hpFQM.NLPSearchResultFormat).JSON:
                return 0, $b7321ed56d8ec1e0$export$135cee1a1b919871;
            case (0, $hpFQM.NLPSearchResultFormat).PLAINTEXT:
            default:
                return 0, $c61152461d70d823$export$f8279a5be196ce2f;
        }
    }, [
        answerFormat
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AIAnswerResultComponent, null);
};
const $47d8550a555006e1$export$e2b54fc495614d59 = ()=>{
    const { isAnswered: isAnswered, hasError: hasError, isReadingAids: isReadingAids, cardTemplate: cardTemplate } = (0, $3hVWe.useAIAnswerContext)();
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $98e3090d57b087a8$export$373eea644718ed14), {
        isReadingAids: isReadingAids && cardTemplate === (0, $zzZbq.CardTemplate).DEFAULT,
        serveDefinitionsUXExp: serveDefinitionUXUpdates
    }, isAnswered && !hasError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($47d8550a555006e1$var$AIAnswerResult, null) : hasError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bc3521c1c358b703$export$106e8178ce804384), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f366b75433df2895$export$ffa24cd7196ce1b0), null)) : null);
};






/* ai-answer-title.tsx generated by @compiled/babel-plugin v2.0.0 */ 































/* DisableDefinitionMenu.tsx generated by @compiled/babel-plugin v2.0.0 */ 















var $6TaGl = parcelRequire("6TaGl");





var $c0A7H = parcelRequire("c0A7H");







const $f93224bfed589820$var$messages = (0, $kSwu1.defineMessages)({
    disable_definitions_more_icon_tooltip: {
        id: "search_ai.disable_definitions_more_icon_tooltip",
        defaultMessage: "See more actions"
    },
    see_more_actions_button_label: {
        id: "search_ai.definitions_see_more_actions_label",
        defaultMessage: "See more actions"
    },
    disable_definitions_header: {
        id: "search_ai.disable_definitions_header",
        defaultMessage: "Don\u2019t recommend definitions at all"
    },
    disable_definitions_description: {
        id: "search_ai.disable_definitions_description",
        defaultMessage: "When this is on, we\u2019ll no longer automatically highlight terms and acronyms on any page. Only you will see these changes."
    }
});
const $f93224bfed589820$var$DisableDefinitionMenuWrapper = null;
const $f93224bfed589820$var$DisableDefinitionMenuTextWrapper = null;
const $f93224bfed589820$var$DisableDefinitionMenuHeaderStyles = null;
const $f93224bfed589820$var$DisableDefinitionMenuDescriptionStyles = null;
const $f93224bfed589820$var$DisableDefinitionMenuToggleWrapper = null;
const $f93224bfed589820$var$MoreIconStyled = ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        label: (0, $ieeJu.expValEquals)('a11y-fixes-week1-june-2026', 'isEnabled', true) ? '' : 'reading-aids-menu-button-icon',
        color: "var(--ds-icon-subtle, #505258)"
    });
const $f93224bfed589820$export$a025edc19ca0650a = ()=>{
    const { readingAidsOptions: readingAidsOptions } = (0, $3hVWe.useAIAnswerContext)();
    const [menuOpen, setMenuOpen] = (0, $cozmU.useState)(false);
    const [disableDefinitions, setDisableDefinitions] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        const definitionsDisabled = !!readingAidsOptions?.disableDefinitionsCallbacks?.getDefinitionsDisabled();
        setDisableDefinitions(definitionsDisabled); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const disableDefinitionsCallbacks = readingAidsOptions?.disableDefinitionsCallbacks;
    return disableDefinitionsCallbacks ? /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        position: "bottom",
        content: formatMessage($f93224bfed589820$var$messages.disable_definitions_more_icon_tooltip)
    }, /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
        isOpen: menuOpen,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                ...props,
                appearance: "subtle",
                icon: $f93224bfed589820$var$MoreIconStyled,
                ref: triggerRef,
                onClick: ()=>{
                    setMenuOpen(!menuOpen);
                },
                testId: "definitions-menu-button",
                label: (0, $ieeJu.expValEquals)('a11y-fixes-week1-june-2026', 'isEnabled', true) ? formatMessage($f93224bfed589820$var$messages.see_more_actions_button_label) : 'definitions-menu-button'
            })
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2mHwu8kG2W _3iDTPbQ4SZ _39xV02sz7G _0aFT5v1qpb _37wbyuI7V3 _42Yu6B7dHp _3138425zaO _1wydGW5zaO _2Zuz6Q8HPE _0adFHsgVvo"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w _39xV02dl5A"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _1UtDYzy7kJ"
        ])
    }, formatMessage($f93224bfed589820$var$messages.disable_definitions_header)), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _1UtDYzKGUX"
        ])
    }, formatMessage($f93224bfed589820$var$messages.disable_definitions_description))), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _39xV02E6Kk"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $c0A7H.default), {
        onChange: ()=>{
            if (disableDefinitions) disableDefinitionsCallbacks.onEnableDefinitions();
            else disableDefinitionsCallbacks.onDisableDefinitions();
            setDisableDefinitions(!disableDefinitions);
        },
        isChecked: disableDefinitions,
        testId: "definitions-toggle-disable"
    }))))) : null;
};


/* DefinitionsDropdownMenu.tsx generated by @compiled/babel-plugin v2.0.0 */ 










































var $kYmM6 = parcelRequire("kYmM6");

var $38ARq = parcelRequire("38ARq");

var $bw8s0 = parcelRequire("bw8s0");



























/* edit-definition-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $ac773248b4c6e67e$export$92161330b4f919c7 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0Of8r2dnbC _1Znuxb8HPE _1wydGWdnbC _2Zuz6Q8HPE _0RxVZVKGUX",
            __cmplp.className
        ])
    });
});


const $b69531bb99313eff$export$f32beb894f554d19 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiCuratedDefinitionEditButton',
        source: source,
        eventType: 'ui',
        attributes: {
            // contentId and readingAidsSessionId passed in from Confluence readingAids
            ...extraAttributes
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};


const $7d46aa3d987b242a$export$9dee3cc92d823001 = (props)=>{
    const { query: query, answerString: answerString, extraAttributes: extraAttributes, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiCuratedDefinitionEditButton',
        source: source,
        eventType: 'track',
        attributes: {
            ...extraAttributes
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};


const $83873e2ed2341e7f$var$messages = (0, $kSwu1.defineMessages)({
    edit_definition_icon_tooltip: {
        id: "search_ai.curated-definition-edit-def-icon-tooltip",
        defaultMessage: "Edit definition"
    },
    edit_definition_prompt_text: {
        id: "search_ai.edit_definition_prompt_text",
        defaultMessage: "Not quite right? Edit this definition"
    },
    edit_definition_prompt_text_updated: {
        id: "search_ai.edit_definition_prompt_text_updated",
        defaultMessage: "Edit this definition"
    }
});
const $83873e2ed2341e7f$var$EditIconStyled = ()=>{
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: "",
        size: serveDefinitionUXUpdates ? 'small' : 'medium'
    });
};
const $83873e2ed2341e7f$export$86ebf34eb079ac26 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { fireAnalyticsEvent: fireAnalyticsEvent, isAnswered: isAnswered, hasError: hasError, readingAidsOptions: readingAidsOptions, commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editButtonSpotlightId = 'ai-definitions-edit-button';
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    const [showEditModal, setShowEditModal] = (0, $cozmU.useState)(false);
    const [displaySuccessFlag, setDisplaySuccessFlag] = (0, $cozmU.useState)(false);
    const closeEditModal = (0, $cozmU.useCallback)(()=>{
        setShowEditModal(false);
        onClose?.();
    }, [
        setShowEditModal,
        onClose
    ]);
    const openEditModal = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $b69531bb99313eff$export$f32beb894f554d19)(commonAttributes));
        setShowEditModal(true);
    }, [
        commonAttributes,
        fireAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isAnswered) fireAnalyticsEvent((0, $7d46aa3d987b242a$export$9dee3cc92d823001)(commonAttributes));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, !hasError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38ARq.SpotlightManager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bw8s0.SpotlightTarget), {
        name: editButtonSpotlightId
    }, serveDefinitionUXUpdates ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: $83873e2ed2341e7f$var$EditIconStyled,
        onClick: openEditModal,
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, formatMessage($83873e2ed2341e7f$var$messages.edit_definition_prompt_text_updated))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ac773248b4c6e67e$export$92161330b4f919c7), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: $83873e2ed2341e7f$var$EditIconStyled,
        onClick: openEditModal
    }, formatMessage($83873e2ed2341e7f$var$messages.edit_definition_prompt_text)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kYmM6.EngagementSpotlight), {
        isMigrated: true,
        engagementId: editButtonSpotlightId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, showEditModal && definitionCurationOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $46b3319f0a259942$export$ea8c8594ad1f3bf3), {
        curatedDefinitionScopeConfig: definitionCurationOptions.curatedDefinitionScopeConfig,
        closeEditModal: closeEditModal,
        onSaveEditModal: ()=>setDisplaySuccessFlag(true)
    })), displaySuccessFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cecfbe2a7b0bbf1$export$7475d9ffda76c69b), {
        onDismissed: ()=>setDisplaySuccessFlag(false)
    }));
};





const $2e40819cb273d646$var$AI_DEFINITION_TOGGLE_CACHE_KEY = 'atlassian.search-ai.ai-definition-toggle';
const $2e40819cb273d646$var$messages = (0, $kSwu1.defineMessages)({
    // messages to disable ALL definitions
    disable_definitions_more_icon_tooltip: {
        id: "search_ai.disable_definitions_more_icon_tooltip",
        defaultMessage: "See more actions"
    },
    disable_definitions_header: {
        id: "search_ai.disable_definitions_header",
        defaultMessage: "Don\u2019t recommend definitions at all"
    },
    disable_definitions_description: {
        id: "search_ai.disable_definitions_description",
        defaultMessage: "When this is on, we\u2019ll no longer automatically highlight terms and acronyms on any page. Only you will see these changes."
    },
    // accessible label for the See More actions button
    see_more_actions_button_label: {
        id: "search_ai.definitions_see_more_actions_label",
        defaultMessage: "See more actions"
    },
    // messages to disable SINGLE definition
    disable_definition_term_header: {
        id: "search_ai.disable_definition_term_header",
        defaultMessage: "Don\u2019t recommend this term"
    },
    disable_definition_term_description: {
        id: "search_ai.disable_definition_term_description",
        defaultMessage: "When this is on, we\u2019ll no longer automatically highlight this specific term on any page. Only you will see these changes."
    }
});
const $2e40819cb273d646$var$MoreIconStyled = ()=>/*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        label: (0, $ieeJu.expValEquals)('a11y-fixes-week1-june-2026', 'isEnabled', true) ? '' : 'definitions-disable-menu-button-icon',
        color: "var(--ds-icon-subtle, #505258)"
    });
const $2e40819cb273d646$var$styles = {
    root: "_39xV025R67 _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    dividerStyles: "_2IVJ4M6wH8 _22sfPnNvrM _3zygPU9r67"
};
const $2e40819cb273d646$export$6a23f0e401dcf4d9 = ()=>{
    const { commonAttributes: commonAttributes, definitionToggleEnabled: definitionToggleEnabled, fireAnalyticsEvent: fireAnalyticsEvent, readingAidsOptions: readingAidsOptions, sourceProduct: sourceProduct } = (0, $3hVWe.useAIAnswerContext)();
    const [definitionsDropdownMenuOpen, setDefinitionsDropdownMenuOpen] = (0, $cozmU.useState)(false);
    const [disableDefinitions, setDisableDefinitions] = (0, $cozmU.useState)(false); // the localStorage method to track whether all Definitions are disabled is different
    // between products so we need to get from the product whether Definitions have already been disabled by user
    (0, $cozmU.useEffect)(()=>{
        const definitionsDisabled = !!readingAidsOptions?.disableDefinitionsCallbacks?.getDefinitionsDisabled();
        setDisableDefinitions(definitionsDisabled); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const disableDefinitionsCallbacks = readingAidsOptions?.disableDefinitionsCallbacks; // need to account for non-platformized version
    const { menuOptions: readingAidsMenuOptions } = readingAidsOptions || {};
    const { cloudId: cloudId, query: keyPhrase, workspaceId: workspaceId } = commonAttributes;
    const cachedDefinitionTermDisabled = JSON.parse((0, $6JEx2.getSessionItem)($2e40819cb273d646$var$AI_DEFINITION_TOGGLE_CACHE_KEY) || '{}');
    const [disableDefinitionTerm, setDisableDefinitionTerm] = (0, $cozmU.useState)(cachedDefinitionTermDisabled.keyPhrase === keyPhrase);
    const { toggleDefinition: toggleDefinition } = (0, $8ed7fc4a26d403e8$export$6e73bcf8826d31a5)();
    const onToggleDefinitionTermDisable = async ()=>{
        try {
            setDisableDefinitionTerm((current)=>!current);
            await toggleDefinition({
                workspaceId: workspaceId,
                keyPhrase: keyPhrase,
                isDisabled: !disableDefinitionTerm,
                cloudId: cloudId,
                product: sourceProduct ?? ''
            });
            if (disableDefinitionTerm) (0, $6JEx2.deleteSessionItem)($2e40819cb273d646$var$AI_DEFINITION_TOGGLE_CACHE_KEY);
            else {
                fireAnalyticsEvent((0, $bc9bd53230eb9105$export$bfe6deae035e3ea7)(commonAttributes));
                (0, $6JEx2.setSessionItem)($2e40819cb273d646$var$AI_DEFINITION_TOGGLE_CACHE_KEY, JSON.stringify({
                    keyPhrase: keyPhrase
                }));
            }
        } catch (error) {
            setDisableDefinitionTerm((current)=>!current);
            fireAnalyticsEvent((0, $7abdbf6c5e9a205a$export$48200d71a3e25afe)(error, commonAttributes));
        }
    };
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editDefinitionEnabled = !!definitionCurationOptions;
    return /*#__PURE__*/ $cozmU.createElement((0, $3vgx3.default), {
        isOpen: definitionsDropdownMenuOpen,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
                ...props,
                appearance: "subtle",
                icon: $2e40819cb273d646$var$MoreIconStyled,
                ref: triggerRef,
                onClick: ()=>{
                    setDefinitionsDropdownMenuOpen(!definitionsDropdownMenuOpen);
                },
                testId: "definitions-menu-button",
                label: (0, $ieeJu.expValEquals)('a11y-fixes-week1-june-2026', 'isEnabled', true) ? formatMessage($2e40819cb273d646$var$messages.see_more_actions_button_label) : 'definitions-menu-button'
            }),
        shouldRenderToParent: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $2e40819cb273d646$var$styles.root,
        space: "space.100"
    }, disableDefinitionsCallbacks && /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xxsmall"
    }, formatMessage($2e40819cb273d646$var$messages.disable_definitions_header)), /*#__PURE__*/ $cozmU.createElement((0, $c0A7H.default), {
        onChange: ()=>{
            if (disableDefinitions) disableDefinitionsCallbacks.onEnableDefinitions();
            else disableDefinitionsCallbacks.onDisableDefinitions();
            setDisableDefinitions(!disableDefinitions);
        },
        isChecked: disableDefinitions,
        testId: "definitions-toggle-disable"
    })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, formatMessage($2e40819cb273d646$var$messages.disable_definitions_description))), readingAidsMenuOptions && readingAidsMenuOptions.length > 0 && readingAidsMenuOptions.map((option)=>/*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "xxsmall"
        }, formatMessage($2e40819cb273d646$var$messages.disable_definitions_header)), /*#__PURE__*/ $cozmU.createElement((0, $c0A7H.default), {
            onChange: option.onChange,
            isChecked: option.toggleState,
            testId: "definitions-toggle-disable"
        })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            color: "color.text.subtle",
            size: "small"
        }, formatMessage($2e40819cb273d646$var$messages.disable_definitions_description)))), definitionToggleEnabled && /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $2e40819cb273d646$var$styles.dividerStyles
    }), /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xxsmall"
    }, formatMessage($2e40819cb273d646$var$messages.disable_definition_term_header)), /*#__PURE__*/ $cozmU.createElement((0, $c0A7H.default), {
        onChange: onToggleDefinitionTermDisable,
        isChecked: disableDefinitionTerm,
        testId: "definition-term-toggle-disable"
    })), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, formatMessage($2e40819cb273d646$var$messages.disable_definition_term_description))), editDefinitionEnabled && /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $2e40819cb273d646$var$styles.dividerStyles
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), null, /*#__PURE__*/ $cozmU.createElement((0, $83873e2ed2341e7f$export$86ebf34eb079ac26), {
        onClose: ()=>setDefinitionsDropdownMenuOpen(false)
    })))));
};


























/* ai-options-menu-option-description.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $cf40e4c79dbf8b12$export$db2baac4fa175461 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _1UtDYzKGUX",
            __cmplp.className
        ])
    });
});


/* ai-options-menu-option-header.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $cfc0d4d5bed71987$export$9a3438b6f4e139e4 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _1UtDYzy7kJ",
            __cmplp.className
        ])
    });
});


/* ai-options-menu-option-text.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $4a54a9104e3371a1$export$7f1bcad9bf8084f8 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0aFT5vbt8w _39xV02dl5A",
            __cmplp.className
        ])
    });
});


/* ai-options-menu-option-toggle-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $65cb69414b015acd$export$832fe7bd333fb9fe = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _39xV02E6Kk",
            __cmplp.className
        ])
    });
});


/* ai-options-menu-option-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $228e66312c3bbf34$export$fb2fc14fe9185637 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu8kG2W _2Zuz6Q8HPE _1ZnuxbgVvo _39xV02sz7G _3iDTPbQ4SZ _0aFT5v1qpb _37wbyuI7V3",
            __cmplp.className
        ])
    });
});


/* ai-options-menu-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $0c13ad963d830321$export$e20ae3fbb1f307c3 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2mHwu8kG2W _3iDTPbQ4SZ _0Of8r25zaO _1wydGW5zaO",
            __cmplp.className
        ])
    });
});


const $dc65f6c7d761f529$var$messages = (0, $kSwu1.defineMessages)({
    definition_more_icon_tooltip: {
        id: "search_ai.definition_more_icon_tooltip",
        defaultMessage: "See more actions"
    }
});
const $dc65f6c7d761f529$var$renderOptionsMenuControl = ({ onChange: onChange, type: type, isChecked: isChecked })=>{
    switch(type){
        case 'toggle':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0A7H.default), {
                onChange: onChange,
                isChecked: isChecked,
                testId: "ai-answer-options-menu-toggle"
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    }
};
const $dc65f6c7d761f529$var$MoreIconStyled = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        label: "reading-aids-menu-button-icon",
        color: "var(--ds-icon-subtle, #505258)"
    });
const $dc65f6c7d761f529$var$AIOptionsMenuOption = ({ header: header, description: description, onChange: onChange, type: type, isChecked: isChecked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $228e66312c3bbf34$export$fb2fc14fe9185637), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4a54a9104e3371a1$export$7f1bcad9bf8084f8), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cfc0d4d5bed71987$export$9a3438b6f4e139e4), null, header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf40e4c79dbf8b12$export$db2baac4fa175461), null, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65cb69414b015acd$export$832fe7bd333fb9fe), null, $dc65f6c7d761f529$var$renderOptionsMenuControl({
        onChange: onChange,
        type: type,
        isChecked: isChecked
    })));
};
const $dc65f6c7d761f529$export$77d203904974193c = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isMenuOpen, setMenuOpen] = (0, $cozmU.useState)(false);
    const { readingAidsOptions: readingAidsOptions } = (0, $3hVWe.useAIAnswerContext)();
    const { menuOptions: menuOptions } = readingAidsOptions || {};
    const toggleMenuOpen = (0, $cozmU.useCallback)(()=>{
        setMenuOpen(!isMenuOpen);
    }, [
        isMenuOpen
    ]);
    return !!menuOptions?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        position: "bottom",
        content: formatMessage($dc65f6c7d761f529$var$messages.definition_more_icon_tooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        isOpen: isMenuOpen,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...props,
                appearance: "subtle",
                icon: $dc65f6c7d761f529$var$MoreIconStyled,
                ref: triggerRef,
                onClick: toggleMenuOpen,
                testId: "reading-aids-menu-button",
                label: "reading-aids-menu-button"
            }),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0c13ad963d830321$export$e20ae3fbb1f307c3), {
        onClick: (e)=>e.stopPropagation()
    }, menuOptions?.length && menuOptions.map((menuOption, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dc65f6c7d761f529$var$AIOptionsMenuOption, {
            header: formatMessage(menuOption.label),
            description: menuOption.description && formatMessage(menuOption.description),
            onChange: menuOption.onChange,
            isChecked: menuOption.toggleState,
            type: menuOption.type,
            key: index
        });
    })))) : null;
};


/* reading-aids-options-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $e24321bc9300cc4c$export$206d383e26348657 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_42Yu6B7dHp _4ApkO2dnbC _3iDTPbQ4SZ _4kiQYAVa5s",
            __cmplp.className
        ])
    });
});


const $abc4eda07ab786ae$export$77d2212db482996b = ()=>{
    const platformDisableOn = (0, $iDrrr.fg)('kd_definitions_confluence_enable_platform');
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e24321bc9300cc4c$export$206d383e26348657), null, serveDefinitionUXUpdates ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2e40819cb273d646$export$6a23f0e401dcf4d9), null) : platformDisableOn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f93224bfed589820$export$a025edc19ca0650a), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dc65f6c7d761f529$export$77d203904974193c), null));
};


const $9d2aaa34bd0047e7$var$DEFINITION_DIALOG_TITLE_ID = 'definition-dialog-title';
const $9d2aaa34bd0047e7$var$styles = {
    titleWrapper: "_37wbyuI7V3 _0hPCNLDIqT _313842kG2W _0adFHsNHnM _2XsHFMNHnM",
    titleWrapperUpdateStyles: "_3138428HPE _0adFHs5zaO _2XsHFM5zaO",
    definitionTitle: "_2sNsIg1kXk _1UtDYzy7kJ"
};
const $9d2aaa34bd0047e7$export$20a48ed23bb601ed = ()=>{
    const { commonAttributes: commonAttributes, baseQuery: baseQuery } = (0, $3hVWe.useAIAnswerContext)();
    const { query: query } = commonAttributes;
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    const isA11yDefinitionDialogRoleFixEnabled = (0, $ieeJu.expValEquals)('a11y-fixes-week1-june-2026', 'isEnabled', true);
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($9d2aaa34bd0047e7$var$styles.titleWrapper, serveDefinitionUXUpdates && $9d2aaa34bd0047e7$var$styles.titleWrapperUpdateStyles)
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $9d2aaa34bd0047e7$var$styles.definitionTitle,
        testId: "definition-answer-card-title",
        as: "h2",
        id: isA11yDefinitionDialogRoleFixEnabled ? $9d2aaa34bd0047e7$var$DEFINITION_DIALOG_TITLE_ID : undefined
    }, baseQuery ? baseQuery : query), /*#__PURE__*/ $cozmU.createElement((0, $abc4eda07ab786ae$export$77d2212db482996b), null));
};










/* reading-aids-follow-ups.tsx generated by @compiled/babel-plugin v2.0.0 */ 
























































const $da2203828d03b963$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    definition_open_chat_user_initial_query: {
        id: "search_ai.definitions_open_chat_initial_query",
        defaultMessage: "Define {term}"
    }
});







const $f634449b63e81159$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    reading_aids_follow_ups_user_initial_query: {
        id: "search_ai.reading_aids_follow_ups_initial_query",
        defaultMessage: "Define {term}"
    }
});


const $0fe3d8897fd30c46$var$styles = {
    followUpWrapperStyles: "_2Zuz6QNHnM _1ZnuxbNHnM _1wydGW2ADO",
    followUpWrapperUpdateStyles: "_2Zuz6Q5zaO _1Znuxb5zaO",
    dividerStyles: "_2IVJ4M6wH8 _22sfPnNvrM _3zygPU9r67"
};
const $0fe3d8897fd30c46$export$b5da368bdedbbfc7 = ()=>{
    const { isAnswered: isAnswered, commonAttributes: commonAttributes, onClose: onClose, readingAidsOptions: readingAidsOptions } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { query: query, answerString: answerString, followUps: followUps } = commonAttributes;
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [showAllFollowUps, setShowAllFollowups] = (0, $cozmU.useState)(false);
    const canExpand = followUps.length > 1;
    const visibleFollowUps = showAllFollowUps ? followUps : followUps.slice(0, 1);
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    const onFollowupsExpand = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $728210eecf84aa8d$export$e6174e7fdfd73609)({
            ...commonAttributes,
            expandButtonSource: 'follow-ups'
        }));
        setShowAllFollowups(!showAllFollowUps);
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        showAllFollowUps
    ]);
    const onFollowUpClick = (0, $cozmU.useCallback)((followUp)=>{
        if (readingAidsOptions?.onFollowUpCallback) {
            readingAidsOptions.onFollowUpCallback(followUp);
            return;
        }
        fireAnalyticsEvent((0, $234e19cc92be917b$export$f1956b3bd380b51e)({
            ...commonAttributes,
            followUpString: followUp
        }));
        publish({
            type: 'chat-new',
            source: 'reading-aids',
            data: {
                name: followUp.substring(0, 30),
                dialogues: [
                    {
                        human_message: {
                            content: formatMessage((0, $f634449b63e81159$export$defe85febe8b728c).reading_aids_follow_ups_user_initial_query, {
                                // query only contains the word that user asked
                                // we want to add the word "define" before it so it makes sense
                                // when this is moved to the chat
                                term: query
                            })
                        },
                        agent_message: {
                            content: answerString
                        }
                    }
                ],
                prompt: followUp
            }
        });
        onClose?.();
    }, [
        query,
        answerString,
        publish,
        formatMessage,
        onClose,
        readingAidsOptions,
        commonAttributes,
        fireAnalyticsEvent
    ]);
    if (!followUps?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($0fe3d8897fd30c46$var$styles.followUpWrapperStyles, serveDefinitionUXUpdates && $0fe3d8897fd30c46$var$styles.followUpWrapperUpdateStyles)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, serveDefinitionUXUpdates && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0fe3d8897fd30c46$var$styles.dividerStyles
    }), visibleFollowUps.map((followUp, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center",
            spread: serveDefinitionUXUpdates ? 'space-between' : undefined
        }, serveDefinitionUXUpdates ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            key: followUp,
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))),
            spacing: "compact",
            onClick: ()=>onFollowUpClick(followUp),
            testId: "definition-follow-up-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: 1,
            color: "color.text.subtle",
            weight: "medium"
        }, followUp)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eHdk6.FollowUpButton), {
            key: followUp,
            followUpIndex: index,
            followUpText: followUp,
            followUpType: "UNAVAILABLE",
            experienceId: "reading-aids",
            onClick: ()=>onFollowUpClick(followUp)
        }), index === 0 && canExpand && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            onClick: onFollowupsExpand,
            icon: (iconProps)=>showAllFollowUps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps,
                    color: "currentColor",
                    testId: "collapse-follow-ups-icon",
                    size: "small"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    ...iconProps,
                    color: "currentColor",
                    testId: "expand-follow-ups-icon",
                    size: "small"
                }),
            appearance: "subtle",
            label: showAllFollowUps ? (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true) ? 'Collapse follow ups' : 'Collapse follow ups button' : (0, $ieeJu.expValEquals)('a11y-fixes-week3-may-2026', 'isEnabled', true) ? 'Expand follow ups' : 'Expand follow ups button'
        }))), isAnswered && serveDefinitionUXUpdates && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1781bd9c74b8683a$export$dc40dedc9df6e59f), {
        prompt: formatMessage((0, $da2203828d03b963$export$defe85febe8b728c).definition_open_chat_user_initial_query, {
            // query only contains the highlighted word
            // we want to prefix the word "define" before
            // when a user's context is moved to chat
            term: query
        }),
        answerString: answerString,
        query: query,
        source: 'reading-aids'
    })));
};



/* reading-aids-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $7ab2fdf45d8a2d57$export$e0e6dbd6257adb05 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "",
            __cmplp.className
        ])
    });
});


var $aa616b6d75a0c7e9$export$c13e418beaf43d1c = /*#__PURE__*/ function(DefinitionAnswerState) {
    DefinitionAnswerState["LOADING"] = "loading";
    DefinitionAnswerState["ANSWERED"] = "answered";
    DefinitionAnswerState["ERRORED"] = "errored";
    return DefinitionAnswerState;
}({});




const $7220d3f091bca8d4$var$styles = {
    sourcesContainer: "_0Of8r2dnbC _1ZnuxbNHnM _1wydGW2ADO _2Zuz6QNHnM",
    openChatContainer: "_2Y7lL4NHnM _0xmtko2ADO"
};
const $7220d3f091bca8d4$var$MAX_SOURCES = 4;
const $7220d3f091bca8d4$var$noop = ()=>{};
const $7220d3f091bca8d4$var$OpenChat = ({ answerString: answerString, query: query })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!(0, $iDrrr.fg)('kd_definitions_open_chat')) return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $7220d3f091bca8d4$var$styles.openChatContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $1781bd9c74b8683a$export$dc40dedc9df6e59f), {
        prompt: formatMessage((0, $da2203828d03b963$export$defe85febe8b728c).definition_open_chat_user_initial_query, {
            // query only contains the highlighted word
            // we want to prefix the word "define" before
            // when a user's context is moved to chat
            term: query
        }),
        query: query,
        answerString: answerString,
        source: 'reading-aids'
    }));
};
const $7220d3f091bca8d4$export$9d3e24a5ad9e38ea = ()=>{
    const { commonAttributes: commonAttributes, callbacks: callbacks, fireAnalyticsEvent: fireAnalyticsEvent, readingAidsOptions: readingAidsOptions, isAnswered: isAnswered, showChatFollowUps: showChatFollowUps } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const enableSmartLinkSources = readingAidsOptions?.enableSmartLinkSources;
    const { searchSessionId: searchSessionId, sources: sources, answerString: answerString, query: query } = commonAttributes;
    const { definitionCurationOptions: definitionCurationOptions } = readingAidsOptions || {};
    const editDefinitionEnabled = !!definitionCurationOptions;
    const { serveExperiment: serveDefinitionsUXExp } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_definitions_ux_uplift_exp'
    });
    const serveDefinitionUXUpdates = serveDefinitionsUXExp && (0, $iDrrr.fg)('kd_definitions_ux_uplift_exp_gate');
    const sourceClickCallback = (0, $cozmU.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source.product),
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $57p4j.default), null, (props)=>/*#__PURE__*/ $cozmU.createElement((0, $7ab2fdf45d8a2d57$export$e0e6dbd6257adb05), {
            onClick: (e)=>e.stopPropagation(),
            ...props,
            "data-testId": "definition-answer-card"
        }, /*#__PURE__*/ $cozmU.createElement((0, $9d2aaa34bd0047e7$export$20a48ed23bb601ed), null), /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null), editDefinitionEnabled && !serveDefinitionUXUpdates && /*#__PURE__*/ $cozmU.createElement((0, $83873e2ed2341e7f$export$86ebf34eb079ac26), null), !serveDefinitionUXUpdates && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $7220d3f091bca8d4$var$styles.sourcesContainer
        }, /*#__PURE__*/ $cozmU.createElement((0, $ce789c5dd436d96e$export$bbbfd63fa7f32357), {
            sources: sources,
            searchSessionId: searchSessionId,
            onClickHandler: sourceClickCallback,
            limit: $7220d3f091bca8d4$var$MAX_SOURCES,
            verticalLayout: true,
            enableSmartLinkSources: enableSmartLinkSources,
            isReadingAids: true
        })), serveDefinitionUXUpdates && /*#__PURE__*/ $cozmU.createElement((0, $0c874a49d33f2b0f$export$63e4658af6ffde25), {
            sources: sources
        }), showChatFollowUps && /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $lPcf8.ErrorBoundary), null, /*#__PURE__*/ $cozmU.createElement((0, $0fe3d8897fd30c46$export$b5da368bdedbbfc7), null)), isAnswered && !serveDefinitionUXUpdates && /*#__PURE__*/ $cozmU.createElement($7220d3f091bca8d4$var$OpenChat, {
            answerString: answerString,
            query: query
        })), /*#__PURE__*/ $cozmU.createElement((0, $34e9b06075b84401$export$37858bd8fa3d5915), null)));
};
const $7220d3f091bca8d4$export$d1b852cfff73cbe8 = ()=>{
    const previousAnswerState = (0, $cozmU.useRef)();
    const { commonAttributes: commonAttributes, loading: loading, partialResponse: partialResponse, isAnswered: isAnswered, hasError: hasError, readingAidsOptions: readingAidsOptions } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const [continueLoadingAnimation, setContinueLoadingAnimation] = (0, $cozmU.useState)(true);
    const { source: source } = commonAttributes;
    const isStreaming = !!partialResponse;
    const { onAnswerStateChange: onAnswerStateChange = $7220d3f091bca8d4$var$noop, definitionLoadingConfig: definitionLoadingConfig } = readingAidsOptions || {};
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!loading) {
            const countdownRemainingAnimation = setTimeout(()=>{
                setContinueLoadingAnimation(false);
            }, 3000);
            return ()=>clearTimeout(countdownRemainingAnimation);
        }
    }, [
        loading
    ]);
    (0, $cozmU.useEffect)(()=>{
        // update answer state for external consumers
        // using a previous answer state to prevent multiple duplicate calls,
        // especially in the case of loading && streaming
        if ((0, $iDrrr.fg)('kd_definitions_answer_state_signal')) {
            if (hasError && previousAnswerState.current !== (0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).ERRORED) {
                onAnswerStateChange((0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).ERRORED);
                previousAnswerState.current = (0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).ERRORED;
                (0, $hsCD1.aiDefinitionsLoadUFOExperience).failure();
            } else if (isAnswered && previousAnswerState.current !== (0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).ANSWERED) {
                onAnswerStateChange((0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).ANSWERED);
                previousAnswerState.current = (0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).ANSWERED;
                (0, $hsCD1.aiDefinitionsLoadUFOExperience).success();
            } else if ((loading || isStreaming) && previousAnswerState.current !== (0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).LOADING) {
                onAnswerStateChange((0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).LOADING);
                previousAnswerState.current = (0, $aa616b6d75a0c7e9$export$c13e418beaf43d1c).LOADING;
            }
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        loading,
        isStreaming,
        isAnswered,
        hasError
    ]);
    const onLoadingAnimationShown = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $kSORO.onAIAnswerLoadingDialogShown)(commonAttributes, true)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fireAnalyticsEvent
    ]);
    if (loading || isStreaming) {
        if (definitionLoadingConfig) return /*#__PURE__*/ $cozmU.createElement((0, $183b5c97f283e9b6$export$c7f94e62a2f54f71), {
            width: definitionLoadingConfig.width
        });
         // will keep this old animation as a fallback in case definitionLoadingConfig is not passed in
        return /*#__PURE__*/ $cozmU.createElement((0, $kYeKA.DotAnimationLoader), {
            onAnimationShown: onLoadingAnimationShown,
            source: source,
            "data-testid": "ai-answer-animated-loader"
        });
    }
    return /*#__PURE__*/ $cozmU.createElement((0, $74af3b3d0be03000$export$f79f209cc21596d), {
        continueAnimation: continueLoadingAnimation
    }, /*#__PURE__*/ $cozmU.createElement((0, $43c2452d73591196$export$a9f6f8fd5598a12e), null, /*#__PURE__*/ $cozmU.createElement($7220d3f091bca8d4$export$9d3e24a5ad9e38ea, null)));
};









const $a393edda7edb3fe8$export$6220c1b7224eb2a2 = ()=>{
    const { isReadingAids: isReadingAids, commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { source: source } = commonAttributes;
    (0, $cozmU.useEffect)(()=>{
        (0, $a7513ed93542ee2f$export$a83a35d6598a5fb6).stop({
            customData: {
                isReadingAids: !!isReadingAids,
                source: source
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null);
};



var $9u8Y2 = parcelRequire("9u8Y2");







const $597405ac0b3b2570$export$cae33476d80498a = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'dropoff',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $c64593c9127399aa$export$e1c446b3b8b22ff = (props, dwellTime)=>{
    const { query: query, source: source } = props;
    return {
        action: 'hidden',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            dwellTime: dwellTime
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $68497448a8541103$export$835458994fc126e4 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'hidden',
        actionSubject: 'aiAnswerLoadingDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $3010e3f8742304a1$export$17e25c724e0ebb55 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'surfaced',
        actionSubject: 'aiAnswerDialog',
        actionSubjectId: 'queryIntent',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $4eab0bf5f1608099$export$c075b0a4ec670c87 = ({ isReadingAids: isReadingAids, sourceProduct: sourceProduct, dwellTime: dwellTime, loadTime: loadTime, fmpLoadTime: fmpLoadTime, ...props })=>{
    const { query: query, source: source, searchSessionId: searchSessionId } = props;
    return {
        action: 'unmounted',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            aiFeatureName: isReadingAids ? `Definitions ${sourceProduct ? `(${sourceProduct})` : ''}` : 'smartAnswers',
            aiInteractionId: isReadingAids ? undefined : searchSessionId,
            aiInteractionType: isReadingAids ? undefined : 'searchSessionId',
            dwellTime: dwellTime,
            loadTime: loadTime,
            fmpLoadTime: fmpLoadTime
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};





const $0f9647babe97feca$export$e9cccbc780a694f3 = (props)=>{
    const { query: query, source: source } = props;
    return {
        action: 'viewed',
        actionSubject: 'aiAnswerDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};








const $189f541bd063b636$export$bd496fce1657ba31 = ({ isStreamed: isStreamed, loadTime: loadTime, fmpLoadTime: fmpLoadTime, ...props })=>{
    const { query: query, answerString: answerString, source: source, errorState: errorState, errorCode: errorCode, networkErrorReason: networkErrorReason, networkErrorDetails: networkErrorDetails, backendFailureType: backendFailureType, streamEventsReceived: streamEventsReceived, networkErrorDuration: networkErrorDuration, extraAttributes: extraAttributes } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerError',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            isStreamed: isStreamed,
            loadTime: loadTime,
            fmpLoadTime: fmpLoadTime,
            errorState: errorState,
            ...(0, $iDrrr.fg)('kd_granular_network_errors') && {
                errorCode: errorCode,
                networkErrorReason: networkErrorReason,
                networkErrorDetails: networkErrorDetails,
                traceId: extraAttributes?.requestId,
                backendFailureType: backendFailureType,
                streamEventsReceived: streamEventsReceived,
                networkErrorDuration: networkErrorDuration
            }
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};



var $h0U7J = parcelRequire("h0U7J");




const $a92ce6609ffd286a$export$67b8bcd639e29c44 = (props, smartAnswersRoute)=>{
    const { query: query, source: source } = props;
    return {
        action: 'classified',
        actionSubject: 'aiAnswerRoute',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            smartAnswersRoute: smartAnswersRoute
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};


/* legacy-smart-answer-card.tsx generated by @compiled/babel-plugin v2.0.0 */ 
























const $63c93f29914d2a48$export$9402fab525dc0906 = ({ ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerExpand',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};



/* ai-answer-loading-dialog.tsx generated by @compiled/babel-plugin v2.0.0 */ 



























/* collapse.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $55fM8 = parcelRequire("55fM8");








var $dLFT2 = parcelRequire("dLFT2");


var $99F21 = parcelRequire("99F21");









/* blur.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 





const $c6d2a8016b60f18c$export$975a268f2c733e4 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2uo31fEoDO _313842dnbC _0adFHsHZdu _1DCdHidnbC _2XsHFMHZdu _0Bm75GdnbC _3iDTPbvLZJ _0jFU0VS40j _1mT5xdHE3j",
            __cmplp.className
        ])
    });
});


/* button-icon.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 





const $2e5a59e941d0fe31$export$e1c22a2ee2645e36 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ _1VJPcacqvQ",
            __cmplp.className
        ])
    });
});





const $be25ea10e9db0496$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    title_label: {
        id: "search_ai.smart_answer_card_title",
        defaultMessage: "Answer"
    },
    expand_label: {
        id: "search_ai.smart_answer_expand_label",
        defaultMessage: "Expand"
    },
    collapse_label: {
        id: "search_ai.smart_answer_collapse_label",
        defaultMessage: "Collapse"
    },
    ai_answer_generating_rovo: {
        id: "ai_answer_generating_rovo",
        defaultMessage: "Generating"
    },
    ai_answer_expand_tooltip: {
        id: "search_ai.ai_answer_expand_tooltip",
        defaultMessage: "Expand"
    },
    ai_answer_collapse_tooltip: {
        id: "search_ai.ai_answer_collapse_tooltip",
        defaultMessage: "Collapse"
    }
});


/* toggle-button.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 





const $5a0cb5fb375d30f7$export$d2b052e7b4be1756 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0wOv4Q7zJH _3iDTPbvLZJ",
            __cmplp.className
        ])
    });
});


const $70cd1a3bbfd7e400$var$styles = {
    container: "_4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS",
    expanded: "_0jFU0VIZbP",
    collapsed: "_0jFU0Vb1xp",
    pointerCursor: "_0wOv4Q7zJH",
    titleContainer: "_2sNsIg7NXe _1UtDYzKGUX _1kk5Tk7GSX _0Of8r25zaO _1ZnuxbNHnM _1wydGWPgdg _2Zuz6QNHnM",
    title: "_0GwItXDIqT _0jFU0VXjOh"
};
var $70cd1a3bbfd7e400$var$EXPANSION_STATE = /*#__PURE__*/ function(EXPANSION_STATE) {
    EXPANSION_STATE[EXPANSION_STATE["LOADING"] = 1] = "LOADING";
    // still computing if the threshold is crossed
    EXPANSION_STATE[EXPANSION_STATE["COLLAPSED"] = 2] = "COLLAPSED";
    // threshold crossed, render component collapsed
    EXPANSION_STATE[EXPANSION_STATE["EXPANDED"] = 3] = "EXPANDED";
    return EXPANSION_STATE;
}($70cd1a3bbfd7e400$var$EXPANSION_STATE || {});
const $70cd1a3bbfd7e400$export$78768a9af065a7b = ({ children: children, collapsed: collapsed, isLoading: isLoading, toggleCollapsedState: toggleCollapsedState = ()=>{}, expandWhenClickedAnywhere: expandWhenClickedAnywhere = false, isStreaming: isStreaming = false, disableCollapse: disableCollapse = false, callbacks: callbacks })=>{
    const [initialExpansionState, setInitialExpansionState] = (0, $cozmU.useState)(1);
    const threshold = 150;
    const collapseableContainerRef = (0, $cozmU.useCallback)((node)=>{
        if (!node || disableCollapse) return;
        const resizeObserver = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            // delay computation to ensure the observed node has rendered and the height reported is accurate
            setTimeout(()=>{
                const childHeight = node.getBoundingClientRect().height;
                if (isStreaming || isLoading || !Boolean(childHeight)) return;
                 // checking if the length of the answer is smaller than the collapse threshold
                if (childHeight <= threshold && initialExpansionState !== 3) setInitialExpansionState(3);
                else setInitialExpansionState(2);
            }, 100);
        }, 100));
        resizeObserver.observe(node);
    }, // make sure the dependancy array is empty,
    // this is to ensure the resizeObserver is registered just once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    (0, $cozmU.useEffect)(()=>{
        /**
     * if the answer has finished isLoading and the container is too small to collapse,
     * toggle collapsed state to false
     * this helps external components watching the boolean to know the actual state
     */ if (initialExpansionState === 3 && !isLoading && !isStreaming && collapsed || disableCollapse) {
            toggleCollapsedState();
            callbacks?.onExpandedByDefault?.();
        }
    }, [
        initialExpansionState,
        isLoading,
        isStreaming,
        collapsed,
        callbacks,
        toggleCollapsedState,
        disableCollapse
    ]);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const tooltipText = formatMessage(collapsed ? (0, $be25ea10e9db0496$export$defe85febe8b728c).ai_answer_expand_tooltip : (0, $be25ea10e9db0496$export$defe85febe8b728c).ai_answer_collapse_tooltip); // allow whole container clicks to expand when enabled
    const onContainerClickHandler = ()=>{
        if (expandWhenClickedAnywhere && collapsed) {
            callbacks?.onExpandClicked?.();
            toggleCollapsedState();
        }
    };
    const onClickHandler = (e)=>{
        // stop container click from being called
        e.stopPropagation();
        if (collapsed) callbacks?.onExpandClicked?.();
        else callbacks?.onCollapseClicked?.();
        toggleCollapsedState();
    }; /**
      * render the non collapsable version
      * - child container's height is lesser than the threshold
      * - collapsed card is externally disabled, ex: for a person card
      */ 
    if (initialExpansionState === 3 || disableCollapse) return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($70cd1a3bbfd7e400$var$styles.container, $70cd1a3bbfd7e400$var$styles.expanded)
    }, /*#__PURE__*/ $cozmU.createElement("div", null, !isLoading && /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        xcss: $70cd1a3bbfd7e400$var$styles.titleContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $70cd1a3bbfd7e400$var$styles.title
    }, formatMessage((0, $be25ea10e9db0496$export$defe85febe8b728c).title_label))), children));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($70cd1a3bbfd7e400$var$styles.container, collapsed ? $70cd1a3bbfd7e400$var$styles.collapsed : $70cd1a3bbfd7e400$var$styles.expanded, expandWhenClickedAnywhere && collapsed && $70cd1a3bbfd7e400$var$styles.pointerCursor),
        onClick: onContainerClickHandler
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: 'space-between',
        xcss: $70cd1a3bbfd7e400$var$styles.titleContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $70cd1a3bbfd7e400$var$styles.title
    }, formatMessage((0, $be25ea10e9db0496$export$defe85febe8b728c).title_label)), initialExpansionState === 2 && /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        position: 'bottom',
        content: tooltipText
    }, /*#__PURE__*/ $cozmU.createElement((0, $5a0cb5fb375d30f7$export$d2b052e7b4be1756), {
        onClick: onClickHandler,
        "data-testid": "expand-collapse-toggle"
    }, /*#__PURE__*/ $cozmU.createElement((0, $2e5a59e941d0fe31$export$e1c22a2ee2645e36), null, collapsed ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($dLFT2))), {
        color: "currentColor",
        spacing: "spacious",
        label: formatMessage((0, $be25ea10e9db0496$export$defe85febe8b728c).expand_label)
    }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($99F21))), {
        color: "currentColor",
        spacing: "spacious",
        label: formatMessage((0, $be25ea10e9db0496$export$defe85febe8b728c).collapse_label)
    }))))), /*#__PURE__*/ $cozmU.createElement("div", {
        ref: collapseableContainerRef
    }, children), initialExpansionState === 2 && collapsed && /*#__PURE__*/ $cozmU.createElement((0, $c6d2a8016b60f18c$export$975a268f2c733e4), null));
};


/* ai-answer-loading-stream.tsx generated by @compiled/babel-plugin v2.0.0 */ // vendored from packages/editor/editor-plugin-ai/src/experience-application/screens-with-logic/LoadingScreenWithLogic.tsx
// similar logic also exists in packages/editor/renderer/src/ui/Renderer/index.tsx
















const $0a9d8cb2ea1f3c14$var$styles = {
    container: "_4kiQYAMw9m _0Of8r22ADO _1ZnuxbNHnM _1wydGW2ADO _2Zuz6QNHnM",
    containerStylesWithoutStreamingExpand: "_4bt5LAnQyn _2WAcuGnQyn _0NUa3roaux"
};

const $0a9d8cb2ea1f3c14$var$ReactRenderer = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("7ydRw")).then(({ ReactRenderer: ReactRenderer })=>{
        return {
            default: ReactRenderer
        };
    }));
const $0a9d8cb2ea1f3c14$export$9799dac43580176f = ({ markdown: markdown })=>{
    const docContent = (0, $cozmU.useMemo)(()=>(0, $6rwn6.encodeAdf)(markdown, false), [
        markdown
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($0a9d8cb2ea1f3c14$var$styles.container, !(0, $iDrrr.fg)('kd_sain_enable_expand_when_streaming') && $0a9d8cb2ea1f3c14$var$styles.containerStylesWithoutStreamingExpand)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement($0a9d8cb2ea1f3c14$var$ReactRenderer, {
        document: docContent,
        nodeComponents: {
            status: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $e2862f0d359af03a$export$21553c57082a6434), props),
            // Preventing media and mediaSingle from rendering images due to security vulnerability: https://asecurityteam.atlassian.net/browse/VULN-1543153
            // Followup ticket to re-enable img rendering: https://hello.jira.atlassian.cloud/browse/CCSEARCH-4799
            ...!(0, $iDrrr.fg)('hybrid_orchestrator_enable_image_search') ? {
                media: ()=>/*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null),
                mediaSingle: ()=>/*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
            } : undefined
        }
    })));
};


/* ai-answer-search-loading-border.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 







const $a933b5b48b93d085$export$1be966180e49de50 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isStreaming: isStreaming, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1sx4jwu": (0, $9aYkv.default)(__cmplp.isStreaming ? `${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-100, 8px)"} 0` : '0px')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvD1Y8M _4FKVYES3mC _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _1mT5xdRAKS _24h04i2Njc _42Yu6B7LI7 _2OUyjtGk8v _1Oimfu1Y8M _4eDJc6wnwD _2OUbymzqbc _3Ku51Iogpp _3ScelF7Iub _1lBcDcUtRB _1L3m71eHuj _35I30Bgews _3dCYwDWVPG _3qT6l0RMbu _3fRV4Cdssy _0EnhYgHZdu _2Gfj6i1Y8M _0GBAIrogpp _2jfUf9yTPQ _47eTBtyTPQ _2WYcYGWVPG _39mJBjvQQr _3wEj0XoI2d",
            __cmplp.className
        ])
    });
});


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 


// vendored from packages/editor/editor-plugin-ai/src/ui/modal/styles.tsx
const $a4d43c012dcfdf53$var$GeneratingAnimation = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "var(--ds-text-brand, #1868DB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "var(--ds-text-brand, #1868DB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "var(--ds-text-brand, #1868DB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));
};
var $a4d43c012dcfdf53$export$2e2bcd8739ae039 = $a4d43c012dcfdf53$var$GeneratingAnimation;


/* generating-container.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 





const $8737e9a3ac95e059$export$b6aef1fd050b8edc = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0jFU0VaXQy _24h04i2Njc _0Of8r2NHnM _1ZnuxbNHnM _1wydGWdnbC _2Zuz6QNHnM",
            __cmplp.className
        ])
    });
});


/* generating-text.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 





const $196cb4b3d52f30e4$export$636ea4c09615ceed = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _2XsHFMFQfX _1UtDYzKGUX",
            __cmplp.className
        ])
    });
});


const $1045f8dfe3504936$var$styles = {
    scroll: "_0NUa3rb1xp _0Of8r25zaO _2WAcuGIZbP _4bt5LAnQyn _0Fz5g59IY0"
};
const $1045f8dfe3504936$export$73cae3a70b740900 = ({ collapsed: collapsed, toggleCollapsedState: toggleCollapsedState, callbacks: callbacks })=>{
    const { commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3hVWe.useAIAnswerContext)();
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent((0, $kSORO.onAIAnswerLoadingDialogShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1045f8dfe3504936$var$LegacySmartAnswerLoadingDialog, {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        callbacks: callbacks
    });
};
const $1045f8dfe3504936$var$LegacySmartAnswerLoadingDialog = ({ collapsed: collapsed = true, toggleCollapsedState: toggleCollapsedState, callbacks: callbacks })=>{
    const { partialResponse: partialResponse, queryReasoning: queryReasoning, isReadingAids: isReadingAids, onClose: onClose } = (0, $3hVWe.useAIAnswerContext)();
    const { serveExperiment: serveSAINReasoningExperiment } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_sain_reasoning_exp'
    });
    const isQuickSearch = Boolean(!isReadingAids && onClose);
    if (!partialResponse || partialResponse?.format !== (0, $hpFQM.NLPSearchResultFormat).MARKDOWN) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a933b5b48b93d085$export$1be966180e49de50), {
        isStreaming: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8737e9a3ac95e059$export$b6aef1fd050b8edc), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a4d43c012dcfdf53$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $196cb4b3d52f30e4$export$636ea4c09615ceed), null, serveSAINReasoningExperiment && queryReasoning ? queryReasoning : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $cb86z.messages).ai_answer_generating_rovo))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $78943e0b983101cb$export$9e8b51119c9a7742), null));
    if (isQuickSearch) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a933b5b48b93d085$export$1be966180e49de50), {
        isStreaming: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1045f8dfe3504936$var$styles.scroll
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0a9d8cb2ea1f3c14$export$9799dac43580176f), {
        markdown: partialResponse.partialNlpResult
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $78943e0b983101cb$export$9e8b51119c9a7742), null))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a933b5b48b93d085$export$1be966180e49de50), {
        isStreaming: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70cd1a3bbfd7e400$export$78768a9af065a7b), {
        collapsed: collapsed,
        isLoading: true,
        isStreaming: true,
        expandWhenClickedAnywhere: true,
        toggleCollapsedState: toggleCollapsedState,
        callbacks: callbacks
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0a9d8cb2ea1f3c14$export$9799dac43580176f), {
        markdown: partialResponse.partialNlpResult
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $78943e0b983101cb$export$9e8b51119c9a7742), null))));
};









/* ai-answer-search-border.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 







const $af4c4d6333fdd634$export$f2207ab910ac3fa8 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, isStreaming: isStreaming, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ibnsxm": (0, $9aYkv.default)(__cmplp.isLoading || __cmplp.isStreaming ? 'conic-gradient( from var(--gradient-angle, 45deg), #BF63F3, #FFA900 25%, #0469FF 67%, #0065FF, #BF63F3)' : "var(--ds-surface-overlay, #FFFFFF)"),
            "--_10yp470": (0, $9aYkv.default)(__cmplp.isLoading || __cmplp.isStreaming ? 'rotate 3s infinite linear' : 'rotate-end 3s 1 linear')
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _30huDKOeNX _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _1mT5xdRAKS _24h04i2Njc _42Yu6B7LI7 _1OimfuKxmn _4eDJc6iSDY _2OUbym3Aaw _3Ku51Iogpp _3ScelF7Iub _1lBcDcUtRB _1L3m71eHuj _35I30Bgews _3dCYwDWVPG _3qT6l0RMbu _3fRV4Cdssy _0EnhYgHZdu _2Gfj6iKxmn _0GBAIrogpp _2jfUf9yTPQ _47eTBtyTPQ _2WYcYGWVPG _39mJBjvQQr _3wEj0XoI2d",
            __cmplp.className
        ])
    });
});



const $4405991c63379ccf$var$styles = {
    spacer: "_0jFU0VEbN9 _0Of8r2kG2W",
    errorContainer: "_3138422ADO _1DCdHi5zaO",
    sourcesContainer: "_0Of8r2dnbC _1ZnuxbNHnM _1wydGW2ADO _2Zuz6QNHnM",
    scroll: "_0NUa3rzY1C _4bt5LAnQyn _2WAcuGIZbP _0Fz5g59IY0"
};
const $4405991c63379ccf$var$MAX_SOURCES = 4;
const $4405991c63379ccf$export$cf72ef8498afcbc2 = ({ LoadingWrapper: LoadingWrapper, DialogWrapper: DialogWrapper, onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange })=>{
    const { commonAttributes: commonAttributes, callbacks: callbacks, loading: loading, isReadingAids: isReadingAids, onClose: onClose, hasError: hasError, initiallyExpanded: initiallyExpanded } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { query: query } = commonAttributes;
    const { answerFormat: answerFormat } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const [collapsed, setCollapsed] = (0, $cozmU.useState)(true);
    const isQuickSearch = Boolean(!isReadingAids && onClose); // reset on each new query
    (0, $cozmU.useEffect)(()=>{
        setCollapsed(!initiallyExpanded); // Notify parent context of initial state
        onAnswerExpandedChange?.(!initiallyExpanded);
    }, [
        query,
        initiallyExpanded,
        onAnswerExpandedChange
    ]); // Call onFMPReached when answer is loaded
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !hasError) onFMPReached?.();
    }, [
        loading,
        hasError,
        onFMPReached
    ]);
    const toggleCollapsedState = ()=>{
        if (collapsed) fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).EXPAND_CLICKED,
            commonAttributes: commonAttributes
        });
        setCollapsed(!collapsed); // Notify parent context of state change
        onAnswerExpandedChange?.(!collapsed);
    };
    const analyticsCallbacks = {
        onExpandedByDefault: ()=>fireAnalyticsEvent((0, $63c93f29914d2a48$export$9402fab525dc0906)(commonAttributes)),
        onExpandClicked: ()=>fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)(commonAttributes)),
        onCollapseClicked: ()=>fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)(commonAttributes))
    };
    const sourceClickCallback = (0, $cozmU.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source.product),
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks
    ]);
    if (loading) return /*#__PURE__*/ $cozmU.createElement(LoadingWrapper, null, // disable collapse/expand when streaming for quick search
    isQuickSearch ? /*#__PURE__*/ $cozmU.createElement((0, $1045f8dfe3504936$export$73cae3a70b740900), null) : /*#__PURE__*/ $cozmU.createElement((0, $1045f8dfe3504936$export$73cae3a70b740900), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        callbacks: analyticsCallbacks
    }));
    let aiAnswerContent = /*#__PURE__*/ $cozmU.createElement((0, $70cd1a3bbfd7e400$export$78768a9af065a7b), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        expandWhenClickedAnywhere: true,
        isLoading: false,
        callbacks: analyticsCallbacks
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    if (hasError) aiAnswerContent = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4405991c63379ccf$var$styles.errorContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    else if (isQuickSearch || answerFormat === (0, $hpFQM.NLPSearchResultFormat).JSON) aiAnswerContent = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4405991c63379ccf$var$styles.spacer
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: isQuickSearch ? $4405991c63379ccf$var$styles.scroll : undefined
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null)));
    return /*#__PURE__*/ $cozmU.createElement(DialogWrapper, null, /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: false,
        isStreaming: false
    }, aiAnswerContent, !hasError && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4405991c63379ccf$var$styles.sourcesContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $ce789c5dd436d96e$export$bbbfd63fa7f32357), {
        sources: commonAttributes.sources,
        searchSessionId: commonAttributes.searchSessionId,
        onClickHandler: sourceClickCallback,
        limit: $4405991c63379ccf$var$MAX_SOURCES,
        enableSmartLinkSources: true
    })), /*#__PURE__*/ $cozmU.createElement((0, $34e9b06075b84401$export$37858bd8fa3d5915), null)));
};


/* legacy-smart-answer-card-without-streaming-expand.tsx generated by @compiled/babel-plugin v2.0.0 */ 

































const $d365ffe2a496da37$var$styles = {
    spacer: "_0jFU0VEbN9 _0Of8r2kG2W",
    errorContainer: "_3138422ADO _1DCdHi5zaO",
    sourcesContainer: "_0Of8r2dnbC _1ZnuxbNHnM _1wydGW2ADO _2Zuz6QNHnM"
};
const $d365ffe2a496da37$var$MAX_SOURCES = 4;
const $d365ffe2a496da37$export$b054d5cce3d1302d = ({ LoadingWrapper: LoadingWrapper, DialogWrapper: DialogWrapper, onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange })=>{
    const { commonAttributes: commonAttributes, callbacks: callbacks, loading: loading, isReadingAids: isReadingAids, onClose: onClose, hasError: hasError, initiallyExpanded: initiallyExpanded } = (0, $3hVWe.useAIAnswerContext)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { answerFormat: answerFormat, query: query } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const [collapsed, setCollapsed] = (0, $cozmU.useState)(true);
    const isQuickSearch = Boolean(!isReadingAids && onClose); // reset on each new query
    (0, $cozmU.useEffect)(()=>{
        setCollapsed(!initiallyExpanded); // Notify parent context of initial state
        onAnswerExpandedChange?.(!initiallyExpanded);
    }, [
        query,
        initiallyExpanded,
        onAnswerExpandedChange
    ]); // Call onFMPReached when answer is loaded
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !hasError) onFMPReached?.();
    }, [
        loading,
        hasError,
        onFMPReached
    ]);
    const toggleCollapsedState = ()=>{
        if (collapsed) fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).EXPAND_CLICKED,
            commonAttributes: commonAttributes
        });
        setCollapsed(!collapsed); // Notify parent context of state change
        onAnswerExpandedChange?.(!collapsed);
    };
    const analyticsCallbacks = {
        onExpandedByDefault: ()=>fireAnalyticsEvent((0, $63c93f29914d2a48$export$9402fab525dc0906)(commonAttributes)),
        onExpandClicked: ()=>fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)(commonAttributes)),
        onCollapseClicked: ()=>fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)(commonAttributes))
    };
    const sourceClickCallback = (0, $cozmU.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source.product),
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks
    ]);
    if (loading) return /*#__PURE__*/ $cozmU.createElement(LoadingWrapper, null, /*#__PURE__*/ $cozmU.createElement((0, $1045f8dfe3504936$export$73cae3a70b740900), null));
    let aiAnswerContent = /*#__PURE__*/ $cozmU.createElement((0, $70cd1a3bbfd7e400$export$78768a9af065a7b), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        expandWhenClickedAnywhere: true,
        isLoading: false,
        callbacks: analyticsCallbacks
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    if (hasError) aiAnswerContent = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d365ffe2a496da37$var$styles.errorContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    else if (isQuickSearch || answerFormat === (0, $hpFQM.NLPSearchResultFormat).JSON) aiAnswerContent = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d365ffe2a496da37$var$styles.spacer
    }), /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    return /*#__PURE__*/ $cozmU.createElement(DialogWrapper, null, /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: false,
        isStreaming: false
    }, aiAnswerContent, !hasError && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $d365ffe2a496da37$var$styles.sourcesContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $ce789c5dd436d96e$export$bbbfd63fa7f32357), {
        sources: commonAttributes.sources,
        searchSessionId: commonAttributes.searchSessionId,
        onClickHandler: sourceClickCallback,
        limit: $d365ffe2a496da37$var$MAX_SOURCES,
        enableSmartLinkSources: true
    })), /*#__PURE__*/ $cozmU.createElement((0, $34e9b06075b84401$export$37858bd8fa3d5915), null)));
};


/* smart-answer-card.tsx generated by @compiled/babel-plugin v2.0.0 */ 
























const $fdc9836a17fb59bc$export$22fa983d82ded8f8 = (text)=>{
    if (!text || typeof text !== 'string') return null;
    // Normalize the text by trimming extra whitespace
    const normalizedText = text.trim();
    // Regular expressions to match various date formats, including day of the week
    const datePatterns = [
        // Date ranges (e.g., "May 5th to May 7th, 2025")
        /\b(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)?,?\s*(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2}(?:st|nd|rd|th)?\s+to\s+(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)?,?\s*(?:January|February|March|April|May|June|July|August|September|October|November|December)?\s*\d{1,2}(?:st|nd|rd|th)?,?\s+\d{4}\b/i,
        // Day of the week with full date (e.g., "Monday, May 26th")
        /\b(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday),?\s+(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2}(?:st|nd|rd|th)?\b/i,
        // Full dates with year (e.g., "May 26, 2025")
        /\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2},\s+\d{4}\b/i,
        // Dates with ordinals (e.g., "June 30th")
        /\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{1,2}(?:st|nd|rd|th)?\b/i,
        // Month and year formats (e.g., "March 2025")
        /\b(?:January|February|March|April|May|June|July|August|September|October|November|December)\s+\d{4}\b/i
    ];
    // Loop through patterns and try to find a match
    for (const pattern of datePatterns){
        const match = normalizedText.match(pattern);
        if (match) return match[0]; // Return the matched date or date range
    }
    // If no date is found, return null
    return null;
};


const $d32a7f1947667167$export$9df94c77b0746c3c = (answerStr)=>{
    if (!answerStr || typeof answerStr !== 'string') return null;
    // Remove extra whitespace and normalize
    const normalizedText = answerStr.trim().replace(/\s+/g, ' ');
    // Too short to be an address
    if (normalizedText.length < 5) return null;
    // Comprehensive address pattern
    // This pattern supports:
    // - Street numbers and names
    // - Unit numbers (e.g., #123, Apt 123, Suite 123)
    // - City/region/state names
    // - Optional state abbreviations (e.g., CA, TX, NSW)
    // - Optional postal/ZIP codes
    // - Optional country names
    const addressPattern = /\b\d{1,5}\s+[\w\s\.,\-#]+(?:#\d+|,\s*(?:Apt|Suite|Unit|Room|Fl|Floor)?\s*\d+)?\s*,\s*[\w\s]+,\s*[A-Z]{2,3}(?:\s*\d{4,5}(?:-\d{4})?)?(?:,\s*[A-Za-z\s]+)?\b/i;
    // Match the address in the text
    const match = normalizedText.match(addressPattern);
    if (match) return match[0]; // Return the matched address
    // If no match is found, return null
    return null;
};





/* DateCard.tsx generated by @compiled/babel-plugin v2.0.0 */ 



















const $52b306ea8d9fa88f$export$732cac0318736348 = (props)=>{
    const { query: query, answerString: answerString, source: source, selectedTab: selectedTab } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerTab',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            selectedTab: selectedTab
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};















var $hMjUh = parcelRequire("hMjUh");

const $bf094e7523adfeb4$export$1aa02cade2c95a15 = ({ children: children, selectedTabIndex: selectedTabIndex, onChange: onChange })=>{
    const handleChange = (0, $cozmU.useCallback)((index)=>{
        onChange?.(index);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMjUh.default), {
        onChange: handleChange,
        selected: selectedTabIndex ?? 0,
        id: "ai-answer-tabs"
    }, children);
};


/* ai-tabs-header.tsx generated by @compiled/babel-plugin v2.0.0 */ 


















var $bxtKM = parcelRequire("bxtKM");

var $dkVNA = parcelRequire("dkVNA");





const $e6b6c44db5d7c309$var$styles = {
    fullHeight: "_0jFU0VN91d",
    tabListAndButtonInline: "_2Zuz6Q5zaO _1Znuxb5zaO _0Of8r2gVvo _3X5xyYjOvk"
};
const $e6b6c44db5d7c309$export$29246287a2faf86e = ({ collapsed: collapsed, onExpandCollapseButtonClick: onExpandCollapseButtonClick, showSourcesTab: showSourcesTab })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        testId: "ai-tabs-header",
        xcss: $e6b6c44db5d7c309$var$styles.tabListAndButtonInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dkVNA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5OgwG.messages).ai_answer_card_tab_ai_answer)), showSourcesTab ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5OgwG.messages).ai_answer_card_tab_sources)) : null), typeof collapsed === 'boolean' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: collapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))),
        label: formatMessage(collapsed ? (0, $5OgwG.messages).ai_answer_card_expand_button : (0, $5OgwG.messages).ai_answer_card_collapse_button),
        spacing: "compact",
        onClick: onExpandCollapseButtonClick
    }) : null);
};
const $e6b6c44db5d7c309$export$fe213eac7ac2fc44 = ({ collapsed: collapsed, onExpandCollapseButtonClick: onExpandCollapseButtonClick, sources: sources })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        spread: "space-between",
        testId: "ai-tabs-header-with-sources-stack",
        xcss: $e6b6c44db5d7c309$var$styles.tabListAndButtonInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dkVNA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5OgwG.messages).ai_answer_card_tab_ai_answer)), sources && sources.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f0122fe4f75fa739$export$ebff7094edd1bb81), {
        sources: sources
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $5OgwG.messages).ai_answer_card_tab_sources_with_pluralization,
        values: {
            sourcesCount: sources.length
        }
    })))) : null), typeof collapsed === 'boolean' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: collapsed ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))),
        label: formatMessage(collapsed ? (0, $5OgwG.messages).ai_answer_card_expand_button : (0, $5OgwG.messages).ai_answer_card_collapse_button),
        spacing: "compact",
        onClick: onExpandCollapseButtonClick
    }) : null);
};


/* ai-tabs-panel.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $22LbG = parcelRequire("22LbG");

const $5de67d1ea6e1b326$var$styles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _1wydGWgVvo _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r28HPE",
    rootCollapsed: "_0jFU0Vv6H3 _3X9j4qyIAw",
    rootCollapsedWithReadMore: "_4bt5LAnQyn _2WAcuGnQyn _0jFU0VaXQy _39HuIbz8Lp _1ANEUSLRg7 _3X9j4qyIAw",
    rootExpanded: "_4kiQYAJK6w",
    fullWidth: "_39xV02N91d"
};
const $5de67d1ea6e1b326$export$43f4112a26740715 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, collapsed: collapsed, showReadMoreButton: showReadMoreButton = false, xcss: xcss }, ref)=>{
    const tabPanelAttributes = (0, $22LbG.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ...tabPanelAttributes,
        ref: ref,
        xcss: xcss ?? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $w6R6I.cx)($5de67d1ea6e1b326$var$styles.root, collapsed ? showReadMoreButton ? $5de67d1ea6e1b326$var$styles.rootCollapsedWithReadMore : $5de67d1ea6e1b326$var$styles.rootCollapsed : $5de67d1ea6e1b326$var$styles.rootExpanded)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $5de67d1ea6e1b326$var$styles.fullWidth
    }, children));
});
































function $f708b07cf4208d3d$export$257180ca8df15f46() {
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { callbacks: callbacks, commonAttributes: commonAttributes, fireAnalyticsEvent: fireAnalyticsEvent } = (0, $3hVWe.useAIAnswerContext)();
    const { searchSessionId: searchSessionId, sources: sources } = commonAttributes;
    const sourceClickCallback = (0, $cozmU.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source.product),
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        callbacks,
        fireSAINUsageEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        rowSpace: "space.100",
        shouldWrap: true,
        space: "space.050"
    }, sources.map((source, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1b1a8e20e360a5ba$export$c74cbf75d6285884), {
            index: index,
            key: `search-ai-answer-source-${index}`,
            source: source,
            searchSessionId: searchSessionId,
            onClickHandler: sourceClickCallback,
            enableSmartLinkSources: true
        }))))));
}


var $c944907a7c3cf04d$exports = {};
$c944907a7c3cf04d$exports = new URL("calendar-dark.a0ed3c18.svg", import.meta.url).toString();


var $b023a6dd3172b3f3$exports = {};
$b023a6dd3172b3f3$exports = new URL("calendar-light.caa4677f.svg", import.meta.url).toString();














const $66672200df25afcb$var$defaultKnowledgeCardActionsProps = {
    alignBlock: 'center',
    grow: 'fill',
    space: 'space.100'
};
const $66672200df25afcb$export$cb4f4efd621b33bb = (props)=>{
    const knowledgeCardActionsProps = {
        ...$66672200df25afcb$var$defaultKnowledgeCardActionsProps,
        ...props
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), knowledgeCardActionsProps);
};








const $3ed1a970e5fbfe5a$export$d7852a48c1d6ef5b = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, children);
};








const $73ede9aab4e60fda$export$ea5f007cec623a83 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), props);
};


/* KnowledgeCardMedia.tsx generated by @compiled/babel-plugin v2.0.0 */ 








const $92faf9abea946b60$var$knowledgeCardMediaStyles = {
    default: "_0bjKvDKxmn _2V7sgOdnbC _3iDTPbQ4SZ _0hPCNLDIqT",
    compact: "_0jFU0VUofl _39xV02Uofl",
    full: "_0jFU0VljYU _39xV02ljYU"
};
const $92faf9abea946b60$export$71b41532401d47f7 = ({ children: children, size: size })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($92faf9abea946b60$var$knowledgeCardMediaStyles.default, size === 'compact' ? $92faf9abea946b60$var$knowledgeCardMediaStyles.compact : $92faf9abea946b60$var$knowledgeCardMediaStyles.full)
    }, children);
};











const $e88096a7a02ac9fb$export$74276a28ff67aa9f = ({ children: children, size: size, color: color = 'color.text.brand' })=>{
    return size === 'compact' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: color,
        weight: "medium"
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "medium"
    }, children);
};








const $56831a9193164adc$export$663c4a200ce34343 = ({ children: children, color: color = 'color.text.subtle', ...textProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: color,
        ...textProps
    }, children);
};


const $6187e3537f7d74da$export$ecbf022f1f5d6f16 = ({ name: name, actions: actions, category: category, media: media, primaryDescription: primaryDescription, secondaryDescription: secondaryDescription, size: size, primaryDescriptionColor: primaryDescriptionColor, containerStyles: containerStyles })=>{
    const isCardCompact = size === 'compact';
    const actionsToDisplay = isCardCompact && actions && actions.length > 1 ? [
        actions[0]
    ] : actions;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i3wdq.KnowledgeCard), {
        name: name,
        space: isCardCompact ? 'space.150' : 'space.250',
        size: size,
        containerStyles: containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92faf9abea946b60$export$71b41532401d47f7), {
        size: size
    }, media), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73ede9aab4e60fda$export$ea5f007cec623a83), {
        space: isCardCompact ? 'space.100' : 'space.200'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73ede9aab4e60fda$export$ea5f007cec623a83), {
        space: 'space.100'
    }, size === 'full' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3ed1a970e5fbfe5a$export$d7852a48c1d6ef5b), null, category) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $73ede9aab4e60fda$export$ea5f007cec623a83), {
        space: isCardCompact ? 'space.0' : 'space.050'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e88096a7a02ac9fb$export$74276a28ff67aa9f), {
        size: size,
        color: primaryDescriptionColor
    }, primaryDescription), secondaryDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $56831a9193164adc$export$663c4a200ce34343), {
        color: isCardCompact ? 'color.text.subtlest' : 'color.text.subtle'
    }, secondaryDescription) : null)), actionsToDisplay && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $66672200df25afcb$export$cb4f4efd621b33bb), null, actionsToDisplay.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: `displayed-action-${index}`
        }, action)))));
};


const $2fce1c23afe6a7a0$var$messages = (0, $kSwu1.defineMessages)({
    knowledge_card_date_category: {
        id: "search_ai_knowledge_card_date_category",
        defaultMessage: "Date"
    }
});
const $2fce1c23afe6a7a0$var$styles = {
    fullHeight: "_0jFU0VN91d",
    containerStyles: "_0Of8r2Pgdg _1ZnuxbPgdg _2Zuz6QPgdg _1wydGWPgdg",
    disclaimer: "_1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r21Y8M"
};
const $2fce1c23afe6a7a0$export$94bf83cfe2387066 = ({ date: date })=>{
    const [selectedTab, setSelectedTab] = (0, $cozmU.useState)((0, $zzZbq.AIAnswerTab).AI_ANSWER);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { sources: sources } = commonAttributes;
    const handleTabChange = (0, $cozmU.useCallback)((selectedTabIndex)=>{
        const selectedTab = (0, $zzZbq.aiAnswerTabsOrder)[selectedTabIndex];
        setSelectedTab(selectedTab);
        fireAnalyticsEvent((0, $52b306ea8d9fa88f$export$732cac0318736348)({
            ...commonAttributes,
            selectedTab: selectedTab
        }));
    }, [
        setSelectedTab,
        fireAnalyticsEvent,
        commonAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        xcss: $2fce1c23afe6a7a0$var$styles.fullHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf094e7523adfeb4$export$1aa02cade2c95a15), {
        onChange: handleTabChange,
        selectedTabIndex: (0, $zzZbq.aiAnswerTabsOrder).indexOf(selectedTab)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e6b6c44db5d7c309$export$29246287a2faf86e), {
        showSourcesTab: sources.length > 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5de67d1ea6e1b326$export$43f4112a26740715), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6187e3537f7d74da$export$ecbf022f1f5d6f16), {
        name: "smart-answer-date-knowledge-card",
        category: formatMessage($2fce1c23afe6a7a0$var$messages.knowledge_card_date_category),
        primaryDescription: date,
        media: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($b023a6dd3172b3f3$exports))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($c944907a7c3cf04d$exports))),
            alt: ""
        }),
        size: "full",
        containerStyles: $2fce1c23afe6a7a0$var$styles.containerStyles
    })), sources.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5de67d1ea6e1b326$export$43f4112a26740715), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f708b07cf4208d3d$export$257180ca8df15f46), null)) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2fce1c23afe6a7a0$var$styles.disclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true,
        showCopyButton: true,
        copyText: date
    })));
};


/* LocationCard.tsx generated by @compiled/babel-plugin v2.0.0 */ 











var $fHs3z = parcelRequire("fHs3z");






































var $5121c4e1ddce602c$exports = {};
$5121c4e1ddce602c$exports = new URL("location-dark.395fc7dc.svg", import.meta.url).toString();


var $c35562e84e0660f8$exports = {};
$c35562e84e0660f8$exports = new URL("location-light.9d9cfd0a.svg", import.meta.url).toString();



const $3ebc882f10955e5e$var$messages = (0, $kSwu1.defineMessages)({
    knowledge_card_location_category: {
        id: "search_ai_knowledge_card_location_category",
        defaultMessage: "Location"
    },
    knowledge_card_location_google_maps_action: {
        id: "search_ai_knowledge_card_location_google_maps_action",
        defaultMessage: "Show on Google Maps"
    }
});
const $3ebc882f10955e5e$var$styles = {
    fullHeight: "_0jFU0VN91d",
    containerStyles: "_0Of8r2Pgdg _1ZnuxbPgdg _2Zuz6QPgdg _1wydGWPgdg",
    disclaimer: "_1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO _0Of8r21Y8M"
};
const $3ebc882f10955e5e$var$generateGoogleMapsLink = (location)=>{
    const encodedAddress = encodeURIComponent(location);
    return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
};
const $3ebc882f10955e5e$export$52cbb82455de8553 = ({ location: location })=>{
    const [selectedTab, setSelectedTab] = (0, $cozmU.useState)((0, $zzZbq.AIAnswerTab).AI_ANSWER);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const { brand: brand, commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString, query: query, queryHash: queryHash, searchSessionId: searchSessionId, sources: sources } = commonAttributes;
    const handleTabChange = (0, $cozmU.useCallback)((selectedTabIndex)=>{
        const selectedTab = (0, $zzZbq.aiAnswerTabsOrder)[selectedTabIndex];
        setSelectedTab(selectedTab);
        fireAnalyticsEvent((0, $52b306ea8d9fa88f$export$732cac0318736348)({
            ...commonAttributes,
            selectedTab: selectedTab
        }));
    }, [
        setSelectedTab,
        fireAnalyticsEvent,
        commonAttributes
    ]);
    const copyLocation = async (location)=>{
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).COPY_CLICKED,
            commonAttributes: commonAttributes
        });
        fireAnalyticsEvent((0, $6O5Et.onAIAnswerCopyButtonClicked)(commonAttributes));
        await navigator.clipboard.writeText(location);
    };
    const onClickGoogleMaps = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $1mpi6.onNonGenerativeAIAnswerResultShown)({
            answerString: answerString,
            brand: brand,
            query: query,
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            source: 'location_knowledge_card',
            answerCardType: (0, $zzZbq.AnswerCardType).LOCATION
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SHOW_ON_GOOGLE_MAPS_CLICKED,
            commonAttributes: commonAttributes
        });
    }, [
        answerString,
        brand,
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        query,
        queryHash,
        searchSessionId,
        commonAttributes
    ]);
    const googleMapsLink = $3ebc882f10955e5e$var$generateGoogleMapsLink(location);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignBlock: "stretch",
        grow: "fill",
        spread: "space-between",
        xcss: $3ebc882f10955e5e$var$styles.fullHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bf094e7523adfeb4$export$1aa02cade2c95a15), {
        onChange: handleTabChange,
        selectedTabIndex: (0, $zzZbq.aiAnswerTabsOrder).indexOf(selectedTab)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e6b6c44db5d7c309$export$29246287a2faf86e), {
        showSourcesTab: sources.length > 0
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5de67d1ea6e1b326$export$43f4112a26740715), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6187e3537f7d74da$export$ecbf022f1f5d6f16), {
        name: "smart-answer-location-knowledge-card",
        category: formatMessage($3ebc882f10955e5e$var$messages.knowledge_card_location_category),
        primaryDescription: location,
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
                href: googleMapsLink,
                onClick: onClickGoogleMaps
            }, formatMessage($3ebc882f10955e5e$var$messages.knowledge_card_location_google_maps_action)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))),
                label: "copy",
                onClick: ()=>copyLocation(location)
            })
        ],
        media: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($c35562e84e0660f8$exports))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($5121c4e1ddce602c$exports))),
            alt: ''
        }),
        size: "full",
        containerStyles: $3ebc882f10955e5e$var$styles.containerStyles
    })), sources.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5de67d1ea6e1b326$export$43f4112a26740715), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f708b07cf4208d3d$export$257180ca8df15f46), null)) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $3ebc882f10955e5e$var$styles.disclaimer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true,
        showCopyButton: true,
        copyText: location
    })));
};
































/* generating-container.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 





const $1bf3cc99cff7b950$export$b6aef1fd050b8edc = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0jFU0VaXQy _24h04i2Njc _0Of8r2NHnM _1ZnuxbNHnM _1wydGWdnbC _2Zuz6QNHnM",
            __cmplp.className
        ])
    });
});


/* generating-text.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ /* eslint-disable  @atlaskit/ui-styling-standard/no-exported-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 





const $81ee304817c850e7$export$636ea4c09615ceed = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _2XsHFMFQfX _1UtDYzKGUX",
            __cmplp.className
        ])
    });
});



const $005c7db905c9053b$var$styles = {
    spacer: "_0jFU0VEbN9 _0Of8r2kG2W",
    errorContainer: "_0Of8r22ADO",
    sourcesContainer: "_0Of8r2dnbC _1ZnuxbNHnM _1wydGW8HPE _2Zuz6QNHnM"
};
const $005c7db905c9053b$var$MAX_SOURCES = 4;
const $005c7db905c9053b$var$SmartAnswerLoadingDialog = ({ collapsed: collapsed, toggleCollapsedState: toggleCollapsedState, callbacks: callbacks })=>{
    const { commonAttributes: commonAttributes, partialResponse: partialResponse, queryReasoning: queryReasoning, smartAnswersRoute: smartAnswersRoute } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent((0, $kSORO.onAIAnswerLoadingDialogShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { serveExperiment: serveSAINReasoningExperiment } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_sain_reasoning_exp'
    }); // no need for the Collapse component when showing the ... generating animation
    if (!partialResponse || partialResponse?.format !== (0, $hpFQM.NLPSearchResultFormat).MARKDOWN || smartAnswersRoute === (0, $zzZbq.QueryIntent).DATE || smartAnswersRoute === (0, $zzZbq.QueryIntent).LOCATION) return /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: true,
        isStreaming: false
    }, /*#__PURE__*/ $cozmU.createElement((0, $1bf3cc99cff7b950$export$b6aef1fd050b8edc), null, /*#__PURE__*/ $cozmU.createElement((0, $a4d43c012dcfdf53$export$2e2bcd8739ae039), null), /*#__PURE__*/ $cozmU.createElement((0, $81ee304817c850e7$export$636ea4c09615ceed), null, serveSAINReasoningExperiment && queryReasoning ? queryReasoning : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $be25ea10e9db0496$export$defe85febe8b728c).ai_answer_generating_rovo))), /*#__PURE__*/ $cozmU.createElement((0, $78943e0b983101cb$export$9e8b51119c9a7742), null));
    return /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: true,
        isStreaming: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ $cozmU.createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ $cozmU.createElement((0, $70cd1a3bbfd7e400$export$78768a9af065a7b), {
        collapsed: collapsed,
        isLoading: true,
        isStreaming: true,
        expandWhenClickedAnywhere: true,
        toggleCollapsedState: toggleCollapsedState,
        callbacks: callbacks
    }, /*#__PURE__*/ $cozmU.createElement((0, $0a9d8cb2ea1f3c14$export$9799dac43580176f), {
        markdown: partialResponse.partialNlpResult
    })), /*#__PURE__*/ $cozmU.createElement((0, $78943e0b983101cb$export$9e8b51119c9a7742), null)))));
};
const $005c7db905c9053b$export$827de04ba3667da0 = ({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange })=>{
    const { isAnswered: isAnswered, hasError: hasError, commonAttributes: commonAttributes, callbacks: callbacks, smartAnswersRoute: smartAnswersRoute, loading: loading, initiallyExpanded: initiallyExpanded } = (0, $3hVWe.useAIAnswerContext)();
    const { answerFormat: answerFormat, answerString: answerString, query: query } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [collapsed, setCollapsed] = (0, $cozmU.useState)(false); // reset on each new query
    (0, $cozmU.useEffect)(()=>{
        setCollapsed(!initiallyExpanded); // Notify parent context of initial state
        onAnswerExpandedChange?.(!initiallyExpanded);
    }, [
        query,
        initiallyExpanded,
        onAnswerExpandedChange
    ]); // Call onFMPReached when answer is loaded
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !hasError) onFMPReached?.();
    }, [
        loading,
        hasError,
        onFMPReached
    ]);
    const toggleCollapsedState = ()=>{
        setCollapsed(!collapsed); // Notify parent context of state change
        onAnswerExpandedChange?.(!collapsed);
    };
    const analyticsCallbacks = {
        onExpandedByDefault: ()=>fireAnalyticsEvent((0, $63c93f29914d2a48$export$9402fab525dc0906)(commonAttributes)),
        onExpandClicked: ()=>{
            fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)(commonAttributes));
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).EXPAND_CLICKED,
                commonAttributes: commonAttributes
            });
        },
        onCollapseClicked: ()=>fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)(commonAttributes))
    };
    const sourceClickCallback = (0, $cozmU.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source.product),
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            commonAttributes: commonAttributes,
            sourceProduct: source.product || ''
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks
    ]);
    if (loading) return /*#__PURE__*/ $cozmU.createElement($005c7db905c9053b$var$SmartAnswerLoadingDialog, {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        callbacks: analyticsCallbacks
    });
    let answerContent = /*#__PURE__*/ $cozmU.createElement((0, $70cd1a3bbfd7e400$export$78768a9af065a7b), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        expandWhenClickedAnywhere: true,
        isLoading: false,
        callbacks: analyticsCallbacks
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    if (hasError) answerContent = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $005c7db905c9053b$var$styles.errorContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    else if (answerFormat === (0, $hpFQM.NLPSearchResultFormat).JSON) answerContent = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $005c7db905c9053b$var$styles.spacer
    }), /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    const dateInAnswer = (0, $fdc9836a17fb59bc$export$22fa983d82ded8f8)(answerString);
    if (isAnswered && smartAnswersRoute === (0, $zzZbq.QueryIntent).DATE && dateInAnswer) return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: false,
        isStreaming: false
    }, /*#__PURE__*/ $cozmU.createElement((0, $2fce1c23afe6a7a0$export$94bf83cfe2387066), {
        date: dateInAnswer
    })));
    const locationInAnswer = (0, $d32a7f1947667167$export$9df94c77b0746c3c)(answerString);
    if (isAnswered && smartAnswersRoute === (0, $zzZbq.QueryIntent).LOCATION && locationInAnswer) return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: false,
        isStreaming: false
    }, /*#__PURE__*/ $cozmU.createElement((0, $3ebc882f10955e5e$export$52cbb82455de8553), {
        location: locationInAnswer
    })));
    return /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: false,
        isStreaming: false
    }, answerContent, !hasError && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $005c7db905c9053b$var$styles.sourcesContainer,
        testId: "ai-answer-sources"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ce789c5dd436d96e$export$bbbfd63fa7f32357), {
        sources: commonAttributes.sources,
        searchSessionId: commonAttributes.searchSessionId,
        onClickHandler: sourceClickCallback,
        allowFreeflowLayout: true,
        limit: $005c7db905c9053b$var$MAX_SOURCES
    })), /*#__PURE__*/ $cozmU.createElement((0, $34e9b06075b84401$export$74b8b3463af67a4d), null));
};


/* smart-answer-card-without-streaming-expand.tsx generated by @compiled/babel-plugin v2.0.0 */ 

























































const $243c0d4568578f49$var$styles = {
    spacer: "_0jFU0VEbN9 _0Of8r2kG2W",
    errorContainer: "_0Of8r22ADO",
    sourcesContainer: "_0Of8r2dnbC _1ZnuxbNHnM _1wydGW8HPE _2Zuz6QNHnM"
};
const $243c0d4568578f49$var$MAX_SOURCES = 4;
const $243c0d4568578f49$var$SmartAnswerLoadingDialog = ()=>{
    const { commonAttributes: commonAttributes, partialResponse: partialResponse, queryReasoning: queryReasoning } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent((0, $kSORO.onAIAnswerLoadingDialogShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { serveExperiment: serveSAINReasoningExperiment } = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'kd_sain_reasoning_exp'
    }); // no need for the Collapse component when showing the ... generating animation
    if (!partialResponse || partialResponse?.format !== (0, $hpFQM.NLPSearchResultFormat).MARKDOWN) return /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: true,
        isStreaming: false
    }, /*#__PURE__*/ $cozmU.createElement((0, $1bf3cc99cff7b950$export$b6aef1fd050b8edc), null, /*#__PURE__*/ $cozmU.createElement((0, $a4d43c012dcfdf53$export$2e2bcd8739ae039), null), /*#__PURE__*/ $cozmU.createElement((0, $81ee304817c850e7$export$636ea4c09615ceed), null, serveSAINReasoningExperiment && queryReasoning ? queryReasoning : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $be25ea10e9db0496$export$defe85febe8b728c).ai_answer_generating_rovo))), /*#__PURE__*/ $cozmU.createElement((0, $78943e0b983101cb$export$9e8b51119c9a7742), null));
    return /*#__PURE__*/ $cozmU.createElement((0, $aYqz2.SearchAIAnalyticsContext), {
        data: (0, $572d81ab3ae88f65$export$b02bdd5f3105358f)({
            location: (0, $uY2pq.SearchAIAnalyticsContextLocation).SAIN_Q_AND_A_CARD,
            commonAttributes: commonAttributes
        })
    }, /*#__PURE__*/ $cozmU.createElement((0, $5HApy.SmartCardProvider), null, /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: true,
        isStreaming: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ $cozmU.createElement((0, $70cd1a3bbfd7e400$export$78768a9af065a7b), {
        collapsed: true,
        isLoading: true,
        isStreaming: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $0a9d8cb2ea1f3c14$export$9799dac43580176f), {
        markdown: partialResponse.partialNlpResult
    })), /*#__PURE__*/ $cozmU.createElement((0, $78943e0b983101cb$export$9e8b51119c9a7742), null)))));
};
const $243c0d4568578f49$var$AnswerCard = ({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange })=>{
    const { hasError: hasError, commonAttributes: commonAttributes, callbacks: callbacks, initiallyExpanded: initiallyExpanded, loading: loading } = (0, $3hVWe.useAIAnswerContext)();
    const { answerFormat: answerFormat, query: query } = commonAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [collapsed, setCollapsed] = (0, $cozmU.useState)(true); // reset on each new query
    (0, $cozmU.useEffect)(()=>{
        setCollapsed(!initiallyExpanded); // Notify parent context of initial state
        onAnswerExpandedChange?.(!initiallyExpanded);
    }, [
        query,
        initiallyExpanded,
        onAnswerExpandedChange
    ]); // Call onFMPReached when answer is loaded
    (0, $cozmU.useEffect)(()=>{
        if (!loading && !hasError) onFMPReached?.();
    }, [
        loading,
        hasError,
        onFMPReached
    ]);
    const toggleCollapsedState = ()=>{
        if (collapsed) fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).EXPAND_CLICKED,
            commonAttributes: commonAttributes
        });
        setCollapsed(!collapsed); // Notify parent context of state change
        onAnswerExpandedChange?.(!collapsed);
    };
    const analyticsCallbacks = {
        onExpandedByDefault: ()=>fireAnalyticsEvent((0, $63c93f29914d2a48$export$9402fab525dc0906)(commonAttributes)),
        onExpandClicked: ()=>fireAnalyticsEvent((0, $e14deeb67bd569aa$export$a499208a458c0e59)(commonAttributes)),
        onCollapseClicked: ()=>fireAnalyticsEvent((0, $5df1629f53f4597d$export$d5927f4d78af7f29)(commonAttributes))
    };
    const sourceClickCallback = (0, $cozmU.useCallback)((index, source, hostname)=>{
        fireAnalyticsEvent((0, $c581527c64231606$export$aef55698754fc321)({
            sourceIndex: index,
            hostname: hostname,
            sourceProduct: source.product || '',
            is3PSource: (0, $4Tg3t.isSourceProduct3P)(source.product),
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).SOURCE_CLICKED,
            sourceProduct: source.product || '',
            commonAttributes: commonAttributes
        });
        callbacks?.onAIAnswerSourceClick?.();
    }, [
        fireAnalyticsEvent,
        commonAttributes,
        fireSAINUsageEvent,
        callbacks
    ]);
    let answerContent = /*#__PURE__*/ $cozmU.createElement((0, $70cd1a3bbfd7e400$export$78768a9af065a7b), {
        collapsed: collapsed,
        toggleCollapsedState: toggleCollapsedState,
        expandWhenClickedAnywhere: true,
        isLoading: false,
        callbacks: analyticsCallbacks
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    if (hasError) answerContent = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $243c0d4568578f49$var$styles.errorContainer
    }, /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    else if (answerFormat === (0, $hpFQM.NLPSearchResultFormat).JSON) answerContent = /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $243c0d4568578f49$var$styles.spacer
    }), /*#__PURE__*/ $cozmU.createElement((0, $47d8550a555006e1$export$e2b54fc495614d59), null));
    return /*#__PURE__*/ $cozmU.createElement((0, $af4c4d6333fdd634$export$f2207ab910ac3fa8), {
        isLoading: false,
        isStreaming: false
    }, answerContent, !hasError && /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $243c0d4568578f49$var$styles.sourcesContainer,
        testId: "ai-answer-sources"
    }, /*#__PURE__*/ $cozmU.createElement((0, $ce789c5dd436d96e$export$bbbfd63fa7f32357), {
        sources: commonAttributes.sources,
        searchSessionId: commonAttributes.searchSessionId,
        onClickHandler: sourceClickCallback,
        allowFreeflowLayout: true,
        limit: $243c0d4568578f49$var$MAX_SOURCES
    })), /*#__PURE__*/ $cozmU.createElement((0, $34e9b06075b84401$export$74b8b3463af67a4d), null));
};
const $243c0d4568578f49$export$7d8a07a50ae14953 = ({ onFMPReached: onFMPReached, onAnswerExpandedChange: onAnswerExpandedChange })=>{
    const { loading: loading } = (0, $3hVWe.useAIAnswerContext)();
    return /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, loading ? /*#__PURE__*/ $cozmU.createElement($243c0d4568578f49$var$SmartAnswerLoadingDialog, null) : /*#__PURE__*/ $cozmU.createElement($243c0d4568578f49$var$AnswerCard, {
        onFMPReached: onFMPReached,
        onAnswerExpandedChange: onAnswerExpandedChange
    }));
};




// These are the element tags Lumina can render inside a <lumina>…</lumina> block. They mirror the
// ElementTag union in @atlassian/lumina (src/layout/element/types.ts), which we can't import
// directly since it isn't on a public subpath — so if Lumina adds or renames a tag, add it here too.
const $b47b63f9e1c9c8da$var$KNOWN_LUMINA_ELEMENT_TAGS = [
    'action-card',
    'carousel',
    'md',
    'people-entity',
    'people-entity-list',
    'project-highlights',
    'related-people',
    'smart-link',
    'smart-link-list'
];
const $b47b63f9e1c9c8da$var$TAG_MATCHERS = $b47b63f9e1c9c8da$var$KNOWN_LUMINA_ELEMENT_TAGS.map((tag)=>[
        tag,
        new RegExp(`<${tag}(?=[\\s/>]|$)`)
    ]);
const $b47b63f9e1c9c8da$export$4e3a85aba66b9a32 = (luminaBlockContents)=>{
    const found = new Set();
    for (const content of luminaBlockContents){
        if (!content) continue;
        for (const [tag, matcher] of $b47b63f9e1c9c8da$var$TAG_MATCHERS)if (matcher.test(content)) found.add(tag);
    }
    return Array.from(found).sort();
};




const $a52d76eb98115dba$export$e25821f3420be6ad = ({ answerString: answerString, smartAnswersRoute: smartAnswersRoute })=>{
    if (!answerString) return 0;
    const { parsedResult: parsedResult, parsedType: parsedType } = (0, $d325f5b9eeee6e40$export$d905ae2a714518e8)({
        answerString: answerString,
        smartAnswersRoute: smartAnswersRoute
    });
    switch(parsedType){
        case (0, $d227efab07c2b9f0$export$eae917983a0398aa).TEAM:
            return 'id' in parsedResult && parsedResult.id ? 1 : 0;
        case (0, $d227efab07c2b9f0$export$eae917983a0398aa).WHO:
        case (0, $d227efab07c2b9f0$export$eae917983a0398aa).PERSON:
        case (0, $d227efab07c2b9f0$export$eae917983a0398aa).AGENT:
        case (0, $d227efab07c2b9f0$export$eae917983a0398aa).WORK:
            return Array.isArray(parsedResult) ? parsedResult.length : 0;
        default:
            return 0;
    }
};








/**
 * Maps product filter key names to the display string to append to the query.
 * "google_drive" is mapped to "google" per product requirement.
 */ const $273cb466e56a9a66$var$PRODUCT_DISPLAY_NAME_MAP = {
    confluence: 'confluence',
    jira: 'jira',
    github: 'github',
    teams: 'teams',
    drive: 'google'
};
function $273cb466e56a9a66$export$90c8c71ce0c72494(query, selectedProduct, queryIntent) {
    if (!(0, $iDrrr.fg)('kd_team_26_sain_rewrite_query') || queryIntent !== (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY) return query;
    if (!selectedProduct || !(selectedProduct in $273cb466e56a9a66$var$PRODUCT_DISPLAY_NAME_MAP)) return query;
    return `${query} from ${$273cb466e56a9a66$var$PRODUCT_DISPLAY_NAME_MAP[selectedProduct]}`;
}


const $86daeed37675c499$var$styles = {
    root: "_1mT5xdRAKS"
};
const $86daeed37675c499$var$SearchAIDialogComponent = ({ query: query, setQuery: setQuery, additionalQueryContext: additionalQueryContext, cloudId: cloudId, orgId: orgId, getAIAnswer: getAIAnswer, onNavigate: onNavigate, onClose: onClose, advancedSearchUrl: advancedSearchUrl, searchSessionId: searchSessionId, userDetails: userDetails, wrapper: wrapper, loadingWrapper: loadingWrapper, source: source = 'unknown', isReadingAids: isReadingAids = false, readingAidsOptions: readingAidsOptions, extraAnalyticsAttributes: extraAnalyticsAttributes = {}, cardProviderProps: cardProviderProps, baseQuery: baseQuery = '', onLoad: onLoad, followUpsEnabled: followUpsEnabled, selectedFilters: selectedFilters, parsedFilters: parsedFilters, selectedProduct: selectedProduct, mappedProductFilter: mappedProductFilter, answerLoadingRef: answerLoadingRef, smartAnswersRoute: smartAnswersRoute, cardTemplate: cardTemplate = (0, $zzZbq.CardTemplate).DEFAULT, sourceProduct: sourceProduct, workspaceId: workspaceId, brand: brand = (0, $zzZbq.AiBrand).AI, closeParentDialog: closeParentDialog, callbacks: callbacks, isAdminHubAIEnabled: isAdminHubAIEnabled, definitionToggleEnabled: definitionToggleEnabled, showChatFollowUps: showChatFollowUps, showGenericFooter: showGenericFooter = false, initiallyExpanded: initiallyExpanded = false, experimentContext: experimentContext, queryIntentClassificationData: queryIntentClassificationData, referrer: referrer, traceHeaders: traceHeaders, floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef, onAnswerExpandedStateChange: onAnswerExpandedStateChange })=>{
    const intl = (0, $kSwu1.useIntl)();
    const locale = intl.locale;
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [dwellTracked, setDwellTracked] = (0, $cozmU.useState)(false);
    const dwellTrackedRef = (0, $cozmU.useRef)(false); // Guards onAIAnswerLoadingDialogHidden so it fires at most once per load. Reset
    // when a new query starts so a subsequent load can fire it again.
    const loadingHiddenTrackedRef = (0, $cozmU.useRef)(false);
    const partialResponseAbortControllerRef = (0, $cozmU.useRef)();
    const [isLuminaAnswer, setIsLuminaAnswer] = (0, $cozmU.useState)(false);
    const [luminaContentMap, setLuminaContentMap] = (0, $cozmU.useState)({});
    const [partialResponse, setPartialResponse] = (0, $cozmU.useState)();
    const [queryReasoning, setQueryReasoning] = (0, $cozmU.useState)(); // Structured research steps from rich `RESEARCH_STEP_*` traces
    const [researchSteps, setResearchSteps] = (0, $cozmU.useState)({});
    const [dynamicLayoutSubAgentMessages, setDynamicLayoutSubAgentMessages] = (0, $cozmU.useState)([]);
    const [tabHasFocus, setTabHasFocus] = (0, $cozmU.useState)(true);
    const [dwellTimer, setDwellTimer] = (0, $cozmU.useState)(null);
    const dwellTimerRef = (0, $cozmU.useRef)(null);
    const definitionDwellTimeRef = (0, $cozmU.useRef)(null);
    const definitionDwellTimeTrackedRef = (0, $cozmU.useRef)(false);
    const [answerStreamed, setAnswerStreamed] = (0, $cozmU.useState)(false);
    const isBlueLinkAnalyticsEnabled = (0, $iDrrr.fg)('kd_sain_blue_links_analytics');
    const [isFMPReached, setIsFMPReached] = (0, $cozmU.useState)(false);
    const [isFmpInViewport, setIsFmpInViewport] = (0, $cozmU.useState)(false);
    const [isAnswerExpanded, setIsAnswerExpanded] = (0, $cozmU.useState)(initiallyExpanded); // Tracks whether the user has minimized the answer card (via SmartAnswerCardMinimized's
    // "Hide answer" button). When minimized the answer is not visible to the user, so
    // we should not count this time toward FMP dwell metrics.
    const [isAnswerMinimized, setIsAnswerMinimized] = (0, $cozmU.useState)(false); // FMP-based dwell timer for analytics sizing
    if ((0, $iDrrr.fg)('kd_fmp_dwell_observer')) // fg check is stable between renders and won't cause issues with hook calls
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $06f67127312b8dc5$export$6dde22325042712e)({
        isEnabled: isFMPReached,
        // Treat a minimized answer the same as out-of-viewport — the user can't see
        // it so we shouldn't count it toward dwell.
        isInViewport: isFmpInViewport && !isAnswerMinimized,
        tabHasFocus: tabHasFocus,
        thresholdMs: (0, $eySxZ.SAIN_USAGE_DWELL_THRESHOLD),
        onDwellStart: ()=>{
            fireSAINUsageEvent({
                metCriteria: isAnswerExpanded ? (0, $bZMnB.SainAction).FMP_DWELL_START_EXPANDED : (0, $bZMnB.SainAction).FMP_DWELL_START,
                dwellTime: 0,
                commonAttributes: commonAttributes
            });
        },
        onDwellThreshold: (dwellTime)=>{
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).FMP_DWELL_REACHED,
                dwellTime: dwellTime,
                commonAttributes: commonAttributes,
                sourceProduct: sourceProduct
            });
        },
        onDwellEnd: (dwellTime)=>{
            fireSAINUsageEvent({
                metCriteria: (0, $bZMnB.SainAction).FMP_RESULT_EXITED,
                dwellTime: dwellTime,
                commonAttributes: commonAttributes,
                sourceProduct: sourceProduct
            });
        }
    });
    const [liked, setLiked] = (0, $cozmU.useState)(undefined);
    const [likesDisabled, setLikesDisabled] = (0, $cozmU.useState)(false);
    const [initialReported, setInitialReported] = (0, $cozmU.useState)(undefined);
    const [nlpSearch, setData] = (0, $cozmU.useState)((0, $hZTED.DEFAULT_EMPTY_NLP_SEARCH_STATE));
    const filtersRef = (0, $cozmU.useRef)(selectedFilters);
    const selectedProductRef = (0, $cozmU.useRef)(selectedProduct);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const resultRef = (0, $cozmU.useRef)(null);
    const initialLoadTs = (0, $cozmU.useRef)(Date.now()).current;
    const loadedTsRef = (0, $cozmU.useRef)();
    const fmpLoadedTsRef = (0, $cozmU.useRef)();
    const dwellTimeRef = (0, $cozmU.useRef)();
    const sainReverAllExperiment = (0, $cXtTj.default).getExperimentValue('sain_revert_all_experiment', 'enable', false);
    const kdSainTabsExperienceRevert = (0, $cXtTj.default).getExperimentValue('kd_sain_tabs_experience_revert', 'enable', false);
    const { serveExperiment: kdSainSmoothStreamingExperiment } = (0, $1XsRq.getSAINLayerFrontendExperiment)({
        abTestId: 'kd_sain_smooth_streaming_non_hello_exp'
    });
    const shouldServeTabsExperiment = sainReverAllExperiment || kdSainTabsExperienceRevert;
    const markLoadedTs = ()=>{
        loadedTsRef.current = Date.now();
        return loadedTsRef.current - initialLoadTs;
    };
    const fmpMarkLoadedTs = ()=>{
        if (fmpLoadedTsRef.current) return fmpLoadedTsRef.current - initialLoadTs;
    };
    const startViewportDwell = ()=>{
        dwellTimeRef.current = Date.now();
    };
    const markViewportDwell = ()=>{
        if (dwellTimeRef.current) return Date.now() - dwellTimeRef.current;
        return 0;
    };
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $cXLoX.useAIEventsInstrumentation)();
    const sessionId = (0, $f557ddd0ea926672$export$baca5c7d93c77000)({
        userId: userDetails.id || '',
        cloudId: cloudId,
        source: source
    });
    const activityClient = (0, $k8VpS.useActivityClient)('v3', 'people');
    const isAnswered = !loading && nlpSearch.errorState === null;
    const hasError = !loading && !!nlpSearch.errorState && nlpSearch.errorState !== (0, $htnqN.NLPSearchErrorState).Default;
    const answerString = nlpSearch.nlpResults?.length ? nlpSearch.nlpResults[0].nlpResult : nlpSearch.nlpResult || '';
    const answerFormat = nlpSearch.format;
    const followUps = nlpSearch.nlpFollowUpResults?.followUps;
    const errorStateSuggestedQueries = nlpSearch.nlpSuggestedQueries;
    const sources = nlpSearch.uniqueSources;
    const disclaimer = nlpSearch.disclaimer;
    const answerEditor = nlpSearch.nlpResultEditor;
    const extraAPIAnalyticsAttributes = nlpSearch.extraAPIAnalyticsAttributes;
    const authorityUiMetadata = nlpSearch.authority_ui_metadata;
    const requestId = nlpSearch.extraAPIAnalyticsAttributes?.requestId;
    const answerCardType = (0, $e8f4d0b6d7c43b83$export$694ee0cc469a8709)(isReadingAids, smartAnswersRoute);
    const isHelloValue = (0, $aTjYs.isHello)(cloudId); // Which inline-Lumina element types this answer contains, e.g. ['smart-link', 'smart-link-list'].
    const luminaContentTypesKey = (0, $cozmU.useMemo)(()=>(0, $iDrrr.fg)('kd_sain_enable_inline_lumina') ? (0, $b47b63f9e1c9c8da$export$4e3a85aba66b9a32)(Object.values(luminaContentMap)).join('|') : undefined, [
        luminaContentMap
    ]);
    const luminaContentTypes = (0, $cozmU.useMemo)(()=>luminaContentTypesKey === undefined ? undefined : luminaContentTypesKey ? luminaContentTypesKey.split('|') : [], [
        luminaContentTypesKey
    ]);
    const commonAttributes = (0, $cozmU.useMemo)(()=>({
            cloudId: cloudId,
            orgId: orgId ?? '',
            queryHash: (0, $9oghv.sha256Hash)(query),
            baseQueryHash: (0, $9oghv.sha256Hash)(baseQuery),
            query: query,
            appliedFilters: parsedFilters,
            searchSessionId: searchSessionId,
            source: source,
            answerString: answerString,
            answerLength: answerString.length,
            answerWordCount: answerString.split(/\s+/).length,
            answerFormat: answerFormat,
            answerCardType: answerCardType,
            sources: sources,
            followUps: followUps || [],
            errorStateSuggestedQueries: errorStateSuggestedQueries || [],
            errorState: nlpSearch.errorState,
            errorCode: nlpSearch.errorCode,
            networkErrorReason: nlpSearch.networkErrorReason,
            networkErrorDetails: nlpSearch.networkErrorDetails,
            backendFailureType: nlpSearch.backendFailureType,
            streamEventsReceived: nlpSearch.streamEventsReceived,
            networkErrorDuration: nlpSearch.networkErrorDuration,
            extraAttributes: {
                featureGates: {
                    precomputedDefinitionsEnabled: (0, $iDrrr.fg)('kd_enable_precomputed_definitions')
                },
                ...extraAnalyticsAttributes,
                ...extraAPIAnalyticsAttributes
            },
            apiSource: 'assistance-service',
            workspaceId: workspaceId ?? '',
            sessionId: sessionId,
            brand: brand,
            sourceProduct: sourceProduct,
            isReadingAids: isReadingAids,
            queryIntent: smartAnswersRoute,
            isHello: isHelloValue,
            ...luminaContentTypes !== undefined && {
                containsLuminaContent: luminaContentTypes.length > 0,
                luminaContentTypes: luminaContentTypes
            },
            luminaContentMap: luminaContentMap
        }), [
        cloudId,
        orgId,
        query,
        baseQuery,
        parsedFilters,
        searchSessionId,
        source,
        answerString,
        answerFormat,
        nlpSearch.errorState,
        nlpSearch.errorCode,
        nlpSearch.networkErrorReason,
        nlpSearch.networkErrorDetails,
        nlpSearch.backendFailureType,
        nlpSearch.streamEventsReceived,
        nlpSearch.networkErrorDuration,
        extraAnalyticsAttributes,
        extraAPIAnalyticsAttributes,
        workspaceId,
        sessionId,
        brand,
        sourceProduct,
        isReadingAids,
        smartAnswersRoute,
        answerCardType,
        followUps,
        sources,
        errorStateSuggestedQueries,
        isHelloValue,
        luminaContentTypes,
        luminaContentMap
    ]);
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire((0, $zzZbq.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    const onNavigateWithMouseEvent = (0, $cozmU.useCallback)((event)=>{
        if (!event.ctrlKey && !event.metaKey) onNavigate();
    }, [
        onNavigate
    ]);
    const getAIAnswerFn = (0, $cozmU.useCallback)(()=>{
        switch(smartAnswersRoute){
            case (0, $zzZbq.QueryIntent).PERSON:
                return (_args)=>(0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation') ? (0, $634e333e90210143$export$3b2275a59c992e87)({
                        tenantId: cloudId,
                        personQuery: query,
                        sourceProduct: sourceProduct,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    }) : (0, $634e333e90210143$export$b40bb50f32e7d452)({
                        tenantId: cloudId,
                        personQuery: query,
                        sourceProduct: sourceProduct,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    });
            case (0, $zzZbq.QueryIntent).TEAM:
                return (_args)=>(0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation') ? (0, $5440ea745c72f677$export$b9b0423f67d54dce)({
                        activityClient: activityClient,
                        orgId: orgId ?? '',
                        siteId: cloudId,
                        teamQuery: query,
                        sourceProduct: sourceProduct,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    }) : (0, $5440ea745c72f677$export$1d3fe260188fa7d9)({
                        activityClient: activityClient,
                        orgId: orgId ?? '',
                        siteId: cloudId,
                        teamQuery: query,
                        sourceProduct: sourceProduct,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    });
            case (0, $zzZbq.QueryIntent).TOPIC:
                return (_args)=>(0, $f015000a0fe91d29$export$d25837238feb3ab6)({
                        cloudId: cloudId,
                        query: query,
                        workspaceId: workspaceId ?? '',
                        sourceProduct: sourceProduct,
                        traceHeaders: traceHeaders
                    });
            case (0, $zzZbq.QueryIntent).AGENT:
                return ()=>(0, $7af6e4b8739a3031$export$9cab63c7e0de7ad8)({
                        query: query,
                        sourceProduct: sourceProduct ?? '',
                        limit: 7,
                        cloudId: cloudId,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    });
            case (0, $zzZbq.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY:
            case (0, $zzZbq.QueryIntent).JIRA_NLQ_KEYWORD:
                // data fetching is handled by the JiraNlToJqlCard internally,
                // this is to prevent streaming from being called
                setLoading(false);
                return null;
            case (0, $zzZbq.QueryIntent).VISUAL:
                // data fetching is handled by the VisualKnowledgeCard internally,
                // this is to prevent streaming from being called
                setLoading(false);
                return null;
            case (0, $zzZbq.QueryIntent).ORG_CHART:
                return ()=>(0, $634e333e90210143$export$b40bb50f32e7d452)({
                        tenantId: cloudId,
                        personQuery: query,
                        sourceProduct: sourceProduct,
                        workspaceId: workspaceId ?? '',
                        traceHeaders: traceHeaders
                    });
            default:
        }
        return getAIAnswer;
    }, [
        getAIAnswer,
        smartAnswersRoute,
        query,
        orgId,
        cloudId,
        activityClient,
        sourceProduct,
        workspaceId,
        traceHeaders
    ]);
    const updateContextCache = (0, $cozmU.useCallback)(({ collapsed: collapsed, liked: liked, reported: reported, recentWorkListExpanded: recentWorkListExpanded, sourcesExpanded: sourcesExpanded, fromFollowUp: fromFollowUp })=>{
        // Do not store session cache if Lumina
        if (isLuminaAnswer && !isReadingAids) return;
        const currentCache = JSON.parse((0, $6JEx2.getSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY)) || '{}');
        (0, $6JEx2.setSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY), JSON.stringify({
            query: query,
            additionalContext: additionalQueryContext || '',
            data: nlpSearch,
            collapsed: collapsed === undefined ? currentCache.collapsed : collapsed,
            liked: liked === undefined ? currentCache.liked : liked,
            reported: reported === undefined ? currentCache.reported : reported,
            fromFollowUp: fromFollowUp === undefined ? currentCache.fromFollowUp : fromFollowUp,
            recentWorkListExpanded: recentWorkListExpanded === undefined ? currentCache.recentWorkListExpanded : recentWorkListExpanded,
            sourcesExpanded: sourcesExpanded === undefined ? currentCache.sourcesExpanded : sourcesExpanded,
            ...(0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation') ? {
                extraAPIAnalyticsAttributes: {
                    requestId: requestId
                }
            } : {}
        }));
    }, [
        query,
        additionalQueryContext,
        nlpSearch,
        requestId,
        isReadingAids,
        isLuminaAnswer
    ]);
    const onFMPReached = (0, $cozmU.useCallback)(()=>{
        setIsFMPReached(true);
        fmpLoadedTsRef.current = Date.now();
    }, []);
    const onAnswerExpandedChange = (0, $cozmU.useCallback)((expanded)=>{
        setIsAnswerExpanded(expanded);
    }, []);
    const onAnswerMinimizedChange = (0, $cozmU.useCallback)((minimized)=>{
        setIsAnswerMinimized(minimized);
    }, []); // Mirror the intersection observer behaviour for the minimize/expand action.
    // Minimizing the answer is semantically equivalent to the dialog leaving the
    // viewport (user can no longer see the answer), so fire onAIAnswerDialogHidden
    // and clear any in-progress dwell timers. Re-expanding while the dialog is in
    // viewport is equivalent to the dialog re-entering the viewport, so fire
    // onAIAnswerDialogViewed and restart dwell tracking.
    // Tracks the previous value with a ref so we only react to actual transitions
    // and not on initial mount.
    const previousIsAnswerMinimizedRef = (0, $cozmU.useRef)(isAnswerMinimized); // Mirror of `isAnswerMinimized` in a ref so `handleIntersect` (which is closed over
    // by an IntersectionObserver created once on mount) can read the latest value
    // without us needing to recreate the observer on minimize/expand.
    const isAnswerMinimizedRef = (0, $cozmU.useRef)(isAnswerMinimized);
    (0, $cozmU.useEffect)(()=>{
        isAnswerMinimizedRef.current = isAnswerMinimized;
    }, [
        isAnswerMinimized
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled() && !(0, $7DMz5.SAINFeatureControl).isSAINLoadingStateTracesUpdateEnabled()) return;
        const previous = previousIsAnswerMinimizedRef.current;
        previousIsAnswerMinimizedRef.current = isAnswerMinimized; // Only fire minimize/expand side-effects after the answer is loaded.
        if (loading || !isAnswered && !hasError) return;
         // User just minimized the answer — fire hidden + clear dwell timers
        if (!previous && isAnswerMinimized) {
            fireAnalyticsEvent((0, $c64593c9127399aa$export$e1c446b3b8b22ff)({
                ...commonAttributes
            }, markViewportDwell()));
            if (dwellTimerRef.current && (0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) {
                clearTimeout(dwellTimerRef.current);
                dwellTimerRef.current = null;
            }
            return;
        } // User just expanded the answer while the dialog is in viewport — fire
        // viewed + restart dwell, mirroring the intersecting branch of handleIntersect.
        if (previous && !isAnswerMinimized && isFmpInViewport) {
            startViewportDwell();
            fireAnalyticsEvent((0, $0f9647babe97feca$export$e9cccbc780a694f3)({
                ...commonAttributes
            }));
            if ((0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) {
                if (smartAnswersRoute !== (0, $zzZbq.QueryIntent).TEAM && smartAnswersRoute !== (0, $zzZbq.QueryIntent).PERSON && smartAnswersRoute !== (0, $zzZbq.QueryIntent).AGENT && !dwellTrackedRef.current) dwellTimerRef.current = setTimeout(()=>{
                    dwellTrackedRef.current = true;
                    fireSAINUsageEvent({
                        metCriteria: (0, $bZMnB.SainAction).DWELL_REACHED,
                        dwellTime: markViewportDwell(),
                        commonAttributes: commonAttributes
                    });
                }, (0, $eySxZ.SAIN_USAGE_DWELL_THRESHOLD));
            }
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAnswerMinimized
    ]);
    (0, $cozmU.useEffect)(()=>{
        onAnswerExpandedStateChange?.(isAnswerExpanded);
    }, [
        isAnswerExpanded,
        onAnswerExpandedStateChange
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (answerLoadingRef) answerLoadingRef.current = !!loading;
    }, [
        loading,
        answerLoadingRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        (0, $a7513ed93542ee2f$export$a83a35d6598a5fb6).start(); // Reset FMP dwell tracking for new queries
        setIsFMPReached(false);
        setIsFmpInViewport(false);
        setIsAnswerMinimized(false);
        setResearchSteps({});
        if (dwellTimer) {
            clearTimeout(dwellTimer);
            setDwellTimer(null);
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query
    ]);
    const handleIntersect = (entries)=>{
        entries.forEach((entry)=>{
            if (!loading && (isAnswered || hasError)) {
                if (entry.isIntersecting) {
                    // Skip the "viewed" tracking branch when the answer is minimized — the user
                    // can't actually see the answer content, so it shouldn't count as viewed
                    // or feed into dwell tracking. The minimize/expand events are handled by a
                    // dedicated effect above so we don't spuriously fire onAIAnswerDialogHidden
                    // from the else-branch in this case.
                    // Read minimize state via ref to get the latest value without recreating the observer.
                    if (isAnswerMinimizedRef.current) return;
                    startViewportDwell();
                    fireAnalyticsEvent((0, $0f9647babe97feca$export$e9cccbc780a694f3)({
                        ...commonAttributes
                    }));
                    if ((0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) {
                        if (smartAnswersRoute !== (0, $zzZbq.QueryIntent).TEAM && smartAnswersRoute !== (0, $zzZbq.QueryIntent).PERSON && smartAnswersRoute !== (0, $zzZbq.QueryIntent).AGENT && !dwellTrackedRef.current) dwellTimerRef.current = setTimeout(()=>{
                            dwellTrackedRef.current = true;
                            fireSAINUsageEvent({
                                metCriteria: (0, $bZMnB.SainAction).DWELL_REACHED,
                                dwellTime: markViewportDwell(),
                                commonAttributes: commonAttributes
                            });
                        }, (0, $eySxZ.SAIN_USAGE_DWELL_THRESHOLD));
                    } else if (smartAnswersRoute !== (0, $zzZbq.QueryIntent).TEAM && smartAnswersRoute !== (0, $zzZbq.QueryIntent).PERSON && !hasError && !dwellTracked) {
                        const usageTimer = setTimeout(()=>{
                            setDwellTracked(true);
                            fireSAINUsageEvent({
                                metCriteria: (0, $bZMnB.SainAction).DWELL_REACHED,
                                dwellTime: markViewportDwell(),
                                commonAttributes: commonAttributes
                            });
                        }, (0, $eySxZ.SAIN_USAGE_DWELL_THRESHOLD));
                        setDwellTimer(usageTimer); // DS team (Ala Qabaja & Nan Ma) wants to fire this event
                        // if user dwells on Definition for over 3 minutes
                        if (isReadingAids && !definitionDwellTimeTrackedRef.current && (0, $iDrrr.fg)('kd_definitions_dwell_fire_result_view')) definitionDwellTimeRef.current = setTimeout(()=>{
                            definitionDwellTimeTrackedRef.current = true;
                            fireSAINUsageEvent({
                                metCriteria: (0, $bZMnB.SainAction).DEFINITION_DWELL_MARKED,
                                dwellTime: markViewportDwell(),
                                commonAttributes: commonAttributes
                            });
                        }, 180000);
                    }
                } else {
                    // onAIAnswerDialogHidden is fired by the minimize/expand effect on line 655 when
                    // the user minimizes the answer, so firing it again on scroll-out would be
                    // a duplicate. The minimize/expand effect is the source of truth for hidden/
                    // viewed events while minimized.
                    // Read minimize state via ref to get the latest value without recreating the observer.
                    if (isAnswerMinimizedRef.current) return;
                    fireAnalyticsEvent((0, $c64593c9127399aa$export$e1c446b3b8b22ff)({
                        ...commonAttributes
                    }, markViewportDwell()));
                    if (dwellTimerRef.current && (0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) {
                        clearTimeout(dwellTimerRef.current);
                        dwellTimerRef.current = null;
                    } // DS team wants to fire this event once user exits viewport
                    if (isReadingAids && !definitionDwellTimeTrackedRef.current && (0, $iDrrr.fg)('kd_definitions_dwell_fire_result_view')) {
                        definitionDwellTimeTrackedRef.current = true; // clear timeout to avoid firing duplicate event at 3 minutes
                        if (definitionDwellTimeRef.current) clearTimeout(definitionDwellTimeRef.current);
                        fireSAINUsageEvent({
                            metCriteria: (0, $bZMnB.SainAction).DEFINITION_DWELL_MARKED,
                            dwellTime: markViewportDwell(),
                            commonAttributes: commonAttributes
                        });
                    }
                }
            } // Fire when the user scrolls the dialog out of the viewport while the
            // answer is still loading (i.e. before it is answered or errored).
            // Guarded so it fires at most once per load.
            if (loading && !entry.isIntersecting && !loadingHiddenTrackedRef.current) {
                loadingHiddenTrackedRef.current = true;
                fireAnalyticsEvent((0, $68497448a8541103$export$835458994fc126e4)({
                    ...commonAttributes
                }));
            }
        });
    };
    (0, $cozmU.useLayoutEffect)(()=>{
        const observer = new IntersectionObserver(handleIntersect, {
            threshold: 0.3
        });
        if (resultRef.current && tabHasFocus) observer.observe(resultRef.current);
        return ()=>{
            observer?.disconnect();
        }; // `isAnswerMinimized` is omitted from deps on purpose — recreating the observer
    // on minimize/expand fires a duplicate viewed/hidden event from the initial
    // intersection callback. `handleIntersect` reads the latest value via
    // `isAnswerMinimizedRef` instead.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading,
        resultRef,
        isAnswered,
        hasError,
        tabHasFocus
    ]); // FMP dwell intersection observer
    (0, $cozmU.useLayoutEffect)(()=>{
        // Use different thresholds based on expanded state:
        // - Collapsed: 1.0 (100% in viewport)
        // - Expanded: 0.3 (30% in viewport)
        const threshold = isAnswerExpanded ? 0.3 : 1.0;
        const fmpObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (isFMPReached) // Always update viewport state when FMP is reached, regardless of tab focus
                // Tab focus is handled separately in the dwell timer hook
                setIsFmpInViewport(entry.isIntersecting);
            });
        }, {
            threshold: threshold
        });
        if (resultRef.current && isFMPReached) fmpObserver.observe(resultRef.current);
        return ()=>{
            fmpObserver?.disconnect();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        resultRef,
        isFMPReached,
        isAnswerExpanded
    ]);
    (0, $cozmU.useEffect)(()=>{
        const cached = JSON.parse((0, $6JEx2.getSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY)) || '{}');
        if (cached?.query === query && cached?.additionalContext === additionalQueryContext) {
            if ((0, $iDrrr.fg)('kd_sain_enable_inline_lumina')) {
                const { processedText: processedText, boundaryContents: boundaryContents } = (0, $f3OgL.extractMarkdownText)(cached.data.nlpResult ?? '', (0, $b2270b423e154e70$export$84f2194b2008422), (0, $b2270b423e154e70$export$192ba1edc601a546), (0, $b2270b423e154e70$export$ea5ceaf3fa709ad4));
                const luminaContentMap = {};
                boundaryContents.forEach((content, index)=>{
                    luminaContentMap[`${0, $b2270b423e154e70$export$b2ac4f39739d467d}${index}`] = content;
                });
                setLuminaContentMap(luminaContentMap);
                setData({
                    ...cached.data,
                    nlpResult: processedText
                });
            } else setData(cached.data);
            if (cached.liked !== undefined) {
                setLiked(cached.liked); // if a like is cached, disable likes
                setLikesDisabled(true);
            }
            if (cached.reported !== undefined) setInitialReported(cached.reported);
            setLoading(false);
        } else {
            (0, $6JEx2.deleteSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY));
            setLoading(true); // Re-arm the loading-hidden analytics guard for this new load.
            loadingHiddenTrackedRef.current = false;
            setLiked(undefined);
            setLikesDisabled(false);
            (0, $b2270b423e154e70$export$6dbb893b575831e8)({
                cloudId: cloudId,
                locale: locale,
                query: (0, $273cb466e56a9a66$export$90c8c71ce0c72494)(query, selectedProduct, smartAnswersRoute),
                additional_context: additionalQueryContext,
                source: source,
                followUpsEnabled: followUpsEnabled && !cached.fromFollowUp,
                getAIAnswer: getAIAnswerFn(),
                setLoading: setLoading,
                partialResponse: partialResponse,
                partialResponseAbortControllerRef: partialResponseAbortControllerRef,
                setPartialResponse: setPartialResponse,
                setData: setData,
                setAnswerStreamed: setAnswerStreamed,
                parsedFilters: parsedFilters,
                selectedProduct: mappedProductFilter,
                isReadingAids: isReadingAids,
                fireAnalyticsEvent: fireAnalyticsEvent,
                setQueryReasoning: setQueryReasoning,
                setResearchSteps: setResearchSteps,
                setDynamicLayoutSubAgentMessages: setDynamicLayoutSubAgentMessages,
                setIsLuminaAnswer: setIsLuminaAnswer,
                setLuminaContentMap: setLuminaContentMap,
                experimentContext: experimentContext,
                queryIntentClassificationData: queryIntentClassificationData,
                referrer: referrer,
                searchSessionId: searchSessionId,
                sourceProduct: sourceProduct,
                queryIntent: smartAnswersRoute
            });
        }
        filtersRef.current = selectedFilters;
        if ((0, $iDrrr.fg)('kd_fix_duplicate_sain_stream_calls')) selectedProductRef.current = selectedProduct;
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query,
        additionalQueryContext
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $iDrrr.fg)('kd_hide_sain_for_unsupported_product_filters') && !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(filtersRef.current, selectedFilters) || !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(selectedProductRef.current, selectedProduct)) {
            (0, $6JEx2.deleteSessionItem)((0, $zzZbq.SEARCH_AI_ANSWER_CACHE_KEY));
            setLoading(true); // Re-arm the loading-hidden analytics guard for this new load.
            loadingHiddenTrackedRef.current = false;
            setLiked(undefined);
            setLikesDisabled(false);
            if ((0, $iDrrr.fg)('kd_fix_abort_errors')) {
                setData((0, $hZTED.DEFAULT_EMPTY_NLP_SEARCH_STATE));
                setPartialResponse(undefined);
            }
            (0, $b2270b423e154e70$export$6dbb893b575831e8)({
                cloudId: cloudId,
                locale: locale,
                query: (0, $273cb466e56a9a66$export$90c8c71ce0c72494)(query, selectedProduct, smartAnswersRoute),
                source: source,
                followUpsEnabled: followUpsEnabled,
                getAIAnswer: getAIAnswerFn(),
                setLoading: setLoading,
                partialResponse: partialResponse,
                partialResponseAbortControllerRef: partialResponseAbortControllerRef,
                setPartialResponse: setPartialResponse,
                setData: setData,
                setAnswerStreamed: setAnswerStreamed,
                parsedFilters: parsedFilters,
                selectedProduct: mappedProductFilter,
                isReadingAids: isReadingAids,
                fireAnalyticsEvent: fireAnalyticsEvent,
                setQueryReasoning: setQueryReasoning,
                setResearchSteps: setResearchSteps,
                setDynamicLayoutSubAgentMessages: setDynamicLayoutSubAgentMessages,
                setIsLuminaAnswer: setIsLuminaAnswer,
                setLuminaContentMap: setLuminaContentMap,
                experimentContext: experimentContext,
                queryIntentClassificationData: queryIntentClassificationData,
                referrer: referrer,
                searchSessionId: searchSessionId,
                sourceProduct: sourceProduct,
                queryIntent: smartAnswersRoute
            });
        }
        filtersRef.current = selectedFilters;
        selectedProductRef.current = selectedProduct; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedFilters,
        selectedProduct
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isAnswered) {
            // if a person or team query returns no data don't log result shown
            const numAddtlWhoMatches = smartAnswersRoute === (0, $zzZbq.QueryIntent).PERSON ? (0, $a52d76eb98115dba$export$e25821f3420be6ad)({
                answerString: answerString,
                smartAnswersRoute: smartAnswersRoute
            }) : 0;
            if ((smartAnswersRoute === (0, $zzZbq.QueryIntent).PERSON || smartAnswersRoute === (0, $zzZbq.QueryIntent).TEAM || smartAnswersRoute === (0, $zzZbq.QueryIntent).AGENT) && (0, $a52d76eb98115dba$export$e25821f3420be6ad)({
                answerString: answerString,
                smartAnswersRoute: smartAnswersRoute
            }) < 1) {
                markLoadedTs();
                callbacks?.onAIAnswerAnalyticsFired?.();
                return;
            }
            fireAnalyticsEvent((0, $h0U7J.onAIAnswerResultShown)({
                ...commonAttributes,
                isStreamed: answerStreamed,
                loadTime: markLoadedTs(),
                fmpLoadTime: fmpMarkLoadedTs(),
                experimentLayers: experimentContext?.experimentLayers,
                ...isBlueLinkAnalyticsEnabled && {
                    blueLinkCount: (0, $63458847df53b6c8$export$9b73daf8fd4da40f)(answerString)
                },
                ...(0, $iDrrr.fg)('rovo_authoritative_answer_attribution') && {
                    authorityUiMetadata: authorityUiMetadata
                },
                extraAttributes: {
                    ...commonAttributes.extraAttributes,
                    multipleUserResultsShown: numAddtlWhoMatches > 0,
                    numAddtlWhoMatches: numAddtlWhoMatches,
                    isCuratedDefinition: !!answerEditor,
                    isPrecomputedDefinition: nlpSearch.customDefinitionType === (0, $9u8Y2.NLPSearchCustomDefinitionType).PRECOMPUTED
                }
            }));
            (0, $7DMz5.SAINFeatureControl).triggerNonPrimaryClickTrackingExposure();
            if (numAddtlWhoMatches > 0) fireSAINUsageEvent({
                commonAttributes: commonAttributes
            });
            callbacks?.onAIAnswerAnalyticsFired?.();
        } else if (hasError) {
            fireAnalyticsEvent((0, $189f541bd063b636$export$bd496fce1657ba31)({
                ...commonAttributes,
                isStreamed: answerStreamed,
                loadTime: markLoadedTs(),
                fmpLoadTime: fmpMarkLoadedTs()
            }));
            callbacks?.onAIAnswerAnalyticsFired?.();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading,
        isAnswered
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        trackAIInteractionInit();
        fireAnalyticsEvent((0, $3010e3f8742304a1$export$17e25c724e0ebb55)(commonAttributes));
        if (!isReadingAids && query && smartAnswersRoute) fireAnalyticsEvent((0, $a92ce6609ffd286a$export$67b8bcd639e29c44)(commonAttributes, smartAnswersRoute));
        return ()=>{
            fireAnalyticsEvent((0, $c64593c9127399aa$export$e1c446b3b8b22ff)({
                ...commonAttributes
            }, markViewportDwell()));
            fireAnalyticsEvent((0, $4eab0bf5f1608099$export$c075b0a4ec670c87)({
                ...commonAttributes,
                isReadingAids: isReadingAids,
                sourceProduct: sourceProduct,
                dwellTime: loadedTsRef.current ? Date.now() - loadedTsRef.current : 0,
                loadTime: markLoadedTs(),
                fmpLoadTime: fmpMarkLoadedTs()
            }));
            trackAIInteractionDismiss();
            if (!loadedTsRef.current) fireAnalyticsEvent((0, $597405ac0b3b2570$export$cae33476d80498a)({
                ...commonAttributes
            }));
             // DS team wants to fire this event once user closes Definition
            if (isReadingAids && !definitionDwellTimeTrackedRef.current && (0, $iDrrr.fg)('kd_definitions_dwell_fire_result_view')) {
                definitionDwellTimeTrackedRef.current = true; // clear timeout to avoid firing duplicate event at 3 minutes
                if (definitionDwellTimeRef.current) clearTimeout(definitionDwellTimeRef.current);
                fireSAINUsageEvent({
                    metCriteria: (0, $bZMnB.SainAction).DEFINITION_DWELL_MARKED,
                    dwellTime: markViewportDwell(),
                    commonAttributes: commonAttributes
                });
            }
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const handleWindowBlurOrClose = ()=>{
            if (tabHasFocus && !loading && (isAnswered || hasError)) {
                fireAnalyticsEvent((0, $c64593c9127399aa$export$e1c446b3b8b22ff)({
                    ...commonAttributes
                }, markViewportDwell()));
                if (dwellTimerRef.current && (0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) {
                    clearTimeout(dwellTimerRef.current);
                    dwellTimerRef.current = null;
                } // DS team wants to fire this event once user leaves tab with Definition still open
                if (isReadingAids && !definitionDwellTimeTrackedRef.current && (0, $iDrrr.fg)('kd_definitions_dwell_fire_result_view')) {
                    definitionDwellTimeTrackedRef.current = true; // clear timeout to avoid firing duplicate event at 3 minutes
                    if (definitionDwellTimeRef.current) clearTimeout(definitionDwellTimeRef.current);
                    fireSAINUsageEvent({
                        metCriteria: (0, $bZMnB.SainAction).DEFINITION_DWELL_MARKED,
                        dwellTime: markViewportDwell(),
                        commonAttributes: commonAttributes
                    });
                }
            }
            setTabHasFocus(false);
        };
        const handleWindowFocus = ()=>{
            setTabHasFocus(true);
            if (!dwellTrackedRef.current && !dwellTimerRef.current && (0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) dwellTimerRef.current = setTimeout(()=>{
                dwellTrackedRef.current = true;
                fireSAINUsageEvent({
                    metCriteria: (0, $bZMnB.SainAction).DWELL_REACHED,
                    dwellTime: markViewportDwell(),
                    commonAttributes: commonAttributes
                });
            }, (0, $eySxZ.SAIN_USAGE_DWELL_THRESHOLD));
        };
        const removeBlurListener = (0, $cbY7C.bind)(window, {
            type: 'blur',
            listener: handleWindowBlurOrClose
        });
        const removeFocusListener = (0, $cbY7C.bind)(window, {
            type: 'focus',
            listener: handleWindowFocus
        });
        const removeCloseListener = (0, $cbY7C.bind)(window, {
            type: 'beforeunload',
            listener: handleWindowBlurOrClose
        });
        return ()=>{
            removeBlurListener();
            removeFocusListener();
            removeCloseListener();
            if ((0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation')) {
                if (dwellTimerRef.current) {
                    clearTimeout(dwellTimerRef.current);
                    dwellTimerRef.current = null;
                }
            } else if (dwellTimer) clearTimeout(dwellTimer);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tabHasFocus,
        loading
    ]);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (onLoad && !loading && (isAnswered || hasError)) onLoad();
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading,
        isAnswered,
        hasError
    ]);
    const AIDialogWrapper = wrapper ? wrapper : (0, $aMSTz.SearchDialog);
    const AILoadingWrapper = loadingWrapper ? loadingWrapper : (0, $28ffaa5aebbd61cc$export$476294a9cde8f045);
    const renderDefinition = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7220d3f091bca8d4$export$d1b852cfff73cbe8), null); // SAIN in FPS
    const renderSearchPageSmartAnswer = ()=>{
        if ((smartAnswersRoute === (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY || smartAnswersRoute === (0, $zzZbq.QueryIntent).KEYWORD_OR_ACRONYM || smartAnswersRoute === (0, $zzZbq.QueryIntent).NAVIGATIONAL && (0, $7DMz5.SAINFeatureControl).isNavigationalIntentEnabled()) && shouldServeTabsExperiment) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AIDialogWrapper, null, (0, $7DMz5.SAINFeatureControl).canRenderLumina() && isLuminaAnswer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12ca716b9376ab26$export$b547d87531f467be), {
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange,
            queryIntent: smartAnswersRoute
        }) : (0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c6a21b3a2fe9d946$export$2b53936d5706be63), {
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange,
            onAnswerMinimizedChange: onAnswerMinimizedChange,
            queryIntent: smartAnswersRoute,
            floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef
        }) : (0, $iDrrr.fg)('kd_smooth_streaming_fg') || kdSainSmoothStreamingExperiment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fd49c31ba41c686c$export$3698d894d0a161e5), {
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange,
            queryIntent: smartAnswersRoute,
            onAnswerMinimizedChange: onAnswerMinimizedChange,
            floatingSmartAnswerReadyPortalRef: floatingSmartAnswerReadyPortalRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2243051d7b6c86e9$export$827de04ba3667da0), {
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange,
            queryIntent: smartAnswersRoute
        }));
        else if ((0, $iDrrr.fg)('kd_sain_enable_expand_when_streaming')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AIDialogWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $005c7db905c9053b$export$827de04ba3667da0), {
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange
        }));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AIDialogWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $243c0d4568578f49$export$7d8a07a50ae14953), {
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange
        }));
    };
    const renderSearchPageKnowledgeCard = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(AIDialogWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0d6d5a5257f57329$export$ab2444a256fc8a9b), {
            onFMPReached: onFMPReached
        })); // Quick search and advanced search
    const renderDefaultSmartAnswer = ()=>{
        return (0, $iDrrr.fg)('kd_sain_enable_expand_when_streaming') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4405991c63379ccf$export$cf72ef8498afcbc2), {
            LoadingWrapper: AILoadingWrapper,
            DialogWrapper: AIDialogWrapper,
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d365ffe2a496da37$export$b054d5cce3d1302d), {
            LoadingWrapper: AILoadingWrapper,
            DialogWrapper: AIDialogWrapper,
            onFMPReached: onFMPReached,
            onAnswerExpandedChange: onAnswerExpandedChange
        });
    };
    const renderExperience = ()=>{
        switch(smartAnswersRoute){
            case (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY:
            case (0, $zzZbq.QueryIntent).KEYWORD_OR_ACRONYM:
            case (0, $zzZbq.QueryIntent).DATE:
            case (0, $zzZbq.QueryIntent).LOCATION:
                return renderSearchPageSmartAnswer();
            case (0, $zzZbq.QueryIntent).NAVIGATIONAL:
                return (0, $7DMz5.SAINFeatureControl).isNavigationalIntentEnabled() ? renderSearchPageSmartAnswer() : null;
            case (0, $zzZbq.QueryIntent).PERSON:
            case (0, $zzZbq.QueryIntent).TEAM:
            case (0, $zzZbq.QueryIntent).TOPIC:
            case (0, $zzZbq.QueryIntent).AGENT:
            case (0, $zzZbq.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY:
            case (0, $zzZbq.QueryIntent).JIRA_NLQ_KEYWORD:
            case (0, $zzZbq.QueryIntent).ORG_CHART:
            case (0, $zzZbq.QueryIntent).VISUAL:
                return renderSearchPageKnowledgeCard();
            default:
                return isReadingAids ? renderDefinition() : renderDefaultSmartAnswer();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3hVWe.AIAnswerContext).Provider, {
        value: {
            loading: loading,
            partialResponse: partialResponse,
            isAnswered: isAnswered,
            hasError: hasError,
            advancedSearchUrl: advancedSearchUrl,
            userDetails: userDetails,
            disclaimer: disclaimer,
            onNavigate: onNavigateWithMouseEvent,
            onClose: onClose,
            updateContextCache: updateContextCache,
            fireAnalyticsEvent: fireAnalyticsEvent,
            setQuery: setQuery,
            setData: setData,
            commonAttributes: commonAttributes,
            liked: liked,
            setLiked: setLiked,
            likesDisabled: likesDisabled,
            setLikesDisabled: setLikesDisabled,
            initialReported: initialReported,
            isReadingAids: isReadingAids,
            dynamicLayoutSubAgentMessages: dynamicLayoutSubAgentMessages,
            setDynamicLayoutSubAgentMessages: setDynamicLayoutSubAgentMessages,
            readingAidsOptions: readingAidsOptions,
            cardProviderProps: cardProviderProps,
            baseQuery: baseQuery,
            cardTemplate: cardTemplate,
            smartAnswersRoute: smartAnswersRoute,
            queryIntentClassificationData: queryIntentClassificationData,
            brand: brand,
            answerEditor: answerEditor,
            closeParentDialog: closeParentDialog,
            additionalQueryContext: additionalQueryContext,
            callbacks: callbacks,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            definitionToggleEnabled: definitionToggleEnabled,
            sourceProduct: sourceProduct,
            showChatFollowUps: showChatFollowUps,
            queryReasoning: queryReasoning,
            researchSteps: researchSteps,
            showGenericFooter: showGenericFooter ?? false,
            initiallyExpanded: initiallyExpanded ?? false,
            traceHeaders: traceHeaders,
            luminaContentMap: luminaContentMap,
            authorityUiMetadata: authorityUiMetadata
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $86daeed37675c499$var$styles.root,
        ref: resultRef
    }, renderExperience()), !loading && (isAnswered || hasError) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a393edda7edb3fe8$export$6220c1b7224eb2a2), null));
};
const $86daeed37675c499$export$effb3597bac74419 = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { definitionExperienceName: definitionExperienceName, isReadingAids: isReadingAids, source: source, sourceProduct: sourceProduct, sourceSubProduct: sourceSubProduct, smartAnswersRoute: smartAnswersRoute, query: query, userGeneratedAI: userGeneratedAI } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "search-ai-dialog"
    }, (0, $iDrrr.fg)('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "hasSAINComponent",
        value: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AzUy.default), {
        dataKey: "sainExperienceName",
        value: (0, $b8dde4ad487d9f98$export$38439c13a4683ecf)(smartAnswersRoute)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3PNw6.default), {
        data: {
            hasSAINComponent: true,
            sainExperienceName: (0, $b8dde4ad487d9f98$export$38439c13a4683ecf)(smartAnswersRoute)
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14367db50208fb8a$export$e926676385687eaf), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $29vMs.AIEventsInstrumentationProvider), {
        config: {
            product: sourceProduct ?? 'unknown',
            subproduct: sourceSubProduct ?? 'unknown',
            aiFeatureName: isReadingAids ? 'aiDefinitions' : 'smartAnswers',
            aiExperienceName: isReadingAids ? definitionExperienceName : (0, $b8dde4ad487d9f98$export$38439c13a4683ecf)(smartAnswersRoute),
            proactiveGeneratedAI: userGeneratedAI ? 0 : 1,
            userGeneratedAI: userGeneratedAI ? 1 : 0,
            isAIFeature: 1,
            source: source,
            channel: (0, $zzZbq.DEFAULT_GAS_CHANNEL)
        }
    }, (0, $iDrrr.fg)('kd_enable_smart_answer_key') || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86daeed37675c499$var$SearchAIDialogComponent, {
        ...props,
        key: query
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($86daeed37675c499$var$SearchAIDialogComponent, props))));
});
module.exports["SearchAIDialog"] = $86daeed37675c499$export$effb3597bac74419;

});

parcelRegister("aTjYs", function(module, exports) {
const $5533ced57b27ed23$export$8e3fc93123f96c19 = (cloudId)=>{
    return cloudId === 'a436116f-02ce-4520-8fbb-7301462a1674';
};
module.exports["isHello"] = $5533ced57b27ed23$export$8e3fc93123f96c19;

});

parcelRegister("1AuMq", function(module, exports) {
function $5a1d8841e113bde7$export$10e7203252b63b0e(ari) {
    return ari.split('/').pop() || '';
}
module.exports["trimARI"] = $5a1d8841e113bde7$export$10e7203252b63b0e;

});

parcelRegister("b3ffN", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");


var $9ivsj = parcelRequire("9ivsj");


var $IQ4Dz = parcelRequire("IQ4Dz");

var $5420b38fb3279371$var$DarkThemeStops = /*#__PURE__*/ function(DarkThemeStops) {
    DarkThemeStops["BLUE800"] = "#0055CC";
    DarkThemeStops["TEAL500"] = "#37B4C3";
    DarkThemeStops["YELLOW500"] = "#CF9F02";
    return DarkThemeStops;
}($5420b38fb3279371$var$DarkThemeStops || {});
var $5420b38fb3279371$var$LightThemeStops = /*#__PURE__*/ function(LightThemeStops) {
    LightThemeStops["BLUE600"] = "#1D7AFC";
    LightThemeStops["TEAL300"] = "#8BDBE5";
    LightThemeStops["YELLOW200"] = "#F8E6A0";
    return LightThemeStops;
}($5420b38fb3279371$var$LightThemeStops || {});
var $5420b38fb3279371$var$UpdatedDarkThemeStops = /*#__PURE__*/ function(UpdatedDarkThemeStops) {
    UpdatedDarkThemeStops["ORANGE"] = "#FCA700";
    UpdatedDarkThemeStops["GREEN"] = "#82B536";
    UpdatedDarkThemeStops["BLUE"] = "#357DE8";
    UpdatedDarkThemeStops["PURPLE"] = "#BF63F3";
    return UpdatedDarkThemeStops;
}($5420b38fb3279371$var$UpdatedDarkThemeStops || {});
var $5420b38fb3279371$var$UpdatedLightThemeStops = /*#__PURE__*/ function(UpdatedLightThemeStops) {
    UpdatedLightThemeStops["ORANGE"] = "#FCA700";
    UpdatedLightThemeStops["GREEN"] = "#6A9A23";
    UpdatedLightThemeStops["BLUE"] = "#1868DB";
    UpdatedLightThemeStops["PURPLE"] = "#AF59E0";
    return UpdatedLightThemeStops;
}($5420b38fb3279371$var$UpdatedLightThemeStops || {});
const $5420b38fb3279371$var$PRE_PULSE_ANIMATION_DURATION = 200;
const $5420b38fb3279371$var$TOTAL_PULSE_ANIMATION_DURATION = 800; // Helper function to convert hex color to rgba with alpha
const $5420b38fb3279371$var$hexToRgba = (hex, alpha)=>{
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}; // This injects a CSS property into the document for the --gradient-angle variable.
// This is needed so the browser understands how to animate the gradient-angle as an angle
// value. This is done this way because compiled doesn't support CSS variables at this time.
let $5420b38fb3279371$var$propertyInjected = false;
const $5420b38fb3279371$var$useGradientAngleProperty = ()=>{
    (0, $cozmU.useEffect)(()=>{
        if ($5420b38fb3279371$var$propertyInjected) return;
        $5420b38fb3279371$var$propertyInjected = true;
        try {
            const style = document.createElement('style');
            style.innerHTML = `
      			@property --gradient-angle {
        			syntax: '<angle>';
        			initial-value: 0deg;
        			inherits: false;
      			}
    		`;
            document.head.appendChild(style);
        } catch (e) {}
    }, []);
};
// Keyframes for rotating the gradient angle
// ts-ignore because jira build is failing, but this is legit
// @ts-ignore
const $5420b38fb3279371$var$rotate = null; // Rainbow border styles
// Note: the actual gradient background varies by light/dark theme - this is added down below
const $5420b38fb3279371$var$borderCss = null; // Inner content box
const $5420b38fb3279371$var$innerBoxCss = null;
const $5420b38fb3279371$var$lightBackgroundGradientCss = null;
const $5420b38fb3279371$var$darkBackgroundGradientCss = null;
const $5420b38fb3279371$var$backgroundGlowContainerCss = null;
const $5420b38fb3279371$var$backgroundBlurCss = null;
const $5420b38fb3279371$var$lightBackgroundDefaultGradientCss = null; // Light theme blur with alpha transparency for loading states
const $5420b38fb3279371$var$lightBackgroundGeneratingGradientCss = null;
const $5420b38fb3279371$var$lightBackgroundTransparentGradientCss = null;
const $5420b38fb3279371$var$lightBackgroundPulseGradientCss = null;
const $5420b38fb3279371$var$darkBackgroundDefaultGradientCss = null; // Dark theme blur with alpha transparency for loading states
const $5420b38fb3279371$var$darkBackgroundGeneratingGradientCss = null;
const $5420b38fb3279371$var$darkBackgroundPulseGradientCss = null;
const $5420b38fb3279371$var$darkBackgroundTransparentGradientCss = null;
const $5420b38fb3279371$var$loadingStateStyles = {
    generating: "_1gBibyzUlx _0nFVCGFSlo _43vdfTHVQb _03m2nySHWH",
    'pre-pulse': "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _1wydGWdnbC _0Of8r2dnbC _2Zuz6QdnbC _1ZnuxbdnbC",
    pulse: "_1gBibyzUlx _0nFVCGpFbM _43vdfTHVQb _03m2nySHWH _1jakNnR7gE",
    generated: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _1wydGWdnbC _0Of8r2dnbC _2Zuz6QdnbC _1ZnuxbdnbC"
};
const $5420b38fb3279371$export$ca874e6b8d314598 = ({ children: children, isAnswerComplete: isAnswerComplete = false, loadingState: loadingState, testId: testId })=>{
    $5420b38fb3279371$var$useGradientAngleProperty();
    const { colorMode: colorMode } = (0, $IQ4Dz.default)();
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)(); // Internal state for automatic transitions
    const [internalLoadingState, setInternalLoadingState] = (0, $cozmU.useState)('generating'); // Use external loadingState if provided, otherwise use internal state
    const currentLoadingState = loadingState ?? internalLoadingState; // Handle automatic transitions when answer is complete
    (0, $cozmU.useEffect)(()=>{
        if (!isAnswerComplete || loadingState) // Don't auto-transition if external loadingState is provided
        return;
         // Start phase 2 transitions
        let timeoutIds = []; // Transition to pre-pulse immediately
        setInternalLoadingState('pre-pulse'); // Transition to pulse after 200ms
        timeoutIds.push(setTimeout(()=>{
            setInternalLoadingState('pulse');
        }, $5420b38fb3279371$var$PRE_PULSE_ANIMATION_DURATION)); // Transition to generated after 800ms total (600ms after pulse)
        timeoutIds.push(setTimeout(()=>{
            setInternalLoadingState('generated');
        }, $5420b38fb3279371$var$TOTAL_PULSE_ANIMATION_DURATION)); // Cleanup timeouts
        return ()=>{
            timeoutIds.forEach(clearTimeout);
        };
    }, [
        isAnswerComplete,
        loadingState
    ]); // Reset to generating when answer becomes incomplete
    (0, $cozmU.useEffect)(()=>{
        if (!isAnswerComplete && !loadingState) setInternalLoadingState('generating');
    }, [
        isAnswerComplete,
        loadingState
    ]); // Simplified approach for Compiled compatibility
    const isGenerating = currentLoadingState === 'generating';
    const isPrePulse = currentLoadingState === 'pre-pulse';
    const isPulse = currentLoadingState === 'pulse';
    const isGenerated = currentLoadingState === 'generated';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _4bt5LAYvD1 _2WAcuGYvD1 _3PxjEG8g64 _1mT5xdRAKS _0Of8r2HZdu _1ZnuxbHZdu _1wydGWHZdu _2Zuz6QHZdu",
            !isReducedMotion ? colorMode === 'dark' ? isGenerating ? "_2uo31f6o3P" : isPrePulse ? "_2uo31f7p9X" : isPulse ? "_2uo31fwtUy" : isGenerated ? "_2uo31f7p9X" : "_2uo31fMcUP" : isGenerating ? "_2uo31fcw9M" : isPrePulse ? "_2uo31fTcsH" : isPulse ? "_2uo31f41qY" : isGenerated ? "_2uo31fTcsH" : "_2uo31fNPHD" : colorMode === 'dark' ? "_2uo31fqCLE" : "_2uo31fAxJq",
            !isReducedMotion && $5420b38fb3279371$var$loadingStateStyles[currentLoadingState],
            isReducedMotion && isPrePulse && $5420b38fb3279371$var$loadingStateStyles[currentLoadingState],
            isReducedMotion && isGenerated && $5420b38fb3279371$var$loadingStateStyles[currentLoadingState]
        ]),
        style: {
            "--_92idzx": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 1)),
            "--_1vk81z2": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#82B536", 1)),
            "--_ki6hwq": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#357DE8", 1)),
            "--_9dqj5t": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#BF63F3", 1)),
            "--_1jec5hf": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 0)),
            "--_8b5chw": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#82B536", 0)),
            "--_gvxzl9": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#357DE8", 0)),
            "--_ujjfrh": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#BF63F3", 0)),
            "--_3g7mui": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 0.5)),
            "--_14o0mv1": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#82B536", 0.5)),
            "--_4a9n2u": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#357DE8", 0.5)),
            "--_ts8ymb": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#BF63F3", 0.5)),
            "--_1ysqspb": (0, $9aYkv.default)("#FCA700"),
            "--_1kd2sou": (0, $9aYkv.default)("#82B536"),
            "--_zaeqnl": (0, $9aYkv.default)("#357DE8"),
            "--_wanli": (0, $9aYkv.default)("#BF63F3"),
            "--_1456abr": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 1)),
            "--_t9jq7i": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#6A9A23", 1)),
            "--_1i41aq5": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#1868DB", 1)),
            "--_wnwy7": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#AF59E0", 1)),
            "--_jkwta5": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 0)),
            "--_6jnsza": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#6A9A23", 0)),
            "--_1v3r5g3": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#1868DB", 0)),
            "--_1vct74": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#AF59E0", 0)),
            "--_1b9vnnu": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 0.5)),
            "--_1tdjujc": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#6A9A23", 0.5)),
            "--_2itg5h": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#1868DB", 0.5)),
            "--_xlhaqx": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#AF59E0", 0.5)),
            "--_1c36rch": (0, $9aYkv.default)("#FCA700"),
            "--_hciyaa": (0, $9aYkv.default)("#6A9A23"),
            "--_1pbtgh9": (0, $9aYkv.default)("#1868DB"),
            "--_26o6n0": (0, $9aYkv.default)("#AF59E0"),
            "--_y94hvq": (0, $9aYkv.default)("#0055CC"),
            "--_vps1rq": (0, $9aYkv.default)("#37B4C3"),
            "--_a0mweg": (0, $9aYkv.default)("#CF9F02"),
            "--_i6w5ag": (0, $9aYkv.default)("#1D7AFC"),
            "--_7nv8o6": (0, $9aYkv.default)("#8BDBE5"),
            "--_1ey9p4c": (0, $9aYkv.default)("#F8E6A0")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_2uo31fYbGa _1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _4ApkO2dnbC _0Bm75GdnbC _42Yu6BdnbC _1pp6NdYbGa _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_3PxjEG8g64 _39xV02N91d _0jFU0VN91d _1llTr60oWv",
            colorMode === 'dark' ? isGenerating ? "_2uo31f6o3P" : isPrePulse ? "_2uo31f7p9X" : isPulse ? "_2uo31fwtUy" : isGenerated ? "_2uo31f7p9X" : "_2uo31fMcUP" : isGenerating ? "_2uo31fcw9M" : isPrePulse ? "_2uo31fTcsH" : isPulse ? "_2uo31f41qY" : isGenerated ? "_2uo31fTcsH" : "_2uo31fNPHD",
            !isReducedMotion && ""
        ]),
        style: {
            "--_92idzx": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 1)),
            "--_1vk81z2": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#82B536", 1)),
            "--_ki6hwq": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#357DE8", 1)),
            "--_9dqj5t": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#BF63F3", 1)),
            "--_1jec5hf": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 0)),
            "--_8b5chw": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#82B536", 0)),
            "--_gvxzl9": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#357DE8", 0)),
            "--_ujjfrh": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#BF63F3", 0)),
            "--_3g7mui": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 0.5)),
            "--_14o0mv1": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#82B536", 0.5)),
            "--_4a9n2u": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#357DE8", 0.5)),
            "--_ts8ymb": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#BF63F3", 0.5)),
            "--_1ysqspb": (0, $9aYkv.default)("#FCA700"),
            "--_1kd2sou": (0, $9aYkv.default)("#82B536"),
            "--_zaeqnl": (0, $9aYkv.default)("#357DE8"),
            "--_wanli": (0, $9aYkv.default)("#BF63F3"),
            "--_1456abr": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 1)),
            "--_t9jq7i": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#6A9A23", 1)),
            "--_1i41aq5": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#1868DB", 1)),
            "--_wnwy7": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#AF59E0", 1)),
            "--_jkwta5": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 0)),
            "--_6jnsza": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#6A9A23", 0)),
            "--_1v3r5g3": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#1868DB", 0)),
            "--_1vct74": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#AF59E0", 0)),
            "--_1b9vnnu": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#FCA700", 0.5)),
            "--_1tdjujc": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#6A9A23", 0.5)),
            "--_2itg5h": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#1868DB", 0.5)),
            "--_xlhaqx": (0, $9aYkv.default)($5420b38fb3279371$var$hexToRgba("#AF59E0", 0.5)),
            "--_1c36rch": (0, $9aYkv.default)("#FCA700"),
            "--_hciyaa": (0, $9aYkv.default)("#6A9A23"),
            "--_1pbtgh9": (0, $9aYkv.default)("#1868DB"),
            "--_26o6n0": (0, $9aYkv.default)("#AF59E0")
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _0KLXrulfZc _1mT5xdRAKS _42Yu6BiZR3 _39xV02N91d"
        ])
    }, children));
};
module.exports["AnimatedWrapper"] = $5420b38fb3279371$export$ca874e6b8d314598;

});

parcelRegister("aYqz2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");


var $4Tg3t = parcelRequire("4Tg3t");

function $3711c88a8522b3a9$export$4d3ad568e79b0fd1({ data: data, children: children }) {
    const value = (0, $4Tg3t.sanitizeSearchAIAnalyticsContextData)(data);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: value
    }, children);
}
module.exports["SearchAIAnalyticsContext"] = $3711c88a8522b3a9$export$4d3ad568e79b0fd1;

});

parcelRegister("uY2pq", function(module, exports) {
var $3e50bbae71b7b022$export$64b1ad5e685d86fd = /*#__PURE__*/ function(SearchAIAnalyticsContextLocation) {
    SearchAIAnalyticsContextLocation["AI_DEFINITION"] = "ai-definition";
    SearchAIAnalyticsContextLocation["SAIN_AGENT_CARD"] = "sain-agent-card";
    SearchAIAnalyticsContextLocation["SAIN_BOOKMARK"] = "sain-bookmark";
    SearchAIAnalyticsContextLocation["SAIN_JIRA_ISSUE_CARD"] = "sain-jira-issue-card";
    SearchAIAnalyticsContextLocation["SAIN_JIRA_NL_TO_JQL_CARD"] = "sain-jira-nl-to-jql-card";
    SearchAIAnalyticsContextLocation["SAIN_PERSON_CARD"] = "sain-person-card";
    SearchAIAnalyticsContextLocation["SAIN_Q_AND_A_CARD"] = "sain-q-and-a-card";
    SearchAIAnalyticsContextLocation["SAIN_TEAM_CARD"] = "sain-team-card";
    SearchAIAnalyticsContextLocation["SEARCH_RESULT_CONFLUENCE_CARD"] = "search-result-confluence-card";
    return SearchAIAnalyticsContextLocation;
}({});
module.exports["SearchAIAnalyticsContextLocation"] = $3e50bbae71b7b022$export$64b1ad5e685d86fd;

});

parcelRegister("kpjET", function(module, exports) {
/* ai-disclaimer-and-feedback.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $fHs3z = parcelRequire("fHs3z");


var $fodiz = parcelRequire("fodiz");


var $i1t43 = parcelRequire("i1t43");


var $iDrrr = parcelRequire("iDrrr");


var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $lEgaq = parcelRequire("lEgaq");


var $3hVWe = parcelRequire("3hVWe");


var $6O5Et = parcelRequire("6O5Et");


var $h1Grp = parcelRequire("h1Grp");


var $bZMnB = parcelRequire("bZMnB");


var $eySxZ = parcelRequire("eySxZ");


var $8tNXq = parcelRequire("8tNXq");




















var $93fnf = parcelRequire("93fnf");


var $c8bBH = parcelRequire("c8bBH");




const $7d1f13593b920bf8$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ai_feedback_report_consent_checkbox_label: {
        id: "search_ai.ai_feedback_report_consent_checkbox_label",
        defaultMessage: "Include my last prompt and response in the feedback."
    },
    ai_feedback_provide_additional_feedback_title: {
        id: "search_ai.ai_feedback_provide_additional_feedback_title",
        defaultMessage: "Provide additional feedback"
    },
    ai_feedback_like_button_tooltip: {
        id: "search_ai.ai_feedback_like_button_tooltip",
        defaultMessage: "Good response"
    },
    ai_feedback_dislike_button_tooltip: {
        id: "search_ai.ai_feedback_dislike_button_tooltip",
        defaultMessage: "Bad response"
    },
    ai_feedback_can_contact_checkbox_label: {
        id: "search_ai.ai_feedback_can_contact_checkbox_label",
        defaultMessage: "Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the {privatePolicyLink}"
    },
    ai_feedback_private_policy_link: {
        id: "search_ai.ai_feedback_private_policy_link",
        defaultMessage: "Atlassian Privacy Policy"
    },
    ai_feedback_reason_out_of_date: {
        id: "search_ai.ai_feedback_reason_out_of_date",
        defaultMessage: "Out of date"
    },
    ai_feedback_reason_inaccurate: {
        id: "search_ai.ai_feedback_reason_inaccurate",
        defaultMessage: "Inaccurate"
    },
    ai_feedback_reason_too_long: {
        id: "search_ai.ai_feedback_reason_too_long",
        defaultMessage: "Too long"
    },
    ai_feedback_reason_too_short: {
        id: "search_ai.ai_feedback_reason_too_short",
        defaultMessage: "Too short"
    },
    ai_feedback_reason_wrong_sources: {
        id: "search_ai.ai_feedback_reason_wrong_sources",
        defaultMessage: "Wrong sources"
    },
    ai_feedback_reason_inappropriate: {
        id: "search_ai.ai_feedback_reason_inappropriate",
        defaultMessage: "Inappropriate or harmful"
    },
    ai_feedback_reason_other: {
        id: "search_ai.ai_feedback_reason_other",
        defaultMessage: "Other"
    },
    ai_feedback_reason_up_to_date: {
        id: "search_ai.ai_feedback_reason_up_to_date",
        defaultMessage: "Up to date"
    },
    ai_feedback_reason_accurate: {
        id: "search_ai.ai_feedback_reason_accurate",
        defaultMessage: "Accurate"
    },
    ai_feedback_reason_helpful: {
        id: "search_ai.ai_feedback_reason_helpful",
        defaultMessage: "Helpful"
    },
    ai_feedback_reason_following_instructions: {
        id: "search_ai.ai_feedback_reason_following_instructions",
        defaultMessage: "Following instructions"
    },
    ai_feedback_reason_good_sources: {
        id: "search_ai.ai_feedback_reason_good_sources",
        defaultMessage: "Good sources"
    },
    ai_feedback_flag_title: {
        id: "search_ai.ai_feedback_flag_title",
        defaultMessage: "Thank you"
    },
    ai_feedback_flag_description: {
        id: "search_ai.ai_feedback_flag_description",
        defaultMessage: "Your feedback helps to improve Rovo"
    },
    ai_feedback_flag_close_action: {
        id: "search_ai.ai_feedback_flag_close_action",
        defaultMessage: "I'm done"
    },
    ai_feedback_what_hasnt_gone_well_title: {
        id: "search_ai.ai_feedback_what_hasnt_gone_well_title",
        defaultMessage: "What hasn't gone well?"
    },
    ai_feedback_what_has_gone_well_title: {
        id: "search_ai.ai_feedback_what_has_gone_well_title",
        defaultMessage: "What has been going well?"
    },
    ai_feedback_additional_feedback_label: {
        id: "search_ai.ai_feedback_additional_feedback_label",
        defaultMessage: "Additional feedback"
    },
    ai_feedback_additional_feedback_placeholder: {
        id: "search_ai.ai_feedback_additional_feedback_placeholder",
        defaultMessage: "Tell us more"
    }
});


const $ff5baad0a85fb87d$var$LikeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    });
const $ff5baad0a85fb87d$var$ActiveLikeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
        label: "",
        color: "var(--ds-icon-selected, #1868DB)"
    });
const $ff5baad0a85fb87d$var$DislikeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
        label: "",
        color: "var(--ds-icon-subtlest, #6B6E76)"
    });
const $ff5baad0a85fb87d$var$ActiveDislikeIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($93fnf))), {
        label: "",
        color: "var(--ds-icon-selected, #1868DB)"
    });
const $ff5baad0a85fb87d$export$ee3da02b14ab91be = ({ liked: liked, setLiked: setLiked, setShowDisplayFlag: setShowDisplayFlag, onLikeButtonClickHandler: onLikeButtonClickHandler, onDislikeButtonClickHandler: onDislikeButtonClickHandler, onDeselectLikeButtonClickHandler: onDeselectLikeButtonClickHandler, onDeselectDislikeButtonClickHandler: onDeselectDislikeButtonClickHandler })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // Using a single state to represent both like/dislike states
    // true - liked, false - disliked, undefined - neither are selected
    const likeButtonCallback = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        if (liked === undefined || liked === false) {
            setShowDisplayFlag(true);
            setLiked(true);
            onLikeButtonClickHandler && onLikeButtonClickHandler(e);
        } else {
            setLiked(undefined);
            onDeselectLikeButtonClickHandler && onDeselectLikeButtonClickHandler(e);
        }
    }, [
        setShowDisplayFlag,
        setLiked,
        onLikeButtonClickHandler,
        liked,
        onDeselectLikeButtonClickHandler
    ]);
    const dislikeButtonCallback = (0, $cozmU.useCallback)((e)=>{
        e.preventDefault();
        if (liked === undefined || liked === true) {
            setShowDisplayFlag(true);
            setLiked(false);
            onDislikeButtonClickHandler && onDislikeButtonClickHandler(e);
        } else {
            setLiked(undefined);
            onDeselectDislikeButtonClickHandler && onDeselectDislikeButtonClickHandler(e);
        }
    }, [
        setShowDisplayFlag,
        setLiked,
        onDislikeButtonClickHandler,
        liked,
        onDeselectDislikeButtonClickHandler
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: liked === true ? $ff5baad0a85fb87d$var$ActiveLikeIcon : $ff5baad0a85fb87d$var$LikeIcon,
        isSelected: liked === true,
        onClick: likeButtonCallback,
        label: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_like_button_tooltip),
        appearance: liked === true ? 'primary' : 'subtle',
        isTooltipDisabled: false,
        spacing: "compact",
        testId: "ai-answer-like-button",
        shape: "circle"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: liked === false ? $ff5baad0a85fb87d$var$ActiveDislikeIcon : $ff5baad0a85fb87d$var$DislikeIcon,
        isSelected: liked === false,
        onClick: dislikeButtonCallback,
        label: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_dislike_button_tooltip),
        appearance: liked === false ? 'primary' : 'subtle',
        isTooltipDisabled: false,
        spacing: "compact",
        testId: "ai-answer-dislike-button",
        shape: "circle"
    }));
};









var $ad7Ou = parcelRequire("ad7Ou");


var $2uDbg = parcelRequire("2uDbg");


var $8Xvwd = parcelRequire("8Xvwd");

var $dUI0h = parcelRequire("dUI0h");







var $dinVW = parcelRequire("dinVW");




var $e3Wrf = parcelRequire("e3Wrf");


var $zzZbq = parcelRequire("zzZbq");

var $40eab6f0a1c6097d$export$1cf63b56d5de87d5 = /*#__PURE__*/ function(FeedbackCollectorModalVariant) {
    FeedbackCollectorModalVariant["POSITIVE"] = "positive";
    FeedbackCollectorModalVariant["NEGATIVE"] = "negative";
    return FeedbackCollectorModalVariant;
}({});




const $d2986553f1f9cb37$var$AkFeedbackCollector = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("hUVfy")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $d2986553f1f9cb37$export$21ca6c649ed55a5a = ({ entrypointId: entrypointId, attributes: attributes, attributesWithConsent: attributesWithConsent, userId: userId, userName: userName, onClose: onClose, onSubmit: onSubmit, variant: variant })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [hasConsent, setConsent] = (0, $cozmU.useState)(false);
    const [canContact, setCanContact] = (0, $cozmU.useState)(false);
    const [selectedReasons, setSelectedReasons] = (0, $cozmU.useState)([]);
    const [description, setDescription] = (0, $cozmU.useState)('');
    const POSITIVE_FEEDBACK_REASONS = [
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_up_to_date),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_accurate),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_helpful),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_following_instructions),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_good_sources),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_other)
    ];
    const NEGATIVE_FEEDBACK_REASONS = [
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_out_of_date),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_inaccurate),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_too_long),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_too_short),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_wrong_sources),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_inappropriate),
        formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_reason_other)
    ];
    const feedbackOptions = variant === (0, $40eab6f0a1c6097d$export$1cf63b56d5de87d5).POSITIVE ? POSITIVE_FEEDBACK_REASONS : NEGATIVE_FEEDBACK_REASONS;
    const handleReasonClick = (option)=>{
        setSelectedReasons((prev)=>prev.includes(option) ? prev.filter((r)=>r !== option) : [
                ...prev,
                option
            ]);
    };
    const feedbackObject = {
        ...attributes,
        ...hasConsent ? attributesWithConsent : {},
        ...selectedReasons.length > 0 ? {
            'Feedback Reasons': selectedReasons.join(', ')
        } : {}
    };
    const feedbackContext = Object.entries(feedbackObject).map(([key, value])=>`${key}: ${value}`).join(', ');
    const toggleConsentCheckbox = (0, $cozmU.useCallback)(()=>{
        setConsent(!hasConsent);
    }, [
        hasConsent
    ]);
    const sendMetadata = {
        userId: userId
    };
    const getDescriptionWithMetadata = ()=>`
	${description}

	\`\`\`
	${JSON.stringify(sendMetadata, null, 2)}
	\`\`\`
  `;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d2986553f1f9cb37$var$AkFeedbackCollector, {
        onClose: onClose,
        onSubmit: ()=>onSubmit({
                feedbackOptions: selectedReasons,
                additionalFeedbackAdded: description.length > 0,
                includeResponse: hasConsent,
                canContact: canContact
            }),
        showTypeField: false,
        showDefaultTextFields: false,
        atlassianAccountId: userId,
        name: userName,
        entrypointId: entrypointId,
        additionalFields: [
            {
                id: (0, $zzZbq.FEEDBACK_CONTEXT_CF),
                value: feedbackContext
            },
            {
                id: 'customfield_10043',
                value: canContact ? [
                    {
                        id: '10109'
                    }
                ] : [
                    {
                        id: '10111'
                    }
                ]
            }
        ],
        feedbackTitle: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_provide_additional_feedback_title),
        descriptionDefaultValue: getDescriptionWithMetadata(),
        summaryDefaultValue: description,
        canBeContactedFieldId: "undefined",
        showRequiredFieldsSummary: false,
        customContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold",
            color: "color.text.subtle"
        }, formatMessage(variant === (0, $40eab6f0a1c6097d$export$1cf63b56d5de87d5).POSITIVE ? (0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_what_has_gone_well_title : (0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_what_hasnt_gone_well_title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            shouldWrap: true
        }, feedbackOptions.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                key: option,
                isSelected: selectedReasons.includes(option),
                onClick: ()=>handleReasonClick(option)
            }, option)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "feedback-summary",
            label: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_additional_feedback_label),
            isRequired: false,
            defaultValue: ""
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
                ...fieldProps,
                name: "feedback-collector-description",
                minimumRows: 6,
                placeholder: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_additional_feedback_placeholder),
                onChange: (e)=>setDescription(e.target.value),
                value: description
            })), Object.keys(attributesWithConsent).length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Xvwd.CheckboxField), {
            name: "search-ai-include-prompt-and-response",
            defaultIsChecked: hasConsent
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                ...fieldProps,
                label: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_report_consent_checkbox_label),
                onChange: toggleConsentCheckbox
            })) : undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Xvwd.CheckboxField), {
            name: "can-be-contacted",
            defaultIsChecked: canContact
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
                ...fieldProps,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_can_contact_checkbox_label, {
                    privatePolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: "https://www.atlassian.com/legal/privacy-policy",
                        target: "_blank"
                    }, formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_private_policy_link))
                })),
                onChange: (event)=>setCanContact(event.target.checked)
            }))))
    }));
};






const $4a58b9ec9be91f32$export$c71de71744353b85 = (0, $cozmU.lazy)(()=>(parcelRequire("ej9Uw")).then(({ AIFeedbackFlag: AIFeedbackFlag })=>({
            default: AIFeedbackFlag
        })));




const $e1d03c67c6cdc8ad$export$41116a477d95163a = function AIFeedback({ entrypointId: entrypointId, onLikeButtonClickHandler: onLikeButtonClickHandler, onDislikeButtonClickHandler: onDislikeButtonClickHandler, onDeselectLikeButtonClickHandler: onDeselectLikeButtonClickHandler, onDeselectDislikeButtonClickHandler: onDeselectDislikeButtonClickHandler, onFeedbackSubmitHandler: onFeedbackSubmitHandler, userDetails: userDetails, attributes: attributes, attributesWithConsent: attributesWithConsent = {}, liked: externalLike // set like state from the outside
 }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [showFeedbackModal, setShowFeedbackModal] = (0, $cozmU.useState)(false);
    const [showDisplayFlag, setShowDisplayFlag] = (0, $cozmU.useState)(false);
    const [liked, setLiked] = (0, $cozmU.useState)(externalLike);
    const onFeedbackSubmit = ({ feedbackOptions: feedbackOptions, additionalFeedbackAdded: additionalFeedbackAdded, includeResponse: includeResponse, canContact: canContact })=>{
        onFeedbackSubmitHandler?.({
            liked: liked,
            feedbackOptions: feedbackOptions,
            additionalFeedbackAdded: additionalFeedbackAdded,
            includeResponse: includeResponse,
            canContact: canContact
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff5baad0a85fb87d$export$ee3da02b14ab91be), {
        setShowDisplayFlag: setShowDisplayFlag,
        onLikeButtonClickHandler: onLikeButtonClickHandler,
        onDislikeButtonClickHandler: onDislikeButtonClickHandler,
        onDeselectLikeButtonClickHandler: onDeselectLikeButtonClickHandler,
        onDeselectDislikeButtonClickHandler: onDeselectDislikeButtonClickHandler,
        liked: liked,
        setLiked: setLiked
    })), showFeedbackModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d2986553f1f9cb37$export$21ca6c649ed55a5a), {
        entrypointId: entrypointId,
        attributes: attributes,
        attributesWithConsent: attributesWithConsent,
        userId: userDetails.id,
        userName: userDetails.name,
        onClose: ()=>setShowFeedbackModal(false),
        onSubmit: onFeedbackSubmit,
        variant: liked ? (0, $40eab6f0a1c6097d$export$1cf63b56d5de87d5).POSITIVE : (0, $40eab6f0a1c6097d$export$1cf63b56d5de87d5).NEGATIVE
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4a58b9ec9be91f32$export$c71de71744353b85), {
        displayFlag: showDisplayFlag,
        onDismissed: ()=>setShowDisplayFlag(false),
        description: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_flag_description),
        title: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_flag_title),
        actions: [
            {
                content: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_provide_additional_feedback_title),
                onClick: ()=>{
                    setShowDisplayFlag(false);
                    setShowFeedbackModal(true);
                }
            },
            {
                content: formatMessage((0, $7d1f13593b920bf8$export$defe85febe8b728c).ai_feedback_flag_close_action),
                onClick: ()=>setShowDisplayFlag(false)
            }
        ]
    })));
};






var $j9bgP = parcelRequire("j9bgP");

/* sain-more-options-dropdown.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $3vgx3 = parcelRequire("3vgx3");

var $is1T6 = parcelRequire("is1T6");

var $lU4RT = parcelRequire("lU4RT");

var $7DqNt = parcelRequire("7DqNt");

var $9erVg = parcelRequire("9erVg");


var $6spAz = parcelRequire("6spAz");


var $gC2EJ = parcelRequire("gC2EJ");


var $6TaGl = parcelRequire("6TaGl");





var $iMnC5 = parcelRequire("iMnC5");




var $IOtUu = parcelRequire("IOtUu");


var $6dPGs = parcelRequire("6dPGs");


var $4QjIS = parcelRequire("4QjIS");











var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");

var $aRGok = parcelRequire("aRGok");














var $6JEx2 = parcelRequire("6JEx2");





var $lT1k3 = parcelRequire("lT1k3");

function $ffbc3a6135adf3d1$export$9534590fb6ce7f04({ isOpen: isOpen, onClose: onClose }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [promptText, setPromptText] = (0, $cozmU.useState)('');
    (0, $cozmU.useEffect)(()=>{
        if (isOpen) {
            const stored = (0, $6JEx2.getSessionItem)((0, $zzZbq.PROMPT_OVERRIDE_SESSION_KEY));
            setPromptText(stored || '');
        }
    }, [
        isOpen
    ]);
    const handleSave = (0, $cozmU.useCallback)(()=>{
        const trimmedPrompt = promptText.trim();
        if (trimmedPrompt) (0, $6JEx2.setSessionItem)((0, $zzZbq.PROMPT_OVERRIDE_SESSION_KEY), trimmedPrompt);
        else (0, $6JEx2.deleteSessionItem)((0, $zzZbq.PROMPT_OVERRIDE_SESSION_KEY));
        onClose();
    }, [
        promptText,
        onClose
    ]);
    const handleTextChange = (0, $cozmU.useCallback)((e)=>{
        setPromptText(e.target.value);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: onClose,
        width: "large",
        testId: "prompt-override-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $lT1k3.messages).prompt_override_modal_title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $lT1k3.messages).prompt_override_custom_prompt_label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        value: promptText,
        onChange: handleTextChange,
        placeholder: formatMessage((0, $lT1k3.messages).prompt_override_textarea_placeholder),
        testId: "prompt-override-textarea",
        resize: "vertical"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $lT1k3.messages).prompt_override_help_text))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $lT1k3.messages).prompt_override_cancel_button)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: handleSave,
        testId: "prompt-override-save-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $lT1k3.messages).prompt_override_save_button))))));
}


const $af13dc6b3c05e823$var$messages = (0, $kSwu1.defineMessages)({
    debugger_menu_item: {
        id: "search_ai.debugger_menu_item",
        defaultMessage: "Debugger"
    },
    prompt_override_menu_item: {
        id: "search_ai.prompt_override_menu_item",
        defaultMessage: "Prompt override"
    },
    store_message_label: {
        id: "search_ai.store_message_label",
        defaultMessage: "Record this message to help us improve answer quality"
    },
    internal_lozenge: {
        id: "search_ai.internal_lozenge",
        defaultMessage: "INTERNAL"
    }
});
const $af13dc6b3c05e823$var$DROPDOWN_Z_INDEX = 900;
const $af13dc6b3c05e823$var$dropdownPanelStyles = {
    panel: "_39xV02aQBb",
    lozengeWrapper: "_39xV02E6Kk"
};
function $af13dc6b3c05e823$export$fcbb8fd6209efbc6() {
    const [isDebuggerModalOpen, setIsDebuggerModalOpen] = (0, $cozmU.useState)(false);
    const [isPromptOverrideModalOpen, setIsPromptOverrideModalOpen] = (0, $cozmU.useState)(false);
    const isArizeGateOn = (0, $iDrrr.fg)('kd_sain_enable_arize_hello_only');
    const showOnlineDebugger = (0, $iDrrr.fg)('kd_sain_online_debugger');
    const showPromptOverride = (0, $iDrrr.fg)('convo_ai_sain_enable_prompt_override_hello_only');
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [storeMessage, setStoreMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(()=>{
        try {
            const stored = (0, $6dPGs.getLocalStorageItemAsString)('search-ai.sain.store_message');
            return stored === null || stored === 'true';
        } catch  {
            return true;
        }
    });
    const onStoreMessageToggle = ()=>{
        const next = !storeMessage;
        setStoreMessage(next);
        try {
            (0, $6dPGs.setLocalStorageItem)('search-ai.sain.store_message', String(next));
        } catch  {}
    };
    const onMoreOptionsClick = (event)=>{
        event.stopPropagation();
    };
    const onDebuggerClick = ()=>{
        setIsDebuggerModalOpen(true);
    };
    const onPromptOverrideClick = ()=>{
        setIsPromptOverrideModalOpen(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...props,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: "More options",
                appearance: "subtle",
                spacing: "compact",
                testId: "sain-more-options-button",
                onClick: (e)=>{
                    onMoreOptionsClick(e);
                    props.onClick?.(e);
                }
            }),
        placement: "bottom-end",
        zIndex: $af13dc6b3c05e823$var$DROPDOWN_Z_INDEX
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $af13dc6b3c05e823$var$dropdownPanelStyles.panel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, showOnlineDebugger && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6spAz))), {
            label: ""
        }),
        onClick: onDebuggerClick,
        testId: "online-debugger-button"
    }, formatMessage($af13dc6b3c05e823$var$messages.debugger_menu_item)), showPromptOverride && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))), {
            label: ""
        }),
        onClick: onPromptOverrideClick,
        testId: "prompt-override-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $af13dc6b3c05e823$var$messages.prompt_override_menu_item))), isArizeGateOn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7DqNt.default), {
        id: "sain-store-message-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lU4RT.default), {
        id: "sain-store-message",
        isSelected: storeMessage,
        onClick: onStoreMessageToggle,
        testId: "sain-store-message-checkbox"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $af13dc6b3c05e823$var$messages.store_message_label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $af13dc6b3c05e823$var$dropdownPanelStyles.lozengeWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
        text: formatMessage($af13dc6b3c05e823$var$messages.internal_lozenge),
        isRemovable: false,
        migration_fallback: "lozenge"
    })))))))), showOnlineDebugger && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4QjIS.OnlineDebuggerModal), {
        isOpen: isDebuggerModalOpen,
        onClose: ()=>setIsDebuggerModalOpen(false)
    }), showPromptOverride && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ffbc3a6135adf3d1$export$9534590fb6ce7f04), {
        isOpen: isPromptOverrideModalOpen,
        onClose: ()=>setIsPromptOverrideModalOpen(false)
    }));
}


const $3b7931cf87bf2e51$var$messages = (0, $kSwu1.defineMessages)({
    ai_content_disclaimer: {
        id: "search_ai.ai_content_disclaimer",
        defaultMessage: "Uses AI. Verify results."
    },
    ai_answer_component_copy_button: {
        id: "search_ai.ai_answer_component_copy_button",
        defaultMessage: "Copy"
    }
});
const $3b7931cf87bf2e51$var$copyIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
        color: "var(--ds-icon-subtlest, #6B6E76)",
        label: "copy"
    });
const $3b7931cf87bf2e51$var$styles = {
    heightWrapper: "_0jFU0VoWWg"
};
function $3b7931cf87bf2e51$export$7c1b08f310ac0a6a({ showFeedbackButtons: showFeedbackButtons, showCopyButton: showCopyButton, showAIUsageDisclaimer: showAIUsageDisclaimer = true, copyText: copyText, renderedContentRef: renderedContentRef }) {
    const { commonAttributes: commonAttributes, isAnswered: isAnswered } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { answerString: answerString } = commonAttributes;
    const feedbackOptions = (0, $h1Grp.useSmartAnswerCardFeedbackOptions)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const isArizeGateOn = (0, $iDrrr.fg)('kd_sain_enable_arize_hello_only');
    const showOnlineDebuggerButton = isAnswered && (0, $iDrrr.fg)('kd_sain_online_debugger');
    const showPromptOverrideButton = (0, $iDrrr.fg)('convo_ai_sain_enable_prompt_override_hello_only');
    const hasMoreOptions = isAnswered && (isArizeGateOn || showPromptOverrideButton);
    const showOnlineDebuggerInline = showOnlineDebuggerButton && !hasMoreOptions;
    const onLinkClickHandler = (event)=>{
        event.stopPropagation();
    };
    const onLikeButtonClickHandler = (event)=>{
        event.stopPropagation();
        feedbackOptions.onLikeButtonClickHandler();
    };
    const onDislikeButtonClickHandler = (event)=>{
        event.stopPropagation();
        feedbackOptions.onDislikeButtonClickHandler();
    };
    const onDeselectLikeButtonClickHandler = (event)=>{
        event.stopPropagation();
        feedbackOptions.onDeselectLikeButtonClickHandler();
    };
    const onDeselectDislikeButtonClickHandler = (event)=>{
        event.stopPropagation();
        feedbackOptions.onDeselectDislikeButtonClickHandler();
    };
    const onCopyButtonClickHandler = async (event)=>{
        event.stopPropagation();
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).COPY_CLICKED,
            commonAttributes: commonAttributes
        });
        fireAnalyticsEvent((0, $6O5Et.onAIAnswerCopyButtonClicked)(commonAttributes));
        if (copyText) await navigator.clipboard.writeText(copyText);
        else {
            const plainText = answerString.replace(/\s*\[\^\d+\^\]\s*/g, ' ').replace(/  +/g, ' ').trim();
            try {
                const node = renderedContentRef?.current;
                if (node) {
                    const clonedNode = node.cloneNode(true);
                    clonedNode.querySelectorAll((0, $lEgaq.SAIN_CITATION_SELECTOR)).forEach((el)=>el.remove());
                    const htmlBlob = new Blob([
                        clonedNode.innerHTML
                    ], {
                        type: 'text/html'
                    });
                    const textBlob = new Blob([
                        plainText
                    ], {
                        type: 'text/plain'
                    });
                    await navigator.clipboard.write([
                        new ClipboardItem({
                            'text/html': htmlBlob,
                            'text/plain': textBlob
                        })
                    ]);
                } else await navigator.clipboard.writeText(plainText);
            } catch  {
                await navigator.clipboard.writeText(plainText);
            }
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "end",
        grow: "fill",
        spread: "space-between",
        xcss: $3b7931cf87bf2e51$var$styles.heightWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.025"
    }, showAIUsageDisclaimer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: "",
        size: "small",
        spacing: "compact"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        appearance: "subtle",
        href: (0, $zzZbq.ATLASSIAN_INTELLIGENCE_TRUST_LINK),
        onClick: onLinkClickHandler,
        rel: "noopener noreferrer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3b7931cf87bf2e51$var$messages.ai_content_disclaimer)))) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, showFeedbackButtons ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e1d03c67c6cdc8ad$export$41116a477d95163a), {
        entrypointId: feedbackOptions.entrypointId,
        userDetails: feedbackOptions.userDetails,
        attributes: feedbackOptions.attributes,
        attributesWithConsent: feedbackOptions.attributesWithConsent,
        onLikeButtonClickHandler: onLikeButtonClickHandler,
        onDislikeButtonClickHandler: onDislikeButtonClickHandler,
        onDeselectLikeButtonClickHandler: onDeselectLikeButtonClickHandler,
        onDeselectDislikeButtonClickHandler: onDeselectDislikeButtonClickHandler,
        onFeedbackSubmitHandler: feedbackOptions.onFeedbackSubmitHandler
    }) : null, showCopyButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: $3b7931cf87bf2e51$var$copyIcon,
        label: formatMessage($3b7931cf87bf2e51$var$messages.ai_answer_component_copy_button),
        onClick: onCopyButtonClickHandler,
        appearance: "subtle",
        isTooltipDisabled: false,
        spacing: "compact",
        shape: "circle",
        testId: "copy-button"
    }) : null, showOnlineDebuggerInline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j9bgP.OnlineDebuggerButton), null), hasMoreOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af13dc6b3c05e823$export$fcbb8fd6209efbc6), null)));
}
module.exports["AIDisclaimerAndFeedback"] = $3b7931cf87bf2e51$export$7c1b08f310ac0a6a;

});

parcelRegister("h1Grp", function(module, exports) {

var $bZMnB = parcelRequire("bZMnB");


var $eySxZ = parcelRequire("eySxZ");


var $8tNXq = parcelRequire("8tNXq");


var $zzZbq = parcelRequire("zzZbq");


var $3hVWe = parcelRequire("3hVWe");


var $4Tg3t = parcelRequire("4Tg3t");

const $740fc7030b799668$export$47b58698bef30558 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDeselectDislikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};





const $9b118bbd0d29337f$export$473e6bca52fdbe16 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDeselectLikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};



var $bIZaC = parcelRequire("bIZaC");




const $3218e8c3e413cf9e$export$67d198681f64796b = (props)=>{
    const { query: query, answerString: answerString, source: source, feedbackSentiment: feedbackSentiment, feedbackOptions: feedbackOptions, additionalFeedbackAdded: additionalFeedbackAdded, includeResponse: includeResponse, canContact: canContact } = props;
    return {
        action: 'submitted',
        actionSubject: 'aiAnswerFeedback',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            feedbackSentiment: feedbackSentiment,
            feedbackOptions: feedbackOptions,
            additionalFeedbackAdded: additionalFeedbackAdded,
            includeResponse: includeResponse,
            canContact: canContact
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};



var $7z5N5 = parcelRequire("7z5N5");

function $fcd16e1a27802e9e$export$7cac3b748a811283() {
    const { commonAttributes: commonAttributes, readingAidsOptions: readingAidsOptions, updateContextCache: updateContextCache, userDetails: userDetails } = (0, $3hVWe.useAIAnswerContext)();
    const { query: query, errorState: errorState, searchSessionId: searchSessionId, source: source, queryHash: queryHash, cloudId: cloudId, answerString: answerString, extraAttributes: extraAttributes } = commonAttributes;
    const { originalQuery: originalQuery } = extraAttributes;
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const onLikeButtonClickHandler = ()=>{
        updateContextCache({
            collapsed: false,
            liked: true
        });
        fireAnalyticsEvent((0, $7z5N5.onLikeButtonClick)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).POSITIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    };
    const onDislikeButtonClickHandler = ()=>{
        updateContextCache({
            collapsed: false,
            liked: false
        });
        fireAnalyticsEvent((0, $bIZaC.onDislikeButtonClick)(commonAttributes));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).NEGATIVE_FEEDBACK_PROVIDED,
            commonAttributes: commonAttributes
        });
    };
    const onDeselectLikeButtonClickHandler = ()=>{
        updateContextCache({
            collapsed: false,
            liked: undefined
        });
        fireAnalyticsEvent((0, $9b118bbd0d29337f$export$473e6bca52fdbe16)(commonAttributes));
    };
    const onDeselectDislikeButtonClickHandler = ()=>{
        updateContextCache({
            collapsed: false,
            liked: undefined
        });
        fireAnalyticsEvent((0, $740fc7030b799668$export$47b58698bef30558)(commonAttributes));
    };
    const onFeedbackSubmitHandler = ({ liked: liked, feedbackOptions: feedbackOptions, additionalFeedbackAdded: additionalFeedbackAdded, includeResponse: includeResponse, canContact: canContact })=>{
        fireAnalyticsEvent((0, $3218e8c3e413cf9e$export$67d198681f64796b)({
            ...commonAttributes,
            feedbackSentiment: liked ? 'positive' : 'negative',
            feedbackOptions: feedbackOptions,
            additionalFeedbackAdded: additionalFeedbackAdded,
            includeResponse: includeResponse,
            canContact: canContact
        }));
    };
    const feedbackAttributes = {
        searchSessionId: searchSessionId,
        source: source,
        queryHash: queryHash,
        cloudId: cloudId,
        documentId: readingAidsOptions?.contentARI,
        errorState: errorState
    };
    const feedbackAttributesWithConsent = {
        transformedPrompt: query,
        originalPrompt: originalQuery,
        answer: answerString
    };
    const feedbackOptions = {
        attributes: feedbackAttributes,
        attributesWithConsent: feedbackAttributesWithConsent,
        entrypointId: (0, $zzZbq.FEEDBACK_ENTRYPOINT_ID_SAIN),
        onLikeButtonClickHandler: onLikeButtonClickHandler,
        onDislikeButtonClickHandler: onDislikeButtonClickHandler,
        onDeselectLikeButtonClickHandler: onDeselectLikeButtonClickHandler,
        onDeselectDislikeButtonClickHandler: onDeselectDislikeButtonClickHandler,
        onFeedbackSubmitHandler: onFeedbackSubmitHandler,
        userDetails: userDetails
    };
    return feedbackOptions;
}
module.exports["useSmartAnswerCardFeedbackOptions"] = $fcd16e1a27802e9e$export$7cac3b748a811283;

});

parcelRegister("hUVfy", function(module, exports) {

let $d0b41348fd61a524$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d0b41348fd61a524$var$load("hhss7"),
    $d0b41348fd61a524$var$load("7gL7H")
]).then(()=>parcelRequire('91uAX'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("ej9Uw", function(module, exports) {

let $a6aa871bd154cbaa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a6aa871bd154cbaa$var$load("1ocnt").then(()=>parcelRequire('hPzO4'));

});

parcelRegister("bE9h1", function(module, exports) {

let $87aa9fa7f0d924ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $87aa9fa7f0d924ad$var$load("cTPK8").then(()=>parcelRequire('ewOJJ'));

});

parcelRegister("aiIBH", function(module, exports) {
/* smart-answer-card-body-generating.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $cJ0FD = parcelRequire("cJ0FD");


var $9ivsj = parcelRequire("9ivsj");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $a9aSv = parcelRequire("a9aSv");


var $3hVWe = parcelRequire("3hVWe");

/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 


const $c75d50a61266072a$export$62d54f79d0abe5c8 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "14",
        height: "20",
        viewBox: "0 0 14 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "3",
        cy: "14",
        r: "1",
        fill: '#1F69DA'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "7",
        cy: "14",
        r: "1",
        fill: '#C16CD4'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "11",
        cy: "14",
        r: "1",
        fill: '#F5A117'
    }));
};



var $7qJqb = parcelRequire("7qJqb");


var $kSORO = parcelRequire("kSORO");


var $8tNXq = parcelRequire("8tNXq");


var $7DMz5 = parcelRequire("7DMz5");


var $24oKg = parcelRequire("24oKg");


var $9LgVw = parcelRequire("9LgVw");

const $738473f8dd204ed0$var$styles = {
    containerNewSAINLoading: "_1Znuxb5zaO _2Zuz6Q5zaO _0Of8r25zaO _1wydGW5zaO _0jFU0Vk3g7 _3X9j4qyIAw",
    inline: "_2Zuz6Q2ADO _1Znuxb2ADO _1wydGW2ADO _0Of8r22ADO",
    inlineAnimation: "_3iDTPbccYA _1RrJLit2nV",
    jiraNlToJqlCardHeightOverride: "_0jFU0V2LXa",
    jiraNlToJqlSmartlinkCardHeightOverride: "_0jFU0Vk3g7",
    navigationalCardHeightOverride: "_0jFU0VehCh",
    luminaOverride: "_0jFU0VaG3x _0Of8r2Pgdg _2Zuz6QPgdg _1ZnuxbPgdg",
    borderlessNoPadding: "_0jFU0Voaux _0Of8r2Pgdg _2Zuz6QPgdg _1ZnuxbPgdg _1wydGWPgdg",
    luminaTallHeightOverride: "_0jFU0Vheo5 _0Of8r2Pgdg _2Zuz6QPgdg _1ZnuxbPgdg",
    sourcesSidePanelOverride: "_0jFU0VqfN2"
};
const $738473f8dd204ed0$var$SKELETON_HEIGHT_LINE = '16px';
const $738473f8dd204ed0$var$SKELETON_BORDER_RADIUS = "var(--ds-radius-medium, 6px)";
const $738473f8dd204ed0$var$skeletonLinesStandard = [
    {
        width: '100%',
        height: $738473f8dd204ed0$var$SKELETON_HEIGHT_LINE
    },
    {
        width: '100%',
        height: $738473f8dd204ed0$var$SKELETON_HEIGHT_LINE
    },
    {
        width: '90%',
        height: $738473f8dd204ed0$var$SKELETON_HEIGHT_LINE
    }
]; /** Borderless UX: 3 lines (two full-width, one 75%). */ 
const $738473f8dd204ed0$var$skeletonLinesBorderless = [
    {
        width: '100%',
        height: $738473f8dd204ed0$var$SKELETON_HEIGHT_LINE
    },
    {
        width: '100%',
        height: $738473f8dd204ed0$var$SKELETON_HEIGHT_LINE
    },
    {
        width: '75%',
        height: $738473f8dd204ed0$var$SKELETON_HEIGHT_LINE
    }
];
function $738473f8dd204ed0$var$getSkeletonLines(isBorderlessUX) {
    return isBorderlessUX ? $738473f8dd204ed0$var$skeletonLinesBorderless : $738473f8dd204ed0$var$skeletonLinesStandard;
}
function $738473f8dd204ed0$export$950bbac928c95aa6({ heightOverride: heightOverride }) {
    const { commonAttributes: commonAttributes, queryReasoning: queryReasoning } = (0, $3hVWe.useAIAnswerContext)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const isReducedMotion = (0, $9ivsj.useIsReducedMotion)();
    const normalizeReasoningString = (str)=>{
        if (!str) return str;
        let result = `${str.charAt(0).toLowerCase()}${str.slice(1)}`; // Remove trailing period if it exists
        if (result.endsWith('.')) result = result.slice(0, -1);
        return result;
    };
    (0, $cozmU.useEffect)(()=>{
        fireAnalyticsEvent((0, $kSORO.onAIAnswerLoadingDialogShown)(commonAttributes)); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: (0, $w6R6I.cx)($738473f8dd204ed0$var$styles.containerNewSAINLoading, heightOverride === 'jiraNlToJqlCard' && $738473f8dd204ed0$var$styles.jiraNlToJqlCardHeightOverride, heightOverride === 'jiraNlToJqlSmartlinkCard' && $738473f8dd204ed0$var$styles.jiraNlToJqlSmartlinkCardHeightOverride, heightOverride === 'navigationalCard' && $738473f8dd204ed0$var$styles.navigationalCardHeightOverride, heightOverride === 'lumina' && ((0, $iDrrr.fg)('kd_team_26_sain_borderless_update') || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled()) && $738473f8dd204ed0$var$styles.luminaOverride, !heightOverride && ((0, $iDrrr.fg)('kd_team_26_sain_borderless_update') || (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled()) && $738473f8dd204ed0$var$styles.borderlessNoPadding, !heightOverride && (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && $738473f8dd204ed0$var$styles.sourcesSidePanelOverride, heightOverride === 'lumina' && (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && $738473f8dd204ed0$var$styles.luminaTallHeightOverride),
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: 'space.100',
        xcss: $738473f8dd204ed0$var$styles.inline,
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9LgVw))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: 'color.text.subtle'
    }, queryReasoning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $24oKg.messages).smart_answer_card_rovo_generating,
        values: {
            queryReasoning: normalizeReasoningString(queryReasoning)
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $24oKg.messages).smart_answer_card_rovo_is_thinking), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $738473f8dd204ed0$var$styles.inlineAnimation
    }, isReducedMotion ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c75d50a61266072a$export$62d54f79d0abe5c8), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7qJqb.RovoGeneratingAnimation), null)))), $738473f8dd204ed0$var$getSkeletonLines((0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled()).map((line, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            key: index,
            width: line.width,
            height: line.height,
            color: "var(--ds-skeleton-subtle, #17171708)",
            borderRadius: $738473f8dd204ed0$var$SKELETON_BORDER_RADIUS
        })), heightOverride === 'lumina' && (0, $7DMz5.SAINFeatureControl).isSAINUXUpliftEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "256px",
        height: "166px",
        color: "var(--ds-skeleton-subtle, #17171708)",
        borderRadius: $738473f8dd204ed0$var$SKELETON_BORDER_RADIUS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "256px",
        height: "166px",
        color: "var(--ds-skeleton-subtle, #17171708)",
        borderRadius: $738473f8dd204ed0$var$SKELETON_BORDER_RADIUS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "256px",
        height: "166px",
        color: "var(--ds-skeleton-subtle, #17171708)",
        borderRadius: $738473f8dd204ed0$var$SKELETON_BORDER_RADIUS
    })));
}
module.exports["SmartAnswerCardBodyGenerating"] = $738473f8dd204ed0$export$950bbac928c95aa6;

});

parcelRegister("jtIlq", function(module, exports) {
const $c84c1835c8e6cc3a$export$89dd6b6e370100a2 = (props)=>{
    const { answerString: answerString, brand: brand, query: query, queryHash: queryHash, searchSessionId: searchSessionId, source: source, targetMarker: targetMarker, answerCardType: answerCardType, location: location, isAuxClick: isAuxClick, isContextMenu: isContextMenu, queryLength: queryLength, wordCount: wordCount, queryIntent: queryIntent, jiraNlToJqlCardVariant: jiraNlToJqlCardVariant, elementInteracted: elementInteracted, imageCount: imageCount, imageIndex: imageIndex, imageSimilarity: imageSimilarity, imageMaxVisibleCount: imageMaxVisibleCount } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDialog',
        actionSubjectId: 'knowledgeCardLink',
        source: source,
        eventType: 'track',
        attributes: {
            brand: brand,
            queryHash: queryHash,
            searchSessionId: searchSessionId,
            targetMarker: targetMarker,
            location: location,
            answerCardType: answerCardType,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu,
            queryLength: queryLength,
            wordCount: wordCount,
            queryIntent: queryIntent,
            jiraNlToJqlCardVariant: jiraNlToJqlCardVariant,
            elementInteracted: elementInteracted,
            imageCount: imageCount,
            imageIndex: imageIndex,
            imageSimilarity: imageSimilarity,
            imageMaxVisibleCount: imageMaxVisibleCount
        },
        nonPrivacySafeAttributes: {
            answerString: answerString,
            query: query
        }
    };
};
module.exports["onNonGenerativeKnowledgeCardLinkClick"] = $c84c1835c8e6cc3a$export$89dd6b6e370100a2;

});

parcelRegister("dsm4u", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $fodiz = parcelRequire("fodiz");


var $i1t43 = parcelRequire("i1t43");


var $9iaFM = parcelRequire("9iaFM");


var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");


var $cXLoX = parcelRequire("cXLoX");


var $3hVWe = parcelRequire("3hVWe");


var $1mpi6 = parcelRequire("1mpi6");


var $bZMnB = parcelRequire("bZMnB");


var $eySxZ = parcelRequire("eySxZ");


var $8tNXq = parcelRequire("8tNXq");


var $kisaw = parcelRequire("kisaw");


var $zzZbq = parcelRequire("zzZbq");


var $aqqYN = parcelRequire("aqqYN");


var $1UlLI = parcelRequire("1UlLI");


var $jtIlq = parcelRequire("jtIlq");


var $9oghv = parcelRequire("9oghv");


var $kpjET = parcelRequire("kpjET");

/* separator-line.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $iMnC5 = parcelRequire("iMnC5");

const $05099f6c2a6daf9f$var$styles = {
    line: "_0jFU0VHZdu _39xV02N91d _0KLXrueZ10"
};
const $05099f6c2a6daf9f$export$8be205ba9c2e6f62 = ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $05099f6c2a6daf9f$var$styles.line
    });



var $i3wdq = parcelRequire("i3wdq");

const $04894e3a3b018384$var$messages = (0, $kSwu1.defineMessages)({
    topic_knowledge_card_why_tooltip: {
        id: "search_ai.topic_knowledge_card.why_tooltip",
        defaultMessage: "We think your search might be related to {topicName}"
    },
    topic_knowledge_card_people_heading: {
        id: "search_ai.topic_knowledge_card.people_heading",
        defaultMessage: "People"
    },
    topic_knowledge_card_people_view_all_cta: {
        id: "search_ai.topic_knowledge_card.people_view_all_cta",
        defaultMessage: "View all"
    }
});
const $04894e3a3b018384$export$559a249c395cc3e2 = ({ onFMPReached: onFMPReached })=>{
    const { commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { answerString: answerString, brand: brand, cloudId: cloudId, query: query, searchSessionId: searchSessionId } = commonAttributes;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { trackAIInteractionInit: trackAIInteractionInit } = (0, $cXLoX.useAIEventsInstrumentation)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { tenantContext: { cloudUrl: cloudUrl } } = (0, $kisaw.useTenantContext)(cloudId);
    const analyticsAttributes = (0, $cozmU.useMemo)(()=>({
            searchSessionId: searchSessionId,
            queryHash: (0, $9oghv.sha256Hash)(query),
            brand: brand,
            source: 'topic_knowledge_card',
            query: query,
            answerString: answerString,
            answerCardType: (0, $zzZbq.AnswerCardType).TOPIC
        }), [
        searchSessionId,
        query,
        brand,
        answerString
    ]);
    (0, $cozmU.useEffect)(()=>{
        onFMPReached?.();
        trackAIInteractionInit();
        fireSAINUsageEvent({
            commonAttributes: commonAttributes
        });
        fireAnalyticsEvent((0, $1mpi6.onNonGenerativeAIAnswerResultShown)(analyticsAttributes));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleTopicClick = ()=>{
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).TOPIC_KNOWLEDGE_CARD_CLICKED,
            commonAttributes: commonAttributes
        });
        fireAnalyticsEvent((0, $jtIlq.onNonGenerativeKnowledgeCardLinkClick)(analyticsAttributes));
    };
    const topicData = JSON.parse(answerString);
    const relatedUsers = topicData.users;
    const topicUrl = cloudUrl ? `${cloudUrl}/wiki/topics/${topicData.topic.id}` : '';
    const getUserUrl = (userId)=>{
        return cloudUrl ? `${cloudUrl}/wiki/people/${userId}` : '';
    };
    // if reached here, this means we query intent as topic
    // but topic query did not find topic for id returned by query intent
    if (topicData.topic.message) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i3wdq.KnowledgeCard), {
        name: "smart-answers-topic-knowledge-card",
        size: "full"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: topicUrl,
        appearance: "subtle",
        onClick: handleTopicClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "large",
        color: "color.link",
        weight: "semibold"
    }, topicData.topic.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage($04894e3a3b018384$var$messages.topic_knowledge_card_why_tooltip, {
            topicName: topicData.topic.name
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: "",
        size: "small",
        color: "var(--ds-text-subtlest, #6B6E76)"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle"
    }, topicData.topic.description), relatedUsers.nodes && relatedUsers.nodes.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $05099f6c2a6daf9f$export$8be205ba9c2e6f62), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h6",
        size: "small"
    }, formatMessage($04894e3a3b018384$var$messages.topic_knowledge_card_people_heading)), relatedUsers.nodes.length > 4 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: topicUrl,
        appearance: "subtle",
        onClick: handleTopicClick,
        testId: "view-all-people-cta"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage($04894e3a3b018384$var$messages.topic_knowledge_card_people_view_all_cta)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9iaFM.Grid), {
        templateColumns: "1fr 1fr",
        gap: "space.100"
    }, relatedUsers.nodes.slice(0, 4).map(({ user: user })=>user && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: getUserUrl(user.accountId),
            appearance: "subtle",
            key: user.id,
            testId: "topic-person-row"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aqqYN.KnowledgeCardsRow), {
            primaryText: user.name,
            secondaryText: user.extendedProfile?.jobTitle ?? '',
            pictureUrl: user.picture,
            type: (0, $1UlLI.KnowledgeCardsRowType).PERSON
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpjET.AIDisclaimerAndFeedback), {
        showFeedbackButtons: true
    })));
};
module.exports["TopicKnowledgeCard"] = $04894e3a3b018384$export$559a249c395cc3e2;

});

parcelRegister("1mpi6", function(module, exports) {
const $1f58c85daee7e042$export$5a7faebf1192b4e4 = ({ searchSessionId: searchSessionId, queryHash: queryHash, brand: brand, source: source, query: query, answerString: answerString, answerCardType: answerCardType, fmpLoadTime: fmpLoadTime, resourceType: resourceType, imageCount: imageCount, imageMaxVisibleCount: imageMaxVisibleCount })=>{
    return {
        action: 'shown',
        actionSubject: 'aiAnswerResult',
        source: source,
        eventType: 'track',
        attributes: {
            searchSessionId: searchSessionId,
            queryHash: queryHash,
            brand: brand,
            source: source,
            answerCardType: answerCardType,
            fmpLoadTime: fmpLoadTime,
            resourceType: resourceType,
            imageCount: imageCount,
            imageMaxVisibleCount: imageMaxVisibleCount
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
module.exports["onNonGenerativeAIAnswerResultShown"] = $1f58c85daee7e042$export$5a7faebf1192b4e4;

});

parcelRegister("i3wdq", function(module, exports) {
/* KnowledgeCard.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");


var $a1L5E = parcelRequire("a1L5E");

const $6f4bbb71feeafa31$var$knowledgeCardStyles = {
    default: "_0bjKvDKxmn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    compact: "_0Of8r28HPE _1Znuxb8HPE _2Zuz6Q8HPE _1wydGW8HPE",
    full: "_0Of8r25zaO _1Znuxb5zaO _2Zuz6Q5zaO _1wydGW5zaO"
};
const $6f4bbb71feeafa31$var$defaultInlineProps = {
    alignBlock: 'center',
    grow: 'fill',
    space: 'space.050'
};
const $6f4bbb71feeafa31$export$ab2444a256fc8a9b = ({ name: name, size: size, children: children, containerStyles: containerStyles, ...inlineProps })=>{
    const knowledgeCardProps = {
        ...$6f4bbb71feeafa31$var$defaultInlineProps,
        ...inlineProps
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        ...knowledgeCardProps,
        xcss: containerStyles ?? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $w6R6I.cx)($6f4bbb71feeafa31$var$knowledgeCardStyles.default, size === 'full' ? $6f4bbb71feeafa31$var$knowledgeCardStyles.full : $6f4bbb71feeafa31$var$knowledgeCardStyles.compact)
    }, children)));
};
module.exports["KnowledgeCard"] = $6f4bbb71feeafa31$export$ab2444a256fc8a9b;

});

parcelRegister("jXQUy", function(module, exports) {

var $5hJlu = parcelRequire("5hJlu");

const $acdc855de2da24d5$export$8a4355009b280d8c = (cloudId)=>new (0, $5hJlu.default)({
        url: '/gateway/api/directory/graphql',
        productIdentifier: 'rovo',
        cloudId: cloudId
    });
module.exports["createProfileClient"] = $acdc855de2da24d5$export$8a4355009b280d8c;

});

parcelRegister("9T3jg", function(module, exports) {
var $5a727b0364f0f178$export$ba9062c439fa44bc = /*#__PURE__*/ function(KnowledgeCardsIntentType) {
    KnowledgeCardsIntentType["PERSON"] = "PERSON";
    KnowledgeCardsIntentType["TEAM"] = "TEAM";
    KnowledgeCardsIntentType["AGENT"] = "AGENT";
    KnowledgeCardsIntentType["VISUAL"] = "VISUAL";
    return KnowledgeCardsIntentType;
}({});
module.exports["KnowledgeCardsIntentType"] = $5a727b0364f0f178$export$ba9062c439fa44bc;

});

parcelRegister("3TiFP", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

const $06aa11e767251fd7$export$63a5aef02e499ea6 = (props)=>{
    const { source: source, location: location, position: position, shownAfterCardBodyExpanded: shownAfterCardBodyExpanded, isAuxClick: isAuxClick, isContextMenu: isContextMenu } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDialog',
        actionSubjectId: 'knowledgeCardLink',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            location: location,
            position: position,
            shownAfterCardBodyExpanded: shownAfterCardBodyExpanded,
            isAuxClick: isAuxClick,
            isContextMenu: isContextMenu
        }
    };
};
module.exports["onKnowledgeCardLinkClick"] = $06aa11e767251fd7$export$63a5aef02e499ea6;

});

parcelRegister("e5LDW", function(module, exports) {

let $a4267d494612a282$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a4267d494612a282$var$load("4yYL2"),
    $a4267d494612a282$var$load("90vep"),
    $a4267d494612a282$var$load("aAJyu"),
    $a4267d494612a282$var$load("f8Q8b"),
    $a4267d494612a282$var$load("6wr18"),
    $a4267d494612a282$var$load("aLwQm"),
    $a4267d494612a282$var$load("gcLWi"),
    $a4267d494612a282$var$load("fsgrC"),
    $a4267d494612a282$var$load("hhss7"),
    $a4267d494612a282$var$load("Wowvf"),
    $a4267d494612a282$var$load("iBJWz"),
    $a4267d494612a282$var$load("jL1Ke"),
    $a4267d494612a282$var$load("5MQ0D"),
    $a4267d494612a282$var$load("kwVVP"),
    $a4267d494612a282$var$load("4x9Jx"),
    $a4267d494612a282$var$load("ffEVr"),
    $a4267d494612a282$var$load("cUdI6"),
    $a4267d494612a282$var$load("k7QWO")
]).then(()=>parcelRequire('fqHdA'));

});

parcelRegister("66eSg", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $eW61a = parcelRequire("eW61a");


var $9T3jg = parcelRequire("9T3jg");

const $39940d89fb6a2fb7$export$cf6047b656d24746 = (props)=>{
    const { cloudId: cloudId, currentUserId: currentUserId, viewAllUrl: viewAllUrl } = props;
    const backupViewAllUrl = `https://hello.atlassian.net/people/${currentUserId}/work`;
    const { href: profileWorkList, onNavigate: profileWorkListOnNavigate } = (0, $eW61a.navigateToTeamsApp)(props.type === (0, $9T3jg.KnowledgeCardsIntentType).PERSON ? {
        type: 'USER_WORK',
        payload: {
            userId: currentUserId || ''
        },
        cloudId: cloudId
    } : {
        type: 'TEAM',
        payload: {
            teamId: props.teamId || ''
        },
        cloudId: cloudId
    });
    const { href: worksWithHref, onNavigate: worksWithOnNavigate } = (0, $eW61a.navigateToTeamsApp)(props.type === (0, $9T3jg.KnowledgeCardsIntentType).PERSON ? {
        type: 'USER',
        payload: {
            userId: currentUserId || '',
            section: 'workswith'
        },
        cloudId: cloudId
    } : {
        type: 'TEAM',
        payload: {
            teamId: props.teamId || ''
        },
        cloudId: cloudId
    });
    const { href: profileHref, onNavigate: profileOnNavigate } = (0, $eW61a.navigateToTeamsApp)(props.type === (0, $9T3jg.KnowledgeCardsIntentType).PERSON ? {
        type: 'USER',
        payload: {
            userId: currentUserId || ''
        },
        cloudId: cloudId
    } : {
        type: 'TEAM',
        payload: {
            teamId: props.teamId || ''
        },
        cloudId: cloudId
    });
    const toUser = (userId)=>(0, $eW61a.navigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: userId
            },
            cloudId: cloudId
        });
    const viewAllLink = (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileWorkList : viewAllUrl || backupViewAllUrl;
    return {
        viewAllLink: viewAllLink,
        viewAllOnNavigate: profileWorkListOnNavigate,
        worksWithHref: worksWithHref,
        worksWithOnNavigate: worksWithOnNavigate,
        profileHref: profileHref,
        profileOnNavigate: profileOnNavigate,
        toUser: toUser
    };
};
module.exports["useTeamsAppLinks"] = $39940d89fb6a2fb7$export$cf6047b656d24746;

});

parcelRegister("jDZkE", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");

async function $a6477302ddfc174b$export$ebe243ab960e089b({ url: url, body: body }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        }
    };
    return (0, $gABt9.utils).requestService({
        url: url
    }, options);
}
module.exports["fetchRestResponse"] = $a6477302ddfc174b$export$ebe243ab960e089b;

});

parcelRegister("8cQty", function(module, exports) {

let $5f98264cc0a82491$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f98264cc0a82491$var$load("cqTuN").then(()=>parcelRequire('5X7NK'));

});

parcelRegister("7Ktzp", function(module, exports) {

let $5a43c44540ae9f28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a43c44540ae9f28$var$load("5HcXV").then(()=>parcelRequire('iqm7a'));

});

parcelRegister("3OvSI", function(module, exports) {

let $2c6ec59c27646bf7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2c6ec59c27646bf7$var$load("dy4Zx").then(()=>parcelRequire('16e2H'));

});

parcelRegister("3KmhA", function(module, exports) {

let $2ba6f3d2a25215de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2ba6f3d2a25215de$var$load("17hGM").then(()=>parcelRequire('JVRDQ'));

});

parcelRegister("1AEVX", function(module, exports) {

let $1288e7dbed343dc7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1288e7dbed343dc7$var$load("7ZfPc").then(()=>parcelRequire('aZy6m'));

});

parcelRegister("gQR0I", function(module, exports) {

let $c44a9f7a8414e316$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c44a9f7a8414e316$var$load("23syh").then(()=>parcelRequire('hEaEz'));

});

parcelRegister("fZZNg", function(module, exports) {

let $ba5c7c74ba8b8e9e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba5c7c74ba8b8e9e$var$load("3pbEP").then(()=>parcelRequire('a4GAP'));

});

parcelRegister("85e4s", function(module, exports) {

let $5e29b48ac9db1c06$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e29b48ac9db1c06$var$load("6O1JJ").then(()=>parcelRequire('jej7M'));

});

parcelRegister("5aiwI", function(module, exports) {

let $3c2c41f3ce57d161$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c2c41f3ce57d161$var$load("lewFW").then(()=>parcelRequire('3BrK1'));

});

parcelRegister("d0yG9", function(module, exports) {

let $97862cf403be8595$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $97862cf403be8595$var$load("7mRqV").then(()=>parcelRequire('httqX'));

});

parcelRegister("566HE", function(module, exports) {

let $3b62b659daa3372f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3b62b659daa3372f$var$load("5ix7K").then(()=>parcelRequire('6j35k'));

});

parcelRegister("7hJxV", function(module, exports) {

let $54dd737884576733$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $54dd737884576733$var$load("lU5wW").then(()=>parcelRequire('dvlvz'));

});

parcelRegister("8Yv6U", function(module, exports) {

let $688c0f31371a9310$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $688c0f31371a9310$var$load("16eo8").then(()=>parcelRequire('bwrHA'));

});

parcelRegister("6KeUd", function(module, exports) {

let $4e9299ec0eb2e4d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e9299ec0eb2e4d7$var$load("5njHu").then(()=>parcelRequire('2ulWo'));

});

parcelRegister("Xhn9f", function(module, exports) {

let $0b22fc974e85e594$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0b22fc974e85e594$var$load("kAWge").then(()=>parcelRequire('jCOw3'));

});

parcelRegister("lKGOU", function(module, exports) {

let $fd5f1c073ca9943e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fd5f1c073ca9943e$var$load("fijpJ").then(()=>parcelRequire('2fJ4d'));

});

parcelRegister("51a3b", function(module, exports) {

let $3a74d788b3412ed6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3a74d788b3412ed6$var$load("d7K0J").then(()=>parcelRequire('84muJ'));

});

parcelRegister("drfHK", function(module, exports) {

let $9c89fa9851663521$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c89fa9851663521$var$load("2gJYs").then(()=>parcelRequire('9rn6b'));

});

parcelRegister("i8A0w", function(module, exports) {

let $d344e7aa42fbc21b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d344e7aa42fbc21b$var$load("cQNNu").then(()=>parcelRequire('6DxsI'));

});

parcelRegister("bYxqJ", function(module, exports) {

let $8b7f3ad77d984ad0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b7f3ad77d984ad0$var$load("dAZOq").then(()=>parcelRequire('iS2kL'));

});

parcelRegister("fMBja", function(module, exports) {

let $b7d84754a9bc59e2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b7d84754a9bc59e2$var$load("dUypO").then(()=>parcelRequire('dhB8X'));

});

parcelRegister("lFCIm", function(module, exports) {

let $fc6b752d4410b7ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fc6b752d4410b7ae$var$load("aFsqY").then(()=>parcelRequire('cGRC5'));

});

parcelRegister("3OZQe", function(module, exports) {

let $2c86030be33d1bb4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2c86030be33d1bb4$var$load("bwfbG").then(()=>parcelRequire('72Yep'));

});

parcelRegister("iytmX", function(module, exports) {

let $037c6c1d3ad04744$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $037c6c1d3ad04744$var$load("a5an6").then(()=>parcelRequire('g9LLU'));

});

parcelRegister("1sS5a", function(module, exports) {

let $11125b997b08e39e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11125b997b08e39e$var$load("chC7H").then(()=>parcelRequire('3v3Ps'));

});

parcelRegister("039lM", function(module, exports) {

let $009788aec3eac91a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $009788aec3eac91a$var$load("gZI2F").then(()=>parcelRequire('61k6M'));

});

parcelRegister("dmWtJ", function(module, exports) {
/* icon-stack.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $f863157e85a6bcec$var$styles = {
    list: "_3iDTPbQ4SZ _2YgrGrP0S5 _0rIjykPgdg _43nrzTPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg",
    item: "_0rIjykPgdg _43nrzTPgdg _0GTcwRPgdg"
}; // Icon rotations for the shuffled/notebook look — keyed by index.
// Matches the ICON_ROTATIONS map used in the Rovo chat button (SourceButtonIcons):
// index 1 → -6deg, index 3 → 8deg, all others → no rotation.
const $f863157e85a6bcec$var$ICON_ROTATIONS = {
    1: -6,
    3: 8
};
const $f863157e85a6bcec$var$unboundStyles = {
    list: "_0aNu0LYbGa _2xTnZxHZdu",
    listEditorOverrides: "_2Zuz6QAASz",
    item: "_0bjKvDKxmn _0KLXrulfZc _2OUyjtcDWF _3iDTPbccYA _2xTnZxA17z"
};
const $f863157e85a6bcec$var$DEFAULT_MAX_STACK_SIZE = 3;
function $f863157e85a6bcec$export$1483abeb36a40e41({ children: children, maxStackSize: maxStackSize, testId: testId, addEditorStyleOverrides: addEditorStyleOverrides, shuffled: shuffled = false }) {
    maxStackSize = maxStackSize ?? $f863157e85a6bcec$var$DEFAULT_MAX_STACK_SIZE;
    return /*#__PURE__*/ $cozmU.createElement("ul", {
        "aria-hidden": true,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $f863157e85a6bcec$var$styles.list,
            $f863157e85a6bcec$var$unboundStyles.list,
            addEditorStyleOverrides && $f863157e85a6bcec$var$unboundStyles.listEditorOverrides
        ])
    }, (0, $cozmU.Children).map(children, (child, index)=>child && /*#__PURE__*/ $cozmU.createElement("li", {
            style: {
                zIndex: shuffled ? index + 1 : maxStackSize - index,
                transform: shuffled && $f863157e85a6bcec$var$ICON_ROTATIONS[index] !== undefined ? `rotate(${$f863157e85a6bcec$var$ICON_ROTATIONS[index]}deg)` : undefined
            },
            className: (0, $hekY6.default)([
                $f863157e85a6bcec$var$styles.item,
                $f863157e85a6bcec$var$unboundStyles.item
            ])
        }, child)));
}
module.exports["IconStack"] = $f863157e85a6bcec$export$1483abeb36a40e41;

});

parcelRegister("j8bJ5", function(module, exports) {
/* open-chat-input-box.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $f6cdQ = parcelRequire("f6cdQ");


var $cJ0FD = parcelRequire("cJ0FD");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $hdBxM = parcelRequire("hdBxM");


var $e3Wrf = parcelRequire("e3Wrf");


var $3hVWe = parcelRequire("3hVWe");


var $dDQsD = parcelRequire("dDQsD");


var $4Tg3t = parcelRequire("4Tg3t");

const $570f2b736386676c$export$ff46c9751614b747 = ({ chatInputQuery: chatInputQuery, ...props })=>{
    const { query: query, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerSendChatInput',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            chatInputQuery: chatInputQuery
        }
    };
};



var $bZMnB = parcelRequire("bZMnB");


var $eySxZ = parcelRequire("eySxZ");


var $8tNXq = parcelRequire("8tNXq");


var $7DMz5 = parcelRequire("7DMz5");


var $9LgVw = parcelRequire("9LgVw");


var $5OgwG = parcelRequire("5OgwG");

const $1778ab1934d48668$var$styles = {
    wrapper: "_23rrnHCu3Z _39xV02N91d _42Yu6BN779 _24h04i2Njc",
    wrapperShownStyles: "_3iDTPbvLZJ _1YKVNs7dHp",
    wrapperHiddenStyles: "_3iDTPbYbGa _1YKVNsdnbC",
    root: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _39xV02N91d _0Of8r28HPE _2Zuz6Q5zaO _1Znuxb5zaO _1wydGW8HPE _0KLXrunmFW _24h04i2Njc",
    inputIconButtonWrapperStyles: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _42Yu6BbFo4",
    enhancedRoot: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn _23rrnHCu3Z _3hxITi6wH8 _2V7sgONvrM _3vBAKH9r67 _39xV02N91d _42Yu6BN779 _0Of8r25zaO _2Zuz6Q5zaO _1Znuxb5zaO _1wydGW8HPE _0KLXrulfZc _24h04i2Njc _1mT5xdRAKS",
    sendButtonOverlay: "_1mT5xdWVPG _0Bm75G8HPE _4ApkO28HPE"
};
const $1778ab1934d48668$export$ca627f6f5c214661 = ({ query: queryProp, searchSessionId: searchSessionIdProp, isVisible: isVisible, source: source = 'sain', commonAttributes: commonAttributesProp, onVisibilityChange: onVisibilityChange, title: title, onHideTransitionEnd: onHideTransitionEnd } = {})=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [fireAnalyticsEvent] = (0, $8tNXq.useAnalytics)();
    const { fireSAINUsageEvent: fireSAINUsageEvent } = (0, $eySxZ.useSAINUsageCriteriaMet)();
    const publish = (0, $hdBxM.usePublish)('ai-mate');
    const [showOpenChatInput, setShowOpenChatInput] = (0, $cozmU.useState)(true);
    const [inputValue, setInputValue] = (0, $cozmU.useState)('');
    const { commonAttributes: contextCommonAttributes, showChatFollowUps: showChatFollowUps } = (0, $3hVWe.useAIAnswerContext)();
    const commonAttributes = commonAttributesProp ?? contextCommonAttributes;
    const query = queryProp ?? commonAttributes.query;
    const searchSessionId = searchSessionIdProp ?? commonAttributes.searchSessionId;
    const { answerString: answerString } = commonAttributes; // Only apply the improved SAIN layout when source is 'sain' — the FPS entry
    // point (fps-open-chat-input-box) reuses this component and must keep its
    // own appearance regardless of the gate state.
    const isImprovedChatOptionsEnabled = source === 'sain' && (0, $7DMz5.SAINFeatureControl).isImprovedChatOptionsEnabled();
    const shouldRender = isVisible ?? showChatFollowUps;
    const isSendDisabled = !inputValue.trim();
    const fireSendAnalytics = (0, $cozmU.useCallback)(()=>{
        fireAnalyticsEvent((0, $570f2b736386676c$export$ff46c9751614b747)({
            chatInputQuery: inputValue,
            ...commonAttributes
        }));
        fireAnalyticsEvent((0, $dDQsD.onOpenChatButtonClick)({
            ...commonAttributes
        }));
        fireSAINUsageEvent({
            metCriteria: (0, $bZMnB.SainAction).OPEN_CHAT_CLICKED,
            commonAttributes: commonAttributes
        });
    }, [
        fireAnalyticsEvent,
        fireSAINUsageEvent,
        inputValue,
        commonAttributes
    ]);
    const handleKeyDown = (event)=>{
        if (inputValue.trim() && event.key === 'Enter') {
            event.preventDefault();
            fireSendAnalytics();
            sendToChat();
        }
    };
    const sendToChat = (0, $cozmU.useCallback)(()=>{
        // Carry the prior turn (and seed the chat name) only when there is a
        // SAIN answer to forward. This keeps the box future-proof: when no
        // answer is present (e.g. FPS results today) the user lands in a clean
        // new chat with only what they typed, and once an answer is available
        // the host simply passes `query` + `answerString` to carry the context
        // — no change needed here.
        const hasAnswerToCarry = Boolean(query && answerString);
        publish({
            type: 'chat-new',
            source: source,
            data: {
                ...hasAnswerToCarry ? {
                    name: query.substring(0, 30)
                } : {},
                dialogues: hasAnswerToCarry ? [
                    {
                        human_message: {
                            content: query
                        },
                        agent_message: {
                            content: answerString
                        }
                    }
                ] : [],
                prompt: inputValue,
                sourceId: searchSessionId
            }
        });
        setShowOpenChatInput(false); // Notify the host at the point the box hides itself (after a prompt is
        // submitted), so sibling chrome (e.g. a title rendered above the box by
        // the host) can hide together with it. We deliberately don't emit an
        // initial `true` on mount — hosts own the box's starting visibility.
        onVisibilityChange?.(false);
    }, [
        inputValue,
        query,
        searchSessionId,
        publish,
        answerString,
        source,
        onVisibilityChange
    ]);
    const handleButtonClick = (0, $cozmU.useCallback)(()=>{
        fireSendAnalytics();
        sendToChat();
    }, [
        fireSendAnalytics,
        sendToChat
    ]);
    const handleTransitionEnd = (0, $cozmU.useCallback)((event)=>{
        // Fire only when the box's own fade-out (opacity) finishes after it has hidden itself
        if (!showOpenChatInput && event.propertyName === 'opacity' && event.target === event.currentTarget) onHideTransitionEnd?.();
    }, [
        showOpenChatInput,
        onHideTransitionEnd
    ]);
    if (!shouldRender) return null;
    if (isImprovedChatOptionsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($1778ab1934d48668$var$styles.enhancedRoot, showOpenChatInput ? $1778ab1934d48668$var$styles.wrapperShownStyles : $1778ab1934d48668$var$styles.wrapperHiddenStyles),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/ensure-design-token-usage
        style: {
            boxShadow: '0 -2px 50px 8px rgba(30, 31, 33, 0.08)'
        },
        onTransitionEnd: handleTransitionEnd
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        "aria-label": formatMessage((0, $5OgwG.messages).ai_answer_open_chat_input_box_ask_rovo),
        placeholder: formatMessage((0, $5OgwG.messages).ai_answer_open_chat_input_box_ask_rovo),
        value: inputValue,
        onChange: (e)=>setInputValue(e.target.value),
        onKeyDown: handleKeyDown,
        appearance: "none",
        minimumRows: 2,
        testId: "lumina-input-to-chat-text-area"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1778ab1934d48668$var$styles.sendButtonOverlay
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "primary",
        isDisabled: isSendDisabled,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))),
        label: formatMessage((0, $5OgwG.messages).ai_answer_open_chat_input_box_send_query),
        onClick: handleButtonClick,
        testId: "lumina-input-to-chat-submit"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($1778ab1934d48668$var$styles.wrapper, showOpenChatInput ? $1778ab1934d48668$var$styles.wrapperShownStyles : $1778ab1934d48668$var$styles.wrapperHiddenStyles),
        onTransitionEnd: handleTransitionEnd
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, title ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "large",
        weight: "medium"
    }, title) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1778ab1934d48668$var$styles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1778ab1934d48668$var$styles.inputIconButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9LgVw))),
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        placeholder: formatMessage((0, $5OgwG.messages).ai_answer_open_chat_input_box_ask_rovo),
        value: inputValue,
        onChange: (e)=>setInputValue(e.target.value),
        onKeyDown: handleKeyDown,
        appearance: "none",
        minimumRows: 1,
        style: {
            paddingTop: '9px'
        },
        testId: "lumina-input-to-chat-text-area"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1778ab1934d48668$var$styles.inputIconButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "primary",
        isDisabled: isSendDisabled,
        shape: "circle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f6cdQ))),
        label: formatMessage((0, $5OgwG.messages).ai_answer_open_chat_input_box_send_query),
        onClick: handleButtonClick,
        testId: "lumina-input-to-chat-submit"
    }))))));
};
module.exports["OpenChatInputBox"] = $1778ab1934d48668$export$ca627f6f5c214661;

});

parcelRegister("ibV84", function(module, exports) {

let $d3e591c347ef2888$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d3e591c347ef2888$var$load("gcLWi"),
    $d3e591c347ef2888$var$load("fsgrC"),
    $d3e591c347ef2888$var$load("gRf94"),
    $d3e591c347ef2888$var$load("hTxlQ"),
    $d3e591c347ef2888$var$load("6bjEk"),
    $d3e591c347ef2888$var$load("Wowvf"),
    $d3e591c347ef2888$var$load("aMsb0"),
    $d3e591c347ef2888$var$load("2PXrC"),
    $d3e591c347ef2888$var$load("h1yOv"),
    $d3e591c347ef2888$var$load("eqj21"),
    $d3e591c347ef2888$var$load("3oAU3"),
    $d3e591c347ef2888$var$load("iZR3N"),
    $d3e591c347ef2888$var$load("4zz48"),
    $d3e591c347ef2888$var$load("jXM1T"),
    $d3e591c347ef2888$var$load("cvcNg"),
    $d3e591c347ef2888$var$load("jw3lv"),
    $d3e591c347ef2888$var$load("7rqWx"),
    $d3e591c347ef2888$var$load("aIze1"),
    $d3e591c347ef2888$var$load("il8bj"),
    $d3e591c347ef2888$var$load("4N1MY"),
    $d3e591c347ef2888$var$load("kG5Ju"),
    $d3e591c347ef2888$var$load("39XCn"),
    $d3e591c347ef2888$var$load("3Cky6"),
    $d3e591c347ef2888$var$load("aFLSJ"),
    $d3e591c347ef2888$var$load("6fJCf"),
    $d3e591c347ef2888$var$load("duEFL"),
    $d3e591c347ef2888$var$load("6wr18"),
    $d3e591c347ef2888$var$load("1pJPT"),
    $d3e591c347ef2888$var$load("7EorR"),
    $d3e591c347ef2888$var$load("ffEVr"),
    $d3e591c347ef2888$var$load("hhss7"),
    $d3e591c347ef2888$var$load("hVFIb")
]).then(()=>parcelRequire('eWlk7'));

});

parcelRegister("7ydRw", function(module, exports) {

let $57f67623fbf2f524$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $57f67623fbf2f524$var$load("kbtA5").then(()=>parcelRequire('lndDI'));

});

parcelRegister("2vPXD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gABt9 = parcelRequire("gABt9");

async function $cafae28ddf3d73b8$var$fetchRestResponse({ url: url, body: body }) {
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        }
    };
    return (0, $gABt9.utils).requestService({
        url: url
    }, options);
}
const $cafae28ddf3d73b8$var$OBJECT_RESOLVER_ENDPOINT = '/gateway/api/object-resolver/resolve/batch';
const $cafae28ddf3d73b8$export$ce7efc011dbfc5b9 = ({ urls: urls })=>{
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const [objectResolverData, setObjectResolverData] = (0, $cozmU.useState)([]);
    const urlKeys = (0, $cozmU.useMemo)(()=>urls.join('|'), [
        urls
    ]);
    (0, $cozmU.useEffect)(()=>{
        const fetchObjectResolver = async ()=>{
            if (!urls.length) {
                setIsLoading(false);
                return;
            }
            try {
                setIsLoading(true);
                const objectResolver = await $cafae28ddf3d73b8$var$fetchRestResponse({
                    url: $cafae28ddf3d73b8$var$OBJECT_RESOLVER_ENDPOINT,
                    body: urls.map((url)=>({
                            resourceUrl: url
                        }))
                });
                if (!objectResolver) {
                    setIsLoading(false);
                    return;
                }
                const objectData = objectResolver.filter((obj)=>obj.status === 200);
                setObjectResolverData(objectData.map((objData)=>objData.body.data));
                setIsLoading(false);
            } catch (err) {
                setIsLoading(false);
            }
        };
        fetchObjectResolver();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        urlKeys
    ]);
    return {
        isLoading: isLoading,
        objectResolverData: objectResolverData
    };
};
module.exports["useFetchSmartLinkData"] = $cafae28ddf3d73b8$export$ce7efc011dbfc5b9;

});

parcelRegister("kYeKA", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iHsYL = parcelRequire("iHsYL");

var $e52c82032f5b8894$exports = {};
$e52c82032f5b8894$exports = JSON.parse("{\"v\":\"5.9.0\",\"fr\":29.9700012207031,\"ip\":0,\"op\":95.0000038694293,\"w\":1920,\"h\":1080,\"nm\":\"Comp 1\",\"ddd\":0,\"assets\":[],\"layers\":[{\"ddd\":0,\"ind\":2,\"ty\":4,\"nm\":\"Shape Layer 3\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[502.345,0,0],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ix\":1,\"en\":1,\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"mn\":\"ADBE Gaussian Blur 2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":50.4,\"ix\":1}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"mn\":\"ADBE Gaussian Blur 2-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":1,\"ix\":2}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"mn\":\"ADBE Gaussian Blur 2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}}]},{\"ty\":5,\"nm\":\"Levels\",\"np\":11,\"mn\":\"ADBE Easy Levels2\",\"ix\":2,\"en\":1,\"ef\":[{\"ty\":7,\"nm\":\"Channel:\",\"mn\":\"ADBE Easy Levels2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":1,\"ix\":1}},{},{\"ty\":0,\"nm\":\"Input Black\",\"mn\":\"ADBE Easy Levels2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}},{\"ty\":0,\"nm\":\"Input White\",\"mn\":\"ADBE Easy Levels2-0004\",\"ix\":4,\"v\":{\"a\":0,\"k\":1,\"ix\":4}},{\"ty\":0,\"nm\":\"Gamma\",\"mn\":\"ADBE Easy Levels2-0005\",\"ix\":5,\"v\":{\"a\":0,\"k\":1,\"ix\":5}},{\"ty\":0,\"nm\":\"Output Black\",\"mn\":\"ADBE Easy Levels2-0006\",\"ix\":6,\"v\":{\"a\":0,\"k\":0,\"ix\":6}},{\"ty\":0,\"nm\":\"Output White\",\"mn\":\"ADBE Easy Levels2-0007\",\"ix\":7,\"v\":{\"a\":0,\"k\":1,\"ix\":7}},{\"ty\":7,\"nm\":\"Clip To Output Black\",\"mn\":\"ADBE Easy Levels2-0008\",\"ix\":8,\"v\":{\"a\":0,\"k\":3,\"ix\":8}},{\"ty\":7,\"nm\":\"Clip To Output White\",\"mn\":\"ADBE Easy Levels2-0009\",\"ix\":9,\"v\":{\"a\":0,\"k\":3,\"ix\":9}}]},{\"ty\":5,\"nm\":\"CC Radial Fast Blur\",\"np\":5,\"mn\":\"CC Radial Fast Blur\",\"ix\":3,\"en\":1,\"ef\":[{\"ty\":3,\"nm\":\"Center\",\"mn\":\"CC Radial Fast Blur-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":[960,540],\"ix\":1}},{\"ty\":0,\"nm\":\"Amount\",\"mn\":\"CC Radial Fast Blur-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":51,\"ix\":2}},{\"ty\":7,\"nm\":\"Zoom\",\"mn\":\"CC Radial Fast Blur-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":1,\"ix\":3}}]}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":2,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[317.555,317.555],\"ix\":2},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":50.479,\"s\":[1486.1,615.223],\"to\":[0,0],\"ti\":[0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":63,\"s\":[1486.1,400],\"to\":[0,0],\"ti\":[0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":72.74,\"s\":[1486.1,575.917],\"to\":[0,0],\"ti\":[0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":79,\"s\":[1486.1,528.917],\"to\":[0,0],\"ti\":[0,0]},{\"t\":82.0000033399285,\"s\":[1486.1,615.223]}],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"gf\",\"o\":{\"a\":0,\"k\":100,\"ix\":10},\"r\":1,\"bm\":0,\"g\":{\"p\":3,\"k\":{\"a\":0,\"k\":[0,0.594,0.384,0.713,0.461,0.777,0.645,0.66,1,0.961,0.906,0.607],\"ix\":9}},\"s\":{\"a\":0,\"k\":[1244.484,582.344],\"ix\":5},\"e\":{\"a\":0,\"k\":[1727.031,624.016],\"ix\":6},\"t\":1,\"nm\":\"Gradient Fill 1\",\"mn\":\"ADBE Vector Graphic - G-Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-497.223,10],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":3,\"ty\":4,\"nm\":\"Shape Layer 2\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":0.667},\"o\":{\"x\":0.333,\"y\":0.333},\"t\":20.479,\"s\":[1486.1,615.223,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0.076},\"t\":21,\"s\":[1486.1,615.223,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":33,\"s\":[1486.1,400,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":42.74,\"s\":[1486.1,575.917,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":49,\"s\":[1486.1,528.917,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":52.0000021180034,\"s\":[1486.1,615.223,0]}],\"ix\":2,\"l\":2},\"a\":{\"a\":0,\"k\":[0,0,0],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ix\":1,\"en\":1,\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"mn\":\"ADBE Gaussian Blur 2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":50.7,\"ix\":1}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"mn\":\"ADBE Gaussian Blur 2-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":1,\"ix\":2}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"mn\":\"ADBE Gaussian Blur 2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}}]},{\"ty\":5,\"nm\":\"Levels\",\"np\":11,\"mn\":\"ADBE Easy Levels2\",\"ix\":2,\"en\":1,\"ef\":[{\"ty\":7,\"nm\":\"Channel:\",\"mn\":\"ADBE Easy Levels2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":1,\"ix\":1}},{},{\"ty\":0,\"nm\":\"Alpha Input Black\",\"mn\":\"ADBE Easy Levels2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}},{\"ty\":0,\"nm\":\"Alpha Input White\",\"mn\":\"ADBE Easy Levels2-0004\",\"ix\":4,\"v\":{\"a\":0,\"k\":1,\"ix\":4}},{\"ty\":0,\"nm\":\"Alpha Gamma\",\"mn\":\"ADBE Easy Levels2-0005\",\"ix\":5,\"v\":{\"a\":0,\"k\":1,\"ix\":5}},{\"ty\":0,\"nm\":\"Alpha Output Black\",\"mn\":\"ADBE Easy Levels2-0006\",\"ix\":6,\"v\":{\"a\":0,\"k\":0,\"ix\":6}},{\"ty\":0,\"nm\":\"Alpha Output White\",\"mn\":\"ADBE Easy Levels2-0007\",\"ix\":7,\"v\":{\"a\":0,\"k\":1,\"ix\":7}},{\"ty\":7,\"nm\":\"Clip To Output Black\",\"mn\":\"ADBE Easy Levels2-0008\",\"ix\":8,\"v\":{\"a\":0,\"k\":3,\"ix\":8}},{\"ty\":7,\"nm\":\"Clip To Output White\",\"mn\":\"ADBE Easy Levels2-0009\",\"ix\":9,\"v\":{\"a\":0,\"k\":3,\"ix\":9}}]},{\"ty\":5,\"nm\":\"CC Radial Fast Blur\",\"np\":5,\"mn\":\"CC Radial Fast Blur\",\"ix\":3,\"en\":1,\"ef\":[{\"ty\":3,\"nm\":\"Center\",\"mn\":\"CC Radial Fast Blur-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":[960,540],\"ix\":1}},{\"ty\":0,\"nm\":\"Amount\",\"mn\":\"CC Radial Fast Blur-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":51,\"ix\":2}},{\"ty\":7,\"nm\":\"Zoom\",\"mn\":\"CC Radial Fast Blur-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":1,\"ix\":3}}]}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[317.555,317.555],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"fl\",\"c\":{\"a\":0,\"k\":[0.749019607843,0.388235294118,0.952941176471,1],\"ix\":4},\"o\":{\"a\":0,\"k\":100,\"ix\":5},\"r\":1,\"bm\":0,\"nm\":\"Fill 1\",\"mn\":\"ADBE Vector Graphic - Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-497.223,10],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0},{\"ddd\":0,\"ind\":4,\"ty\":4,\"nm\":\"Shape Layer 1\",\"sr\":1,\"ks\":{\"o\":{\"a\":0,\"k\":100,\"ix\":11},\"r\":{\"a\":0,\"k\":0,\"ix\":10},\"p\":{\"a\":0,\"k\":[2454.1,1191.14,0],\"ix\":2,\"l\":2},\"a\":{\"a\":1,\"k\":[{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":1,\"s\":[1486.1,615.223,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":8,\"s\":[1486.1,784.917,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.667,\"y\":1},\"o\":{\"x\":0.333,\"y\":0},\"t\":15,\"s\":[1486.1,575.917,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"i\":{\"x\":0.833,\"y\":0.833},\"o\":{\"x\":0.333,\"y\":0},\"t\":21.441,\"s\":[1486.1,615.223,0],\"to\":[0,0,0],\"ti\":[0,0,0]},{\"t\":24.00000097754,\"s\":[1486.1,575.917,0]}],\"ix\":1,\"l\":2},\"s\":{\"a\":0,\"k\":[100,100,100],\"ix\":6,\"l\":2}},\"ao\":0,\"ef\":[{\"ty\":29,\"nm\":\"Gaussian Blur\",\"np\":5,\"mn\":\"ADBE Gaussian Blur 2\",\"ix\":1,\"en\":1,\"ef\":[{\"ty\":0,\"nm\":\"Blurriness\",\"mn\":\"ADBE Gaussian Blur 2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":46.3,\"ix\":1}},{\"ty\":7,\"nm\":\"Blur Dimensions\",\"mn\":\"ADBE Gaussian Blur 2-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":1,\"ix\":2}},{\"ty\":7,\"nm\":\"Repeat Edge Pixels\",\"mn\":\"ADBE Gaussian Blur 2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}}]},{\"ty\":5,\"nm\":\"Levels\",\"np\":11,\"mn\":\"ADBE Easy Levels2\",\"ix\":2,\"en\":1,\"ef\":[{\"ty\":7,\"nm\":\"Channel:\",\"mn\":\"ADBE Easy Levels2-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":1,\"ix\":1}},{},{\"ty\":0,\"nm\":\"Alpha Input Black\",\"mn\":\"ADBE Easy Levels2-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":0,\"ix\":3}},{\"ty\":0,\"nm\":\"Alpha Input White\",\"mn\":\"ADBE Easy Levels2-0004\",\"ix\":4,\"v\":{\"a\":0,\"k\":1,\"ix\":4}},{\"ty\":0,\"nm\":\"Alpha Gamma\",\"mn\":\"ADBE Easy Levels2-0005\",\"ix\":5,\"v\":{\"a\":0,\"k\":1,\"ix\":5}},{\"ty\":0,\"nm\":\"Alpha Output Black\",\"mn\":\"ADBE Easy Levels2-0006\",\"ix\":6,\"v\":{\"a\":0,\"k\":0,\"ix\":6}},{\"ty\":0,\"nm\":\"Alpha Output White\",\"mn\":\"ADBE Easy Levels2-0007\",\"ix\":7,\"v\":{\"a\":0,\"k\":1,\"ix\":7}},{\"ty\":7,\"nm\":\"Clip To Output Black\",\"mn\":\"ADBE Easy Levels2-0008\",\"ix\":8,\"v\":{\"a\":0,\"k\":3,\"ix\":8}},{\"ty\":7,\"nm\":\"Clip To Output White\",\"mn\":\"ADBE Easy Levels2-0009\",\"ix\":9,\"v\":{\"a\":0,\"k\":3,\"ix\":9}}]},{\"ty\":5,\"nm\":\"CC Radial Fast Blur\",\"np\":5,\"mn\":\"CC Radial Fast Blur\",\"ix\":3,\"en\":1,\"ef\":[{\"ty\":3,\"nm\":\"Center\",\"mn\":\"CC Radial Fast Blur-0001\",\"ix\":1,\"v\":{\"a\":0,\"k\":[960,540],\"ix\":1}},{\"ty\":0,\"nm\":\"Amount\",\"mn\":\"CC Radial Fast Blur-0002\",\"ix\":2,\"v\":{\"a\":0,\"k\":50,\"ix\":2}},{\"ty\":7,\"nm\":\"Zoom\",\"mn\":\"CC Radial Fast Blur-0003\",\"ix\":3,\"v\":{\"a\":0,\"k\":1,\"ix\":3}}]}],\"shapes\":[{\"ty\":\"gr\",\"it\":[{\"d\":1,\"ty\":\"el\",\"s\":{\"a\":0,\"k\":[317.555,317.555],\"ix\":2},\"p\":{\"a\":0,\"k\":[0,0],\"ix\":3},\"nm\":\"Ellipse Path 1\",\"mn\":\"ADBE Vector Shape - Ellipse\",\"hd\":false},{\"ty\":\"gf\",\"o\":{\"a\":0,\"k\":100,\"ix\":10},\"r\":1,\"bm\":0,\"g\":{\"p\":3,\"k\":{\"a\":0,\"k\":[0,0,0.396,1,0.724,0.182,0.396,1,1,0.364,0.396,1],\"ix\":9}},\"s\":{\"a\":0,\"k\":[0,0],\"ix\":5},\"e\":{\"a\":0,\"k\":[100,0],\"ix\":6},\"t\":1,\"nm\":\"Gradient Fill 1\",\"mn\":\"ADBE Vector Graphic - G-Fill\",\"hd\":false},{\"ty\":\"tr\",\"p\":{\"a\":0,\"k\":[-497.223,10],\"ix\":2},\"a\":{\"a\":0,\"k\":[0,0],\"ix\":1},\"s\":{\"a\":0,\"k\":[100,100],\"ix\":3},\"r\":{\"a\":0,\"k\":0,\"ix\":6},\"o\":{\"a\":0,\"k\":100,\"ix\":7},\"sk\":{\"a\":0,\"k\":0,\"ix\":4},\"sa\":{\"a\":0,\"k\":0,\"ix\":5},\"nm\":\"Transform\"}],\"nm\":\"Ellipse 1\",\"np\":2,\"cix\":2,\"bm\":0,\"ix\":1,\"mn\":\"ADBE Vector Group\",\"hd\":false}],\"ip\":0,\"op\":900.000036657751,\"st\":0,\"bm\":0}],\"markers\":[]}");


const $8ca28c87450183a6$var$loadingAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: (0, (/*@__PURE__*/$parcel$interopDefault($e52c82032f5b8894$exports))),
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};
const $8ca28c87450183a6$var$loadingAnimationStyles = null;
const $8ca28c87450183a6$var$jiraOverrideStyles = null;
const $8ca28c87450183a6$export$1110722318fbbc6b = ({ onAnimationShown: onAnimationShown, source: source })=>{
    (0, $cozmU.useEffect)(()=>{
        onAnimationShown?.(); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($iHsYL)) // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored because an external consumer needs to override the style with styled component. https://atlassian.slack.com/archives/C06K9T53N66/p1745962052140289?thread_ts=1745868665.350719&cid=C06K9T53N66
    ), {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhToncF0J _3OE6xYODnY _39xV02HMkp _0jFU0Vey7F _1VJPcasUvU",
            source === 'jira-highlight-actions' && "_2IhTonF3IB _3OE6xY8ija",
            "dot-animation-loader"
        ]),
        ...$8ca28c87450183a6$var$loadingAnimationOptions
    });
};
module.exports["DotAnimationLoader"] = $8ca28c87450183a6$export$1110722318fbbc6b;

});

parcelRegister("h0U7J", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

/**
 * Derives non-UGC authority attributes from the authoritative-answer metadata so
 * they can be attached to the existing aiAnswerResult shown event. Only counts,
 * booleans, and the coarse authority level/confidence are emitted — never source
 * titles, expert names, URLs, or reasoning text.
 */ const $f09050a325aeee13$var$getAuthorityAttributes = (authorityUiMetadata)=>{
    if (!authorityUiMetadata) return {
        hasAuthoritativeSources: false
    };
    return {
        hasAuthoritativeSources: true,
        authorityLevel: authorityUiMetadata.authorityLevel,
        isHighlyAuthoritative: authorityUiMetadata.isHighlyAuthoritative ?? authorityUiMetadata.highlyAuthoritative ?? false,
        overallConfidence: authorityUiMetadata.overallConfidence,
        authoritativeSourceCount: authorityUiMetadata.sources?.length ?? 0,
        authoritativeExpertCount: authorityUiMetadata.domainExperts?.length ?? 0
    };
};
const $f09050a325aeee13$export$bc6497c5d340e00a = ({ isStreamed: isStreamed, loadTime: loadTime, fmpLoadTime: fmpLoadTime, experimentLayers: experimentLayers, blueLinkCount: blueLinkCount, authorityUiMetadata: authorityUiMetadata, ...props })=>{
    const { query: query, answerString: answerString, source: source, cloudId: cloudId } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerResult',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            cloudId: cloudId,
            isStreamed: isStreamed,
            loadTime: loadTime,
            fmpLoadTime: fmpLoadTime,
            blueLinkCount: blueLinkCount,
            ...experimentLayers && {
                backendExperiments: {
                    experimentLayers: experimentLayers
                }
            },
            ...$f09050a325aeee13$var$getAuthorityAttributes(authorityUiMetadata)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
module.exports["onAIAnswerResultShown"] = $f09050a325aeee13$export$bc6497c5d340e00a;

});

parcelRegister("hZTED", function(module, exports) {

var $htnqN = parcelRequire("htnqN");

const $4195fdef80fa1f78$export$fd2b85accaf97974 = {
    errorState: (0, $htnqN.NLPSearchErrorState).Default,
    format: null,
    disclaimer: null,
    nlpResults: [],
    uniqueSources: []
};
module.exports["DEFAULT_EMPTY_NLP_SEARCH_STATE"] = $4195fdef80fa1f78$export$fd2b85accaf97974;

});

parcelRegister("lEgaq", function(module, exports) {
const $126e4170420ccea3$export$f5f7924ac6f8609b = 'data-sain-citation';
const $126e4170420ccea3$export$110c96b5e53088b6 = '[data-sain-citation]';
module.exports["SAIN_CITATION_ATTRIBUTE"] = $126e4170420ccea3$export$f5f7924ac6f8609b;
module.exports["SAIN_CITATION_SELECTOR"] = $126e4170420ccea3$export$110c96b5e53088b6;

});

parcelRegister("6O5Et", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

const $b4e21899d850c11f$export$476afff83df695b3 = (props, copySource = 'answer')=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerCopy',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            copySource: copySource
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
module.exports["onAIAnswerCopyButtonClicked"] = $b4e21899d850c11f$export$476afff83df695b3;

});

parcelRegister("j9bgP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $6spAz = parcelRequire("6spAz");


var $lT1k3 = parcelRequire("lT1k3");


var $4QjIS = parcelRequire("4QjIS");

const $3ac44a319e685d85$var$ColoredBugIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6spAz))), {
        color: "var(--ds-icon-subtlest, #6B6E76)",
        label: ""
    });
const $3ac44a319e685d85$export$6e6fdd8d215e1d59 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isSAINDebuggerModalOpen, setIsSAINDebuggerModalOpen] = (0, $cozmU.useState)(false);
    const openDebuggerModal = (0, $cozmU.useCallback)((e)=>{
        e.stopPropagation();
        onClick?.(e);
        setIsSAINDebuggerModalOpen(true);
    }, [
        onClick
    ]);
    const closeDebuggerModal = (0, $cozmU.useCallback)(()=>setIsSAINDebuggerModalOpen(false), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: $3ac44a319e685d85$var$ColoredBugIcon,
        label: formatMessage((0, $lT1k3.messages).ai_debugger_icon_label),
        onClick: openDebuggerModal,
        appearance: "subtle",
        isTooltipDisabled: false,
        spacing: "compact",
        testId: "sain-online-debugger-button",
        color: "var(--ds-icon-subtlest, #6B6E76)",
        shape: "circle"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4QjIS.OnlineDebuggerModal), {
        isOpen: isSAINDebuggerModalOpen,
        onClose: closeDebuggerModal
    }));
};
module.exports["OnlineDebuggerButton"] = $3ac44a319e685d85$export$6e6fdd8d215e1d59;

});

parcelRegister("4QjIS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7aRdF = parcelRequire("7aRdF");

var $fEPJS = parcelRequire("fEPJS");

var $eQiT1 = parcelRequire("eQiT1");

var $9Umtx = parcelRequire("9Umtx");

var $jq995 = parcelRequire("jq995");

var $aRGok = parcelRequire("aRGok");


var $iDrrr = parcelRequire("iDrrr");


var $hMjUh = parcelRequire("hMjUh");


var $3hVWe = parcelRequire("3hVWe");


var $zzZbq = parcelRequire("zzZbq");


var $lT1k3 = parcelRequire("lT1k3");


var $6R26v = parcelRequire("6R26v");


var $ftCDW = parcelRequire("ftCDW");


var $lIZC4 = parcelRequire("lIZC4");


var $7Mjvn = parcelRequire("7Mjvn");


var $8ynLJ = parcelRequire("8ynLJ");


var $61d8U = parcelRequire("61d8U");


var $9UsEc = parcelRequire("9UsEc");


var $kV3xA = parcelRequire("kV3xA");


var $aAdO3 = parcelRequire("aAdO3");

function $28d8eb347c66ef20$export$c8392feccb7e3f1f({ isOpen: isOpen, onClose: onClose }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { commonAttributes: commonAttributes, smartAnswersRoute: smartAnswersRoute } = (0, $3hVWe.useAIAnswerContext)();
    const isNaturalLanguageQuery = smartAnswersRoute === (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY;
    const { extraAttributes: extraAttributes, sources: sources } = commonAttributes;
    const debuggerData = (0, $cozmU.useMemo)(()=>(0, $6R26v.normalizeDebuggerData)(extraAttributes, (0, $iDrrr.fg)('kd_consolidate_sources_analytics') ? sources : undefined), [
        extraAttributes,
        sources
    ]);
    const showPluginsPanels = isNaturalLanguageQuery && !debuggerData.minions.hasMinionOutputs && debuggerData.pluginInvocations.hasPluginInvocations;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        onClose: onClose,
        width: "x-large",
        testId: "sain-online-debugger-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMjUh.default), {
        id: "sain-online-debugger-tabs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ftCDW.DebuggerTabList), {
        isNaturalLanguageQuery: isNaturalLanguageQuery,
        hasMinionOutputs: debuggerData.minions.hasMinionOutputs,
        hasPluginInvocations: debuggerData.pluginInvocations.hasPluginInvocations,
        roundCount: debuggerData.minions.roundCount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aAdO3.RequestOverviewPanel), {
        ...debuggerData.requestOverview,
        smartAnswersRoute: smartAnswersRoute,
        isNaturalLanguageQuery: isNaturalLanguageQuery
    }), showPluginsPanels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kV3xA.RawSearchResultsPanel), {
        searchResults: debuggerData.rawSearch.searchResults
    }), showPluginsPanels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $61d8U.RankedSearchResultsPanel), {
        rankedDocumentsWithChunks: debuggerData.rankedSearch.rankedDocumentsWithChunks
    }), showPluginsPanels && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8ynLJ.PluginInvocationsPanel), {
        nonSearchPluginInvocations: debuggerData.pluginInvocations.nonSearchPluginInvocations
    }), isNaturalLanguageQuery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Mjvn.OrchestrationOverviewPanel), {
        orchestrationRounds: debuggerData.minions.orchestrationRounds
    }), isNaturalLanguageQuery && debuggerData.minions.hasMinionOutputs && debuggerData.minions.orchestrationRounds.map((round, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lIZC4.LoopPanel), {
            key: `loop-panel-${index}`,
            round: round,
            roundIndex: index
        })), isNaturalLanguageQuery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9UsEc.RawJsonPanel), {
        rawJson: debuggerData.rawJson.rawJson
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null)));
}
module.exports["OnlineDebuggerModal"] = $28d8eb347c66ef20$export$c8392feccb7e3f1f;

});

parcelRegister("lT1k3", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $834ca13a4b04c199$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ai_debugger_icon_label: {
        id: "search_ai.ai_debugger_icon_label",
        defaultMessage: "Debugger"
    },
    ai_debugger_modal_title: {
        id: "search_ai.ai_debugger_modal_title",
        defaultMessage: "SAIN Debugging Panel"
    },
    ai_debugger_modal_original_query_subheading: {
        id: "search_ai.ai_debugger_modal_original_query_subheading",
        defaultMessage: "Original Query"
    },
    ai_debugger_modal_transformed_query_subheading: {
        id: "search_ai.ai_debugger_modal_transformed_query_subheading",
        defaultMessage: "Transformed Query"
    },
    ai_debugger_modal_detected_intent_subheading: {
        id: "search_ai.ai_debugger_modal_detected_intent_subheading",
        defaultMessage: "Detected Intent"
    },
    ai_debugger_modal_trace_id_subheading: {
        id: "search_ai.ai_debugger_modal_trace_id_subheading",
        defaultMessage: "Trace ID"
    },
    ai_debugger_modal_model_subheading: {
        id: "search_ai.ai_debugger_modal_model_subheading",
        defaultMessage: "Answer Generation Model"
    },
    ai_debugger_modal_sources_subheading: {
        id: "search_ai.ai_debugger_modal_sources_subheading",
        defaultMessage: "Sources"
    },
    ai_debugger_modal_cached_answer_subheading: {
        id: "search_ai.ai_debugger_modal_cached_answer_subheading",
        defaultMessage: "Cached answer"
    },
    ai_debugger_modal_copy_button_text: {
        id: "search_ai.ai_debugger_modal_copy_button_text",
        defaultMessage: "Copy JSON"
    },
    ai_debugger_modal_copy_button_copied_text: {
        id: "search_ai.ai_debugger_modal_copy_button_copied_text",
        defaultMessage: "JSON Copied"
    },
    ai_debugger_modal_tab_request_overview: {
        id: "search_ai.ai_debugger_modal_tab_request_overview",
        defaultMessage: "Request Overview"
    },
    ai_debugger_modal_tab_raw_search_results: {
        id: "search_ai.ai_debugger_modal_tab_raw_search_results",
        defaultMessage: "Raw Search Results"
    },
    ai_debugger_modal_tab_ranked_search_results: {
        id: "search_ai.ai_debugger_modal_tab_ranked_search_results",
        defaultMessage: "Ranked Search Results"
    },
    ai_debugger_modal_tab_plugin_invocations: {
        id: "search_ai.ai_debugger_modal_tab_plugin_invocations",
        defaultMessage: "Plugin Invocations"
    },
    ai_debugger_modal_tab_raw_json: {
        id: "search_ai.ai_debugger_modal_tab_raw_json",
        defaultMessage: "Raw JSON"
    },
    ai_debugger_modal_copy_trace_id_label: {
        id: "search_ai.ai_debugger_modal_copy_trace_id_label",
        defaultMessage: "Copy Trace ID"
    },
    ai_debugger_modal_trace_id_copied_text: {
        id: "search_ai.ai_debugger_modal_trace_id_copied_text",
        defaultMessage: "Trace ID copied"
    },
    ai_debugger_modal_expand_label: {
        id: "search_ai.ai_debugger_modal_expand_label",
        defaultMessage: "Expand"
    },
    ai_debugger_modal_collapse_label: {
        id: "search_ai.ai_debugger_modal_collapse_label",
        defaultMessage: "Collapse"
    },
    ai_debugger_modal_success_label: {
        id: "search_ai.ai_debugger_modal_success_label",
        defaultMessage: "Success"
    },
    ai_debugger_modal_failed_label: {
        id: "search_ai.ai_debugger_modal_failed_label",
        defaultMessage: "Failed"
    },
    ai_debugger_modal_search_results_heading: {
        id: "search_ai.ai_debugger_modal_search_results_heading",
        defaultMessage: "Search Results ({count})"
    },
    ai_debugger_modal_ranked_documents_heading: {
        id: "search_ai.ai_debugger_modal_ranked_documents_heading",
        defaultMessage: "Ranked Documents ({count})"
    },
    ai_debugger_modal_tab_orchestration_overview: {
        id: "search_ai.ai_debugger_modal_tab_orchestration_overview",
        defaultMessage: "Orchestration Overview"
    },
    ai_debugger_modal_tab_loop: {
        id: "search_ai.ai_debugger_modal_tab_loop",
        defaultMessage: "Loop {number}"
    },
    ai_debugger_modal_orchestration_loop_heading: {
        id: "search_ai.ai_debugger_modal_orchestration_loop_heading",
        defaultMessage: "Loop {number}"
    },
    ai_debugger_modal_orchestration_loop_with_count: {
        id: "search_ai.ai_debugger_modal_orchestration_loop_with_count",
        defaultMessage: "Loop {number} - {count} {count, plural, one {minion} other {minions}}"
    },
    ai_debugger_modal_orchestration_minions_count: {
        id: "search_ai.ai_debugger_modal_orchestration_minions_count",
        defaultMessage: "{count} {count, plural, one {minion} other {minions}}"
    },
    ai_debugger_modal_no_orchestration_data: {
        id: "search_ai.ai_debugger_modal_no_orchestration_data",
        defaultMessage: "No minion outputs to show."
    },
    ai_debugger_modal_minion_input_label: {
        id: "search_ai.ai_debugger_modal_minion_input_label",
        defaultMessage: "Input"
    },
    ai_debugger_modal_minion_output_label: {
        id: "search_ai.ai_debugger_modal_minion_output_label",
        defaultMessage: "Output"
    },
    ai_debugger_modal_execution_duration: {
        id: "search_ai.ai_debugger_modal_execution_duration",
        defaultMessage: "{duration}ms"
    },
    ai_debugger_modal_execution_duration_label: {
        id: "search_ai.ai_debugger_modal_execution_duration_label",
        defaultMessage: "Duration"
    },
    ai_debugger_modal_minion_name_label: {
        id: "search_ai.ai_debugger_modal_minion_name_label",
        defaultMessage: "Minion Name"
    },
    ai_debugger_modal_disabled: {
        id: "search_ai.ai_debugger_modal_disabled",
        defaultMessage: "disabled"
    },
    ai_debugger_modal_minion_extra_info_label: {
        id: "search_ai.ai_debugger_modal_plugin_output_label",
        defaultMessage: "Extra Info"
    },
    ai_debugger_modal_no_plugins_invoked: {
        id: "search_ai.ai_debugger_modal_no_plugins_invoked",
        defaultMessage: "No additional plugins invoked."
    },
    ai_debugger_modal_teamwork_unnamed_team: {
        id: "search_ai.ai_debugger_modal_teamwork_unnamed_team",
        defaultMessage: "Unnamed Team"
    },
    ai_debugger_modal_teamwork_members_count: {
        id: "search_ai.ai_debugger_modal_teamwork_members_count",
        defaultMessage: "Members: {count}"
    },
    ai_debugger_modal_teamwork_state: {
        id: "search_ai.ai_debugger_modal_teamwork_state",
        defaultMessage: "State: {state}"
    },
    ai_debugger_modal_teamwork_creator: {
        id: "search_ai.ai_debugger_modal_teamwork_creator",
        defaultMessage: "Creator: {creator}"
    },
    ai_debugger_modal_teamwork_show_count: {
        id: "search_ai.ai_debugger_modal_teamwork_show_count",
        defaultMessage: "Show {count} {count, plural, one {member} other {members}}"
    },
    ai_debugger_modal_teamwork_hide_count: {
        id: "search_ai.ai_debugger_modal_teamwork_hide_count",
        defaultMessage: "Hide {count} {count, plural, one {member} other {members}}"
    },
    ai_debugger_modal_author_label: {
        id: "search_ai.ai_debugger_modal_author_label",
        defaultMessage: "Author: {author}"
    },
    ai_debugger_modal_teamwork_document_updated: {
        id: "search_ai.ai_debugger_modal_teamwork_document_updated",
        defaultMessage: "Updated: {date}"
    },
    ai_debugger_modal_page_search_space: {
        id: "search_ai.ai_debugger_modal_page_search_space",
        defaultMessage: "Space: {space}"
    },
    ai_debugger_modal_page_search_count: {
        id: "search_ai.ai_debugger_modal_page_search_count",
        defaultMessage: "{count} {count, plural, one {page} other {pages}} found"
    },
    ai_debugger_modal_function_results_count: {
        id: "search_ai.ai_debugger_modal_function_results_count",
        defaultMessage: "Function Results ({count})"
    },
    ai_debugger_modal_raw_search_results_heading: {
        id: "search_ai.ai_debugger_modal_raw_search_results_heading",
        defaultMessage: "{count, plural, one {Raw Search Result ({count})} other {Raw Search Results ({count})}}"
    },
    ai_debugger_modal_table_url_header: {
        id: "search_ai.ai_debugger_modal_table_url_header",
        defaultMessage: "Document URL"
    },
    ai_debugger_modal_table_doc_index_header: {
        id: "search_ai.ai_debugger_modal_table_doc_index_header",
        defaultMessage: "#"
    },
    ai_debugger_modal_no_raw_search_results: {
        id: "search_ai.ai_debugger_modal_no_raw_search_results",
        defaultMessage: "No raw search results available."
    },
    ai_debugger_modal_ranked_search_results_heading: {
        id: "search_ai.ai_debugger_modal_ranked_search_results_heading",
        defaultMessage: "{count, plural, one {Ranked Document with Chunks ({count})} other {Ranked Documents with Chunks ({count})}}"
    },
    ai_debugger_modal_table_chunk_id_header: {
        id: "search_ai.ai_debugger_modal_table_chunk_id_header",
        defaultMessage: "Chunk ID"
    },
    ai_debugger_modal_table_chunk_score_header: {
        id: "search_ai.ai_debugger_modal_table_chunk_score_header",
        defaultMessage: "Score"
    },
    ai_debugger_modal_table_chunk_rank_header: {
        id: "search_ai.ai_debugger_modal_table_chunk_rank_header",
        defaultMessage: "Rank"
    },
    ai_debugger_modal_no_ranked_search_results: {
        id: "search_ai.ai_debugger_modal_no_ranked_search_results",
        defaultMessage: "No ranked search results available."
    },
    ai_debugger_modal_unable_to_match_chunks: {
        id: "search_ai.ai_debugger_modal_unable_to_match_chunks",
        defaultMessage: "Unable to match chunks"
    },
    ai_debugger_modal_plugins_invoked_subheading: {
        id: "search_ai.ai_debugger_modal_plugins_invoked_subheading",
        defaultMessage: "Plugins Invoked"
    },
    prompt_override_button_label: {
        id: "search_ai.prompt_override_button_label",
        defaultMessage: "Prompt override"
    },
    prompt_override_modal_title: {
        id: "search_ai.prompt_override_modal_title",
        defaultMessage: "Custom System Prompt Override"
    },
    prompt_override_custom_prompt_label: {
        id: "search_ai.prompt_override_custom_prompt_label",
        defaultMessage: "Custom Prompt:"
    },
    prompt_override_textarea_placeholder: {
        id: "search_ai.prompt_override_textarea_placeholder",
        defaultMessage: "Enter your custom system prompt here..."
    },
    prompt_override_help_text: {
        id: "search_ai.prompt_override_help_text",
        defaultMessage: "This prompt will override the default system prompt for AI requests during this session."
    },
    prompt_override_cancel_button: {
        id: "search_ai.prompt_override_cancel_button",
        defaultMessage: "Cancel"
    },
    prompt_override_save_button: {
        id: "search_ai.prompt_override_save_button",
        defaultMessage: "Save"
    }
});
module.exports["messages"] = $834ca13a4b04c199$export$defe85febe8b728c;

});

parcelRegister("bIZaC", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

const $ff375125b11d6992$export$c4c8b81ee90e6af2 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerDislikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
module.exports["onDislikeButtonClick"] = $ff375125b11d6992$export$c4c8b81ee90e6af2;

});

parcelRegister("7z5N5", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

const $d72bf611d64ecd70$export$5b155f527aff26b9 = (props)=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerLikeButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props)
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
module.exports["onLikeButtonClick"] = $d72bf611d64ecd70$export$5b155f527aff26b9;

});

parcelRegister("7qJqb", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $cozmU = parcelRequire("cozmU");

const $eab2f21eaddd320a$export$f3f282f819d3a3cc = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "14",
        height: "20",
        viewBox: "0 0 14 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "3",
        cy: "14",
        r: "1",
        fill: '#1F69DA'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "opacity",
        values: "0;1;1;1;",
        dur: "0.8s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "7",
        cy: "14",
        r: "1",
        fill: '#C16CD4'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "opacity",
        values: "0;0;1;1;",
        dur: "0.8s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "11",
        cy: "14",
        r: "1",
        fill: '#F5A117'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "opacity",
        values: "0;0;0;1;",
        dur: "0.8s",
        repeatCount: "indefinite",
        begin: "0s"
    })));
};
module.exports["RovoGeneratingAnimation"] = $eab2f21eaddd320a$export$f3f282f819d3a3cc;

});

parcelRegister("kSORO", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

const $345c4b3767ab340d$export$a43930cde520e30 = (props, isAnimated)=>{
    const { query: query, source: source } = props;
    return {
        action: 'shown',
        actionSubject: 'aiAnswerLoadingDialog',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            isAnimated: isAnimated
        },
        nonPrivacySafeAttributes: {
            query: query
        }
    };
};
module.exports["onAIAnswerLoadingDialogShown"] = $345c4b3767ab340d$export$a43930cde520e30;

});

parcelRegister("24oKg", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $9ee8edf58ce8906b$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    smart_answer_card_generating: {
        id: "search_ai.smart_answer_card_generating",
        defaultMessage: "Generating"
    },
    smart_answer_card_title: {
        id: "search_ai.smart_answer_card.title",
        defaultMessage: "Answer"
    },
    smart_answer_card_dynamic_layout_title: {
        id: "search_ai.smart_answer_card_dynamic_layout_title",
        defaultMessage: "Overview"
    },
    smart_answer_card_rovo_generating: {
        id: "search_ai.smart_answer_card_rovo_generating",
        defaultMessage: "Rovo is {queryReasoning}"
    },
    smart_answer_card_rovo_is_thinking: {
        id: "search_ai.smart_answer_card_rovo_is_thinking",
        defaultMessage: "Rovo is thinking"
    },
    related_links_title: {
        id: "search_ai.related_links_list_label",
        defaultMessage: "Related links"
    },
    hide_answer: {
        id: "search_ai.smart_answer_card.hide_answer",
        defaultMessage: "Hide answer"
    }
});
module.exports["messages"] = $9ee8edf58ce8906b$export$defe85febe8b728c;

});

parcelRegister("9LgVw", function(module, exports) {
module.exports = new URL("Rovo.e24f6f93.svg", import.meta.url).toString();

});

parcelRegister("aqqYN", function(module, exports) {
/* knowledge-cards-row.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $apU4q = parcelRequire("apU4q");


var $1UlLI = parcelRequire("1UlLI");


var $lJqiq = parcelRequire("lJqiq");


var $43jvb = parcelRequire("43jvb");


var $9K2hX = parcelRequire("9K2hX");

const $4115b74ed5746564$var$i18n = (0, $kSwu1.defineMessages)({
    knowledgeRowTypeWork: {
        id: "search_ai.knowledge_cards.row.knowledge-row-type.work",
        defaultMessage: "Work Item"
    },
    knowledgeRowTypeAgent: {
        id: "search_ai.knowledge_cards.row.knowledge-row-type.agent",
        defaultMessage: "Agent"
    },
    knowledgeRowTypePerson: {
        id: "search_ai.knowledge_cards.row.knowledge-row-type.person",
        defaultMessage: "Person"
    }
});
const $4115b74ed5746564$var$styles = {
    root: "_0bjKvDKxmn _2xTnZx2ADO _1eOmH6d1Zr _0ReiIH7zJH"
};
const $4115b74ed5746564$export$96be17c41f7933d9 = ({ primaryText: primaryText, secondaryText: secondaryText, pictureUrl: pictureUrl, type: type, triggerProps: triggerProps, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, contentTypeName: contentTypeName })=>{
    const intl = (0, $kSwu1.useIntl)();
    const altText = contentTypeName ? (0, $43jvb.formatContentTypeName)(contentTypeName) : type === (0, $1UlLI.KnowledgeCardsRowType).PERSON ? intl.formatMessage($4115b74ed5746564$var$i18n.knowledgeRowTypePerson) : intl.formatMessage($4115b74ed5746564$var$i18n.knowledgeRowTypeWork);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4115b74ed5746564$var$styles.root,
        paddingInline: "space.200",
        paddingBlock: "space.100",
        ...triggerProps,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, type === (0, $1UlLI.KnowledgeCardsRowType).PERSON ? /*#__PURE__*/ $cozmU.createElement((0, $lJqiq.PersonStyles), {
        src: pictureUrl,
        alt: altText
    }) : /*#__PURE__*/ $cozmU.createElement((0, $9K2hX.WorkStyles), {
        src: pictureUrl,
        alt: altText
    }), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        spread: "space-between"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        maxLines: 1
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xxsmall"
    }, primaryText)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 1
    }, secondaryText))));
};
const $4115b74ed5746564$export$465f421106844c87 = ({ primaryText: primaryText, secondaryText: secondaryText, pictureUrl: pictureUrl, type: type, triggerProps: triggerProps, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, contentTypeName: contentTypeName })=>{
    const intl = (0, $kSwu1.useIntl)();
    const altText = contentTypeName ? (0, $43jvb.formatContentTypeName)(contentTypeName) : type === (0, $1UlLI.KnowledgeCardsRowType).WORK ? intl.formatMessage($4115b74ed5746564$var$i18n.knowledgeRowTypeWork) : type === (0, $1UlLI.KnowledgeCardsRowType).AGENT ? intl.formatMessage($4115b74ed5746564$var$i18n.knowledgeRowTypeAgent) : intl.formatMessage($4115b74ed5746564$var$i18n.knowledgeRowTypePerson);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $4115b74ed5746564$var$styles.root,
        paddingInline: "space.200",
        paddingBlock: "space.075",
        ...triggerProps,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, type === (0, $1UlLI.KnowledgeCardsRowType).WORK ? /*#__PURE__*/ $cozmU.createElement((0, $9K2hX.WorkStyles), {
        src: pictureUrl,
        alt: altText
    }) : type === (0, $1UlLI.KnowledgeCardsRowType).AGENT ? /*#__PURE__*/ $cozmU.createElement((0, $apU4q.AgentStyles), {
        src: pictureUrl,
        alt: altText
    }) : /*#__PURE__*/ $cozmU.createElement((0, $lJqiq.PersonStyles), {
        src: pictureUrl,
        alt: altText
    }), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        maxLines: 1
    }, primaryText), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest",
        maxLines: 1
    }, secondaryText))));
};
module.exports["KnowledgeCardsRow"] = $4115b74ed5746564$export$96be17c41f7933d9;
module.exports["KnowledgeCardsRowRefresh"] = $4115b74ed5746564$export$465f421106844c87;

});

parcelRegister("1UlLI", function(module, exports) {
var $e3379cc3d34812dc$export$f6d5eb0487369ad6 = /*#__PURE__*/ function(KnowledgeCardsRowType) {
    KnowledgeCardsRowType["PERSON"] = "PERSON";
    KnowledgeCardsRowType["WORK"] = "WORK";
    KnowledgeCardsRowType["AGENT"] = "AGENT";
    return KnowledgeCardsRowType;
}({});
module.exports["KnowledgeCardsRowType"] = $e3379cc3d34812dc$export$f6d5eb0487369ad6;

});

parcelRegister("dDQsD", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

const $569708f7a87c1cd2$export$689a00fa0f31e3ff = ({ experimentCohort: experimentCohort, ...props })=>{
    const { query: query, answerString: answerString, source: source } = props;
    return {
        action: 'clicked',
        actionSubject: 'aiAnswerOpenChatButton',
        source: source,
        eventType: 'ui',
        attributes: {
            ...(0, $4Tg3t.filterCommonAttributes)(props),
            experimentCohort: experimentCohort
        },
        nonPrivacySafeAttributes: {
            query: query,
            answerString: answerString
        }
    };
};
module.exports["onOpenChatButtonClick"] = $569708f7a87c1cd2$export$689a00fa0f31e3ff;

});

parcelRegister("5OgwG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1589bfa747ca2c19$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    ai_answer_card_collapse_button: {
        id: "search_ai.ai_answer_card_collapse_button",
        defaultMessage: "Collapse"
    },
    ai_answer_card_expand_button: {
        id: "search_ai.ai_answer_card_expand_button",
        defaultMessage: "Expand"
    },
    ai_answer_card_tab_ai_answer: {
        id: "search_ai.ai_answer_card_tab_ai_answer",
        defaultMessage: "AI Answer"
    },
    ai_answer_card_tab_sources: {
        id: "search_ai.ai_answer_card_tab_sources",
        defaultMessage: "Sources"
    },
    ai_answer_card_tab_sources_with_pluralization: {
        id: "search_ai.ai_answer_card_tab_sources_with_pluralization",
        defaultMessage: "{sourcesCount, plural, one {Source} other {Sources {sourcesCount}}}"
    },
    ai_answer_card_read_more_button: {
        id: "search_ai.ai_answer_card_read_more_button",
        defaultMessage: "Read more"
    },
    ai_answer_card_show_more_button: {
        id: "search_ai.ai_answer_card_show_more_button",
        defaultMessage: "Show more"
    },
    ai_answer_open_chat_input_box_ask_rovo: {
        id: "search_ai.ai_answer_open_chat_input_box_ask_rovo",
        defaultMessage: "Ask Rovo anything"
    },
    ai_answer_card_early_stop_text: {
        id: "search_ai.ai_answer_card_early_stop_text",
        defaultMessage: "Rovo couldn't generate an answer for \"{searchQuery}\". Try rephrasing your query."
    },
    ai_answer_card_early_stop_close_button_label: {
        id: "search_ai.ai_answer_card_early_stop_close_button",
        defaultMessage: "Close"
    },
    ai_answer_open_chat_input_box_send_query: {
        id: "search_ai.ai_answer_open_chat_input_box_send_query",
        defaultMessage: "Send query"
    }
});
module.exports["messages"] = $1589bfa747ca2c19$export$defe85febe8b728c;

});

parcelRegister("6R26v", function(module, exports) {

var $1Nf9V = parcelRequire("1Nf9V");


var $dP3C2 = parcelRequire("dP3C2");


var $4762y = parcelRequire("4762y");


var $4hGoz = parcelRequire("4hGoz");


var $izeRj = parcelRequire("izeRj");


var $4WM05 = parcelRequire("4WM05");


var $614SU = parcelRequire("614SU");


var $agj0v = parcelRequire("agj0v");


var $9S2qh = parcelRequire("9S2qh");


var $5J4us = parcelRequire("5J4us");

const $c4e2d49fa2b5e1bc$export$6f0a258f64ff7a99 = (extraAttributes, sources)=>{
    const { originalQuery: originalQuery, transformedQuery: transformedQuery, traceId: traceId, answerGenerationModel: answerGenerationModel, cacheInfo: cacheInfo, sources: extraSources = [], pluginInvocations: pluginInvocations = [], minion_outputs: minion_outputs = [], rawJson: rawJson } = extraAttributes ?? {};
    const resolvedSources = sources !== undefined ? sources : extraSources;
    // Extract search data from both plugins and minions, then merge
    const pluginSearchInfo = (0, $614SU.getSearchResultsFromPlugins)(pluginInvocations);
    const minionSearchInfo = (0, $4WM05.getSearchResultsFromMinions)(minion_outputs);
    const searchExtraInfo = (0, $agj0v.mergeSearchExtraInfo)(pluginSearchInfo, minionSearchInfo);
    const rankedDocumentsWithChunks = (0, $izeRj.getRankedDocumentsWithChunks)(searchExtraInfo);
    const orchestrationRounds = (0, $5J4us.getOrchestrationRounds)(minion_outputs);
    return {
        requestOverview: {
            originalQuery: originalQuery ?? null,
            transformedQuery: transformedQuery ?? null,
            traceId: traceId ?? null,
            modelName: (0, $1Nf9V.extractModelName)(answerGenerationModel),
            cacheHit: (0, $9S2qh.normalizeCacheHit)(cacheInfo),
            sources: resolvedSources,
            invokedPluginNames: (0, $dP3C2.extractUniquePluginNames)(pluginInvocations)
        },
        rankedSearch: {
            searchExtraInfo: searchExtraInfo,
            rankedDocumentsWithChunks: rankedDocumentsWithChunks
        },
        rawSearch: {
            searchResults: searchExtraInfo?.searchResults ?? []
        },
        pluginInvocations: {
            allPluginInvocations: pluginInvocations,
            nonSearchPluginInvocations: (0, $4hGoz.filterNonSearchPlugins)(pluginInvocations),
            hasPluginInvocations: pluginInvocations ? pluginInvocations.length > 0 : false
        },
        minions: {
            allMinionOutputs: minion_outputs,
            nonSearchMinionOutputs: (0, $4762y.filterNonSearchMinions)(minion_outputs),
            hasMinionOutputs: minion_outputs ? minion_outputs.length > 0 : false,
            orchestrationRounds: orchestrationRounds,
            roundCount: orchestrationRounds.length
        },
        rawJson: {
            rawJson: rawJson
        }
    };
};
module.exports["normalizeDebuggerData"] = $c4e2d49fa2b5e1bc$export$6f0a258f64ff7a99;

});

parcelRegister("ftCDW", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bxtKM = parcelRequire("bxtKM");

var $dkVNA = parcelRequire("dkVNA");


var $lT1k3 = parcelRequire("lT1k3");

const $b69d7ae01770c92a$export$77c21587411d3943 = ({ isNaturalLanguageQuery: isNaturalLanguageQuery, hasMinionOutputs: hasMinionOutputs, hasPluginInvocations: hasPluginInvocations, roundCount: roundCount })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const showPluginsTabs = isNaturalLanguageQuery && !hasMinionOutputs && hasPluginInvocations;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dkVNA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_tab_request_overview)), showPluginsTabs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_tab_raw_search_results)), showPluginsTabs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_tab_ranked_search_results)), showPluginsTabs && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_tab_plugin_invocations)), isNaturalLanguageQuery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_tab_orchestration_overview)), isNaturalLanguageQuery && hasMinionOutputs && Array.from({
        length: roundCount
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), {
            key: `loop-${index}`
        }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_tab_loop, {
            number: index
        }))), isNaturalLanguageQuery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bxtKM.default), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_tab_raw_json)));
};
module.exports["DebuggerTabList"] = $b69d7ae01770c92a$export$77c21587411d3943;

});

parcelRegister("lIZC4", function(module, exports) {
/* loop-panel.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $3pCca = parcelRequire("3pCca");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $gRGWz = parcelRequire("gRGWz");


var $lPcf8 = parcelRequire("lPcf8");


var $kJmyb = parcelRequire("kJmyb");


var $izeRj = parcelRequire("izeRj");


var $lT1k3 = parcelRequire("lT1k3");


var $9kYnS = parcelRequire("9kYnS");


var $2IyOa = parcelRequire("2IyOa");


var $3AbYV = parcelRequire("3AbYV");


var $5J4us = parcelRequire("5J4us");


var $7LI7r = parcelRequire("7LI7r");

const $ae2c26e8d2f5c295$var$styles = {
    minionCard: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _0KLXru66of",
    pressable: "_0Of8r28HPE _1Znuxb5zaO _1wydGW8HPE _2Zuz6Q5zaO _0wOv4Q7zJH _39xV02N91d",
    expandedContent: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXruDMqu _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    borderedBox: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _0KLXru66of",
    sectionPadding: "_0Of8r28HPE _1wydGW8HPE _2Zuz6Q5zaO _1Znuxb5zaO",
    codeBlock: "_0bjKvDKxmn _4bt5LAIZbP _2WAcuGIZbP _0KLXru7Cj1 _0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _1ANEUSlpBW _3W2Oc84hR5 _0NUa3rgZxp",
    expandableHeader: "_0Of8r22ADO _1Znuxb8HPE _1wydGW2ADO _2Zuz6Q8HPE _0wOv4Q7zJH _39xV02N91d",
    expandableContent: "_0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67",
    searchResultsGrid: "_2iEGP2UfmU",
    rankedDocsGrid: "_2iEGP2VIym",
    gridCell: "_0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _3W2Oc84hR5",
    gridCellWithLeftBorder: "_1Vs123NvrM _421I1o6wH8 _0obpEh9r67",
    gridHeader: "_0KLXruDMqu"
};
const $ae2c26e8d2f5c295$var$ExpandableSection = ({ title: title, children: children, defaultExpanded: defaultExpanded = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(defaultExpanded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ae2c26e8d2f5c295$var$styles.borderedBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: ()=>setIsExpanded(!isExpanded),
        xcss: $ae2c26e8d2f5c295$var$styles.expandableHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_collapse_label),
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_expand_label),
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, title))), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ae2c26e8d2f5c295$var$styles.expandableContent
    }, children));
};
const $ae2c26e8d2f5c295$var$MinionExpandableItem = ({ minion: minion, index: index })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const minionInfo = (0, $kJmyb.getMinionOutputItem)(minion);
    const isSearchMinion = minionInfo.minion_id?.toLowerCase().includes((0, $9kYnS.MinionName).SEARCH);
    const { extraInfo: extraInfo, parsedOutput: parsedOutput, functionResults: functionResults, searchExtraInfo: searchExtraInfo } = (0, $5J4us.parseMinionExtraInfo)(minionInfo.minion_extra_info, minionInfo.minion_id, isSearchMinion ?? false);
    const rankedDocumentsWithChunks = (0, $izeRj.getRankedDocumentsWithChunks)(searchExtraInfo);
    const rawSearchResults = searchExtraInfo?.searchResults ?? [];
    const executionDuration = minionInfo.minion_execution_duration;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ae2c26e8d2f5c295$var$styles.minionCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: ()=>setIsExpanded(!isExpanded),
        xcss: $ae2c26e8d2f5c295$var$styles.pressable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_collapse_label),
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_expand_label),
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, minionInfo.minion_id || `Minion ${index + 1}`)), executionDuration !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_execution_duration_label), ":", ' ', formatMessage((0, $lT1k3.messages).ai_debugger_modal_execution_duration, {
        duration: executionDuration
    })))), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ae2c26e8d2f5c295$var$styles.expandedContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, minionInfo.minion_input && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.borderedBox, $ae2c26e8d2f5c295$var$styles.sectionPadding)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold",
        size: "small"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_minion_input_label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ae2c26e8d2f5c295$var$styles.codeBlock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, typeof minionInfo.minion_input === 'object' ? JSON.stringify(minionInfo.minion_input, null, 2) : minionInfo.minion_input)))), minionInfo.minion_output && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2c26e8d2f5c295$var$ExpandableSection, {
        title: formatMessage((0, $lT1k3.messages).ai_debugger_modal_minion_output_label)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ae2c26e8d2f5c295$var$styles.codeBlock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, typeof minionInfo.minion_output === 'object' ? JSON.stringify(minionInfo.minion_output, null, 2) : minionInfo.minion_output))), functionResults && functionResults.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2c26e8d2f5c295$var$ExpandableSection, {
        title: formatMessage((0, $lT1k3.messages).ai_debugger_modal_function_results_count, {
            count: functionResults.length
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, functionResults.map((result, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2IyOa.FunctionResult), {
            key: idx,
            result: result,
            index: idx
        })))), (parsedOutput || extraInfo) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2c26e8d2f5c295$var$ExpandableSection, {
        title: formatMessage((0, $lT1k3.messages).ai_debugger_modal_minion_extra_info_label)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3AbYV.PluginOutputRenderer), {
        parsedOutput: parsedOutput,
        extraInfo: extraInfo
    })), isSearchMinion && rawSearchResults.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2c26e8d2f5c295$var$ExpandableSection, {
        title: formatMessage((0, $lT1k3.messages).ai_debugger_modal_raw_search_results_heading, {
            count: rawSearchResults.length
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ae2c26e8d2f5c295$var$styles.borderedBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        xcss: $ae2c26e8d2f5c295$var$styles.searchResultsGrid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_url_header))), rawSearchResults.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: url,
            xcss: $ae2c26e8d2f5c295$var$styles.gridCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: url,
            target: "_blank"
        }, url)))))), isSearchMinion && rankedDocumentsWithChunks.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2c26e8d2f5c295$var$ExpandableSection, {
        title: formatMessage((0, $lT1k3.messages).ai_debugger_modal_ranked_search_results_heading, {
            count: rankedDocumentsWithChunks.length
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ae2c26e8d2f5c295$var$styles.borderedBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        xcss: $ae2c26e8d2f5c295$var$styles.rankedDocsGrid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_doc_index_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder, $ae2c26e8d2f5c295$var$styles.gridHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_url_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder, $ae2c26e8d2f5c295$var$styles.gridHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_chunk_id_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder, $ae2c26e8d2f5c295$var$styles.gridHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_chunk_score_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder, $ae2c26e8d2f5c295$var$styles.gridHeader)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_chunk_rank_header))), rankedDocumentsWithChunks.map((doc, docIndex)=>{
        const chunkCount = Math.max(doc.chunks.length, 1);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
            key: doc.url
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $ae2c26e8d2f5c295$var$styles.gridCell,
            style: {
                gridRow: `span ${chunkCount}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "semibold"
        }, docIndex + 1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder),
            style: {
                gridRow: `span ${chunkCount}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: doc.url,
            target: "_blank"
        }, doc.url)), doc.chunks.length > 0 ? doc.chunks.map((chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
                key: chunk.chunk_id
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, chunk.chunk_id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, chunk.score.toFixed(4))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, chunk.rank)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_unable_to_match_chunks))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, "-")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($ae2c26e8d2f5c295$var$styles.gridCell, $ae2c26e8d2f5c295$var$styles.gridCellWithLeftBorder)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, "-"))));
    }))))))));
};
const $ae2c26e8d2f5c295$export$99187093ec4738cf = ({ round: round, roundIndex: roundIndex })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), {
        testId: `sain-online-debugger-loop-${roundIndex}-panel`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_orchestration_loop_with_count, {
        number: roundIndex,
        count: round.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, round.map((minion, minionIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ae2c26e8d2f5c295$var$MinionExpandableItem, {
            key: (0, $kJmyb.getMinionOutputItem)(minion).minion_id || minionIndex,
            minion: minion,
            index: minionIndex
        }))))));
};
module.exports["LoopPanel"] = $ae2c26e8d2f5c295$export$99187093ec4738cf;

});

parcelRegister("7Mjvn", function(module, exports) {
/* orchestration-overview-panel.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

var $3pCca = parcelRequire("3pCca");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $gRGWz = parcelRequire("gRGWz");


var $IOtUu = parcelRequire("IOtUu");


var $kJmyb = parcelRequire("kJmyb");


var $lT1k3 = parcelRequire("lT1k3");


var $7LI7r = parcelRequire("7LI7r");

const $a5b738d83e7d73f2$var$styles = {
    minionGrid: "_2iEGP2wA97"
};
const $a5b738d83e7d73f2$export$fb4e2149d28f72b3 = ({ orchestrationRounds: orchestrationRounds })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (orchestrationRounds.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), {
        testId: "sain-online-debugger-orchestration-overview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_no_orchestration_data))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), {
        testId: "sain-online-debugger-orchestration-overview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, orchestrationRounds.map((round, roundIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: roundIndex
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_orchestration_loop_heading, {
            number: roundIndex
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
            text: formatMessage((0, $lT1k3.messages).ai_debugger_modal_orchestration_minions_count, {
                count: round.length
            }),
            isRemovable: false,
            migration_fallback: "lozenge"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
            xcss: $a5b738d83e7d73f2$var$styles.minionGrid,
            gap: "space.100",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_minion_name_label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_execution_duration_label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xsmall"
        }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_minion_input_label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, round.map((minion, minionIndex)=>{
            const minionInfo = (0, $kJmyb.getMinionOutputItem)(minion);
            const minionId = minionInfo.minion_id;
            const minionInput = minionInfo.minion_input;
            const executionDuration = minionInfo.minion_execution_duration;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
                key: `${minionId}-${minionIndex}`,
                xcss: $a5b738d83e7d73f2$var$styles.minionGrid,
                gap: "space.100",
                alignItems: "center"
            }, minionId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtle"
            }, minionId) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtlest",
                testId: "disabled-minion-id"
            }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_disabled)), executionDuration !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtle"
            }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_execution_duration, {
                duration: executionDuration
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtlest",
                testId: "disabled-execution-duration"
            }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_disabled)), minionInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtle"
            }, typeof minionInput === 'object' ? JSON.stringify(minionInput, null, 2) : minionInput) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                color: "color.text.subtlest",
                testId: "disabled-minion-input"
            }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_disabled)));
        }))))))));
};
module.exports["OrchestrationOverviewPanel"] = $a5b738d83e7d73f2$export$fb4e2149d28f72b3;

});

parcelRegister("8ynLJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $gRGWz = parcelRequire("gRGWz");


var $3nKR8 = parcelRequire("3nKR8");


var $lT1k3 = parcelRequire("lT1k3");


var $7LI7r = parcelRequire("7LI7r");

const $f9cc317b71411006$export$8eddb41fbb2fcd3f = ({ nonSearchPluginInvocations: nonSearchPluginInvocations })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), {
        testId: "sain-online-debugger-plugin-invocations-panel"
    }, nonSearchPluginInvocations.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.0"
    }, nonSearchPluginInvocations.map((plugin, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3nKR8.PluginInvocationItem), {
            key: plugin.plugin_invocation_id || index,
            plugin: plugin,
            index: index
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_no_plugins_invoked))));
};
module.exports["PluginInvocationsPanel"] = $f9cc317b71411006$export$8eddb41fbb2fcd3f;

});

parcelRegister("61d8U", function(module, exports) {
/* ranked-search-results-panel.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $3pCca = parcelRequire("3pCca");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $gRGWz = parcelRequire("gRGWz");


var $lT1k3 = parcelRequire("lT1k3");


var $7LI7r = parcelRequire("7LI7r");

const $1953b8642f0f994c$var$styles = {
    rankedDocsGrid: "_2iEGP2VIym _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _1Vs123NvrM _421I1o6wH8 _0obpEh9r67",
    gridHeader: "_0KLXruDMqu _0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _1aEeYeNvrM _3587oR6wH8 _1uR5uv9r67",
    gridCell: "_0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _1aEeYeNvrM _3587oR6wH8 _1uR5uv9r67",
    gridUrlCell: "_0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _1aEeYeNvrM _3587oR6wH8 _1uR5uv9r67 _3W2Oc84hR5"
};
const $1953b8642f0f994c$export$39197e0ebf675eb2 = ({ rankedDocumentsWithChunks: rankedDocumentsWithChunks })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), {
        testId: "sain-online-debugger-ranked-search-results-panel"
    }, rankedDocumentsWithChunks.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_no_ranked_search_results)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_ranked_search_results_heading, {
        count: rankedDocumentsWithChunks.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        xcss: $1953b8642f0f994c$var$styles.rankedDocsGrid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1953b8642f0f994c$var$styles.gridHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_doc_index_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1953b8642f0f994c$var$styles.gridHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_url_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1953b8642f0f994c$var$styles.gridHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_chunk_id_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1953b8642f0f994c$var$styles.gridHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_chunk_score_header))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $1953b8642f0f994c$var$styles.gridHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_chunk_rank_header))), rankedDocumentsWithChunks.map((doc, index)=>{
        const chunkCount = Math.max(doc.chunks.length, 1);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
            key: `${doc.url}-${index}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $1953b8642f0f994c$var$styles.gridCell,
            style: {
                gridRow: `span ${chunkCount}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "semibold"
        }, index + 1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $1953b8642f0f994c$var$styles.gridUrlCell,
            style: {
                gridRow: `span ${chunkCount}`
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: doc.url,
            target: "_blank"
        }, doc.url)), doc.chunks.length > 0 ? doc.chunks.map((chunk, chunkIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
                key: `${chunk.chunk_id}-${chunkIndex}`
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $1953b8642f0f994c$var$styles.gridCell
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, chunk.chunk_id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $1953b8642f0f994c$var$styles.gridCell
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, chunk.score.toFixed(4))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $1953b8642f0f994c$var$styles.gridCell
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, chunk.rank)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $1953b8642f0f994c$var$styles.gridCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_unable_to_match_chunks))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $1953b8642f0f994c$var$styles.gridCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, "-")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $1953b8642f0f994c$var$styles.gridCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, "-"))));
    })))));
};
module.exports["RankedSearchResultsPanel"] = $1953b8642f0f994c$export$39197e0ebf675eb2;

});

parcelRegister("9UsEc", function(module, exports) {
/* raw-json-panel.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $azTKI = parcelRequire("azTKI");


var $fHs3z = parcelRequire("fHs3z");


var $chu6R = parcelRequire("chu6R");


var $iMnC5 = parcelRequire("iMnC5");


var $gRGWz = parcelRequire("gRGWz");


var $lT1k3 = parcelRequire("lT1k3");


var $7LI7r = parcelRequire("7LI7r");

const $08be90183ca9ea64$var$styles = {
    copyJsonButton: "_2XsHFMIZbP"
};
const $08be90183ca9ea64$var$formatJson = (data)=>{
    return JSON.stringify(data, null, 2);
};
const $08be90183ca9ea64$export$c1727a1710dac2d1 = ({ rawJson: rawJson })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [jsonCopied, setJsonCopied] = (0, $cozmU.useState)(false);
    const copyFinalResponseJson = (0, $cozmU.useCallback)(async ()=>{
        try {
            if (!rawJson) return;
            const jsonString = $08be90183ca9ea64$var$formatJson(rawJson);
            if (!jsonString) return;
            await navigator.clipboard.writeText(jsonString);
            setJsonCopied(true);
            setTimeout(()=>{
                setJsonCopied(false);
            }, 2500);
        } catch  {
            return;
        }
    }, [
        rawJson
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $08be90183ca9ea64$var$styles.copyJsonButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: copyFinalResponseJson,
        iconBefore: jsonCopied ? (0, (/*@__PURE__*/$parcel$interopDefault($chu6R))) : (0, (/*@__PURE__*/$parcel$interopDefault($fHs3z)))
    }, jsonCopied ? formatMessage((0, $lT1k3.messages).ai_debugger_modal_copy_button_copied_text) : formatMessage((0, $lT1k3.messages).ai_debugger_modal_copy_button_text))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $azTKI.default), {
        language: "json",
        text: $08be90183ca9ea64$var$formatJson(rawJson ?? null),
        shouldWrapLongLines: true
    })));
};
module.exports["RawJsonPanel"] = $08be90183ca9ea64$export$c1727a1710dac2d1;

});

parcelRegister("kV3xA", function(module, exports) {
/* raw-search-results-panel.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $3pCca = parcelRequire("3pCca");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $gRGWz = parcelRequire("gRGWz");


var $lT1k3 = parcelRequire("lT1k3");


var $7LI7r = parcelRequire("7LI7r");

const $8a3882a721380e47$var$styles = {
    singleColumnGrid: "_2iEGP2UfmU _22sfPnNvrM _2IVJ4M6wH8 _3zygPU9r67 _1Vs123NvrM _421I1o6wH8 _0obpEh9r67",
    gridHeader: "_0KLXruDMqu _0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _1aEeYeNvrM _3587oR6wH8 _1uR5uv9r67",
    gridUrlCell: "_0Of8r22ADO _1wydGW2ADO _2Zuz6Q8HPE _1Znuxb8HPE _3hhsrrNvrM _3BoeID6wH8 _3XVgLM9r67 _1aEeYeNvrM _3587oR6wH8 _1uR5uv9r67 _3W2Oc84hR5"
};
const $8a3882a721380e47$export$4809e441463be887 = ({ searchResults: searchResults })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), {
        testId: "sain-online-debugger-raw-search-results-panel"
    }, searchResults.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_raw_search_results_heading, {
        count: searchResults.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        xcss: $8a3882a721380e47$var$styles.singleColumnGrid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8a3882a721380e47$var$styles.gridHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_table_url_header))), searchResults.map((url, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: `${url}-${index}`,
            xcss: $8a3882a721380e47$var$styles.gridUrlCell
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: url,
            target: "_blank"
        }, url))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $lT1k3.messages).ai_debugger_modal_no_raw_search_results))));
};
module.exports["RawSearchResultsPanel"] = $8a3882a721380e47$export$4809e441463be887;

});

parcelRegister("aAdO3", function(module, exports) {
/* request-overview-panel.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $3pCca = parcelRequire("3pCca");

var $1l0kj = parcelRequire("1l0kj");

var $4aRua = parcelRequire("4aRua");


var $gRGWz = parcelRequire("gRGWz");


var $IOtUu = parcelRequire("IOtUu");


var $8MLeD = parcelRequire("8MLeD");


var $6Skkp = parcelRequire("6Skkp");


var $lT1k3 = parcelRequire("lT1k3");


var $7LI7r = parcelRequire("7LI7r");

const $9269137e932107dc$var$styles = {
    twoColumnGrid: "_2iEGP2Lmr7"
};
const $9269137e932107dc$export$fff5f67a3c73a716 = ({ originalQuery: originalQuery, transformedQuery: transformedQuery, smartAnswersRoute: smartAnswersRoute, traceId: traceId, modelName: modelName, cacheHit: cacheHit, sources: sources, isNaturalLanguageQuery: isNaturalLanguageQuery, invokedPluginNames: invokedPluginNames })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const displayCacheHit = cacheHit === null ? 'disabled' : cacheHit.toString();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gRGWz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7LI7r.Panel), {
        testId: "sain-online-debugger-request-overview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_original_query_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, originalQuery ?? 'null')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_transformed_query_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, transformedQuery ?? 'null')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        xcss: $9269137e932107dc$var$styles.twoColumnGrid,
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_detected_intent_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, smartAnswersRoute)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_trace_id_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, traceId ?? 'null'), traceId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MLeD.CopyButton), {
        copyText: traceId,
        copyLabel: formatMessage((0, $lT1k3.messages).ai_debugger_modal_copy_trace_id_label),
        copiedLabel: formatMessage((0, $lT1k3.messages).ai_debugger_modal_trace_id_copied_text),
        testId: "sain-online-debugger-copy-trace-id-button"
    }))), isNaturalLanguageQuery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_model_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, modelName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_cached_answer_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, displayCacheHit)))), isNaturalLanguageQuery && invokedPluginNames.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_plugins_invoked_subheading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, invokedPluginNames.map((pluginName)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $IOtUu.default), {
            key: pluginName,
            text: pluginName,
            color: (0, $6Skkp.getPluginTagColor)(pluginName),
            isRemovable: false,
            migration_fallback: "lozenge"
        })))), isNaturalLanguageQuery && sources.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_sources_subheading)), sources.map((source, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            key: source.ari ?? source.id,
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, index + 1, "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: source.url,
            target: "_blank"
        }, source.title))))));
};
module.exports["RequestOverviewPanel"] = $9269137e932107dc$export$fff5f67a3c73a716;

});

parcelRegister("apU4q", function(module, exports) {
/* agent-styles.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $e324c4543a86b9df$export$f23caa50568db2b0 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDKTcp _39xV02Uofl _0jFU0VUofl",
            __cmplp.className
        ])
    });
});
module.exports["AgentStyles"] = $e324c4543a86b9df$export$f23caa50568db2b0;

});

parcelRegister("lJqiq", function(module, exports) {
/* person-styles.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $f72cf7c4fbe681a5$export$bf503936295d1d98 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _39xV02Uofl _0jFU0VUofl",
            __cmplp.className
        ])
    });
});
module.exports["PersonStyles"] = $f72cf7c4fbe681a5$export$bf503936295d1d98;

});

parcelRegister("43jvb", function(module, exports) {
/**
 * Converts a GraphQL __typename (PascalCase) to a human-readable format for alt text.
 *
 * Examples:
 * - "ConfluencePage" → "Confluence Page"
 * - "JiraIssue" → "Jira Issue"
 * - "BitbucketPullRequest" → "Bitbucket Pull Request"
 * - "TownsquareGoal" → "Townsquare Goal"
 *
 * @param typeName - The GraphQL __typename value
 * @returns Human-readable formatted string
 */ function $ef06f3dec2ca89f2$export$aeeed0811af42dc5(typeName) {
    if (!typeName) return '';
    let result = '';
    for(let i = 0; i < typeName.length; i++){
        const char = typeName[i];
        // Add space before uppercase letters (except the first character)
        if (i > 0 && char === char.toUpperCase() && char !== char.toLowerCase()) result += ' ';
        result += char;
    }
    return result;
}
module.exports["formatContentTypeName"] = $ef06f3dec2ca89f2$export$aeeed0811af42dc5;

});

parcelRegister("9K2hX", function(module, exports) {
/* work-styles.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $748919a09e20f311$export$b32bf078e8b397e9 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDdnbC _39xV02oWWg _0jFU0VoWWg",
            __cmplp.className
        ])
    });
});
module.exports["WorkStyles"] = $748919a09e20f311$export$b32bf078e8b397e9;

});

parcelRegister("1Nf9V", function(module, exports) {
const $c6236f5d17be7ea0$export$fda8ebbceae980b6 = (answerGenerationModel)=>{
    if (answerGenerationModel?.model_usage && typeof answerGenerationModel.model_usage === 'object') {
        const keys = Object.keys(answerGenerationModel.model_usage);
        return keys[0] ?? 'null';
    }
    return 'null';
};
module.exports["extractModelName"] = $c6236f5d17be7ea0$export$fda8ebbceae980b6;

});

parcelRegister("dP3C2", function(module, exports) {
const $f5b0b766cbb1f718$export$25fa9bb580a33ec7 = (pluginInvocations)=>{
    if (!Array.isArray(pluginInvocations)) return [];
    return [
        ...new Set(pluginInvocations.map((p)=>p.plugin_name).filter((name)=>Boolean(name)))
    ];
};
module.exports["extractUniquePluginNames"] = $f5b0b766cbb1f718$export$25fa9bb580a33ec7;

});

parcelRegister("4762y", function(module, exports) {

var $9kYnS = parcelRequire("9kYnS");

const $b5380383f002e2ac$export$fabd92b0068ace48 = (minionOutputs)=>{
    if (!Array.isArray(minionOutputs)) return [];
    return minionOutputs.filter((minion)=>{
        const minionInfo = Array.isArray(minion) ? minion[0] : minion;
        return !minionInfo.minion_id?.toLowerCase().includes((0, $9kYnS.MinionName).SEARCH);
    });
};
module.exports["filterNonSearchMinions"] = $b5380383f002e2ac$export$fabd92b0068ace48;

});

parcelRegister("4hGoz", function(module, exports) {

var $badUP = parcelRequire("badUP");

const $f2a3a514766e6b00$export$b79df509190735d5 = (pluginInvocations)=>{
    if (!Array.isArray(pluginInvocations)) return [];
    return pluginInvocations.filter((plugin)=>plugin.plugin_name !== (0, $badUP.PluginName).SEARCH);
};
module.exports["filterNonSearchPlugins"] = $f2a3a514766e6b00$export$b79df509190735d5;

});

parcelRegister("izeRj", function(module, exports) {
const $7e45e15a5194ddbf$export$1f23ec3fd5426403 = (searchExtraInfo)=>{
    if (!searchExtraInfo?.rankedDocuments || !searchExtraInfo?.rawRankedDocumentsInfoMap) return [];
    const { rankedDocuments: rankedDocuments, rawRankedDocumentsInfoMap: rawRankedDocumentsInfoMap } = searchExtraInfo;
    const chunkArrays = Object.values(rawRankedDocumentsInfoMap);
    return rankedDocuments.map((url, index)=>({
            url: url,
            chunks: chunkArrays[index]?.sort((a, b)=>a.chunk_id - b.chunk_id) ?? []
        }));
};
module.exports["getRankedDocumentsWithChunks"] = $7e45e15a5194ddbf$export$1f23ec3fd5426403;

});

parcelRegister("4WM05", function(module, exports) {

var $9kYnS = parcelRequire("9kYnS");

const $064360b402655e5b$export$bf63c148d8c5608b = (minionOutputs)=>{
    if (!Array.isArray(minionOutputs)) return null;
    // Find search minion - check if minion_id contains 'search' (case insensitive)
    const searchMinion = minionOutputs.find((minion)=>{
        const minionInfo = Array.isArray(minion) ? minion[0] : minion;
        return minionInfo.minion_id?.toLowerCase().includes((0, $9kYnS.MinionName).SEARCH);
    });
    if (!searchMinion) return null;
    const minionInfo = Array.isArray(searchMinion) ? searchMinion[0] : searchMinion;
    if (!minionInfo.minion_extra_info) return null;
    try {
        const parsedExtraInfo = JSON.parse(minionInfo.minion_extra_info);
        // Extract from functionMessage.pluginInvocationInfo.extraInfo
        if (parsedExtraInfo.functionMessage?.pluginInvocationInfo?.extraInfo) try {
            return JSON.parse(parsedExtraInfo.functionMessage.pluginInvocationInfo.extraInfo);
        } catch  {
            return null;
        }
        return null;
    } catch  {
        return null;
    }
};
module.exports["getSearchResultsFromMinions"] = $064360b402655e5b$export$bf63c148d8c5608b;

});

parcelRegister("614SU", function(module, exports) {

var $badUP = parcelRequire("badUP");

const $a5a5f591ff56ba7b$export$9007e115c1a30684 = (pluginInvocations)=>{
    if (!Array.isArray(pluginInvocations)) return null;
    const searchPlugin = pluginInvocations.find((plugin)=>plugin.plugin_name === (0, $badUP.PluginName).SEARCH);
    if (!searchPlugin?.plugin_extra_info) return null;
    try {
        return JSON.parse(searchPlugin.plugin_extra_info);
    } catch  {
        return null;
    }
};
module.exports["getSearchResultsFromPlugins"] = $a5a5f591ff56ba7b$export$9007e115c1a30684;

});

parcelRegister("agj0v", function(module, exports) {
const $dbb4f2f53a15a957$export$15d9e451202b41ba = (pluginSearchInfo, minionSearchInfo)=>{
    // If we have plugin search info, use it (it has more complete data like rawRankedDocumentsInfoMap)
    if (pluginSearchInfo) return pluginSearchInfo;
    // Otherwise, use minion search info
    return minionSearchInfo;
};
module.exports["mergeSearchExtraInfo"] = $dbb4f2f53a15a957$export$15d9e451202b41ba;

});

parcelRegister("9S2qh", function(module, exports) {
const $389964e4852aec55$export$60b013a10d8ce23 = (cacheInfo)=>{
    if (!cacheInfo) return null;
    return cacheInfo.cache_hit ?? null;
};
module.exports["normalizeCacheHit"] = $389964e4852aec55$export$60b013a10d8ce23;

});

parcelRegister("5J4us", function(module, exports) {

var $2adW1 = parcelRequire("2adW1");


var $baaZA = parcelRequire("baaZA");

const $ef1500d73dac0c9e$export$702a9b90e43f0129 = (text)=>{
    const match = text.match(/\[([^\]]+)\]\(([^)]+)\)/);
    if (!match) return null;
    const [, name, url] = match;
    const accountIdMatch = url.match(/\/people\/([^/]+)/);
    const accountId = accountIdMatch ? accountIdMatch[1] : null;
    return {
        name: name,
        url: url,
        accountId: accountId
    };
};
const $ef1500d73dac0c9e$export$167366d10321aef5 = (minionExtraInfo, minionId, isSearchMinion)=>{
    let extraInfo = null;
    let parsedOutput = null;
    let functionResults = null;
    let searchExtraInfo = null;
    if (!minionExtraInfo) return {
        extraInfo: extraInfo,
        parsedOutput: parsedOutput,
        functionResults: functionResults,
        searchExtraInfo: searchExtraInfo
    };
    try {
        const parsedExtraInfo = JSON.parse(minionExtraInfo);
        // Case 1 & 2: Has functionMessage (single function call result)
        if (parsedExtraInfo.functionMessage) {
            const { pluginInvocationInfo: pluginInvocationInfo, output: output } = parsedExtraInfo.functionMessage;
            if (isSearchMinion && pluginInvocationInfo?.extraInfo) // Search minion: extract nested search results from extraInfo
            try {
                searchExtraInfo = JSON.parse(pluginInvocationInfo.extraInfo);
            } catch  {
                extraInfo = pluginInvocationInfo.extraInfo;
            }
            else {
                // Non-search minion: parse the output for structured display
                const rawOutput = pluginInvocationInfo?.output || output;
                if (typeof rawOutput === 'string') {
                    parsedOutput = (0, $baaZA.parsePluginOutput)(minionId, rawOutput);
                    if (!parsedOutput) extraInfo = rawOutput;
                }
            }
        } else if (Array.isArray(parsedExtraInfo.results) && parsedExtraInfo.results.length > 0) functionResults = parsedExtraInfo.results;
        else if (parsedExtraInfo.content) extraInfo = parsedExtraInfo.content;
    } catch  {
        // Case 5: JSON parsing failed, use raw string
        extraInfo = minionExtraInfo;
    }
    return {
        extraInfo: extraInfo,
        parsedOutput: parsedOutput,
        functionResults: functionResults,
        searchExtraInfo: searchExtraInfo
    };
};
const $ef1500d73dac0c9e$export$f14fe30fd1a0b725 = (minionOutputs)=>{
    if (!Array.isArray(minionOutputs) || minionOutputs.length === 0) return [];
    // Check if it's already a rounds structure (array of arrays)
    if ((0, $2adW1.isOrchestrationStructure)(minionOutputs)) return minionOutputs;
    // Wrap flat array in a single round
    return [
        minionOutputs
    ];
};
module.exports["parseMarkdownLink"] = $ef1500d73dac0c9e$export$702a9b90e43f0129;
module.exports["parseMinionExtraInfo"] = $ef1500d73dac0c9e$export$167366d10321aef5;
module.exports["getOrchestrationRounds"] = $ef1500d73dac0c9e$export$f14fe30fd1a0b725;

});

parcelRegister("kJmyb", function(module, exports) {
const $a21a1dd5d77d9ec8$export$be4d3e7f2d62c728 = (minion)=>{
    return Array.isArray(minion) ? minion[0] : minion;
};
module.exports["getMinionOutputItem"] = $a21a1dd5d77d9ec8$export$be4d3e7f2d62c728;

});

parcelRegister("9kYnS", function(module, exports) {
var $b79ec1f3f50b1758$export$ea22648b9de9e52c = /*#__PURE__*/ function(MinionName) {
    MinionName["TEAMWORK_AGENT"] = "TeamworkAgent";
    MinionName["SEARCH"] = "search";
    return MinionName;
}({});
module.exports["MinionName"] = $b79ec1f3f50b1758$export$ea22648b9de9e52c;

});

parcelRegister("2IyOa", function(module, exports) {
/* function-result.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $5avUB = parcelRequire("5avUB");


var $chu6R = parcelRequire("chu6R");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $c6XYw = parcelRequire("c6XYw");


var $lT1k3 = parcelRequire("lT1k3");

const $a85b82d1edaf032f$var$functionResultStyles = {
    functionCard: "_0bjKvDKxmn _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0KLXruDMqu",
    outputContent: "_0bjKvDKxmn _4bt5LAIZbP _2WAcuGIZbP _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0KLXru66of _0NUa3rBfNa",
    preformatted: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _1ANEUSlpBW _0WKd3Gfx9v"
};
const $a85b82d1edaf032f$export$c460f77fbe5ab0de = ({ result: result, index: index })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const info = result.pluginInvocationInfo;
    if (!info) return null;
    const isSuccess = info.status === (0, $c6XYw.FunctionResultStatus).SUCCESS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a85b82d1edaf032f$var$functionResultStyles.functionCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: ()=>setIsExpanded(!isExpanded)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_collapse_label),
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: formatMessage((0, $lT1k3.messages).ai_debugger_modal_expand_label),
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium",
        size: "small"
    }, index + 1, ". ", info.name || 'Unknown Function')), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, isSuccess ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        label: info.status || 'Unknown',
        color: "var(--ds-icon-success, #6A9A23)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
        label: info.status || 'Unknown',
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: isSuccess ? 'color.text.success' : 'color.text.danger'
    }, info.status || 'Unknown')))), isExpanded && info.output && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $a85b82d1edaf032f$var$functionResultStyles.outputContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "pre",
        xcss: $a85b82d1edaf032f$var$functionResultStyles.preformatted
    }, info.output))));
};
module.exports["FunctionResult"] = $a85b82d1edaf032f$export$c460f77fbe5ab0de;

});

parcelRegister("3AbYV", function(module, exports) {
/* plugin-output-renderer.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $lT1k3 = parcelRequire("lT1k3");


var $fa5QD = parcelRequire("fa5QD");


var $6fiLQ = parcelRequire("6fiLQ");


var $9nsLV = parcelRequire("9nsLV");

const $65960bc791dba5c8$var$styles = {
    numberBox: "_4ouGXIoWWg _3YEZNOdnbC",
    linkBox: "_4bt5LAnQyn _2WAcuGnQyn _3W2Oc8wPeg _2O5Vij7dHp",
    divider: "_0jFU0VHZdu _0KLXruDMqu _3138428HPE _1DCdHi8HPE"
};
const $65960bc791dba5c8$var$TeamworkRenderer = ({ data: data })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, data.data.header && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, data.data.header), data.data.sections.map((section, sectionIdx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            key: sectionIdx,
            space: "space.150"
        }, section.sectionHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "medium",
            size: "small"
        }, section.sectionHeader), section.teams && section.teams.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, section.teams.map((team, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9nsLV.TeamworkTeamCard), {
                key: idx,
                team: team,
                index: idx
            }))), section.documents && section.documents.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, section.documents.map((doc, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6fiLQ.TeamworkDocumentCard), {
                key: idx,
                doc: doc,
                index: idx
            }))))));
};
const $65960bc791dba5c8$var$SearchPluginRenderer = ({ extraInfo: extraInfo })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, extraInfo.searchResults && extraInfo.searchResults.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_search_results_heading, {
        count: extraInfo.searchResults.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, extraInfo.searchResults.map((url, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            key: idx,
            space: "space.050",
            alignBlock: "start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $65960bc791dba5c8$var$styles.numberBox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, idx + 1, ".")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $65960bc791dba5c8$var$styles.linkBox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: url,
            target: "_blank"
        }, url)))))), extraInfo.searchResults && extraInfo.searchResults.length > 0 && extraInfo.rankedDocuments && extraInfo.rankedDocuments.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $65960bc791dba5c8$var$styles.divider
    }), extraInfo.rankedDocuments && extraInfo.rankedDocuments.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_ranked_documents_heading, {
        count: extraInfo.rankedDocuments.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, extraInfo.rankedDocuments.map((url, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            key: idx,
            space: "space.050",
            alignBlock: "start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $65960bc791dba5c8$var$styles.numberBox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, idx + 1, ".")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $65960bc791dba5c8$var$styles.linkBox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: url,
            target: "_blank"
        }, url)))))));
};
const $65960bc791dba5c8$export$50ae64692e52fc4f = ({ parsedOutput: parsedOutput, extraInfo: extraInfo })=>{
    // Render based on parsed output type
    if (parsedOutput) switch(parsedOutput.type){
        case 'teamwork':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($65960bc791dba5c8$var$TeamworkRenderer, {
                data: parsedOutput
            });
        case 'pageSearch':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fa5QD.PageSearchCard), {
                data: parsedOutput.data
            });
    }
     // Fallback to string display
    if (typeof extraInfo === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, extraInfo);
     // Render search plugin extra info
    if (extraInfo && (extraInfo.searchResults || extraInfo.rankedDocuments)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($65960bc791dba5c8$var$SearchPluginRenderer, {
        extraInfo: extraInfo
    });
    return null;
};
module.exports["PluginOutputRenderer"] = $65960bc791dba5c8$export$50ae64692e52fc4f;

});

parcelRegister("7LI7r", function(module, exports) {
/* panel-wrapper.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $dinVW = parcelRequire("dinVW");

const $8493a884ae6435e0$var$styles = {
    root: "_39xV02N91d _0Of8r22ADO _1wydGW2ADO"
};
const $8493a884ae6435e0$export$2ddb90ad54e5f587 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        xcss: $8493a884ae6435e0$var$styles.root,
        testId: testId
    }, children);
module.exports["Panel"] = $8493a884ae6435e0$export$2ddb90ad54e5f587;

});

parcelRegister("3nKR8", function(module, exports) {
/* plugin-invocation.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $5avUB = parcelRequire("5avUB");


var $chu6R = parcelRequire("chu6R");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $hBYtq = parcelRequire("hBYtq");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $lPcf8 = parcelRequire("lPcf8");


var $lT1k3 = parcelRequire("lT1k3");


var $baaZA = parcelRequire("baaZA");


var $kBYCn = parcelRequire("kBYCn");


var $badUP = parcelRequire("badUP");


var $3AbYV = parcelRequire("3AbYV");

/**
 * Parses plugin data to extract displayable information.
 *
 * Different plugin types have different data structures:
 *
 * 1. Search Plugin:
 *    - Uses plugin_extra_info containing searchResults/rankedDocuments as JSON
 *    - Falls back to raw string if JSON parsing fails
 *
 * 2. Other Plugins (Teamwork, People, Page Search, etc.):
 *    - Uses plugin_output containing structured text
 *    - Attempts to parse output using parsePluginOutput for structured display
 */ const $de25e2fc659989b5$var$parsePluginExtraInfo = ({ pluginName: pluginName, pluginExtraInfo: pluginExtraInfo, pluginOutput: pluginOutput })=>{
    let extraInfo;
    let parsedOutput = null; // Search plugin: parse plugin_extra_info for search results
    if (pluginName === (0, $badUP.PluginName).SEARCH) try {
        if (pluginExtraInfo) extraInfo = JSON.parse(pluginExtraInfo);
    } catch  {
        extraInfo = pluginExtraInfo;
    }
    else {
        extraInfo = pluginOutput;
        if (typeof extraInfo === 'string') parsedOutput = (0, $baaZA.parsePluginOutput)(pluginName, extraInfo);
    }
    return {
        extraInfo: extraInfo,
        parsedOutput: parsedOutput
    };
};
const $de25e2fc659989b5$var$pluginInvocationStyles = {
    pressable: "_0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _0wOv4Q7zJH _39xV02N91d",
    content: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXru66of"
};
const $de25e2fc659989b5$export$213f6c57639a4547 = ({ plugin: plugin, index: index })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const isSuccess = plugin.plugin_invocation_status === (0, $kBYCn.PluginInvocationStatus).PLUGIN_FINISHED;
    const StatusIcon = isSuccess ? (0, (/*@__PURE__*/$parcel$interopDefault($chu6R))) : (0, (/*@__PURE__*/$parcel$interopDefault($5avUB)));
    const statusColor = isSuccess ? "var(--ds-icon-success, #6A9A23)" : "var(--ds-icon-danger, #C9372C)";
    const statusText = isSuccess ? formatMessage((0, $lT1k3.messages).ai_debugger_modal_success_label) : formatMessage((0, $lT1k3.messages).ai_debugger_modal_failed_label);
    const expandLabel = formatMessage((0, $lT1k3.messages).ai_debugger_modal_expand_label);
    const collapseLabel = formatMessage((0, $lT1k3.messages).ai_debugger_modal_collapse_label);
    const { extraInfo: extraInfo, parsedOutput: parsedOutput } = $de25e2fc659989b5$var$parsePluginExtraInfo({
        pluginName: plugin.plugin_name,
        pluginExtraInfo: plugin.plugin_extra_info,
        pluginOutput: plugin.plugin_output
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lPcf8.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: ()=>setIsExpanded(!isExpanded),
        xcss: $de25e2fc659989b5$var$pluginInvocationStyles.pressable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: collapseLabel,
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: expandLabel,
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, plugin.plugin_name || `Plugin ${index + 1}`)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(StatusIcon, {
        label: statusText,
        color: statusColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: isSuccess ? 'color.text.success' : 'color.text.danger'
    }, statusText)))), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $de25e2fc659989b5$var$pluginInvocationStyles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3AbYV.PluginOutputRenderer), {
        parsedOutput: parsedOutput,
        extraInfo: extraInfo
    })))));
};
module.exports["PluginInvocationItem"] = $de25e2fc659989b5$export$213f6c57639a4547;

});

parcelRegister("8MLeD", function(module, exports) {
/* copy-button.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $fHs3z = parcelRequire("fHs3z");


var $chu6R = parcelRequire("chu6R");


var $hBYtq = parcelRequire("hBYtq");


var $lpNn5 = parcelRequire("lpNn5");

const $f4001d2d7d88a108$var$TIMEOUT_DELAY = 2500;
const $f4001d2d7d88a108$var$buttonStyles = {
    root: "_0bjKvDKxmn _0jFU0Vey7F _39xV02ey7F _03SyCPPgdg _0LQT5EPgdg",
    cursorDisabledStyles: "_30huDKYbGa _0wOv4Q18ZR"
};
const $f4001d2d7d88a108$export$4f2558dd25106ae2 = ({ copyText: copyText, copyLabel: copyLabel, copiedLabel: copiedLabel, testId: testId })=>{
    const [isCopied, setIsCopied] = (0, $cozmU.useState)(false);
    const [currentTooltipLabel, setCurrentTooltipLabel] = (0, $cozmU.useState)(copyLabel);
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useLayoutEffect(()=>{
        updateTooltip.current?.();
    }, [
        currentTooltipLabel
    ]);
    const copyTextToClipboard = async ()=>{
        try {
            if (!copyText) return;
            await navigator.clipboard.writeText(copyText);
            setIsCopied(true);
            setCurrentTooltipLabel(copiedLabel);
            setTimeout(()=>{
                setIsCopied(false);
                setCurrentTooltipLabel(copyLabel);
            }, $f4001d2d7d88a108$var$TIMEOUT_DELAY);
        } catch (_e) {
            // Failed to copy
            throw new Error('Failed to copy');
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return currentTooltipLabel;
        },
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($f4001d2d7d88a108$var$buttonStyles.root, isCopied ? $f4001d2d7d88a108$var$buttonStyles.cursorDisabledStyles : undefined),
        isDisabled: isCopied,
        onClick: copyTextToClipboard,
        "aria-label": copyLabel,
        testId: testId
    }, isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
        label: copiedLabel,
        color: "var(--ds-icon-accent-green, #22A06B)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
        label: copyLabel,
        color: "var(--ds-icon-subtle, #505258)"
    })));
};
module.exports["CopyButton"] = $f4001d2d7d88a108$export$4f2558dd25106ae2;

});

parcelRegister("6Skkp", function(module, exports) {

var $iQ1xn = parcelRequire("iQ1xn");

const $e9a86c11a9e34acc$export$cb8121cdf102bdd9 = (pluginName)=>{
    if (!pluginName) return 0, $iQ1xn.DEFAULT_PLUGIN_TAG_COLOR;
    if (pluginName in (0, $iQ1xn.PLUGIN_TAG_COLOR)) return (0, $iQ1xn.PLUGIN_TAG_COLOR)[pluginName];
    return 0, $iQ1xn.DEFAULT_PLUGIN_TAG_COLOR;
};
module.exports["getPluginTagColor"] = $e9a86c11a9e34acc$export$cb8121cdf102bdd9;

});

parcelRegister("badUP", function(module, exports) {
var $3a16d2177b76af26$export$a80387b071fd4173 = /*#__PURE__*/ function(PluginName) {
    PluginName["TEAMWORK"] = "teamwork";
    PluginName["PAGE_SEARCH_PLUGIN"] = "Page-Search-Plugin";
    PluginName["SEARCH"] = "search";
    PluginName["PEOPLE"] = "people";
    return PluginName;
}({});
module.exports["PluginName"] = $3a16d2177b76af26$export$a80387b071fd4173;

});

parcelRegister("2adW1", function(module, exports) {
const $1020c2e6b7181502$export$a5ce513682ddb349 = (minionOutputs)=>{
    if (!Array.isArray(minionOutputs) || minionOutputs.length === 0) return false;
    // Check if first element is an array (indicating rounds structure)
    return Array.isArray(minionOutputs[0]);
};
module.exports["isOrchestrationStructure"] = $1020c2e6b7181502$export$a5ce513682ddb349;

});

parcelRegister("baaZA", function(module, exports) {

var $390xH = parcelRequire("390xH");


var $8L4Ur = parcelRequire("8L4Ur");


var $badUP = parcelRequire("badUP");

const $fa720d82c3e4bf85$export$cc2e1f911cfb137c = (pluginName, output)=>{
    switch(pluginName){
        case (0, $badUP.PluginName).TEAMWORK:
            {
                const teamworkData = (0, $8L4Ur.parseTeamworkOutput)(output);
                if (teamworkData) return {
                    type: 'teamwork',
                    data: teamworkData
                };
                break;
            }
        case (0, $badUP.PluginName).PAGE_SEARCH_PLUGIN:
            {
                const pageSearchData = (0, $390xH.parsePageSearchOutput)(output);
                if (pageSearchData) return {
                    type: 'pageSearch',
                    data: pageSearchData
                };
                break;
            }
    }
    return null;
};
module.exports["parsePluginOutput"] = $fa720d82c3e4bf85$export$cc2e1f911cfb137c;

});

parcelRegister("c6XYw", function(module, exports) {
var $27d32892120f0993$export$5731613326371a4a = /*#__PURE__*/ function(FunctionResultStatus) {
    FunctionResultStatus["SUCCESS"] = "SUCCESS";
    FunctionResultStatus["ERROR"] = "ERROR";
    return FunctionResultStatus;
}({});
module.exports["FunctionResultStatus"] = $27d32892120f0993$export$5731613326371a4a;

});

parcelRegister("fa5QD", function(module, exports) {
/* page-search-card.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $lT1k3 = parcelRequire("lT1k3");


const $cb3cafbeb8a13861$var$Card = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("bE9h1")).then(({ Card: Card })=>({
            default: Card
        })));
const $cb3cafbeb8a13861$var$styles = {
    card: "_0bjKvDKxmn _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _0KLXruDMqu _1DCdHi2ADO",
    itemNumber: "_4ouGXIoWWg _3YEZNOdnbC _1ANEUSLRg7",
    snippet: "_4bt5LAnQyn _2WAcuGnQyn _3W2Oc8wPeg"
};
const $cb3cafbeb8a13861$var$PageCard = ({ page: page, index: index })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb3cafbeb8a13861$var$styles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb3cafbeb8a13861$var$styles.itemNumber
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        color: "color.text"
    }, index + 1, ".")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, page.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: page.url,
            target: "_blank"
        }, page.title)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb3cafbeb8a13861$var$Card, {
        appearance: "inline",
        url: page.url
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold"
    }, page.title), page.space && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_page_search_space, {
        space: page.space
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.200"
    }, page.author && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_author_label, {
        author: page.author
    })), page.date && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, page.date)), page.snippet && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $cb3cafbeb8a13861$var$styles.snippet
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, page.snippet))));
};
const $cb3cafbeb8a13861$export$fbdb7e4b907b475b = ({ data: data })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, data.header && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, data.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_page_search_count, {
        count: data.pages.length
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, data.pages.map((page, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cb3cafbeb8a13861$var$PageCard, {
            key: idx,
            page: page,
            index: idx
        }))));
};
module.exports["PageSearchCard"] = $cb3cafbeb8a13861$export$fbdb7e4b907b475b;

});

parcelRegister("6fiLQ", function(module, exports) {
/* teamwork-document-card.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $jxGuq = parcelRequire("jxGuq");


var $lT1k3 = parcelRequire("lT1k3");

const $ce675b55a4c0c1d4$var$pluginInvocationStyles = {
    teamworkCard: "_0bjKvDKxmn _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _0KLXruDMqu _1DCdHi2ADO",
    teamworkItemNumber: "_4ouGXIoWWg _3YEZNOdnbC _1ANEUSLRg7"
};
const $ce675b55a4c0c1d4$export$4bdcb2db328c0713 = ({ doc: doc, index: index })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ce675b55a4c0c1d4$var$pluginInvocationStyles.teamworkCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ce675b55a4c0c1d4$var$pluginInvocationStyles.teamworkItemNumber
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, index + 1, ".")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, doc.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        href: doc.url,
        target: "_blank"
    }, doc.title || doc.url) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, doc.title), doc.type && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, doc.type))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.200",
        alignBlock: "center"
    }, doc.author && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_author_label, {
        author: (0, $jxGuq.formatMarkdownLinkAsText)(doc.author)
    })), doc.updated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_teamwork_document_updated, {
        date: new Date(doc.updated).toLocaleDateString()
    }))), doc.ari && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, doc.ari)));
};
module.exports["TeamworkDocumentCard"] = $ce675b55a4c0c1d4$export$4bdcb2db328c0713;

});

parcelRegister("9nsLV", function(module, exports) {
/* teamwork-team-card.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iMnC5 = parcelRequire("iMnC5");

var $1l0kj = parcelRequire("1l0kj");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $jxGuq = parcelRequire("jxGuq");


var $lT1k3 = parcelRequire("lT1k3");

const $090b81aac414f11d$var$pluginInvocationStyles = {
    teamworkCard: "_0bjKvDKxmn _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE _0KLXruDMqu _1DCdHi2ADO",
    teamworkMembersList: "_4bt5LAIZbP _2WAcuGIZbP _3138422ADO _2XsHFMNHnM _0NUa3rgZxp",
    teamworkItemNumber: "_4ouGXIoWWg _3YEZNOdnbC _1ANEUSLRg7"
};
const $090b81aac414f11d$export$f27472f36b5cad7b = ({ team: team, index: index })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [showMembers, setShowMembers] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $090b81aac414f11d$var$pluginInvocationStyles.teamworkCard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $090b81aac414f11d$var$pluginInvocationStyles.teamworkItemNumber
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        color: "color.text"
    }, index + 1, ".")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        color: "color.text"
    }, team.name || formatMessage((0, $lT1k3.messages).ai_debugger_modal_teamwork_unnamed_team))), team.description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, team.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.200",
        alignBlock: "center"
    }, team.memberCount !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_teamwork_members_count, {
        count: team.memberCount
    })), team.teamState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_teamwork_state, {
        state: team.teamState
    }))), team.creator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, formatMessage((0, $lT1k3.messages).ai_debugger_modal_teamwork_creator, {
        creator: team.creator
    })), team.ari && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, team.ari), team.members.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        iconBefore: showMembers ? (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))) : (0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))),
        appearance: "subtle",
        spacing: "compact",
        onClick: ()=>setShowMembers(!showMembers)
    }, showMembers ? formatMessage((0, $lT1k3.messages).ai_debugger_modal_teamwork_hide_count, {
        count: team.members.length
    }) : formatMessage((0, $lT1k3.messages).ai_debugger_modal_teamwork_show_count, {
        count: team.members.length
    })), showMembers && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $090b81aac414f11d$var$pluginInvocationStyles.teamworkMembersList
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, team.members.map((member, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            key: idx
        }, (0, $jxGuq.formatMarkdownLinkAsText)(member))))))));
};
module.exports["TeamworkTeamCard"] = $090b81aac414f11d$export$f27472f36b5cad7b;

});

parcelRegister("kBYCn", function(module, exports) {
var $719bafe69d01c26b$export$7088950d16b52135 = /*#__PURE__*/ function(PluginInvocationStatus) {
    PluginInvocationStatus["PLUGIN_FINISHED"] = "PLUGIN_FINISHED";
    PluginInvocationStatus["PLUGIN_ERRORED"] = "PLUGIN_ERRORED";
    return PluginInvocationStatus;
}({});
module.exports["PluginInvocationStatus"] = $719bafe69d01c26b$export$7088950d16b52135;

});

parcelRegister("iQ1xn", function(module, exports) {

var $badUP = parcelRequire("badUP");

const $86be65b82995f8e3$export$254d68b455df6f6b = {
    [(0, $badUP.PluginName).SEARCH]: 'green',
    [(0, $badUP.PluginName).PEOPLE]: 'blue',
    [(0, $badUP.PluginName).TEAMWORK]: 'purple',
    [(0, $badUP.PluginName).PAGE_SEARCH_PLUGIN]: 'yellow'
};
const $86be65b82995f8e3$export$92abffed8cc5f142 = 'gray';
module.exports["PLUGIN_TAG_COLOR"] = $86be65b82995f8e3$export$254d68b455df6f6b;
module.exports["DEFAULT_PLUGIN_TAG_COLOR"] = $86be65b82995f8e3$export$92abffed8cc5f142;

});

parcelRegister("390xH", function(module, exports) {
const $beb9f99e78229947$export$97b80a86e0bee15d = (output)=>{
    const lines = output.split('\n');
    const result = {
        pages: []
    };
    let currentPage = null;
    let headerCaptured = false;
    const savePage = ()=>{
        if (currentPage && currentPage.title) result.pages.push(currentPage);
    };
    for (const line of lines){
        const trimmedLine = line.trim();
        // Capture header
        if (!headerCaptured && trimmedLine.startsWith('Here are')) {
            result.header = trimmedLine;
            headerCaptured = true;
            continue;
        }
        // Start of a new page entry (title line)
        if (trimmedLine.startsWith('- title:')) {
            // Save previous page if exists
            savePage();
            currentPage = {
                title: trimmedLine.substring(9).trim()
            };
            continue;
        }
        // Parse page fields
        if (currentPage) {
            if (trimmedLine.startsWith('url:')) currentPage.url = trimmedLine.substring(4).trim();
            else if (trimmedLine.startsWith('space:')) currentPage.space = trimmedLine.substring(6).trim();
            else if (trimmedLine.startsWith('date:')) currentPage.date = trimmedLine.substring(5).trim();
            else if (trimmedLine.startsWith('author:')) currentPage.author = trimmedLine.substring(7).trim();
            else if (trimmedLine.startsWith('snippet:')) currentPage.snippet = trimmedLine.substring(8).trim();
        }
    }
    // Save the last page
    savePage();
    return result.pages.length > 0 ? result : null;
};
module.exports["parsePageSearchOutput"] = $beb9f99e78229947$export$97b80a86e0bee15d;

});

parcelRegister("8L4Ur", function(module, exports) {
const $4c1a5e8c336543e6$export$21986be684877eaa = (output)=>{
    const lines = output.split('\n');
    const result = {
        sections: []
    };
    let currentTeam = null;
    let currentDocument = null;
    let inMembersSection = false;
    let headerLines = [];
    let currentSection = {};
    lines.forEach((line)=>{
        const trimmedLine = line.trim();
        // Capture main header
        if (trimmedLine.startsWith('Here are') && !result.header && !currentTeam && !currentDocument) {
            headerLines.push(trimmedLine);
            return;
        }
        // Section headers (like "Here are the Confluence documents:")
        if (trimmedLine.startsWith('Here are the') && trimmedLine.endsWith(':') && !currentTeam && !currentDocument) {
            // Save previous section if exists
            if (currentSection.teams || currentSection.documents) result.sections.push(currentSection);
            currentSection = {
                sectionHeader: trimmedLine.slice(0, -1)
            }; // Remove trailing colon
            return;
        }
        // Start of a new team
        if (trimmedLine.startsWith('- type: Team')) {
            // Save previous item
            if (currentTeam) {
                if (!currentSection.teams) currentSection.teams = [];
                currentSection.teams.push(currentTeam);
            }
            if (currentDocument) {
                if (!currentSection.documents) currentSection.documents = [];
                currentSection.documents.push(currentDocument);
            }
            currentTeam = {
                type: 'Team',
                members: []
            };
            currentDocument = null;
            inMembersSection = false;
            return;
        }
        // Start of a new document (Confluence Page, Confluence Blog Post, etc.)
        if (trimmedLine.startsWith('- type: Confluence') || trimmedLine.startsWith('- type: Jira')) {
            // Save previous item
            if (currentTeam) {
                if (!currentSection.teams) currentSection.teams = [];
                currentSection.teams.push(currentTeam);
            }
            if (currentDocument) {
                if (!currentSection.documents) currentSection.documents = [];
                currentSection.documents.push(currentDocument);
            }
            currentDocument = {
                type: trimmedLine.substring(8).trim()
            };
            currentTeam = null;
            inMembersSection = false;
            return;
        }
        // Parse fields
        if (currentTeam) {
            // Team parsing
            if (inMembersSection && trimmedLine.startsWith('- [')) currentTeam.members.push(trimmedLine.substring(2).trim());
            else if (trimmedLine.startsWith('- ')) {
                const colonIndex = trimmedLine.indexOf(':');
                if (colonIndex !== -1) {
                    const fieldName = trimmedLine.substring(2, colonIndex).toLowerCase();
                    const fieldValue = trimmedLine.substring(colonIndex + 1).trim();
                    switch(fieldName){
                        case 'ari':
                            currentTeam.ari = fieldValue;
                            break;
                        case 'name':
                            currentTeam.name = fieldValue;
                            break;
                        case 'description':
                            currentTeam.description = fieldValue;
                            break;
                        case 'creator':
                            currentTeam.creator = fieldValue;
                            break;
                        case 'member count':
                            currentTeam.memberCount = parseInt(fieldValue, 10);
                            break;
                        case 'teamstate':
                            currentTeam.teamState = fieldValue;
                            inMembersSection = false;
                            break;
                        case 'members':
                            inMembersSection = true;
                            currentTeam.members = [];
                            break;
                    }
                }
            }
        } else if (currentDocument && trimmedLine.startsWith('- ')) {
            // Document parsing
            const colonIndex = trimmedLine.indexOf(':');
            if (colonIndex !== -1) {
                const fieldName = trimmedLine.substring(2, colonIndex).toLowerCase();
                const fieldValue = trimmedLine.substring(colonIndex + 1).trim();
                switch(fieldName){
                    case 'ari':
                        currentDocument.ari = fieldValue;
                        break;
                    case 'title':
                        currentDocument.title = fieldValue;
                        break;
                    case 'url':
                        currentDocument.url = fieldValue;
                        break;
                    case 'author':
                        currentDocument.author = fieldValue;
                        break;
                    case 'updated':
                        currentDocument.updated = fieldValue;
                        break;
                }
            }
        }
    });
    // Save last item
    if (currentTeam) {
        if (!currentSection.teams) currentSection.teams = [];
        currentSection.teams.push(currentTeam);
    }
    if (currentDocument) {
        if (!currentSection.documents) currentSection.documents = [];
        currentSection.documents.push(currentDocument);
    }
    // Save last section
    if (currentSection.teams || currentSection.documents) result.sections.push(currentSection);
    if (headerLines.length > 0) result.header = headerLines.join(' ');
    return result.sections.length > 0 ? result : null;
};
module.exports["parseTeamworkOutput"] = $4c1a5e8c336543e6$export$21986be684877eaa;

});

parcelRegister("jxGuq", function(module, exports) {

var $5J4us = parcelRequire("5J4us");

const $52a506f226b267ba$export$c064dfbb0e9baaa8 = (text)=>{
    const parsed = (0, $5J4us.parseMarkdownLink)(text);
    if (!parsed) return text;
    return parsed.accountId ? `${parsed.name} (${parsed.accountId})` : parsed.name;
};
module.exports["formatMarkdownLinkAsText"] = $52a506f226b267ba$export$c064dfbb0e9baaa8;

});


$parcel$global.rlb("gckbX")
//# sourceMappingURL=ConversationAssistant.e4fe79fb.js.map
